
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("cetrx", function(module, exports) {

$parcel$export(module.exports, "ConnectedProformaFormsView", () => (parcelRequire("5b8cu")).ConnectedProformaFormsView);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $5b8cu = parcelRequire("5b8cu");

});
parcelRegister("5b8cu", function(module, exports) {

$parcel$export(module.exports, "ConnectedProformaFormsView", () => $bf3d9daf5dbfd69b$export$17f8dd7432b73f09);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $cUugh = parcelRequire("cUugh");

var $a4i8P = parcelRequire("a4i8P");

var $dJq4H = parcelRequire("dJq4H");

var $cC9Cp = parcelRequire("cC9Cp");

var $5bpEQ = parcelRequire("5bpEQ");

var $93Yeu = parcelRequire("93Yeu");

var $bC2fB = parcelRequire("bC2fB");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $38Cza = parcelRequire("38Cza");

var $hu5EZ = parcelRequire("hu5EZ");
const $bf3d9daf5dbfd69b$export$884c9d32dc2ec9b6 = ({ canEditIssues: canEditIssues, isProjectAdmin: isProjectAdmin, panelAddFormButtonClickedCount: panelAddFormButtonClickedCount, useEditModeCallback: useEditModeCallback, getMediaReadToken: getMediaReadToken })=>{
    const { locale: locale } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const issueId = (0, $2gCtH.useIssueId)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const [settings, setSettings] = (0, $5uXOq.useState)();
    const mediaContextDetails = (0, $cUugh.useMediaContext)(issueKey);
    const { data: projectUploadToken } = (0, $hu5EZ.useFetchProjectToken)(projectId, mediaContextDetails);
    const mediaApiContextDetails = mediaContextDetails?.viewContext && projectUploadToken ? {
        uploadContext: projectUploadToken,
        viewContext: mediaContextDetails.viewContext
    } : undefined;
    (0, $5uXOq.useEffect)(()=>{
        if (issueId && projectId && projectType && accountId) setSettings({
            analytics: {
                channel: (0, $5bpEQ.ANALYTICS_CHANNEL)
            },
            flags: {},
            urls: (0, $5bpEQ.getUrls)(environment, cloudId),
            environment: (0, $cC9Cp.toProformaEnvironment)(environment),
            context: {
                accountId: accountId,
                issueKey: issueKey,
                issueId: Number(issueId),
                projectId: Number(projectId),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                projectType: projectType,
                userIsProjectAdmin: isProjectAdmin,
                userCanEditIssue: canEditIssues,
                showFormVisibility: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT),
                intlLocale: locale,
                editModeCallback: useEditModeCallback
            }
        });
    }, [
        accountId,
        environment,
        cloudId,
        issueKey,
        issueId,
        projectId,
        projectType,
        isProjectAdmin,
        canEditIssues,
        locale,
        useEditModeCallback
    ]);
    const mediaReadTokenRefreshCallback = (0, $5uXOq.useCallback)(()=>getMediaReadToken(), [
        getMediaReadToken
    ]);
    return projectId !== undefined && projectId !== '' && settings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Cza.IssueViewApp), {
        settings: settings,
        addFormButtonClickedCount: panelAddFormButtonClickedCount,
        mediaContextDetails: mediaApiContextDetails,
        mediaReadTokenRefresh: mediaReadTokenRefreshCallback
    }) : null;
};
const $bf3d9daf5dbfd69b$var$mapDispatchToProps = {
    useEditModeCallback: (0, $a4i8P.proformaFormEditModeChange),
    getMediaReadToken: (0, $dJq4H.fetchViewContextRequest)
};
const $bf3d9daf5dbfd69b$export$17f8dd7432b73f09 = (0, $bC2fB.connect)(null, $bf3d9daf5dbfd69b$var$mapDispatchToProps)($bf3d9daf5dbfd69b$export$884c9d32dc2ec9b6);

});
parcelRegister("cUugh", function(module, exports) {

$parcel$export(module.exports, "useMediaContextUnsafe", () => $ec81a228b49b91d2$export$803413e8e9ad4fcd);
$parcel$export(module.exports, "useMediaContext", () => $ec81a228b49b91d2$export$2d636d13f24b27df);
$parcel$export(module.exports, "useMediaContextActions", () => $ec81a228b49b91d2$export$172587b1623c4b83);

var $5uXOq = parcelRequire("5uXOq");

var $WiYKn = parcelRequire("WiYKn");
const $ec81a228b49b91d2$export$803413e8e9ad4fcd = (issueKey)=>{
    const [mediaContext] = (0, $WiYKn.useMediaContextStore)(issueKey);
    return mediaContext;
};
const $ec81a228b49b91d2$export$2d636d13f24b27df = (issueKey)=>{
    const [mediaContext] = (0, $WiYKn.useMediaContextStore)(issueKey);
    return mediaContext;
};
const $ec81a228b49b91d2$export$172587b1623c4b83 = ()=>{
    const [, { setViewContext: setViewContext, setUploadContext: setUploadContext, setUserAuthContext: setUserAuthContext }] = (0, $WiYKn.useMediaContextStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>({
            setViewContext: setViewContext,
            setUploadContext: setUploadContext,
            setUserAuthContext: setUserAuthContext
        }), [
        setViewContext,
        setUploadContext,
        setUserAuthContext
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("WiYKn", function(module, exports) {

$parcel$export(module.exports, "useMediaContextStore", () => $5fff11f8e5b2b3e9$export$46c137231247a5a5);
$parcel$export(module.exports, "useMediaContextStoreActions", () => $5fff11f8e5b2b3e9$export$248f9c7f818f5e44);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $2XZAp = parcelRequire("2XZAp");
const $5fff11f8e5b2b3e9$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'media-context',
    initialState: {},
    actions: $2XZAp
});
const $5fff11f8e5b2b3e9$var$getMediaSelector = (state, issueKey)=>state[issueKey];
const $5fff11f8e5b2b3e9$export$46c137231247a5a5 = (0, $3sQ5x.createHook)($5fff11f8e5b2b3e9$export$6f57813fe9f31bf9, {
    selector: $5fff11f8e5b2b3e9$var$getMediaSelector
});
const $5fff11f8e5b2b3e9$export$248f9c7f818f5e44 = (0, $3sQ5x.createHook)($5fff11f8e5b2b3e9$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("2XZAp", function(module, exports) {

$parcel$export(module.exports, "setViewContext", () => $40e609a45dee467a$export$8dad3433bf08f4d);
$parcel$export(module.exports, "setUploadContext", () => $40e609a45dee467a$export$d50b6be00915c5d);
$parcel$export(module.exports, "setUserAuthContext", () => $40e609a45dee467a$export$2b9ceccff2ce0ffc);
const $40e609a45dee467a$export$8dad3433bf08f4d = (issueKey, viewContext)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                viewContext: viewContext
            }
        });
    };
const $40e609a45dee467a$export$d50b6be00915c5d = (issueKey, uploadContext)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                uploadContext: uploadContext
            }
        });
    };
const $40e609a45dee467a$export$2b9ceccff2ce0ffc = (issueKey, userAuth)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                userAuth: userAuth
            }
        });
    };

});



parcelRegister("a4i8P", function(module, exports) {

$parcel$export(module.exports, "PROFORMA_FORM_EDIT_MODE_CHANGE", () => $45c8b1b273b3229b$export$52c06ba5cbabc8e7);
$parcel$export(module.exports, "proformaFormEditModeChange", () => $45c8b1b273b3229b$export$d6c51616b4535713);
// PROFORMA_FORM_EDIT_MODE_CHANGE
const $45c8b1b273b3229b$export$52c06ba5cbabc8e7 = 'PROFORMA_FORM_EDIT_MODE_CHANGE';
const $45c8b1b273b3229b$export$d6c51616b4535713 = (isProformaFormInEditMode)=>({
        type: $45c8b1b273b3229b$export$52c06ba5cbabc8e7,
        payload: isProformaFormInEditMode
    });

});

parcelRegister("cC9Cp", function(module, exports) {

$parcel$export(module.exports, "toProformaEnvironment", () => $498398f11ffa02f4$export$81a9ecf6b01a04d4);

var $fxMku = parcelRequire("fxMku");
const $498398f11ffa02f4$export$81a9ecf6b01a04d4 = (environment)=>{
    switch(environment){
        case 'dev':
            return (0, $fxMku.Environment).DEVELOPMENT;
        case 'staging':
            return (0, $fxMku.Environment).STAGING;
        case 'prod':
            return (0, $fxMku.Environment).PRODUCTION;
        case 'local':
        default:
            return (0, $fxMku.Environment).LOCAL;
    }
};

});
parcelRegister("fxMku", function(module, exports) {

$parcel$export(module.exports, "Environment", () => $b50f6d5564bbfb55$export$7dc6752a22ab011a);
let $b50f6d5564bbfb55$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["PRODUCTION"] = "prod";
    Environment["STAGING"] = "staging";
    Environment["DEVELOPMENT"] = "dev";
    Environment["LOCAL"] = "local";
    return Environment;
}({});

});


parcelRegister("5bpEQ", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $1cd284857d4cae3e$export$85183a312807388d);
$parcel$export(module.exports, "getUrls", () => $1cd284857d4cae3e$export$c69765bbdb1543ad);





const $1cd284857d4cae3e$export$85183a312807388d = 'productAnalytics';
const $1cd284857d4cae3e$export$c69765bbdb1543ad = (environment, cloudId)=>({
        api: `/gateway/api/proforma/cloudid/${cloudId}`,
        jira: '',
        templatesService: environment === 'prod' ? 'https://proforma-templates.services.atlassian.com' : 'https://proforma-templates.stg.services.atlassian.com',
        analyticsService: environment === 'prod' ? 'https://proforma-analytics.services.atlassian.com' : 'https://proforma-analytics.stg.services.atlassian.com'
    });

});

parcelRegister("38Cza", function(module, exports) {

$parcel$export(module.exports, "IssueViewApp", () => $81ea2bf3dcd8fd64$export$881cc5030249ac05);

var $5uXOq = parcelRequire("5uXOq");

var $alnGD = parcelRequire("alnGD");

var $bngFq = parcelRequire("bngFq");

var $7ndW8 = parcelRequire("7ndW8");

var $kW74I = parcelRequire("kW74I");

var $hBLXw = parcelRequire("hBLXw");
var $8b5Ks = parcelRequire("8b5Ks");

var $koVbs = parcelRequire("koVbs");

var $bEQ2i = parcelRequire("bEQ2i");

var $bv2Tr = parcelRequire("bv2Tr");

var $iu3cq = parcelRequire("iu3cq");
var $6W5Vt = parcelRequire("6W5Vt");
var $9rYSe = parcelRequire("9rYSe");

var $6jvUj = parcelRequire("6jvUj");

var $N5QrD = parcelRequire("N5QrD");

var $erWXD = parcelRequire("erWXD");
var $bV8dQ = parcelRequire("bV8dQ");

var $6U2FW = parcelRequire("6U2FW");

var $f6U3Q = parcelRequire("f6U3Q");

var $y7oWF = parcelRequire("y7oWF");

var $4Ihci = parcelRequire("4Ihci");

var $3PJX6 = parcelRequire("3PJX6");

var $e4820 = parcelRequire("e4820");

var $i7kEj = parcelRequire("i7kEj");

var $1A1EL = parcelRequire("1A1EL");

var $88gr9 = parcelRequire("88gr9");
// Configure MobX to isolate itself from other copies of MobX, such as the MobX loaded by proforma-ui or a third-party Jira app.
(0, $alnGD.configure)({
    isolateGlobalState: true
});
const $81ea2bf3dcd8fd64$export$88baa5c10fe8794 = ({ settings: settings, moduleContext: moduleContext, addFormButtonClickedCount: addFormButtonClickedCount })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { set: setFormSaveErrors, clear: clearFormSaveErrors } = (0, $bEQ2i.useFormSaveErrorsActions)();
    const intl = (0, $koVbs.default)();
    const [issueViewStore, setIssueViewStore] = (0, $5uXOq.useState)();
    const { showFlag: showFlag } = (0, $7ndW8.useFlags)();
    (0, $5uXOq.useEffect)(()=>{
        setIssueViewStore(new (0, $e4820.IssueViewStore)(intl, moduleContext, settings.context.projectId, settings.context.issueKey, settings.context.issueId, createAnalyticsEvent, clearFormSaveErrors, settings.context.editModeCallback, showFlag));
    // NOTE: `intl` from `useIntl()` must not be used in a dependency list.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clearFormSaveErrors,
        createAnalyticsEvent,
        setFormSaveErrors,
        moduleContext,
        settings.context.issueId,
        settings.context.issueKey,
        settings.context.projectId
    ]);
    const getFormIndex = (0, $5uXOq.useCallback)(async ()=>{
        const formIndex = await moduleContext.apis.issueViewFormApi.getFormIndex(settings.context.issueId);
        return (0, $88gr9.convertToFormIndexItems)(formIndex);
    }, [
        moduleContext.apis.issueViewFormApi,
        settings.context.issueId
    ]);
    const deleteForm = (0, $5uXOq.useCallback)((formId)=>moduleContext.apis.issueViewFormApi.deleteForm(settings.context.issueId, formId), [
        moduleContext.apis.issueViewFormApi,
        settings.context.issueId
    ]);
    const reopenForm = (0, $5uXOq.useCallback)((formId, formStatus)=>moduleContext.apis.issueViewFormApi.reopenForm(settings.context.issueId, formId, formStatus), [
        moduleContext.apis.issueViewFormApi,
        settings.context.issueId
    ]);
    const updateFormVisibility = (0, $5uXOq.useCallback)((formId, isInternal)=>moduleContext.apis.issueViewFormApi.updateFormVisibility(settings.context.issueId, formId, isInternal), [
        moduleContext.apis.issueViewFormApi,
        settings.context.issueId
    ]);
    const submitForm = (0, $5uXOq.useCallback)((formId, submitLock)=>moduleContext.apis.issueViewFormApi.submitForm(settings.context.issueId, formId, submitLock), [
        moduleContext.apis.issueViewFormApi,
        settings.context.issueId
    ]);
    const saveAnswers = (0, $5uXOq.useCallback)((formId, formAnswers)=>moduleContext.apis.issueViewFormApi.saveAnswers(settings.context.issueId, formId, formAnswers), [
        moduleContext.apis.issueViewFormApi,
        settings.context.issueId
    ]);
    const hasSeenOnboarding = (0, $5uXOq.useCallback)((propertyKey)=>moduleContext.apis.issueViewFormApi.getUserProperty(propertyKey, settings.context.accountId).then((_)=>true).catch((error)=>error.status !== 404), [
        moduleContext.apis.issueViewFormApi,
        settings
    ]);
    const markAsSeenOnboarding = (0, $5uXOq.useCallback)((propertyKey)=>moduleContext.apis.issueViewFormApi.setUserProperty(propertyKey, settings.context.accountId, true), [
        moduleContext.apis.issueViewFormApi,
        settings
    ]);
    const api = (0, $5uXOq.useMemo)(()=>({
            getFormIndex: getFormIndex,
            deleteForm: deleteForm,
            updateFormVisibility: updateFormVisibility,
            reopenForm: reopenForm,
            submitForm: submitForm,
            saveAnswers: saveAnswers,
            hasSeenOnboarding: hasSeenOnboarding,
            markAsSeenOnboarding: markAsSeenOnboarding
        }), [
        getFormIndex,
        deleteForm,
        updateFormVisibility,
        reopenForm,
        submitForm,
        saveAnswers,
        hasSeenOnboarding,
        markAsSeenOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bv2Tr.ErrorBoundary), {
        errorUtils: moduleContext.utils.errorUtils
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U2FW.NoticeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6W5Vt.PfFlagsProvider), {
        flags: settings.flags
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9rYSe.UtilsProvider), {
        utils: moduleContext.utils
    }, issueViewStore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Ihci.IssueViewFormApiProvider), {
        api: moduleContext.apis.issueViewFormApi
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $N5QrD.FormIndexStoreContainer), {
        api: api,
        errorUtils: moduleContext.utils.errorUtils,
        projectId: settings.context.projectId,
        permissions: moduleContext.permissions,
        scope: settings.context.issueId.toString()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i7kEj.IssueView), {
        proformaUrl: settings.urls.api,
        issueViewStore: issueViewStore,
        permissions: moduleContext.permissions,
        showFormVisibility: settings.context.showFormVisibility || false,
        addFormButtonClickedCount: addFormButtonClickedCount,
        disableIssueViewFullPageDropzoneCallback: settings.context.editModeCallback,
        projectType: settings.context.projectType
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8b5Ks.FireUIAnalytics), {
        actionSubject: (0, $erWXD.ActionSubject).PANEL,
        action: (0, $erWXD.Action).VIEWED,
        actionSubjectId: "proformaFormSystem"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: "pf-dialog-container"
    }))))));
};
const $81ea2bf3dcd8fd64$var$WrappedIssueViewApp = ({ settings: settings, addFormButtonClickedCount: addFormButtonClickedCount })=>{
    const { showFlag: showFlag } = (0, $7ndW8.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $f6U3Q.useUFOComponentExperience)((0, $1A1EL.issueViewAttachedFormExperience));
    const [configuration, setConfiguration] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        const utils = (0, $6jvUj.createUtils)(settings, 'IssueView', showFlag, createAnalyticsEvent, settings.context.intlLocale);
        let permissions = (0, $3PJX6.readOnlyPermissions);
        if (settings.context.userIsProjectAdmin && settings.context.userCanEditIssue) permissions = (0, $3PJX6.adminPermissions);
        else if (settings.context.userCanEditIssue) permissions = (0, $3PJX6.editPermissions);
        setConfiguration({
            settings: settings,
            moduleContext: {
                permissions: permissions,
                apis: {
                    issueViewFormApi: new (0, $y7oWF.LiveIssueViewFormApi)(utils.apiUtil, settings.context.projectId, settings.context.issueId)
                },
                utils: {
                    errorUtils: utils.errorUtils
                }
            }
        });
    }, [
        createAnalyticsEvent,
        settings,
        showFlag
    ]);
    return configuration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81ea2bf3dcd8fd64$export$88baa5c10fe8794, {
        settings: configuration.settings,
        moduleContext: configuration.moduleContext,
        addFormButtonClickedCount: addFormButtonClickedCount
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $81ea2bf3dcd8fd64$export$881cc5030249ac05 = (props)=>{
    const mediaContext = {
        mediaUploadAndViewContexts: props.mediaContextDetails,
        projectId: props.settings.context.projectId,
        issueKey: props.settings.context.issueKey,
        mediaReadTokenRefresh: props.mediaReadTokenRefresh
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bV8dQ.AnalyticsProvider), props.settings.analytics, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBLXw.ContextWrapper), {
        sourceName: "proformaJiraIssueView",
        sourceType: (0, $d253eab4f2dd6d94$export$f636b5b56f1d624a),
        attributes: $81ea2bf3dcd8fd64$var$getAnalyticsAttributes(props.settings.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ndW8.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iu3cq.MediaProvider), {
        mediaContext: mediaContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81ea2bf3dcd8fd64$var$WrappedIssueViewApp, props)))));
};
const $81ea2bf3dcd8fd64$var$getAnalyticsAttributes = (settings)=>{
    const { projectId: projectId, projectType: projectType, issueId: issueId, userIsProjectAdmin: userIsProjectAdmin, userCanEditIssue: userCanEditIssue, showFormVisibility: showFormVisibility } = settings;
    return {
        projectId: projectId,
        projectType: projectType,
        issueId: issueId,
        isIssueEditableByUser: userCanEditIssue || false,
        isProjectAdmin: userIsProjectAdmin || false,
        isFormVisibilityShown: showFormVisibility || false
    };
};

});
parcelRegister("alnGD", function(module, exports) {

$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "computed", () => computed);
$parcel$export(module.exports, "getDependencyTree", () => getDependencyTree);
$parcel$export(module.exports, "Reaction", () => Reaction);
$parcel$export(module.exports, "spy", () => spy);
$parcel$export(module.exports, "action", () => action);
$parcel$export(module.exports, "runInAction", () => runInAction);
$parcel$export(module.exports, "configure", () => configure);
$parcel$export(module.exports, "toJS", () => toJS);
$parcel$export(module.exports, "transaction", () => transaction);
/** MobX - (c) Michel Weststrate 2015 - 2020 - MIT Licensed */ 
var $6cAn5 = parcelRequire("6cAn5");
var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var mockGlobal = {};
function getGlobal() {
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message) {
    invariant(false, message);
    throw "X"; // unreachable
}
function invariant(check, message) {
    if (!check) throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */ var deprecatedMessages = [];
function deprecated(msg, thing) {
    return false;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function() {};
function unique(list) {
    var res = [];
    list.forEach(function(item) {
        if (res.indexOf(item) === -1) res.push(item);
    });
    return res;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object") return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return fail("Cannot convert to map from '" + dataStructure + "'");
}
function makeNonEnumerable(object, propNames) {
    for(var i = 0; i < propNames.length; i++)addHiddenProp(object, propNames[i], object[propNames[i]]);
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || descriptor.configurable !== false && descriptor.writable !== false;
}
function assertPropertyConfigurable(object, prop) {}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */ function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map) return true;
    return false;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
// use Array.from in Mobx 5
function iteratorToArray(it) {
    var res = [];
    while(true){
        var r = it.next();
        if (r.done) break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol() {
    // es-disable-next-line
    return typeof Symbol === "function" && Symbol.toPrimitive || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
// Use "for of" in V5
function forOf(iter, callback) {
    var next = iter.next();
    while(!next.done){
        callback(next.value);
        next = iter.next();
    }
}
function iteratorSymbol() {
    return typeof Symbol === "function" && Symbol.iterator || "@@iterator";
}
function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}
function makeIterable(iterator) {
    iterator[iteratorSymbol()] = getSelf;
    return iterator;
}
function toStringTagSymbol() {
    return typeof Symbol === "function" && Symbol.toStringTag || "@@toStringTag";
}
function getSelf() {
    return this;
}
/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */ var Atom = /** @class */ function() {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */ function Atom(name) {
        if (name === void 0) name = "Atom@" + getNextId();
        this.name = name;
        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.isBeingObserved = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    Atom.prototype.onBecomeUnobserved = function() {
    // noop
    };
    Atom.prototype.onBecomeObserved = function() {
    /* noop */ };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */ Atom.prototype.reportObserved = function() {
        return reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */ Atom.prototype.reportChanged = function() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    Atom.prototype.toString = function() {
        return this.name;
    };
    return Atom;
}();
var isAtom = createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    onBecomeObserved(atom, onBecomeObservedHandler);
    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer,
    shallow: shallowComparer
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return cache[prop] || (cache[prop] = {
        configurable: true,
        enumerable: enumerable,
        get: function() {
            initializeInstance(this);
            return this[prop];
        },
        set: function(value) {
            initializeInstance(this);
            this[prop] = value;
        }
    });
}
function initializeInstance(target) {
    if (target.__mobxDidRunLazyInitializers === true) return;
    var decorators = target.__mobxDecorators;
    if (decorators) {
        addHiddenProp(target, "__mobxDidRunLazyInitializers", true);
        for(var key in decorators){
            var d = decorators[key];
            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
        }
    }
}
function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate(target, prop, descriptor, applyImmediately) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
                var inheritedDecorators = target.__mobxDecorators;
                addHiddenProp(target, "__mobxDecorators", __assign({}, inheritedDecorators));
            }
            target.__mobxDecorators[prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY;
            return decorator.apply(null, arguments);
        } else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator(args) {
    return (args.length === 2 || args.length === 3) && typeof args[1] === "string" || args.length === 4 && args[3] === true;
}
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
    return fail(false);
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue, name) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
function createDecoratorForEnhancer(enhancer) {
    invariant(enhancer);
    var decorator = createPropDecorator(true, function(target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        var initialValue = descriptor ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value : undefined;
        defineObservableProperty(target, propertyName, initialValue, enhancer);
    });
    var res = // Extra process checks, as this happens during module initialization
    (typeof $6cAn5 !== "undefined" && $6cAn5.env, decorator);
    res.enhancer = enhancer;
    return res;
}
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined
};
var shallowCreateObservableOptions = {
    deep: false,
    name: undefined,
    defaultDecorator: undefined
};
Object.freeze(defaultCreateObservableOptions);
Object.freeze(shallowCreateObservableOptions);
function assertValidOption(key) {
    if (!/^(deep|name|equals|defaultDecorator)$/.test(key)) fail("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions(thing) {
    if (thing === null || thing === undefined) return defaultCreateObservableOptions;
    if (typeof thing === "string") return {
        name: thing,
        deep: true
    };
    return thing;
}
function getEnhancerFromOptions(options) {
    return options.defaultDecorator ? options.defaultDecorator.enhancer : options.deep === false ? referenceEnhancer : deepEnhancer;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string") return deepDecorator.apply(null, arguments);
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    var res = isPlainObject(v) ? observable.object(v, arg2, arg3) : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : isES6Set(v) ? observable.set(v, arg2) : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v) return res;
    // otherwise, just box it
    fail(false);
}
var observableFactories = {
    box: function(value, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    shallowBox: function(value, name) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowBox");
        deprecated("observable.shallowBox", "observable.box(value, { deep: false })");
        return observable.box(value, {
            name: name,
            deep: false
        });
    },
    array: function(initialValues, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions(options);
        return new ObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowArray: function(initialValues, name) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowArray");
        deprecated("observable.shallowArray", "observable.array(values, { deep: false })");
        return observable.array(initialValues, {
            name: name,
            deep: false
        });
    },
    map: function(initialValues, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowMap: function(initialValues, name) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("shallowMap");
        deprecated("observable.shallowMap", "observable.map(values, { deep: false })");
        return observable.map(initialValues, {
            name: name,
            deep: false
        });
    },
    set: function(initialValues, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("set");
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function(props, decorators, options) {
        if (typeof arguments[1] === "string") incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions(options);
        return extendObservable({}, props, decorators, o);
    },
    shallowObject: function(props, name) {
        if (typeof arguments[1] === "string") incorrectlyUsedAsDecorator("shallowObject");
        deprecated("observable.shallowObject", "observable.object(values, {}, { deep: false })");
        return observable.object(props, {}, {
            name: name,
            deep: false
        });
    },
    ref: refDecorator,
    shallow: shallowDecorator,
    deep: deepDecorator,
    struct: refStructDecorator
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function(name) {
    return observable[name] = observableFactories[name];
});
function incorrectlyUsedAsDecorator(methodName) {
    fail(// process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}
var computedDecorator = createPropDecorator(false, function(instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    // Forcing instance now, fixes hot reloadig issues on React Native:
    var options = decoratorArgs[0] || {};
    defineComputedProperty(instance, propertyName, __assign({
        get: get,
        set: set
    }, options));
});
var computedStructDecorator = computedDecorator({
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") // @computed
    return computedDecorator.apply(null, arguments);
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) // @computed({ options })
    return computedDecorator.apply(null, arguments);
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */ 
    return new ComputedValue(opts);
};
computed.struct = computedStructDecorator;
var IDerivationState;
(function(IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ function() {
    function CaughtException(cause) {
        this.cause = cause;
    // Empty
    }
    return CaughtException;
}();
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState){
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
// function invariantShouldCompute(derivation: IDerivation) {
//     const newDepState = (derivation as any).dependenciesState
//     if (
//         process.env.NODE_ENV === "production" &&
//         (newDepState === IDerivationState.POSSIBLY_STALE ||
//             newDepState === IDerivationState.NOT_TRACKING)
//     )
//         fail("Illegal dependency state")
// }
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers) fail(false);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "strict")) fail(false);
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    if (derivation.observing.length === 0) warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = derivation.observing = derivation.newObserving;
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState;
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var dep = prevObserving[l];
        if (dep.diffValue === 0) removeObserver(dep, derivation);
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE) return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var functionNameDescriptor = Object.getOwnPropertyDescriptor(function() {}, "name");
var isFunctionNameConfigurable = functionNameDescriptor && functionNameDescriptor.configurable;
function createAction(actionName, fn) {
    var res = function() {
        return executeAction(actionName, fn, this, arguments);
    };
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = _startAction(actionName, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = args && args.length || 0;
        var flattendArgs = new Array(l);
        if (l > 0) for(var i = 0; i < l; i++)flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    var prevAllowStateReads = allowStateReadsStart(true);
    var runInfo = {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        prevAllowStateReads: prevAllowStateReads,
        notifySpy: notifySpy,
        startTime: startTime,
        actionId: nextActionId++,
        parentActionId: currentActionId
    };
    currentActionId = runInfo.actionId;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId) fail("invalid action stack. did you forget to finish an action?");
    currentActionId = runInfo.parentActionId;
    if (runInfo.error !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    allowStateReadsEnd(runInfo.prevAllowStateReads);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy) spyReportEnd({
        time: Date.now() - runInfo.startTime
    });
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    } finally{
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
function allowStateChangesInsideComputed(func) {
    var prev = globalState.computationDepth;
    globalState.computationDepth = 0;
    var res;
    try {
        res = func();
    } finally{
        globalState.computationDepth = prev;
    }
    return res;
}
var ObservableValue = /** @class */ function(_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy, equals) {
        if (name === void 0) name = "ObservableValue@" + getNextId();
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer.default;
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.name = name;
        _this.equals = equals;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) // only notify spy if this is a stand-alone observable
        spyReport({
            type: "create",
            name: _this.name,
            newValue: "" + _this.value
        });
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function(newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) spyReportStart({
                type: "update",
                name: this.name,
                newValue: newValue,
                oldValue: oldValue
            });
            this.setNewValue(newValue);
            if (notifySpy) spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.equals(this.value, newValue) ? globalState.UNCHANGED : newValue;
    };
    ObservableValue.prototype.setNewValue = function(newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: "update",
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    ObservableValue.prototype.get = function() {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function(handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function(listener, fireImmediately) {
        if (fireImmediately) listener({
            object: this,
            type: "update",
            newValue: this.value,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function() {
        return this.get();
    };
    ObservableValue.prototype.toString = function() {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function() {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(Atom);
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /** @class */ function() {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce a new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */ function ComputedValue(options) {
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        invariant(options.get, "missing option for computed: get");
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId();
        if (options.set) this.setter = createAction(this.name + "-setter", options.set);
        this.equals = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        this.keepAlive = !!options.keepAlive;
    }
    ComputedValue.prototype.onBecomeStale = function() {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function() {};
    ComputedValue.prototype.onBecomeObserved = function() {};
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */ ComputedValue.prototype.get = function() {
        if (this.isComputing) fail("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState.inBatch === 0 && this.observers.length === 0 && !this.keepAlive) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead();
                startBatch(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
            }
        }
        var result = this.value;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function() {
        var res = this.computeValue(false);
        if (isCaughtException(res)) throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function(value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else invariant(false, false);
    };
    ComputedValue.prototype.trackAndCompute = function() {
        if (isSpyEnabled()) spyReport({
            object: this.scope,
            type: "compute",
            name: this.name
        });
        var oldValue = this.value;
        var wasSuspended = /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals(oldValue, newValue);
        if (changed) this.value = newValue;
        return changed;
    };
    ComputedValue.prototype.computeValue = function(track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope);
            else try {
                res = this.derivation.call(this.scope);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.suspend = function() {
        if (!this.keepAlive) {
            clearObserving(this);
            this.value = undefined; // don't hold on to computed value!
        }
    };
    ComputedValue.prototype.observe = function(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.warnAboutUntrackedRead = function() {
        return;
    };
    ComputedValue.prototype.toJSON = function() {
        return this.get();
    };
    ComputedValue.prototype.toString = function() {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function() {
        return toPrimitive(this.get());
    };
    return ComputedValue;
}();
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED"
];
var MobXGlobals = /** @class */ function() {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         *
         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
         * internal state storage of MobX, and can be the same across many different package versions
         */ this.version = 5;
        /**
         * globally unique token to signal unchanged
         */ this.UNCHANGED = {};
        /**
         * Currently running derivation
         */ this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */ this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */ this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */ this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */ this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */ this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */ this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */ this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */ this.allowStateChanges = true;
        /**
         * Is it allowed to read observables at this point?
         * Used to hold the state needed for `observableRequiresReaction`
         */ this.allowStateReads = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */ this.enforceActions = false;
        /**
         * Spy callbacks
         */ this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */ this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */ this.computedRequiresReaction = false;
        /**
         * (Experimental)
         * Warn if you try to create to derivation / reactive context without accessing any observable.
         */ this.reactionRequiresObservable = false;
        /**
         * (Experimental)
         * Warn if observables are accessed outside a reactive context
         */ this.observableRequiresReaction = false;
        /**
         * Allows overwriting of computed properties, useful in tests but not prod as it can cause
         * memory leaks. See https://github.com/mobxjs/mobx/issues/1867
         */ this.computedConfigurable = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */ this.disableErrorBoundaries = false;
        /*
         * If true, we are already handling an exception in an action. Any errors in reactions should be supressed, as
         * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
         */ this.suppressReactionErrors = false;
    }
    return MobXGlobals;
}();
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = function() {
    var global1 = getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        setTimeout(function() {
            if (!isolateCalled) fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) fail("isolateGlobalState should be called before MobX is running any reactions");
    isolateCalled = true;
    if (canMergeGlobalState) {
        if (--getGlobal().__mobxInstanceCount === 0) getGlobal().__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) // because object assignment is relatively expensive, let's not store data about index 0.
    observable.observersIndexes[node.__mapid] = l;
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState) observable.lowestObserverState = node.dependenciesState;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    } else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) // map store all indexes but 0, see comment in `addObserver`
            map[filler.__mapid] = index;
            else delete map[filler.__mapid];
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBecomeUnobserved();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observable of another, etc..
                observable.suspend();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */ if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
            if (!observable.isBeingObserved) {
                observable.isBeingObserved = true;
                observable.onBecomeObserved();
            }
        }
        return true;
    } else if (observable.observers.length === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE) return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while(i--){
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) logTraceInfo(d, observable);
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE) return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while(i--){
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE) d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE) return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while(i--){
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) logTraceInfo(d, observable);
            d.onBecomeStale();
        }
    }
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /** @class */ function() {
    function Reaction(name, onInvalidate, errorHandler, requiresObservable) {
        if (name === void 0) name = "Reaction@" + getNextId();
        if (requiresObservable === void 0) requiresObservable = false;
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.requiresObservable = requiresObservable;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function() {
        this.schedule();
    };
    Reaction.prototype.schedule = function() {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function() {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */ Reaction.prototype.runReaction = function() {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending && isSpyEnabled()) // onInvalidate didn't trigger track right away..
                    spyReport({
                        name: this.name,
                        type: "scheduled-reaction"
                    });
                } catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function(fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation(result.cause);
        if (notify) spyReportEnd({
            time: Date.now() - startTime
        });
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function(error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
        if (globalState.suppressReactionErrors) console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
        else console.error(message, error);
        if (isSpyEnabled()) spyReport({
            type: "error",
            name: this.name,
            message: message,
            error: "" + error
        });
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    Reaction.prototype.dispose = function() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function() {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        return r;
    };
    Reaction.prototype.toString = function() {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.trace = function(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length) return;
    var listeners = globalState.spyListeners;
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](event);
}
function spyReportStart(event) {
    var change = __assign(__assign({}, event), {
        spyReportStart: true
    });
    spyReport(change);
}
var END_EVENT = {
    spyReportEnd: true
};
function spyReportEnd(change) {
    if (change) spyReport(__assign(__assign({}, change), {
        spyReportEnd: true
    }));
    else spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function() {
        globalState.spyListeners = globalState.spyListeners.filter(function(l) {
            return l !== listener;
        });
    });
}
function dontReassignFields() {
    fail(false);
}
function namedActionDecorator(name) {
    return function(target, prop, descriptor) {
        if (descriptor) {
            // babel / typescript
            // @action method() { }
            if (descriptor.value) // typescript
            return {
                value: createAction(name, descriptor.value),
                enumerable: false,
                configurable: true,
                writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
            };
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function() {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function actionFieldDecorator(name) {
    // Simple property that writes on first invocation to the current instance
    return function(target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function() {
                return undefined;
            },
            set: function(value) {
                addHiddenProp(this, prop, action(name, value));
            }
        });
    };
}
function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) // if (descriptor.value)
    // Typescript / Babel: @action.bound method() { }
    // also: babel @action.bound method = () => {}
    return {
        configurable: true,
        enumerable: false,
        get: function() {
            defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
            return this[propertyName];
        },
        set: dontReassignFields
    };
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function(v) {
            defineBoundAction(this, propertyName, v);
        },
        get: function() {
            return undefined;
        }
    };
}
var action = function action(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function") return createAction(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function") return createAction(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string") return namedActionDecorator(arg1);
    // @action fn() {}
    if (arg4 === true) // apply to instance immediately
    arg1[arg2] = createAction(arg1.name || arg2, arg3.value);
    else return namedActionDecorator(arg2).apply(null, arguments);
};
action.bound = boundActionDecorator;
function runInAction(arg1, arg2) {
    // TODO: deprecate?
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    return executeAction(actionName, fn, this, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = opts && opts.name || view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function() {
                    isScheduled_1 = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
var run = function(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    if (opts === void 0) opts = EMPTY_OBJECT;
    if (typeof opts === "boolean") {
        opts = {
            fireImmediately: opts
        };
        deprecated("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
    }
    var name = opts.name || "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer.default;
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false; // Q: move into reaction runner?
        if (r.isDisposed) return;
        var changed = false;
        r.track(function() {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, r);
        if (!firstTime && changed === true) effectAction(value, r);
        if (firstTime) firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = typeof arg3 === "function" ? arg3 : arg2;
    var orig = atom[hook];
    if (typeof orig !== "function") return fail(false);
    atom[hook] = function() {
        orig.call(this);
        cb.call(this);
    };
    return function() {
        atom[hook] = orig;
    };
}
function configure(options) {
    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, computedConfigurable = options.computedConfigurable, disableErrorBoundaries = options.disableErrorBoundaries, arrayBuffer = options.arrayBuffer, reactionScheduler = options.reactionScheduler, reactionRequiresObservable = options.reactionRequiresObservable, observableRequiresReaction = options.observableRequiresReaction;
    if (options.isolateGlobalState === true) isolateGlobalState();
    if (enforceActions !== undefined) {
        if (typeof enforceActions === "boolean" || enforceActions === "strict") deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
        var ea = void 0;
        switch(enforceActions){
            case true:
            case "observed":
                ea = true;
                break;
            case false:
            case "never":
                ea = false;
                break;
            case "strict":
            case "always":
                ea = "strict";
                break;
            default:
                fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
        }
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) globalState.computedRequiresReaction = !!computedRequiresReaction;
    if (reactionRequiresObservable !== undefined) globalState.reactionRequiresObservable = !!reactionRequiresObservable;
    if (observableRequiresReaction !== undefined) {
        globalState.observableRequiresReaction = !!observableRequiresReaction;
        globalState.allowStateReads = !globalState.observableRequiresReaction;
    }
    if (computedConfigurable !== undefined) globalState.computedConfigurable = !!computedConfigurable;
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true) console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (typeof arrayBuffer === "number") reserveArrayBuffer(arrayBuffer);
    if (reactionScheduler) setReactionScheduler(reactionScheduler);
}
function decorate(thing, decorators) {
    var target = typeof thing === "function" ? thing.prototype : thing;
    var _loop_1 = function(prop) {
        var propertyDecorators = decorators[prop];
        if (!Array.isArray(propertyDecorators)) propertyDecorators = [
            propertyDecorators
        ];
        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
        var newDescriptor = propertyDecorators.reduce(function(accDescriptor, decorator) {
            return decorator(target, prop, accDescriptor);
        }, descriptor);
        if (newDescriptor) Object.defineProperty(target, prop, newDescriptor);
    };
    for(var prop in decorators)_loop_1(prop);
    return thing;
}
function extendShallowObservable(target, properties, decorators) {
    deprecated("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
    return extendObservable(target, properties, decorators, shallowCreateObservableOptions);
}
function extendObservable(target, properties, decorators, options) {
    var key;
    options = asCreateObservableOptions(options);
    var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
    initializeInstance(target);
    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    startBatch();
    try {
        var keys = Object.getOwnPropertyNames(properties);
        for(var i = 0, l = keys.length; i < l; i++){
            var key = keys[i];
            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
            var decorator = decorators && key in decorators ? decorators[key] : descriptor.get ? computedDecorator : defaultDecorator;
            var resultDescriptor = decorator(target, key, descriptor, true);
            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
            ) Object.defineProperty(target, key, resultDescriptor);
        }
    } finally{
        endBatch();
    }
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0) result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node)) result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
function flow(generator) {
    if (arguments.length !== 1) fail("Flow expects one 1 argument and cannot be used as decorator");
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    return function() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var res = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        res.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var res_1 = gen.return(undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(res_1.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return res;
    };
}
function cancelPromise(promise) {
    if (typeof promise.cancel === "function") promise.cancel();
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string") return fail(false);
        target = getAdministration(thing, propOrHandler);
    } else return fail(false);
    if (target.dehancer !== undefined) return fail(false);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function") return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}
function _isComputed(value, property) {
    if (value === null || value === undefined) return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false) return false;
        if (!value.$mobx.values[property]) return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function isComputed(value) {
    if (arguments.length > 1) return fail(false);
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (typeof propName !== "string") return fail(false);
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (value === null || value === undefined) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value.$mobx || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    if (arguments.length !== 1) fail(false);
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (typeof propName !== "string") return fail(false);
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj.$mobx.getKeys();
    if (isObservableMap(obj)) return iteratorToArray(obj.keys());
    if (isObservableSet(obj)) return iteratorToArray(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    return fail(false);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return iteratorToArray(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    return fail(false);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return iteratorToArray(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    return fail(false);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var values_1 = key;
        try {
            for(var key_1 in values_1)set(obj, key_1, values_1[key_1]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) {
        var adm = obj.$mobx;
        var existingObservable = adm.values[key];
        if (existingObservable) adm.write(obj, key, value);
        else defineObservableProperty(obj, key, value, adm.defaultEnhancer);
    } else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else return fail(false);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj.$mobx.remove(key);
    else if (isObservableMap(obj)) obj.delete(key);
    else if (isObservableSet(obj)) obj.delete(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        obj.splice(key, 1);
    } else return fail(false);
}
function has(obj, key) {
    if (isObservableObject(obj)) {
        // return keys(obj).indexOf(key) >= 0
        var adm = getAdministration(obj);
        adm.getKeys(); // make sure we get notified of key changes, but for performance, use the values map to look up existence
        return !!adm.values[key];
    } else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    else return fail(false);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[key];
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    else return fail(false);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function") return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}
var defaultOptions = {
    detectCycles: true,
    exportMapsAsObjects: true,
    recurseEverything: false
};
function cache(map, key, value, options) {
    if (options.detectCycles) map.set(key, value);
    return value;
}
function toJSHelper(source, options, __alreadySeen) {
    if (!options.recurseEverything && !isObservable(source)) return source;
    if (typeof source !== "object") return source;
    // Directly return null if source is null
    if (source === null) return null;
    // Directly return the Date object itself if contained in the observable
    if (source instanceof Date) return source;
    if (isObservableValue(source)) return toJSHelper(source.get(), options, __alreadySeen);
    // make sure we track the keys of the object
    if (isObservable(source)) keys(source);
    var detectCycles = options.detectCycles === true;
    if (detectCycles && source !== null && __alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source) || Array.isArray(source)) {
        var res_1 = cache(__alreadySeen, source, [], options);
        var toAdd = source.map(function(value) {
            return toJSHelper(value, options, __alreadySeen);
        });
        res_1.length = toAdd.length;
        for(var i = 0, l = toAdd.length; i < l; i++)res_1[i] = toAdd[i];
        return res_1;
    }
    if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_2 = cache(__alreadySeen, source, new Set(), options);
            source.forEach(function(value) {
                res_2.add(toJSHelper(value, options, __alreadySeen));
            });
            return res_2;
        } else {
            var res_3 = cache(__alreadySeen, source, [], options);
            source.forEach(function(value) {
                res_3.push(toJSHelper(value, options, __alreadySeen));
            });
            return res_3;
        }
    }
    if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_4 = cache(__alreadySeen, source, new Map(), options);
            source.forEach(function(value, key) {
                res_4.set(key, toJSHelper(value, options, __alreadySeen));
            });
            return res_4;
        } else {
            var res_5 = cache(__alreadySeen, source, {}, options);
            source.forEach(function(value, key) {
                res_5[key] = toJSHelper(value, options, __alreadySeen);
            });
            return res_5;
        }
    }
    // Fallback to the situation that source is an ObservableObject or a plain object
    var res = cache(__alreadySeen, source, {}, options);
    for(var key in source)res[key] = toJSHelper(source[key], options, __alreadySeen);
    return res;
}
function toJS(source, options) {
    // backward compatibility
    if (typeof options === "boolean") options = {
        detectCycles: options
    };
    if (!options) options = defaultOptions;
    options.detectCycles = options.detectCycles === undefined ? options.recurseEverything === true : options.detectCycles === true;
    var __alreadySeen;
    if (options.detectCycles) __alreadySeen = new Map();
    return toJSHelper(source, options, __alreadySeen);
}
function trace() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean") enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) return fail(false);
    if (derivation.isTracing === TraceMode.NONE) console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") timeoutHandle = setTimeout(function() {
        if (!disposer.$mobx.isDisposed) {
            disposer();
            var error = new Error("WHEN_TIMEOUT");
            if (opts.onError) opts.onError(error);
            else throw error;
        }
    }, opts.timeout);
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    var disposer = autorun(function(r) {
        if (predicate()) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var cancel;
    var res = new Promise(function(resolve, reject) {
        var disposer = _when(predicate, resolve, __assign(__assign({}, opts), {
            onError: reject
        }));
        cancel = function() {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors) for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function() {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = /** @class */ function() {
    function StubArray() {}
    return StubArray;
}();
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") Object["setPrototypeOf"](ctor.prototype, proto);
    else if (typeof ctor.prototype.__proto__ !== "undefined") ctor.prototype.__proto__ = proto;
    else ctor["prototype"] = proto;
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) [
    "constructor",
    "push",
    "shift",
    "concat",
    "pop",
    "unshift",
    "replace",
    "find",
    "findIndex",
    "splice",
    "reverse",
    "sort"
].forEach(function(key) {
    Object.defineProperty(StubArray.prototype, key, {
        configurable: true,
        writable: true,
        value: Array.prototype[key]
    });
});
var ObservableArrayAdministration = /** @class */ function() {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.atom = new Atom(name || "ObservableArray@" + getNextId());
        this.enhancer = function(newV, oldV) {
            return enhancer(newV, oldV, name + "[..]");
        };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function(handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            object: this.array,
            type: "splice",
            index: 0,
            added: this.values.slice(),
            addedCount: this.values.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function() {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function(newLength) {
        if (typeof newLength !== "number" || newLength < 0) throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        } else this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function(oldLength, delta) {
        if (oldLength !== this.lastKnownLength) throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE) reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer(v, undefined);
        });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function(index, deleteCount, newItems) {
        var _a;
        if (newItems.length < MAX_SPLICE_SIZE) return (_a = this.values).splice.apply(_a, __spread([
            index,
            deleteCount
        ], newItems));
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values.slice(0, index).concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function(index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            object: this.array,
            type: "update",
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        if (notifySpy) spyReportStart(__assign(__assign({}, change), {
            name: this.atom.name
        }));
        this.atom.reportChanged();
        if (notify) notifyListeners(this, change);
        if (notifySpy) spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function(index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            object: this.array,
            type: "splice",
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        if (notifySpy) spyReportStart(__assign(__assign({}, change), {
            name: this.atom.name
        }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
        if (notifySpy) spyReportEnd();
    };
    return ObservableArrayAdministration;
}();
var ObservableArray = /** @class */ function(_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) name = "ObservableArray@" + getNextId();
        if (owned === void 0) owned = false;
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            var prev = allowStateChangesStart(true);
            _this.spliceWithArray(0, 0, initialValues);
            allowStateChangesEnd(prev);
        }
        if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter untill any * numeric property is
        // defined on the instance. After that it works fine, even if this property is deleted.
        Object.defineProperty(adm.array, "0", ENTRY_0);
        return _this;
    }
    ObservableArray.prototype.intercept = function(handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function() {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function() {
        var arrays = [];
        for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function(a) {
            return isObservableArray(a) ? a.peek() : a;
        }));
    };
    ObservableArray.prototype.replace = function(newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */ ObservableArray.prototype.toJS = function() {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function() {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function() {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function(predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) fromIndex = 0;
        if (arguments.length === 3) deprecated("The array.find fromIndex argument to find will not be supported anymore in the next major");
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function(predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) fromIndex = 0;
        if (arguments.length === 3) deprecated("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
        var items = this.peek(), l = items.length;
        for(var i = fromIndex; i < l; i++)if (predicate.call(thisArg, items[i], i, this)) return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */ ObservableArray.prototype.splice = function(index, deleteCount) {
        var newItems = [];
        for(var _i = 2; _i < arguments.length; _i++)newItems[_i - 2] = arguments[_i];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function(index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function() {
        var items = [];
        for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function() {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function() {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function() {
        var items = [];
        for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function(compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function(value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function(fromIndex, toIndex) {
        deprecated("observableArray.move is deprecated, use .slice() & .replace() instead");
        function checkIndex(index) {
            if (index < 0) throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            var length = this.$mobx.values.length;
            if (index >= length) throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) return;
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
            oldItems[fromIndex]
        ], oldItems.slice(toIndex + 1));
        else // toIndex < fromIndex
        newItems = __spread(oldItems.slice(0, toIndex), [
            oldItems[fromIndex]
        ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function(index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function(index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        } else if (index === values.length) // add a new item
        adm.spliceWithArray(index, 0, [
            newValue
        ]);
        else // out of bounds
        throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
    };
    return ObservableArray;
}(StubArray);
declareIterator(ObservableArray.prototype, function() {
    this.$mobx.atom.reportObserved();
    var self1 = this;
    var nextIndex = 0;
    return makeIterable({
        next: function() {
            return nextIndex < self1.length ? {
                value: self1[nextIndex++],
                done: false
            } : {
                done: true,
                value: undefined
            };
        }
    });
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function() {
        return this.$mobx.getArrayLength();
    },
    set: function(newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
addHiddenProp(ObservableArray.prototype, toStringTagSymbol(), "Array");
[
    "indexOf",
    "join",
    "lastIndexOf",
    "slice",
    "toString",
    "toLocaleString"
].forEach(function(funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function() {
        return baseFunc.apply(this.peek(), arguments);
    });
});
[
    "every",
    "filter",
    //"find", // implemented individually (IE support)
    //"findIndex", // implemented individually (IE support)
    //"flatMap", // not supported
    "forEach",
    "map",
    "some"
].forEach(function(funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function(callback, thisArg) {
        var _this = this;
        var adm = this.$mobx;
        adm.atom.reportObserved();
        var dehancedValues = adm.dehanceValues(adm.values);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this);
        }, thisArg);
    });
});
[
    "reduce",
    "reduceRight"
].forEach(function(funcName) {
    addHiddenProp(ObservableArray.prototype, funcName, function() {
        var _this = this;
        var adm = this.$mobx;
        adm.atom.reportObserved();
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            currentValue = adm.dehanceValue(currentValue);
            return callback(accumulator, currentValue, index, _this);
        };
        return adm.values[funcName].apply(adm.values, arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */ makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function() {
            return this.get(index);
        },
        set: function(value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}
var ObservableMapMarker = {};
var ObservableMap = /** @class */ function() {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name === void 0) name = "ObservableMap@" + getNextId();
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._keysAtom = createAtom(this.name + ".keys()");
        if (typeof Map !== "function") throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function(key) {
        return this._data.has(key);
    };
    ObservableMap.prototype.has = function(key) {
        var _this = this;
        if (!globalState.trackingDerivation) return this._has(key);
        var entry = this._hasMap.get(key);
        if (!entry) {
            // todo: replace with atom (breaking change)
            var newEntry = entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
            this._hasMap.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this._hasMap.delete(key);
            });
        }
        return entry.get();
    };
    ObservableMap.prototype.set = function(key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this._updateValue(key, value);
        else this._addValue(key, value);
        return this;
    };
    ObservableMap.prototype.delete = function(key) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "delete",
                object: this,
                oldValue: this._data.get(key).value,
                name: key
            } : null;
            if (notifySpy) spyReportStart(__assign(__assign({}, change), {
                name: this.name,
                key: key
            }));
            transaction(function() {
                _this._keysAtom.reportChanged();
                _this._updateHasMapEntry(key, false);
                var observable = _this._data.get(key);
                observable.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify) notifyListeners(this, change);
            if (notifySpy) spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function(key, value) {
        var entry = this._hasMap.get(key);
        if (entry) entry.setNewValue(value);
    };
    ObservableMap.prototype._updateValue = function(key, newValue) {
        var observable = this._data.get(key);
        newValue = observable.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "update",
                object: this,
                oldValue: observable.value,
                name: key,
                newValue: newValue
            } : null;
            if (notifySpy) spyReportStart(__assign(__assign({}, change), {
                name: this.name,
                key: key
            }));
            observable.setNewValue(newValue);
            if (notify) notifyListeners(this, change);
            if (notifySpy) spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function(key, newValue) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        transaction(function() {
            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);
            _this._data.set(key, observable);
            newValue = observable.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keysAtom.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            type: "add",
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notifySpy) spyReportStart(__assign(__assign({}, change), {
            name: this.name,
            key: key
        }));
        if (notify) notifyListeners(this, change);
        if (notifySpy) spyReportEnd();
    };
    ObservableMap.prototype.get = function(key) {
        if (this.has(key)) return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    ObservableMap.prototype.keys = function() {
        this._keysAtom.reportObserved();
        return this._data.keys();
    };
    ObservableMap.prototype.values = function() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function() {
                var _a = keys.next(), done = _a.done, value = _a.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    ObservableMap.prototype.entries = function() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function() {
                var _a = keys.next(), done = _a.done, value = _a.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    ObservableMap.prototype.forEach = function(callback, thisArg) {
        var _this = this;
        this._keysAtom.reportObserved();
        this._data.forEach(function(_, key) {
            return callback.call(thisArg, _this.get(key), key, _this);
        });
    };
    /** Merge another object into this object, returns this. */ ObservableMap.prototype.merge = function(other) {
        var _this = this;
        if (isObservableMap(other)) other = other.toJS();
        transaction(function() {
            var prev = allowStateChangesStart(true);
            try {
                if (isPlainObject(other)) Object.keys(other).forEach(function(key) {
                    return _this.set(key, other[key]);
                });
                else if (Array.isArray(other)) other.forEach(function(_a) {
                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                    return _this.set(key, value);
                });
                else if (isES6Map(other)) {
                    if (other.constructor !== Map) fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
                    else other.forEach(function(value, key) {
                        return _this.set(key, value);
                    });
                } else if (other !== null && other !== undefined) fail("Cannot initialize map from " + other);
            } finally{
                allowStateChangesEnd(prev);
            }
        });
        return this;
    };
    ObservableMap.prototype.clear = function() {
        var _this = this;
        transaction(function() {
            untracked(function() {
                // Note we are concurrently reading/deleting the same keys
                // forEach handles this properly
                _this._data.forEach(function(_, key) {
                    return _this.delete(key);
                });
            });
        });
    };
    ObservableMap.prototype.replace = function(values) {
        var _this = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            forOf(_this._data.keys(), function(key) {
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this.delete(key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this._data.get(key);
                        orderedData.set(key, value);
                    }
                }
            });
            // Merge entries
            forOf(replacementMap.entries(), function(_a) {
                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                // We will want to know whether a new key is added
                var keyExisted = _this._data.has(key);
                // Add or update value
                _this.set(key, value);
                // The addition could have been prevent by interceptor
                if (_this._data.has(key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var value_1 = _this._data.get(key);
                    orderedData.set(key, value_1);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            });
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this._data.size !== orderedData.size) // If size differs, keys are definitely modified
                _this._keysAtom.reportChanged();
                else {
                    var iter1 = _this._data.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this._keysAtom.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this._data = orderedData;
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function() {
            this._keysAtom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */ ObservableMap.prototype.toPOJO = function() {
        var _this = this;
        var res = {};
        this.forEach(function(_, key) {
            return res[typeof key === "symbol" ? key : stringifyKey(key)] = _this.get(key);
        });
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */ ObservableMap.prototype.toJS = function() {
        return new Map(this);
    };
    ObservableMap.prototype.toJSON = function() {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap.prototype.toString = function() {
        var _this = this;
        return this.name + "[{ " + iteratorToArray(this.keys()).map(function(key) {
            return stringifyKey(key) + ": " + ("" + _this.get(key));
        }).join(", ") + " }]";
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */ ObservableMap.prototype.observe = function(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function(handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}();
function stringifyKey(key) {
    if (key && key.toString) return key.toString();
    else return new String(key).toString();
}
declareIterator(ObservableMap.prototype, function() {
    return this.entries();
});
addHiddenFinalProp(ObservableMap.prototype, toStringTagSymbol(), "Map");
/* 'var' fixes small-build issue */ var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
var ObservableSetMarker = {};
var ObservableSet = /** @class */ function() {
    function ObservableSet(initialData, enhancer, name) {
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name === void 0) name = "ObservableSet@" + getNextId();
        this.name = name;
        this.$mobx = ObservableSetMarker;
        this._data = new Set();
        this._atom = createAtom(this.name);
        if (typeof Set !== "function") throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
        this.enhancer = function(newV, oldV) {
            return enhancer(newV, oldV, name);
        };
        if (initialData) this.replace(initialData);
    }
    ObservableSet.prototype.dehanceValue = function(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    ObservableSet.prototype.clear = function() {
        var _this = this;
        transaction(function() {
            untracked(function() {
                _this._data.forEach(function(value) {
                    _this.delete(value);
                });
            });
        });
    };
    ObservableSet.prototype.forEach = function(callbackFn, thisArg) {
        var _this = this;
        this._atom.reportObserved();
        this._data.forEach(function(value) {
            callbackFn.call(thisArg, value, value, _this);
        });
    };
    Object.defineProperty(ObservableSet.prototype, "size", {
        get: function() {
            this._atom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    ObservableSet.prototype.add = function(value) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._atom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "add",
                object: this,
                newValue: value
            });
            if (!change) return this;
        // TODO: ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this._data.add(_this.enhancer(value, undefined));
                _this._atom.reportChanged();
            });
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "add",
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        return this;
    };
    ObservableSet.prototype.delete = function(value) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "delete",
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this._atom.reportChanged();
                _this._data.delete(value);
            });
            if (notify) notifyListeners(this, change);
            return true;
        }
        return false;
    };
    ObservableSet.prototype.has = function(value) {
        this._atom.reportObserved();
        return this._data.has(this.dehanceValue(value));
    };
    ObservableSet.prototype.entries = function() {
        var nextIndex = 0;
        var keys = iteratorToArray(this.keys());
        var values = iteratorToArray(this.values());
        return makeIterable({
            next: function() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    ObservableSet.prototype.keys = function() {
        return this.values();
    };
    ObservableSet.prototype.values = function() {
        this._atom.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues;
        if (this._data.values !== undefined) observableValues = iteratorToArray(this._data.values());
        else {
            // There is no values function in IE11
            observableValues = [];
            this._data.forEach(function(e) {
                return observableValues.push(e);
            });
        }
        return makeIterable({
            next: function() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    ObservableSet.prototype.replace = function(other) {
        var _this = this;
        if (isObservableSet(other)) other = other.toJS();
        transaction(function() {
            var prev = allowStateChangesStart(true);
            try {
                if (Array.isArray(other)) {
                    _this.clear();
                    other.forEach(function(value) {
                        return _this.add(value);
                    });
                } else if (isES6Set(other)) {
                    _this.clear();
                    other.forEach(function(value) {
                        return _this.add(value);
                    });
                } else if (other !== null && other !== undefined) fail("Cannot initialize set from " + other);
            } finally{
                allowStateChangesEnd(prev);
            }
        });
        return this;
    };
    ObservableSet.prototype.observe = function(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    ObservableSet.prototype.intercept = function(handler) {
        return registerInterceptor(this, handler);
    };
    ObservableSet.prototype.toJS = function() {
        return new Set(this);
    };
    ObservableSet.prototype.toString = function() {
        return this.name + "[ " + iteratorToArray(this.keys()).join(", ") + " ]";
    };
    return ObservableSet;
}();
declareIterator(ObservableSet.prototype, function() {
    return this.values();
});
addHiddenFinalProp(ObservableSet.prototype, toStringTagSymbol(), "Set");
var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);
var ObservableObjectAdministration = /** @class */ function() {
    function ObservableObjectAdministration(target, name, defaultEnhancer) {
        this.target = target;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.values = {};
    }
    ObservableObjectAdministration.prototype.read = function(owner, key) {
        if (this.target !== owner) {
            this.illegalAccess(owner, key);
            if (!this.values[key]) return undefined;
        }
        return this.values[key].get();
    };
    ObservableObjectAdministration.prototype.write = function(owner, key, newValue) {
        var instance = this.target;
        if (instance !== owner) this.illegalAccess(owner, key);
        var observable = this.values[key];
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "update",
                object: instance,
                name: key,
                newValue: newValue
            });
            if (!change) return;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var change = notify || notifySpy ? {
                type: "update",
                object: instance,
                oldValue: observable.value,
                name: key,
                newValue: newValue
            } : null;
            if (notifySpy) spyReportStart(__assign(__assign({}, change), {
                name: this.name,
                key: key
            }));
            observable.setNewValue(newValue);
            if (notify) notifyListeners(this, change);
            if (notifySpy) spyReportEnd();
        }
    };
    ObservableObjectAdministration.prototype.remove = function(key) {
        if (!this.values[key]) return;
        var target = this.target;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: target,
                name: key,
                type: "remove"
            });
            if (!change) return;
        }
        try {
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var oldValue = this.values[key].get();
            if (this.keys) this.keys.remove(key);
            delete this.values[key];
            delete this.target[key];
            var change = notify || notifySpy ? {
                type: "remove",
                object: target,
                oldValue: oldValue,
                name: key
            } : null;
            if (notifySpy) spyReportStart(__assign(__assign({}, change), {
                name: this.name,
                key: key
            }));
            if (notify) notifyListeners(this, change);
            if (notifySpy) spyReportEnd();
        } finally{
            endBatch();
        }
    };
    ObservableObjectAdministration.prototype.illegalAccess = function(owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */ console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */ ObservableObjectAdministration.prototype.observe = function(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function(handler) {
        return registerInterceptor(this, handler);
    };
    ObservableObjectAdministration.prototype.getKeys = function() {
        var _this = this;
        if (this.keys === undefined) this.keys = new ObservableArray(Object.keys(this.values).filter(function(key) {
            return _this.values[key] instanceof ObservableValue;
        }), referenceEnhancer, "keys(" + this.name + ")", true);
        return this.keys.slice();
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, name, defaultEnhancer) {
    if (name === void 0) name = "";
    if (defaultEnhancer === void 0) defaultEnhancer = deepEnhancer;
    var adm = target.$mobx;
    if (adm) return adm;
    if (!isPlainObject(target)) name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name) name = "ObservableObject@" + getNextId();
    adm = new ObservableObjectAdministration(target, name, defaultEnhancer);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservableProperty(target, propName, newValue, enhancer) {
    var adm = asObservableObject(target);
    assertPropertyConfigurable(target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change) return;
        newValue = change.newValue;
    }
    var observable = adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false);
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(target, propName, generateObservablePropConfig(propName));
    if (adm.keys) adm.keys.push(propName);
    notifyPropertyAddition(adm, target, propName, newValue);
}
function defineComputedProperty(target, propName, options) {
    var adm = asObservableObject(target);
    options.name = adm.name + "." + propName;
    options.context = target;
    adm.values[propName] = new ComputedValue(options);
    Object.defineProperty(target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = Object.create(null);
var computedPropertyConfigs = Object.create(null);
function generateObservablePropConfig(propName) {
    return observablePropertyConfigs[propName] || (observablePropertyConfigs[propName] = {
        configurable: true,
        enumerable: true,
        get: function() {
            return this.$mobx.read(this, propName);
        },
        set: function(v) {
            this.$mobx.write(this, propName, v);
        }
    });
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner.$mobx;
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance(owner);
        return owner.$mobx;
    }
    return adm;
}
function generateComputedPropConfig(propName) {
    return computedPropertyConfigs[propName] || (computedPropertyConfigs[propName] = {
        configurable: globalState.computedConfigurable,
        enumerable: false,
        get: function() {
            return getAdministrationForComputedPropOwner(this).read(this, propName);
        },
        set: function(v) {
            getAdministrationForComputedPropOwner(this).write(this, propName, v);
        }
    });
}
function notifyPropertyAddition(adm, object, key, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy ? {
        type: "add",
        object: object,
        name: key,
        newValue: newValue
    } : null;
    if (notifySpy) spyReportStart(__assign(__assign({}, change), {
        name: adm.name,
        key: key
    }));
    if (notify) notifyListeners(adm, change);
    if (notifySpy) spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) fail(false);
            return thing.$mobx.atom;
        }
        if (isObservableSet(thing)) return thing.$mobx;
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined) return anyThing._keysAtom;
            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable) fail(false);
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        if (property && !thing.$mobx) thing[property]; // See #1072
        if (isObservableObject(thing)) {
            if (!property) return fail(false);
            var observable = thing.$mobx.values[property];
            if (!observable) fail(false);
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) // disposer function
        return thing.$mobx;
    }
    return fail(false);
}
function getAdministration(thing, property) {
    if (!thing) fail("Expecting some object");
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance(thing);
    if (thing.$mobx) return thing.$mobx;
    fail(false);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else named = getAtom(thing); // valid for arrays as well
    return named.name;
}
var toString = Object.prototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return(// eslint-disable-next-line
            typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(typeof aCtor === "function" && aCtor instanceof aCtor && typeof bCtor === "function" && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key = void 0;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.peek();
    if (isES6Map(a) || isObservableMap(a)) return iteratorToArray(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return iteratorToArray(a.entries());
    return a;
}
function has$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}
/**
 * (c) Michel Weststrate 2015 - 2019
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    // tslint:disable-next-line
    "production";
} catch (e) {
    var g = getGlobal();
    if (typeof $6cAn5 === "undefined") g.process = {};
    g.process.env = {};
}
(function() {
    function testCodeMinification() {}
    testCodeMinification.name;
    var varName;
})();
// forward compatibility with mobx, so that packages can easily support mobx 4 & 5
var $mobx = "$mobx";
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});
var warnedAboutDefaultExport_1;

});

parcelRegister("hBLXw", function(module, exports) {

$parcel$export(module.exports, "ContextWrapper", () => $14008dab6d90a2a9$export$34282a1f95511a11);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");

var $htBRZ = parcelRequire("htBRZ");
const $14008dab6d90a2a9$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};
const $14008dab6d90a2a9$export$34282a1f95511a11 = (props)=>{
    const data = $14008dab6d90a2a9$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: data,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: props.children
        })
    });
};

});

parcelRegister("8b5Ks", function(module, exports) {

$parcel$export(module.exports, "FireUIAnalytics", () => $0c97521da2f23e1a$export$1f3555c9be6c5e08);
$parcel$export(module.exports, "FireTrackAnalytics", () => $0c97521da2f23e1a$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $0c97521da2f23e1a$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $0c97521da2f23e1a$export$2ccf161b817b43b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");


var $aNTEp = parcelRequire("aNTEp");
const $0c97521da2f23e1a$var$getFixedActionAndActionSubject = (props)=>{
    const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const $0c97521da2f23e1a$var$getFixedActionSubjectId = (props)=>{
    const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class $0c97521da2f23e1a$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action: action, actionSubject: actionSubject } = $0c97521da2f23e1a$var$getFixedActionAndActionSubject(this.props);
        const { actionSubjectId: actionSubjectId } = $0c97521da2f23e1a$var$getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $aNTEp.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $0c97521da2f23e1a$var$WithAnalytics = (0, $3TR0I.default)()($0c97521da2f23e1a$var$FireComponent);
const $0c97521da2f23e1a$export$1f3555c9be6c5e08 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($0c97521da2f23e1a$var$WithAnalytics, {
        ...props,
        type: (0, $d253eab4f2dd6d94$export$a1562d08625f5d7e)
    });
const $0c97521da2f23e1a$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($0c97521da2f23e1a$var$WithAnalytics, {
        ...props,
        type: (0, $d253eab4f2dd6d94$export$947dac6c72b26f81)
    });
const $0c97521da2f23e1a$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($0c97521da2f23e1a$var$WithAnalytics, {
        ...props,
        type: (0, $d253eab4f2dd6d94$export$12346a674644c156)
    });
const $0c97521da2f23e1a$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($0c97521da2f23e1a$var$WithAnalytics, {
        ...props,
        type: (0, $d253eab4f2dd6d94$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});
const $d253eab4f2dd6d94$export$f636b5b56f1d624a = 'Screen';
const $d253eab4f2dd6d94$export$9d2de6eebf7462b5 = 'Drawer';
const $d253eab4f2dd6d94$export$1171103ea9083ffa = 'Modal';
const $d253eab4f2dd6d94$export$cae2783c9279926 = 'InlineDialog';
const $d253eab4f2dd6d94$export$d1123261ca8831d2 = 'Dropdown';
const $d253eab4f2dd6d94$export$a1562d08625f5d7e = 'UI';
const $d253eab4f2dd6d94$export$947dac6c72b26f81 = 'TRACK';
const $d253eab4f2dd6d94$export$f1d537d508d2945a = 'SCREEN';
const $d253eab4f2dd6d94$export$12346a674644c156 = 'OPERATIONAL';
const $d253eab4f2dd6d94$export$2ceccf177fae277c = 'analyticsBridge';


parcelRegister("bEQ2i", function(module, exports) {

$parcel$export(module.exports, "useFormSaveErrorsActions", () => $87cbcb65748b9438$export$48041cd2370efddc);
$parcel$export(module.exports, "useFormSaveQuestionError", () => $87cbcb65748b9438$export$6c13595b521b4dfd);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $bngFq = parcelRequire("bngFq");

var $aNTEp = parcelRequire("aNTEp");

var $erWXD = parcelRequire("erWXD");
const $87cbcb65748b9438$var$initialState = {
    errorsByQuestionId: {}
};
const $87cbcb65748b9438$var$actions = {
    set: (errorsByQuestionId)=>({ setState: setState })=>setState({
                errorsByQuestionId: errorsByQuestionId
            }),
    setFromJiraFieldErrors: (form, jiraFieldErrors)=>({ setState: setState })=>{
            const formQuestionsByJiraField = form.questions.reduce((accQuestions, question)=>{
                const jiraField = question.formQuestion.jiraField;
                if (!jiraField) return accQuestions;
                return {
                    ...accQuestions,
                    [jiraField]: question
                };
            }, {});
            const errorsByQuestionId = Object.entries(jiraFieldErrors).reduce((accErrorsByQuestionId, [jiraField, error])=>{
                var _formQuestionsByJiraF, _formQuestionsByJiraF2;
                const questionId = ((_formQuestionsByJiraF = formQuestionsByJiraField[jiraField]) === null || _formQuestionsByJiraF === void 0 ? void 0 : _formQuestionsByJiraF.id) && Number((_formQuestionsByJiraF2 = formQuestionsByJiraField[jiraField]) === null || _formQuestionsByJiraF2 === void 0 ? void 0 : _formQuestionsByJiraF2.id);
                if (!questionId) return accErrorsByQuestionId;
                return {
                    ...accErrorsByQuestionId,
                    [questionId]: error
                };
            }, {});
            setState({
                ...$87cbcb65748b9438$var$initialState,
                errorsByQuestionId: errorsByQuestionId
            });
        },
    clear: ()=>({ setState: setState })=>setState($87cbcb65748b9438$var$initialState)
};
const $87cbcb65748b9438$var$Store = (0, $iXqE5.createStore)({
    initialState: $87cbcb65748b9438$var$initialState,
    actions: $87cbcb65748b9438$var$actions,
    name: `FormSaveErrors`
});
const $87cbcb65748b9438$var$useFormSaveErrors = (0, $3sQ5x.createHook)($87cbcb65748b9438$var$Store);
const $87cbcb65748b9438$export$48041cd2370efddc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [, { set: set, setFromJiraFieldErrors: setFromJiraFieldErrors, clear: clear }] = $87cbcb65748b9438$var$useFormSaveErrors();
    const setWithAnalytics = (0, $5uXOq.useCallback)((errorsByQuestionId)=>{
        if (Object.keys(errorsByQuestionId).length > 0) (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM_SAVE} ${(0, $erWXD.Action).STOPPED}`);
        set(errorsByQuestionId);
    }, [
        createAnalyticsEvent,
        set
    ]);
    const setWithJiraFieldErrorsWithAnalytics = (0, $5uXOq.useCallback)((form, jiraFieldErrors)=>{
        if (Object.keys(jiraFieldErrors).length > 0) (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM_SAVE} ${(0, $erWXD.Action).STOPPED}`);
        setFromJiraFieldErrors(form, jiraFieldErrors);
    }, [
        createAnalyticsEvent,
        setFromJiraFieldErrors
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            set: setWithAnalytics,
            setFromJiraFieldErrors: setWithJiraFieldErrorsWithAnalytics,
            clear: clear
        }), [
        clear,
        setWithAnalytics,
        setWithJiraFieldErrorsWithAnalytics
    ]);
};
const $87cbcb65748b9438$export$6c13595b521b4dfd = (questionId)=>{
    const [{ errorsByQuestionId: errorsByQuestionId }] = $87cbcb65748b9438$var$useFormSaveErrors();
    return errorsByQuestionId[questionId];
};

});
parcelRegister("erWXD", function(module, exports) {

$parcel$export(module.exports, "ActionSubject", () => $a85152b408a7fe70$export$7f97440769de1377);
$parcel$export(module.exports, "Action", () => $a85152b408a7fe70$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "FormUpdateType", () => $a85152b408a7fe70$export$d7867a52899740a0);
/* Read https://hello.atlassian.net/wiki/spaces/DQ/pages/786078865 on how to instrument well. */ // These are entities in ProForma. Reuse as much as possible.
// Think carefully when making a new ActionSubject about whether you can reuse an existing one.
let $a85152b408a7fe70$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    // Objects
    ActionSubject["FORM"] = "form";
    // An actual form on an issue.
    ActionSubject["FORM_FIELD"] = "formField";
    // A field in a form.
    ActionSubject["FORM_FIELD_CHOICES_DATA_CONNECTION"] = "formFieldChoicesDataConnection";
    // A data connection's choices in a form.
    ActionSubject["FORM_FIELD_CHOICES_JIRA_FIELD"] = "formFieldChoicesJiraField";
    // A Jira field's choices in a form.
    ActionSubject["FORM_SETTINGS_LANGUAGE"] = "formSettingsLanguage";
    // Language dropdown of a form in form settings.
    ActionSubject["FORM_SETTINGS_SUBMIT"] = "formSettingsSubmit";
    // Lock and PDF of a form on submit toggle in form settings.
    ActionSubject["FORM_SETTINGS_ISSUE_CREATE"] = "formSettingsIssueCreate";
    // Submit and validate on create toggle in form settings.
    ActionSubject["FORM_SETTINGS_ISSUE_FORMS_TYPES"] = "formSettingsIssueFormsTypes";
    // Issue forms types dropdown in form settings, enabled through issue forms toggle.
    ActionSubject["FORM_SETTINGS_RECOMMENDED_FORMS_TYPES"] = "formSettingsRecommendedFormsTypes";
    // Recommended forms types dropdown in form settings, enabled through recommended forms toggle.
    ActionSubject["FORM_SETTINGS_REQUEST_CREATE_TYPES"] = "formSettingsRequestCreateTypes";
    // Request create types dropdown in form settings, enabled through request create toggle ("Attach to request types").
    ActionSubject["QUESTION_ANSWER"] = "questionAnswer";
    // Answer of a Question in a form.
    ActionSubject["TEMPLATE_FORM"] = "templateForm";
    // A form in a project created by form builder than can be then instantiated on an issue.
    ActionSubject["EXAMPLE_TEMPLATE"] = "exampleTemplate";
    // Predefined templates available in the form builder that can be inserted into a template form.
    ActionSubject["BUTTON"] = "button";
    ActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
    ActionSubject["SELECT_ITEM"] = "selectItem";
    ActionSubject["FILTER"] = "filter";
    ActionSubject["LIST"] = "list";
    ActionSubject["PANEL"] = "panel";
    ActionSubject["SECTION"] = "section";
    ActionSubject["TABLE"] = "table";
    ActionSubject["MODAL"] = "modal";
    ActionSubject["PROFORMA_API"] = "proformaAPI";
    ActionSubject["PROFORMA_UI"] = "proformaUI";
    ActionSubject["SECTION_MESSAGE"] = "sectionMessage";
    ActionSubject["ATTACHMENT"] = "proformaAttachment";
    ActionSubject["ATTACHMENT_UPLOAD"] = "proformaAttachmentUpload";
    ActionSubject["ATTACHMENT_VIEWER"] = "proformaAttachmentViewer";
    ActionSubject["ATTACHMENT_VIEWER_CARD"] = "proformaAttachmentViewerCard";
    ActionSubject["REQUEST_TYPE"] = "requestType";
    ActionSubject["DUPLICATE_REQUEST_TYPE_LINKED_FIELDS_WARNING_MODAL"] = "duplicateRequestTypeLinkedFieldsWarningModal";
    ActionSubject["TRANSLATIONS_EDITOR"] = "translationsEditor";
    ActionSubject["FORM_PERMISSIONS"] = "proformaFormPermissions";
    // Processes
    ActionSubject["ADF_NODE_INSERT"] = "adfNodeInsert";
    ActionSubject["FORM_VALIDATION"] = "formValidation";
    ActionSubject["FORM_EDIT"] = "formEdit";
    ActionSubject["FORM_SAVE"] = "formSave";
    ActionSubject["SEARCH_ASYNC_CHOICES"] = "searchAsyncChoices";
    ActionSubject["FETCH_FORM_ATTACHMENTS"] = "fetchFormAttachments";
    ActionSubject["UPLOAD_ISSUE_FORM_ATTACHMENTS"] = "uploadFormAttachments";
    ActionSubject["TRANSLATIONS_LANGUAGES_LOAD"] = "translationsLoad";
    ActionSubject["TRANSLATIONS_LOAD"] = "translationsLoad";
    ActionSubject["TRANSLATIONS_SAVE"] = "translationsSave";
    ActionSubject["TRANSLATIONS_DELETE"] = "translationsDelete";
    return ActionSubject;
}({});
let $a85152b408a7fe70$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    // Objects
    Action["ADDED"] = "added";
    // When an entity is added/inserted into another.
    Action["CLICKED"] = "clicked";
    Action["CREATED"] = "created";
    Action["DELETED"] = "deleted";
    Action["DOWNLOADED"] = "downloaded";
    Action["EXPORTED"] = "exported";
    Action["UPDATED"] = "updated";
    Action["VIEWED"] = "viewed";
    Action["SELECTED"] = "selected";
    Action["COPIED"] = "copied";
    // Processes
    Action["FAILED"] = "failed";
    Action["FINISHED"] = "finished";
    Action["STARTED"] = "started";
    Action["STOPPED"] = "stopped";
    return Action;
}({});
let $a85152b408a7fe70$export$d7867a52899740a0 = /*#__PURE__*/ function(FormUpdateType) {
    FormUpdateType["REOPEN"] = "REOPEN";
    FormUpdateType["SAVE"] = "SAVE";
    FormUpdateType["SET_EXTERNAL"] = "SET_EXTERNAL";
    FormUpdateType["SET_INTERNAL"] = "SET_INTERNAL";
    FormUpdateType["SUBMIT"] = "SUBMIT";
    FormUpdateType["CLOSE"] = "CLOSE"; // Similar to SUBMIT, used in "Close customer edits" option in form card meatball menu
    return FormUpdateType;
}({});

});


parcelRegister("bv2Tr", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $85f4d5778164d0dc$export$e926676385687eaf);
/* eslint-disable react/destructuring-assignment */ 
var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $k9nuy = parcelRequire("k9nuy");

var $9FSw2 = parcelRequire("9FSw2");

var $erWXD = parcelRequire("erWXD");
class $85f4d5778164d0dc$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            errorInfo: null,
            error: null
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo.componentStack
        });
        this.props.errorUtils.reportError(error, {
            actionSubject: (0, $erWXD.ActionSubject).PROFORMA_UI,
            id: 'errorBoundary',
            errorInfo: errorInfo
        });
    }
    render() {
        if (this.state.hasError) {
            // Render error UI here
            const { renderError: renderError } = this.props;
            return renderError ? renderError({
                error: this.state.error
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f4d5778164d0dc$var$ErrorPage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f4d5778164d0dc$var$ErrorPageSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
                appearance: "error",
                title: "Something went wrong"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
                as: "p"
            }, "Refresh the page and try again. ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), "If the error persists,", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: "https://support.thinktilt.com",
                target: "_blank",
                rel: "noopener noreferrer"
            }, "contact support"), "."))));
        }
        return this.props.children;
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85f4d5778164d0dc$var$ErrorPage = (0, $dAHxw.default).div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression -- Ignored via go/DSP-18766
const $85f4d5778164d0dc$var$ErrorPageSection = (0, $dAHxw.default).div({});

});
parcelRegister("dAHxw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e506934574c3414$export$2e2bcd8739ae039);
parcelRequire("bS32t");
parcelRequire("5uXOq");
parcelRequire("bS0aY");

var $bWGt6 = parcelRequire("bWGt6");

parcelRequire("l9ACI");
parcelRequire("7PpcK");
parcelRequire("lDKn9");
var $9e506934574c3414$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $9e506934574c3414$var$newStyled = (0, $bWGt6.default).bind();
$9e506934574c3414$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $9e506934574c3414$var$newStyled[tagName] = $9e506934574c3414$var$newStyled(tagName);
});
var $9e506934574c3414$export$2e2bcd8739ae039 = $9e506934574c3414$var$newStyled;

});


parcelRegister("iu3cq", function(module, exports) {

$parcel$export(module.exports, "MediaProvider", () => $d74d82b21dcfae89$export$57164260bc1f1218);
$parcel$export(module.exports, "useMediaContext", () => $d74d82b21dcfae89$export$2d636d13f24b27df);

var $5uXOq = parcelRequire("5uXOq");
const $d74d82b21dcfae89$var$MediaContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $d74d82b21dcfae89$export$57164260bc1f1218 = ({ children: children, mediaContext: mediaContext })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d74d82b21dcfae89$var$MediaContext.Provider, {
        value: mediaContext
    }, children);
};
function $d74d82b21dcfae89$export$2d636d13f24b27df() {
    const mediaContext = (0, $5uXOq.useContext)($d74d82b21dcfae89$var$MediaContext);
    const { mediaApiUploadToken: mediaApiUploadToken, mediaApiReadToken: mediaApiReadToken, projectId: projectId, portalId: portalId, issueKey: issueKey, mediaUploadAndViewContexts: mediaUploadAndViewContexts, mediaReadTokenRefresh: mediaReadTokenRefresh, mediaApiError: mediaApiError } = mediaContext !== null && mediaContext !== void 0 ? mediaContext : {};
    return {
        mediaApiUploadToken: mediaApiUploadToken,
        mediaApiReadToken: mediaApiReadToken,
        mediaUploadAndViewContexts: mediaUploadAndViewContexts,
        projectId: projectId,
        portalId: portalId,
        issueKey: issueKey,
        mediaReadTokenRefresh: mediaReadTokenRefresh,
        mediaApiError: mediaApiError
    };
}

});

parcelRegister("6W5Vt", function(module, exports) {

$parcel$export(module.exports, "PfFlagsProvider", () => $50ccc1a344ad6c19$export$33dbaef47fd9c29b);

var $5uXOq = parcelRequire("5uXOq");

var $8251k = parcelRequire("8251k");
const $50ccc1a344ad6c19$var$PfFlagsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $50ccc1a344ad6c19$export$33dbaef47fd9c29b = ({ flags: flags, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($50ccc1a344ad6c19$var$PfFlagsContext.Provider, {
        value: flags
    }, children);
};
function $50ccc1a344ad6c19$export$a37d68d19485eb11() {
    const flags = (0, $5uXOq.useContext)($50ccc1a344ad6c19$var$PfFlagsContext);
    if (flags === undefined) throw new Error(`usePfFlags must be used within a PfFlagsProvider. ${(0, $8251k.errorMessageDuplicateCommonCore)}`);
    return flags;
}

});
parcelRegister("8251k", function(module, exports) {

$parcel$export(module.exports, "errorMessageDuplicateCommonCore", () => $5d926790292467ac$export$202e68bc03a230f);
const $5d926790292467ac$export$202e68bc03a230f = "Please check that the yarn.lock file contains only 1 version of proforma-common-core. You should bump all Proforma packages to their latest version";

});


parcelRegister("9rYSe", function(module, exports) {

$parcel$export(module.exports, "UtilsProvider", () => $01c68bca0be3a904$export$df5be093c1f55d13);

var $5uXOq = parcelRequire("5uXOq");

var $ex6Rw = parcelRequire("ex6Rw");
const $01c68bca0be3a904$export$df5be093c1f55d13 = ({ utils: utils, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ex6Rw.PfErrorUtilsProvider), {
        errorUtils: utils.errorUtils
    }, children);
};

});
parcelRegister("ex6Rw", function(module, exports) {

$parcel$export(module.exports, "PfErrorUtilsProvider", () => $a9497877cb60343e$export$b71d28c58577f663);
$parcel$export(module.exports, "usePfErrorUtils", () => $a9497877cb60343e$export$19d62bf1891c25ff);

var $5uXOq = parcelRequire("5uXOq");

var $8251k = parcelRequire("8251k");
const $a9497877cb60343e$var$PfErrorUtilsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $a9497877cb60343e$export$b71d28c58577f663 = ({ errorUtils: errorUtils, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9497877cb60343e$var$PfErrorUtilsContext.Provider, {
        value: errorUtils
    }, children);
};
function $a9497877cb60343e$export$19d62bf1891c25ff() {
    const errorUtils = (0, $5uXOq.useContext)($a9497877cb60343e$var$PfErrorUtilsContext);
    if (errorUtils === undefined) throw new Error(`usePfErrorUtils() must be used within a PfErrorUtilsProvider. ${(0, $8251k.errorMessageDuplicateCommonCore)}`);
    return errorUtils;
}

});


parcelRegister("6jvUj", function(module, exports) {

$parcel$export(module.exports, "createErrorUtils", () => $498d4489c00ccef2$export$7a2f0d878b08650d);
$parcel$export(module.exports, "createUtils", () => $498d4489c00ccef2$export$b6881d4b4863cacc);
$parcel$export(module.exports, "createUtils2", () => $498d4489c00ccef2$export$e4e37e88de17afb6);

var $a1RLT = parcelRequire("a1RLT");

var $j93Fo = parcelRequire("j93Fo");

var $gFGsm = parcelRequire("gFGsm");
function $498d4489c00ccef2$export$7a2f0d878b08650d(errorUtilsModuleName, environment, createAnalyticsEvent, showFlag = ()=>()=>{}) {
    return new (0, $gFGsm.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
}
function $498d4489c00ccef2$export$b6881d4b4863cacc(settings, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
    const errorUtils = new (0, $gFGsm.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, settings.environment);
    (0, $j93Fo.setNoticeLocale)(locale);
    const apiUtil = new (0, $a1RLT.ApiUtil)(settings.urls.jira, settings.urls.api, errorUtils, createAnalyticsEvent);
    return {
        apiUtil: apiUtil,
        errorUtils: errorUtils
    };
}
function $498d4489c00ccef2$export$e4e37e88de17afb6(jiraUrl, apiUrl, environment, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
    const errorUtils = new (0, $gFGsm.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
    (0, $j93Fo.setNoticeLocale)(locale);
    const apiUtil = new (0, $a1RLT.ApiUtil)(jiraUrl, apiUrl, errorUtils, createAnalyticsEvent);
    return {
        apiUtil: apiUtil,
        errorUtils: errorUtils
    };
}

});
parcelRegister("a1RLT", function(module, exports) {

$parcel$export(module.exports, "AcceptedResponseType", () => $74d3b548944c3270$export$9126c50ecfe2a46d);
$parcel$export(module.exports, "ApiUtil", () => $74d3b548944c3270$export$baa861b25a2283a4);

var $bDAxW = parcelRequire("bDAxW");

var $erWXD = parcelRequire("erWXD");

var $bRqoO = parcelRequire("bRqoO");

var $caW8j = parcelRequire("caW8j");
let $74d3b548944c3270$export$9126c50ecfe2a46d = /*#__PURE__*/ function(AcceptedResponseType) {
    AcceptedResponseType["Json"] = "json";
    AcceptedResponseType["Blob"] = "blob";
    return AcceptedResponseType;
}({});
class $74d3b548944c3270$export$baa861b25a2283a4 {
    constructor(jiraUrl, proformaUrl, errorUtils, createAnalyticsEvent){
        this.errorUtils = void 0;
        this.jiraUrl = void 0;
        this.proformaUrl = void 0;
        this.createAnalyticsEvent = void 0;
        this.jiraUrl = jiraUrl;
        this.proformaUrl = proformaUrl;
        this.errorUtils = errorUtils;
        this.createAnalyticsEvent = createAnalyticsEvent;
    }
    get(path, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(true, 'GET', path, responseType, requestName);
    }
    jiraGet(path, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(false, 'GET', path, responseType, requestName);
    }
    put(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(true, 'PUT', path, responseType, requestName, body);
    }
    jiraPut(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(false, 'PUT', path, responseType, requestName, body);
    }
    post(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(true, 'POST', path, responseType, requestName, body);
    }
    jiraPost(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(false, 'POST', path, responseType, requestName, body);
    }
    delete(path, body, requestName, responseType = 'none') {
        return this.fetchApi(true, 'DELETE', path, responseType, requestName, body);
    }
    /** Converts the `relativePath` into an absolute ProForma API URI. */ createApiUrl(relativePath) {
        return this.proformaUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
    }
    /** Converts the `relativePath` into an absolute Jira URI. */ createJiraUrl(relativePath) {
        return this.jiraUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
    }
    getAnalyticsSource() {
        try {
            var _analyticsData$payloa, _analyticsData$payloa2;
            const analyticsEvent = this.createAnalyticsEvent({});
            const analyticsData = (0, $bDAxW.extractAWCDataFromEvent)(analyticsEvent);
            return (_analyticsData$payloa = analyticsData === null || analyticsData === void 0 ? void 0 : (_analyticsData$payloa2 = analyticsData.payload) === null || _analyticsData$payloa2 === void 0 ? void 0 : _analyticsData$payloa2.source) !== null && _analyticsData$payloa !== void 0 ? _analyticsData$payloa : 'unknown';
        } catch (e) {
            return 'unknown';
        }
    }
    fetchApi(proForma, method, path, responseType, requestName, body) {
        const analyticsSource = this.getAnalyticsSource();
        return fetch(proForma ? this.createApiUrl(path) : this.createJiraUrl(path), {
            method: method,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Experimental-Experience': analyticsSource,
                ...responseType === $74d3b548944c3270$export$9126c50ecfe2a46d.Json ? {
                    Accept: 'application/json'
                } : {}
            },
            ...body && {
                body: JSON.stringify(body)
            }
        }).catch((error)=>{
            const message = `No response from API: ${error.message || ''}`;
            const apiError = $74d3b548944c3270$var$toApiError(0, {
                error: message
            }, true, requestName);
            this.errorUtils.reportError(error, {
                actionSubject: (0, $erWXD.ActionSubject).PROFORMA_API,
                id: 'fetchApi',
                attributes: {
                    path: path,
                    method: method,
                    responseType: responseType,
                    requestName: requestName,
                    apiError: JSON.stringify(apiError),
                    isClientFetchError: true
                }
            });
            return Promise.reject(apiError);
        }).then((response)=>{
            let errorObj = new Error(response.statusText);
            if (!response.ok) {
                var _ref, _response$headers$get;
                const traceId = (_ref = (_response$headers$get = response.headers.get('x-trace-id')) !== null && _response$headers$get !== void 0 ? _response$headers$get : response.headers.get('atl-traceid')) !== null && _ref !== void 0 ? _ref : undefined;
                let apiErrorPromise;
                try {
                    // Try to parse response error details
                    const responseJsonApiError = responseType !== 'json' ? undefined : response.json().then((responseJson)=>$74d3b548944c3270$var$toApiError(response.status, responseJson, false, requestName, traceId)).catch((error)=>{
                        const message = `Failed to parse error response as JSON from API: ${error.message || ''}`;
                        errorObj = error;
                        return $74d3b548944c3270$var$toApiError(response.status, {
                            error: message
                        }, false, requestName, traceId);
                    });
                    if (response.status === 401) this.errorUtils.notifyUser((0, $bRqoO.NoticeType).ErrorApiUnauthorised);
                    if (response.status === 403) this.errorUtils.notifyUser((0, $bRqoO.NoticeType).ErrorApiMissingPermissions);
                    if (responseJsonApiError !== undefined) apiErrorPromise = responseJsonApiError.then((apiError)=>Promise.reject(apiError));
                    else // Create error object with error response body
                    apiErrorPromise = Promise.reject($74d3b548944c3270$var$toApiError(response.status, {
                        error: response.body || ''
                    }, false, requestName, traceId));
                } catch (error) {
                    const message = `Unexpected response from API: ${response.body || ''}`;
                    errorObj = error;
                    apiErrorPromise = Promise.reject($74d3b548944c3270$var$toApiError(response.status, {
                        error: message
                    }, false, requestName, traceId));
                }
                apiErrorPromise.catch((apiError)=>{
                    this.errorUtils.reportError(errorObj, {
                        actionSubject: (0, $erWXD.ActionSubject).PROFORMA_API,
                        id: 'fetchApi',
                        attributes: {
                            status: response.status,
                            statusGroup: `${Math.floor(response.status / 100)}xx`,
                            traceId: traceId,
                            path: path,
                            method: method,
                            responseType: responseType,
                            requestName: requestName,
                            apiError: JSON.stringify(apiError),
                            isClientFetchError: false
                        }
                    });
                });
                return apiErrorPromise;
            }
            if (response.status === 204) return '';
            switch(responseType){
                case 'json':
                    return response.json();
                case 'blob':
                    return response.blob();
                case 'text':
                    return response.text();
                case 'none':
                    return '';
                default:
                    return response;
            }
        });
    }
}
function $74d3b548944c3270$var$toApiError(status, responseJson, isClientFetchError, requestName, traceId) {
    if (Object.keys(responseJson).length === 0) return (0, $caW8j.constructApiError)(`Unexpected API reply (HTTP/${status})`, status, responseJson, requestName);
    const error = responseJson['error'] || `Unexpected API reply (HTTP/${status})`;
    const context = responseJson['context'];
    const contextId = responseJson['contextId'];
    const details = responseJson['details'];
    return (0, $caW8j.constructApiError)(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId);
}

});
parcelRegister("bRqoO", function(module, exports) {

$parcel$export(module.exports, "NoticeType", () => $8a291f441fcc3884$export$3b5003ffe8119af2);
$parcel$export(module.exports, "Notices", () => $8a291f441fcc3884$export$ba15f0a357d713fd);

var $9svqU = parcelRequire("9svqU");

var $7fcWf = parcelRequire("7fcWf");
let $8a291f441fcc3884$export$3b5003ffe8119af2 = /*#__PURE__*/ function(NoticeType) {
    NoticeType["ConfirmDeleteForm"] = "ConfirmDeleteForm";
    NoticeType["ConfirmChangeFormToInternal"] = "ConfirmChangeFormToInternal";
    NoticeType["ConfirmChangeFormToExternal"] = "ConfirmChangeFormToExternal";
    NoticeType["ConfirmCancelEdit"] = "ConfirmCancelEdit";
    NoticeType["ConfirmSubmitForm"] = "ConfirmSubmitForm";
    NoticeType["ConfirmSubmitFormLock"] = "ConfirmSubmitFormLock";
    NoticeType["ConfirmReopenForm"] = "ConfirmReopenForm";
    NoticeType["ErrorApiUnauthorised"] = "ErrorApiUnauthorised";
    NoticeType["ErrorApiMissingPermissions"] = "ErrorApiMissingPermissions";
    NoticeType["ErrorApiAddConnectionFailed"] = "ErrorApiAddConnectionFailed";
    NoticeType["ErrorApiUpdateConnectionFailed"] = "ErrorApiUpdateConnectionFailed";
    NoticeType["ErrorApiSubmitFormFailed"] = "ErrorApiSubmitFormFailed";
    NoticeType["ErrorApiSaveFormFailed"] = "ErrorApiSaveFormFailed";
    NoticeType["ErrorApiSaveFormFailedOnConflict"] = "ErrorApiSaveFormFailedOnConflict";
    NoticeType["ErrorApiSaveFormInvalidAnswersFailed"] = "ErrorApiSaveFormInvalidAnswersFailed";
    NoticeType["ErrorApiSaveTemplateFormFailed"] = "ErrorApiSaveTemplateFormFailed";
    NoticeType["ErrorApiLoadTemplateFormFailed"] = "ErrorApiLoadTemplateFormFailed";
    NoticeType["ErrorApiLoadJiraFieldsFailed"] = "ErrorApiLoadJiraFieldsFailed";
    NoticeType["ErrorApiLoadDataConnectionsFailed"] = "ErrorApiLoadDataConnectionsFailed";
    NoticeType["ErrorApiLoadSettingsRefDataFailed"] = "ErrorApiLoadSettingsRefDataFailed";
    return NoticeType;
}({});
const $8a291f441fcc3884$export$ba15f0a357d713fd = {
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmDeleteForm]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).DeleteFormTitle],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).DeleteFormMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Delete],
        isWarningNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormToInternal]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ChangeFormToInternalHeader],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ChangeFormToInternalMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).MakeInternal]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormToExternal]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ChangeFormToExternalHeader],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ChangeFormToExternalMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).MakeExternal]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmCancelEdit]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).CancelEditFormTitle],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).CancelEditFormMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Confirm]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitForm]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).SubmitFormTitle],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).SubmitFormMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Submit]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitFormLock]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).SubmitFormTitle],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).SubmitFormLockMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Submit]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmReopenForm]: {
        title: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ReopenFormTitle],
        message: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ReopenFormMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Reopen]
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiUnauthorised]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).UnauthorisedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).UnauthorisedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiMissingPermissions]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).MissingPermissionsTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).MissingPermissionsMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiAddConnectionFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).AddConnectionFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).AddConnectionFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiUpdateConnectionFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).UpdateConnectionFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).UpdateConnectionFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSubmitFormFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SubmitFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SubmitFormFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormInvalidAnswersFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormInvalidAnswersMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormFailedOnConflict]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveFormFailedOnConflictMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveTemplateFormFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveTemplateFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).SaveTemplateFormFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadTemplateFormFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadTemplateFormFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadTemplateFormFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadJiraFieldsFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadJiraFieldsFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadJiraFieldsFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadDataConnectionsFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadDataConnectionsFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadDataConnectionsFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadSettingsRefDataFailed]: {
        title: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadSettingsRefDataFailedTitle],
        message: (0, $9svqU.IntlApiErrorMessages)[(0, $9svqU.ApiErrorMessage).LoadSettingsRefDataFailedMsg],
        confirmText: (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close],
        isErrorNotice: true
    }
};

});
parcelRegister("9svqU", function(module, exports) {

$parcel$export(module.exports, "ApiErrorMessage", () => $6e2f1c86cfbb31d7$export$231e36d3eb058aab);
$parcel$export(module.exports, "IntlApiErrorMessages", () => $6e2f1c86cfbb31d7$export$4a210a14fc5cbd69);

var $7VHMR = parcelRequire("7VHMR");
let $6e2f1c86cfbb31d7$export$231e36d3eb058aab = /*#__PURE__*/ function(ApiErrorMessage) {
    ApiErrorMessage["UnauthorisedTitle"] = "UnauthorisedTitle";
    ApiErrorMessage["UnauthorisedMsg"] = "UnauthorisedMsg";
    ApiErrorMessage["MissingPermissionsTitle"] = "MissingPermissionsTitle";
    ApiErrorMessage["MissingPermissionsMsg"] = "MissingPermissionsMsg";
    ApiErrorMessage["AddConnectionFailedTitle"] = "AddConnectionFailedTitle";
    ApiErrorMessage["AddConnectionFailedMsg"] = "AddConnectionFailedMsg";
    ApiErrorMessage["UpdateConnectionFailedTitle"] = "UpdateConnectionFailedTitle";
    ApiErrorMessage["UpdateConnectionFailedMsg"] = "UpdateConnectionFailedMsg";
    ApiErrorMessage["SubmitFormFailedTitle"] = "SubmitFormFailedTitle";
    ApiErrorMessage["SubmitFormFailedMsg"] = "SubmitFormFailedMsg";
    ApiErrorMessage["SaveFormFailedTitle"] = "SaveFormFailedTitle";
    ApiErrorMessage["SaveFormFailedMsg"] = "SaveFormFailedMsg";
    ApiErrorMessage["SaveFormInvalidAnswersMsg"] = "SaveFormInvalidAnswersMsg";
    ApiErrorMessage["SaveFormFailedOnConflictMsg"] = "SaveFormFailedOnConflictMsg";
    ApiErrorMessage["SaveTemplateFormFailedTitle"] = "SaveTemplateFormFailedTitle";
    ApiErrorMessage["SaveTemplateFormFailedMsg"] = "SaveTemplateFormFailedMsg";
    ApiErrorMessage["LoadTemplateFormFailedTitle"] = "LoadTemplateFormFailedTitle";
    ApiErrorMessage["LoadTemplateFormFailedMsg"] = "LoadTemplateFormFailedMsg";
    ApiErrorMessage["LoadJiraFieldsFailedTitle"] = "LoadJiraFieldsFailedTitle";
    ApiErrorMessage["LoadJiraFieldsFailedMsg"] = "LoadJiraFieldsFailedMsg";
    ApiErrorMessage["LoadDataConnectionsFailedTitle"] = "LoadDataConnectionsFailedTitle";
    ApiErrorMessage["LoadDataConnectionsFailedMsg"] = "LoadDataConnectionsFailedMsg";
    ApiErrorMessage["LoadSettingsRefDataFailedTitle"] = "LoadSettingsRefDataFailedTitle";
    ApiErrorMessage["LoadSettingsRefDataFailedMsg"] = "LoadSettingsRefDataFailedMsg";
    return ApiErrorMessage;
}({});
const $6e2f1c86cfbb31d7$export$4a210a14fc5cbd69 = (0, $7VHMR.defineMessages)({
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UnauthorisedTitle]: {
        id: 'ui-notices.apiError.title.UnauthorisedTitle',
        defaultMessage: 'Error: User Unauthorised'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UnauthorisedMsg]: {
        id: 'ui-notices.apiError.msg.UnauthorisedMsg',
        defaultMessage: 'Try refreshing your page or logging into Jira again.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.MissingPermissionsTitle]: {
        id: 'ui-notices.apiError.title.MissingPermissionsTitle',
        defaultMessage: 'Error: User is not allowed this action'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.MissingPermissionsMsg]: {
        id: 'ui-notices.apiError.msg.MissingPermissionsMsg',
        defaultMessage: 'You do not have the necessary permissions to perform this action. Please contact your Jira Administrator.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.AddConnectionFailedTitle]: {
        id: 'ui-notices.apiError.title.AddConnectionFailedTitle',
        defaultMessage: 'Error: Adding data connection failed'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.AddConnectionFailedMsg]: {
        id: 'ui-notices.apiError.msg.AddConnectionFailedMsg',
        defaultMessage: 'A server error occurred while trying to add the data connection.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UpdateConnectionFailedTitle]: {
        id: 'ui-notices.apiError.title.UpdateConnectionFailedTitle',
        defaultMessage: 'Error: Updating data connection failed'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UpdateConnectionFailedMsg]: {
        id: 'ui-notices.apiError.msg.UpdateConnectionFailedMsg',
        defaultMessage: 'A server error occurred while trying to update the data connection.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SubmitFormFailedTitle]: {
        id: 'ui-notices.apiError.title.SubmitFormFailedTitle',
        defaultMessage: 'Error: Submitting form failed'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SubmitFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.SubmitFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to submit the form.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedTitle]: {
        id: 'ui-notices.apiError.title.SaveFormFailedTitle',
        defaultMessage: "We couldn\u2019t save your changes",
        description: 'The title on the error flag informing customers that their form failed to save.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.SaveFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to save the form.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormInvalidAnswersMsg]: {
        id: 'ui-notices.apiError.msg.SaveFormInvalidAnswersMsg',
        defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
        description: 'The error message on the error flag informing customers that their form failed to save due to invalid answers.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedOnConflictMsg]: {
        id: 'ui-notices.apiError.msg.SaveFormFailedOnConflictMsg',
        defaultMessage: 'The settings for this form have been changed. If you believe this was an error, leave a comment on the request.',
        description: "The error message on error flag informing customers about what happened and what to do when saving form answers request was rejected because the form state doesn't allow the customer to do so."
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveTemplateFormFailedTitle]: {
        id: 'ui-notices.apiError.title.SaveTemplateFormFailedTitle',
        defaultMessage: 'Error: Saving template form failed'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveTemplateFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.SaveTemplateFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to save the template form.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadTemplateFormFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadTemplateFormFailedTitle',
        defaultMessage: "We couldn\u2019t load your form"
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadTemplateFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadTemplateFormFailedMsg',
        defaultMessage: 'Refresh the page to try again'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadJiraFieldsFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadJiraFieldsFailedTitle',
        defaultMessage: 'Error: Loading Jira fields failed'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadJiraFieldsFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadJiraFieldsFailedMsg',
        defaultMessage: 'A server error occurred while trying to load Jira fields on the template form.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadDataConnectionsFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadDataConnectionsFailedTitle',
        defaultMessage: 'Error: Loading data connections failed.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadDataConnectionsFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadDataConnectionsFailedMsg',
        defaultMessage: 'A server error occurred while trying to load data connections on the template form.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadSettingsRefDataFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadSettingsRefDataFailedTitle',
        defaultMessage: 'Error: Loading form settings reference data failed.'
    },
    [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadSettingsRefDataFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadSettingsRefDataFailedMsg',
        defaultMessage: "A server error occurred while trying to load the reference for the template form's settings."
    }
});

});

parcelRegister("7fcWf", function(module, exports) {

$parcel$export(module.exports, "NoticeMessage", () => $5463f86ac7c8d952$export$cd61f3d27ce0e442);
$parcel$export(module.exports, "IntlNoticeMessages", () => $5463f86ac7c8d952$export$5f3ce93e2cd01692);

var $7VHMR = parcelRequire("7VHMR");
let $5463f86ac7c8d952$export$cd61f3d27ce0e442 = /*#__PURE__*/ function(NoticeMessage) {
    NoticeMessage["Delete"] = "Delete";
    NoticeMessage["Discard"] = "Discard";
    NoticeMessage["Change"] = "Change";
    NoticeMessage["Confirm"] = "Confirm";
    NoticeMessage["Submit"] = "Submit";
    NoticeMessage["Reopen"] = "Reopen";
    NoticeMessage["Close"] = "Close";
    NoticeMessage["Cancel"] = "Cancel";
    NoticeMessage["UpgradeNow"] = "UpgradeNow";
    NoticeMessage["MakeInternal"] = "MakeInternal";
    NoticeMessage["MakeExternal"] = "MakeExternal";
    NoticeMessage["DeleteFormTitle"] = "DeleteFormTitle";
    NoticeMessage["DeleteFormMsg"] = "DeleteFormMsg";
    NoticeMessage["ChangeFormAvailabilityTitle"] = "ChangeFormAvailabilityTitle";
    NoticeMessage["ChangeFormToInternalHeader"] = "ChangeFormToInternalHeader";
    NoticeMessage["ChangeFormToInternalMsg"] = "ChangeFormToInternalMsg";
    NoticeMessage["ChangeFormToExternalHeader"] = "ChangeFormToExternalHeader";
    NoticeMessage["ChangeFormToExternalMsg"] = "ChangeFormToExternalMsg";
    NoticeMessage["CancelEditFormTitle"] = "CancelEditFormTitle";
    NoticeMessage["CancelEditFormMsg"] = "CancelEditFormMsg";
    NoticeMessage["SubmitFormTitle"] = "SubmitFormTitle";
    NoticeMessage["SubmitFormMsg"] = "SubmitFormMsg";
    NoticeMessage["SubmitFormLockMsg"] = "SubmitFormLockMsg";
    NoticeMessage["ReopenFormTitle"] = "ReopenFormTitle";
    NoticeMessage["ReopenFormMsg"] = "ReopenFormMsg";
    NoticeMessage["ErrorExplanations1"] = "ErrorExplanations1";
    NoticeMessage["ErrorExplanations2"] = "ErrorExplanations2";
    NoticeMessage["ErrorExplanations3"] = "ErrorExplanations3";
    NoticeMessage["ErrorExplanations4"] = "ErrorExplanations4";
    return NoticeMessage;
}({});
const $5463f86ac7c8d952$export$5f3ce93e2cd01692 = (0, $7VHMR.defineMessages)({
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Delete]: {
        id: 'ui-notices.confirmText.Delete',
        defaultMessage: 'Delete'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Discard]: {
        id: 'ui-notices.confirmText.Discard',
        defaultMessage: 'Discard'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Change]: {
        id: 'ui-notices.confirmText.Change',
        defaultMessage: 'Change'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Confirm]: {
        id: 'ui-notices.confirmText.Confirm',
        defaultMessage: 'Confirm'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Submit]: {
        id: 'ui-notices.confirmText.Submit',
        defaultMessage: 'Submit'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Reopen]: {
        id: 'ui-notices.confirmText.Reopen',
        defaultMessage: 'Reopen'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Close]: {
        id: 'ui-notices.confirmText.Close',
        defaultMessage: 'Close'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Cancel]: {
        id: 'ui-notices.confirmText.Cancel',
        defaultMessage: 'Cancel'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.UpgradeNow]: {
        id: 'ui-notices.confirmText.UpgradeNow',
        defaultMessage: 'Upgrade Now'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.MakeInternal]: {
        id: 'ui-notices.confirmText.MakeInternal',
        defaultMessage: 'Make internal'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.MakeExternal]: {
        id: 'ui-notices.confirmText.MakeExternal',
        defaultMessage: 'Make external'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.DeleteFormTitle]: {
        id: 'ui-notices.title.DeleteFormTitle',
        defaultMessage: 'Confirm Deleting Form'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.DeleteFormMsg]: {
        id: 'ui-notices.msg.DeleteFormMsg',
        defaultMessage: "Are you sure you want to delete the \u201C{formName}\u201D form? This cannot be undone."
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormAvailabilityTitle]: {
        id: 'ui-notices.title.ChangeFormAvailabilityTitle',
        defaultMessage: 'Confirm Changing Form Availability'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToInternalHeader]: {
        id: 'ui-notices.title.ChangeFormInternalHeader',
        defaultMessage: 'Make form internal only and hide from customer'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToInternalMsg]: {
        id: 'ui-notices.msg.ChangeFormInternalMsg',
        defaultMessage: 'Any forms made internal will only be seen by agents and hidden in the portal from customers.'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToExternalHeader]: {
        id: 'ui-notices.title.ChangeFormToExternalHeader',
        defaultMessage: 'Make form external and show to customer'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToExternalMsg]: {
        id: 'ui-notices.msg.ChangeFormToExternalMsg',
        defaultMessage: 'Customers will be able to view this form in the portal and it will no longer be internal only.'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.CancelEditFormTitle]: {
        id: 'ui-notices.title.CancelEditFormTitle',
        defaultMessage: 'Confirm Discarding Changes'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.CancelEditFormMsg]: {
        id: 'ui-notices.msg.CancelEditFormMsg',
        defaultMessage: 'There are changes to answers on the \u201C{formName}\u201D form that will be lost if you choose "Confirm". Are you sure you want to continue?'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormTitle]: {
        id: 'ui-notices.title.SubmitFormTitle',
        defaultMessage: 'Confirm Form Submission'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormMsg]: {
        id: 'ui-notices.msg.SubmitFormMsg',
        defaultMessage: 'Are you sure you want to submit this form ?'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormLockMsg]: {
        id: 'ui-notices.msg.SubmitFormLockMsg',
        defaultMessage: 'Are you sure you want to submit this form ? Once submitted no further changes can be made.'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ReopenFormTitle]: {
        id: 'ui-notices.title.ReopenFormTitle',
        defaultMessage: 'Confirm Reopening Form'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ReopenFormMsg]: {
        id: 'ui-notices.msg.ReopenFormMsg',
        defaultMessage: 'Are you sure you want to reopen the submitted form for editing?'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations1]: {
        id: 'ui-notices.msg.ErrorExplanations1',
        defaultMessage: 'Please refer to our'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations2]: {
        id: 'ui-notices.msg.ErrorExplanations2',
        defaultMessage: 'Error Explanations'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations3]: {
        id: 'ui-notices.msg.ErrorExplanations3',
        defaultMessage: 'page for more details or contact'
    },
    [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations4]: {
        id: 'ui-notices.msg.ErrorExplanations4',
        defaultMessage: 'ThinkTilt Support'
    }
});

});


parcelRegister("caW8j", function(module, exports) {

$parcel$export(module.exports, "constructApiError", () => $8dd38339de80c582$export$4fb8f0e1418096d0);
$parcel$export(module.exports, "isUnknownApiError", () => $8dd38339de80c582$export$a072859f46abbb91);
$parcel$export(module.exports, "getFormSaveErrors", () => $8dd38339de80c582$export$ed98b2247c52f4f6);
$parcel$export(module.exports, "getJiraErrorCollectionResponse", () => $8dd38339de80c582$export$e6390e344b33daed);

var $3KrJl = parcelRequire("3KrJl");

var $8w794 = parcelRequire("8w794");
function $8dd38339de80c582$export$4fb8f0e1418096d0(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId) {
    switch(error){
        case (0, $3KrJl.ApiErrorType).client:
            return {
                error: (0, $3KrJl.ApiErrorType).client,
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $3KrJl.ApiErrorType).clientWithDetails:
            return {
                error: (0, $3KrJl.ApiErrorType).clientWithDetails,
                context: (0, $8w794.ErrorContextOf)(context),
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $3KrJl.ApiErrorType).json:
            return {
                error: (0, $3KrJl.ApiErrorType).json,
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $3KrJl.ApiErrorType).jwt:
            return {
                error: (0, $3KrJl.ApiErrorType).jwt,
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        default:
            return {
                error: (0, $3KrJl.ApiErrorType).unknown,
                message: error,
                status: status,
                responseJson: responseJson,
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                requestName: requestName
            };
    }
}
const $8dd38339de80c582$export$a072859f46abbb91 = (apiError)=>apiError.error === (0, $3KrJl.ApiErrorType).unknown;
const $8dd38339de80c582$export$ed98b2247c52f4f6 = (apiError)=>{
    if ($8dd38339de80c582$export$a072859f46abbb91(apiError) && apiError.status === 400) return {
        generalErrors: [],
        errorsByQuestionId: {},
        ...apiError.responseJson
    };
    return undefined;
};
const $8dd38339de80c582$export$e6390e344b33daed = (apiError)=>{
    if ($8dd38339de80c582$export$a072859f46abbb91(apiError) && apiError.status >= 400 && apiError.status < 500) return {
        errorMessages: [],
        errors: {},
        ...apiError.responseJson
    };
    return undefined;
};

});
parcelRegister("3KrJl", function(module, exports) {

$parcel$export(module.exports, "ApiErrorType", () => $2bab2d9fb6f6d466$export$eb26b24d7b7bab09);
let $2bab2d9fb6f6d466$export$eb26b24d7b7bab09 = /*#__PURE__*/ function(ApiErrorType) {
    ApiErrorType["client"] = "client";
    ApiErrorType["clientWithDetails"] = "clientWithDetails";
    ApiErrorType["json"] = "json";
    ApiErrorType["jwt"] = "jwt";
    ApiErrorType["unknown"] = "unknown";
    ApiErrorType["timeout"] = "timeout";
    return ApiErrorType;
}({});

});

parcelRegister("8w794", function(module, exports) {

$parcel$export(module.exports, "ErrorContextOf", () => $6336dacbdad88890$export$2c172aed648e926c);
let $6336dacbdad88890$export$21818dff4f4f7174 = /*#__PURE__*/ function(ErrorContext) {
    ErrorContext["I18nAccessPathKey"] = "err.access.path";
    ErrorContext["I18nEntityConnectionKey"] = "err.entity.connection";
    ErrorContext["I18nEntityFormKey"] = "err.entity.form";
    ErrorContext["I18nEntityIssueKey"] = "err.entity.issue";
    ErrorContext["I18nEntityIssueCreateKey"] = "err.entity.issue.create";
    ErrorContext["I18nEntityPreferredFormKey"] = "err.entity.preferredform";
    ErrorContext["I18nEntityProjectKey"] = "err.entity.project";
    ErrorContext["I18nEntityRequestTypeKey"] = "err.entity.requesttype";
    ErrorContext["I18nEntityServiceDeskKey"] = "err.entity.servicedesk";
    ErrorContext["I18nJwtParseKey"] = "err.jwt.parse";
    ErrorContext["I18nJwtSignatureKey"] = "err.jwt.signed";
    ErrorContext["I18nJwtVerifyKey"] = "err.jwt.verify";
    ErrorContext["I18nInternalServerError"] = "err.server.internal";
    ErrorContext["I18nUnknownContextError"] = "err.context.unknown";
    return ErrorContext;
}({});
function $6336dacbdad88890$export$2c172aed648e926c(context) {
    switch(context){
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nAccessPathKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nAccessPathKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityConnectionKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityConnectionKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityFormKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityFormKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueCreateKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueCreateKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityPreferredFormKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityPreferredFormKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityProjectKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityProjectKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityRequestTypeKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityRequestTypeKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityServiceDeskKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityServiceDeskKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtParseKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtParseKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtSignatureKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtSignatureKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtVerifyKey:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtVerifyKey;
        case $6336dacbdad88890$export$21818dff4f4f7174.I18nInternalServerError:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nInternalServerError;
        default:
            return $6336dacbdad88890$export$21818dff4f4f7174.I18nUnknownContextError;
    }
}

});



parcelRegister("j93Fo", function(module, exports) {

$parcel$export(module.exports, "setNoticeLocale", () => $df01b3b500941fc5$export$caf904df61b5b10d);
$parcel$export(module.exports, "showNotice", () => $df01b3b500941fc5$export$b25305d7fdb340d7);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $24oqM = parcelRequire("24oqM");
let $df01b3b500941fc5$var$locale = 'en-US';
function $df01b3b500941fc5$export$caf904df61b5b10d(newLocale) {
    $df01b3b500941fc5$var$locale = newLocale;
}
function $df01b3b500941fc5$export$b25305d7fdb340d7(noticeType, intlValues, errorDetails) {
    return new Promise((resolve)=>{
        const dialogTargetNode = document.getElementById('pf-dialog-container');
        if (!dialogTargetNode) {
            // eslint-disable-next-line no-console
            console.error(`Could not show notice ${noticeType}. The target Node for the dialog is not available`);
            resolve(false);
        }
        const handleClose = (confirmed)=>{
            resolve(!!confirmed);
            $df01b3b500941fc5$var$closeNotice();
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $24oqM.Notice), {
            noticeType: noticeType,
            handleClose: handleClose,
            settings: {
                intlValues: intlValues,
                errorDetails: errorDetails,
                customLocale: $df01b3b500941fc5$var$locale
            }
        }), dialogTargetNode);
    });
}
function $df01b3b500941fc5$var$closeNotice() {
    const dialogTargetNode = document.getElementById('pf-dialog-container');
    if (!dialogTargetNode) {
        // eslint-disable-next-line no-console
        console.error(`Could not close notice. The target Node for the dialog is not available`);
        return false;
    }
    const closed = (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unmountComponentAtNode(dialogTargetNode);
    if (!closed) // eslint-disable-next-line no-console
    console.error(`Could not close notice. There is no dialog to unmount`);
    return closed;
}

});
parcelRegister("24oqM", function(module, exports) {

$parcel$export(module.exports, "Notice", () => $181ee7fa9c781879$export$71802e30fd294f61);

var $5uXOq = parcelRequire("5uXOq");

var $dlLGv = parcelRequire("dlLGv");

var $fiX4W = parcelRequire("fiX4W");

var $8v3RR = parcelRequire("8v3RR");

var $bRqoO = parcelRequire("bRqoO");
const $181ee7fa9c781879$export$71802e30fd294f61 = ({ noticeType: noticeType, handleClose: handleClose, settings: { customLocale: customLocale = (0, $fiX4W.DEFAULT_LOCALE), intlValues: intlValues, errorDetails: errorDetails, overrideZIndex: overrideZIndex } })=>{
    const notice = (0, $bRqoO.Notices)[noticeType];
    if (!notice) {
        // eslint-disable-next-line no-console
        console.error(`Could not show notice, notice type ${noticeType} does not exist`);
        handleClose();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlLGv.PackageIntlProvider), {
        locale: customLocale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8v3RR.NoticeDialog), {
        title: notice.title,
        titleVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.titleVars,
        message: notice.message,
        messageVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.msgVars,
        confirmText: notice.confirmText,
        confirmLink: notice.confirmLink,
        handleClose: handleClose,
        isErrorNotice: notice.isErrorNotice,
        errorDetails: errorDetails,
        isWarningNotice: notice.isWarningNotice,
        overrideZIndex: overrideZIndex
    }));
};

});
parcelRegister("dlLGv", function(module, exports) {

$parcel$export(module.exports, "PackageIntlProvider", () => $9b8239ac40bcdc9c$export$dfce9acc1b75df7a);
$parcel$export(module.exports, "withPackageIntlProvider", () => $9b8239ac40bcdc9c$export$38662a78c6a3a7ce);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $i9OHB = parcelRequire("i9OHB");

var $ioVpW = parcelRequire("ioVpW");
const $9b8239ac40bcdc9c$export$dfce9acc1b75df7a = ({ children: children, locale: locale })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9OHB.ProformaIntlProvider), {
        locale: locale,
        messages: (0, $ioVpW.default)
    }, children);
const $9b8239ac40bcdc9c$export$38662a78c6a3a7ce = (WrappedComponent)=>(props)=>{
        const intl = (0, $koVbs.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b8239ac40bcdc9c$export$dfce9acc1b75df7a, {
            locale: intl.locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
    };

});
parcelRegister("i9OHB", function(module, exports) {

$parcel$export(module.exports, "ProformaIntlProvider", () => $d38065afc4acf5f2$export$f345b4b8e42e419e);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $k9nuy = parcelRequire("k9nuy");

var $iyjlq = parcelRequire("iyjlq");
const $d38065afc4acf5f2$export$f345b4b8e42e419e = ({ children: children, locale: locale, messages: messages })=>{
    var _getCodesFromLocale;
    const { language: language, country: country } = (_getCodesFromLocale = (0, $iyjlq.getCodesFromLocale)(locale)) !== null && _getCodesFromLocale !== void 0 ? _getCodesFromLocale : {};
    const lazyMessages = (0, $iyjlq.useLazyMessages)(messages, language !== null && language !== void 0 ? language : (0, $iyjlq.DEFAULT_LOCALE), country);
    if (lazyMessages === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        messages: lazyMessages,
        locale: country && `${language}-${country}` || language || locale.replace('_', '-'),
        defaultLocale: (0, $iyjlq.DEFAULT_LOCALE),
        defaultRichTextElements: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
                    weight: "bold"
                }, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
                    as: "strong"
                }, chunks)
        }
    }, children);
};

});
parcelRegister("iyjlq", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $d81a686b660c1f7e$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "getCodesFromLocale", () => $d81a686b660c1f7e$export$4d25b49b6dc1b540);
$parcel$export(module.exports, "useLazyMessages", () => $d81a686b660c1f7e$export$7ddce3b5511cfaa8);

var $5uXOq = parcelRequire("5uXOq");
const $d81a686b660c1f7e$export$1af4c7e47ad72f44 = 'en';
const $d81a686b660c1f7e$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
const $d81a686b660c1f7e$export$4d25b49b6dc1b540 = (locale)=>{
    const match = $d81a686b660c1f7e$var$localeRegex.exec(locale);
    if (match) {
        const [, language, country] = match;
        return {
            language: language.toLowerCase(),
            country: country === null || country === void 0 ? void 0 : country.toUpperCase()
        };
    }
    // TODO: Use error service to log:
    // eslint-disable-next-line no-console
    console.error('Unable to determine language and country from invalid locale.');
    return undefined;
};
const $d81a686b660c1f7e$var$loadLazyMessages = async (lazyMessages, language, country)=>{
    var _await$default, _await, _ref;
    return (_await$default = (_await = await ((_ref = country && lazyMessages[`${language}_${country}`] || lazyMessages[language] || lazyMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) !== null && _await$default !== void 0 ? _await$default : {};
};
const $d81a686b660c1f7e$export$7ddce3b5511cfaa8 = (lazyMessages, language, country)=>{
    const [messages, setMessages] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        $d81a686b660c1f7e$var$loadLazyMessages(lazyMessages, language, country).catch(()=>({})).then(setMessages);
    }, [
        country,
        language,
        lazyMessages,
        setMessages
    ]);
    return messages;
};

});


parcelRegister("ioVpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d65701c9e2552e18$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index in @atlassian/proforma-utils.
 */ 
























const $d65701c9e2552e18$var$lazyMessages = {
    cs: ()=>(parcelRequire("hpylm")),
    da: ()=>(parcelRequire("bxes0")),
    de: ()=>(parcelRequire("62Ikn")),
    en: ()=>(parcelRequire("b940G")),
    en_GB: ()=>(parcelRequire("3MfRg")),
    en_ZZ: ()=>(parcelRequire("8GHTS")),
    es: ()=>(parcelRequire("iDINQ")),
    fi: ()=>(parcelRequire("avWuc")),
    fr: ()=>(parcelRequire("7mRR8")),
    hu: ()=>(parcelRequire("hhRcH")),
    it: ()=>(parcelRequire("6zd31")),
    ja: ()=>(parcelRequire("dWqMX")),
    ko: ()=>(parcelRequire("AYLPF")),
    nb: ()=>(parcelRequire("kuyLU")),
    nl: ()=>(parcelRequire("aJNtk")),
    pl: ()=>(parcelRequire("6NSn1")),
    pt_BR: ()=>(parcelRequire("9nKnc")),
    ru: ()=>(parcelRequire("a1Urr")),
    sv: ()=>(parcelRequire("3KPzJ")),
    th: ()=>(parcelRequire("bxanm")),
    tr: ()=>(parcelRequire("e7v7R")),
    uk: ()=>(parcelRequire("SCees")),
    vi: ()=>(parcelRequire("e68UC")),
    zh: ()=>(parcelRequire("1diT2")),
    zh_TW: ()=>(parcelRequire("eCwMW"))
};
var $d65701c9e2552e18$export$2e2bcd8739ae039 = $d65701c9e2552e18$var$lazyMessages;

});
parcelRegister("hpylm", function(module, exports) {

let $cacf695d6609942d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cacf695d6609942d$var$load("bOMSG").then(()=>parcelRequire('bSYnh'));

});

parcelRegister("bxes0", function(module, exports) {

let $865dfc5d95b6d240$var$load = (parcelRequire("28QjX"))(4);
module.exports = $865dfc5d95b6d240$var$load("99s0m").then(()=>parcelRequire('fr8Uf'));

});

parcelRegister("62Ikn", function(module, exports) {

let $46655085ceabc6c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $46655085ceabc6c5$var$load("41WhO").then(()=>parcelRequire('6EC1L'));

});

parcelRegister("b940G", function(module, exports) {

let $81d3a54780c1512c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81d3a54780c1512c$var$load("iZTjR").then(()=>parcelRequire('iSOzX'));

});

parcelRegister("3MfRg", function(module, exports) {

let $2c0227debdd6f9d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2c0227debdd6f9d9$var$load("dzFRq").then(()=>parcelRequire('eBxLi'));

});

parcelRegister("8GHTS", function(module, exports) {

let $65344ca64273a036$var$load = (parcelRequire("28QjX"))(4);
module.exports = $65344ca64273a036$var$load("DijSr").then(()=>parcelRequire('8e7FB'));

});

parcelRegister("iDINQ", function(module, exports) {

let $d91e9f78456f87ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d91e9f78456f87ec$var$load("abWEg").then(()=>parcelRequire('bSBGI'));

});

parcelRegister("avWuc", function(module, exports) {

let $7a7a2ac1dfd6d20e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7a7a2ac1dfd6d20e$var$load("6OcKU").then(()=>parcelRequire('jStmS'));

});

parcelRegister("7mRR8", function(module, exports) {

let $55d45d2a793960aa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $55d45d2a793960aa$var$load("ffJfg").then(()=>parcelRequire('lVomF'));

});

parcelRegister("hhRcH", function(module, exports) {

let $c95d4b5c58f8de0c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c95d4b5c58f8de0c$var$load("3qpTf").then(()=>parcelRequire('gV19l'));

});

parcelRegister("6zd31", function(module, exports) {

let $4c8021fc781a1dce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c8021fc781a1dce$var$load("eK7PP").then(()=>parcelRequire('iRfhX'));

});

parcelRegister("dWqMX", function(module, exports) {

let $a26578cc82e9244d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a26578cc82e9244d$var$load("lt3Cs").then(()=>parcelRequire('kEMuB'));

});

parcelRegister("AYLPF", function(module, exports) {

let $06f280a925b1a0c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $06f280a925b1a0c0$var$load("dHRzd").then(()=>parcelRequire('lJY2E'));

});

parcelRegister("kuyLU", function(module, exports) {

let $eeb194e95369a68f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eeb194e95369a68f$var$load("hwtzD").then(()=>parcelRequire('icvbb'));

});

parcelRegister("aJNtk", function(module, exports) {

let $7d147b7cef45b1ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7d147b7cef45b1ad$var$load("7KTDh").then(()=>parcelRequire('btUKW'));

});

parcelRegister("6NSn1", function(module, exports) {

let $4f417e81a6d8cf92$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f417e81a6d8cf92$var$load("ly7Tk").then(()=>parcelRequire('UaJXH'));

});

parcelRegister("9nKnc", function(module, exports) {

let $6d4a3bc61a0abadb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d4a3bc61a0abadb$var$load("5nTxr").then(()=>parcelRequire('dqi2n'));

});

parcelRegister("a1Urr", function(module, exports) {

let $74d5c7870b6e24d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $74d5c7870b6e24d0$var$load("cuJeo").then(()=>parcelRequire('deEZs'));

});

parcelRegister("3KPzJ", function(module, exports) {

let $2bbdacbfddda11a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2bbdacbfddda11a1$var$load("7khh5").then(()=>parcelRequire('gtyia'));

});

parcelRegister("bxanm", function(module, exports) {

let $865ad335ab3b7d27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $865ad335ab3b7d27$var$load("35Enp").then(()=>parcelRequire('cRlYl'));

});

parcelRegister("e7v7R", function(module, exports) {

let $a479dd13cfb78f86$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a479dd13cfb78f86$var$load("2yjYv").then(()=>parcelRequire('c7xZi'));

});

parcelRegister("SCees", function(module, exports) {

let $0a42b2a787c0725f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a42b2a787c0725f$var$load("3l58i").then(()=>parcelRequire('4rorX'));

});

parcelRegister("e68UC", function(module, exports) {

let $a43889fd69003bb6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a43889fd69003bb6$var$load("4mWuc").then(()=>parcelRequire('1vLaj'));

});

parcelRegister("1diT2", function(module, exports) {

let $0e25a7d85e0988e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0e25a7d85e0988e0$var$load("lG0k3").then(()=>parcelRequire('auLUs'));

});

parcelRegister("eCwMW", function(module, exports) {

let $aa4e0c675e7f1870$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aa4e0c675e7f1870$var$load("jvhrA").then(()=>parcelRequire('3SBDK'));

});



parcelRegister("fiX4W", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $b2465d41ca8b525b$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "ProFormaIntlProvider", () => $b2465d41ca8b525b$export$23e25b3437f9c000);
$parcel$export(module.exports, "withProFormaIntlProvider", () => $b2465d41ca8b525b$export$a98a2d834cadecf0);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $k9nuy = parcelRequire("k9nuy");

var $ioVpW = parcelRequire("ioVpW");

var $hPkt9 = parcelRequire("hPkt9");
const $b2465d41ca8b525b$export$1af4c7e47ad72f44 = 'en-US';
const $b2465d41ca8b525b$export$23e25b3437f9c000 = ({ children: children, i18nMessages: i18nMessages, locale: locale })=>{
    var _ref, _ref2;
    // `commonCoreI18nMessages` is a temporary variable required only while we need to maintain
    // access to the 'proforma-common-core' translations for other packages. Once the translations
    // are properly per package, this can be removed.
    const commonCoreI18nMessages = (0, $hPkt9.useLazyI18nMessages)(locale, (0, $ioVpW.default));
    if (!commonCoreI18nMessages) return null;
    const { language: language, country: country } = (0, $hPkt9.getCodesFromLocale)(locale);
    const messages = (_ref = (_ref2 = country && i18nMessages[`${language}_${country}`]) !== null && _ref2 !== void 0 ? _ref2 : i18nMessages[language]) !== null && _ref !== void 0 ? _ref : i18nMessages.en;
    // `aggregateMessages` is a temporary variable required only while we need to maintain
    // access to the 'proforma-common-core' translations for other packages. Once the translations
    // are properly per package, this can be removed.
    const aggregateMessages = {
        ...commonCoreI18nMessages,
        ...messages
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        messages: aggregateMessages,
        locale: country ? `${language}-${country}` : language,
        defaultLocale: $b2465d41ca8b525b$export$1af4c7e47ad72f44,
        defaultRichTextElements: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
                    weight: "bold"
                }, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
                    as: "strong"
                }, chunks)
        }
    }, children);
};
const $b2465d41ca8b525b$export$a98a2d834cadecf0 = (i18nMessages, WrappedComponent)=>(props)=>{
        const intl = (0, $koVbs.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b2465d41ca8b525b$export$23e25b3437f9c000, {
            i18nMessages: i18nMessages,
            locale: intl.locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
    };

});
parcelRegister("hPkt9", function(module, exports) {

$parcel$export(module.exports, "getCodesFromLocale", () => $cfa713d6b7186a1c$export$4d25b49b6dc1b540);
$parcel$export(module.exports, "useLazyI18nMessages", () => $cfa713d6b7186a1c$export$30a7082641f381ea);

var $5uXOq = parcelRequire("5uXOq");

var $fiX4W = parcelRequire("fiX4W");
const $cfa713d6b7186a1c$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
const $cfa713d6b7186a1c$export$4d25b49b6dc1b540 = (locale)=>{
    let match = $cfa713d6b7186a1c$var$localeRegex.exec(locale);
    if (!match) {
        // eslint-disable-next-line no-console
        console.error('Unable to get language and country from invalid locale, falling back to default locale.');
        match = $cfa713d6b7186a1c$var$localeRegex.exec((0, $fiX4W.DEFAULT_LOCALE));
    }
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        country: country === null || country === void 0 ? void 0 : country.toUpperCase()
    };
};
const $cfa713d6b7186a1c$var$loadLazyI18nMessages = async (locale, lazyI18nMessages)=>{
    var _await$default, _await, _ref;
    const { language: language, country: country } = $cfa713d6b7186a1c$export$4d25b49b6dc1b540(locale);
    return (_await$default = (_await = await ((_ref = country && lazyI18nMessages[`${language}_${country}`] || lazyI18nMessages[language] || lazyI18nMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) !== null && _await$default !== void 0 ? _await$default : {};
};
const $cfa713d6b7186a1c$export$30a7082641f381ea = (locale, lazyI18nMessages)=>{
    const [messages, setMessages] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        $cfa713d6b7186a1c$var$loadLazyI18nMessages(locale, lazyI18nMessages).catch(()=>({})).then(setMessages);
    }, [
        locale,
        setMessages,
        lazyI18nMessages
    ]);
    return messages;
};

});


parcelRegister("8v3RR", function(module, exports) {

$parcel$export(module.exports, "NoticeDialog", () => $63043807ff653784$export$7ccde09c2c5f5940);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cNW3X = parcelRequire("cNW3X");

var $hordk = parcelRequire("hordk");
var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");

var $k9nuy = parcelRequire("k9nuy");

var $abT4b = parcelRequire("abT4b");

var $fsAfP = parcelRequire("fsAfP");

var $7fcWf = parcelRequire("7fcWf");
const $63043807ff653784$export$7ccde09c2c5f5940 = ({ title: title, titleVars: titleVars, message: message, messageVars: messageVars, confirmText: confirmText, confirmLink: confirmLink, handleClose: handleClose, isErrorNotice: isErrorNotice, errorDetails: errorDetails, isWarningNotice: isWarningNotice, overrideZIndex: overrideZIndex })=>{
    const appearance = isErrorNotice ? 'danger' : isWarningNotice ? 'warning' : undefined;
    const actions = [];
    if (isErrorNotice) ;
    else if (confirmLink) actions.push({
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Close]),
        onClick: ()=>handleClose(false),
        appearance: 'subtle'
    });
    else actions.push({
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).Cancel]),
        onClick: ()=>handleClose(false),
        appearance: 'subtle'
    });
    const primaryButtonAppearance = appearance || 'primary';
    if (confirmLink) actions.push({
        // @ts-ignore
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), confirmText),
        href: confirmLink,
        target: '_blank',
        rel: 'noopener noreferrer',
        appearance: primaryButtonAppearance
    });
    else actions.push({
        // @ts-ignore
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), confirmText),
        onClick: ()=>handleClose(true),
        appearance: primaryButtonAppearance
    });
    let onOpenCompleteF;
    if (overrideZIndex) onOpenCompleteF = (node, isAppearing)=>{
        overrideZIndex && node.parentElement ? node.parentElement.style.zIndex = '5000' : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hordk.default), {
        onOpenComplete: onOpenCompleteF,
        onClose: ()=>handleClose(),
        shouldCloseOnOverlayClick: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), {
        appearance: appearance
    }, /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, title, {
        values: titleVars
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, message, {
        values: messageVars
    }))), isErrorNotice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ErrorExplanations1]), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abT4b.PfLink), {
        href: "http://links.thinktilt.net/error-explanations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ErrorExplanations2])), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ErrorExplanations3]), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abT4b.PfLink), {
        href: "https://support.thinktilt.com/"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7fcWf.IntlNoticeMessages)[(0, $7fcWf.NoticeMessage).ErrorExplanations4])), "."), !!errorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fsAfP.ErrorSection), {
        errorDetails: errorDetails
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, actions.map(({ text: text, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), props, text))));
};

});
parcelRegister("abT4b", function(module, exports) {

$parcel$export(module.exports, "PfLink", () => $76b5a57dfb2cdc0a$export$9522c077a5f2be27);

var $5uXOq = parcelRequire("5uXOq");
const $76b5a57dfb2cdc0a$export$9522c077a5f2be27 = ({ href: href, onClick: onClick, id: id, popup: popup = true, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: href,
        id: id,
        rel: popup ? 'noreferrer noopener' : undefined,
        target: popup ? '_blank' : undefined,
        onClick: onClick
    }, children);
};

});

parcelRegister("fsAfP", function(module, exports) {

$parcel$export(module.exports, "ErrorSection", () => $b41597dfedacbba9$export$b0bceea2ea86179a);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $k9nuy = parcelRequire("k9nuy");


var $fHMtf = parcelRequire("fHMtf");
const $b41597dfedacbba9$export$b0bceea2ea86179a = ({ errorDetails: errorDetails })=>{
    const [showErrorDetails, setShowErrorDetails] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b41597dfedacbba9$var$ErrorSectionLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
        as: "p"
    }, "Show error details:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHMtf.default), {
        isChecked: showErrorDetails,
        onChange: ()=>{
            setShowErrorDetails(!showErrorDetails);
        }
    })), showErrorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b41597dfedacbba9$var$ErrorDetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("code", null, errorDetails)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b41597dfedacbba9$var$ErrorSectionLabel = (0, $dAHxw.default).div({
    display: 'flex',
    marginTop: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> p': {
        marginTop: "var(--ds-space-025, 2px)"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b41597dfedacbba9$var$ErrorDetailsWrapper = (0, $dAHxw.default).div({
    backgroundColor: `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`,
    padding: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';





parcelRegister("gFGsm", function(module, exports) {

$parcel$export(module.exports, "LiveErrorUtils", () => $c23168a474488ad4$export$f2a509cffb92cb9c);
/* eslint-disable no-console */ 
var $5uXOq = parcelRequire("5uXOq");

var $8kBWK = parcelRequire("8kBWK");
var $3kk8J = parcelRequire("3kk8J");
var $kIiWO = parcelRequire("kIiWO");

var $ousew = parcelRequire("ousew");

var $5E93O = parcelRequire("5E93O");


var $aNTEp = parcelRequire("aNTEp");

var $b4PzF = parcelRequire("b4PzF");

var $9e9ba = parcelRequire("9e9ba");

var $erWXD = parcelRequire("erWXD");

var $bRqoO = parcelRequire("bRqoO");

var $fxMku = parcelRequire("fxMku");
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $c23168a474488ad4$var$TAGS = [
    'module',
    'actionSubject',
    'url'
];
// From https://sentry.io/settings/atlassian-2y/projects/proforma/keys/
const $c23168a474488ad4$var$SENTRY_PUBLIC_KEY = 'c6ac6cc7ef554e3286ec09d412c9c1f4';
const $c23168a474488ad4$var$SENTRY_PROJECT_ID = '6388218';
const $c23168a474488ad4$var$SENTRY_COMMERCIAL_DSN = `https://${$c23168a474488ad4$var$SENTRY_PUBLIC_KEY}@o55978.ingest.sentry.io/${$c23168a474488ad4$var$SENTRY_PROJECT_ID}`;
const $c23168a474488ad4$var$SENTRY_FEDRAMP_DSN = `https://${$c23168a474488ad4$var$SENTRY_PUBLIC_KEY}@sentry.atlassian-us-gov-mod.com/${$c23168a474488ad4$var$SENTRY_PROJECT_ID}`;
const $c23168a474488ad4$var$PROFORMA_SENTRY_PROJECT_DSN = (0, $b4PzF.isFedRamp)() ? $c23168a474488ad4$var$SENTRY_FEDRAMP_DSN : $c23168a474488ad4$var$SENTRY_COMMERCIAL_DSN;
class $c23168a474488ad4$export$f2a509cffb92cb9c {
    constructor(moduleName, showFlag, createAnalyticsEvent, environment){
        this.moduleName = void 0;
        this.showFlag = void 0;
        this.createAnalyticsEvent = void 0;
        this.sentryHub = void 0;
        this.environment = void 0;
        this.moduleName = moduleName;
        this.showFlag = showFlag;
        this.createAnalyticsEvent = createAnalyticsEvent;
        this.environment = environment;
        this.sentryHub = this.getSentryHub(environment);
    }
    reportError(error, options) {
        var _options$actionSubjec;
        const errorPrefix = `Proforma(${this.moduleName}): `;
        const severity = options !== null && options !== void 0 && options.severity ? options.severity : (0, $kIiWO.Severity).Error;
        // 1) Log error in console
        switch(severity){
            case (0, $kIiWO.Severity).Warning:
                console.warn(errorPrefix, error);
                break;
            case (0, $kIiWO.Severity).Info:
                console.info(errorPrefix, error);
                break;
            default:
                console.error(errorPrefix, error);
                break;
        }
        const actionSubject = (_options$actionSubjec = options === null || options === void 0 ? void 0 : options.actionSubject) !== null && _options$actionSubjec !== void 0 ? _options$actionSubjec : (0, $erWXD.ActionSubject).PROFORMA_UI;
        const attributes = (options === null || options === void 0 ? void 0 : options.attributes) && Object.fromEntries(Object.entries(options.attributes).map(([key, value])=>[
                key,
                typeof value === 'string' ? (0, $9e9ba.maskEmailIds)(value) : value
            ]));
        // Todo: add user agent, package version, url,
        const details = {
            actionSubject: actionSubject,
            errorId: options === null || options === void 0 ? void 0 : options.id,
            severity: severity,
            module: this.moduleName,
            errorMsg: error.message,
            errorInfo: options === null || options === void 0 ? void 0 : options.errorInfo,
            isClientFetchError: error.isClientFetchError,
            requestName: error.requestName,
            traceId: error.traceId,
            status: error.status,
            userAgent: this.getBrowserUserAgent(),
            url: this.getUrl(),
            ...attributes
        };
        // 2) Send error to Atlassian analytics pipeline (GasV3)
        (0, $aNTEp.fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, $erWXD.Action).FAILED}`, details);
        // 3) Send error to Sentry
        if (this.environment === (0, $fxMku.Environment).LOCAL || this.sentryHub === undefined) return;
        const sentryHub = this.sentryHub;
        sentryHub.withScope((scope)=>{
            scope.setLevel(severity);
            Object.keys(details).forEach((key)=>{
                const value = details[key];
                if (value) {
                    if ($c23168a474488ad4$var$TAGS.includes(key)) scope.setTag(key, value.toString());
                    else scope.setExtra(key, value);
                }
            });
            sentryHub.captureException(error);
        });
    }
    /**
   * @private
   * @deprecated notifyUser has been deprecated. Please use the `useFlags()` hook directly instead.
   */ notifyUser(errorNotice, customDescription) {
        const notice = (0, $bRqoO.Notices)[errorNotice];
        if (notice) {
            this.showFlag({
                appearance: 'error',
                isAutoDismiss: true,
                //TO DO - https://product-fabric.atlassian.net/browse/DSP-21423
                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                    label: "",
                    LEGACY_secondaryColor: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$2010d0fb4295b346)})`,
                    color: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), notice.title),
                description: customDescription ? customDescription : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), notice.message)
            });
            return Promise.resolve();
        } else {
            console.error(`Could not show error, notice type ${errorNotice} does not exist`);
            return Promise.reject();
        }
    }
    getSentryHub(environment) {
        try {
            const client = new (0, $8kBWK.BrowserClient)({
                environment: environment,
                dsn: $c23168a474488ad4$var$PROFORMA_SENTRY_PROJECT_DSN
            });
            return new (0, $3kk8J.Hub)(client);
        } catch (error) {
            const actionSubject = 'getProformaSentryHub';
            const details = {
                actionSubject: actionSubject,
                severity: (0, $kIiWO.Severity).Error,
                module: this.moduleName,
                errorMsg: error.message,
                userAgent: this.getBrowserUserAgent(),
                url: this.getUrl()
            };
            (0, $aNTEp.fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, $erWXD.Action).FAILED}`, details);
        }
    }
    getBrowserUserAgent() {
        var _window$navigator$use, _window, _window$navigator;
        return (_window$navigator$use = (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) !== null && _window$navigator$use !== void 0 ? _window$navigator$use : 'unknown';
    }
    getUrl() {
        var _window$document$loca, _window2, _window2$document, _window2$document$loc;
        return (_window$document$loca = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$document = _window2.document) === null || _window2$document === void 0 ? void 0 : (_window2$document$loc = _window2$document.location) === null || _window2$document$loc === void 0 ? void 0 : _window2$document$loc.host) !== null && _window$document$loca !== void 0 ? _window$document$loca : 'unknown';
    }
}

});
parcelRegister("8kBWK", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", () => $610da062c0153a87$export$1df9218a526d318d);

var $3VFsf = parcelRequire("3VFsf");

var $6Gox7 = parcelRequire("6Gox7");
var $1U0bt = parcelRequire("1U0bt");
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");

var $e5AkH = parcelRequire("e5AkH");

var $7HgA0 = parcelRequire("7HgA0");

var $dFFWm = parcelRequire("dFFWm");

var $gSRAG = parcelRequire("gSRAG");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $610da062c0153a87$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $1U0bt.SDK_VERSION)
                }
            ],
            version: (0, $1U0bt.SDK_VERSION)
        };
        _this = _super.call(this, (0, $e5AkH.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $lrKz8.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $7HgA0.IS_DEBUG_BUILD) && (0, $lrKz8.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $dFFWm.injectReportDialog)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $gSRAG.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $6Gox7.BaseClient));

});
parcelRegister("6Gox7", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $4dd9b21d74c34b51$export$4f22f74eddb7716a);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");

var $1YZ0Z = parcelRequire("1YZ0Z");

var $uXILP = parcelRequire("uXILP");
var $4dd9b21d74c34b51$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $4dd9b21d74c34b51$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $lrKz8.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $lrKz8.checkOrSetAlreadyCaught)(exception)) {
            (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).log($4dd9b21d74c34b51$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $lrKz8.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $lrKz8.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).log($4dd9b21d74c34b51$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $uXILP.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $3VFsf.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $lrKz8.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $lrKz8.uuid4)()),
            timestamp: event.timestamp || (0, $lrKz8.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $gfYRq.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $lrKz8.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $lrKz8.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, b), b.data && {
                    data: (0, $lrKz8.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $lrKz8.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $lrKz8.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $lrKz8.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $lrKz8.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $lrKz8.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $lrKz8.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $3VFsf.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $lrKz8.rejectedSyncPromise)(new (0, $lrKz8.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $lrKz8.rejectedSyncPromise)(new (0, $lrKz8.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $lrKz8.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $4dd9b21d74c34b51$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $lrKz8.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $lrKz8.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $lrKz8.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $4dd9b21d74c34b51$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $lrKz8.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $lrKz8.isPlainObject)(event) || event === null)) throw new (0, $lrKz8.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $lrKz8.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $lrKz8.isPlainObject)(rv) || rv === null)) throw new (0, $lrKz8.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("ghgla", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("kesNJ")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("h5th4")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("h5th4")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("bsuC0")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("bsuC0")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("6GNoN")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("cVsDc")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("f06ai")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("8iYMs")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("8iYMs")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("8iYMs")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("8iYMs")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("8iYMs")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("8iYMs")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("8iYMs")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("8iYMs")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("8iYMs")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("8iYMs")).isThenable);
$parcel$export(module.exports, "logger", () => (parcelRequire("3zTYc")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("k9zn8")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("k9zn8")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("k9zn8")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("k9zn8")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("k9zn8")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("k9zn8")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("7qnIT")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("7qnIT")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("7WyHU")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("7WyHU")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("7WyHU")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("7WyHU")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("7WyHU")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("7WyHU")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("2UNe3")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("53I05")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("hBriY")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("hBriY")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("aR1fZ")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("3Fb06")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("3Fb06")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("3Fb06")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("1trRX")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("1trRX")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("1trRX")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("dtkXJ")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("dtkXJ")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("dtkXJ")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("bDjOB")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("bDjOB")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("bDjOB")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("7IXlz")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("fSOj5")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("fSOj5")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("fSOj5")).updateRateLimits);
parcelRequire("kesNJ");
parcelRequire("h5th4");
parcelRequire("bsuC0");

parcelRequire("6GNoN");
parcelRequire("cVsDc");
parcelRequire("f06ai");
parcelRequire("8iYMs");
parcelRequire("3zTYc");

parcelRequire("k9zn8");

var $aV0ua = parcelRequire("aV0ua");
parcelRequire("7qnIT");
parcelRequire("7WyHU");

parcelRequire("2UNe3");
parcelRequire("53I05");
parcelRequire("hBriY");
parcelRequire("aR1fZ");
parcelRequire("3Fb06");
parcelRequire("1trRX");
parcelRequire("dtkXJ");

var $lrKz8 = parcelRequire("lrKz8");


parcelRequire("bDjOB");
parcelRequire("7IXlz");
parcelRequire("fSOj5");
$parcel$exportWildcard(module.exports, $aV0ua);
$parcel$exportWildcard(module.exports, $lrKz8);

});

parcelRegister("1YZ0Z", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $171ab956f1a90644$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $171ab956f1a90644$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("uXILP", function(module, exports) {

$parcel$export(module.exports, "setupIntegrations", () => $05d120d2e280c9b1$export$51abed9797baa598);

var $3VFsf = parcelRequire("3VFsf");

var $gfYRq = parcelRequire("gfYRq");
var $3kk8J = parcelRequire("3kk8J");
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");

var $1YZ0Z = parcelRequire("1YZ0Z");
var $05d120d2e280c9b1$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $05d120d2e280c9b1$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $05d120d2e280c9b1$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $3VFsf.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $3VFsf.__spread)($05d120d2e280c9b1$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $3VFsf.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $05d120d2e280c9b1$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $3VFsf.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $05d120d2e280c9b1$export$e7390a03b70a6f2f(integration) {
    if ($05d120d2e280c9b1$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $gfYRq.addGlobalEventProcessor), (0, $3kk8J.getCurrentHub));
    $05d120d2e280c9b1$export$b14a8888f80a0b3e.push(integration.name);
    (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).log("Integration installed: " + integration.name);
}
function $05d120d2e280c9b1$export$51abed9797baa598(options) {
    var integrations = {};
    $05d120d2e280c9b1$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $05d120d2e280c9b1$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $lrKz8.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("1U0bt", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $162b29f80b5d0cf5$export$31499a9cd224b78c);
var $162b29f80b5d0cf5$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("e5AkH", function(module, exports) {

$parcel$export(module.exports, "BrowserBackend", () => $a41db741def54f0d$export$2526e21aec9d0ce7);

var $3VFsf = parcelRequire("3VFsf");

var $c4nDf = parcelRequire("c4nDf");
var $8EMIt = parcelRequire("8EMIt");

var $kIiWO = parcelRequire("kIiWO");
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");

var $1WGIa = parcelRequire("1WGIa");

var $j48wV = parcelRequire("j48wV");
var $dZLt5 = parcelRequire("dZLt5");
var $h10ur = parcelRequire("h10ur");
var $5eCLW = parcelRequire("5eCLW");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $a41db741def54f0d$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $1WGIa.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $kIiWO.Severity).Info;
        return (0, $1WGIa.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $8EMIt.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $8EMIt.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $lrKz8.supportsFetch)()) {
            var requestOptions = (0, $3VFsf.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $dZLt5.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $j48wV.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $h10ur.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $5eCLW.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $c4nDf.BaseBackend));

});
parcelRegister("c4nDf", function(module, exports) {

$parcel$export(module.exports, "BaseBackend", () => $8c9830908b93e616$export$8f43a53a38d7e95f);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");

var $8EMIt = parcelRequire("8EMIt");

var $1YZ0Z = parcelRequire("1YZ0Z");

var $01GH5 = parcelRequire("01GH5");

var $1xv5a = parcelRequire("1xv5a");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $8c9830908b93e616$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $lrKz8.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $lrKz8.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $8EMIt.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $01GH5.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $8EMIt.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $3VFsf.__read)((0, $01GH5.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $1YZ0Z.IS_DEBUG_BUILD) && (0, $lrKz8.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $1xv5a.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("8EMIt", function(module, exports) {

$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $64d7d9312337c0a2$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $64d7d9312337c0a2$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $64d7d9312337c0a2$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $64d7d9312337c0a2$export$671c7ed8e40a7a57);
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");
var $64d7d9312337c0a2$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $64d7d9312337c0a2$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $lrKz8.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $64d7d9312337c0a2$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $64d7d9312337c0a2$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $64d7d9312337c0a2$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $64d7d9312337c0a2$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $64d7d9312337c0a2$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $lrKz8.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $64d7d9312337c0a2$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $64d7d9312337c0a2$var$_getIngestEndpoint(dsn, target) {
    return "" + $64d7d9312337c0a2$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $64d7d9312337c0a2$var$_encodedAuth(dsn) {
    return (0, $lrKz8.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $64d7d9312337c0a2$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $64d7d9312337c0a2$var$getStoreEndpoint(dsn) {
    return $64d7d9312337c0a2$var$_getIngestEndpoint(dsn, 'store');
}
function $64d7d9312337c0a2$export$c1677e22ac2217a5(dsn) {
    return $64d7d9312337c0a2$var$getStoreEndpoint(dsn) + "?" + $64d7d9312337c0a2$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $64d7d9312337c0a2$var$_getEnvelopeEndpoint(dsn) {
    return $64d7d9312337c0a2$var$_getIngestEndpoint(dsn, 'envelope');
}
function $64d7d9312337c0a2$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $64d7d9312337c0a2$var$_getEnvelopeEndpoint(dsn) + "?" + $64d7d9312337c0a2$var$_encodedAuth(dsn);
}
function $64d7d9312337c0a2$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $64d7d9312337c0a2$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $64d7d9312337c0a2$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $lrKz8.makeDsn)(dsnLike);
    var endpoint = $64d7d9312337c0a2$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $lrKz8.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("01GH5", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", () => $00513637c6fd9389$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $00513637c6fd9389$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $00513637c6fd9389$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $00513637c6fd9389$export$2006389de558b996);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("ghgla");
var $bDjOB = parcelRequire("bDjOB");
var $lrKz8 = parcelRequire("lrKz8");

var $8EMIt = parcelRequire("8EMIt");
/** Extract sdk info from from the API metadata */ function $00513637c6fd9389$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $00513637c6fd9389$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $3VFsf.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $3VFsf.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $00513637c6fd9389$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $00513637c6fd9389$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $lrKz8.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $bDjOB.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $00513637c6fd9389$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $3VFsf.__read)($00513637c6fd9389$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $bDjOB.serializeEnvelope)(envelope),
        type: type,
        url: (0, $8EMIt.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $00513637c6fd9389$export$c31057337a18010f(event, api) {
    var sdkInfo = $00513637c6fd9389$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $00513637c6fd9389$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $lrKz8.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $bDjOB.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $00513637c6fd9389$export$2006389de558b996(event, api) {
    var sdkInfo = $00513637c6fd9389$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $00513637c6fd9389$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $lrKz8.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $8EMIt.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $8EMIt.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $lrKz8.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $bDjOB.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $bDjOB.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("1xv5a", function(module, exports) {

$parcel$export(module.exports, "NoopTransport", () => $11f0fbcf3ca85bd8$export$6f2767450ea1346c);
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");
/** Noop transport */ var $11f0fbcf3ca85bd8$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $lrKz8.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $lrKz8.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("1WGIa", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $16ac56d33e310e8e$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $16ac56d33e310e8e$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $16ac56d33e310e8e$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $16ac56d33e310e8e$export$5425b53185d13d6c);

var $3VFsf = parcelRequire("3VFsf");

var $kIiWO = parcelRequire("kIiWO");
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");

var $cmVYs = parcelRequire("cmVYs");
function $16ac56d33e310e8e$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $16ac56d33e310e8e$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $16ac56d33e310e8e$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $16ac56d33e310e8e$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $lrKz8.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $lrKz8.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $lrKz8.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $16ac56d33e310e8e$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $16ac56d33e310e8e$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $16ac56d33e310e8e$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $16ac56d33e310e8e$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $16ac56d33e310e8e$var$getPopSize(ex);
    try {
        return (0, $lrKz8.createStackParser)((0, $cmVYs.opera10StackParser), (0, $cmVYs.opera11StackParser), (0, $cmVYs.chromeStackParser), (0, $cmVYs.winjsStackParser), (0, $cmVYs.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $16ac56d33e310e8e$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $16ac56d33e310e8e$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($16ac56d33e310e8e$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $16ac56d33e310e8e$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $16ac56d33e310e8e$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $16ac56d33e310e8e$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $lrKz8.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $kIiWO.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $lrKz8.resolvedSyncPromise)(event);
}
function $16ac56d33e310e8e$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $kIiWO.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $16ac56d33e310e8e$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $lrKz8.resolvedSyncPromise)(event);
}
function $16ac56d33e310e8e$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $lrKz8.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $16ac56d33e310e8e$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $lrKz8.isDOMError)(exception) || (0, $lrKz8.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $16ac56d33e310e8e$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $lrKz8.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $16ac56d33e310e8e$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $lrKz8.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $lrKz8.isError)(exception)) // we have a real Error object, do nothing
    return $16ac56d33e310e8e$export$73fbea5a0a5234af(exception);
    if ((0, $lrKz8.isPlainObject)(exception) || (0, $lrKz8.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $16ac56d33e310e8e$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $lrKz8.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $16ac56d33e310e8e$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $lrKz8.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $lrKz8.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $16ac56d33e310e8e$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $16ac56d33e310e8e$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("cmVYs", function(module, exports) {

$parcel$export(module.exports, "chromeStackParser", () => $9014828be74b589f$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $9014828be74b589f$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $9014828be74b589f$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $9014828be74b589f$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $9014828be74b589f$export$989a1824b4734ce6);

var $3VFsf = parcelRequire("3VFsf");
// global reference to slice
var $9014828be74b589f$var$UNKNOWN_FUNCTION = '?';
var $9014828be74b589f$var$OPERA10_PRIORITY = 10;
var $9014828be74b589f$var$OPERA11_PRIORITY = 20;
var $9014828be74b589f$var$CHROME_PRIORITY = 30;
var $9014828be74b589f$var$WINJS_PRIORITY = 40;
var $9014828be74b589f$var$GECKO_PRIORITY = 50;
function $9014828be74b589f$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $9014828be74b589f$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $9014828be74b589f$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $9014828be74b589f$var$chrome = function(line) {
    var parts = $9014828be74b589f$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $9014828be74b589f$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $3VFsf.__read)($9014828be74b589f$var$extractSafariExtensionDetails(parts[1] || $9014828be74b589f$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $9014828be74b589f$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $9014828be74b589f$export$c693d9295441d8f9 = [
    $9014828be74b589f$var$CHROME_PRIORITY,
    $9014828be74b589f$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $9014828be74b589f$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $9014828be74b589f$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $9014828be74b589f$var$gecko = function(line) {
    var _a;
    var parts = $9014828be74b589f$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $9014828be74b589f$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $9014828be74b589f$var$UNKNOWN_FUNCTION;
        _a = (0, $3VFsf.__read)($9014828be74b589f$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $9014828be74b589f$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $9014828be74b589f$export$c9ddf1e2b5d48bff = [
    $9014828be74b589f$var$GECKO_PRIORITY,
    $9014828be74b589f$var$gecko
];
var $9014828be74b589f$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $9014828be74b589f$var$winjs = function(line) {
    var parts = $9014828be74b589f$var$winjsRegex.exec(line);
    return parts ? $9014828be74b589f$var$createFrame(parts[2], parts[1] || $9014828be74b589f$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $9014828be74b589f$export$b6d155d85c1dcba5 = [
    $9014828be74b589f$var$WINJS_PRIORITY,
    $9014828be74b589f$var$winjs
];
var $9014828be74b589f$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $9014828be74b589f$var$opera10 = function(line) {
    var parts = $9014828be74b589f$var$opera10Regex.exec(line);
    return parts ? $9014828be74b589f$var$createFrame(parts[2], parts[3] || $9014828be74b589f$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $9014828be74b589f$export$966ec832d9699d6 = [
    $9014828be74b589f$var$OPERA10_PRIORITY,
    $9014828be74b589f$var$opera10
];
var $9014828be74b589f$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $9014828be74b589f$var$opera11 = function(line) {
    var parts = $9014828be74b589f$var$opera11Regex.exec(line);
    return parts ? $9014828be74b589f$var$createFrame(parts[5], parts[3] || parts[4] || $9014828be74b589f$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $9014828be74b589f$export$989a1824b4734ce6 = [
    $9014828be74b589f$var$OPERA11_PRIORITY,
    $9014828be74b589f$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $9014828be74b589f$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $9014828be74b589f$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("j48wV", function(module, exports) {

$parcel$export(module.exports, "FetchTransport", () => $de1501f43e5e2db2$export$2bdee3f9b92f4e82);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");

var $aeSJy = parcelRequire("aeSJy");

var $dpLpv = parcelRequire("dpLpv");
/** `fetch` based transport */ var $de1501f43e5e2db2$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $dpLpv.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $lrKz8.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $lrKz8.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $lrKz8.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $aeSJy.BaseTransport));

});
parcelRegister("aeSJy", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", () => $7745ab30d525e8a9$export$74b99d619e90f481);

var $3VFsf = parcelRequire("3VFsf");

var $01GH5 = parcelRequire("01GH5");
var $8EMIt = parcelRequire("8EMIt");
parcelRequire("ghgla");
var $7IXlz = parcelRequire("7IXlz");
var $fSOj5 = parcelRequire("fSOj5");
var $lrKz8 = parcelRequire("lrKz8");
var $bDjOB = parcelRequire("bDjOB");

var $7HgA0 = parcelRequire("7HgA0");

var $dpLpv = parcelRequire("dpLpv");
function $7745ab30d525e8a9$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $7745ab30d525e8a9$var$global = (0, $lrKz8.getGlobalObject)();
/** Base Transport class implementation */ var $7745ab30d525e8a9$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $lrKz8.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $8EMIt.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $8EMIt.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $7745ab30d525e8a9$var$global.document) $7745ab30d525e8a9$var$global.document.addEventListener('visibilitychange', function() {
            if ($7745ab30d525e8a9$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $01GH5.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $01GH5.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $7745ab30d525e8a9$var$requestTypeToCategory(category) + ":" + reason;
        (0, $7HgA0.IS_DEBUG_BUILD) && (0, $lrKz8.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $7HgA0.IS_DEBUG_BUILD) && (0, $lrKz8.logger).log('No outcomes to flush');
            return;
        }
        (0, $7HgA0.IS_DEBUG_BUILD) && (0, $lrKz8.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $8EMIt.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $3VFsf.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $7IXlz.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $lrKz8.dsnToString)(this._api.dsn));
        try {
            (0, $dpLpv.sendReport)(url, (0, $bDjOB.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $7HgA0.IS_DEBUG_BUILD) && (0, $lrKz8.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $lrKz8.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $fSOj5.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $7HgA0.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $lrKz8.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $7745ab30d525e8a9$var$requestTypeToCategory(requestType);
        return new Date((0, $fSOj5.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $7745ab30d525e8a9$var$requestTypeToCategory(requestType);
        return (0, $fSOj5.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("7HgA0", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $59a968f4eed2b3c5$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $59a968f4eed2b3c5$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("dpLpv", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", () => $9c4262e354cd9fcc$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $9c4262e354cd9fcc$export$84bb63b2c17ec44d);
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");

var $7HgA0 = parcelRequire("7HgA0");
var $9c4262e354cd9fcc$var$global = (0, $lrKz8.getGlobalObject)();
var $9c4262e354cd9fcc$var$cachedFetchImpl;
function $9c4262e354cd9fcc$export$8be2119ce08e3379() {
    if ($9c4262e354cd9fcc$var$cachedFetchImpl) return $9c4262e354cd9fcc$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $lrKz8.isNativeFetch)($9c4262e354cd9fcc$var$global.fetch)) return $9c4262e354cd9fcc$var$cachedFetchImpl = $9c4262e354cd9fcc$var$global.fetch.bind($9c4262e354cd9fcc$var$global);
    var document = $9c4262e354cd9fcc$var$global.document;
    var fetchImpl = $9c4262e354cd9fcc$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $7HgA0.IS_DEBUG_BUILD) && (0, $lrKz8.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $9c4262e354cd9fcc$var$cachedFetchImpl = fetchImpl.bind($9c4262e354cd9fcc$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $9c4262e354cd9fcc$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($9c4262e354cd9fcc$var$global && $9c4262e354cd9fcc$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $9c4262e354cd9fcc$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $9c4262e354cd9fcc$var$global.navigator.sendBeacon.bind($9c4262e354cd9fcc$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $lrKz8.supportsFetch)()) {
        var fetch_1 = $9c4262e354cd9fcc$export$8be2119ce08e3379();
        return (0, $lrKz8.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("dZLt5", function(module, exports) {

$parcel$export(module.exports, "makeNewFetchTransport", () => $a305cb080f4250f2$export$1c57e6bfd09bad13);

var $3VFsf = parcelRequire("3VFsf");

var $g6CWy = parcelRequire("g6CWy");

var $dpLpv = parcelRequire("dpLpv");
function $a305cb080f4250f2$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $dpLpv.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $3VFsf.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $g6CWy.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("g6CWy", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $bb9b6a3a9455c7ca$export$d09f50d9ab7f7b69);
parcelRequire("ghgla");
var $fSOj5 = parcelRequire("fSOj5");
var $lrKz8 = parcelRequire("lrKz8");
var $bDjOB = parcelRequire("bDjOB");
var $bb9b6a3a9455c7ca$export$d8a725a7dce95622 = 'error';
var $bb9b6a3a9455c7ca$export$99adc6fe67a3c63e = 'transaction';
var $bb9b6a3a9455c7ca$export$9d7ad34f132fe68f = 'attachment';
var $bb9b6a3a9455c7ca$export$42d9e7b5fc564c45 = 'session';
var $bb9b6a3a9455c7ca$export$e515cf6dfd2f98b8 = 30;
function $bb9b6a3a9455c7ca$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $lrKz8.makePromiseBuffer)(options.bufferSize || $bb9b6a3a9455c7ca$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $bDjOB.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $bDjOB.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $fSOj5.isRateLimited)(rateLimits, category)) return (0, $lrKz8.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $bb9b6a3a9455c7ca$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $lrKz8.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $fSOj5.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $lrKz8.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $lrKz8.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $bb9b6a3a9455c7ca$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $bb9b6a3a9455c7ca$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $fSOj5.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("h10ur", function(module, exports) {

$parcel$export(module.exports, "makeNewXHRTransport", () => $c632e8f3128fc73a$export$4c0ac1dd4bbf4921);

var $g6CWy = parcelRequire("g6CWy");
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $c632e8f3128fc73a$var$XHR_READYSTATE_DONE = 4;
function $c632e8f3128fc73a$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $lrKz8.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $c632e8f3128fc73a$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $g6CWy.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("5eCLW", function(module, exports) {

$parcel$export(module.exports, "XHRTransport", () => $3cfc55e46320635d$export$874a283af77e8e62);

var $3VFsf = parcelRequire("3VFsf");
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");

var $aeSJy = parcelRequire("aeSJy");
/** `XHR` based transport */ var $3cfc55e46320635d$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $lrKz8.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $lrKz8.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $aeSJy.BaseTransport));

});


parcelRegister("dFFWm", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreOnError", () => $9f3fa326c16d0bc7$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $9f3fa326c16d0bc7$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $9f3fa326c16d0bc7$export$deb9aac8ea0b576c);

var $3VFsf = parcelRequire("3VFsf");

var $7zHWg = parcelRequire("7zHWg");
var $8EMIt = parcelRequire("8EMIt");
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");

var $7HgA0 = parcelRequire("7HgA0");
var $9f3fa326c16d0bc7$var$global = (0, $lrKz8.getGlobalObject)();
var $9f3fa326c16d0bc7$var$ignoreOnError = 0;
function $9f3fa326c16d0bc7$export$b79738ab10c590b2() {
    return $9f3fa326c16d0bc7$var$ignoreOnError > 0;
}
function $9f3fa326c16d0bc7$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9f3fa326c16d0bc7$var$ignoreOnError += 1;
    setTimeout(function() {
        $9f3fa326c16d0bc7$var$ignoreOnError -= 1;
    });
}
function $9f3fa326c16d0bc7$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $lrKz8.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $9f3fa326c16d0bc7$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9f3fa326c16d0bc7$export$1265a142ff5ba165();
            (0, $7zHWg.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $lrKz8.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $lrKz8.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $7zHWg.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $lrKz8.markFunctionWrapped)(sentryWrapped, fn);
    (0, $lrKz8.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $9f3fa326c16d0bc7$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$9f3fa326c16d0bc7$var$global.document) return;
    if (!options.eventId) {
        (0, $7HgA0.IS_DEBUG_BUILD) && (0, $lrKz8.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $7HgA0.IS_DEBUG_BUILD) && (0, $lrKz8.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $9f3fa326c16d0bc7$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $8EMIt.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $9f3fa326c16d0bc7$var$global.document.head || $9f3fa326c16d0bc7$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("gSRAG", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $c4ab427bc459b14f$export$2dc68d50d56fbbd);

var $3VFsf = parcelRequire("3VFsf");

var $3kk8J = parcelRequire("3kk8J");

var $kIiWO = parcelRequire("kIiWO");
parcelRequire("ghgla");
var $lrKz8 = parcelRequire("lrKz8");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $c4ab427bc459b14f$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $3VFsf.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $lrKz8.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $lrKz8.addInstrumentationHandler)('console', $c4ab427bc459b14f$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $lrKz8.addInstrumentationHandler)('dom', $c4ab427bc459b14f$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $lrKz8.addInstrumentationHandler)('xhr', $c4ab427bc459b14f$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $lrKz8.addInstrumentationHandler)('fetch', $c4ab427bc459b14f$var$_fetchBreadcrumb);
        if (this._options.history) (0, $lrKz8.addInstrumentationHandler)('history', $c4ab427bc459b14f$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c4ab427bc459b14f$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $lrKz8.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $lrKz8.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c4ab427bc459b14f$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $lrKz8.severityFromString)(handlerData.level),
        message: (0, $lrKz8.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $lrKz8.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $3kk8J.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c4ab427bc459b14f$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $3kk8J.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c4ab427bc459b14f$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $kIiWO.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c4ab427bc459b14f$var$_historyBreadcrumb(handlerData) {
    var global = (0, $lrKz8.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $lrKz8.parseUrl)(global.location.href);
    var parsedFrom = (0, $lrKz8.parseUrl)(from);
    var parsedTo = (0, $lrKz8.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $3kk8J.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("9e9ba", function(module, exports) {

$parcel$export(module.exports, "maskEmailIds", () => $6b7c8aa13a9e7ef7$export$7a75efd77ad928b4);
const $6b7c8aa13a9e7ef7$var$EMAIL_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
const $6b7c8aa13a9e7ef7$export$7a75efd77ad928b4 = (text)=>text.replace($6b7c8aa13a9e7ef7$var$EMAIL_REGEX, '***@***');

});



parcelRegister("N5QrD", function(module, exports) {

$parcel$export(module.exports, "useFormIndexState", () => $09391c63e2b61648$export$f74100c7a791655f);
$parcel$export(module.exports, "useFormIndexActions", () => $09391c63e2b61648$export$d4c535471ad660c0);
$parcel$export(module.exports, "useReportError", () => $09391c63e2b61648$export$5a5695b638d078e7);
$parcel$export(module.exports, "useSelectedFormStoreState", () => $09391c63e2b61648$export$3ad8ab7c381142b0);
$parcel$export(module.exports, "FormIndexStoreContainer", () => $09391c63e2b61648$export$1ecd1ee077f9d22e);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $1oEv5 = parcelRequire("1oEv5");

var $74BNb = parcelRequire("74BNb");

var $4JE17 = parcelRequire("4JE17");

var $hprFm = parcelRequire("hprFm");
const $09391c63e2b61648$var$FormIndexStore = (0, $iXqE5.createStore)({
    initialState: {
        isIndexLoading: false,
        formIndex: [],
        selectedFormId: undefined,
        isInitialised: false,
        permissions: {},
        formViewMode: (0, $hprFm.FormViewMode).View
    },
    actions: $1oEv5.actions,
    name: 'proforma-form-index-store'
});
const $09391c63e2b61648$export$f74100c7a791655f = (0, $3sQ5x.createStateHook)($09391c63e2b61648$var$FormIndexStore);
const $09391c63e2b61648$export$d4c535471ad660c0 = (0, $3sQ5x.createActionsHook)($09391c63e2b61648$var$FormIndexStore);
const $09391c63e2b61648$export$5a5695b638d078e7 = ()=>{
    const { reportError: reportError } = $09391c63e2b61648$export$d4c535471ad660c0();
    return reportError;
};
const $09391c63e2b61648$export$3ad8ab7c381142b0 = (0, $3sQ5x.createStateHook)($09391c63e2b61648$var$FormIndexStore, {
    selector: (0, $4JE17.getSelectedFormStoreState)
});
const $09391c63e2b61648$export$1ecd1ee077f9d22e = (0, $gg7kZ.createContainer)($09391c63e2b61648$var$FormIndexStore, {
    onInit: ()=>async ({ dispatch: dispatch, setState: setState }, { permissions: permissions })=>{
            setState({
                permissions: permissions
            });
            await dispatch((0, $74BNb.loadIndex)());
            setState({
                // The `isInitialised` property exists to let the consumer of FormIndexStore, in proforma-jira-issue-view
                // package, know when to start fetching the default selected form.
                // This is a temporarily-ish solution, we need to think of a better way to orchestrate this relationship
                // after we have implemented a react-sweet-state IssueViewStore in proforma-jira-issue-view.
                isInitialised: true
            });
        }
});

});
parcelRegister("1oEv5", function(module, exports) {

$parcel$export(module.exports, "actions", () => $104772dfef8d5338$export$e324594224ef24da);

var $btowL = parcelRequire("btowL");

var $iG5bN = parcelRequire("iG5bN");

var $kC64R = parcelRequire("kC64R");

var $74BNb = parcelRequire("74BNb");

var $57u5B = parcelRequire("57u5B");

var $kmwdf = parcelRequire("kmwdf");

var $9vFFC = parcelRequire("9vFFC");

var $f2zSa = parcelRequire("f2zSa");

var $dw6Ox = parcelRequire("dw6Ox");

var $4jJ1O = parcelRequire("4jJ1O");

var $dm6ZU = parcelRequire("dm6ZU");

var $eUlwF = parcelRequire("eUlwF");

var $3FH8i = parcelRequire("3FH8i");

var $1n126 = parcelRequire("1n126");

var $hQd8D = parcelRequire("hQd8D");

var $aCyn5 = parcelRequire("aCyn5");
const $104772dfef8d5338$export$e324594224ef24da = {
    deleteFormOld: $iG5bN.deleteFormOld,
    deleteForm: $btowL.deleteForm,
    hasSeenOnboarding: $kC64R.hasSeenOnboarding,
    loadIndex: $74BNb.loadIndex,
    markAsSeenOnboarding: $57u5B.markAsSeenOnboarding,
    setIsIndexLoading: $4jJ1O.setIsIndexLoading,
    setSelectedFormId: $dm6ZU.setSelectedFormId,
    updateFormVisibility: $aCyn5.updateFormVisibility,
    updateFormStatus: $hQd8D.updateFormStatus,
    reopenForm: $kmwdf.reopenForm,
    submitForm: $1n126.submitForm,
    saveAnswers: $f2zSa.saveAnswers,
    setSelectedFormStore: $eUlwF.setSelectedFormStore,
    setFormViewMode: $dw6Ox.setFormViewMode,
    reportError: $9vFFC.reportError,
    setSelectedFormStoreState: $3FH8i.setSelectedFormStoreState
};

});
parcelRegister("btowL", function(module, exports) {

$parcel$export(module.exports, "deleteForm", () => $85a56dc9025ed021$export$53d90b96312e813f);
const $85a56dc9025ed021$export$53d90b96312e813f = (formId)=>async ({ getState: getState, setState: setState }, { api: api })=>{
        const { permissions: permissions } = getState();
        if (!permissions.delete) return Promise.reject(new Error('no permissions to delete'));
        setState({
            isIndexLoading: true
        });
        try {
            await api.deleteForm(formId);
            const deletedFormIndexItem = getState().formIndex.find((formIndex)=>formIndex.id === formId);
            setState({
                formIndex: getState().formIndex.filter((formIndexItem)=>formIndexItem.id !== (deletedFormIndexItem === null || deletedFormIndexItem === void 0 ? void 0 : deletedFormIndexItem.id))
            });
            return deletedFormIndexItem === null || deletedFormIndexItem === void 0 ? void 0 : deletedFormIndexItem.projectFormId;
        } finally{
            setState({
                isIndexLoading: false
            });
        }
    };

});

parcelRegister("iG5bN", function(module, exports) {

$parcel$export(module.exports, "deleteFormOld", () => $d9902cbdfaf6bd5d$export$8ee3215c9c35b3a7);

var $bRqoO = parcelRequire("bRqoO");

var $j93Fo = parcelRequire("j93Fo");

var $dm6ZU = parcelRequire("dm6ZU");
const $d9902cbdfaf6bd5d$export$8ee3215c9c35b3a7 = (formId, formName)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { api: api })=>{
        const { permissions: permissions } = getState();
        if (!permissions.delete) return Promise.reject(new Error('no permissions to delete'));
        const isConfirmed = await (0, $j93Fo.showNotice)((0, $bRqoO.NoticeType).ConfirmDeleteForm, {
            msgVars: {
                formName: formName
            }
        });
        if (isConfirmed) {
            setState({
                isIndexLoading: true
            });
            try {
                await api.deleteForm(formId);
                const deletedFormIndexItem = getState().formIndex.find((formIndex)=>formIndex.id === formId);
                setState({
                    formIndex: getState().formIndex.filter((formIndexItem)=>formIndexItem.id !== (deletedFormIndexItem === null || deletedFormIndexItem === void 0 ? void 0 : deletedFormIndexItem.id))
                });
                // unset if it is the current selected form
                if (getState().selectedFormId === (deletedFormIndexItem === null || deletedFormIndexItem === void 0 ? void 0 : deletedFormIndexItem.id)) await dispatch((0, $dm6ZU.setSelectedFormId)());
                return deletedFormIndexItem === null || deletedFormIndexItem === void 0 ? void 0 : deletedFormIndexItem.projectFormId;
            } finally{
                setState({
                    isIndexLoading: false
                });
            }
        }
        return Promise.reject(new Error('cancelled'));
    };

});
parcelRegister("dm6ZU", function(module, exports) {

$parcel$export(module.exports, "setSelectedFormId", () => $9b92c1fab37f7896$export$dae2f484d2d301f4);

var $9L60d = parcelRequire("9L60d");

var $5wBnn = parcelRequire("5wBnn");
const $9b92c1fab37f7896$export$dae2f484d2d301f4 = (formId)=>async ({ setState: setState, getState: getState }, { projectId: projectId })=>{
        var _getSelectedFormIndex;
        setState({
            selectedFormId: formId
        });
        const selectedProjectFormId = (_getSelectedFormIndex = (0, $9L60d.getSelectedFormIndexItem)(getState())) === null || _getSelectedFormIndex === void 0 ? void 0 : _getSelectedFormIndex.projectFormId;
        await (0, $5wBnn.setLastViewedForm)(projectId, {
            templateFormId: selectedProjectFormId
        });
    };

});
parcelRegister("9L60d", function(module, exports) {

$parcel$export(module.exports, "getSelectedFormIndexItem", () => $71ad28d55e5e6a25$export$63af515a392262be);
const $71ad28d55e5e6a25$export$63af515a392262be = (state)=>state.formIndex.find((formIndex)=>formIndex.id === state.selectedFormId);

});

parcelRegister("5wBnn", function(module, exports) {

$parcel$export(module.exports, "setLastViewedForm", () => $405cef036aa7fdce$export$1f6effbabca4b159);

var $1dN1z = parcelRequire("1dN1z");
const $405cef036aa7fdce$var$LAST_VIEWED_FORM_COOKIE_NAME_PREFIX = 'lastViewedForm-';
const $405cef036aa7fdce$export$1f6effbabca4b159 = async (projectId, lastViewedFormCookie)=>{
    const updatedLastViewedFormCookie = lastViewedFormCookie !== null && lastViewedFormCookie !== void 0 && lastViewedFormCookie.templateFormId ? lastViewedFormCookie : {};
    await (0, $1dN1z.setCookie)(`${$405cef036aa7fdce$var$LAST_VIEWED_FORM_COOKIE_NAME_PREFIX}${projectId}`, JSON.stringify(updatedLastViewedFormCookie), {
        sameSite: 'None',
        secure: true
    });
};

});
parcelRegister("1dN1z", function(module, exports) {

$parcel$export(module.exports, "setCookie", () => $317d08d061b7f78b$export$110700823644f4a6);

var $eYli8 = parcelRequire("eYli8");

var $fHpHg = parcelRequire("fHpHg");

var $6ZTqw = parcelRequire("6ZTqw");
var $2MdED = parcelRequire("2MdED");

var $7B39G = parcelRequire("7B39G");

var $4TktD = parcelRequire("4TktD");

var $3liKs = parcelRequire("3liKs");
const $317d08d061b7f78b$export$110700823644f4a6 = async (key, value, attributes)=>{
    if ((0, $fHpHg.fg)('platform_moonjelly_bsc_master_killswitch')) {
        // Set the cookie without checking user preferences
        // when master killswitch is enabled
        (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
        return (0, $3liKs.Status).SUCCESS;
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    const productName = (0, $6ZTqw.getBscGlobalState)().product;
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetCookie = await (0, $7B39G.isProcessingAllowedByPreferences)({
        itemKey: key,
        storageType: (0, $3liKs.CategoryStorageType).Cookies,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetCookie,
        cookieKey: key
    };
    try {
        (0, $2MdED.sendPackageOperationalEvent)({
            action: 'usedSetCookie',
            attributes: eventAttributes
        });
        if (shouldSetCookie) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
            return (0, $3liKs.Status).SUCCESS;
        } else return (0, $3liKs.Status).BLOCKED;
    } catch (e) {
        (0, $4TktD.Logger).errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: `Failed to use set cookie. ${e.message || ''}`
        });
        return (0, $3liKs.Status).BLOCKED;
    }
};

});




parcelRegister("kC64R", function(module, exports) {

$parcel$export(module.exports, "hasSeenOnboarding", () => $f01c12208da7693f$export$587476478bb3f90f);
const $f01c12208da7693f$export$587476478bb3f90f = (propertyKey)=>async (_, { api: api })=>api.hasSeenOnboarding(propertyKey);

});

parcelRegister("74BNb", function(module, exports) {

$parcel$export(module.exports, "loadIndex", () => $526638df2764aeb2$export$c7d1fecc6778ba74);
const $526638df2764aeb2$export$c7d1fecc6778ba74 = ()=>async ({ setState: setState }, { api: api, errorUtils: errorUtils })=>{
        setState({
            isIndexLoading: true
        });
        try {
            const formIndex = await api.getFormIndex();
            setState({
                formIndex: formIndex,
                isIndexLoading: false
            });
            return undefined;
        } catch (error) {
            errorUtils.reportError(error, {
                id: 'loadIndex'
            });
            setState({
                isIndexLoading: false
            });
            return Promise.reject(error);
        }
    };

});

parcelRegister("57u5B", function(module, exports) {

$parcel$export(module.exports, "markAsSeenOnboarding", () => $3ba4f257b25b8a5e$export$b0a88327fce3b75d);
const $3ba4f257b25b8a5e$export$b0a88327fce3b75d = (propertyKey)=>async (_, { api: api })=>api.markAsSeenOnboarding(propertyKey);

});

parcelRegister("kmwdf", function(module, exports) {

$parcel$export(module.exports, "reopenForm", () => $ed2ed97ec3528dbf$export$984e056551540c97);
const $ed2ed97ec3528dbf$export$984e056551540c97 = (formId, formStatus)=>async (_, { api: api })=>api.reopenForm(formId, formStatus);

});

parcelRegister("9vFFC", function(module, exports) {

$parcel$export(module.exports, "reportError", () => $6ec7552b6e413903$export$b33b857ad1d9900e);
const $6ec7552b6e413903$export$b33b857ad1d9900e = (...params)=>(_, { errorUtils: errorUtils })=>{
        errorUtils.reportError(...params);
    };

});

parcelRegister("f2zSa", function(module, exports) {

$parcel$export(module.exports, "saveAnswers", () => $af32de814d9b10ad$export$13572ce8a55fa8a3);
const $af32de814d9b10ad$export$13572ce8a55fa8a3 = (formId, formAnswers)=>async (_, { api: api })=>api.saveAnswers(formId, formAnswers);

});

parcelRegister("dw6Ox", function(module, exports) {

$parcel$export(module.exports, "setFormViewMode", () => $9d738ca968c7dcc3$export$c5ddae97a3e6243);
const $9d738ca968c7dcc3$export$c5ddae97a3e6243 = (formViewMode)=>({ setState: setState })=>{
        setState({
            formViewMode: formViewMode
        });
    };

});

parcelRegister("4jJ1O", function(module, exports) {

$parcel$export(module.exports, "setIsIndexLoading", () => $324bdd733728bd3b$export$53ce67b27aca4f51);
const $324bdd733728bd3b$export$53ce67b27aca4f51 = (isIndexLoading)=>({ setState: setState })=>{
        setState({
            isIndexLoading: isIndexLoading
        });
    };

});

parcelRegister("eUlwF", function(module, exports) {

$parcel$export(module.exports, "setSelectedFormStore", () => $ada6fe3fd7dcd962$export$5a5d3b4bc1b57d1a);

var $hprFm = parcelRequire("hprFm");
const $ada6fe3fd7dcd962$export$5a5d3b4bc1b57d1a = (formStore, formViewMode = (0, $hprFm.FormViewMode).View)=>({ setState: setState })=>{
        setState({
            formViewMode: formViewMode,
            selectedFormStore: formStore
        });
    };

});
parcelRegister("hprFm", function(module, exports) {

$parcel$export(module.exports, "FormViewMode", () => $caca3b5f45328e32$export$f089e843cef96c44);
// We should have our own permissions type for Form Index.
let $caca3b5f45328e32$export$f089e843cef96c44 = /*#__PURE__*/ function(FormViewMode) {
    FormViewMode["View"] = "view";
    FormViewMode["Edit"] = "edit";
    return FormViewMode;
}({});

});


parcelRegister("3FH8i", function(module, exports) {

$parcel$export(module.exports, "setSelectedFormStoreState", () => $2ac6a8b52468c8f3$export$a7e4a2aeaa52eeb0);

var $hprFm = parcelRequire("hprFm");
const $2ac6a8b52468c8f3$export$a7e4a2aeaa52eeb0 = (formStoreState)=>({ setState: setState })=>{
        setState({
            selectedFormStoreState: formStoreState,
            formViewMode: (0, $hprFm.FormViewMode).View
        });
    };

});

parcelRegister("1n126", function(module, exports) {

$parcel$export(module.exports, "submitForm", () => $0ff8bd88b238d340$export$e02251cfbe407ee6);
const $0ff8bd88b238d340$export$e02251cfbe407ee6 = (formId, submitLock)=>async (_, { api: api })=>api.submitForm(formId, submitLock);

});

parcelRegister("hQd8D", function(module, exports) {

$parcel$export(module.exports, "updateFormStatus", () => $cfd17bfc81e2deed$export$17feae27841bb594);
const $cfd17bfc81e2deed$export$17feae27841bb594 = (formId, formStatus)=>({ setState: setState, getState: getState })=>{
        const selectedFormIndex = getState().formIndex.find((formIndexItem)=>formIndexItem.id === formId);
        if (selectedFormIndex) {
            const updatedFormIndex = getState().formIndex.map((formIndexItem)=>{
                if (formIndexItem.id !== selectedFormIndex.id) return formIndexItem;
                return {
                    ...formIndexItem,
                    status: formStatus
                };
            });
            setState({
                formIndex: updatedFormIndex
            });
        }
    };

});

parcelRegister("aCyn5", function(module, exports) {

$parcel$export(module.exports, "updateFormVisibility", () => $7bb81d71920edcc5$export$e8a15adde8b1436c);
const $7bb81d71920edcc5$export$e8a15adde8b1436c = (formId, toInternal)=>async ({ getState: getState, setState: setState }, { api: api })=>{
        const { permissions: permissions } = getState();
        if (!permissions.toggleAccess) return Promise.reject(new Error('no toggle access permission'));
        await api.updateFormVisibility(formId, toInternal);
        setState({
            formIndex: getState().formIndex.map((formIndexItem)=>{
                if (formIndexItem.id !== formId) return formIndexItem;
                return {
                    ...formIndexItem,
                    internal: toInternal
                };
            })
        });
    };

});


parcelRegister("4JE17", function(module, exports) {

$parcel$export(module.exports, "getSelectedFormStoreState", () => $372a67f535fb3269$export$5f5dccdff38a1b8a);
const $372a67f535fb3269$export$5f5dccdff38a1b8a = (state)=>{
    var _state$selectedFormSt, _state$selectedFormSt2, _state$selectedFormSt3, _state$selectedFormSt4;
    return {
        selectedFormStore: (_state$selectedFormSt = state.selectedFormStoreState) === null || _state$selectedFormSt === void 0 ? void 0 : _state$selectedFormSt.data,
        loading: (_state$selectedFormSt2 = (_state$selectedFormSt3 = state.selectedFormStoreState) === null || _state$selectedFormSt3 === void 0 ? void 0 : _state$selectedFormSt3.loading) !== null && _state$selectedFormSt2 !== void 0 ? _state$selectedFormSt2 : false,
        error: (_state$selectedFormSt4 = state.selectedFormStoreState) === null || _state$selectedFormSt4 === void 0 ? void 0 : _state$selectedFormSt4.error
    };
};

});


parcelRegister("bV8dQ", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $8adb655be51f0bfa$export$1b581a2ec13e37f1);

var $5uXOq = parcelRequire("5uXOq");

var $jblqj = parcelRequire("jblqj");

const $8adb655be51f0bfa$export$1b581a2ec13e37f1 = ({ children: children, channel: channel })=>{
    const sendEvent = (0, $5uXOq.useCallback)((event)=>{
        var _event$clone;
        // For backwards compatibility with analytics listeners in the product
        // which attempt to determine the actionSubject and attributes
        // from the context.
        const { actionSubject: actionSubject, attributes: attributes } = event.payload;
        const context = {};
        if (actionSubject) {
            context.component = actionSubject;
            context.componentName = actionSubject;
        }
        if (attributes) context.attributes = attributes;
        event.context.push(context);
        (_event$clone = event.clone()) === null || _event$clone === void 0 || _event$clone.fire(channel);
    }, [
        channel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jblqj.default), {
        channel: (0, $d253eab4f2dd6d94$export$2ceccf177fae277c),
        onEvent: sendEvent
    }, children);
};

});

parcelRegister("6U2FW", function(module, exports) {

$parcel$export(module.exports, "useShowNotice", () => $506a0c54f50374db$export$6935f0f6f663b91f);
$parcel$export(module.exports, "NoticeProvider", () => $506a0c54f50374db$export$a9b49e4ddf9e18db);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $hordk = parcelRequire("hordk");
var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");
const $506a0c54f50374db$var$ShowNoticeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $506a0c54f50374db$export$6935f0f6f663b91f = ()=>{
    const noticeApi = (0, $5uXOq.useContext)($506a0c54f50374db$var$ShowNoticeContext);
    if (!noticeApi) throw Error('Hook must be used in a NoticeProvider');
    return noticeApi;
};
const $506a0c54f50374db$export$a9b49e4ddf9e18db = ({ children: children })=>{
    const [notice, setNotice] = (0, $5uXOq.useState)();
    const onCloseHandler = ()=>{
        setNotice(undefined);
        if (notice && notice.onCloseHandler) notice.onCloseHandler();
    };
    const onConfirmHandler = ()=>{
        setNotice(undefined);
        if (notice && notice.onConfirmHandler) notice.onConfirmHandler();
    };
    const noticeApi = (0, $5uXOq.useMemo)(()=>({
            showNotice: (props)=>{
                setNotice(props);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($506a0c54f50374db$var$ShowNoticeContext.Provider, {
        value: noticeApi
    }, children), notice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($506a0c54f50374db$export$71802e30fd294f61, (0, $bS32t.default)({}, notice, {
        onCloseHandler: onCloseHandler,
        onConfirmHandler: onConfirmHandler
    })));
};
const $506a0c54f50374db$export$71802e30fd294f61 = ({ appearance: appearance, title: title, body: body, closeText: closeText, onCloseHandler: onCloseHandler, confirmText: confirmText, onConfirmHandler: onConfirmHandler })=>{
    const actions = [];
    const primaryButtonAppearance = appearance || 'primary';
    if (confirmText && onConfirmHandler) {
        actions.push({
            key: 'pf-notice-secondary-button',
            appearance: 'subtle',
            onClick: onCloseHandler,
            text: closeText
        });
        actions.push({
            key: 'pf-notice-primary-button',
            appearance: primaryButtonAppearance,
            onClick: onConfirmHandler,
            text: confirmText,
            testId: 'show-notice-confirm-btn'
        });
    } else actions.push({
        key: 'pf-notice-primary-button',
        appearance: primaryButtonAppearance,
        onClick: onCloseHandler,
        text: closeText,
        testId: 'show-notice-close-btn'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hordk.default), {
        shouldCloseOnOverlayClick: false,
        onClose: onCloseHandler,
        testId: "show-notice-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUaFh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Sb4G.default), {
        appearance: appearance
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1QfP.default), null, body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CjwE.default), null, actions.map(({ key: key, text: text, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), (0, $bS32t.default)({
            key: key
        }, props), text))));
};

});

parcelRegister("y7oWF", function(module, exports) {

$parcel$export(module.exports, "LiveIssueViewFormApi", () => $7036cc4bf76fc626$export$835c0153b2386f5f);

var $4R6GH = parcelRequire("4R6GH");

var $4aJmI = parcelRequire("4aJmI");

var $5aQYy = parcelRequire("5aQYy");

var $a1RLT = parcelRequire("a1RLT");
class $7036cc4bf76fc626$export$835c0153b2386f5f {
    constructor(util, projectId, issueId){
        this.util = util;
        this.projectId = projectId;
        this.issueId = issueId;
    }
    getFormIndex(issueId) {
        return this.util.get(`/api/3/issue/${issueId}/formindex`);
    }
    getForm(formId) {
        return this.util.get(`/api/3/issue/${this.issueId}/form/${formId}`);
    }
    submitForm(issueId, formId, lock) {
        return this.util.put(`/api/3/issue/${issueId}/form/${formId}/${lock ? 'lock' : 'submit'}`, {});
    }
    reopenForm(issueId, formId, formStatus) {
        if (formStatus === (0, $4aJmI.FormStatus).Locked) return this.util.put(`/api/3/issue/${issueId}/form/${formId}/unlock`, {});
        return this.util.put(`/api/3/issue/${issueId}/form/${formId}/reopen`, {});
    }
    getFormChoices(formId) {
        return this.util.get(`/api/3/issue/${this.issueId}/form/${formId}/formchoices?allowSubmittedForm=true`);
    }
    postFieldData(formId, request) {
        return this.util.post(`/api/cloud/issue/${this.issueId}/form/${formId}/fielddata`, request);
    }
    searchUsers(jiraField, query) {
        if (jiraField === 'assignee') return this.util.jiraGet(`/rest/api/3/user/assignable/search?project=${this.projectId}&query=${encodeURIComponent(query)}`).then((data)=>data.map((user)=>({
                    value: user.accountId,
                    label: user.displayName ?? ''
                })));
        return this.util.jiraGet(`/rest/api/3/user/picker?query=${encodeURIComponent(query)}`).then((data)=>data.users.map((user)=>({
                    value: user.accountId,
                    label: user.displayName ?? ''
                })));
    }
    searchUsersWithFieldConfig(jiraField, fieldConfigId, projectId, query) {
        if (jiraField === 'assignee') return this.util.jiraGet(`/rest/api/3/user/assignable/search?project=${this.projectId}&query=${encodeURIComponent(query)}`).then((data)=>data.map((user)=>({
                    value: user.accountId,
                    label: user.displayName ?? ''
                })));
        if (jiraField && fieldConfigId) return this.util.jiraGet(`/rest/api/1.0/users/picker?fieldName=${jiraField}&fieldConfigId=${fieldConfigId}&projectId=${projectId}&showAvatar=true&query=${encodeURIComponent(query)}`).then((data)=>data.users.map((user)=>({
                    value: user.accountId,
                    label: user.displayName ?? ''
                })));
        return this.util.jiraGet(`/rest/api/3/user/picker?query=${encodeURIComponent(query)}`).then((data)=>data.users.map((user)=>({
                    value: user.accountId,
                    label: user.displayName ?? ''
                })));
    }
    searchLabels(issueId, jiraField, query) {
        let uri = '';
        const isCustomLabelsField = jiraField.startsWith('customfield_');
        if (isCustomLabelsField) {
            const customFieldId = jiraField?.split('_')[1];
            uri = `/rest/api/1.0/labels/${issueId}/suggest?customFieldId=${customFieldId}&query=${query || ''}`;
        } else uri = `/rest/api/1.0/labels/${issueId}/suggest?query=${query || ''}`;
        return this.util.jiraGet(uri).then((data)=>data.suggestions.map((jiraLabel)=>({
                    value: jiraLabel.label,
                    label: jiraLabel.label
                })))// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((e)=>{
            // eslint-disable-next-line no-console
            console.warn(e);
            throw e;
        });
    }
    searchAffectedServices(query) {
        const uri = `/rest/service-registry-api/service?query=${query ?? ''}`;
        return this.util.jiraGet(uri).then((data)=>data.services.map((affectedService)=>({
                    value: affectedService.id,
                    label: affectedService.name
                })))// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((e)=>{
            // eslint-disable-next-line no-console
            console.warn(e);
            throw e;
        });
    }
    searchCmdb(jiraField, query, issueId, issueFormId, fieldConfigId, fieldValueMap) {
        const uri = `/rest/servicedesk/cmdb/1/proforma/field/${jiraField}/config/${fieldConfigId}/autocomplete`;
        return this.util.jiraPost(uri, {
            query: query,
            issueId: issueId,
            issueFormId: issueFormId,
            fieldValueMap: fieldValueMap
        }, 'cmdbAutocomplete').then((data)=>data.results.map((cmdbObject)=>({
                    value: cmdbObject.id,
                    label: cmdbObject.label,
                    ...(0, $4R6GH.fg)('proforma_asset_fields_show_selected_attributes') ? {
                        cmdbObject: cmdbObject
                    } : {}
                })));
    }
    findAvailableFormsForIssue(issueId) {
        return this.util.get(`/api/1/issues/${issueId}/availableforms`);
    }
    getFormPreview(issueId, templateFormId) {
        return this.util.get(`/api/2/issues/${issueId}/availableforms/${templateFormId}/preview`).then((templateForm)=>(0, $5aQYy.convertTemplateFormToUnsavedForm)(templateForm));
    }
    addForm(issueId, templateFormId) {
        return this.util.post(`/api/2/issues/${issueId}/forms`, {
            templateFormId: templateFormId
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    deleteForm(issueId, formId) {
        return this.util.delete(`/api/1/issues/${issueId}/forms/${formId}`);
    }
    updateFormVisibility(issueId, formId, isInternal) {
        return this.util.post(`/api/2/issues/${issueId}/forms/${formId}`, {
            visibility: isInternal ? (0, $4aJmI.FormVisibility).Internal : (0, $4aJmI.FormVisibility).External
        });
    }
    saveAnswers(issueId, formId, answers) {
        return this.util.put(`/api/2/issues/${issueId}/forms/${formId}`, answers);
    }
    // User properties - for onboarding
    getUserProperty(propertyKey, accountId) {
        return this.util.jiraGet(`/rest/api/latest/user/properties/${propertyKey}?accountId=${accountId}`, 'userPropertyOnboarding');
    }
    setUserProperty(propertyKey, accountId, hasSeen) {
        return this.util.jiraPut(`/rest/api/latest/user/properties/${propertyKey}?accountId=${accountId}`, hasSeen, 'userPropertyOnboarding');
    }
    getPdfDownloadUrl(issueid, formId) {
        return `/api/1/issues/${issueid}/forms/${formId}/pdf`;
    }
    getXlsxDownloadUrl(issueid, formId) {
        return `/api/1/issues/${issueid}/forms/${formId}/spreadsheet`;
    }
    get(path, requestName, responseType = (0, $a1RLT.AcceptedResponseType).Json) {
        return this.util.get(path, requestName, responseType);
    }
}

});
parcelRegister("4aJmI", function(module, exports) {

$parcel$export(module.exports, "defaultFormPublishing", () => $309b493b4ac9e842$export$ff4a00b513452bc5);
$parcel$export(module.exports, "isShowCondition", () => $309b493b4ac9e842$export$c385a29f77656020);
$parcel$export(module.exports, "FormConditionType", () => $309b493b4ac9e842$export$943ba666dd740a86);
$parcel$export(module.exports, "FormAnswerEmpty", () => $309b493b4ac9e842$export$f1c794d8fb489e8c);
$parcel$export(module.exports, "FormVisibility", () => $309b493b4ac9e842$export$c501a2032cd34718);
$parcel$export(module.exports, "FormStatus", () => $309b493b4ac9e842$export$fc8a1cc6d4fd1a88);
$parcel$export(module.exports, "FormSectionType", () => $309b493b4ac9e842$export$d636d1a763e6b20b);
$parcel$export(module.exports, "FormQuestionType", () => $309b493b4ac9e842$export$5fcf8ca5ea137df2);
/**
 * A ProForma form with everything: supports all features in ProForma.
 */ /**
 * A ProForma form that cannot be filled out.  It serves as a template for forms that can be filled out, and is typically
 * copied onto Jira issues where it can be filled out.
 */ /**
 * A ProForma form that can be previewed.
 */ /**
 * A ProForma form that can be filled out.
 */ /**
 * Configures how this form is published (if it is published somewhere).
 * Used only on template forms, not available on forms.
 */ /**
 * Configures how this form is published within Jira.
 * Used only on template forms, not available on forms.
 */ /**
 * Configures how this form is published on the Jira Service Desk portal.
 * Used only on template forms, not available on forms.
 */ const $309b493b4ac9e842$export$ff4a00b513452bc5 = {
    submitOnCreate: true,
    validateOnCreate: true
};
function $309b493b4ac9e842$export$c385a29f77656020(c) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return c.t === $309b493b4ac9e842$export$943ba666dd740a86.Show;
}
const $309b493b4ac9e842$export$f1c794d8fb489e8c = {};
let $309b493b4ac9e842$export$c501a2032cd34718 = /*#__PURE__*/ function(FormVisibility) {
    /**
   * Internal form: in the context of Jira Service Desk this means the form only appears inside Jira and not on the Jira Service Desk portal.
   * In other contexts like template forms and Jira Software the meaning is undefined.
   */ FormVisibility["Internal"] = "i";
    /**
   * External form: in the context of Jira Service Desk this means the form appears both in Jira and on the Jira Service Desk portal.
   * In other contexts like template forms and Jira Software the meaning is undefined.
   */ FormVisibility["External"] = "e";
    return FormVisibility;
}({});
let $309b493b4ac9e842$export$fc8a1cc6d4fd1a88 = /*#__PURE__*/ function(FormStatus) {
    FormStatus["Open"] = "o";
    FormStatus["Submitted"] = "s";
    FormStatus["Locked"] = "l";
    return FormStatus;
}({});
let $309b493b4ac9e842$export$943ba666dd740a86 = /*#__PURE__*/ function(FormConditionType) {
    FormConditionType["Show"] = "sh";
    return FormConditionType;
}({});
let $309b493b4ac9e842$export$d636d1a763e6b20b = /*#__PURE__*/ function(FormSectionType) {
    FormSectionType["Block"] = "b";
    FormSectionType["Page"] = "p";
    return FormSectionType;
}({});
let $309b493b4ac9e842$export$5fcf8ca5ea137df2 = /*#__PURE__*/ function(FormQuestionType) {
    FormQuestionType["Attachment"] = "at";
    FormQuestionType["ChoiceCascading"] = "cc";
    FormQuestionType["ChoiceDropdown"] = "cd";
    FormQuestionType["ChoiceDropdownMultiple"] = "cl";
    FormQuestionType["ChoiceMultiple"] = "cm";
    FormQuestionType["ChoiceSingle"] = "cs";
    FormQuestionType["CmdbObject"] = "ob";
    FormQuestionType["Date"] = "da";
    FormQuestionType["DateTime"] = "dt";
    FormQuestionType["Number"] = "no";
    FormQuestionType["TextEmail"] = "te";
    FormQuestionType["TextLong"] = "tl";
    FormQuestionType["TextParagraph"] = "pg";
    FormQuestionType["RichTextParagraph"] = "rt";
    FormQuestionType["TextShort"] = "ts";
    FormQuestionType["TextUrl"] = "tu";
    FormQuestionType["Time"] = "ti";
    FormQuestionType["UserMultiple"] = "um";
    FormQuestionType["UserSingle"] = "us";
    return FormQuestionType;
}({});

});

parcelRegister("5aQYy", function(module, exports) {

$parcel$export(module.exports, "convertTemplateFormToUnsavedForm", () => $3c46fac54e6c7429$export$336bdbb8f937b813);

var $4aJmI = parcelRequire("4aJmI");
function $3c46fac54e6c7429$export$336bdbb8f937b813(templateForm) {
    const convertedForm = {
        id: undefined,
        updated: templateForm.updated,
        design: templateForm.design,
        ...templateForm.publish && {
            publish: templateForm.publish
        },
        state: $3c46fac54e6c7429$var$createStateFromTemplateForm(templateForm)
    };
    return convertedForm;
}
function $3c46fac54e6c7429$var$createStateFromTemplateForm(templateForm) {
    return {
        visibility: (0, $4aJmI.FormVisibility).Internal,
        status: (0, $4aJmI.FormStatus).Open,
        answers: $3c46fac54e6c7429$var$populateDefaultAnswers(templateForm.design.questions)
    };
}
function $3c46fac54e6c7429$var$populateDefaultAnswers(questions) {
    const formAnswers = {};
    Object.keys(questions).forEach((key)=>{
        const question = questions[key];
        if (question.defaultAnswer) formAnswers[key] = question.defaultAnswer;
    });
    return formAnswers;
}

});


parcelRegister("4Ihci", function(module, exports) {

$parcel$export(module.exports, "IssueViewFormApiProvider", () => $d572b37401094625$export$eaa79ed4bbfbc1b4);
$parcel$export(module.exports, "useIssueViewFormApi", () => $d572b37401094625$export$48a1f3b59205c05a);

var $5uXOq = parcelRequire("5uXOq");
const $d572b37401094625$var$IssueViewFormApiContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $d572b37401094625$export$eaa79ed4bbfbc1b4 = ({ children: children, api: api })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d572b37401094625$var$IssueViewFormApiContext.Provider, {
        value: api
    }, children);
const $d572b37401094625$export$48a1f3b59205c05a = ()=>{
    const api = (0, $5uXOq.useContext)($d572b37401094625$var$IssueViewFormApiContext);
    if (!api) throw new Error('useIssueViewFormApi must be used within a IssueViewFormApiProvider');
    return api;
};

});

parcelRegister("3PJX6", function(module, exports) {

$parcel$export(module.exports, "readOnlyPermissions", () => $d2d8c931f8832585$export$77f9577742025360);
$parcel$export(module.exports, "editPermissions", () => $d2d8c931f8832585$export$94589b185237449);
$parcel$export(module.exports, "adminPermissions", () => $d2d8c931f8832585$export$b1c204fae4cc4fe9);
$parcel$export(module.exports, "FORM_RESTRICTION_URL", () => $d2d8c931f8832585$export$5433776cac94f4b5);
const $d2d8c931f8832585$export$77f9577742025360 = {
    download: true
};
const $d2d8c931f8832585$export$94589b185237449 = {
    ...$d2d8c931f8832585$export$77f9577742025360,
    save: true,
    submit: true,
    reopen: true,
    delete: true,
    toggleAccess: true,
    addForm: true
};
const $d2d8c931f8832585$export$b1c204fae4cc4fe9 = {
    ...$d2d8c931f8832585$export$94589b185237449,
    unlock: true
};
const $d2d8c931f8832585$export$5433776cac94f4b5 = 'https://support.atlassian.com/jira-service-management-cloud/docs/restrict-who-can-view-forms/';

});

parcelRegister("e4820", function(module, exports) {

$parcel$export(module.exports, "IssueViewStore", () => $83dd7f6643fc7546$export$36291e3faf86fff0);

var $imEoS = parcelRequire("imEoS");

var $ctPpG = parcelRequire("ctPpG");
var $iPJqX = parcelRequire("iPJqX");

var $3G30a = parcelRequire("3G30a");
var $c66GK = parcelRequire("c66GK");
var $ln9gy = parcelRequire("ln9gy");

var $hlh9r = parcelRequire("hlh9r");
class $83dd7f6643fc7546$export$36291e3faf86fff0 {
    constructor(intl, moduleContext, projectId, issueKey, issueId, createAnalyticsEvent, clearFormSaveErrors, editModeCallback, showFlag){
        this.intl = intl;
        this.clearFormSaveErrors = clearFormSaveErrors;
        this.searchUsers = (jiraField, query)=>this.issueViewFormApi.searchUsers(jiraField, query);
        this.searchUsersWithFieldConfig = (jiraField, fieldConfigId, query)=>this.issueViewFormApi.searchUsersWithFieldConfig(jiraField, fieldConfigId, this.projectId, query);
        this.callAddForm = async (templateFormId)=>this.issueViewFormApi.addForm(this.issueId, templateFormId);
        this.loadFormStore = async (formId)=>{
            try {
                return this.issueViewFormApi.getForm(formId).then((form)=>this.createFormStore(form));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                this.errorUtils.reportError(error, {
                    id: 'loadFormStore',
                    attributes: {
                        formId: formId
                    }
                });
                return Promise.reject(error);
            }
        };
        this.createFormStore = (form)=>new (0, $imEoS.FormStore)(this.intl, this.createAnalyticsEvent, this._loadFieldDataFn(form.id).bind(this), this._loadChoicesFn.bind(this), this._loadChoicesAsyncFn.bind(this), this.searchUsers.bind(this), this.searchUsersWithFieldConfig.bind(this), form, false);
        this.issueKey = issueKey;
        this.issueId = issueId;
        this.projectId = projectId;
        this.editModeCallback = editModeCallback;
        this._loadFieldDataFn = (formId)=>(0, $ln9gy.loadFieldDataFn)((request)=>formId && moduleContext.apis.issueViewFormApi.postFieldData(formId, request) || Promise.resolve({}), moduleContext.utils.errorUtils);
        this._loadChoicesFn = (0, $c66GK.loadChoicesFn)((templateFormId, formId)=>formId && this.issueViewFormApi.getFormChoices(formId) || Promise.reject(), moduleContext.utils.errorUtils, true, createAnalyticsEvent);
        this._loadChoicesAsyncFn = (0, $3G30a.loadChoicesAsyncFn)({
            custom: {
                [(0, $ctPpG.AFFECTED_SERVICES_SCHEMA_CUSTOM)]: {
                    searchOptionsFn: (_, query)=>moduleContext.apis.issueViewFormApi.searchAffectedServices(query)
                },
                [(0, $ctPpG.CMDB_SCHEMA_CUSTOM)]: {
                    searchOptionsFn: (jiraField, query, issueFieldData, form)=>form && form.formId && issueFieldData?.fieldConfigId && moduleContext.apis.issueViewFormApi.searchCmdb(jiraField, query, this.issueId, form.formId, issueFieldData.fieldConfigId, (0, $iPJqX.getCmdbFieldValueMap)(form)) || Promise.resolve([]),
                    onSearchError: ({ status: status })=>{
                        if (status === 400) return {
                            title: intl.formatMessage((0, $hlh9r.messages).objectSearchErrorTitle),
                            description: intl.formatMessage((0, $hlh9r.messages).objectSearchErrorDescription)
                        };
                    }
                },
                [(0, $ctPpG.LABELS_SCHEMA_CUSTOM)]: {
                    searchOptionsFn: (jiraField, query)=>!query.includes(' ') && moduleContext.apis.issueViewFormApi.searchLabels(issueId, jiraField, query) || Promise.resolve([])
                }
            },
            system: {
                [(0, $ctPpG.LABELS_SCHEMA_SYSTEM)]: {
                    searchOptionsFn: (jiraField, query)=>!query.includes(' ') && moduleContext.apis.issueViewFormApi.searchLabels(issueId, jiraField, query) || Promise.resolve([])
                }
            }
        }, moduleContext.utils.errorUtils, createAnalyticsEvent, showFlag);
        this.issueViewFormApi = moduleContext.apis.issueViewFormApi;
        this.errorUtils = moduleContext.utils.errorUtils;
        this.permissions = moduleContext.permissions;
        this.createAnalyticsEvent = createAnalyticsEvent;
    }
}

});
parcelRegister("imEoS", function(module, exports) {

$parcel$export(module.exports, "FormStore", () => $d5e99eb3f1ac4fc8$export$75ff1ab1187e691);

var $9kzTP = parcelRequire("9kzTP");

var $7Jkpx = parcelRequire("7Jkpx");
parcelRequire("cTQjS");

var $alnGD = parcelRequire("alnGD");

var $97iZx = parcelRequire("97iZx");

var $4aJmI = parcelRequire("4aJmI");

var $chyFx = parcelRequire("chyFx");

var $4QmvR = parcelRequire("4QmvR");
var $d5e99eb3f1ac4fc8$var$_class, $d5e99eb3f1ac4fc8$var$_descriptor, $d5e99eb3f1ac4fc8$var$_descriptor2, $d5e99eb3f1ac4fc8$var$_descriptor3, $d5e99eb3f1ac4fc8$var$_descriptor4, $d5e99eb3f1ac4fc8$var$_descriptor5, $d5e99eb3f1ac4fc8$var$_descriptor6, $d5e99eb3f1ac4fc8$var$_descriptor7, $d5e99eb3f1ac4fc8$var$_descriptor8, $d5e99eb3f1ac4fc8$var$_descriptor9, $d5e99eb3f1ac4fc8$var$_descriptor10, $d5e99eb3f1ac4fc8$var$_descriptor11, $d5e99eb3f1ac4fc8$var$_descriptor12;
let $d5e99eb3f1ac4fc8$export$75ff1ab1187e691 = ($d5e99eb3f1ac4fc8$var$_class = class FormStore {
    /**
   * Creates a new form store.
   *
   * @param intl The `intl` instance to pass to the `QuestionStore`s
   * @param createAnalyticsEvent The function to create an analytics event so it can be fired
   * @param loadFieldDataFn The function to generate the function to load the field data
   * @param loadChoicesFn The function to generate the function to load the form choices
   * @param loadChoicesAsyncFn The function to generate the function to load form choices async
   * @param searchUsers The function to search for users
   * @param searchUsersWithFieldConfig The function to search for users
   * @param form The form to populate the store with
   * @param populateDefaultValueOnEmptySearch For fields that support it (e.g. CMDB), whether to populate the field with a default value retrieved on an empty search query.
   * @param issueKey The key of the current issue, if known
   * @param jiraFieldMap The map of Jira fields (only used in the Form Builder)
   * @param onFieldChange optional callback function that is passed down to the QuestionStore on the portal create screen and is run when a question's answer changes
   * @param onFieldDirty optional callback function that is passed down to the QuestionStore on the portal create screen
   * and is run when a form is considered dirty. It has different behaviour to onFieldChange.
   */ constructor(intl, createAnalyticsEvent, loadFieldDataFn, loadChoicesFn, loadChoicesAsyncFn, searchUsers, searchUsersWithFieldConfig, _form, populateDefaultValueOnEmptySearch, issueKey, jiraFieldMap, onFieldChange, onFieldDirty){
        var _form$publish, _form$publish2;
        this.formId = void 0;
        this.issueKey = void 0;
        (0, $9kzTP.default)(this, "savingAnswers", $d5e99eb3f1ac4fc8$var$_descriptor, this);
        (0, $9kzTP.default)(this, "submittingForm", $d5e99eb3f1ac4fc8$var$_descriptor2, this);
        this.templateFormId = void 0;
        this.templateFormUuid = void 0;
        this.formName = void 0;
        this.language = void 0;
        (0, $9kzTP.default)(this, "updated", $d5e99eb3f1ac4fc8$var$_descriptor3, this);
        (0, $9kzTP.default)(this, "status", $d5e99eb3f1ac4fc8$var$_descriptor4, this);
        this.submitLock = void 0;
        this.submitPdf = void 0;
        (0, $9kzTP.default)(this, "questions", $d5e99eb3f1ac4fc8$var$_descriptor5, this);
        this.layout = void 0;
        (0, $9kzTP.default)(this, "internal", $d5e99eb3f1ac4fc8$var$_descriptor6, this);
        this.conditions = void 0;
        this.sections = void 0;
        (0, $9kzTP.default)(this, "invalid", $d5e99eb3f1ac4fc8$var$_descriptor7, this);
        this.createOpen = void 0;
        this.validateOnCreate = void 0;
        this.portalCanSubmit = void 0;
        this.analyticsAttributes = void 0;
        this.prevVisibleSections = void 0;
        this.primaryLocale = void 0;
        this.translatedLocale = void 0;
        this.loadFieldData = void 0;
        this.loadChoices = void 0;
        this.loadChoicesAsync = void 0;
        this.searchUsers = void 0;
        this.searchUsersWithFieldConfig = void 0;
        (0, $9kzTP.default)(this, "attachQuestionsToSections", $d5e99eb3f1ac4fc8$var$_descriptor8, this);
        this.getQuestionIdsFromSectionContent = (sectionContent)=>{
            return (0, $97iZx.filter)(sectionContent, (node)=>{
                if (!node.attrs || !node.attrs.parameters || !node.attrs.parameters.id) return false;
                return node.attrs.extensionKey === 'question';
            }).map((node)=>node.attrs.parameters.id.toString());
        };
        (0, $9kzTP.default)(this, "update", $d5e99eb3f1ac4fc8$var$_descriptor9, this);
        this._update = (constructing, form, refreshChoices = false)=>{
            this.updated = form.updated;
            this.status = form.state.status;
            this.internal = form.state.visibility === (0, $4aJmI.FormVisibility).Internal;
            if (!constructing) {
                this.invalid = false;
                this.questions.forEach((question)=>{
                    const questionKey = question.id.toString();
                    const formQuestion = {
                        ...form.design.questions[questionKey],
                        choices: question.choices // Retain the current choices.
                    };
                    question.update(formQuestion, form.state.answers[questionKey]);
                });
                if (!refreshChoices) return this.loadFieldData().then(()=>this.afterUpdate());
            }
            return Promise.all([
                this.loadFieldData(),
                this.loadChoices()
            ]).then(()=>this.afterUpdate());
        };
        this.validate = ()=>{
            const visibleQuestions = this.questions.filter((question)=>!this.hiddenQuestions.includes(question.id.toString()));
            // Validate each question
            let allQuestionsValid = true;
            visibleQuestions.forEach((questionStore)=>{
                // activate validations on question
                questionStore.validate();
                if (!!questionStore.validationErrors) allQuestionsValid = false;
            });
            (0, $alnGD.runInAction)(()=>{
                this.invalid = !allQuestionsValid;
            });
        };
        (0, $9kzTP.default)(this, "hideValidations", $d5e99eb3f1ac4fc8$var$_descriptor10, this);
        (0, $9kzTP.default)(this, "discardModifiedAnswers", $d5e99eb3f1ac4fc8$var$_descriptor11, this);
        (0, $9kzTP.default)(this, "onFieldChange", $d5e99eb3f1ac4fc8$var$_descriptor12, this);
        this.formId = _form.id;
        this.issueKey = issueKey;
        const formSettings = _form.design.settings;
        this.templateFormId = formSettings.templateId;
        this.templateFormUuid = formSettings.templateFormUuid;
        this.formName = formSettings.name;
        this.language = formSettings.language;
        this.submitLock = formSettings.submit.lock;
        this.submitPdf = formSettings.submit.pdf;
        this.createOpen = ((_form$publish = _form.publish) === null || _form$publish === void 0 ? void 0 : _form$publish.portal) !== undefined && !_form.publish.portal.submitOnCreate;
        this.validateOnCreate = !this.createOpen || ((_form$publish2 = _form.publish) === null || _form$publish2 === void 0 ? void 0 : _form$publish2.portal) !== undefined && _form.publish.portal.validateOnCreate;
        this.portalCanSubmit = !formSettings.portal || formSettings.portal.canSubmit;
        this.conditions = _form.design.conditions;
        this.layout = _form.design.layout;
        this.sections = {
            ..._form.design.sections
        };
        this.attachQuestionsToSections();
        this.analyticsAttributes = {
            ...(0, $chyFx.getFormAnalyticsAttributes)(_form),
            formId: this.formId,
            templateFormId: this.templateFormId
        };
        this.primaryLocale = formSettings.primaryLocale;
        this.translatedLocale = formSettings.translatedLocale;
        if (_form.design.questions) this.questions = Object.keys(_form.design.questions).map((questionKey)=>{
            const formQuestion = _form.design.questions[questionKey];
            return new (0, $4QmvR.QuestionStore)(intl, questionKey, formQuestion, (query)=>loadChoicesAsyncFn(this)(parseInt(questionKey, 10), query), (fieldMeta, value)=>{
                this.onFieldChange(fieldMeta.jiraField);
                onFieldChange === null || onFieldChange === void 0 || onFieldChange(fieldMeta, value);
            }, populateDefaultValueOnEmptySearch, _form.state.answers[questionKey], onFieldDirty);
        });
        else this.questions = [];
        this.loadFieldData = loadFieldDataFn(this);
        this.loadChoices = loadChoicesFn(this);
        this.loadChoicesAsync = loadChoicesAsyncFn(this);
        this.searchUsers = searchUsers;
        this.searchUsersWithFieldConfig = searchUsersWithFieldConfig;
        this._update(true, _form);
    }
    get formIsBlank() {
        if (!this.layout) return true;
        return this.layout.every((subLayout)=>subLayout.content.length === 0);
    }
    get answersModified() {
        for (const questionStore of this.questions){
            if (questionStore.answerModified) return true;
        }
        return false;
    }
    get satisfiedConditions() {
        if (!this.conditions) return [];
        const satisfiedConditions = [];
        Object.keys(this.conditions).forEach((conditionKey)=>{
            // @ts-ignore
            const condition = this.conditions[conditionKey];
            if (this.conditionIsSatisfied(condition)) satisfiedConditions.push(conditionKey);
        });
        return satisfiedConditions;
    }
    conditionIsSatisfied(condition) {
        // Currently this code only supports conditions with 'choice - one of' inputs
        if (condition.i.co) // Currently this code only supports one input per condition, because it returns from the first iteration of this loop
        for(const conditionQuestionId in condition.i.co.cIds){
            const trackedQuestion = this.questions.find((question)=>`${question.id}` === conditionQuestionId);
            const currentAnswer = (0, $4QmvR.toChoiceQuestionAnswer)(trackedQuestion === null || trackedQuestion === void 0 ? void 0 : trackedQuestion.currentAnswer);
            if (!(currentAnswer !== null && currentAnswer !== void 0 && currentAnswer.choices)) return false;
            const conditionInput = condition.i.co.cIds[conditionQuestionId];
            return currentAnswer.choices.some((choice)=>conditionInput.includes(choice) || conditionInput.includes(choice.split(':')[0]));
        }
        return false;
    }
    get visibleSections() {
        if (!this.sections) return [
            '0'
        ];
        const { satisfiedConditions: satisfiedConditions } = this;
        const visibleSections = [
            '0'
        ];
        Object.keys(this.sections).forEach((sectionKey)=>{
            const section = this.sections[sectionKey];
            if (!section.conditions) visibleSections.push(sectionKey);
            if (section.conditions && section.conditions.every((condition)=>satisfiedConditions.includes(condition))) visibleSections.push(sectionKey);
        });
        return visibleSections;
    }
    get hiddenQuestions() {
        if (!this.sections) return this.questions.map((question)=>question.id.toString());
        const hiddenSections = [];
        Object.keys(this.sections).forEach((sectionKey)=>{
            if (!this.visibleSections.includes(sectionKey)) hiddenSections.push(this.sections[sectionKey]);
        });
        return this.questions.filter((question)=>{
            return hiddenSections.some((hiddenSection)=>hiddenSection.questions && hiddenSection.questions.includes(question.id.toString()));
        }).map((question)=>question.id.toString());
    }
    get visibleQuestions() {
        return this.questions.filter((question)=>!this.hiddenQuestions.includes(question.id.toString()));
    }
    get isUploadingMedia() {
        for (const questionStore of this.questions){
            if (questionStore.isUploadingMedia) return true;
        }
        return false;
    }
    get hasAttachmentField() {
        for (const questionStore of this.questions){
            if (questionStore.formQuestion.type === (0, $4aJmI.FormQuestionType).Attachment) return true;
        }
        return false;
    }
    get numberOfAttachment() {
        let size = 0;
        for (const questionStore of this.questions)if (questionStore.formQuestion.type === (0, $4aJmI.FormQuestionType).Attachment) {
            const attachments = questionStore.currentAnswer;
            size += attachments.length;
        }
        return size;
    }
    get attachmentIds() {
        const attachmentIds = new Set();
        for (const questionStore of this.questions)if (questionStore.formQuestion.type === (0, $4aJmI.FormQuestionType).Attachment) {
            const attachments = questionStore.answer ? questionStore.answer : [];
            attachments.forEach((attachment)=>attachmentIds.add(attachment.id));
        }
        return attachmentIds;
    }
    afterUpdate() {
        this.prevVisibleSections = this.visibleSections;
        this.visibleQuestions.forEach((question)=>question.doPopulateDefaultValueOnEmptySearch());
    }
    getNewlyVisibleQuestions() {
        if (!this.prevVisibleSections) // Don't calculate any questions as becoming newly visible until the form is loaded fully and this field is set.
        return [];
        const newlyVisibleSections = this.visibleSections.filter((sectionId)=>{
            var _this$prevVisibleSect;
            return !((_this$prevVisibleSect = this.prevVisibleSections) !== null && _this$prevVisibleSect !== void 0 && _this$prevVisibleSect.includes(sectionId));
        });
        const newlyVisibleQuestions = newlyVisibleSections.reduce((accumulatedQuestions, sectionId)=>{
            var _this$sections;
            const section = (_this$sections = this.sections) === null || _this$sections === void 0 ? void 0 : _this$sections[sectionId];
            if (!section) return accumulatedQuestions;
            return [
                ...accumulatedQuestions,
                ...this.questions.filter((question)=>{
                    var _section$questions;
                    return (_section$questions = section.questions) === null || _section$questions === void 0 ? void 0 : _section$questions.includes(question.id.toString());
                })
            ];
        }, []);
        this.prevVisibleSections = this.visibleSections;
        return newlyVisibleQuestions;
    }
}, $d5e99eb3f1ac4fc8$var$_descriptor = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "savingAnswers", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $d5e99eb3f1ac4fc8$var$_descriptor2 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "submittingForm", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $d5e99eb3f1ac4fc8$var$_descriptor3 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "updated", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $d5e99eb3f1ac4fc8$var$_descriptor4 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "status", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $d5e99eb3f1ac4fc8$var$_descriptor5 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "questions", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $d5e99eb3f1ac4fc8$var$_descriptor6 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "internal", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $d5e99eb3f1ac4fc8$var$_descriptor7 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "invalid", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "formIsBlank", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "formIsBlank"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "answersModified", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "answersModified"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "satisfiedConditions", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "satisfiedConditions"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "visibleSections", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "visibleSections"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "hiddenQuestions", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "hiddenQuestions"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "visibleQuestions", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "visibleQuestions"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "isUploadingMedia", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "isUploadingMedia"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "hasAttachmentField", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "hasAttachmentField"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "numberOfAttachment", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "numberOfAttachment"), $d5e99eb3f1ac4fc8$var$_class.prototype), (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "attachmentIds", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($d5e99eb3f1ac4fc8$var$_class.prototype, "attachmentIds"), $d5e99eb3f1ac4fc8$var$_class.prototype), $d5e99eb3f1ac4fc8$var$_descriptor8 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "attachQuestionsToSections", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return ()=>{
            if (!this.layout || !this.layout[0]) return;
            const sectionsAdf = this.layout.map((sectionLayout, index)=>({
                    id: index,
                    questions: sectionLayout.content ? this.getQuestionIdsFromSectionContent(sectionLayout) : []
                }));
            sectionsAdf.forEach((section)=>{
                const { sections: sections } = this;
                if (sections && sections[section.id]) sections[section.id].questions = section.questions;
            });
        };
    }
}), $d5e99eb3f1ac4fc8$var$_descriptor9 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "update", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (form, refreshChoices = false)=>{
            return this._update(false, form, refreshChoices);
        };
    }
}), $d5e99eb3f1ac4fc8$var$_descriptor10 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "hideValidations", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return ()=>{
            this.invalid = false;
            this.questions.forEach((question)=>question.hideValidation());
        };
    }
}), $d5e99eb3f1ac4fc8$var$_descriptor11 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "discardModifiedAnswers", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return ()=>{
            this.questions.forEach((question)=>question.discardModifiedAnswer());
        };
    }
}), $d5e99eb3f1ac4fc8$var$_descriptor12 = (0, $7Jkpx.default)($d5e99eb3f1ac4fc8$var$_class.prototype, "onFieldChange", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (jiraField)=>{
            const dependentVisibleQuestions = jiraField ? this.visibleQuestions.filter((question)=>{
                var _question$issueFieldD, _question$issueFieldD2;
                return (_question$issueFieldD = question.issueFieldData) === null || _question$issueFieldD === void 0 ? void 0 : (_question$issueFieldD2 = _question$issueFieldD.dependsOn) === null || _question$issueFieldD2 === void 0 ? void 0 : _question$issueFieldD2.includes(jiraField);
            }) : [];
            const newlyVisibleNonDependentQuestions = this.getNewlyVisibleQuestions().filter((newlyVisibleQuestion)=>!dependentVisibleQuestions.some((dependentQuestion)=>dependentQuestion.id === newlyVisibleQuestion.id));
            dependentVisibleQuestions.forEach((question)=>{
                question.onDependentFieldChanged();
                question.doPopulateDefaultValueOnEmptySearch();
            });
            newlyVisibleNonDependentQuestions.forEach((question)=>question.doPopulateDefaultValueOnEmptySearch());
        };
    }
}), $d5e99eb3f1ac4fc8$var$_class);

});
parcelRegister("9kzTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cb1d438ffa235a6$export$2e2bcd8739ae039);
function $6cb1d438ffa235a6$export$2e2bcd8739ae039(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}

});

parcelRegister("7Jkpx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a0c9192206f93ca$export$2e2bcd8739ae039);
function $5a0c9192206f93ca$export$2e2bcd8739ae039(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}

});

parcelRegister("cTQjS", function(module, exports) {
function $964334b28db9c870$export$2e2bcd8739ae039(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}

});

parcelRegister("chyFx", function(module, exports) {

$parcel$export(module.exports, "getFormAnalyticsAttributes", () => $8f11f71a45f1b0de$export$74358040f8588ae5);
$parcel$export(module.exports, "getTemplateFormAnalyticsAttributes", () => $8f11f71a45f1b0de$export$e9ac6861e8924d45);
const $8f11f71a45f1b0de$var$capitaliseFirstLetter = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
const $8f11f71a45f1b0de$export$74358040f8588ae5 = (form)=>{
    var _form$publish, _form$publish2, _jiraConfig$issueRequ, _jiraConfig$issueRequ2, _portalConfig$portalR, _portalConfig$portalR2, _jiraConfig$newIssueI, _jiraConfig$newIssueI2, _jiraConfig$newIssueR, _jiraConfig$newIssueR2;
    const jiraConfig = (_form$publish = form.publish) === null || _form$publish === void 0 ? void 0 : _form$publish.jira;
    const portalConfig = (_form$publish2 = form.publish) === null || _form$publish2 === void 0 ? void 0 : _form$publish2.portal;
    const design = form.design;
    const questions = Object.entries(design.questions);
    const sections = Object.values(design.sections);
    const conditions = Object.values(design.conditions);
    const questionsAttributes = {};
    const questionsRequiredAttributes = {};
    const questionsUsedAsSectionConditionAttributes = {};
    const jiraFieldAttributes = {};
    const dataConnectionsAttributes = {};
    questions.forEach(([id, question])=>{
        var _questionsAttributes$, _questionsRequiredAtt, _questionsUsedAsSecti;
        const questionType = $8f11f71a45f1b0de$var$capitaliseFirstLetter(question.type);
        const questionAttribute = `templateFormQuestion${questionType}Count`;
        questionsAttributes[questionAttribute] = ((_questionsAttributes$ = questionsAttributes[questionAttribute]) !== null && _questionsAttributes$ !== void 0 ? _questionsAttributes$ : 0) + 1;
        const questionRequiredAttribute = `templateFormRequiredQuestion${questionType}Count`;
        questionsRequiredAttributes[questionRequiredAttribute] = ((_questionsRequiredAtt = questionsRequiredAttributes[questionRequiredAttribute]) !== null && _questionsRequiredAtt !== void 0 ? _questionsRequiredAtt : 0) + (question.validation.rq ? 1 : 0);
        if (question.jiraField) {
            var _jiraFieldAttributes$;
            const jiraFieldAttribute = `templateFormJiraFieldQuestion${questionType}Count`;
            jiraFieldAttributes[jiraFieldAttribute] = ((_jiraFieldAttributes$ = jiraFieldAttributes[jiraFieldAttribute]) !== null && _jiraFieldAttributes$ !== void 0 ? _jiraFieldAttributes$ : 0) + 1;
        }
        if (question.dcId) {
            var _dataConnectionsAttri;
            const dataConnectionAttribute = `templateFormDataConnectionQuestion${questionType}Count`;
            dataConnectionsAttributes[dataConnectionAttribute] = ((_dataConnectionsAttri = dataConnectionsAttributes[dataConnectionAttribute]) !== null && _dataConnectionsAttri !== void 0 ? _dataConnectionsAttri : 0) + 1;
        }
        const questionUsedAsSectionConditionAttribute = `templateFormUsedAsSectionConditionQuestion${questionType}Count`;
        const questionUsedAsSectionConditionCount = conditions.filter((condition)=>{
            var _condition$i$co;
            return (_condition$i$co = condition.i.co) === null || _condition$i$co === void 0 ? void 0 : _condition$i$co.cIds[id];
        }).length;
        questionsUsedAsSectionConditionAttributes[questionUsedAsSectionConditionAttribute] = ((_questionsUsedAsSecti = questionsUsedAsSectionConditionAttributes[questionUsedAsSectionConditionAttribute]) !== null && _questionsUsedAsSecti !== void 0 ? _questionsUsedAsSecti : 0) + questionUsedAsSectionConditionCount;
    });
    const layoutItemAttributes = {};
    const recurseLayoutItemAttributes = (layoutItemNodes)=>{
        layoutItemNodes.forEach((layoutItemNode)=>{
            var _layoutItemAttributes, _layoutItemNode$conte;
            const layoutItemType = $8f11f71a45f1b0de$var$capitaliseFirstLetter(layoutItemNode.type);
            const layoutItemName = `templateFormLayoutItem${layoutItemType}Count`;
            layoutItemAttributes[layoutItemName] = ((_layoutItemAttributes = layoutItemAttributes[layoutItemName]) !== null && _layoutItemAttributes !== void 0 ? _layoutItemAttributes : 0) + 1;
            recurseLayoutItemAttributes((_layoutItemNode$conte = layoutItemNode.content) !== null && _layoutItemNode$conte !== void 0 ? _layoutItemNode$conte : []);
        });
    };
    recurseLayoutItemAttributes(design.layout);
    return {
        ...questionsAttributes,
        ...questionsRequiredAttributes,
        ...questionsUsedAsSectionConditionAttributes,
        ...jiraFieldAttributes,
        ...dataConnectionsAttributes,
        ...layoutItemAttributes,
        templateFormQuestionsCount: questions.length,
        templateFormSectionsCount: sections.length,
        templateFormConditionalSectionsCount: sections.filter((section)=>{
            var _section$conditions;
            return (_section$conditions = section.conditions) === null || _section$conditions === void 0 ? void 0 : _section$conditions.length;
        }).length,
        templateFormConditionsCount: conditions.length,
        templateFormLinkedFieldsCount: questions.filter(([, question])=>question.jiraField).length,
        templateFormDataConnectionFieldsCount: questions.filter(([, question])=>question.dcId).length,
        templateFormRecommendedCount: (_jiraConfig$issueRequ = jiraConfig === null || jiraConfig === void 0 ? void 0 : (_jiraConfig$issueRequ2 = jiraConfig.issueRequestTypeIds) === null || _jiraConfig$issueRequ2 === void 0 ? void 0 : _jiraConfig$issueRequ2.length) !== null && _jiraConfig$issueRequ !== void 0 ? _jiraConfig$issueRequ : 0,
        templateFormPortalFormsCount: (_portalConfig$portalR = portalConfig === null || portalConfig === void 0 ? void 0 : (_portalConfig$portalR2 = portalConfig.portalRequestTypeIds) === null || _portalConfig$portalR2 === void 0 ? void 0 : _portalConfig$portalR2.length) !== null && _portalConfig$portalR !== void 0 ? _portalConfig$portalR : 0,
        templateFormIssueFormsCount: ((_jiraConfig$newIssueI = jiraConfig === null || jiraConfig === void 0 ? void 0 : (_jiraConfig$newIssueI2 = jiraConfig.newIssueIssueTypeIds) === null || _jiraConfig$newIssueI2 === void 0 ? void 0 : _jiraConfig$newIssueI2.length) !== null && _jiraConfig$newIssueI !== void 0 ? _jiraConfig$newIssueI : 0) + ((_jiraConfig$newIssueR = jiraConfig === null || jiraConfig === void 0 ? void 0 : (_jiraConfig$newIssueR2 = jiraConfig.newIssueRequestTypeIds) === null || _jiraConfig$newIssueR2 === void 0 ? void 0 : _jiraConfig$newIssueR2.length) !== null && _jiraConfig$newIssueR !== void 0 ? _jiraConfig$newIssueR : 0),
        isTemplateFormSubmitOnRequestCreate: (portalConfig === null || portalConfig === void 0 ? void 0 : portalConfig.submitOnCreate) || false,
        isTemplateFormValidateOnRequestCreate: (portalConfig === null || portalConfig === void 0 ? void 0 : portalConfig.submitOnCreate) || (portalConfig === null || portalConfig === void 0 ? void 0 : portalConfig.validateOnCreate) || false,
        isTemplateFormGeneratePDFOnSubmit: design.settings.submit.pdf,
        isTemplateFormLockOnSubmit: design.settings.submit.lock
    };
};
const $8f11f71a45f1b0de$export$e9ac6861e8924d45 = (updatedTemplateForm, oldTemplateForm)=>{
    var _oldTemplateForm$publ, _oldTemplateForm$publ2, _oldTemplateForm$publ3, _updatedTemplateForm$, _updatedTemplateForm$2, _updatedTemplateForm$3;
    const updatedFormAttributes = $8f11f71a45f1b0de$export$74358040f8588ae5(updatedTemplateForm);
    const oldFormAttributes = $8f11f71a45f1b0de$export$74358040f8588ae5(oldTemplateForm);
    const deltaAttributes = {};
    const toggleAttributes = {};
    function addDeltaAttribute(numberAttributeKey) {
        var _ref, _ref2;
        const oldValue = (_ref = oldFormAttributes[numberAttributeKey]) !== null && _ref !== void 0 ? _ref : 0;
        const newValue = (_ref2 = updatedFormAttributes[numberAttributeKey]) !== null && _ref2 !== void 0 ? _ref2 : 0;
        deltaAttributes[`${numberAttributeKey}Delta`] = newValue - oldValue;
    }
    function addToggleAttribute(booleanAttributeKey) {
        const oldValue = oldFormAttributes[booleanAttributeKey];
        const newValue = updatedFormAttributes[booleanAttributeKey];
        if (oldValue && !newValue) toggleAttributes[`${booleanAttributeKey}Toggled`] = 'off';
        else if (!oldValue && newValue) toggleAttributes[`${booleanAttributeKey}Toggled`] = 'on';
    }
    Object.entries(updatedFormAttributes).forEach(([key, value])=>{
        if (typeof value === 'number') addDeltaAttribute(key);
        else if (typeof value === 'boolean') addToggleAttribute(key);
    });
    /**
   * Cover attributes that are undefined in `updatedFormAttributes`
   *
   * E.G.
   *   When user removed all 4 ChoiceDropdown questions, it would be
   *   oldFormAttributes = { templateFormQuestionCdCount: 4, ...rest };
   *   updatedFormAttributes = { templateFormQuestionCdCount: never, ...rest };
   *  */ Object.entries(oldFormAttributes).forEach(([key, value])=>{
        if (typeof value === 'number' && deltaAttributes[`${key}Delta`] === undefined) addDeltaAttribute(key);
        else if (typeof value === 'boolean' && deltaAttributes[`${key}Toggled`] === undefined) addToggleAttribute(key);
    });
    const oldPortalForms = (_oldTemplateForm$publ = (_oldTemplateForm$publ2 = oldTemplateForm.publish) === null || _oldTemplateForm$publ2 === void 0 ? void 0 : (_oldTemplateForm$publ3 = _oldTemplateForm$publ2.portal) === null || _oldTemplateForm$publ3 === void 0 ? void 0 : _oldTemplateForm$publ3.portalRequestTypeIds) !== null && _oldTemplateForm$publ !== void 0 ? _oldTemplateForm$publ : [];
    const newPortalForms = (_updatedTemplateForm$ = (_updatedTemplateForm$2 = updatedTemplateForm.publish) === null || _updatedTemplateForm$2 === void 0 ? void 0 : (_updatedTemplateForm$3 = _updatedTemplateForm$2.portal) === null || _updatedTemplateForm$3 === void 0 ? void 0 : _updatedTemplateForm$3.portalRequestTypeIds) !== null && _updatedTemplateForm$ !== void 0 ? _updatedTemplateForm$ : [];
    const templateFormPortalFormAdded = newPortalForms.filter((n)=>!oldPortalForms.includes(n)).length;
    const templateFormPortalFormRemoved = oldPortalForms.filter((n)=>!newPortalForms.includes(n)).length;
    return {
        ...updatedFormAttributes,
        ...deltaAttributes,
        ...toggleAttributes,
        templateFormPortalFormAdded: templateFormPortalFormAdded,
        templateFormPortalFormRemoved: templateFormPortalFormRemoved
    };
};

});

parcelRegister("4QmvR", function(module, exports) {

$parcel$export(module.exports, "toRichTextQuestionAnswer", () => $386d7b5ac0037e42$export$957053b5df8c35dd);
$parcel$export(module.exports, "toTextQuestionAnswer", () => $386d7b5ac0037e42$export$4392c3957775e9f7);
$parcel$export(module.exports, "toDateTimeQuestionAnswer", () => $386d7b5ac0037e42$export$6305e45d67abc440);
$parcel$export(module.exports, "toDateTimeQuestionAnswerOrEmpty", () => $386d7b5ac0037e42$export$c747b9cbc376a41c);
$parcel$export(module.exports, "toChoiceQuestionAnswer", () => $386d7b5ac0037e42$export$bb1c52eccaca93f1);
$parcel$export(module.exports, "toChoiceQuestionAnswerOrEmpty", () => $386d7b5ac0037e42$export$cf2ff167d32b34bc);
$parcel$export(module.exports, "toUserPickerQuestionAnswer", () => $386d7b5ac0037e42$export$4ed34efc5377e1e1);
$parcel$export(module.exports, "toUserPickerQuestionAnswerOrEmpty", () => $386d7b5ac0037e42$export$40f309d38988372e);
$parcel$export(module.exports, "toAttachmentQuestionAnswer", () => $386d7b5ac0037e42$export$97d32e27706e0cc4);
$parcel$export(module.exports, "QuestionStore", () => $386d7b5ac0037e42$export$429c93ea52a8aa75);

var $9kzTP = parcelRequire("9kzTP");

var $7Jkpx = parcelRequire("7Jkpx");
parcelRequire("cTQjS");

var $alnGD = parcelRequire("alnGD");

var $8LePZ = parcelRequire("8LePZ");

var $fHpHg = parcelRequire("fHpHg");

var $jLSMy = parcelRequire("jLSMy");

var $4aJmI = parcelRequire("4aJmI");

var $ctPpG = parcelRequire("ctPpG");

var $djQya = parcelRequire("djQya");
var $386d7b5ac0037e42$var$_class, $386d7b5ac0037e42$var$_descriptor, $386d7b5ac0037e42$var$_descriptor2, $386d7b5ac0037e42$var$_descriptor3, $386d7b5ac0037e42$var$_descriptor4, $386d7b5ac0037e42$var$_descriptor5, $386d7b5ac0037e42$var$_descriptor6, $386d7b5ac0037e42$var$_descriptor7, $386d7b5ac0037e42$var$_descriptor8, $386d7b5ac0037e42$var$_descriptor9, $386d7b5ac0037e42$var$_descriptor10, $386d7b5ac0037e42$var$_descriptor11, $386d7b5ac0037e42$var$_descriptor12, $386d7b5ac0037e42$var$_descriptor13, $386d7b5ac0037e42$var$_descriptor14, $386d7b5ac0037e42$var$_descriptor15, $386d7b5ac0037e42$var$_descriptor16, $386d7b5ac0037e42$var$_descriptor17, $386d7b5ac0037e42$var$_descriptor18, $386d7b5ac0037e42$var$_descriptor19, $386d7b5ac0037e42$var$_descriptor20, $386d7b5ac0037e42$var$_descriptor21, $386d7b5ac0037e42$var$_descriptor22, $386d7b5ac0037e42$var$_descriptor23, $386d7b5ac0037e42$var$_descriptor24, $386d7b5ac0037e42$var$_QuestionStore;
// extracted FormAnswer data, done in extractAnswer()
// was: { id: string; name: string };
// Array.isArray() returns false for mobx ObservableArray - see "known pitfalls" in mobX docs
const $386d7b5ac0037e42$var$isArray = (value)=>{
    return !!value && value.length != null && value.splice != null;
};
const $386d7b5ac0037e42$export$85d7ec96a7f16e50 = (answer)=>{
    return typeof answer === 'object' && answer.hasOwnProperty('content') && answer.hasOwnProperty('version') && answer.hasOwnProperty('type') && answer.type === 'doc';
};
const $386d7b5ac0037e42$export$957053b5df8c35dd = (answer)=>$386d7b5ac0037e42$export$85d7ec96a7f16e50(answer) ? answer : undefined;
const $386d7b5ac0037e42$var$isTextQuestionAnswer = (answer)=>typeof answer === 'string';
const $386d7b5ac0037e42$export$4392c3957775e9f7 = (answer)=>$386d7b5ac0037e42$var$isTextQuestionAnswer(answer) ? answer : undefined;
const $386d7b5ac0037e42$var$isDateTimeQuestionAnswer = (answer)=>(answer === null || answer === void 0 ? void 0 : answer.date) !== undefined;
const $386d7b5ac0037e42$export$6305e45d67abc440 = (answer)=>$386d7b5ac0037e42$var$isDateTimeQuestionAnswer(answer) ? answer : undefined;
const $386d7b5ac0037e42$export$c747b9cbc376a41c = (answer)=>$386d7b5ac0037e42$var$isDateTimeQuestionAnswer(answer) ? answer : {
        date: '',
        time: ''
    }; // same default data as in extractAnswer()
const $386d7b5ac0037e42$var$isChoiceQuestionAnswer = (answer)=>(answer === null || answer === void 0 ? void 0 : answer.choices) !== undefined;
const $386d7b5ac0037e42$export$bb1c52eccaca93f1 = (answer)=>$386d7b5ac0037e42$var$isChoiceQuestionAnswer(answer) ? answer : undefined;
const $386d7b5ac0037e42$export$cf2ff167d32b34bc = (answer)=>$386d7b5ac0037e42$var$isChoiceQuestionAnswer(answer) ? answer : {
        text: '',
        choices: []
    };
const $386d7b5ac0037e42$var$isUserPickerQuestionAnswer = (answer)=>{
    return $386d7b5ac0037e42$var$isArray(answer);
};
const $386d7b5ac0037e42$export$4ed34efc5377e1e1 = (answer)=>$386d7b5ac0037e42$var$isUserPickerQuestionAnswer(answer) ? answer : undefined;
const $386d7b5ac0037e42$export$40f309d38988372e = (answer)=>$386d7b5ac0037e42$var$isUserPickerQuestionAnswer(answer) ? answer : [];
const $386d7b5ac0037e42$export$30613a542e82c0b7 = (answer)=>$386d7b5ac0037e42$var$isArray(answer) && answer.every((a)=>a.id !== undefined);
const $386d7b5ac0037e42$export$97d32e27706e0cc4 = (answer)=>$386d7b5ac0037e42$export$30613a542e82c0b7(answer) ? answer : undefined;
const $386d7b5ac0037e42$var$extractAnswer = (questionType, answer)=>{
    var _console$debug, _console;
    switch(questionType){
        case (0, $4aJmI.FormQuestionType).TextShort:
        case (0, $4aJmI.FormQuestionType).TextLong:
        case (0, $4aJmI.FormQuestionType).TextParagraph:
        case (0, $4aJmI.FormQuestionType).TextEmail:
        case (0, $4aJmI.FormQuestionType).TextUrl:
        case (0, $4aJmI.FormQuestionType).Number:
            return answer.text || '';
        case (0, $4aJmI.FormQuestionType).DateTime:
            return {
                date: answer.date || '',
                time: answer.time || ''
            };
        case (0, $4aJmI.FormQuestionType).Date:
            return answer.date || '';
        case (0, $4aJmI.FormQuestionType).Time:
            return answer.time || '';
        case (0, $4aJmI.FormQuestionType).ChoiceCascading:
        case (0, $4aJmI.FormQuestionType).ChoiceSingle:
        case (0, $4aJmI.FormQuestionType).ChoiceMultiple:
        case (0, $4aJmI.FormQuestionType).ChoiceDropdown:
        case (0, $4aJmI.FormQuestionType).ChoiceDropdownMultiple:
        case (0, $4aJmI.FormQuestionType).CmdbObject:
            return {
                text: answer.text || '',
                choices: answer.choices || []
            };
        case (0, $4aJmI.FormQuestionType).UserSingle:
        case (0, $4aJmI.FormQuestionType).UserMultiple:
            return answer.users || [];
        case (0, $4aJmI.FormQuestionType).RichTextParagraph:
            return answer.adf || (0, $8LePZ.getEmptyADF)();
        case (0, $4aJmI.FormQuestionType).Attachment:
            return answer.files || [];
        default:
            // eslint-disable-next-line no-console
            (_console$debug = (_console = console).debug) === null || _console$debug === void 0 || _console$debug.call(_console, `Question type ${questionType} is not handled.`);
            return '';
    }
};
const $386d7b5ac0037e42$var$sortById = (a, b)=>{
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
};
let $386d7b5ac0037e42$export$429c93ea52a8aa75 = ($386d7b5ac0037e42$var$_class = ($386d7b5ac0037e42$var$_QuestionStore = class QuestionStore {
    constructor(intl, questionKey, _formQuestion, loadChoicesAsync, onFieldChange, populateDefaultValueOnEmptySearch, _currentAnswer, onFieldDirty){
        var _formQuestion$conditi;
        this.intl = intl;
        this.id = void 0;
        this.formQuestion = void 0;
        this.conditions = void 0;
        this.hasJiraField = void 0;
        this.hasDataConnection = void 0;
        (0, $9kzTP.default)(this, "answer", $386d7b5ac0037e42$var$_descriptor, this);
        (0, $9kzTP.default)(this, "modifiedAnswer", $386d7b5ac0037e42$var$_descriptor2, this);
        (0, $9kzTP.default)(this, "validating", $386d7b5ac0037e42$var$_descriptor3, this);
        (0, $9kzTP.default)(this, "loading", $386d7b5ac0037e42$var$_descriptor4, this);
        (0, $9kzTP.default)(this, "isUploadingMedia", $386d7b5ac0037e42$var$_descriptor5, this);
        (0, $9kzTP.default)(this, "choices", $386d7b5ac0037e42$var$_descriptor6, this);
        (0, $9kzTP.default)(this, "answerChoicesAsObjects", $386d7b5ac0037e42$var$_descriptor7, this);
        (0, $9kzTP.default)(this, "dependentFieldChangedCount", $386d7b5ac0037e42$var$_descriptor8, this);
        (0, $9kzTP.default)(this, "otherChoiceId", $386d7b5ac0037e42$var$_descriptor9, this);
        (0, $9kzTP.default)(this, "revisionToken", $386d7b5ac0037e42$var$_descriptor10, this);
        (0, $9kzTP.default)(this, "issueFieldData", $386d7b5ac0037e42$var$_descriptor11, this);
        this.loadChoicesAsync = void 0;
        this.onFieldChange = void 0;
        this.populateDefaultValueOnEmptySearch = void 0;
        this.onFieldDirty = void 0;
        this.attachmentEqual = (a1, a2)=>{
            if (a1 === undefined || a2 === undefined) return false;
            return a1['id'] === a2['id'];
        };
        this.hasAttachmentFieldModified = ()=>{
            const af1 = this.answer;
            const af2 = this.modifiedAnswer;
            if (af1 === undefined || af2 === undefined) return false;
            return !(af1.length === af2.length && af1.every((a, idx)=>this.attachmentEqual(a, af2[idx])));
        };
        this.choiceToOption = (choice)=>{
            var _choice$children;
            return {
                value: choice.id,
                label: choice.label,
                children: (_choice$children = choice.children) === null || _choice$children === void 0 ? void 0 : _choice$children.map(this.choiceToOption),
                ...(0, $fHpHg.fg)('proforma_asset_fields_show_selected_attributes') ? {
                    cmdbObject: choice.cmdbObject
                } : {}
            };
        };
        this.availableOptions = ()=>{
            return this.choices.map(this.choiceToOption);
        };
        /**
     * Use only for choices fields
     */ this.getAnswerChoicesAsObjects = ()=>{
            const choices = this.answerChoicesAsObjects;
            const currentChoiceOptions = choices.map(this.choiceToOption);
            const choiceAnswer = $386d7b5ac0037e42$export$cf2ff167d32b34bc(this.currentAnswer);
            return currentChoiceOptions.filter((option)=>choiceAnswer.choices.includes(option.value) || // If the answer is a cascading response, this will return the parent choice
                choiceAnswer.choices.map((choice)=>choice.split(':')[0]).includes(option.value));
        };
        (0, $9kzTP.default)(this, "setLastUpdated", $386d7b5ac0037e42$var$_descriptor12, this);
        (0, $9kzTP.default)(this, "setAnswer", $386d7b5ac0037e42$var$_descriptor13, this);
        (0, $9kzTP.default)(this, "doPopulateDefaultValueOnEmptySearch", $386d7b5ac0037e42$var$_descriptor14, this);
        (0, $9kzTP.default)(this, "onDependentFieldChanged", $386d7b5ac0037e42$var$_descriptor15, this);
        (0, $9kzTP.default)(this, "validate", $386d7b5ac0037e42$var$_descriptor16, this);
        (0, $9kzTP.default)(this, "hideValidation", $386d7b5ac0037e42$var$_descriptor17, this);
        (0, $9kzTP.default)(this, "setUploadingMedia", $386d7b5ac0037e42$var$_descriptor18, this);
        (0, $9kzTP.default)(this, "discardModifiedAnswer", $386d7b5ac0037e42$var$_descriptor19, this);
        (0, $9kzTP.default)(this, "setAnswerFromFieldValue", $386d7b5ac0037e42$var$_descriptor20, this);
        (0, $9kzTP.default)(this, "setChoices", $386d7b5ac0037e42$var$_descriptor21, this);
        this._setChoices = (choices)=>{
            this.choices.splice(0, this.choices.length, ...choices);
            const otherChoice = this._setOtherChoiceLabel(choices);
            this.otherChoiceId = otherChoice === null || otherChoice === void 0 ? void 0 : otherChoice.id;
        };
        this._setOtherChoiceLabel = (choices)=>{
            const otherChoice = choices.find((choice)=>choice.other);
            if (otherChoice) otherChoice.label = this.intl.formatMessage((0, $jLSMy.IntlChoiceMessages)[(0, $jLSMy.ChoiceMessage).OtherPlaceholder]);
            return otherChoice;
        };
        this._isAsyncChoicesQuestion = ()=>{
            var _this$choices;
            // for non-async choices fields - all choices are fetched on form load
            return !(((_this$choices = this.choices) === null || _this$choices === void 0 ? void 0 : _this$choices.length) > 0);
        };
        (0, $9kzTP.default)(this, "setAnswerChoicesAsObjects", $386d7b5ac0037e42$var$_descriptor22, this);
        this._setAnswerChoicesAsObjects = (answerChoicesAsObjects)=>{
            this.answerChoicesAsObjects.splice(0, this.answerChoicesAsObjects.length, ...answerChoicesAsObjects);
            this._setOtherChoiceLabel(this.answerChoicesAsObjects);
        };
        (0, $9kzTP.default)(this, "setIssueFieldData", $386d7b5ac0037e42$var$_descriptor23, this);
        (0, $9kzTP.default)(this, "update", $386d7b5ac0037e42$var$_descriptor24, this);
        this._update = (constructing, formQuestion, currentAnswer)=>{
            this._setChoices(formQuestion.choices || []);
            this.answer = $386d7b5ac0037e42$var$extractAnswer(formQuestion.type, currentAnswer || (0, $4aJmI.FormAnswerEmpty));
            if (!constructing) {
                this.hideValidation();
                this.discardModifiedAnswer();
                this.setLastUpdated();
            }
        };
        this.loadChoicesAsync = loadChoicesAsync;
        this.onFieldChange = onFieldChange;
        this.onFieldDirty = onFieldDirty;
        this.populateDefaultValueOnEmptySearch = populateDefaultValueOnEmptySearch;
        this.id = parseInt(questionKey, 10);
        this.revisionToken = `${this.id}-${Date.now()}`;
        this.formQuestion = _formQuestion;
        this.conditions = ((_formQuestion$conditi = _formQuestion.conditions) === null || _formQuestion$conditi === void 0 ? void 0 : _formQuestion$conditi.map((condition)=>parseInt(condition))) || [];
        this.hasJiraField = !!_formQuestion.jiraField;
        this.hasDataConnection = !!_formQuestion.dcId;
        this._setChoices(_formQuestion.choices || []);
        // this set call is for proforma non-linked dropdowns. As they do not have results in fielddata/ nor in formchoices/, so answerChoicesAsObjects will not be set from e.g. loadFieldDataFn for them.
        this._setAnswerChoicesAsObjects(_formQuestion.choices || []);
        this.answer = $386d7b5ac0037e42$var$extractAnswer(_formQuestion.type, _currentAnswer || (0, $4aJmI.FormAnswerEmpty));
        switch(_formQuestion.type){
            case (0, $4aJmI.FormQuestionType).TextEmail:
                this.formQuestion.validation.rgx = {
                    p: /[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*/
                };
                break;
            case (0, $4aJmI.FormQuestionType).TextUrl:
                this.formQuestion.validation.rgx = {
                    p: /((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/
                };
                break;
            default:
        }
        this._update(true, _formQuestion, _currentAnswer);
    }
    get answerModified() {
        if (this.formQuestion.type === (0, $4aJmI.FormQuestionType).Attachment) return this.hasAttachmentFieldModified();
        else return this.modifiedAnswer !== undefined;
    }
    get currentAnswer() {
        if (this.modifiedAnswer !== undefined) return this.modifiedAnswer;
        if (this.answer != null) return this.answer;
        return 0, $4aJmI.FormAnswerEmpty;
    }
    get isAsyncChoicesField() {
        var _this$issueFieldData, _this$issueFieldData$, _this$issueFieldData2, _this$issueFieldData3;
        const linkedJiraFieldSchemaSystem = (_this$issueFieldData = this.issueFieldData) === null || _this$issueFieldData === void 0 ? void 0 : (_this$issueFieldData$ = _this$issueFieldData.schema) === null || _this$issueFieldData$ === void 0 ? void 0 : _this$issueFieldData$.system;
        if (linkedJiraFieldSchemaSystem && (0, $ctPpG.asyncChoicesFieldSchemaSystems).includes(linkedJiraFieldSchemaSystem)) return true;
        const linkedJiraFieldSchemaCustom = (_this$issueFieldData2 = this.issueFieldData) === null || _this$issueFieldData2 === void 0 ? void 0 : (_this$issueFieldData3 = _this$issueFieldData2.schema) === null || _this$issueFieldData3 === void 0 ? void 0 : _this$issueFieldData3.custom;
        if (linkedJiraFieldSchemaCustom && ((0, $fHpHg.fg)('jcs_master_flag') ? (0, $ctPpG.asyncChoicesFieldSchemaCustomsWithEntitlement) : (0, $ctPpG.asyncChoicesFieldSchemaCustoms)).includes(linkedJiraFieldSchemaCustom)) return true;
        return false;
    }
    get validationErrors() {
        var _this$issueFieldData4;
        if (this.answerModified || this.validating) {
            const currentAnswerForTextQuestion = $386d7b5ac0037e42$export$4392c3957775e9f7(this.currentAnswer) || '';
            switch(this.formQuestion.type){
                case (0, $4aJmI.FormQuestionType).TextShort:
                case (0, $4aJmI.FormQuestionType).TextLong:
                case (0, $4aJmI.FormQuestionType).TextParagraph:
                    return (0, $djQya.getTextValidation)(this.formQuestion.validation, currentAnswerForTextQuestion, undefined, this.formQuestion.label);
                case (0, $4aJmI.FormQuestionType).RichTextParagraph:
                    return (0, $djQya.getRichTextValidation)(this.formQuestion.validation, (0, $alnGD.toJS)($386d7b5ac0037e42$export$957053b5df8c35dd(this.currentAnswer)) || (0, $8LePZ.getEmptyADF)(), undefined, this.formQuestion.label);
                case (0, $4aJmI.FormQuestionType).TextEmail:
                    return (0, $djQya.getTextValidation)(this.formQuestion.validation, currentAnswerForTextQuestion, (0, $4aJmI.FormQuestionType).TextEmail, this.formQuestion.label);
                case (0, $4aJmI.FormQuestionType).TextUrl:
                    return (0, $djQya.getTextValidation)(this.formQuestion.validation, currentAnswerForTextQuestion, (0, $4aJmI.FormQuestionType).TextUrl, this.formQuestion.label);
                case (0, $4aJmI.FormQuestionType).Number:
                    return (0, $djQya.getNumberValidation)(this.formQuestion.validation, currentAnswerForTextQuestion, this.formQuestion.label);
                case (0, $4aJmI.FormQuestionType).DateTime:
                    return (0, $djQya.getDateTimeValidation)(this.formQuestion.validation, $386d7b5ac0037e42$export$c747b9cbc376a41c(this.currentAnswer), this.formQuestion.label);
                case (0, $4aJmI.FormQuestionType).Date:
                    return (0, $djQya.getDateValidation)(this.formQuestion.validation, currentAnswerForTextQuestion, this.formQuestion.label);
                case (0, $4aJmI.FormQuestionType).Time:
                    return (0, $djQya.getTimeValidation)(this.formQuestion.validation, currentAnswerForTextQuestion, this.formQuestion.label);
                case (0, $4aJmI.FormQuestionType).ChoiceCascading:
                case (0, $4aJmI.FormQuestionType).ChoiceSingle:
                case (0, $4aJmI.FormQuestionType).ChoiceMultiple:
                case (0, $4aJmI.FormQuestionType).ChoiceDropdown:
                case (0, $4aJmI.FormQuestionType).ChoiceDropdownMultiple:
                case (0, $4aJmI.FormQuestionType).CmdbObject:
                    return (0, $djQya.getChoiceValidation)(this.formQuestion.validation, this.choices, $386d7b5ac0037e42$export$cf2ff167d32b34bc(this.currentAnswer), (_this$issueFieldData4 = this.issueFieldData) === null || _this$issueFieldData4 === void 0 ? void 0 : _this$issueFieldData4.asyncRequiredChoice, this.formQuestion.label);
                case (0, $4aJmI.FormQuestionType).UserSingle:
                case (0, $4aJmI.FormQuestionType).UserMultiple:
                    return (0, $djQya.getUserPickerValidation)(this.formQuestion.validation, $386d7b5ac0037e42$export$4ed34efc5377e1e1(this.currentAnswer) || [], this.formQuestion.label);
                case (0, $4aJmI.FormQuestionType).Attachment:
                    return (0, $djQya.getAttachmentValidation)(this.formQuestion.validation, (0, $alnGD.toJS)($386d7b5ac0037e42$export$97d32e27706e0cc4(this.currentAnswer)) || [], this.formQuestion.type, this.formQuestion.label);
                default:
            }
        }
    }
}, $386d7b5ac0037e42$var$_QuestionStore.optionToChoice = (option)=>{
    var _option$children;
    return {
        id: option.value,
        label: option.label,
        children: (_option$children = option.children) === null || _option$children === void 0 ? void 0 : _option$children.map($386d7b5ac0037e42$var$_QuestionStore.optionToChoice),
        ...(0, $fHpHg.fg)('proforma_asset_fields_show_selected_attributes') ? {
            cmdbObject: option.cmdbObject
        } : {}
    };
}, $386d7b5ac0037e42$var$_QuestionStore), $386d7b5ac0037e42$var$_descriptor = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "answer", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $386d7b5ac0037e42$var$_descriptor2 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "modifiedAnswer", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $386d7b5ac0037e42$var$_descriptor3 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "validating", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $386d7b5ac0037e42$var$_descriptor4 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "loading", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $386d7b5ac0037e42$var$_descriptor5 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "isUploadingMedia", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return false;
    }
}), $386d7b5ac0037e42$var$_descriptor6 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "choices", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $386d7b5ac0037e42$var$_descriptor7 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "answerChoicesAsObjects", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return [];
    }
}), $386d7b5ac0037e42$var$_descriptor8 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "dependentFieldChangedCount", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return 0;
    }
}), $386d7b5ac0037e42$var$_descriptor9 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "otherChoiceId", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $386d7b5ac0037e42$var$_descriptor10 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "revisionToken", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $386d7b5ac0037e42$var$_descriptor11 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "issueFieldData", [
    (0, $alnGD.observable)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "answerModified", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($386d7b5ac0037e42$var$_class.prototype, "answerModified"), $386d7b5ac0037e42$var$_class.prototype), (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "currentAnswer", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($386d7b5ac0037e42$var$_class.prototype, "currentAnswer"), $386d7b5ac0037e42$var$_class.prototype), (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "isAsyncChoicesField", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($386d7b5ac0037e42$var$_class.prototype, "isAsyncChoicesField"), $386d7b5ac0037e42$var$_class.prototype), (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "validationErrors", [
    (0, $alnGD.computed)
], Object.getOwnPropertyDescriptor($386d7b5ac0037e42$var$_class.prototype, "validationErrors"), $386d7b5ac0037e42$var$_class.prototype), $386d7b5ac0037e42$var$_descriptor12 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setLastUpdated", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return ()=>{
            this.revisionToken = `${this.id}-${Date.now()}`;
        };
    }
}), $386d7b5ac0037e42$var$_descriptor13 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setAnswer", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (answer, modifiedAnswer = true)=>{
            if (modifiedAnswer) {
                this.modifiedAnswer = answer;
                if (this.answerModified) {
                    var _this$onFieldDirty;
                    (_this$onFieldDirty = this.onFieldDirty) === null || _this$onFieldDirty === void 0 || _this$onFieldDirty.call(this);
                }
            } else {
                this.modifiedAnswer = undefined;
                this.answer = answer;
            }
            if ($386d7b5ac0037e42$var$isChoiceQuestionAnswer(answer) && answer.choiceObjects != null) this.setAnswerChoicesAsObjects(answer.choiceObjects);
            this.setLastUpdated();
            this.onFieldChange({
                jiraField: this.formQuestion.jiraField,
                questionType: this.formQuestion.type
            }, $386d7b5ac0037e42$export$4392c3957775e9f7(answer) || '');
        };
    }
}), $386d7b5ac0037e42$var$_descriptor14 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "doPopulateDefaultValueOnEmptySearch", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return ()=>{
            var _this$issueFieldData5;
            if (!this.populateDefaultValueOnEmptySearch || !((_this$issueFieldData5 = this.issueFieldData) !== null && _this$issueFieldData5 !== void 0 && _this$issueFieldData5.populateDefaultValueOnEmptySearch) || !this.isAsyncChoicesField) return Promise.resolve();
            this.loading = true;
            return this.loadChoicesAsync('').then((options)=>{
                var _this$formQuestion$va, _this$issueFieldData$2, _this$issueFieldData6;
                const choices = options.map($386d7b5ac0037e42$export$429c93ea52a8aa75.optionToChoice);
                const maxAllowedChoices = Math.min((_this$formQuestion$va = this.formQuestion.validation.mxs) !== null && _this$formQuestion$va !== void 0 ? _this$formQuestion$va : choices.length, (_this$issueFieldData$2 = (_this$issueFieldData6 = this.issueFieldData) === null || _this$issueFieldData6 === void 0 ? void 0 : _this$issueFieldData6.maxAllowedChoices) !== null && _this$issueFieldData$2 !== void 0 ? _this$issueFieldData$2 : choices.length);
                const validatedChoices = choices.splice(0, maxAllowedChoices);
                this.setAnswer({
                    choices: validatedChoices.map(({ id: id })=>id),
                    choiceObjects: validatedChoices
                }, false);
            }).finally(()=>{
                this.loading = false;
            });
        };
    }
}), $386d7b5ac0037e42$var$_descriptor15 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "onDependentFieldChanged", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return ()=>{
            this.dependentFieldChangedCount++;
        };
    }
}), $386d7b5ac0037e42$var$_descriptor16 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "validate", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return ()=>{
            this.validating = true;
        };
    }
}), $386d7b5ac0037e42$var$_descriptor17 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "hideValidation", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return ()=>{
            this.validating = false;
            this.setLastUpdated();
        };
    }
}), $386d7b5ac0037e42$var$_descriptor18 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setUploadingMedia", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (isUploadingMedia)=>{
            this.isUploadingMedia = isUploadingMedia;
        };
    }
}), $386d7b5ac0037e42$var$_descriptor19 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "discardModifiedAnswer", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return ()=>{
            this.modifiedAnswer = undefined;
            this.setLastUpdated();
        };
    }
}), $386d7b5ac0037e42$var$_descriptor20 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setAnswerFromFieldValue", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (answer)=>{
            this.answer = $386d7b5ac0037e42$var$extractAnswer(this.formQuestion.type, answer);
            this.modifiedAnswer = undefined;
            this.setLastUpdated();
        };
    }
}), $386d7b5ac0037e42$var$_descriptor21 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setChoices", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (choices)=>{
            // Populate choiceObjects in the existing answer for choices where only the ID was known previously (e.g. default answers).
            const currentAnswerChoices = this.getAnswerChoicesAsObjects().map($386d7b5ac0037e42$export$429c93ea52a8aa75.optionToChoice);
            const newAnswerChoices = choices.filter((choice)=>{
                var _toChoiceQuestionAnsw;
                return ((_toChoiceQuestionAnsw = $386d7b5ac0037e42$export$bb1c52eccaca93f1(this.currentAnswer)) === null || _toChoiceQuestionAnsw === void 0 ? void 0 : _toChoiceQuestionAnsw.choices.includes(choice.id)) && !currentAnswerChoices.some(({ id: id })=>id === choice.id);
            });
            this.setAnswerChoicesAsObjects([
                ...currentAnswerChoices,
                ...newAnswerChoices
            ]);
            this._setChoices(choices);
            this.setLastUpdated();
        };
    }
}), $386d7b5ac0037e42$var$_descriptor22 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setAnswerChoicesAsObjects", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (choices)=>{
            let sortedChoices;
            if (!this._isAsyncChoicesQuestion()) // sort in the same order as this.choices from API - to have same sorting order between Open and Submitted form states
            sortedChoices = choices.slice().sort((a, b)=>this.choices.findIndex((choice)=>choice.id === a.id) - this.choices.findIndex((choice)=>choice.id === b.id));
            else sortedChoices = choices.slice().sort($386d7b5ac0037e42$var$sortById); // same as at the BE
            this._setAnswerChoicesAsObjects(sortedChoices);
            this.setLastUpdated();
        };
    }
}), $386d7b5ac0037e42$var$_descriptor23 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "setIssueFieldData", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (issueFieldData)=>{
            this.issueFieldData = issueFieldData;
            this.setLastUpdated();
        };
    }
}), $386d7b5ac0037e42$var$_descriptor24 = (0, $7Jkpx.default)($386d7b5ac0037e42$var$_class.prototype, "update", [
    (0, $alnGD.action)
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return (formQuestion, currentAnswer)=>this._update(false, formQuestion, currentAnswer);
    }
}), $386d7b5ac0037e42$var$_class);

});
parcelRegister("jLSMy", function(module, exports) {

$parcel$export(module.exports, "ChoiceMessage", () => $e64ce6b26902a7d4$export$875538404f4123ab);
$parcel$export(module.exports, "IntlChoiceMessages", () => $e64ce6b26902a7d4$export$253372a934dae76);

var $7VHMR = parcelRequire("7VHMR");
let $e64ce6b26902a7d4$export$875538404f4123ab = /*#__PURE__*/ function(ChoiceMessage) {
    ChoiceMessage["OtherPlaceholder"] = "OtherPlaceholder";
    return ChoiceMessage;
}({});
const $e64ce6b26902a7d4$export$253372a934dae76 = (0, $7VHMR.defineMessages)({
    [$e64ce6b26902a7d4$export$875538404f4123ab.OtherPlaceholder]: {
        id: 'form-system.ChoiceQuestion.OtherPlaceholder',
        defaultMessage: 'Other...'
    }
});

});

parcelRegister("ctPpG", function(module, exports) {

$parcel$export(module.exports, "AFFECTED_SERVICES_SCHEMA_CUSTOM", () => $91601312dc4b477f$export$f38b84edab004d9a);
$parcel$export(module.exports, "CMDB_SCHEMA_CUSTOM", () => $91601312dc4b477f$export$701618b68a89ad17);
$parcel$export(module.exports, "LABELS_SCHEMA_CUSTOM", () => $91601312dc4b477f$export$9af6b0504e2cd927);
$parcel$export(module.exports, "LABELS_SCHEMA_SYSTEM", () => $91601312dc4b477f$export$65f164d21923031);
$parcel$export(module.exports, "asyncChoicesFieldSchemaCustoms", () => $91601312dc4b477f$export$e0a5682f246556b7);
$parcel$export(module.exports, "asyncChoicesFieldSchemaCustomsWithEntitlement", () => $91601312dc4b477f$export$ad017676e0b3e2e5);
$parcel$export(module.exports, "asyncChoicesFieldSchemaSystems", () => $91601312dc4b477f$export$4c6a5fe7f37267b9);
$parcel$export(module.exports, "isAsyncCreatable", () => $91601312dc4b477f$export$eb35d73dc2127303);
// Jira fields that should ONLY be rendered as dropdown multi-selects:
const $91601312dc4b477f$export$f38b84edab004d9a = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $91601312dc4b477f$export$701618b68a89ad17 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $91601312dc4b477f$export$9af6b0504e2cd927 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $91601312dc4b477f$export$65f164d21923031 = 'labels';
const $91601312dc4b477f$export$f98dadc49306934 = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $91601312dc4b477f$export$e0a5682f246556b7 = [
    $91601312dc4b477f$export$f38b84edab004d9a,
    $91601312dc4b477f$export$701618b68a89ad17,
    $91601312dc4b477f$export$9af6b0504e2cd927
];
const $91601312dc4b477f$export$ad017676e0b3e2e5 = [
    ...$91601312dc4b477f$export$e0a5682f246556b7,
    $91601312dc4b477f$export$f98dadc49306934
];
const $91601312dc4b477f$export$4c6a5fe7f37267b9 = [
    $91601312dc4b477f$export$65f164d21923031
];
const $91601312dc4b477f$export$eb35d73dc2127303 = (question)=>{
    var _question$issueFieldD, _question$issueFieldD2, _question$issueFieldD3, _question$issueFieldD4;
    return ((_question$issueFieldD = question.issueFieldData) === null || _question$issueFieldD === void 0 ? void 0 : (_question$issueFieldD2 = _question$issueFieldD.schema) === null || _question$issueFieldD2 === void 0 ? void 0 : _question$issueFieldD2.custom) === $91601312dc4b477f$export$9af6b0504e2cd927 || ((_question$issueFieldD3 = question.issueFieldData) === null || _question$issueFieldD3 === void 0 ? void 0 : (_question$issueFieldD4 = _question$issueFieldD3.schema) === null || _question$issueFieldD4 === void 0 ? void 0 : _question$issueFieldD4.system) === $91601312dc4b477f$export$65f164d21923031;
};

});

parcelRegister("djQya", function(module, exports) {

$parcel$export(module.exports, "getRichTextValidation", () => $9b25d012193ba90d$export$a4a4282c6e45fe75);
$parcel$export(module.exports, "getTextValidation", () => $9b25d012193ba90d$export$6d44ff6f0b04b047);
$parcel$export(module.exports, "getNumberValidation", () => $9b25d012193ba90d$export$26fbcce145c8b4e4);
$parcel$export(module.exports, "getDateValidation", () => $9b25d012193ba90d$export$8d4b85d34923a80b);
$parcel$export(module.exports, "getTimeValidation", () => $9b25d012193ba90d$export$a226e2ebf33a3dd5);
$parcel$export(module.exports, "getDateTimeValidation", () => $9b25d012193ba90d$export$1ff6abd4f0e07282);
$parcel$export(module.exports, "getChoiceValidation", () => $9b25d012193ba90d$export$9ec08da1d33bbc5e);
$parcel$export(module.exports, "getUserPickerValidation", () => $9b25d012193ba90d$export$6f9eb7b39b2f37de);
$parcel$export(module.exports, "getAttachmentValidation", () => $9b25d012193ba90d$export$1375a2241da0cd1);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fd9ep = parcelRequire("fd9ep");

var $8ELPZ = parcelRequire("8ELPZ");

var $hIzKv = parcelRequire("hIzKv");

var $507I3 = parcelRequire("507I3");

var $fHpHg = parcelRequire("fHpHg");

var $cnwtr = parcelRequire("cnwtr");

var $4aJmI = parcelRequire("4aJmI");

var $6lxfx = parcelRequire("6lxfx");

var $51KJm = parcelRequire("51KJm");
const $9b25d012193ba90d$var$wikiTransformer = new (0, $507I3.WikiMarkupTransformer)();
const $9b25d012193ba90d$var$jsonTransformer = new (0, $hIzKv.JSONTransformer)();
const $9b25d012193ba90d$export$a4a4282c6e45fe75 = (requirements, adf, questionType, fieldLabel)=>{
    const pmNode = $9b25d012193ba90d$var$jsonTransformer.parse(adf);
    return $9b25d012193ba90d$export$6d44ff6f0b04b047(requirements, $9b25d012193ba90d$var$wikiTransformer.encode(pmNode), questionType, fieldLabel);
};
const $9b25d012193ba90d$export$6d44ff6f0b04b047 = (requirements, text, questionType, fieldLabel)=>{
    const trimmedText = text.trim();
    let wordCount;
    if (requirements.mnw || requirements.mxw) wordCount = (0, $51KJm.wordCounter)(trimmedText);
    // text is empty AND a response is required (requirements.rq)
    if (trimmedText.length === 0) {
        if (requirements.rq) return fieldLabel && (0, $fHpHg.fg)('a11y_error_messages') ? [
            {
                key: (0, $6lxfx.ValidationErrorMsg).RequiredWithLabel,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).RequiredWithLabel], {
                    values: {
                        fieldLabel: fieldLabel
                    }
                }))
            }
        ] : [
            {
                key: (0, $6lxfx.ValidationErrorMsg).Required,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).Required])
            }
        ];
    } else {
        // the char count in the trimmed text does not match the char count in the validation rule
        if (requirements.mnc && requirements.mnc === requirements.mxc && trimmedText.length !== requirements.mnc) return [
            {
                key: (0, $6lxfx.TextValidationErrorMsg).ExactChars,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).ExactChars], {
                    values: {
                        mnc: requirements.mnc
                    }
                }))
            }
        ];
        // the word count in the trimmed text does not match the word count in the validation rule
        if (requirements.mnw && requirements.mnw === requirements.mxw && wordCount !== requirements.mnw) return [
            {
                key: (0, $6lxfx.TextValidationErrorMsg).ExactWords,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).ExactWords], {
                    values: {
                        mnw: requirements.mnw
                    }
                }))
            }
        ];
        // the char count in the trimmed text is outside the [min,max] range in the validation rule
        if (requirements.mnc && requirements.mxc && (trimmedText.length < requirements.mnc || trimmedText.length > requirements.mxc)) return [
            {
                key: (0, $6lxfx.TextValidationErrorMsg).BetweenChars,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).BetweenChars], {
                    values: {
                        mnc: requirements.mnc,
                        mxc: requirements.mxc
                    }
                }))
            }
        ];
        // the word count in the trimmed text is outside the [min,max] range in the validation rule
        if (requirements.mnw && requirements.mxw && wordCount && (wordCount < requirements.mnw || wordCount > requirements.mxw)) return [
            {
                key: (0, $6lxfx.TextValidationErrorMsg).BetweenWords,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).BetweenWords], {
                    values: {
                        mnw: requirements.mnw,
                        mxw: requirements.mxw
                    }
                }))
            }
        ];
        // the char count in the trimmed text is below the min value in the validation rule
        if (requirements.mnc && trimmedText.length < requirements.mnc) return [
            {
                key: (0, $6lxfx.TextValidationErrorMsg).MinChars,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).MinChars], {
                    values: {
                        mnc: requirements.mnc - 1
                    }
                }))
            }
        ];
         // Note: threshold is modified here to fit the validation error messages wording see (PF-1683)
        // the word count in the trimmed text is below the min value in the validation rule
        if (requirements.mnw && wordCount && wordCount < requirements.mnw) return [
            {
                key: (0, $6lxfx.TextValidationErrorMsg).MinWords,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).MinWords], {
                    values: {
                        mnw: requirements.mnw - 1
                    }
                }))
            }
        ];
         // Note: threshold is modified here to fit the validation error messages wording see (PF-1683)
        // the char count in the trimmed text is above the max value in the validation rule
        if (requirements.mxc && trimmedText.length > requirements.mxc) return [
            {
                key: (0, $6lxfx.TextValidationErrorMsg).MaxChars,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).MaxChars], {
                    values: {
                        mxc: requirements.mxc + 1
                    }
                }))
            }
        ];
         // Note: threshold is modified here to fit the validation error messages wording see (PF-1683)
        // the word count in the trimmed text is above the max value in the validation rule
        if (requirements.mxw && wordCount && wordCount > requirements.mxw) return [
            {
                key: (0, $6lxfx.TextValidationErrorMsg).MaxWords,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).MaxWords], {
                    values: {
                        mxw: requirements.mxw + 1
                    }
                }))
            }
        ];
         // Note: threshold is modified here to fit the validation error messages wording see (PF-1683)
        // a custom regex pattern was provided
        if (requirements.rgx && requirements.rgx.p) try {
            // don't use the trimmedText for regex validation
            if (!text.match(requirements.rgx.p)) {
                if (questionType === (0, $4aJmI.FormQuestionType).TextUrl) return [
                    {
                        key: (0, $6lxfx.TextValidationErrorMsg).InvalidUrl,
                        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).InvalidUrl])
                    }
                ];
                if (questionType === (0, $4aJmI.FormQuestionType).TextEmail) return [
                    {
                        key: (0, $6lxfx.TextValidationErrorMsg).InvalidEmail,
                        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).InvalidEmail])
                    }
                ];
                if (requirements.rgx.m) return [
                    {
                        key: (0, $6lxfx.TextValidationErrorMsg).RegexCustomMsg,
                        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).RegexCustomMsg], {
                            values: {
                                message: requirements.rgx.m
                            }
                        }))
                    }
                ];
                return [
                    {
                        key: (0, $6lxfx.TextValidationErrorMsg).RegexDefaultMsg,
                        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).RegexDefaultMsg])
                    }
                ];
            }
        } catch  {
            // eslint-disable-next-line no-console
            console.log(`Invalid regex: ${requirements.rgx.p}`);
            return [
                {
                    key: (0, $6lxfx.TextValidationErrorMsg).RegexInvalidMsg,
                    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.TextValidationErrorMsg).RegexInvalidMsg])
                }
            ];
        }
    }
};
const $9b25d012193ba90d$export$26fbcce145c8b4e4 = (requirements, value, fieldLabel)=>{
    if (value.length > 0 && !((0, (/*@__PURE__*/$parcel$interopDefault($8ELPZ)))(value) || (0, (/*@__PURE__*/$parcel$interopDefault($fd9ep)))(value))) return [
        {
            key: (0, $6lxfx.NumberValidationErrorMsg).InvalidNum,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.NumberValidationErrorMsg).InvalidNum])
        }
    ];
    // Remove number decorations
    const cleanNumber = value.replace(/[\,]/g, '');
    const number = parseFloat(cleanNumber);
    if (!value.length) {
        if (requirements.rq && value.length === 0) return fieldLabel && (0, $fHpHg.fg)('a11y_error_messages') ? [
            {
                key: (0, $6lxfx.ValidationErrorMsg).RequiredWithLabel,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).RequiredWithLabel], {
                    values: {
                        fieldLabel: fieldLabel
                    }
                }))
            }
        ] : [
            {
                key: (0, $6lxfx.ValidationErrorMsg).Required,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).Required])
            }
        ];
    } else {
        if (isNaN(number)) return [
            {
                key: (0, $6lxfx.NumberValidationErrorMsg).InvalidNum,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.NumberValidationErrorMsg).InvalidNum])
            }
        ];
        if (requirements.wh && !Number.isInteger(number)) return [
            {
                key: (0, $6lxfx.NumberValidationErrorMsg).WholeNum,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.NumberValidationErrorMsg).WholeNum])
            }
        ];
        // Check equal
        if (requirements.mnn && requirements.mnn === requirements.mxn && number !== requirements.mnn) return [
            {
                key: (0, $6lxfx.NumberValidationErrorMsg).ExactNum,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.NumberValidationErrorMsg).ExactNum], {
                    values: {
                        mnn: requirements.mnn
                    }
                }))
            }
        ];
        // check between
        if (requirements.mnn && requirements.mxn && (number < requirements.mnn || number > requirements.mxn)) return [
            {
                key: (0, $6lxfx.NumberValidationErrorMsg).BetweenNum,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.NumberValidationErrorMsg).BetweenNum], {
                    values: {
                        mnn: requirements.mnn,
                        mxn: requirements.mxn
                    }
                }))
            }
        ];
        if (requirements.mnn && number < requirements.mnn) return [
            {
                key: (0, $6lxfx.NumberValidationErrorMsg).MinNum,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.NumberValidationErrorMsg).MinNum], {
                    values: {
                        mnn: requirements.mnn
                    }
                }))
            }
        ];
        if (requirements.mxn && number > requirements.mxn) return [
            {
                key: (0, $6lxfx.NumberValidationErrorMsg).MaxNum,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.NumberValidationErrorMsg).MaxNum], {
                    values: {
                        mxn: requirements.mxn
                    }
                }))
            }
        ];
    }
};
const $9b25d012193ba90d$export$8d4b85d34923a80b = (requirements, dateValue, fieldLabel)=>{
    // Date values to be reused throughout the validation logic
    let minDate;
    let maxDate;
    let enteredDate;
    if (requirements.mnd) minDate = new Date((0, $cnwtr.convertDateFormatToSlashes)(requirements.mnd));
    if (requirements.mxd) maxDate = new Date((0, $cnwtr.convertDateFormatToSlashes)(requirements.mxd));
    // Boolean values for validation logic
    const hasExactDateRequirements = requirements.mnd && requirements.mnd === requirements.mxd;
    const hasBetweenDateRequirements = !!requirements.mnd && !!requirements.mxd;
    // Check if empty
    if (!dateValue && requirements.rq) return fieldLabel && (0, $fHpHg.fg)('a11y_error_messages') ? [
        {
            key: (0, $6lxfx.ValidationErrorMsg).RequiredWithLabel,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).RequiredWithLabel], {
                values: {
                    fieldLabel: fieldLabel
                }
            }))
        }
    ] : [
        {
            key: (0, $6lxfx.ValidationErrorMsg).Required,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).Required])
        }
    ];
    else {
        enteredDate = new Date((0, $cnwtr.convertDateFormatToSlashes)(dateValue));
        const validationErrors = [];
        if (hasExactDateRequirements && minDate) {
            if (enteredDate.valueOf() !== minDate.valueOf()) validationErrors.push({
                key: (0, $6lxfx.DateTimeValidationErrorMsg).ExactDate,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).ExactDate], {
                    values: {
                        mnd: minDate
                    }
                }))
            });
             // No need to compare with both max and min again
        } else if (hasBetweenDateRequirements && minDate && maxDate) // Between dates scenario
        {
            if (enteredDate < minDate || enteredDate > maxDate) validationErrors.push({
                key: (0, $6lxfx.DateTimeValidationErrorMsg).BetweenDate,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).BetweenDate], {
                    values: {
                        mnd: minDate,
                        mxd: maxDate
                    }
                }))
            });
        } else {
            if (requirements.mnd && minDate) {
                if (enteredDate < minDate) validationErrors.push({
                    key: (0, $6lxfx.DateTimeValidationErrorMsg).MinDate,
                    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).MinDate], {
                        values: {
                            mnd: minDate
                        }
                    }))
                });
            }
            if (requirements.mxd && maxDate) {
                if (enteredDate > maxDate) validationErrors.push({
                    key: (0, $6lxfx.DateTimeValidationErrorMsg).MaxDate,
                    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).MaxDate], {
                        values: {
                            mxd: maxDate
                        }
                    }))
                });
            }
        }
        if (validationErrors.length > 0) return validationErrors;
    }
};
const $9b25d012193ba90d$export$a226e2ebf33a3dd5 = (requirements, timeValue, fieldLabel)=>{
    if (!timeValue && requirements.rq) return fieldLabel && (0, $fHpHg.fg)('a11y_error_messages') ? [
        {
            key: (0, $6lxfx.ValidationErrorMsg).RequiredWithLabel,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).RequiredWithLabel], {
                values: {
                    fieldLabel: fieldLabel
                }
            }))
        }
    ] : [
        {
            key: (0, $6lxfx.ValidationErrorMsg).Required,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).Required])
        }
    ];
    else if (!!timeValue) {
        const time = new Date(`01/01/1999 ${timeValue}`); // Add arbitrary fixed date to allow Date() object creation
        const validationErrors = [];
        if (isNaN(time.getTime())) // Check time is valid
        validationErrors.push({
            key: (0, $6lxfx.DateTimeValidationErrorMsg).InvalidTime,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).InvalidTime])
        });
        else if (requirements.mnt && requirements.mnt === requirements.mxt) {
            // Exact time scenario
            const minTime = new Date(`01/01/1999 ${requirements.mnt}`);
            if (time.getTime() !== minTime.getTime()) validationErrors.push({
                key: (0, $6lxfx.DateTimeValidationErrorMsg).ExactTime,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).ExactTime], {
                    values: {
                        mnt: minTime
                    }
                }))
            });
        } else if (requirements.mnt && requirements.mxt) {
            // Between times scenario
            const minTime = new Date(`01/01/1999 ${requirements.mnt}`);
            const maxTime = new Date(`01/01/1999 ${requirements.mxt}`);
            if (time < minTime || time > maxTime) validationErrors.push({
                key: (0, $6lxfx.DateTimeValidationErrorMsg).BetweenTime,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).BetweenTime], {
                    values: {
                        mnt: minTime,
                        mxt: maxTime
                    }
                }))
            });
        } else {
            if (requirements.mnt) {
                const minTime = new Date(`01/01/1999 ${requirements.mnt}`);
                if (time < minTime) validationErrors.push({
                    key: (0, $6lxfx.DateTimeValidationErrorMsg).MinTime,
                    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).MinTime], {
                        values: {
                            mnt: minTime
                        }
                    }))
                });
            }
            if (requirements.mxt) {
                const maxTime = new Date(`01/01/1999 ${requirements.mxt}`);
                if (time > maxTime) validationErrors.push({
                    key: (0, $6lxfx.DateTimeValidationErrorMsg).MaxTime,
                    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).MaxTime], {
                        values: {
                            mxt: maxTime
                        }
                    }))
                });
            }
        }
        if (validationErrors.length > 0) return validationErrors;
    }
};
const $9b25d012193ba90d$export$1ff6abd4f0e07282 = (requirements, dateTime, fieldLabel)=>{
    // DateTime values to be reused throughout the validation logic
    let minDateTime;
    let maxDateTime;
    let enteredDateTime;
    if (requirements.mnd && requirements.mnt) minDateTime = new Date(`${(0, $cnwtr.convertDateFormatToSlashes)(requirements.mnd)} ${requirements.mnt}`);
    if (requirements.mxd && requirements.mxt) maxDateTime = new Date(`${(0, $cnwtr.convertDateFormatToSlashes)(requirements.mxd)} ${requirements.mxt}`);
    if (dateTime.date) enteredDateTime = new Date(`${(0, $cnwtr.convertDateFormatToSlashes)(dateTime.date)} ${dateTime.time}`);
    // Boolean values for validation logic
    const hasMinDateTimeRequirements = !!requirements.mnd && !!requirements.mnt;
    const hasMaxDateTimeRequirements = !!requirements.mxd && !!requirements.mxt;
    const hasExactDateTimeRequirements = hasMinDateTimeRequirements && requirements.mnd === requirements.mxd && requirements.mnt === requirements.mxt;
    const hasBetweenDateTimeRequirements = hasMinDateTimeRequirements && hasMaxDateTimeRequirements;
    // Date or time required
    if (requirements.rq && (!dateTime.date || !dateTime.time)) return fieldLabel && (0, $fHpHg.fg)('a11y_error_messages') ? [
        {
            key: (0, $6lxfx.DateTimeValidationErrorMsg).RequiredDateTimeWithLabel,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).RequiredDateTimeWithLabel], {
                values: {
                    fieldLabel: fieldLabel
                }
            }))
        }
    ] : [
        {
            key: (0, $6lxfx.DateTimeValidationErrorMsg).RequiredDateTime,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).RequiredDateTime])
        }
    ];
    if (hasExactDateTimeRequirements && minDateTime && enteredDateTime) {
        if (enteredDateTime.valueOf() !== minDateTime.valueOf()) return [
            {
                key: (0, $6lxfx.DateTimeValidationErrorMsg).ExactDateTime,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).ExactDateTime], {
                    values: {
                        mnd: new Date((0, $cnwtr.convertDateFormatToSlashes)(requirements.mnd || '')),
                        mnt: new Date(`01/01/1999 ${requirements.mnt}`)
                    }
                }))
            }
        ];
    } else if (hasBetweenDateTimeRequirements && minDateTime && maxDateTime && enteredDateTime) {
        if (enteredDateTime < minDateTime || enteredDateTime > maxDateTime) return [
            {
                key: (0, $6lxfx.DateTimeValidationErrorMsg).BetweenDateTime,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).BetweenDateTime], {
                    values: {
                        mnd: new Date((0, $cnwtr.convertDateFormatToSlashes)(requirements.mnd || '')),
                        mnt: new Date(`01/01/1999 ${requirements.mnt}`),
                        mxd: new Date((0, $cnwtr.convertDateFormatToSlashes)(requirements.mxd || '')),
                        mxt: new Date(`01/01/1999 ${requirements.mxt}`)
                    }
                }))
            }
        ];
    } else if (hasMinDateTimeRequirements || hasMaxDateTimeRequirements) {
        if (hasMinDateTimeRequirements && minDateTime && enteredDateTime) {
            if (enteredDateTime < minDateTime) return [
                {
                    key: (0, $6lxfx.DateTimeValidationErrorMsg).MinDateTime,
                    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).MinDateTime], {
                        values: {
                            mnd: new Date((0, $cnwtr.convertDateFormatToSlashes)(requirements.mnd || '')),
                            mnt: new Date(`01/01/1999 ${requirements.mnt}`)
                        }
                    }))
                }
            ];
        }
        // Max Date and time
        if (hasMaxDateTimeRequirements && enteredDateTime && maxDateTime) {
            if (enteredDateTime > maxDateTime) return [
                {
                    key: (0, $6lxfx.DateTimeValidationErrorMsg).MaxDateTime,
                    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.DateTimeValidationErrorMsg).MaxDateTime], {
                        values: {
                            mxd: new Date((0, $cnwtr.convertDateFormatToSlashes)(requirements.mxd || '')),
                            mxt: new Date(`01/01/1999 ${requirements.mxt}`)
                        }
                    }))
                }
            ];
        }
    } else {
        // Individual date and time validations
        const validationErrors = [];
        // Validate Date
        const dateValidationErrors = $9b25d012193ba90d$export$8d4b85d34923a80b(requirements, dateTime.date);
        if (dateValidationErrors) validationErrors.push(...dateValidationErrors);
        // Validate Time
        const timeValidationErrors = $9b25d012193ba90d$export$a226e2ebf33a3dd5(requirements, dateTime.time);
        if (timeValidationErrors) validationErrors.push(...timeValidationErrors);
        if (validationErrors.length > 0) return validationErrors;
    }
};
// Helper functions for choice validation
const $9b25d012193ba90d$var$choiceIsSelected = (selectedChoices, choiceId)=>{
    return selectedChoices.includes(choiceId) || selectedChoices.map((id)=>id.split(':')[0]).includes(choiceId.toString());
};
const $9b25d012193ba90d$export$9ec08da1d33bbc5e = (requirements, choices, choiceAnswers, asyncRequiredChoice, fieldLabel)=>{
    const numChoicesSelected = choiceAnswers.choices.length;
    // Validate required
    if (requirements.rq) {
        if (numChoicesSelected === 0) return fieldLabel && (0, $fHpHg.fg)('a11y_error_messages') ? [
            {
                key: (0, $6lxfx.ValidationErrorMsg).RequiredWithLabel,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).RequiredWithLabel], {
                    values: {
                        fieldLabel: fieldLabel
                    }
                }))
            }
        ] : [
            {
                key: (0, $6lxfx.ValidationErrorMsg).Required,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).Required])
            }
        ];
    }
    const validationErrors = [];
    if (numChoicesSelected !== 0) {
        if (requirements.mns && requirements.mns === requirements.mxs) // Check for exact num of choices
        {
            if (numChoicesSelected !== requirements.mns) validationErrors.push({
                key: (0, $6lxfx.ChoiceValidationErrorMsg).ExactChoices,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ChoiceValidationErrorMsg).ExactChoices], {
                    values: {
                        mns: requirements.mns
                    }
                }))
            });
        } else if (requirements.mns && requirements.mxs) // check for in between num of choices
        {
            if (numChoicesSelected < requirements.mns || numChoicesSelected > requirements.mxs) validationErrors.push({
                key: (0, $6lxfx.ChoiceValidationErrorMsg).BetweenChoices,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ChoiceValidationErrorMsg).BetweenChoices], {
                    values: {
                        mns: requirements.mns,
                        mxs: requirements.mxs
                    }
                }))
            });
        } else {
            // min or max num of choices
            if (requirements.mns && numChoicesSelected < requirements.mns) validationErrors.push({
                key: (0, $6lxfx.ChoiceValidationErrorMsg).MinChoices,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ChoiceValidationErrorMsg).MinChoices], {
                    values: {
                        mns: requirements.mns
                    }
                }))
            });
            if (requirements.mxs && numChoicesSelected > requirements.mxs) validationErrors.push({
                key: (0, $6lxfx.ChoiceValidationErrorMsg).MaxChoices,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ChoiceValidationErrorMsg).MaxChoices], {
                    values: {
                        mxs: requirements.mxs
                    }
                }))
            });
        }
        if (requirements.ch) {
            var _requiredChoice$child;
            // check for required choice
            const requiredChoice = asyncRequiredChoice !== null && asyncRequiredChoice !== void 0 ? asyncRequiredChoice : choices.find((choice)=>choice.id === requirements.ch || requirements.ch && choice.id === requirements.ch.split(':')[0]);
            // check for required child choice
            const requiredChildChoice = requiredChoice === null || requiredChoice === void 0 ? void 0 : (_requiredChoice$child = requiredChoice.children) === null || _requiredChoice$child === void 0 ? void 0 : _requiredChoice$child.find((child)=>{
                var _requirements$ch;
                return child.id === ((_requirements$ch = requirements.ch) === null || _requirements$ch === void 0 ? void 0 : _requirements$ch.split(':')[1]);
            });
            if (requiredChoice && !$9b25d012193ba90d$var$choiceIsSelected(choiceAnswers.choices, requirements.ch) && (!requirements.ch.includes(':') || requiredChildChoice)) validationErrors.push({
                key: (0, $6lxfx.ChoiceValidationErrorMsg).ReqChoice,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ChoiceValidationErrorMsg).ReqChoice], {
                    values: {
                        label: requiredChildChoice ? `${requiredChoice.label} - ${requiredChildChoice.label}` : requiredChoice.label
                    }
                }))
            });
        }
    }
    if (validationErrors.length > 0) return validationErrors;
};
const $9b25d012193ba90d$export$6f9eb7b39b2f37de = (requirements, userPickerAnswers, fieldLabel)=>{
    const numChoicesSelected = userPickerAnswers.length;
    if (requirements.rq) {
        if (numChoicesSelected === 0) return fieldLabel && (0, $fHpHg.fg)('a11y_error_messages') ? [
            {
                key: (0, $6lxfx.ValidationErrorMsg).RequiredWithLabel,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).RequiredWithLabel], {
                    values: {
                        fieldLabel: fieldLabel
                    }
                }))
            }
        ] : [
            {
                key: (0, $6lxfx.ValidationErrorMsg).Required,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).Required])
            }
        ];
    }
    const validationErrors = [];
    if (requirements.mns && requirements.mns === requirements.mxs) // Check for exact num of choices
    {
        if (numChoicesSelected !== requirements.mns) validationErrors.push({
            key: (0, $6lxfx.UserPickerValidationErrorMsg).ExactChoices,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.UserPickerValidationErrorMsg).ExactChoices], {
                values: {
                    mns: requirements.mns
                }
            }))
        });
    } else if (requirements.mns && requirements.mxs) // check for in between num of choices
    {
        if (numChoicesSelected < requirements.mns || numChoicesSelected > requirements.mxs) validationErrors.push({
            key: (0, $6lxfx.UserPickerValidationErrorMsg).BetweenChoices,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.UserPickerValidationErrorMsg).BetweenChoices], {
                values: {
                    mns: requirements.mns,
                    mxs: requirements.mxs
                }
            }))
        });
    } else {
        // min or max num of choices
        if (requirements.mns && numChoicesSelected < requirements.mns) validationErrors.push({
            key: (0, $6lxfx.UserPickerValidationErrorMsg).MinChoices,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.UserPickerValidationErrorMsg).MinChoices], {
                values: {
                    mns: requirements.mns
                }
            }))
        });
        if (requirements.mxs && numChoicesSelected > requirements.mxs) validationErrors.push({
            key: (0, $6lxfx.UserPickerValidationErrorMsg).MaxChoices,
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.UserPickerValidationErrorMsg).MaxChoices], {
                values: {
                    mxs: requirements.mxs
                }
            }))
        });
    }
    if (validationErrors.length > 0) return validationErrors;
};
const $9b25d012193ba90d$export$1375a2241da0cd1 = (requirements, files, questionType, fieldLabel)=>{
    if (requirements.rq && questionType === 'at') {
        if (files.length === 0) return fieldLabel && (0, $fHpHg.fg)('a11y_error_messages') ? [
            {
                key: (0, $6lxfx.ValidationErrorMsg).RequiredWithLabel,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).RequiredWithLabel], {
                    values: {
                        fieldLabel: fieldLabel
                    }
                }))
            }
        ] : [
            {
                key: (0, $6lxfx.ValidationErrorMsg).Required,
                message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6lxfx.IntlValidationErrorMessages)[(0, $6lxfx.ValidationErrorMsg).Required])
            }
        ];
    }
};

});
parcelRegister("fd9ep", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b12f3b12c8b53ed3$var$isDecimal;

var $iRYdY = parcelRequire("iRYdY");
var $b12f3b12c8b53ed3$var$_merge2 = $b12f3b12c8b53ed3$var$_interopRequireDefault($iRYdY);

var $7oCN8 = parcelRequire("7oCN8");
var $b12f3b12c8b53ed3$var$_assertString2 = $b12f3b12c8b53ed3$var$_interopRequireDefault($7oCN8);

var $hTHDP = parcelRequire("hTHDP");
function $b12f3b12c8b53ed3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b12f3b12c8b53ed3$var$decimalRegExp(options) {
    var regExp = new RegExp('^[-+]?([0-9]+)?(\\' + $hTHDP.decimal[options.locale] + '[0-9]{' + options.decimal_digits + '})' + (options.force_decimal ? '' : '?') + '$');
    return regExp;
}
var $b12f3b12c8b53ed3$var$default_decimal_options = {
    force_decimal: false,
    decimal_digits: '1,',
    locale: 'en-US'
};
var $b12f3b12c8b53ed3$var$blacklist = [
    '',
    '-',
    '+'
];
function $b12f3b12c8b53ed3$var$isDecimal(str, options) {
    (0, $b12f3b12c8b53ed3$var$_assertString2.default)(str);
    options = (0, $b12f3b12c8b53ed3$var$_merge2.default)(options, $b12f3b12c8b53ed3$var$default_decimal_options);
    if (options.locale in $hTHDP.decimal) return !$b12f3b12c8b53ed3$var$blacklist.includes(str.replace(/ /g, '')) && $b12f3b12c8b53ed3$var$decimalRegExp(options).test(str);
    throw new Error('Invalid locale \'' + options.locale + '\'');
}
module.exports = module.exports['default'];

});
parcelRegister("iRYdY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dbcbe48af9e82c0e$var$merge;
function $dbcbe48af9e82c0e$var$merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments[1];
    for(var key in defaults)if (typeof obj[key] === 'undefined') obj[key] = defaults[key];
    return obj;
}
module.exports = module.exports['default'];

});

parcelRegister("7oCN8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5628dd7c3b681d30$var$assertString;
function $5628dd7c3b681d30$var$assertString(input) {
    var isString = typeof input === 'string' || input instanceof String;
    if (!isString) throw new TypeError('This library (validator.js) validates strings only');
}
module.exports = module.exports['default'];

});

parcelRegister("hTHDP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d0796d009721feb4$var$alpha = module.exports.alpha = {
    'en-US': /^[A-Z]+$/i,
    'bg-BG': /^[А-Я]+$/i,
    'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    'da-DK': /^[A-ZÆØÅ]+$/i,
    'de-DE': /^[A-ZÄÖÜß]+$/i,
    'el-GR': /^[Α-ω]+$/i,
    'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    'nb-NO': /^[A-ZÆØÅ]+$/i,
    'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    'nn-NO': /^[A-ZÆØÅ]+$/i,
    'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
    'ru-RU': /^[А-ЯЁ]+$/i,
    'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
    'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
    'sv-SE': /^[A-ZÅÄÖ]+$/i,
    'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
    'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
};
var $d0796d009721feb4$var$alphanumeric = module.exports.alphanumeric = {
    'en-US': /^[0-9A-Z]+$/i,
    'bg-BG': /^[0-9А-Я]+$/i,
    'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    'da-DK': /^[0-9A-ZÆØÅ]+$/i,
    'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
    'el-GR': /^[0-9Α-ω]+$/i,
    'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
    'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
    'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
    'ru-RU': /^[0-9А-ЯЁ]+$/i,
    'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
    'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
    'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
};
var $d0796d009721feb4$var$decimal = module.exports.decimal = {
    'en-US': '.',
    ar: "\u066B"
};
var $d0796d009721feb4$var$englishLocales = module.exports.englishLocales = [
    'AU',
    'GB',
    'HK',
    'IN',
    'NZ',
    'ZA',
    'ZM'
];
for(var $d0796d009721feb4$var$locale, $d0796d009721feb4$var$i = 0; $d0796d009721feb4$var$i < $d0796d009721feb4$var$englishLocales.length; $d0796d009721feb4$var$i++){
    $d0796d009721feb4$var$locale = 'en-' + $d0796d009721feb4$var$englishLocales[$d0796d009721feb4$var$i];
    $d0796d009721feb4$var$alpha[$d0796d009721feb4$var$locale] = $d0796d009721feb4$var$alpha['en-US'];
    $d0796d009721feb4$var$alphanumeric[$d0796d009721feb4$var$locale] = $d0796d009721feb4$var$alphanumeric['en-US'];
    $d0796d009721feb4$var$decimal[$d0796d009721feb4$var$locale] = $d0796d009721feb4$var$decimal['en-US'];
}
// Source: http://www.localeplanet.com/java/
var $d0796d009721feb4$var$arabicLocales = module.exports.arabicLocales = [
    'AE',
    'BH',
    'DZ',
    'EG',
    'IQ',
    'JO',
    'KW',
    'LB',
    'LY',
    'MA',
    'QM',
    'QA',
    'SA',
    'SD',
    'SY',
    'TN',
    'YE'
];
for(var $d0796d009721feb4$var$_locale, $d0796d009721feb4$var$_i = 0; $d0796d009721feb4$var$_i < $d0796d009721feb4$var$arabicLocales.length; $d0796d009721feb4$var$_i++){
    $d0796d009721feb4$var$_locale = 'ar-' + $d0796d009721feb4$var$arabicLocales[$d0796d009721feb4$var$_i];
    $d0796d009721feb4$var$alpha[$d0796d009721feb4$var$_locale] = $d0796d009721feb4$var$alpha.ar;
    $d0796d009721feb4$var$alphanumeric[$d0796d009721feb4$var$_locale] = $d0796d009721feb4$var$alphanumeric.ar;
    $d0796d009721feb4$var$decimal[$d0796d009721feb4$var$_locale] = $d0796d009721feb4$var$decimal.ar;
}
// Source: https://en.wikipedia.org/wiki/Decimal_mark
var $d0796d009721feb4$var$dotDecimal = module.exports.dotDecimal = [];
var $d0796d009721feb4$var$commaDecimal = module.exports.commaDecimal = [
    'bg-BG',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'el-GR',
    'es-ES',
    'fr-FR',
    'it-IT',
    'hu-HU',
    'nb-NO',
    'nn-NO',
    'nl-NL',
    'pl-Pl',
    'pt-PT',
    'ru-RU',
    'sr-RS@latin',
    'sr-RS',
    'sv-SE',
    'tr-TR',
    'uk-UA'
];
for(var $d0796d009721feb4$var$_i2 = 0; $d0796d009721feb4$var$_i2 < $d0796d009721feb4$var$dotDecimal.length; $d0796d009721feb4$var$_i2++)$d0796d009721feb4$var$decimal[$d0796d009721feb4$var$dotDecimal[$d0796d009721feb4$var$_i2]] = $d0796d009721feb4$var$decimal['en-US'];
for(var $d0796d009721feb4$var$_i3 = 0; $d0796d009721feb4$var$_i3 < $d0796d009721feb4$var$commaDecimal.length; $d0796d009721feb4$var$_i3++)$d0796d009721feb4$var$decimal[$d0796d009721feb4$var$commaDecimal[$d0796d009721feb4$var$_i3]] = ',';
$d0796d009721feb4$var$alpha['pt-BR'] = $d0796d009721feb4$var$alpha['pt-PT'];
$d0796d009721feb4$var$alphanumeric['pt-BR'] = $d0796d009721feb4$var$alphanumeric['pt-PT'];
$d0796d009721feb4$var$decimal['pt-BR'] = $d0796d009721feb4$var$decimal['pt-PT'];

});


parcelRegister("8ELPZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $64d72ab15b72a9b7$var$isNumeric;

var $7oCN8 = parcelRequire("7oCN8");
var $64d72ab15b72a9b7$var$_assertString2 = $64d72ab15b72a9b7$var$_interopRequireDefault($7oCN8);
function $64d72ab15b72a9b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $64d72ab15b72a9b7$var$numeric = /^[-+]?[0-9]+$/;
function $64d72ab15b72a9b7$var$isNumeric(str) {
    (0, $64d72ab15b72a9b7$var$_assertString2.default)(str);
    return $64d72ab15b72a9b7$var$numeric.test(str);
}
module.exports = module.exports['default'];

});

parcelRegister("cnwtr", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $9030d2a8015fc5dc$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "convertDateFormatToSlashes", () => $9030d2a8015fc5dc$export$9ed21541b7ef1a9f);
const $9030d2a8015fc5dc$export$9a1adf421b69c6a = (x)=>{
    return !!x;
};
const $9030d2a8015fc5dc$export$f44a717c401a878a = ()=>{
    if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
};
const $9030d2a8015fc5dc$export$61fc7d43ac8f84b0 = (func, wait, immediate)=>{
    var timeout;
    return function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this;
        const args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
const $9030d2a8015fc5dc$export$9ed21541b7ef1a9f = (date)=>{
    return date.replace(/-/g, '/');
};

});

parcelRegister("6lxfx", function(module, exports) {

$parcel$export(module.exports, "ValidationErrorMsg", () => $49ee7ee62244437f$export$918e8d988e50ccc0);
$parcel$export(module.exports, "NumberValidationErrorMsg", () => $49ee7ee62244437f$export$29e4a6c62db1e0ba);
$parcel$export(module.exports, "TextValidationErrorMsg", () => $49ee7ee62244437f$export$66fb68ff0427090f);
$parcel$export(module.exports, "DateTimeValidationErrorMsg", () => $49ee7ee62244437f$export$ae02ba97d418070);
$parcel$export(module.exports, "ChoiceValidationErrorMsg", () => $49ee7ee62244437f$export$c8f7f52f47b04c93);
$parcel$export(module.exports, "UserPickerValidationErrorMsg", () => $49ee7ee62244437f$export$ef5d979bfd00ccfc);
$parcel$export(module.exports, "IntlValidationErrorMessages", () => $49ee7ee62244437f$export$40d5a30c6400de7b);

var $7VHMR = parcelRequire("7VHMR");
let $49ee7ee62244437f$export$918e8d988e50ccc0 = /*#__PURE__*/ function(ValidationErrorMsg) {
    ValidationErrorMsg["Required"] = "Required";
    ValidationErrorMsg["RequiredWithLabel"] = "RequiredWithLabel";
    ValidationErrorMsg["FormSave"] = "FormSave";
    return ValidationErrorMsg;
}({});
let $49ee7ee62244437f$export$29e4a6c62db1e0ba = /*#__PURE__*/ function(NumberValidationErrorMsg) {
    NumberValidationErrorMsg["WholeNum"] = "WholeNum";
    NumberValidationErrorMsg["MinNum"] = "MinNum";
    NumberValidationErrorMsg["MaxNum"] = "MaxNum";
    NumberValidationErrorMsg["BetweenNum"] = "BetweenNum";
    NumberValidationErrorMsg["ExactNum"] = "ExactNum";
    NumberValidationErrorMsg["InvalidNum"] = "InvalidNum";
    return NumberValidationErrorMsg;
}({});
let $49ee7ee62244437f$export$66fb68ff0427090f = /*#__PURE__*/ function(TextValidationErrorMsg) {
    TextValidationErrorMsg["MinChars"] = "MinChars";
    TextValidationErrorMsg["MaxChars"] = "MaxChars";
    TextValidationErrorMsg["BetweenChars"] = "BetweenChars";
    TextValidationErrorMsg["ExactChars"] = "ExactChars";
    TextValidationErrorMsg["MinWords"] = "MinWords";
    TextValidationErrorMsg["MaxWords"] = "MaxWords";
    TextValidationErrorMsg["BetweenWords"] = "BetweenWords";
    TextValidationErrorMsg["ExactWords"] = "ExactWords";
    TextValidationErrorMsg["RegexCustomMsg"] = "RegexCustomMsg";
    TextValidationErrorMsg["RegexDefaultMsg"] = "RegexDefaultMSg";
    TextValidationErrorMsg["RegexInvalidMsg"] = "RegexInvalidMsg";
    TextValidationErrorMsg["InvalidEmail"] = "InvalidEmail";
    TextValidationErrorMsg["InvalidUrl"] = "InvalidUrl";
    return TextValidationErrorMsg;
}({});
let $49ee7ee62244437f$export$ae02ba97d418070 = /*#__PURE__*/ function(DateTimeValidationErrorMsg) {
    DateTimeValidationErrorMsg["MinDate"] = "MinDate";
    DateTimeValidationErrorMsg["MaxDate"] = "MaxDate";
    DateTimeValidationErrorMsg["BetweenDate"] = "BetweenDate";
    DateTimeValidationErrorMsg["ExactDate"] = "ExactDate";
    DateTimeValidationErrorMsg["MinTime"] = "MinTime";
    DateTimeValidationErrorMsg["MaxTime"] = "MaxTime";
    DateTimeValidationErrorMsg["BetweenTime"] = "BetweenTime";
    DateTimeValidationErrorMsg["ExactTime"] = "ExactTime";
    DateTimeValidationErrorMsg["InvalidTime"] = "InvalidTime";
    DateTimeValidationErrorMsg["RequiredDateTime"] = "RequiredDateTime";
    DateTimeValidationErrorMsg["RequiredDateTimeWithLabel"] = "RequiredDateTimeWithLabel";
    DateTimeValidationErrorMsg["MinDateTime"] = "MinDateTime";
    DateTimeValidationErrorMsg["MaxDateTime"] = "MaxDateTime";
    DateTimeValidationErrorMsg["ExactDateTime"] = "ExactDateTime";
    DateTimeValidationErrorMsg["BetweenDateTime"] = "BetweenDateTime";
    return DateTimeValidationErrorMsg;
}({});
let $49ee7ee62244437f$export$c8f7f52f47b04c93 = /*#__PURE__*/ function(ChoiceValidationErrorMsg) {
    ChoiceValidationErrorMsg["MinChoices"] = "MinChoices";
    ChoiceValidationErrorMsg["MaxChoices"] = "MaxChoices";
    ChoiceValidationErrorMsg["ReqChoice"] = "ReqChoice";
    ChoiceValidationErrorMsg["ExactChoices"] = "ExactChoices";
    ChoiceValidationErrorMsg["BetweenChoices"] = "BetweenChoices";
    return ChoiceValidationErrorMsg;
}({});
let $49ee7ee62244437f$export$ef5d979bfd00ccfc = /*#__PURE__*/ function(UserPickerValidationErrorMsg) {
    UserPickerValidationErrorMsg["MinChoices"] = "UpMinChoices";
    UserPickerValidationErrorMsg["MaxChoices"] = "UpMaxChoices";
    UserPickerValidationErrorMsg["ExactChoices"] = "UpExactChoices";
    UserPickerValidationErrorMsg["BetweenChoices"] = "UpBetweenChoices";
    return UserPickerValidationErrorMsg;
}({});
const $49ee7ee62244437f$export$40d5a30c6400de7b = (0, $7VHMR.defineMessages)({
    //
    // General Validation messages
    //
    [$49ee7ee62244437f$export$918e8d988e50ccc0.RequiredWithLabel]: {
        id: 'form-system.validationErrorMsg.RequiredWithLabel',
        defaultMessage: '{fieldLabel} is required.'
    },
    [$49ee7ee62244437f$export$918e8d988e50ccc0.Required]: {
        id: 'form-system.validationErrorMsg.Required',
        defaultMessage: 'This field is required.'
    },
    //
    // Text Validation messages
    //
    [$49ee7ee62244437f$export$66fb68ff0427090f.MinChars]: {
        id: 'form-system.validationErrorMsg.text.MinChars',
        defaultMessage: 'Must be more than {mnc, plural, one {# character} other {# characters}}.'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.MinWords]: {
        id: 'form-system.validationErrorMsg.text.MinWords',
        defaultMessage: 'Must be more than {mnw, plural, one {# word} other {# words}}.'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.MaxChars]: {
        id: 'form-system.validationErrorMsg.text.MaxChars',
        defaultMessage: 'Must be less than {mxc, plural, one {# character} other {# characters}}.'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.MaxWords]: {
        id: 'form-system.validationErrorMsg.text.MaxWords',
        defaultMessage: 'Must be less than {mxw, plural, one {# word} other {# words}}.'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.BetweenChars]: {
        id: 'form-system.validationErrorMsg.text.BetweenChars',
        defaultMessage: 'Must be between {mnc} and {mxc, plural, one {# character} other {# characters}}.'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.ExactChars]: {
        id: 'form-system.validationErrorMsg.text.ExactChars',
        defaultMessage: 'Must be exactly {mnc, plural, one {# character} other {# characters}}.'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.BetweenWords]: {
        id: 'form-system.validationErrorMsg.text.BetweenWords',
        defaultMessage: 'Must be between {mnw} and {mxw, plural, one {# word} other {# words}}.'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.ExactWords]: {
        id: 'form-system.validationErrorMsg.text.ExactWords',
        defaultMessage: 'Must be exactly {mnw, plural, one {# word} other {# words}}.'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.RegexCustomMsg]: {
        id: 'form-system.validationErrorMsg.text.RegexCustomMsg',
        defaultMessage: '{message}'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.RegexDefaultMsg]: {
        id: 'form-system.validationErrorMsg.text.RegexDefaultMsg',
        defaultMessage: 'Response does not match required pattern.'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.RegexInvalidMsg]: {
        id: 'form-system.validationErrorMsg.text.RegexInvalidMsg',
        defaultMessage: 'The regex pattern on this field is invalid. Answer unable to be validated.'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.InvalidEmail]: {
        id: 'form-system.validationErrorMsg.text.InvalidEmail',
        defaultMessage: 'Must be an email address'
    },
    [$49ee7ee62244437f$export$66fb68ff0427090f.InvalidUrl]: {
        id: 'form-system.validationErrorMsg.text.InvalidUrl',
        defaultMessage: 'Must be a valid URL e.g. https://www.google.com/images'
    },
    //
    // Number validation messages
    //
    [$49ee7ee62244437f$export$29e4a6c62db1e0ba.InvalidNum]: {
        id: 'form-system.validationErrorMsg.number.InvalidNum',
        defaultMessage: 'Please enter a valid number.'
    },
    [$49ee7ee62244437f$export$29e4a6c62db1e0ba.WholeNum]: {
        id: 'form-system.validationErrorMsg.number.WholeNum',
        defaultMessage: 'Must be a whole number.'
    },
    [$49ee7ee62244437f$export$29e4a6c62db1e0ba.MinNum]: {
        id: 'form-system.validationErrorMsg.number.MinNum',
        defaultMessage: 'Must be more than or equal to {mnn}.'
    },
    [$49ee7ee62244437f$export$29e4a6c62db1e0ba.MaxNum]: {
        id: 'form-system.validationErrorMsg.number.MaxNum',
        defaultMessage: 'Must be less than or equal to {mxn}.'
    },
    [$49ee7ee62244437f$export$29e4a6c62db1e0ba.BetweenNum]: {
        id: 'form-system.validationErrorMsg.number.BetweenNum',
        defaultMessage: 'Must be between {mnn} and {mxn}.'
    },
    [$49ee7ee62244437f$export$29e4a6c62db1e0ba.ExactNum]: {
        id: 'form-system.validationErrorMsg.number.ExactNum',
        defaultMessage: 'Must be exactly {mnn}.'
    },
    //
    // DateTime validation messages
    //
    [$49ee7ee62244437f$export$ae02ba97d418070.RequiredDateTimeWithLabel]: {
        id: 'form-system.validationErrorMsg.datetime.RequiredDateTimeWithLabel',
        defaultMessage: '{fieldLabel} is required. Please specify a date and time.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.RequiredDateTime]: {
        id: 'form-system.validationErrorMsg.datetime.RequiredDateTime',
        defaultMessage: 'This field is required. Please specify a date and time.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.ExactDateTime]: {
        id: 'form-system.validationErrorMsg.datetime.ExactDateTime',
        defaultMessage: 'The date and time must be exactly the {mnd, date, medium} at {mnt, time, short}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.BetweenDateTime]: {
        id: 'form-system.validationErrorMsg.datetime.BetweenDateTime',
        defaultMessage: 'The date and time must be between the {mnd, date, medium} at {mnt, time, short} and the {mxd, date, medium} at {mxt, time, short}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.MinDateTime]: {
        id: 'form-system.validationErrorMsg.datetime.MinDateTime',
        defaultMessage: 'The date and time must be on or after the {mnd, date, medium} at {mnt, time, short}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.MaxDateTime]: {
        id: 'form-system.validationErrorMsg.datetime.MaxDateTime',
        defaultMessage: 'The date and time must be on or before the {mxd, date, medium} at {mxt, time, short}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.MinDate]: {
        id: 'form-system.validationErrorMsg.datetime.MinDate',
        defaultMessage: 'The date must be on or after {mnd, date, medium}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.MaxDate]: {
        id: 'form-system.validationErrorMsg.datetime.MaxDate',
        defaultMessage: 'The date must be on or before {mxd, date, medium}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.BetweenDate]: {
        id: 'form-system.validationErrorMsg.datetime.BetweenDate',
        defaultMessage: 'The date must be between {mnd, date, medium} and {mxd, date, medium}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.ExactDate]: {
        id: 'form-system.validationErrorMsg.datetime.ExactDate',
        defaultMessage: 'The date must be exactly {mnd, date, medium}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.MinTime]: {
        id: 'form-system.validationErrorMsg.datetime.MinTime',
        defaultMessage: 'The time must be at or after {mnt, time, short}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.MaxTime]: {
        id: 'form-system.validationErrorMsg.datetime.MaxTime',
        defaultMessage: 'The time must be at or before {mxt, time, short}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.BetweenTime]: {
        id: 'form-system.validationErrorMsg.datetime.BetweenTime',
        defaultMessage: 'The time must be between {mnt, time, short} and {mxt, time, short}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.ExactTime]: {
        id: 'form-system.validationErrorMsg.datetime.ExactTime',
        defaultMessage: 'The time must be exactly {mnt, time, short}.'
    },
    [$49ee7ee62244437f$export$ae02ba97d418070.InvalidTime]: {
        id: 'form-system.validationErrorMsg.datetime.InvalidTime',
        defaultMessage: 'The time is invalid.'
    },
    //
    // Choice validation messages
    //
    [$49ee7ee62244437f$export$c8f7f52f47b04c93.ExactChoices]: {
        id: 'form-system.validationErrorMsg.choice.ExactChoices',
        defaultMessage: 'Choose exactly {mns}.'
    },
    [$49ee7ee62244437f$export$c8f7f52f47b04c93.BetweenChoices]: {
        id: 'form-system.validationErrorMsg.choice.BetweenChoices',
        defaultMessage: 'Choose between {mns} and {mxs}.'
    },
    [$49ee7ee62244437f$export$c8f7f52f47b04c93.MinChoices]: {
        id: 'form-system.validationErrorMsg.choice.MinChoices',
        defaultMessage: 'Choose at least {mns}.'
    },
    [$49ee7ee62244437f$export$c8f7f52f47b04c93.MaxChoices]: {
        id: 'form-system.validationErrorMsg.choice.MaxChoices',
        defaultMessage: 'Choose no more than {mxs}.'
    },
    [$49ee7ee62244437f$export$c8f7f52f47b04c93.ReqChoice]: {
        id: 'form-system.validationErrorMsg.choice.ReqChoice',
        defaultMessage: "The \u2018{label}\u2019 choice is required."
    },
    //
    // User Picker validation messages
    //
    [$49ee7ee62244437f$export$ef5d979bfd00ccfc.ExactChoices]: {
        id: 'form-system.validationErrorMsg.userpicker.ExactChoices',
        defaultMessage: 'Choose exactly {mns, plural, one {# user} other {# users}}.'
    },
    [$49ee7ee62244437f$export$ef5d979bfd00ccfc.BetweenChoices]: {
        id: 'form-system.validationErrorMsg.userpicker.BetweenChoices',
        defaultMessage: 'Choose between {mns} and {mxs, plural, one {# user} other{# users}}.'
    },
    [$49ee7ee62244437f$export$ef5d979bfd00ccfc.MinChoices]: {
        id: 'form-system.validationErrorMsg.userpicker.MinChoices',
        defaultMessage: 'Choose at least {mns, plural, one {# user} other {# users}}.'
    },
    [$49ee7ee62244437f$export$ef5d979bfd00ccfc.MaxChoices]: {
        id: 'form-system.validationErrorMsg.userpicker.MaxChoices',
        defaultMessage: 'Choose no more than {mxs, plural, one {# user} other {# users}}.'
    }
});

});

parcelRegister("51KJm", function(module, exports) {

$parcel$export(module.exports, "wordCounter", () => $3a914b7ad8a24eb7$export$85cf3a3ba4c43fc4);
const $3a914b7ad8a24eb7$export$85cf3a3ba4c43fc4 = (text)=>{
    const filteredWords = text.trim().replace(/['";:,.?¿\-!¡]+/g, '');
    return filteredWords ? (filteredWords.match(/\S+/g) || []).length : 0;
};

});




parcelRegister("iPJqX", function(module, exports) {

$parcel$export(module.exports, "getCmdbFieldValueMap", () => $db603b9cdd007a8c$export$2b093d36da44d0ce);

var $4aJmI = parcelRequire("4aJmI");

var $4QmvR = parcelRequire("4QmvR");

var $4QmvR = parcelRequire("4QmvR");
const $db603b9cdd007a8c$var$getCmdbContextValue = (question)=>{
    var _toChoiceQuestionAnsw, _toUserPickerQuestion;
    switch(question.formQuestion.type){
        case (0, $4aJmI.FormQuestionType).TextShort:
        case (0, $4aJmI.FormQuestionType).TextLong:
        case (0, $4aJmI.FormQuestionType).TextParagraph:
        case (0, $4aJmI.FormQuestionType).TextEmail:
        case (0, $4aJmI.FormQuestionType).TextUrl:
        case (0, $4aJmI.FormQuestionType).Date:
        case (0, $4aJmI.FormQuestionType).Number:
            return (0, $4QmvR.toTextQuestionAnswer)(question.currentAnswer);
        case (0, $4aJmI.FormQuestionType).ChoiceDropdown:
        case (0, $4aJmI.FormQuestionType).ChoiceSingle:
        case (0, $4aJmI.FormQuestionType).ChoiceMultiple:
        case (0, $4aJmI.FormQuestionType).ChoiceDropdownMultiple:
        case (0, $4aJmI.FormQuestionType).CmdbObject:
            return (_toChoiceQuestionAnsw = (0, $4QmvR.toChoiceQuestionAnswer)(question.currentAnswer)) === null || _toChoiceQuestionAnsw === void 0 ? void 0 : _toChoiceQuestionAnsw.choices.join(',');
        case (0, $4aJmI.FormQuestionType).UserSingle:
        case (0, $4aJmI.FormQuestionType).UserMultiple:
            return (_toUserPickerQuestion = (0, $4QmvR.toUserPickerQuestionAnswer)(question.currentAnswer)) === null || _toUserPickerQuestion === void 0 ? void 0 : _toUserPickerQuestion.map(({ id: id })=>id).join(',');
        default:
            return undefined;
    }
};
const $db603b9cdd007a8c$export$2b093d36da44d0ce = (form)=>{
    const cmdbFieldValueMap = {};
    form.questions.forEach((question)=>{
        if (question.formQuestion.jiraField) {
            const cmdbContextValue = $db603b9cdd007a8c$var$getCmdbContextValue(question);
            if (cmdbContextValue !== undefined) cmdbFieldValueMap[question.formQuestion.jiraField] = cmdbContextValue;
        }
    });
    return cmdbFieldValueMap;
};

});

parcelRegister("3G30a", function(module, exports) {

$parcel$export(module.exports, "loadChoicesAsyncFn", () => $2ad79f68e5b2ef37$export$21296cd1cc9ee2ae);

var $5uXOq = parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $fHpHg = parcelRequire("fHpHg");


var $aNTEp = parcelRequire("aNTEp");

var $erWXD = parcelRequire("erWXD");
const $2ad79f68e5b2ef37$export$21296cd1cc9ee2ae = (jiraFieldsSearchOptionFns, errorUtils, createAnalyticsEvent, showFlag)=>{
    return (formStore)=>{
        return (questionId, query)=>{
            try {
                // Find the question and load the search choices.
                for (const questionStore of formStore.questions)if (questionStore.id === questionId && questionStore.formQuestion.jiraField) {
                    var _questionStore$issueF, _questionStore$issueF2, _questionStore$issueF3, _questionStore$issueF4;
                    const searchOptions = ((_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 ? void 0 : (_questionStore$issueF2 = _questionStore$issueF.schema) === null || _questionStore$issueF2 === void 0 ? void 0 : _questionStore$issueF2.custom) && jiraFieldsSearchOptionFns.custom[questionStore.issueFieldData.schema.custom] || ((_questionStore$issueF3 = questionStore.issueFieldData) === null || _questionStore$issueF3 === void 0 ? void 0 : (_questionStore$issueF4 = _questionStore$issueF3.schema) === null || _questionStore$issueF4 === void 0 ? void 0 : _questionStore$issueF4.system) && jiraFieldsSearchOptionFns.system[questionStore.issueFieldData.schema.system] || undefined;
                    if (searchOptions !== undefined) {
                        const { searchOptionsFn: searchOptionsFn, onSearchError: onSearchError } = searchOptions;
                        return searchOptionsFn(questionStore.formQuestion.jiraField, query, questionStore.issueFieldData, formStore).then((options)=>{
                            var _questionStore$issueF5, _questionStore$issueF6, _questionStore$issueF7, _questionStore$issueF8, _questionStore$issueF9;
                            questionStore.setChoices(options.map((option)=>({
                                    id: option.value,
                                    label: option.label,
                                    ...(0, $fHpHg.fg)('proforma_asset_fields_show_selected_attributes') ? {
                                        cmdbObject: option.cmdbObject
                                    } : {}
                                })));
                            (0, $aNTEp.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).SEARCH_ASYNC_CHOICES} ${(0, $erWXD.Action).FINISHED}`, {
                                schemaKey: (_questionStore$issueF5 = (_questionStore$issueF6 = questionStore.issueFieldData) === null || _questionStore$issueF6 === void 0 ? void 0 : (_questionStore$issueF7 = _questionStore$issueF6.schema) === null || _questionStore$issueF7 === void 0 ? void 0 : _questionStore$issueF7.system) !== null && _questionStore$issueF5 !== void 0 ? _questionStore$issueF5 : (_questionStore$issueF8 = questionStore.issueFieldData) === null || _questionStore$issueF8 === void 0 ? void 0 : (_questionStore$issueF9 = _questionStore$issueF8.schema) === null || _questionStore$issueF9 === void 0 ? void 0 : _questionStore$issueF9.custom
                            });
                            return options;
                        }).catch((error)=>{
                            var _questionStore$issueF10, _questionStore$issueF11, _questionStore$issueF12, _questionStore$issueF13, _questionStore$issueF14;
                            errorUtils.reportError(error, {
                                id: (0, $erWXD.ActionSubject).SEARCH_ASYNC_CHOICES,
                                attributes: {
                                    schemaKey: (_questionStore$issueF10 = (_questionStore$issueF11 = questionStore.issueFieldData) === null || _questionStore$issueF11 === void 0 ? void 0 : (_questionStore$issueF12 = _questionStore$issueF11.schema) === null || _questionStore$issueF12 === void 0 ? void 0 : _questionStore$issueF12.system) !== null && _questionStore$issueF10 !== void 0 ? _questionStore$issueF10 : (_questionStore$issueF13 = questionStore.issueFieldData) === null || _questionStore$issueF13 === void 0 ? void 0 : (_questionStore$issueF14 = _questionStore$issueF13.schema) === null || _questionStore$issueF14 === void 0 ? void 0 : _questionStore$issueF14.custom
                                }
                            });
                            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                            if (error.error) {
                                // assume ApiError
                                const flag = onSearchError === null || onSearchError === void 0 ? void 0 : onSearchError(error);
                                if (flag) showFlag({
                                    title: flag.title,
                                    description: flag.description,
                                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                                        spacing: "spacious",
                                        label: "Error",
                                        color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$4a7404f376229999)})`
                                    }),
                                    isAutoDismiss: true
                                });
                            }
                            return Promise.resolve([]);
                        });
                    }
                }
                throw new Error('`questionId` not found while trying to load search choices.');
            } catch (error) {
                errorUtils.reportError(error, {
                    id: (0, $erWXD.ActionSubject).SEARCH_ASYNC_CHOICES
                });
                return Promise.resolve([]);
            }
        };
    };
};

});

parcelRegister("c66GK", function(module, exports) {

$parcel$export(module.exports, "loadChoicesFn", () => $8ceb3bc5f7614ba5$export$fc6667e6aad0d9af);

var $aNTEp = parcelRequire("aNTEp");

var $erWXD = parcelRequire("erWXD");

var $4aJmI = parcelRequire("4aJmI");

var $5e1Fe = parcelRequire("5e1Fe");
const $8ceb3bc5f7614ba5$export$fc6667e6aad0d9af = (getFormChoices, errorUtils, loadFormChoicesForASubmittedForm = true, createAnalyticsEvent)=>{
    return (formStore)=>{
        return (questionId, query)=>{
            if (!loadFormChoicesForASubmittedForm && formStore.status !== (0, $4aJmI.FormStatus).Open) // When a form is submitted, the choices are stored within the questions.
            return Promise.resolve();
            // map jiraField to QuestionStore[] for easy lookup of all questions which are linked to a Jira field.
            const jiraFieldQuestionMap = new Map();
            // map jiraField to QuestionStore[] for easy lookup of all questions which are linked to a data connection.
            const dataConnectionQuestionMap = new Map();
            // Allocate out each linked choice question to either the appropriate map.
            formStore.questions.forEach((question)=>{
                if (!questionId || questionId === question.id) {
                    if (question.formQuestion.jiraField && $8ceb3bc5f7614ba5$var$isChoiceType(question.formQuestion.type)) {
                        let questionStores;
                        if (jiraFieldQuestionMap.has(question.formQuestion.jiraField)) questionStores = jiraFieldQuestionMap.get(question.formQuestion.jiraField);
                        else {
                            questionStores = [];
                            jiraFieldQuestionMap.set(question.formQuestion.jiraField, questionStores);
                        }
                        questionStores.push(question);
                    }
                    if (question.formQuestion.dcId) {
                        let questionStores = dataConnectionQuestionMap.get(question.formQuestion.dcId);
                        if (questionStores === undefined) {
                            questionStores = [];
                            dataConnectionQuestionMap.set(question.formQuestion.dcId, questionStores);
                        }
                        questionStores.push(question);
                    }
                }
            });
            const lookups = [];
            // Retrieve formStore choices from the backend if there are any linked choice fields handled by ProForma
            if (jiraFieldQuestionMap.size > 0 || dataConnectionQuestionMap.size > 0) lookups.push(getFormChoices(formStore.templateFormId, formStore.formId).then((response)=>{
                const validationResult = (0, $5e1Fe.validate)('ApiFormChoicesResponseSchema', response);
                if (!validationResult.isValid) {
                    errorUtils.reportError(new Error('Response type mismatch'), {
                        id: 'ApiFormChoicesResponseSchema',
                        attributes: {
                            errors: JSON.stringify(validationResult.errors)
                        }
                    });
                    return;
                }
                const { fields: fields, dataConnections: dataConnections } = response;
                jiraFieldQuestionMap.forEach((questionStores, jiraField)=>{
                    if (fields[jiraField]) questionStores.forEach((questionStore)=>questionStore.setChoices(fields[jiraField]));
                });
                dataConnectionQuestionMap.forEach((questionStores, dcId)=>{
                    if (dataConnections[dcId]) questionStores.forEach((questionStore)=>{
                        questionStore.setChoices(dataConnections[dcId]);
                    });
                    else if (createAnalyticsEvent) (0, $aNTEp.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM_FIELD_CHOICES_DATA_CONNECTION} ${(0, $erWXD.Action).FAILED}`, {
                        formId: formStore.formId,
                        templateFormId: formStore.templateFormId,
                        dcId: dcId
                    });
                });
            }));
            return Promise.all(lookups).then((_)=>{});
        };
    };
};
function $8ceb3bc5f7614ba5$var$isChoiceType(questionType) {
    return questionType === (0, $4aJmI.FormQuestionType).ChoiceCascading || questionType === (0, $4aJmI.FormQuestionType).ChoiceDropdown || questionType === (0, $4aJmI.FormQuestionType).ChoiceSingle || questionType === (0, $4aJmI.FormQuestionType).ChoiceMultiple || questionType === (0, $4aJmI.FormQuestionType).ChoiceDropdownMultiple;
}

});
parcelRegister("5e1Fe", function(module, exports) {

$parcel$export(module.exports, "validate", () => $3cdf8cfb98827350$export$a22775fa5e2eebd9);

var $hWnzn = parcelRequire("hWnzn");

var $jngaF = parcelRequire("jngaF");

var $Z8Nv6 = parcelRequire("Z8Nv6");

const $3cdf8cfb98827350$var$ajv = new (0, (/*@__PURE__*/$parcel$interopDefault($hWnzn)))({
    allErrors: true,
    coerceTypes: false,
    format: 'fast',
    nullable: true,
    schemaId: 'auto',
    unicode: true,
    uniqueItems: true,
    useDefaults: true
}).addMetaSchema((parcelRequire("9uYSm")));
const $3cdf8cfb98827350$var$schemas = {
    ApiFieldDataResponseSchema: $jngaF.ApiFieldDataResponseSchema,
    ApiFormChoicesResponseSchema: $Z8Nv6.ApiFormChoicesResponseSchema
};
const $3cdf8cfb98827350$export$a22775fa5e2eebd9 = (schema, data)=>{
    var _ajv$errors;
    const schemaInUse = $3cdf8cfb98827350$var$schemas[schema];
    const isValid = !!$3cdf8cfb98827350$var$ajv.validate(schemaInUse, data);
    return {
        isValid: isValid,
        errors: (_ajv$errors = $3cdf8cfb98827350$var$ajv.errors) !== null && _ajv$errors !== void 0 ? _ajv$errors : undefined
    };
};

});
parcelRegister("hWnzn", function(module, exports) {
'use strict';

var $5FvFt = parcelRequire("5FvFt");

var $jugvk = parcelRequire("jugvk");

var $dpNWO = parcelRequire("dpNWO");

var $sJD4s = parcelRequire("sJD4s");

var $fkrBp = parcelRequire("fkrBp");

var $VK0gq = parcelRequire("VK0gq");

var $bDkiI = parcelRequire("bDkiI");

var $6iZXf = parcelRequire("6iZXf");

var $iDk2u = parcelRequire("iDk2u");
module.exports = $d0fa22dfd3a49ce0$var$Ajv;
$d0fa22dfd3a49ce0$var$Ajv.prototype.validate = $d0fa22dfd3a49ce0$var$validate;
$d0fa22dfd3a49ce0$var$Ajv.prototype.compile = $d0fa22dfd3a49ce0$var$compile;
$d0fa22dfd3a49ce0$var$Ajv.prototype.addSchema = $d0fa22dfd3a49ce0$var$addSchema;
$d0fa22dfd3a49ce0$var$Ajv.prototype.addMetaSchema = $d0fa22dfd3a49ce0$var$addMetaSchema;
$d0fa22dfd3a49ce0$var$Ajv.prototype.validateSchema = $d0fa22dfd3a49ce0$var$validateSchema;
$d0fa22dfd3a49ce0$var$Ajv.prototype.getSchema = $d0fa22dfd3a49ce0$var$getSchema;
$d0fa22dfd3a49ce0$var$Ajv.prototype.removeSchema = $d0fa22dfd3a49ce0$var$removeSchema;
$d0fa22dfd3a49ce0$var$Ajv.prototype.addFormat = $d0fa22dfd3a49ce0$var$addFormat;
$d0fa22dfd3a49ce0$var$Ajv.prototype.errorsText = $d0fa22dfd3a49ce0$var$errorsText;
$d0fa22dfd3a49ce0$var$Ajv.prototype._addSchema = $d0fa22dfd3a49ce0$var$_addSchema;
$d0fa22dfd3a49ce0$var$Ajv.prototype._compile = $d0fa22dfd3a49ce0$var$_compile;

$d0fa22dfd3a49ce0$var$Ajv.prototype.compileAsync = (parcelRequire("9M3ly"));

var $8y08O = parcelRequire("8y08O");
$d0fa22dfd3a49ce0$var$Ajv.prototype.addKeyword = $8y08O.add;
$d0fa22dfd3a49ce0$var$Ajv.prototype.getKeyword = $8y08O.get;
$d0fa22dfd3a49ce0$var$Ajv.prototype.removeKeyword = $8y08O.remove;
$d0fa22dfd3a49ce0$var$Ajv.prototype.validateKeyword = $8y08O.validate;

var $fWa4K = parcelRequire("fWa4K");
$d0fa22dfd3a49ce0$var$Ajv.ValidationError = $fWa4K.Validation;
$d0fa22dfd3a49ce0$var$Ajv.MissingRefError = $fWa4K.MissingRef;
$d0fa22dfd3a49ce0$var$Ajv.$dataMetaSchema = $6iZXf;
var $d0fa22dfd3a49ce0$var$META_SCHEMA_ID = 'http://json-schema.org/draft-07/schema';
var $d0fa22dfd3a49ce0$var$META_IGNORE_OPTIONS = [
    'removeAdditional',
    'useDefaults',
    'coerceTypes',
    'strictDefaults'
];
var $d0fa22dfd3a49ce0$var$META_SUPPORT_DATA = [
    '/properties'
];
/**
 * Creates validator instance.
 * Usage: `Ajv(opts)`
 * @param {Object} opts optional options
 * @return {Object} ajv instance
 */ function $d0fa22dfd3a49ce0$var$Ajv(opts) {
    if (!(this instanceof $d0fa22dfd3a49ce0$var$Ajv)) return new $d0fa22dfd3a49ce0$var$Ajv(opts);
    opts = this._opts = $iDk2u.copy(opts) || {};
    $d0fa22dfd3a49ce0$var$setLogger(this);
    this._schemas = {};
    this._refs = {};
    this._fragments = {};
    this._formats = $VK0gq(opts.format);
    this._cache = opts.cache || new $dpNWO;
    this._loadingSchemas = {};
    this._compilations = [];
    this.RULES = $bDkiI();
    this._getId = $d0fa22dfd3a49ce0$var$chooseGetId(opts);
    opts.loopRequired = opts.loopRequired || Infinity;
    if (opts.errorDataPath == 'property') opts._errorDataPathProperty = true;
    if (opts.serialize === undefined) opts.serialize = $fkrBp;
    this._metaOpts = $d0fa22dfd3a49ce0$var$getMetaSchemaOptions(this);
    if (opts.formats) $d0fa22dfd3a49ce0$var$addInitialFormats(this);
    if (opts.keywords) $d0fa22dfd3a49ce0$var$addInitialKeywords(this);
    $d0fa22dfd3a49ce0$var$addDefaultMetaSchema(this);
    if (typeof opts.meta == 'object') this.addMetaSchema(opts.meta);
    if (opts.nullable) this.addKeyword('nullable', {
        metaSchema: {
            type: 'boolean'
        }
    });
    $d0fa22dfd3a49ce0$var$addInitialSchemas(this);
}
/**
 * Validate data using schema
 * Schema will be compiled and cached (using serialized JSON as key. [fast-json-stable-stringify](https://github.com/epoberezkin/fast-json-stable-stringify) is used to serialize.
 * @this   Ajv
 * @param  {String|Object} schemaKeyRef key, ref or schema object
 * @param  {Any} data to be validated
 * @return {Boolean} validation result. Errors from the last validation will be available in `ajv.errors` (and also in compiled schema: `schema.errors`).
 */ function $d0fa22dfd3a49ce0$var$validate(schemaKeyRef, data) {
    var v;
    if (typeof schemaKeyRef == 'string') {
        v = this.getSchema(schemaKeyRef);
        if (!v) throw new Error('no schema with key or ref "' + schemaKeyRef + '"');
    } else {
        var schemaObj = this._addSchema(schemaKeyRef);
        v = schemaObj.validate || this._compile(schemaObj);
    }
    var valid = v(data);
    if (v.$async !== true) this.errors = v.errors;
    return valid;
}
/**
 * Create validating function for passed schema.
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Boolean} _meta true if schema is a meta-schema. Used internally to compile meta schemas of custom keywords.
 * @return {Function} validating function
 */ function $d0fa22dfd3a49ce0$var$compile(schema, _meta) {
    var schemaObj = this._addSchema(schema, undefined, _meta);
    return schemaObj.validate || this._compile(schemaObj);
}
/**
 * Adds schema to the instance.
 * @this   Ajv
 * @param {Object|Array} schema schema or array of schemas. If array is passed, `key` and other parameters will be ignored.
 * @param {String} key Optional schema key. Can be passed to `validate` method instead of schema object or id/ref. One schema per instance can have empty `id` and `key`.
 * @param {Boolean} _skipValidation true to skip schema validation. Used internally, option validateSchema should be used instead.
 * @param {Boolean} _meta true if schema is a meta-schema. Used internally, addMetaSchema should be used instead.
 * @return {Ajv} this for method chaining
 */ function $d0fa22dfd3a49ce0$var$addSchema(schema, key, _skipValidation, _meta) {
    if (Array.isArray(schema)) {
        for(var i = 0; i < schema.length; i++)this.addSchema(schema[i], undefined, _skipValidation, _meta);
        return this;
    }
    var id = this._getId(schema);
    if (id !== undefined && typeof id != 'string') throw new Error('schema id must be string');
    key = $jugvk.normalizeId(key || id);
    $d0fa22dfd3a49ce0$var$checkUnique(this, key);
    this._schemas[key] = this._addSchema(schema, _skipValidation, _meta, true);
    return this;
}
/**
 * Add schema that will be used to validate other schemas
 * options in META_IGNORE_OPTIONS are alway set to false
 * @this   Ajv
 * @param {Object} schema schema object
 * @param {String} key optional schema key
 * @param {Boolean} skipValidation true to skip schema validation, can be used to override validateSchema option for meta-schema
 * @return {Ajv} this for method chaining
 */ function $d0fa22dfd3a49ce0$var$addMetaSchema(schema, key, skipValidation) {
    this.addSchema(schema, key, skipValidation, true);
    return this;
}
/**
 * Validate schema
 * @this   Ajv
 * @param {Object} schema schema to validate
 * @param {Boolean} throwOrLogError pass true to throw (or log) an error if invalid
 * @return {Boolean} true if schema is valid
 */ function $d0fa22dfd3a49ce0$var$validateSchema(schema, throwOrLogError) {
    var $schema = schema.$schema;
    if ($schema !== undefined && typeof $schema != 'string') throw new Error('$schema must be a string');
    $schema = $schema || this._opts.defaultMeta || $d0fa22dfd3a49ce0$var$defaultMeta(this);
    if (!$schema) {
        this.logger.warn('meta-schema not available');
        this.errors = null;
        return true;
    }
    var valid = this.validate($schema, schema);
    if (!valid && throwOrLogError) {
        var message = 'schema is invalid: ' + this.errorsText();
        if (this._opts.validateSchema == 'log') this.logger.error(message);
        else throw new Error(message);
    }
    return valid;
}
function $d0fa22dfd3a49ce0$var$defaultMeta(self) {
    var meta = self._opts.meta;
    self._opts.defaultMeta = typeof meta == 'object' ? self._getId(meta) || meta : self.getSchema($d0fa22dfd3a49ce0$var$META_SCHEMA_ID) ? $d0fa22dfd3a49ce0$var$META_SCHEMA_ID : undefined;
    return self._opts.defaultMeta;
}
/**
 * Get compiled schema from the instance by `key` or `ref`.
 * @this   Ajv
 * @param  {String} keyRef `key` that was passed to `addSchema` or full schema reference (`schema.id` or resolved id).
 * @return {Function} schema validating function (with property `schema`).
 */ function $d0fa22dfd3a49ce0$var$getSchema(keyRef) {
    var schemaObj = $d0fa22dfd3a49ce0$var$_getSchemaObj(this, keyRef);
    switch(typeof schemaObj){
        case 'object':
            return schemaObj.validate || this._compile(schemaObj);
        case 'string':
            return this.getSchema(schemaObj);
        case 'undefined':
            return $d0fa22dfd3a49ce0$var$_getSchemaFragment(this, keyRef);
    }
}
function $d0fa22dfd3a49ce0$var$_getSchemaFragment(self, ref) {
    var res = $jugvk.schema.call(self, {
        schema: {}
    }, ref);
    if (res) {
        var schema = res.schema, root = res.root, baseId = res.baseId;
        var v = $5FvFt.call(self, schema, root, undefined, baseId);
        self._fragments[ref] = new $sJD4s({
            ref: ref,
            fragment: true,
            schema: schema,
            root: root,
            baseId: baseId,
            validate: v
        });
        return v;
    }
}
function $d0fa22dfd3a49ce0$var$_getSchemaObj(self, keyRef) {
    keyRef = $jugvk.normalizeId(keyRef);
    return self._schemas[keyRef] || self._refs[keyRef] || self._fragments[keyRef];
}
/**
 * Remove cached schema(s).
 * If no parameter is passed all schemas but meta-schemas are removed.
 * If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
 * Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
 * @this   Ajv
 * @param  {String|Object|RegExp} schemaKeyRef key, ref, pattern to match key/ref or schema object
 * @return {Ajv} this for method chaining
 */ function $d0fa22dfd3a49ce0$var$removeSchema(schemaKeyRef) {
    if (schemaKeyRef instanceof RegExp) {
        $d0fa22dfd3a49ce0$var$_removeAllSchemas(this, this._schemas, schemaKeyRef);
        $d0fa22dfd3a49ce0$var$_removeAllSchemas(this, this._refs, schemaKeyRef);
        return this;
    }
    switch(typeof schemaKeyRef){
        case 'undefined':
            $d0fa22dfd3a49ce0$var$_removeAllSchemas(this, this._schemas);
            $d0fa22dfd3a49ce0$var$_removeAllSchemas(this, this._refs);
            this._cache.clear();
            return this;
        case 'string':
            var schemaObj = $d0fa22dfd3a49ce0$var$_getSchemaObj(this, schemaKeyRef);
            if (schemaObj) this._cache.del(schemaObj.cacheKey);
            delete this._schemas[schemaKeyRef];
            delete this._refs[schemaKeyRef];
            return this;
        case 'object':
            var serialize = this._opts.serialize;
            var cacheKey = serialize ? serialize(schemaKeyRef) : schemaKeyRef;
            this._cache.del(cacheKey);
            var id = this._getId(schemaKeyRef);
            if (id) {
                id = $jugvk.normalizeId(id);
                delete this._schemas[id];
                delete this._refs[id];
            }
    }
    return this;
}
function $d0fa22dfd3a49ce0$var$_removeAllSchemas(self, schemas, regex) {
    for(var keyRef in schemas){
        var schemaObj = schemas[keyRef];
        if (!schemaObj.meta && (!regex || regex.test(keyRef))) {
            self._cache.del(schemaObj.cacheKey);
            delete schemas[keyRef];
        }
    }
}
/* @this   Ajv */ function $d0fa22dfd3a49ce0$var$_addSchema(schema, skipValidation, meta, shouldAddSchema) {
    if (typeof schema != 'object' && typeof schema != 'boolean') throw new Error('schema should be object or boolean');
    var serialize = this._opts.serialize;
    var cacheKey = serialize ? serialize(schema) : schema;
    var cached = this._cache.get(cacheKey);
    if (cached) return cached;
    shouldAddSchema = shouldAddSchema || this._opts.addUsedSchema !== false;
    var id = $jugvk.normalizeId(this._getId(schema));
    if (id && shouldAddSchema) $d0fa22dfd3a49ce0$var$checkUnique(this, id);
    var willValidate = this._opts.validateSchema !== false && !skipValidation;
    var recursiveMeta;
    if (willValidate && !(recursiveMeta = id && id == $jugvk.normalizeId(schema.$schema))) this.validateSchema(schema, true);
    var localRefs = $jugvk.ids.call(this, schema);
    var schemaObj = new $sJD4s({
        id: id,
        schema: schema,
        localRefs: localRefs,
        cacheKey: cacheKey,
        meta: meta
    });
    if (id[0] != '#' && shouldAddSchema) this._refs[id] = schemaObj;
    this._cache.put(cacheKey, schemaObj);
    if (willValidate && recursiveMeta) this.validateSchema(schema, true);
    return schemaObj;
}
/* @this   Ajv */ function $d0fa22dfd3a49ce0$var$_compile(schemaObj, root) {
    if (schemaObj.compiling) {
        schemaObj.validate = callValidate;
        callValidate.schema = schemaObj.schema;
        callValidate.errors = null;
        callValidate.root = root ? root : callValidate;
        if (schemaObj.schema.$async === true) callValidate.$async = true;
        return callValidate;
    }
    schemaObj.compiling = true;
    var currentOpts;
    if (schemaObj.meta) {
        currentOpts = this._opts;
        this._opts = this._metaOpts;
    }
    var v;
    try {
        v = $5FvFt.call(this, schemaObj.schema, root, schemaObj.localRefs);
    } catch (e) {
        delete schemaObj.validate;
        throw e;
    } finally{
        schemaObj.compiling = false;
        if (schemaObj.meta) this._opts = currentOpts;
    }
    schemaObj.validate = v;
    schemaObj.refs = v.refs;
    schemaObj.refVal = v.refVal;
    schemaObj.root = v.root;
    return v;
    /* @this   {*} - custom context, see passContext option */ function callValidate() {
        /* jshint validthis: true */ var _validate = schemaObj.validate;
        var result = _validate.apply(this, arguments);
        callValidate.errors = _validate.errors;
        return result;
    }
}
function $d0fa22dfd3a49ce0$var$chooseGetId(opts) {
    switch(opts.schemaId){
        case 'auto':
            return $d0fa22dfd3a49ce0$var$_get$IdOrId;
        case 'id':
            return $d0fa22dfd3a49ce0$var$_getId;
        default:
            return $d0fa22dfd3a49ce0$var$_get$Id;
    }
}
/* @this   Ajv */ function $d0fa22dfd3a49ce0$var$_getId(schema) {
    if (schema.$id) this.logger.warn('schema $id ignored', schema.$id);
    return schema.id;
}
/* @this   Ajv */ function $d0fa22dfd3a49ce0$var$_get$Id(schema) {
    if (schema.id) this.logger.warn('schema id ignored', schema.id);
    return schema.$id;
}
function $d0fa22dfd3a49ce0$var$_get$IdOrId(schema) {
    if (schema.$id && schema.id && schema.$id != schema.id) throw new Error('schema $id is different from id');
    return schema.$id || schema.id;
}
/**
 * Convert array of error message objects to string
 * @this   Ajv
 * @param  {Array<Object>} errors optional array of validation errors, if not passed errors from the instance are used.
 * @param  {Object} options optional options with properties `separator` and `dataVar`.
 * @return {String} human readable string with all errors descriptions
 */ function $d0fa22dfd3a49ce0$var$errorsText(errors, options) {
    errors = errors || this.errors;
    if (!errors) return 'No errors';
    options = options || {};
    var separator = options.separator === undefined ? ', ' : options.separator;
    var dataVar = options.dataVar === undefined ? 'data' : options.dataVar;
    var text = '';
    for(var i = 0; i < errors.length; i++){
        var e = errors[i];
        if (e) text += dataVar + e.dataPath + ' ' + e.message + separator;
    }
    return text.slice(0, -separator.length);
}
/**
 * Add custom format
 * @this   Ajv
 * @param {String} name format name
 * @param {String|RegExp|Function} format string is converted to RegExp; function should return boolean (true when valid)
 * @return {Ajv} this for method chaining
 */ function $d0fa22dfd3a49ce0$var$addFormat(name, format) {
    if (typeof format == 'string') format = new RegExp(format);
    this._formats[name] = format;
    return this;
}


function $d0fa22dfd3a49ce0$var$addDefaultMetaSchema(self) {
    var $dataSchema;
    if (self._opts.$data) {
        $dataSchema = (parcelRequire("gQ2Dr"));
        self.addMetaSchema($dataSchema, $dataSchema.$id, true);
    }
    if (self._opts.meta === false) return;
    var metaSchema = (parcelRequire("6UkVC"));
    if (self._opts.$data) metaSchema = $6iZXf(metaSchema, $d0fa22dfd3a49ce0$var$META_SUPPORT_DATA);
    self.addMetaSchema(metaSchema, $d0fa22dfd3a49ce0$var$META_SCHEMA_ID, true);
    self._refs['http://json-schema.org/schema'] = $d0fa22dfd3a49ce0$var$META_SCHEMA_ID;
}
function $d0fa22dfd3a49ce0$var$addInitialSchemas(self) {
    var optsSchemas = self._opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) self.addSchema(optsSchemas);
    else for(var key in optsSchemas)self.addSchema(optsSchemas[key], key);
}
function $d0fa22dfd3a49ce0$var$addInitialFormats(self) {
    for(var name in self._opts.formats){
        var format = self._opts.formats[name];
        self.addFormat(name, format);
    }
}
function $d0fa22dfd3a49ce0$var$addInitialKeywords(self) {
    for(var name in self._opts.keywords){
        var keyword = self._opts.keywords[name];
        self.addKeyword(name, keyword);
    }
}
function $d0fa22dfd3a49ce0$var$checkUnique(self, id) {
    if (self._schemas[id] || self._refs[id]) throw new Error('schema with key or id "' + id + '" already exists');
}
function $d0fa22dfd3a49ce0$var$getMetaSchemaOptions(self) {
    var metaOpts = $iDk2u.copy(self._opts);
    for(var i = 0; i < $d0fa22dfd3a49ce0$var$META_IGNORE_OPTIONS.length; i++)delete metaOpts[$d0fa22dfd3a49ce0$var$META_IGNORE_OPTIONS[i]];
    return metaOpts;
}
function $d0fa22dfd3a49ce0$var$setLogger(self) {
    var logger = self._opts.logger;
    if (logger === false) self.logger = {
        log: $d0fa22dfd3a49ce0$var$noop,
        warn: $d0fa22dfd3a49ce0$var$noop,
        error: $d0fa22dfd3a49ce0$var$noop
    };
    else {
        if (logger === undefined) logger = console;
        if (!(typeof logger == 'object' && logger.log && logger.warn && logger.error)) throw new Error('logger must implement log, warn and error methods');
        self.logger = logger;
    }
}
function $d0fa22dfd3a49ce0$var$noop() {}

});
parcelRegister("5FvFt", function(module, exports) {
'use strict';

var $jugvk = parcelRequire("jugvk");

var $iDk2u = parcelRequire("iDk2u");

var $fWa4K = parcelRequire("fWa4K");

var $fkrBp = parcelRequire("fkrBp");

var $46Gbg = parcelRequire("46Gbg");
/**
 * Functions below are used inside compiled validations function
 */ var $420958a7bdd2fe67$var$ucs2length = $iDk2u.ucs2length;

var $1SBaA = parcelRequire("1SBaA");
// this error is thrown by async schemas to return validation errors via exception
var $420958a7bdd2fe67$var$ValidationError = $fWa4K.Validation;
module.exports = $420958a7bdd2fe67$var$compile;
/**
 * Compiles schema to validation function
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Object} root object with information about the root schema for this schema
 * @param  {Object} localRefs the hash of local references inside the schema (created by resolve.id), used for inline resolution
 * @param  {String} baseId base ID for IDs in the schema
 * @return {Function} validation function
 */ function $420958a7bdd2fe67$var$compile(schema, root, localRefs, baseId) {
    /* jshint validthis: true, evil: true */ /* eslint no-shadow: 0 */ var self = this, opts = this._opts, refVal = [
        undefined
    ], refs = {}, patterns = [], patternsHash = {}, defaults = [], defaultsHash = {}, customRules = [];
    root = root || {
        schema: schema,
        refVal: refVal,
        refs: refs
    };
    var c = $420958a7bdd2fe67$var$checkCompiling.call(this, schema, root, baseId);
    var compilation = this._compilations[c.index];
    if (c.compiling) return compilation.callValidate = callValidate;
    var formats = this._formats;
    var RULES = this.RULES;
    try {
        var v = localCompile(schema, root, localRefs, baseId);
        compilation.validate = v;
        var cv = compilation.callValidate;
        if (cv) {
            cv.schema = v.schema;
            cv.errors = null;
            cv.refs = v.refs;
            cv.refVal = v.refVal;
            cv.root = v.root;
            cv.$async = v.$async;
            if (opts.sourceCode) cv.source = v.source;
        }
        return v;
    } finally{
        $420958a7bdd2fe67$var$endCompiling.call(this, schema, root, baseId);
    }
    /* @this   {*} - custom context, see passContext option */ function callValidate() {
        /* jshint validthis: true */ var validate = compilation.validate;
        var result = validate.apply(this, arguments);
        callValidate.errors = validate.errors;
        return result;
    }
    function localCompile(_schema, _root, localRefs, baseId) {
        var isRoot = !_root || _root && _root.schema == _schema;
        if (_root.schema != root.schema) return $420958a7bdd2fe67$var$compile.call(self, _schema, _root, localRefs, baseId);
        var $async = _schema.$async === true;
        var sourceCode = $46Gbg({
            isTop: true,
            schema: _schema,
            isRoot: isRoot,
            baseId: baseId,
            root: _root,
            schemaPath: '',
            errSchemaPath: '#',
            errorPath: '""',
            MissingRefError: $fWa4K.MissingRef,
            RULES: RULES,
            validate: $46Gbg,
            util: $iDk2u,
            resolve: $jugvk,
            resolveRef: resolveRef,
            usePattern: usePattern,
            useDefault: useDefault,
            useCustomRule: useCustomRule,
            opts: opts,
            formats: formats,
            logger: self.logger,
            self: self
        });
        sourceCode = $420958a7bdd2fe67$var$vars(refVal, $420958a7bdd2fe67$var$refValCode) + $420958a7bdd2fe67$var$vars(patterns, $420958a7bdd2fe67$var$patternCode) + $420958a7bdd2fe67$var$vars(defaults, $420958a7bdd2fe67$var$defaultCode) + $420958a7bdd2fe67$var$vars(customRules, $420958a7bdd2fe67$var$customRuleCode) + sourceCode;
        if (opts.processCode) sourceCode = opts.processCode(sourceCode, _schema);
        // console.log('\n\n\n *** \n', JSON.stringify(sourceCode));
        var validate;
        try {
            var makeValidate = new Function('self', 'RULES', 'formats', 'root', 'refVal', 'defaults', 'customRules', 'equal', 'ucs2length', 'ValidationError', sourceCode);
            validate = makeValidate(self, RULES, formats, root, refVal, defaults, customRules, $1SBaA, $420958a7bdd2fe67$var$ucs2length, $420958a7bdd2fe67$var$ValidationError);
            refVal[0] = validate;
        } catch (e) {
            self.logger.error('Error compiling schema, function code:', sourceCode);
            throw e;
        }
        validate.schema = _schema;
        validate.errors = null;
        validate.refs = refs;
        validate.refVal = refVal;
        validate.root = isRoot ? validate : _root;
        if ($async) validate.$async = true;
        if (opts.sourceCode === true) validate.source = {
            code: sourceCode,
            patterns: patterns,
            defaults: defaults
        };
        return validate;
    }
    function resolveRef(baseId, ref, isRoot) {
        ref = $jugvk.url(baseId, ref);
        var refIndex = refs[ref];
        var _refVal, refCode;
        if (refIndex !== undefined) {
            _refVal = refVal[refIndex];
            refCode = 'refVal[' + refIndex + ']';
            return resolvedRef(_refVal, refCode);
        }
        if (!isRoot && root.refs) {
            var rootRefId = root.refs[ref];
            if (rootRefId !== undefined) {
                _refVal = root.refVal[rootRefId];
                refCode = addLocalRef(ref, _refVal);
                return resolvedRef(_refVal, refCode);
            }
        }
        refCode = addLocalRef(ref);
        var v = $jugvk.call(self, localCompile, root, ref);
        if (v === undefined) {
            var localSchema = localRefs && localRefs[ref];
            if (localSchema) v = $jugvk.inlineRef(localSchema, opts.inlineRefs) ? localSchema : $420958a7bdd2fe67$var$compile.call(self, localSchema, root, localRefs, baseId);
        }
        if (v === undefined) removeLocalRef(ref);
        else {
            replaceLocalRef(ref, v);
            return resolvedRef(v, refCode);
        }
    }
    function addLocalRef(ref, v) {
        var refId = refVal.length;
        refVal[refId] = v;
        refs[ref] = refId;
        return 'refVal' + refId;
    }
    function removeLocalRef(ref) {
        delete refs[ref];
    }
    function replaceLocalRef(ref, v) {
        var refId = refs[ref];
        refVal[refId] = v;
    }
    function resolvedRef(refVal, code) {
        return typeof refVal == 'object' || typeof refVal == 'boolean' ? {
            code: code,
            schema: refVal,
            inline: true
        } : {
            code: code,
            $async: refVal && !!refVal.$async
        };
    }
    function usePattern(regexStr) {
        var index = patternsHash[regexStr];
        if (index === undefined) {
            index = patternsHash[regexStr] = patterns.length;
            patterns[index] = regexStr;
        }
        return 'pattern' + index;
    }
    function useDefault(value) {
        switch(typeof value){
            case 'boolean':
            case 'number':
                return '' + value;
            case 'string':
                return $iDk2u.toQuotedString(value);
            case 'object':
                if (value === null) return 'null';
                var valueStr = $fkrBp(value);
                var index = defaultsHash[valueStr];
                if (index === undefined) {
                    index = defaultsHash[valueStr] = defaults.length;
                    defaults[index] = value;
                }
                return 'default' + index;
        }
    }
    function useCustomRule(rule, schema, parentSchema, it) {
        if (self._opts.validateSchema !== false) {
            var deps = rule.definition.dependencies;
            if (deps && !deps.every(function(keyword) {
                return Object.prototype.hasOwnProperty.call(parentSchema, keyword);
            })) throw new Error('parent schema must have all required keywords: ' + deps.join(','));
            var validateSchema = rule.definition.validateSchema;
            if (validateSchema) {
                var valid = validateSchema(schema);
                if (!valid) {
                    var message = 'keyword schema is invalid: ' + self.errorsText(validateSchema.errors);
                    if (self._opts.validateSchema == 'log') self.logger.error(message);
                    else throw new Error(message);
                }
            }
        }
        var compile = rule.definition.compile, inline = rule.definition.inline, macro = rule.definition.macro;
        var validate;
        if (compile) validate = compile.call(self, schema, parentSchema, it);
        else if (macro) {
            validate = macro.call(self, schema, parentSchema, it);
            if (opts.validateSchema !== false) self.validateSchema(validate, true);
        } else if (inline) validate = inline.call(self, it, rule.keyword, schema, parentSchema);
        else {
            validate = rule.definition.validate;
            if (!validate) return;
        }
        if (validate === undefined) throw new Error('custom keyword "' + rule.keyword + '"failed to compile');
        var index = customRules.length;
        customRules[index] = validate;
        return {
            code: 'customRule' + index,
            validate: validate
        };
    }
}
/**
 * Checks if the schema is currently compiled
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Object} object with properties "index" (compilation index) and "compiling" (boolean)
 */ function $420958a7bdd2fe67$var$checkCompiling(schema, root, baseId) {
    /* jshint validthis: true */ var index = $420958a7bdd2fe67$var$compIndex.call(this, schema, root, baseId);
    if (index >= 0) return {
        index: index,
        compiling: true
    };
    index = this._compilations.length;
    this._compilations[index] = {
        schema: schema,
        root: root,
        baseId: baseId
    };
    return {
        index: index,
        compiling: false
    };
}
/**
 * Removes the schema from the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 */ function $420958a7bdd2fe67$var$endCompiling(schema, root, baseId) {
    /* jshint validthis: true */ var i = $420958a7bdd2fe67$var$compIndex.call(this, schema, root, baseId);
    if (i >= 0) this._compilations.splice(i, 1);
}
/**
 * Index of schema compilation in the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Integer} compilation index
 */ function $420958a7bdd2fe67$var$compIndex(schema, root, baseId) {
    /* jshint validthis: true */ for(var i = 0; i < this._compilations.length; i++){
        var c = this._compilations[i];
        if (c.schema == schema && c.root == root && c.baseId == baseId) return i;
    }
    return -1;
}
function $420958a7bdd2fe67$var$patternCode(i, patterns) {
    return 'var pattern' + i + ' = new RegExp(' + $iDk2u.toQuotedString(patterns[i]) + ');';
}
function $420958a7bdd2fe67$var$defaultCode(i) {
    return 'var default' + i + ' = defaults[' + i + '];';
}
function $420958a7bdd2fe67$var$refValCode(i, refVal) {
    return refVal[i] === undefined ? '' : 'var refVal' + i + ' = refVal[' + i + '];';
}
function $420958a7bdd2fe67$var$customRuleCode(i) {
    return 'var customRule' + i + ' = customRules[' + i + '];';
}
function $420958a7bdd2fe67$var$vars(arr, statement) {
    if (!arr.length) return '';
    var code = '';
    for(var i = 0; i < arr.length; i++)code += statement(i, arr);
    return code;
}

});
parcelRegister("jugvk", function(module, exports) {
'use strict';

var $jzwjK = parcelRequire("jzwjK");

var $1SBaA = parcelRequire("1SBaA");

var $iDk2u = parcelRequire("iDk2u");

var $sJD4s = parcelRequire("sJD4s");

var $9O5cx = parcelRequire("9O5cx");
module.exports = $e2fd9f167e40d3fc$var$resolve;
$e2fd9f167e40d3fc$var$resolve.normalizeId = $e2fd9f167e40d3fc$var$normalizeId;
$e2fd9f167e40d3fc$var$resolve.fullPath = $e2fd9f167e40d3fc$var$getFullPath;
$e2fd9f167e40d3fc$var$resolve.url = $e2fd9f167e40d3fc$var$resolveUrl;
$e2fd9f167e40d3fc$var$resolve.ids = $e2fd9f167e40d3fc$var$resolveIds;
$e2fd9f167e40d3fc$var$resolve.inlineRef = $e2fd9f167e40d3fc$var$inlineRef;
$e2fd9f167e40d3fc$var$resolve.schema = $e2fd9f167e40d3fc$var$resolveSchema;
/**
 * [resolve and compile the references ($ref)]
 * @this   Ajv
 * @param  {Function} compile reference to schema compilation funciton (localCompile)
 * @param  {Object} root object with information about the root schema for the current schema
 * @param  {String} ref reference to resolve
 * @return {Object|Function} schema object (if the schema can be inlined) or validation function
 */ function $e2fd9f167e40d3fc$var$resolve(compile, root, ref) {
    /* jshint validthis: true */ var refVal = this._refs[ref];
    if (typeof refVal == 'string') {
        if (this._refs[refVal]) refVal = this._refs[refVal];
        else return $e2fd9f167e40d3fc$var$resolve.call(this, compile, root, refVal);
    }
    refVal = refVal || this._schemas[ref];
    if (refVal instanceof $sJD4s) return $e2fd9f167e40d3fc$var$inlineRef(refVal.schema, this._opts.inlineRefs) ? refVal.schema : refVal.validate || this._compile(refVal);
    var res = $e2fd9f167e40d3fc$var$resolveSchema.call(this, root, ref);
    var schema, v, baseId;
    if (res) {
        schema = res.schema;
        root = res.root;
        baseId = res.baseId;
    }
    if (schema instanceof $sJD4s) v = schema.validate || compile.call(this, schema.schema, root, undefined, baseId);
    else if (schema !== undefined) v = $e2fd9f167e40d3fc$var$inlineRef(schema, this._opts.inlineRefs) ? schema : compile.call(this, schema, root, undefined, baseId);
    return v;
}
/**
 * Resolve schema, its root and baseId
 * @this Ajv
 * @param  {Object} root root object with properties schema, refVal, refs
 * @param  {String} ref  reference to resolve
 * @return {Object} object with properties schema, root, baseId
 */ function $e2fd9f167e40d3fc$var$resolveSchema(root, ref) {
    /* jshint validthis: true */ var p = $jzwjK.parse(ref), refPath = $e2fd9f167e40d3fc$var$_getFullPath(p), baseId = $e2fd9f167e40d3fc$var$getFullPath(this._getId(root.schema));
    if (Object.keys(root.schema).length === 0 || refPath !== baseId) {
        var id = $e2fd9f167e40d3fc$var$normalizeId(refPath);
        var refVal = this._refs[id];
        if (typeof refVal == 'string') return $e2fd9f167e40d3fc$var$resolveRecursive.call(this, root, refVal, p);
        else if (refVal instanceof $sJD4s) {
            if (!refVal.validate) this._compile(refVal);
            root = refVal;
        } else {
            refVal = this._schemas[id];
            if (refVal instanceof $sJD4s) {
                if (!refVal.validate) this._compile(refVal);
                if (id == $e2fd9f167e40d3fc$var$normalizeId(ref)) return {
                    schema: refVal,
                    root: root,
                    baseId: baseId
                };
                root = refVal;
            } else return;
        }
        if (!root.schema) return;
        baseId = $e2fd9f167e40d3fc$var$getFullPath(this._getId(root.schema));
    }
    return $e2fd9f167e40d3fc$var$getJsonPointer.call(this, p, baseId, root.schema, root);
}
/* @this Ajv */ function $e2fd9f167e40d3fc$var$resolveRecursive(root, ref, parsedRef) {
    /* jshint validthis: true */ var res = $e2fd9f167e40d3fc$var$resolveSchema.call(this, root, ref);
    if (res) {
        var schema = res.schema;
        var baseId = res.baseId;
        root = res.root;
        var id = this._getId(schema);
        if (id) baseId = $e2fd9f167e40d3fc$var$resolveUrl(baseId, id);
        return $e2fd9f167e40d3fc$var$getJsonPointer.call(this, parsedRef, baseId, schema, root);
    }
}
var $e2fd9f167e40d3fc$var$PREVENT_SCOPE_CHANGE = $iDk2u.toHash([
    'properties',
    'patternProperties',
    'enum',
    'dependencies',
    'definitions'
]);
/* @this Ajv */ function $e2fd9f167e40d3fc$var$getJsonPointer(parsedRef, baseId, schema, root) {
    /* jshint validthis: true */ parsedRef.fragment = parsedRef.fragment || '';
    if (parsedRef.fragment.slice(0, 1) != '/') return;
    var parts = parsedRef.fragment.split('/');
    for(var i = 1; i < parts.length; i++){
        var part = parts[i];
        if (part) {
            part = $iDk2u.unescapeFragment(part);
            schema = schema[part];
            if (schema === undefined) break;
            var id;
            if (!$e2fd9f167e40d3fc$var$PREVENT_SCOPE_CHANGE[part]) {
                id = this._getId(schema);
                if (id) baseId = $e2fd9f167e40d3fc$var$resolveUrl(baseId, id);
                if (schema.$ref) {
                    var $ref = $e2fd9f167e40d3fc$var$resolveUrl(baseId, schema.$ref);
                    var res = $e2fd9f167e40d3fc$var$resolveSchema.call(this, root, $ref);
                    if (res) {
                        schema = res.schema;
                        root = res.root;
                        baseId = res.baseId;
                    }
                }
            }
        }
    }
    if (schema !== undefined && schema !== root.schema) return {
        schema: schema,
        root: root,
        baseId: baseId
    };
}
var $e2fd9f167e40d3fc$var$SIMPLE_INLINED = $iDk2u.toHash([
    'type',
    'format',
    'pattern',
    'maxLength',
    'minLength',
    'maxProperties',
    'minProperties',
    'maxItems',
    'minItems',
    'maximum',
    'minimum',
    'uniqueItems',
    'multipleOf',
    'required',
    'enum'
]);
function $e2fd9f167e40d3fc$var$inlineRef(schema, limit) {
    if (limit === false) return false;
    if (limit === undefined || limit === true) return $e2fd9f167e40d3fc$var$checkNoRef(schema);
    else if (limit) return $e2fd9f167e40d3fc$var$countKeys(schema) <= limit;
}
function $e2fd9f167e40d3fc$var$checkNoRef(schema) {
    var item;
    if (Array.isArray(schema)) for(var i = 0; i < schema.length; i++){
        item = schema[i];
        if (typeof item == 'object' && !$e2fd9f167e40d3fc$var$checkNoRef(item)) return false;
    }
    else for(var key in schema){
        if (key == '$ref') return false;
        item = schema[key];
        if (typeof item == 'object' && !$e2fd9f167e40d3fc$var$checkNoRef(item)) return false;
    }
    return true;
}
function $e2fd9f167e40d3fc$var$countKeys(schema) {
    var count = 0, item;
    if (Array.isArray(schema)) for(var i = 0; i < schema.length; i++){
        item = schema[i];
        if (typeof item == 'object') count += $e2fd9f167e40d3fc$var$countKeys(item);
        if (count == Infinity) return Infinity;
    }
    else for(var key in schema){
        if (key == '$ref') return Infinity;
        if ($e2fd9f167e40d3fc$var$SIMPLE_INLINED[key]) count++;
        else {
            item = schema[key];
            if (typeof item == 'object') count += $e2fd9f167e40d3fc$var$countKeys(item) + 1;
            if (count == Infinity) return Infinity;
        }
    }
    return count;
}
function $e2fd9f167e40d3fc$var$getFullPath(id, normalize) {
    if (normalize !== false) id = $e2fd9f167e40d3fc$var$normalizeId(id);
    var p = $jzwjK.parse(id);
    return $e2fd9f167e40d3fc$var$_getFullPath(p);
}
function $e2fd9f167e40d3fc$var$_getFullPath(p) {
    return $jzwjK.serialize(p).split('#')[0] + '#';
}
var $e2fd9f167e40d3fc$var$TRAILING_SLASH_HASH = /#\/?$/;
function $e2fd9f167e40d3fc$var$normalizeId(id) {
    return id ? id.replace($e2fd9f167e40d3fc$var$TRAILING_SLASH_HASH, '') : '';
}
function $e2fd9f167e40d3fc$var$resolveUrl(baseId, id) {
    id = $e2fd9f167e40d3fc$var$normalizeId(id);
    return $jzwjK.resolve(baseId, id);
}
/* @this Ajv */ function $e2fd9f167e40d3fc$var$resolveIds(schema) {
    var schemaId = $e2fd9f167e40d3fc$var$normalizeId(this._getId(schema));
    var baseIds = {
        '': schemaId
    };
    var fullPaths = {
        '': $e2fd9f167e40d3fc$var$getFullPath(schemaId, false)
    };
    var localRefs = {};
    var self = this;
    $9O5cx(schema, {
        allKeys: true
    }, function(sch, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
        if (jsonPtr === '') return;
        var id = self._getId(sch);
        var baseId = baseIds[parentJsonPtr];
        var fullPath = fullPaths[parentJsonPtr] + '/' + parentKeyword;
        if (keyIndex !== undefined) fullPath += '/' + (typeof keyIndex == 'number' ? keyIndex : $iDk2u.escapeFragment(keyIndex));
        if (typeof id == 'string') {
            id = baseId = $e2fd9f167e40d3fc$var$normalizeId(baseId ? $jzwjK.resolve(baseId, id) : id);
            var refVal = self._refs[id];
            if (typeof refVal == 'string') refVal = self._refs[refVal];
            if (refVal && refVal.schema) {
                if (!$1SBaA(sch, refVal.schema)) throw new Error('id "' + id + '" resolves to more than one schema');
            } else if (id != $e2fd9f167e40d3fc$var$normalizeId(fullPath)) {
                if (id[0] == '#') {
                    if (localRefs[id] && !$1SBaA(sch, localRefs[id])) throw new Error('id "' + id + '" resolves to more than one schema');
                    localRefs[id] = sch;
                } else self._refs[id] = fullPath;
            }
        }
        baseIds[jsonPtr] = baseId;
        fullPaths[jsonPtr] = fullPath;
    });
    return localRefs;
}

});
parcelRegister("jzwjK", function(module, exports) {
/** @license URI.js v4.2.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    function merge() {
        for(var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++)sets[_key] = arguments[_key];
        if (sets.length > 1) {
            sets[0] = sets[0].slice(0, -1);
            var xl = sets.length - 1;
            for(var x = 1; x < xl; ++x)sets[x] = sets[x].slice(1, -1);
            sets[xl] = sets[xl].slice(1);
            return sets.join('');
        } else return sets[0];
    }
    function subexp(str) {
        return "(?:" + str + ")";
    }
    function typeOf(o) {
        return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
    }
    function toUpperCase(str) {
        return str.toUpperCase();
    }
    function toArray(obj) {
        return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [
            obj
        ] : Array.prototype.slice.call(obj) : [];
    }
    function assign(target, source) {
        var obj = target;
        if (source) for(var key in source)obj[key] = source[key];
        return obj;
    }
    function buildExps(isIRI) {
        var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"), //case-insensitive
        LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)), //expanded
        GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", //subset, excludes bidi control characters
        IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", //subset
        UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), //relaxed parsing rules
        IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$ + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), //                           6( h16 ":" ) ls32
        IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), //                      "::" 5( h16 ":" ) ls32
        IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), //[               h16 ] "::" 4( h16 ":" ) ls32
        IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
        IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
        IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
        IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), //[ *4( h16 ":" ) h16 ] "::"              ls32
        IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), //[ *5( h16 ":" ) h16 ] "::"              h16
        IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), //[ *6( h16 ":" ) h16 ] "::"
        IPV6ADDRESS$ = subexp([
            IPV6ADDRESS1$,
            IPV6ADDRESS2$,
            IPV6ADDRESS3$,
            IPV6ADDRESS4$,
            IPV6ADDRESS5$,
            IPV6ADDRESS6$,
            IPV6ADDRESS7$,
            IPV6ADDRESS8$,
            IPV6ADDRESS9$
        ].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"), //RFC 6874
        IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), //RFC 6874
        IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$), //RFC 6874, with relaxed parsing rules
        IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), //RFC 6874
        REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), //simplified
        PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), //simplified
        PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), //simplified
        PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
        return {
            NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
            NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            UNRESERVED: new RegExp(UNRESERVED$$, "g"),
            OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
            PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
            IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
        };
    }
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var toConsumableArray = function(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    };
    /** Highest positive signed 32-bit float value */ var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
    /** Bootstring parameters */ var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128; // 0x80
    var delimiter = '-'; // '\x2D'
    /** Regular expressions */ var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
    /** Error messages */ var errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    };
    /** Convenience shortcuts */ var baseMinusTMin = base - tMin;
    var floor = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    /*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error$1(type) {
        throw new RangeError(errors[type]);
    }
    /**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, fn) {
        var result = [];
        var length = array.length;
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        while(counter < length){
            var value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // It's a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // Low surrogate.
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // It's an unmatched surrogate; only append this code unit, in case the
                    // next code unit is the high surrogate of a surrogate pair.
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ var ucs2encode = function ucs2encode(array) {
        return String.fromCodePoint.apply(String, toConsumableArray(array));
    };
    /**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ var basicToDigit = function basicToDigit(codePoint) {
        if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
        if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
        if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
        return base;
    };
    /**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ var digitToBasic = function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    /**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ var adapt = function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    /**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ var decode = function decode(input) {
        // Don't use UCS-2.
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(var j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error$1('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(var index = basic > 0 ? basic + 1 : 0; index < inputLength;)/* no final expression */ {
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            var oldi = i;
            for(var w = 1, k = base;; k += base){
                if (index >= inputLength) error$1('invalid-input');
                var digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error$1('overflow');
                i += digit * w;
                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                var baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error$1('overflow');
                w *= baseMinusT;
            }
            var out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error$1('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output.
            output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
    };
    /**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ var encode = function encode(input) {
        var output = [];
        // Convert the input in UCS-2 to an array of Unicode code points.
        input = ucs2decode(input);
        // Cache the length.
        var inputLength = input.length;
        // Initialize the state.
        var n = initialN;
        var delta = 0;
        var bias = initialBias;
        // Handle the basic code points.
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _currentValue2 = _step.value;
                if (_currentValue2 < 0x80) output.push(stringFromCharCode(_currentValue2));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string with a delimiter unless it's empty.
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            var m = maxInt;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;
            try {
                for(var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var currentValue = _step2.value;
                    if (currentValue >= n && currentValue < m) m = currentValue;
                }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow.
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                } finally{
                    if (_didIteratorError2) throw _iteratorError2;
                }
            }
            var handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error$1('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for(var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _currentValue = _step3.value;
                    if (_currentValue < n && ++delta > maxInt) error$1('overflow');
                    if (_currentValue == n) {
                        // Represent delta as a generalized variable-length integer.
                        var q = delta;
                        for(var k = base;; k += base){
                            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                            if (q < t) break;
                            var qMinusT = q - t;
                            var baseMinusT = base - t;
                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                            q = floor(qMinusT / baseMinusT);
                        }
                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                        delta = 0;
                        ++handledCPCount;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                } finally{
                    if (_didIteratorError3) throw _iteratorError3;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    };
    /**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ var toUnicode = function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    };
    /**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ var toASCII = function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    };
    /*--------------------------------------------------------------------------*/ /** Define the public API */ var punycode = {
        /**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */ 'version': '2.1.0',
        /**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */ /**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */ var SCHEMES = {};
    function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16) e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128) e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
    }
    function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while(i < il){
            var c = parseInt(str.substr(i + 1, 2), 16);
            if (c < 128) {
                newStr += String.fromCharCode(c);
                i += 3;
            } else if (c >= 194 && c < 224) {
                if (il - i >= 6) {
                    var c2 = parseInt(str.substr(i + 4, 2), 16);
                    newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
                } else newStr += str.substr(i, 6);
                i += 6;
            } else if (c >= 224) {
                if (il - i >= 9) {
                    var _c = parseInt(str.substr(i + 4, 2), 16);
                    var c3 = parseInt(str.substr(i + 7, 2), 16);
                    newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
                } else newStr += str.substr(i, 9);
                i += 9;
            } else {
                newStr += str.substr(i, 3);
                i += 3;
            }
        }
        return newStr;
    }
    function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved(str) {
            var decStr = pctDecChars(str);
            return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
    }
    function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
    }
    function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) return address.split(".").map(_stripLeadingZeros).join(".");
        else return host;
    }
    function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
            var _address$toLowerCase$ = address.toLowerCase().split('::').reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
            var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
            var lastFields = last.split(":").map(_stripLeadingZeros);
            var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
            var fieldCount = isLastFieldIPv4Address ? 7 : 8;
            var lastFieldsStart = lastFields.length - fieldCount;
            var fields = Array(fieldCount);
            for(var x = 0; x < fieldCount; ++x)fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || '';
            if (isLastFieldIPv4Address) fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
            var allZeroFields = fields.reduce(function(acc, field, index) {
                if (!field || field === "0") {
                    var lastLongest = acc[acc.length - 1];
                    if (lastLongest && lastLongest.index + lastLongest.length === index) lastLongest.length++;
                    else acc.push({
                        index: index,
                        length: 1
                    });
                }
                return acc;
            }, []);
            var longestZeroFields = allZeroFields.sort(function(a, b) {
                return b.length - a.length;
            })[0];
            var newHost = void 0;
            if (longestZeroFields && longestZeroFields.length > 1) {
                var newFirst = fields.slice(0, longestZeroFields.index);
                var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
                newHost = newFirst.join(":") + "::" + newLast.join(":");
            } else newHost = fields.join(":");
            if (zone) newHost += "%" + zone;
            return newHost;
        } else return host;
    }
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
    function parse(uriString) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var components = {};
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
            if (NO_MATCH_IS_UNDEFINED) {
                //store each component
                components.scheme = matches[1];
                components.userinfo = matches[3];
                components.host = matches[4];
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = matches[7];
                components.fragment = matches[8];
                //fix port number
                if (isNaN(components.port)) components.port = matches[5];
            } else {
                //IE FIX for improper RegExp matching
                //store each component
                components.scheme = matches[1] || undefined;
                components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
                components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
                components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
                //fix port number
                if (isNaN(components.port)) components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
            if (components.host) //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
            //determine reference type
            if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) components.reference = "same-document";
            else if (components.scheme === undefined) components.reference = "relative";
            else if (components.fragment === undefined) components.reference = "absolute";
            else components.reference = "uri";
            //check for reference errors
            if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) components.error = components.error || "URI is not a " + options.reference + " reference.";
            //find scheme handler
            var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
            //check if scheme can't handle IRIs
            if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
                //if host component is a domain name
                if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
                //convert IRI -> URI
                _normalizeComponentEncoding(components, URI_PROTOCOL);
            } else //normalize encodings
            _normalizeComponentEncoding(components, protocol);
            //perform scheme specific parsing
            if (schemeHandler && schemeHandler.parse) schemeHandler.parse(components, options);
        } else components.error = components.error || "URI can not be parsed.";
        return components;
    }
    function _recomposeAuthority(components, options) {
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== undefined) {
            uriTokens.push(components.userinfo);
            uriTokens.push("@");
        }
        if (components.host !== undefined) //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
        if (typeof components.port === "number") {
            uriTokens.push(":");
            uriTokens.push(components.port.toString(10));
        }
        return uriTokens.length ? uriTokens.join("") : undefined;
    }
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function removeDotSegments(input) {
        var output = [];
        while(input.length){
            if (input.match(RDS1)) input = input.replace(RDS1, "");
            else if (input.match(RDS2)) input = input.replace(RDS2, "/");
            else if (input.match(RDS3)) {
                input = input.replace(RDS3, "/");
                output.pop();
            } else if (input === "." || input === "..") input = "";
            else {
                var im = input.match(RDS5);
                if (im) {
                    var s = im[0];
                    input = input.slice(s.length);
                    output.push(s);
                } else throw new Error("Unexpected dot segment condition");
            }
        }
        return output.join("");
    }
    function serialize(components) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //perform scheme specific serialization
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
        if (components.host) {
            //if host component is an IPv6 address
            if (protocol.IPV6ADDRESS.test(components.host)) ;
            else if (options.domainHost || schemeHandler && schemeHandler.domainHost) //convert IDN via punycode
            try {
                components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
        }
        //normalize encoding
        _normalizeComponentEncoding(components, protocol);
        if (options.reference !== "suffix" && components.scheme) {
            uriTokens.push(components.scheme);
            uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options);
        if (authority !== undefined) {
            if (options.reference !== "suffix") uriTokens.push("//");
            uriTokens.push(authority);
            if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
        }
        if (components.path !== undefined) {
            var s = components.path;
            if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
            if (authority === undefined) s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
            uriTokens.push(s);
        }
        if (components.query !== undefined) {
            uriTokens.push("?");
            uriTokens.push(components.query);
        }
        if (components.fragment !== undefined) {
            uriTokens.push("#");
            uriTokens.push(components.fragment);
        }
        return uriTokens.join(""); //merge tokens into a string
    }
    function resolveComponents(base, relative) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target = {};
        if (!skipNormalization) {
            base = parse(serialize(base, options), options); //normalize base components
            relative = parse(serialize(relative, options), options); //normalize relative components
        }
        options = options || {};
        if (!options.tolerant && relative.scheme) {
            target.scheme = relative.scheme;
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
                //target.authority = relative.authority;
                target.userinfo = relative.userinfo;
                target.host = relative.host;
                target.port = relative.port;
                target.path = removeDotSegments(relative.path || "");
                target.query = relative.query;
            } else {
                if (!relative.path) {
                    target.path = base.path;
                    if (relative.query !== undefined) target.query = relative.query;
                    else target.query = base.query;
                } else {
                    if (relative.path.charAt(0) === "/") target.path = removeDotSegments(relative.path);
                    else {
                        if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                        else if (!base.path) target.path = relative.path;
                        else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                        target.path = removeDotSegments(target.path);
                    }
                    target.query = relative.query;
                }
                //target.authority = base.authority;
                target.userinfo = base.userinfo;
                target.host = base.host;
                target.port = base.port;
            }
            target.scheme = base.scheme;
        }
        target.fragment = relative.fragment;
        return target;
    }
    function resolve(baseURI, relativeURI, options) {
        var schemelessOptions = assign({
            scheme: 'null'
        }, options);
        return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    }
    function normalize(uri, options) {
        if (typeof uri === "string") uri = serialize(parse(uri, options), options);
        else if (typeOf(uri) === "object") uri = parse(serialize(uri, options), options);
        return uri;
    }
    function equal(uriA, uriB, options) {
        if (typeof uriA === "string") uriA = serialize(parse(uriA, options), options);
        else if (typeOf(uriA) === "object") uriA = serialize(uriA, options);
        if (typeof uriB === "string") uriB = serialize(parse(uriB, options), options);
        else if (typeOf(uriB) === "object") uriB = serialize(uriB, options);
        return uriA === uriB;
    }
    function escapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    }
    function unescapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    }
    var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse(components, options) {
            //report missing host
            if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
            return components;
        },
        serialize: function serialize(components, options) {
            //normalize the default port
            if (components.port === (String(components.scheme).toLowerCase() !== "https" ? 80 : 443) || components.port === "") components.port = undefined;
            //normalize the empty path
            if (!components.path) components.path = "/";
            //NOTE: We do not parse query strings for HTTP URIs
            //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
            //and not the HTTP spec.
            return components;
        }
    };
    var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
    };
    var O = {};
    var isIRI = true;
    //RFC 3986
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
    var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
    //RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
    //const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
    //const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
    //const VCHAR$$ = "[\\x21-\\x7E]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
    //const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
    //const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
    //const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge(QTEXT$$, "[\\\"\\\\]");
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
    }
    var handler$2 = {
        scheme: "mailto",
        parse: function parse$$1(components, options) {
            var mailtoComponents = components;
            var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
            mailtoComponents.path = undefined;
            if (mailtoComponents.query) {
                var unknownHeaders = false;
                var headers = {};
                var hfields = mailtoComponents.query.split("&");
                for(var x = 0, xl = hfields.length; x < xl; ++x){
                    var hfield = hfields[x].split("=");
                    switch(hfield[0]){
                        case "to":
                            var toAddrs = hfield[1].split(",");
                            for(var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x)to.push(toAddrs[_x]);
                            break;
                        case "subject":
                            mailtoComponents.subject = unescapeComponent(hfield[1], options);
                            break;
                        case "body":
                            mailtoComponents.body = unescapeComponent(hfield[1], options);
                            break;
                        default:
                            unknownHeaders = true;
                            headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                            break;
                    }
                }
                if (unknownHeaders) mailtoComponents.headers = headers;
            }
            mailtoComponents.query = undefined;
            for(var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2){
                var addr = to[_x2].split("@");
                addr[0] = unescapeComponent(addr[0]);
                if (!options.unicodeSupport) //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                else addr[1] = unescapeComponent(addr[1], options).toLowerCase();
                to[_x2] = addr.join("@");
            }
            return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options) {
            var components = mailtoComponents;
            var to = toArray(mailtoComponents.to);
            if (to) {
                for(var x = 0, xl = to.length; x < xl; ++x){
                    var toAddr = String(to[x]);
                    var atIdx = toAddr.lastIndexOf("@");
                    var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                    var domain = toAddr.slice(atIdx + 1);
                    //convert IDN via punycode
                    try {
                        domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                    } catch (e) {
                        components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                    }
                    to[x] = localPart + "@" + domain;
                }
                components.path = to.join(",");
            }
            var headers = mailtoComponents.headers = mailtoComponents.headers || {};
            if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
            if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
            var fields = [];
            for(var name in headers)if (headers[name] !== O[name]) fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            if (fields.length) components.query = fields.join("&");
            return components;
        }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    //RFC 2141
    var handler$3 = {
        scheme: "urn",
        parse: function parse$$1(components, options) {
            var matches = components.path && components.path.match(URN_PARSE);
            var urnComponents = components;
            if (matches) {
                var scheme = options.scheme || urnComponents.scheme || "urn";
                var nid = matches[1].toLowerCase();
                var nss = matches[2];
                var urnScheme = scheme + ":" + (options.nid || nid);
                var schemeHandler = SCHEMES[urnScheme];
                urnComponents.nid = nid;
                urnComponents.nss = nss;
                urnComponents.path = undefined;
                if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
            } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
            return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = urnComponents.nid;
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
            var uriComponents = urnComponents;
            var nss = urnComponents.nss;
            uriComponents.path = (nid || options.nid) + ":" + nss;
            return uriComponents;
        }
    };
    var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    //RFC 4122
    var handler$4 = {
        scheme: "urn:uuid",
        parse: function parse(urnComponents, options) {
            var uuidComponents = urnComponents;
            uuidComponents.uuid = uuidComponents.nss;
            uuidComponents.nss = undefined;
            if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
            return uuidComponents;
        },
        serialize: function serialize(uuidComponents, options) {
            var urnComponents = uuidComponents;
            //normalize UUID
            urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
            return urnComponents;
        }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    exports1.SCHEMES = SCHEMES;
    exports1.pctEncChar = pctEncChar;
    exports1.pctDecChars = pctDecChars;
    exports1.parse = parse;
    exports1.removeDotSegments = removeDotSegments;
    exports1.serialize = serialize;
    exports1.resolveComponents = resolveComponents;
    exports1.resolve = resolve;
    exports1.normalize = normalize;
    exports1.equal = equal;
    exports1.escapeComponent = escapeComponent;
    exports1.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("iDk2u", function(module, exports) {
'use strict';


module.exports = {
    copy: $d90b69df9b5c59fb$var$copy,
    checkDataType: $d90b69df9b5c59fb$var$checkDataType,
    checkDataTypes: $d90b69df9b5c59fb$var$checkDataTypes,
    coerceToTypes: $d90b69df9b5c59fb$var$coerceToTypes,
    toHash: $d90b69df9b5c59fb$var$toHash,
    getProperty: $d90b69df9b5c59fb$var$getProperty,
    escapeQuotes: $d90b69df9b5c59fb$var$escapeQuotes,
    equal: (parcelRequire("1SBaA")),
    ucs2length: (parcelRequire("gNe7L")),
    varOccurences: $d90b69df9b5c59fb$var$varOccurences,
    varReplace: $d90b69df9b5c59fb$var$varReplace,
    schemaHasRules: $d90b69df9b5c59fb$var$schemaHasRules,
    schemaHasRulesExcept: $d90b69df9b5c59fb$var$schemaHasRulesExcept,
    schemaUnknownRules: $d90b69df9b5c59fb$var$schemaUnknownRules,
    toQuotedString: $d90b69df9b5c59fb$var$toQuotedString,
    getPathExpr: $d90b69df9b5c59fb$var$getPathExpr,
    getPath: $d90b69df9b5c59fb$var$getPath,
    getData: $d90b69df9b5c59fb$var$getData,
    unescapeFragment: $d90b69df9b5c59fb$var$unescapeFragment,
    unescapeJsonPointer: $d90b69df9b5c59fb$var$unescapeJsonPointer,
    escapeFragment: $d90b69df9b5c59fb$var$escapeFragment,
    escapeJsonPointer: $d90b69df9b5c59fb$var$escapeJsonPointer
};
function $d90b69df9b5c59fb$var$copy(o, to) {
    to = to || {};
    for(var key in o)to[key] = o[key];
    return to;
}
function $d90b69df9b5c59fb$var$checkDataType(dataType, data, strictNumbers, negate) {
    var EQUAL = negate ? ' !== ' : ' === ', AND = negate ? ' || ' : ' && ', OK = negate ? '!' : '', NOT = negate ? '' : '!';
    switch(dataType){
        case 'null':
            return data + EQUAL + 'null';
        case 'array':
            return OK + 'Array.isArray(' + data + ')';
        case 'object':
            return '(' + OK + data + AND + 'typeof ' + data + EQUAL + '"object"' + AND + NOT + 'Array.isArray(' + data + '))';
        case 'integer':
            return '(typeof ' + data + EQUAL + '"number"' + AND + NOT + '(' + data + ' % 1)' + AND + data + EQUAL + data + (strictNumbers ? AND + OK + 'isFinite(' + data + ')' : '') + ')';
        case 'number':
            return '(typeof ' + data + EQUAL + '"' + dataType + '"' + (strictNumbers ? AND + OK + 'isFinite(' + data + ')' : '') + ')';
        default:
            return 'typeof ' + data + EQUAL + '"' + dataType + '"';
    }
}
function $d90b69df9b5c59fb$var$checkDataTypes(dataTypes, data, strictNumbers) {
    switch(dataTypes.length){
        case 1:
            return $d90b69df9b5c59fb$var$checkDataType(dataTypes[0], data, strictNumbers, true);
        default:
            var code = '';
            var types = $d90b69df9b5c59fb$var$toHash(dataTypes);
            if (types.array && types.object) {
                code = types.null ? '(' : '(!' + data + ' || ';
                code += 'typeof ' + data + ' !== "object")';
                delete types.null;
                delete types.array;
                delete types.object;
            }
            if (types.number) delete types.integer;
            for(var t in types)code += (code ? ' && ' : '') + $d90b69df9b5c59fb$var$checkDataType(t, data, strictNumbers, true);
            return code;
    }
}
var $d90b69df9b5c59fb$var$COERCE_TO_TYPES = $d90b69df9b5c59fb$var$toHash([
    'string',
    'number',
    'integer',
    'boolean',
    'null'
]);
function $d90b69df9b5c59fb$var$coerceToTypes(optionCoerceTypes, dataTypes) {
    if (Array.isArray(dataTypes)) {
        var types = [];
        for(var i = 0; i < dataTypes.length; i++){
            var t = dataTypes[i];
            if ($d90b69df9b5c59fb$var$COERCE_TO_TYPES[t]) types[types.length] = t;
            else if (optionCoerceTypes === 'array' && t === 'array') types[types.length] = t;
        }
        if (types.length) return types;
    } else if ($d90b69df9b5c59fb$var$COERCE_TO_TYPES[dataTypes]) return [
        dataTypes
    ];
    else if (optionCoerceTypes === 'array' && dataTypes === 'array') return [
        'array'
    ];
}
function $d90b69df9b5c59fb$var$toHash(arr) {
    var hash = {};
    for(var i = 0; i < arr.length; i++)hash[arr[i]] = true;
    return hash;
}
var $d90b69df9b5c59fb$var$IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
var $d90b69df9b5c59fb$var$SINGLE_QUOTE = /'|\\/g;
function $d90b69df9b5c59fb$var$getProperty(key) {
    return typeof key == 'number' ? '[' + key + ']' : $d90b69df9b5c59fb$var$IDENTIFIER.test(key) ? '.' + key : "['" + $d90b69df9b5c59fb$var$escapeQuotes(key) + "']";
}
function $d90b69df9b5c59fb$var$escapeQuotes(str) {
    return str.replace($d90b69df9b5c59fb$var$SINGLE_QUOTE, '\\$&').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\f/g, '\\f').replace(/\t/g, '\\t');
}
function $d90b69df9b5c59fb$var$varOccurences(str, dataVar) {
    dataVar += '[^0-9]';
    var matches = str.match(new RegExp(dataVar, 'g'));
    return matches ? matches.length : 0;
}
function $d90b69df9b5c59fb$var$varReplace(str, dataVar, expr) {
    dataVar += '([^0-9])';
    expr = expr.replace(/\$/g, '$$$$');
    return str.replace(new RegExp(dataVar, 'g'), expr + '$1');
}
function $d90b69df9b5c59fb$var$schemaHasRules(schema, rules) {
    if (typeof schema == 'boolean') return !schema;
    for(var key in schema)if (rules[key]) return true;
}
function $d90b69df9b5c59fb$var$schemaHasRulesExcept(schema, rules, exceptKeyword) {
    if (typeof schema == 'boolean') return !schema && exceptKeyword != 'not';
    for(var key in schema)if (key != exceptKeyword && rules[key]) return true;
}
function $d90b69df9b5c59fb$var$schemaUnknownRules(schema, rules) {
    if (typeof schema == 'boolean') return;
    for(var key in schema)if (!rules[key]) return key;
}
function $d90b69df9b5c59fb$var$toQuotedString(str) {
    return '\'' + $d90b69df9b5c59fb$var$escapeQuotes(str) + '\'';
}
function $d90b69df9b5c59fb$var$getPathExpr(currentPath, expr, jsonPointers, isNumber) {
    var path = jsonPointers // false by default
     ? '\'/\' + ' + expr + (isNumber ? '' : '.replace(/~/g, \'~0\').replace(/\\//g, \'~1\')') : isNumber ? '\'[\' + ' + expr + ' + \']\'' : '\'[\\\'\' + ' + expr + ' + \'\\\']\'';
    return $d90b69df9b5c59fb$var$joinPaths(currentPath, path);
}
function $d90b69df9b5c59fb$var$getPath(currentPath, prop, jsonPointers) {
    var path = jsonPointers // false by default
     ? $d90b69df9b5c59fb$var$toQuotedString('/' + $d90b69df9b5c59fb$var$escapeJsonPointer(prop)) : $d90b69df9b5c59fb$var$toQuotedString($d90b69df9b5c59fb$var$getProperty(prop));
    return $d90b69df9b5c59fb$var$joinPaths(currentPath, path);
}
var $d90b69df9b5c59fb$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
var $d90b69df9b5c59fb$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $d90b69df9b5c59fb$var$getData($data, lvl, paths) {
    var up, jsonPointer, data, matches;
    if ($data === '') return 'rootData';
    if ($data[0] == '/') {
        if (!$d90b69df9b5c59fb$var$JSON_POINTER.test($data)) throw new Error('Invalid JSON-pointer: ' + $data);
        jsonPointer = $data;
        data = 'rootData';
    } else {
        matches = $data.match($d90b69df9b5c59fb$var$RELATIVE_JSON_POINTER);
        if (!matches) throw new Error('Invalid JSON-pointer: ' + $data);
        up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer == '#') {
            if (up >= lvl) throw new Error('Cannot access property/index ' + up + ' levels up, current level is ' + lvl);
            return paths[lvl - up];
        }
        if (up > lvl) throw new Error('Cannot access data ' + up + ' levels up, current level is ' + lvl);
        data = 'data' + (lvl - up || '');
        if (!jsonPointer) return data;
    }
    var expr = data;
    var segments = jsonPointer.split('/');
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        if (segment) {
            data += $d90b69df9b5c59fb$var$getProperty($d90b69df9b5c59fb$var$unescapeJsonPointer(segment));
            expr += ' && ' + data;
        }
    }
    return expr;
}
function $d90b69df9b5c59fb$var$joinPaths(a, b) {
    if (a == '""') return b;
    return (a + ' + ' + b).replace(/([^\\])' \+ '/g, '$1');
}
function $d90b69df9b5c59fb$var$unescapeFragment(str) {
    return $d90b69df9b5c59fb$var$unescapeJsonPointer(decodeURIComponent(str));
}
function $d90b69df9b5c59fb$var$escapeFragment(str) {
    return encodeURIComponent($d90b69df9b5c59fb$var$escapeJsonPointer(str));
}
function $d90b69df9b5c59fb$var$escapeJsonPointer(str) {
    return str.replace(/~/g, '~0').replace(/\//g, '~1');
}
function $d90b69df9b5c59fb$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, '/').replace(/~0/g, '~');
}

});
parcelRegister("gNe7L", function(module, exports) {
'use strict';
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
module.exports = function ucs2length(str) {
    var length = 0, len = str.length, pos = 0, value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xD800 && value <= 0xDBFF && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xFC00) == 0xDC00) pos++; // low surrogate
        }
    }
    return length;
};

});


parcelRegister("sJD4s", function(module, exports) {
'use strict';

var $iDk2u = parcelRequire("iDk2u");
module.exports = $056602a4ad4a52f6$var$SchemaObject;
function $056602a4ad4a52f6$var$SchemaObject(obj) {
    $iDk2u.copy(obj, this);
}

});

parcelRegister("9O5cx", function(module, exports) {
'use strict';
var $723cd16ff2f707ae$var$traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == 'function') {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == 'function' ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $723cd16ff2f707ae$var$_traverse(opts, pre, post, schema, '', schema);
};
$723cd16ff2f707ae$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true
};
$723cd16ff2f707ae$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$723cd16ff2f707ae$var$traverse.propsKeywords = {
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$723cd16ff2f707ae$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $723cd16ff2f707ae$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $723cd16ff2f707ae$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$723cd16ff2f707ae$var$_traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $723cd16ff2f707ae$var$traverse.propsKeywords) {
                if (sch && typeof sch == 'object') for(var prop in sch)$723cd16ff2f707ae$var$_traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + $723cd16ff2f707ae$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $723cd16ff2f707ae$var$traverse.keywords || opts.allKeys && !(key in $723cd16ff2f707ae$var$traverse.skipKeywords)) $723cd16ff2f707ae$var$_traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $723cd16ff2f707ae$var$escapeJsonPtr(str) {
    return str.replace(/~/g, '~0').replace(/\//g, '~1');
}

});


parcelRegister("fWa4K", function(module, exports) {
'use strict';

var $jugvk = parcelRequire("jugvk");
module.exports = {
    Validation: $b9a4169970ea8551$var$errorSubclass($b9a4169970ea8551$var$ValidationError),
    MissingRef: $b9a4169970ea8551$var$errorSubclass($b9a4169970ea8551$var$MissingRefError)
};
function $b9a4169970ea8551$var$ValidationError(errors) {
    this.message = 'validation failed';
    this.errors = errors;
    this.ajv = this.validation = true;
}
$b9a4169970ea8551$var$MissingRefError.message = function(baseId, ref) {
    return 'can\'t resolve reference ' + ref + ' from id ' + baseId;
};
function $b9a4169970ea8551$var$MissingRefError(baseId, ref, message) {
    this.message = message || $b9a4169970ea8551$var$MissingRefError.message(baseId, ref);
    this.missingRef = $jugvk.url(baseId, ref);
    this.missingSchema = $jugvk.normalizeId($jugvk.fullPath(this.missingRef));
}
function $b9a4169970ea8551$var$errorSubclass(Subclass) {
    Subclass.prototype = Object.create(Error.prototype);
    Subclass.prototype.constructor = Subclass;
    return Subclass;
}

});

parcelRegister("46Gbg", function(module, exports) {
'use strict';
module.exports = function generate_validate(it, $keyword, $ruleType) {
    var out = '';
    var $async = it.schema.$async === true, $refKeywords = it.util.schemaHasRulesExcept(it.schema, it.RULES.all, '$ref'), $id = it.self._getId(it.schema);
    if (it.opts.strictKeywords) {
        var $unknownKwd = it.util.schemaUnknownRules(it.schema, it.RULES.keywords);
        if ($unknownKwd) {
            var $keywordsMsg = 'unknown keyword: ' + $unknownKwd;
            if (it.opts.strictKeywords === 'log') it.logger.warn($keywordsMsg);
            else throw new Error($keywordsMsg);
        }
    }
    if (it.isTop) {
        out += ' var validate = ';
        if ($async) {
            it.async = true;
            out += 'async ';
        }
        out += 'function(data, dataPath, parentData, parentDataProperty, rootData) { \'use strict\'; ';
        if ($id && (it.opts.sourceCode || it.opts.processCode)) out += ' ' + ('/\*# sourceURL=' + $id + ' */') + ' ';
    }
    if (typeof it.schema == 'boolean' || !($refKeywords || it.schema.$ref)) {
        var $keyword = 'false schema';
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $errorKeyword;
        var $data = 'data' + ($dataLvl || '');
        var $valid = 'valid' + $lvl;
        if (it.schema === false) {
            if (it.isTop) $breakOnError = true;
            else out += ' var ' + $valid + ' = false; ';
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = ''; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += ' { keyword: \'' + ($errorKeyword || 'false schema') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
                if (it.opts.messages !== false) out += ' , message: \'boolean schema is false\' ';
                if (it.opts.verbose) out += ' , schema: false , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                else out += ' validate.errors = [' + __err + ']; return false; ';
            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        } else if (it.isTop) {
            if ($async) out += ' return data; ';
            else out += ' validate.errors = null; return true; ';
        } else out += ' var ' + $valid + ' = true; ';
        if (it.isTop) out += ' }; return validate; ';
        return out;
    }
    if (it.isTop) {
        var $top = it.isTop, $lvl = it.level = 0, $dataLvl = it.dataLevel = 0, $data = 'data';
        it.rootId = it.resolve.fullPath(it.self._getId(it.root.schema));
        it.baseId = it.baseId || it.rootId;
        delete it.isTop;
        it.dataPathArr = [
            ""
        ];
        if (it.schema.default !== undefined && it.opts.useDefaults && it.opts.strictDefaults) {
            var $defaultMsg = 'default is ignored in the schema root';
            if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
            else throw new Error($defaultMsg);
        }
        out += ' var vErrors = null; ';
        out += ' var errors = 0;     ';
        out += ' if (rootData === undefined) rootData = data; ';
    } else {
        var $lvl = it.level, $dataLvl = it.dataLevel, $data = 'data' + ($dataLvl || '');
        if ($id) it.baseId = it.resolve.url(it.baseId, $id);
        if ($async && !it.async) throw new Error('async schema in sync schema');
        out += ' var errs_' + $lvl + ' = errors;';
    }
    var $valid = 'valid' + $lvl, $breakOnError = !it.opts.allErrors, $closingBraces1 = '', $closingBraces2 = '';
    var $errorKeyword;
    var $typeSchema = it.schema.type, $typeIsArray = Array.isArray($typeSchema);
    if ($typeSchema && it.opts.nullable && it.schema.nullable === true) {
        if ($typeIsArray) {
            if ($typeSchema.indexOf('null') == -1) $typeSchema = $typeSchema.concat('null');
        } else if ($typeSchema != 'null') {
            $typeSchema = [
                $typeSchema,
                'null'
            ];
            $typeIsArray = true;
        }
    }
    if ($typeIsArray && $typeSchema.length == 1) {
        $typeSchema = $typeSchema[0];
        $typeIsArray = false;
    }
    if (it.schema.$ref && $refKeywords) {
        if (it.opts.extendRefs == 'fail') throw new Error('$ref: validation keywords used in schema at path "' + it.errSchemaPath + '" (see option extendRefs)');
        else if (it.opts.extendRefs !== true) {
            $refKeywords = false;
            it.logger.warn('$ref: keywords ignored in schema at path "' + it.errSchemaPath + '"');
        }
    }
    if (it.schema.$comment && it.opts.$comment) out += ' ' + it.RULES.all.$comment.code(it, '$comment');
    if ($typeSchema) {
        if (it.opts.coerceTypes) var $coerceToTypes = it.util.coerceToTypes(it.opts.coerceTypes, $typeSchema);
        var $rulesGroup = it.RULES.types[$typeSchema];
        if ($coerceToTypes || $typeIsArray || $rulesGroup === true || $rulesGroup && !$shouldUseGroup($rulesGroup)) {
            var $schemaPath = it.schemaPath + '.type', $errSchemaPath = it.errSchemaPath + '/type';
            var $schemaPath = it.schemaPath + '.type', $errSchemaPath = it.errSchemaPath + '/type', $method = $typeIsArray ? 'checkDataTypes' : 'checkDataType';
            out += ' if (' + it.util[$method]($typeSchema, $data, it.opts.strictNumbers, true) + ') { ';
            if ($coerceToTypes) {
                var $dataType = 'dataType' + $lvl, $coerced = 'coerced' + $lvl;
                out += ' var ' + $dataType + ' = typeof ' + $data + '; var ' + $coerced + ' = undefined; ';
                if (it.opts.coerceTypes == 'array') out += ' if (' + $dataType + ' == \'object\' && Array.isArray(' + $data + ') && ' + $data + '.length == 1) { ' + $data + ' = ' + $data + '[0]; ' + $dataType + ' = typeof ' + $data + '; if (' + it.util.checkDataType(it.schema.type, $data, it.opts.strictNumbers) + ') ' + $coerced + ' = ' + $data + '; } ';
                out += ' if (' + $coerced + ' !== undefined) ; ';
                var arr1 = $coerceToTypes;
                if (arr1) {
                    var $type, $i = -1, l1 = arr1.length - 1;
                    while($i < l1){
                        $type = arr1[$i += 1];
                        if ($type == 'string') out += ' else if (' + $dataType + ' == \'number\' || ' + $dataType + ' == \'boolean\') ' + $coerced + ' = \'\' + ' + $data + '; else if (' + $data + ' === null) ' + $coerced + ' = \'\'; ';
                        else if ($type == 'number' || $type == 'integer') {
                            out += ' else if (' + $dataType + ' == \'boolean\' || ' + $data + ' === null || (' + $dataType + ' == \'string\' && ' + $data + ' && ' + $data + ' == +' + $data + ' ';
                            if ($type == 'integer') out += ' && !(' + $data + ' % 1)';
                            out += ')) ' + $coerced + ' = +' + $data + '; ';
                        } else if ($type == 'boolean') out += ' else if (' + $data + ' === \'false\' || ' + $data + ' === 0 || ' + $data + ' === null) ' + $coerced + ' = false; else if (' + $data + ' === \'true\' || ' + $data + ' === 1) ' + $coerced + ' = true; ';
                        else if ($type == 'null') out += ' else if (' + $data + ' === \'\' || ' + $data + ' === 0 || ' + $data + ' === false) ' + $coerced + ' = null; ';
                        else if (it.opts.coerceTypes == 'array' && $type == 'array') out += ' else if (' + $dataType + ' == \'string\' || ' + $dataType + ' == \'number\' || ' + $dataType + ' == \'boolean\' || ' + $data + ' == null) ' + $coerced + ' = [' + $data + ']; ';
                    }
                }
                out += ' else {   ';
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { type: \'';
                    if ($typeIsArray) out += '' + $typeSchema.join(",");
                    else out += '' + $typeSchema;
                    out += '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'should be ';
                        if ($typeIsArray) out += '' + $typeSchema.join(",");
                        else out += '' + $typeSchema;
                        out += '\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                out += ' } if (' + $coerced + ' !== undefined) {  ';
                var $parentData = $dataLvl ? 'data' + ($dataLvl - 1 || '') : 'parentData', $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
                out += ' ' + $data + ' = ' + $coerced + '; ';
                if (!$dataLvl) out += 'if (' + $parentData + ' !== undefined)';
                out += ' ' + $parentData + '[' + $parentDataProperty + '] = ' + $coerced + '; } ';
            } else {
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { type: \'';
                    if ($typeIsArray) out += '' + $typeSchema.join(",");
                    else out += '' + $typeSchema;
                    out += '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'should be ';
                        if ($typeIsArray) out += '' + $typeSchema.join(",");
                        else out += '' + $typeSchema;
                        out += '\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            }
            out += ' } ';
        }
    }
    if (it.schema.$ref && !$refKeywords) {
        out += ' ' + it.RULES.all.$ref.code(it, '$ref') + ' ';
        if ($breakOnError) {
            out += ' } if (errors === ';
            if ($top) out += '0';
            else out += 'errs_' + $lvl;
            out += ') { ';
            $closingBraces2 += '}';
        }
    } else {
        var arr2 = it.RULES;
        if (arr2) {
            var $rulesGroup, i2 = -1, l2 = arr2.length - 1;
            while(i2 < l2){
                $rulesGroup = arr2[i2 += 1];
                if ($shouldUseGroup($rulesGroup)) {
                    if ($rulesGroup.type) out += ' if (' + it.util.checkDataType($rulesGroup.type, $data, it.opts.strictNumbers) + ') { ';
                    if (it.opts.useDefaults) {
                        if ($rulesGroup.type == 'object' && it.schema.properties) {
                            var $schema = it.schema.properties, $schemaKeys = Object.keys($schema);
                            var arr3 = $schemaKeys;
                            if (arr3) {
                                var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                                while(i3 < l3){
                                    $propertyKey = arr3[i3 += 1];
                                    var $sch = $schema[$propertyKey];
                                    if ($sch.default !== undefined) {
                                        var $passData = $data + it.util.getProperty($propertyKey);
                                        if (it.compositeRule) {
                                            if (it.opts.strictDefaults) {
                                                var $defaultMsg = 'default is ignored for: ' + $passData;
                                                if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                                                else throw new Error($defaultMsg);
                                            }
                                        } else {
                                            out += ' if (' + $passData + ' === undefined ';
                                            if (it.opts.useDefaults == 'empty') out += ' || ' + $passData + ' === null || ' + $passData + ' === \'\' ';
                                            out += ' ) ' + $passData + ' = ';
                                            if (it.opts.useDefaults == 'shared') out += ' ' + it.useDefault($sch.default) + ' ';
                                            else out += ' ' + JSON.stringify($sch.default) + ' ';
                                            out += '; ';
                                        }
                                    }
                                }
                            }
                        } else if ($rulesGroup.type == 'array' && Array.isArray(it.schema.items)) {
                            var arr4 = it.schema.items;
                            if (arr4) {
                                var $sch, $i = -1, l4 = arr4.length - 1;
                                while($i < l4){
                                    $sch = arr4[$i += 1];
                                    if ($sch.default !== undefined) {
                                        var $passData = $data + '[' + $i + ']';
                                        if (it.compositeRule) {
                                            if (it.opts.strictDefaults) {
                                                var $defaultMsg = 'default is ignored for: ' + $passData;
                                                if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                                                else throw new Error($defaultMsg);
                                            }
                                        } else {
                                            out += ' if (' + $passData + ' === undefined ';
                                            if (it.opts.useDefaults == 'empty') out += ' || ' + $passData + ' === null || ' + $passData + ' === \'\' ';
                                            out += ' ) ' + $passData + ' = ';
                                            if (it.opts.useDefaults == 'shared') out += ' ' + it.useDefault($sch.default) + ' ';
                                            else out += ' ' + JSON.stringify($sch.default) + ' ';
                                            out += '; ';
                                        }
                                    }
                                }
                            }
                        }
                    }
                    var arr5 = $rulesGroup.rules;
                    if (arr5) {
                        var $rule, i5 = -1, l5 = arr5.length - 1;
                        while(i5 < l5){
                            $rule = arr5[i5 += 1];
                            if ($shouldUseRule($rule)) {
                                var $code = $rule.code(it, $rule.keyword, $rulesGroup.type);
                                if ($code) {
                                    out += ' ' + $code + ' ';
                                    if ($breakOnError) $closingBraces1 += '}';
                                }
                            }
                        }
                    }
                    if ($breakOnError) {
                        out += ' ' + $closingBraces1 + ' ';
                        $closingBraces1 = '';
                    }
                    if ($rulesGroup.type) {
                        out += ' } ';
                        if ($typeSchema && $typeSchema === $rulesGroup.type && !$coerceToTypes) {
                            out += ' else { ';
                            var $schemaPath = it.schemaPath + '.type', $errSchemaPath = it.errSchemaPath + '/type';
                            var $$outStack = $$outStack || [];
                            $$outStack.push(out);
                            out = ''; /* istanbul ignore else */ 
                            if (it.createErrors !== false) {
                                out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { type: \'';
                                if ($typeIsArray) out += '' + $typeSchema.join(",");
                                else out += '' + $typeSchema;
                                out += '\' } ';
                                if (it.opts.messages !== false) {
                                    out += ' , message: \'should be ';
                                    if ($typeIsArray) out += '' + $typeSchema.join(",");
                                    else out += '' + $typeSchema;
                                    out += '\' ';
                                }
                                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                                out += ' } ';
                            } else out += ' {} ';
                            var __err = out;
                            out = $$outStack.pop();
                            if (!it.compositeRule && $breakOnError) {
                                /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                                else out += ' validate.errors = [' + __err + ']; return false; ';
                            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                            out += ' } ';
                        }
                    }
                    if ($breakOnError) {
                        out += ' if (errors === ';
                        if ($top) out += '0';
                        else out += 'errs_' + $lvl;
                        out += ') { ';
                        $closingBraces2 += '}';
                    }
                }
            }
        }
    }
    if ($breakOnError) out += ' ' + $closingBraces2 + ' ';
    if ($top) {
        if ($async) {
            out += ' if (errors === 0) return data;           ';
            out += ' else throw new ValidationError(vErrors); ';
        } else {
            out += ' validate.errors = vErrors; ';
            out += ' return errors === 0;       ';
        }
        out += ' }; return validate;';
    } else out += ' var ' + $valid + ' = errors === errs_' + $lvl + ';';
    function $shouldUseGroup($rulesGroup) {
        var rules = $rulesGroup.rules;
        for(var i = 0; i < rules.length; i++)if ($shouldUseRule(rules[i])) return true;
    }
    function $shouldUseRule($rule) {
        return it.schema[$rule.keyword] !== undefined || $rule.implements && $ruleImplementsSomeKeyword($rule);
    }
    function $ruleImplementsSomeKeyword($rule) {
        var impl = $rule.implements;
        for(var i = 0; i < impl.length; i++)if (it.schema[impl[i]] !== undefined) return true;
    }
    return out;
};

});


parcelRegister("dpNWO", function(module, exports) {
'use strict';
var $9c445ab117ddd250$var$Cache = module.exports = function Cache() {
    this._cache = {};
};
$9c445ab117ddd250$var$Cache.prototype.put = function Cache_put(key, value) {
    this._cache[key] = value;
};
$9c445ab117ddd250$var$Cache.prototype.get = function Cache_get(key) {
    return this._cache[key];
};
$9c445ab117ddd250$var$Cache.prototype.del = function Cache_del(key) {
    delete this._cache[key];
};
$9c445ab117ddd250$var$Cache.prototype.clear = function Cache_clear() {
    this._cache = {};
};

});

parcelRegister("VK0gq", function(module, exports) {
'use strict';

var $iDk2u = parcelRequire("iDk2u");
var $0ad902462d5f8f56$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
var $0ad902462d5f8f56$var$DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $0ad902462d5f8f56$var$TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
var $0ad902462d5f8f56$var$HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
var $0ad902462d5f8f56$var$URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
var $0ad902462d5f8f56$var$URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
// uri-template: https://tools.ietf.org/html/rfc6570
var $0ad902462d5f8f56$var$URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
// For the source: https://gist.github.com/dperini/729294
// For test cases: https://mathiasbynens.be/demo/url-regex
// @todo Delete current URL in favour of the commented out URL rule when this issue is fixed https://github.com/eslint/eslint/issues/7983.
// var URL = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
var $0ad902462d5f8f56$var$URL = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
var $0ad902462d5f8f56$var$UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
var $0ad902462d5f8f56$var$JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
var $0ad902462d5f8f56$var$JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
var $0ad902462d5f8f56$var$RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
module.exports = $0ad902462d5f8f56$var$formats;
function $0ad902462d5f8f56$var$formats(mode) {
    mode = mode == 'full' ? 'full' : 'fast';
    return $iDk2u.copy($0ad902462d5f8f56$var$formats[mode]);
}
$0ad902462d5f8f56$var$formats.fast = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
    'date-time': /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    'uri-reference': /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    'uri-template': $0ad902462d5f8f56$var$URITEMPLATE,
    url: $0ad902462d5f8f56$var$URL,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
    hostname: $0ad902462d5f8f56$var$HOSTNAME,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex: $0ad902462d5f8f56$var$regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: $0ad902462d5f8f56$var$UUID,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    'json-pointer': $0ad902462d5f8f56$var$JSON_POINTER,
    'json-pointer-uri-fragment': $0ad902462d5f8f56$var$JSON_POINTER_URI_FRAGMENT,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    'relative-json-pointer': $0ad902462d5f8f56$var$RELATIVE_JSON_POINTER
};
$0ad902462d5f8f56$var$formats.full = {
    date: $0ad902462d5f8f56$var$date,
    time: $0ad902462d5f8f56$var$time,
    'date-time': $0ad902462d5f8f56$var$date_time,
    uri: $0ad902462d5f8f56$var$uri,
    'uri-reference': $0ad902462d5f8f56$var$URIREF,
    'uri-template': $0ad902462d5f8f56$var$URITEMPLATE,
    url: $0ad902462d5f8f56$var$URL,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: $0ad902462d5f8f56$var$HOSTNAME,
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex: $0ad902462d5f8f56$var$regex,
    uuid: $0ad902462d5f8f56$var$UUID,
    'json-pointer': $0ad902462d5f8f56$var$JSON_POINTER,
    'json-pointer-uri-fragment': $0ad902462d5f8f56$var$JSON_POINTER_URI_FRAGMENT,
    'relative-json-pointer': $0ad902462d5f8f56$var$RELATIVE_JSON_POINTER
};
function $0ad902462d5f8f56$var$isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $0ad902462d5f8f56$var$date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    var matches = str.match($0ad902462d5f8f56$var$DATE);
    if (!matches) return false;
    var year = +matches[1];
    var month = +matches[2];
    var day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month == 2 && $0ad902462d5f8f56$var$isLeapYear(year) ? 29 : $0ad902462d5f8f56$var$DAYS[month]);
}
function $0ad902462d5f8f56$var$time(str, full) {
    var matches = str.match($0ad902462d5f8f56$var$TIME);
    if (!matches) return false;
    var hour = matches[1];
    var minute = matches[2];
    var second = matches[3];
    var timeZone = matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour == 23 && minute == 59 && second == 60) && (!full || timeZone);
}
var $0ad902462d5f8f56$var$DATE_TIME_SEPARATOR = /t|\s/i;
function $0ad902462d5f8f56$var$date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    var dateTime = str.split($0ad902462d5f8f56$var$DATE_TIME_SEPARATOR);
    return dateTime.length == 2 && $0ad902462d5f8f56$var$date(dateTime[0]) && $0ad902462d5f8f56$var$time(dateTime[1], true);
}
var $0ad902462d5f8f56$var$NOT_URI_FRAGMENT = /\/|:/;
function $0ad902462d5f8f56$var$uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return $0ad902462d5f8f56$var$NOT_URI_FRAGMENT.test(str) && $0ad902462d5f8f56$var$URI.test(str);
}
var $0ad902462d5f8f56$var$Z_ANCHOR = /[^\\]\\Z/;
function $0ad902462d5f8f56$var$regex(str) {
    if ($0ad902462d5f8f56$var$Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("bDkiI", function(module, exports) {
'use strict';

var $hEvFi = parcelRequire("hEvFi");

var $iDk2u = parcelRequire("iDk2u");
var $87831589cae2fe93$require$toHash = $iDk2u.toHash;
module.exports = function rules() {
    var RULES = [
        {
            type: 'number',
            rules: [
                {
                    'maximum': [
                        'exclusiveMaximum'
                    ]
                },
                {
                    'minimum': [
                        'exclusiveMinimum'
                    ]
                },
                'multipleOf',
                'format'
            ]
        },
        {
            type: 'string',
            rules: [
                'maxLength',
                'minLength',
                'pattern',
                'format'
            ]
        },
        {
            type: 'array',
            rules: [
                'maxItems',
                'minItems',
                'items',
                'contains',
                'uniqueItems'
            ]
        },
        {
            type: 'object',
            rules: [
                'maxProperties',
                'minProperties',
                'required',
                'dependencies',
                'propertyNames',
                {
                    'properties': [
                        'additionalProperties',
                        'patternProperties'
                    ]
                }
            ]
        },
        {
            rules: [
                '$ref',
                'const',
                'enum',
                'not',
                'anyOf',
                'oneOf',
                'allOf',
                'if'
            ]
        }
    ];
    var ALL = [
        'type',
        '$comment'
    ];
    var KEYWORDS = [
        '$schema',
        '$id',
        'id',
        '$data',
        '$async',
        'title',
        'description',
        'default',
        'definitions',
        'examples',
        'readOnly',
        'writeOnly',
        'contentMediaType',
        'contentEncoding',
        'additionalItems',
        'then',
        'else'
    ];
    var TYPES = [
        'number',
        'integer',
        'string',
        'array',
        'object',
        'boolean',
        'null'
    ];
    RULES.all = $87831589cae2fe93$require$toHash(ALL);
    RULES.types = $87831589cae2fe93$require$toHash(TYPES);
    RULES.forEach(function(group) {
        group.rules = group.rules.map(function(keyword) {
            var implKeywords;
            if (typeof keyword == 'object') {
                var key = Object.keys(keyword)[0];
                implKeywords = keyword[key];
                keyword = key;
                implKeywords.forEach(function(k) {
                    ALL.push(k);
                    RULES.all[k] = true;
                });
            }
            ALL.push(keyword);
            var rule = RULES.all[keyword] = {
                keyword: keyword,
                code: $hEvFi[keyword],
                implements: implKeywords
            };
            return rule;
        });
        RULES.all.$comment = {
            keyword: '$comment',
            code: $hEvFi.$comment
        };
        if (group.type) RULES.types[group.type] = group;
    });
    RULES.keywords = $87831589cae2fe93$require$toHash(ALL.concat(KEYWORDS));
    RULES.custom = {};
    return RULES;
};

});
parcelRegister("hEvFi", function(module, exports) {
'use strict';




























//all requires must be explicit because browserify won't work with dynamic requires
module.exports = {
    '$ref': (parcelRequire("hpp4A")),
    allOf: (parcelRequire("jubkA")),
    anyOf: (parcelRequire("FI8c4")),
    '$comment': (parcelRequire("7crzl")),
    const: (parcelRequire("lKz2J")),
    contains: (parcelRequire("hkLLM")),
    dependencies: (parcelRequire("9gPat")),
    'enum': (parcelRequire("iTdLK")),
    format: (parcelRequire("lA6mt")),
    'if': (parcelRequire("jrYMY")),
    items: (parcelRequire("fLhmh")),
    maximum: (parcelRequire("gR5XB")),
    minimum: (parcelRequire("gR5XB")),
    maxItems: (parcelRequire("btFuY")),
    minItems: (parcelRequire("btFuY")),
    maxLength: (parcelRequire("7fIG7")),
    minLength: (parcelRequire("7fIG7")),
    maxProperties: (parcelRequire("bdygO")),
    minProperties: (parcelRequire("bdygO")),
    multipleOf: (parcelRequire("5CQOJ")),
    not: (parcelRequire("6Jkrv")),
    oneOf: (parcelRequire("3uBa0")),
    pattern: (parcelRequire("iIIcn")),
    properties: (parcelRequire("3GxNC")),
    propertyNames: (parcelRequire("5IFBq")),
    required: (parcelRequire("8ucLm")),
    uniqueItems: (parcelRequire("dUhaW")),
    validate: (parcelRequire("46Gbg"))
};

});
parcelRegister("hpp4A", function(module, exports) {
'use strict';
module.exports = function generate_ref(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $async, $refCode;
    if ($schema == '#' || $schema == '#/') {
        if (it.isRoot) {
            $async = it.async;
            $refCode = 'validate';
        } else {
            $async = it.root.schema.$async === true;
            $refCode = 'root.refVal[0]';
        }
    } else {
        var $refVal = it.resolveRef(it.baseId, $schema, it.isRoot);
        if ($refVal === undefined) {
            var $message = it.MissingRefError.message(it.baseId, $schema);
            if (it.opts.missingRefs == 'fail') {
                it.logger.error($message);
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: '$ref' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { ref: \'' + it.util.escapeQuotes($schema) + '\' } ';
                    if (it.opts.messages !== false) out += ' , message: \'can\\\'t resolve reference ' + it.util.escapeQuotes($schema) + '\' ';
                    if (it.opts.verbose) out += ' , schema: ' + it.util.toQuotedString($schema) + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                if ($breakOnError) out += ' if (false) { ';
            } else if (it.opts.missingRefs == 'ignore') {
                it.logger.warn($message);
                if ($breakOnError) out += ' if (true) { ';
            } else throw new it.MissingRefError(it.baseId, $schema, $message);
        } else if ($refVal.inline) {
            var $it = it.util.copy(it);
            $it.level++;
            var $nextValid = 'valid' + $it.level;
            $it.schema = $refVal.schema;
            $it.schemaPath = '';
            $it.errSchemaPath = $schema;
            var $code = it.validate($it).replace(/validate\.schema/g, $refVal.code);
            out += ' ' + $code + ' ';
            if ($breakOnError) out += ' if (' + $nextValid + ') { ';
        } else {
            $async = $refVal.$async === true || it.async && $refVal.$async !== false;
            $refCode = $refVal.code;
        }
    }
    if ($refCode) {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        if (it.opts.passContext) out += ' ' + $refCode + '.call(this, ';
        else out += ' ' + $refCode + '( ';
        out += ' ' + $data + ', (dataPath || \'\')';
        if (it.errorPath != '""') out += ' + ' + it.errorPath;
        var $parentData = $dataLvl ? 'data' + ($dataLvl - 1 || '') : 'parentData', $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
        out += ' , ' + $parentData + ' , ' + $parentDataProperty + ', rootData)  ';
        var __callValidate = out;
        out = $$outStack.pop();
        if ($async) {
            if (!it.async) throw new Error('async schema referenced by sync schema');
            if ($breakOnError) out += ' var ' + $valid + '; ';
            out += ' try { await ' + __callValidate + '; ';
            if ($breakOnError) out += ' ' + $valid + ' = true; ';
            out += ' } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ';
            if ($breakOnError) out += ' ' + $valid + ' = false; ';
            out += ' } ';
            if ($breakOnError) out += ' if (' + $valid + ') { ';
        } else {
            out += ' if (!' + __callValidate + ') { if (vErrors === null) vErrors = ' + $refCode + '.errors; else vErrors = vErrors.concat(' + $refCode + '.errors); errors = vErrors.length; } ';
            if ($breakOnError) out += ' else { ';
        }
    }
    return out;
};

});

parcelRegister("jubkA", function(module, exports) {
'use strict';
module.exports = function generate_allOf(it, $keyword, $ruleType) {
    var out = ' ';
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $currentBaseId = $it.baseId, $allSchemasEmpty = true;
    var arr1 = $schema;
    if (arr1) {
        var $sch, $i = -1, l1 = arr1.length - 1;
        while($i < l1){
            $sch = arr1[$i += 1];
            if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                $allSchemasEmpty = false;
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + '[' + $i + ']';
                $it.errSchemaPath = $errSchemaPath + '/' + $i;
                out += '  ' + it.validate($it) + ' ';
                $it.baseId = $currentBaseId;
                if ($breakOnError) {
                    out += ' if (' + $nextValid + ') { ';
                    $closingBraces += '}';
                }
            }
        }
    }
    if ($breakOnError) {
        if ($allSchemasEmpty) out += ' if (true) { ';
        else out += ' ' + $closingBraces.slice(0, -1) + ' ';
    }
    return out;
};

});

parcelRegister("FI8c4", function(module, exports) {
'use strict';
module.exports = function generate_anyOf(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $noEmptySchema = $schema.every(function($sch) {
        return it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all);
    });
    if ($noEmptySchema) {
        var $currentBaseId = $it.baseId;
        out += ' var ' + $errs + ' = errors; var ' + $valid + ' = false;  ';
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var arr1 = $schema;
        if (arr1) {
            var $sch, $i = -1, l1 = arr1.length - 1;
            while($i < l1){
                $sch = arr1[$i += 1];
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + '[' + $i + ']';
                $it.errSchemaPath = $errSchemaPath + '/' + $i;
                out += '  ' + it.validate($it) + ' ';
                $it.baseId = $currentBaseId;
                out += ' ' + $valid + ' = ' + $valid + ' || ' + $nextValid + '; if (!' + $valid + ') { ';
                $closingBraces += '}';
            }
        }
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += ' ' + $closingBraces + ' if (!' + $valid + ') {   var err =   '; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
            if (it.opts.messages !== false) out += ' , message: \'should match some schema in anyOf\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError(vErrors); ';
            else out += ' validate.errors = vErrors; return false; ';
        }
        out += ' } else {  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; } ';
        if (it.opts.allErrors) out += ' } ';
    } else if ($breakOnError) out += ' if (true) { ';
    return out;
};

});

parcelRegister("7crzl", function(module, exports) {
'use strict';
module.exports = function generate_comment(it, $keyword, $ruleType) {
    var out = ' ';
    var $schema = it.schema[$keyword];
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $comment = it.util.toQuotedString($schema);
    if (it.opts.$comment === true) out += ' console.log(' + $comment + ');';
    else if (typeof it.opts.$comment == 'function') out += ' self._opts.$comment(' + $comment + ', ' + it.util.toQuotedString($errSchemaPath) + ', validate.root.schema);';
    return out;
};

});

parcelRegister("lKz2J", function(module, exports) {
'use strict';
module.exports = function generate_const(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (!$isData) out += ' var schema' + $lvl + ' = validate.schema' + $schemaPath + ';';
    out += 'var ' + $valid + ' = equal(' + $data + ', schema' + $lvl + '); if (!' + $valid + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'const' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { allowedValue: schema' + $lvl + ' } ';
        if (it.opts.messages !== false) out += ' , message: \'should be equal to constant\' ';
        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += ' }';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("hkLLM", function(module, exports) {
'use strict';
module.exports = function generate_contains(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $idx = 'i' + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $currentBaseId = it.baseId, $nonEmptySchema = it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all);
    out += 'var ' + $errs + ' = errors;var ' + $valid + ';';
    if ($nonEmptySchema) {
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += ' var ' + $nextValid + ' = false; for (var ' + $idx + ' = 0; ' + $idx + ' < ' + $data + '.length; ' + $idx + '++) { ';
        $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
        var $passData = $data + '[' + $idx + ']';
        $it.dataPathArr[$dataNxt] = $idx;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
        else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
        out += ' if (' + $nextValid + ') break; }  ';
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += ' ' + $closingBraces + ' if (!' + $nextValid + ') {';
    } else out += ' if (' + $data + '.length == 0) {';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'contains' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
        if (it.opts.messages !== false) out += ' , message: \'should contain a valid item\' ';
        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += ' } else { ';
    if ($nonEmptySchema) out += '  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; } ';
    if (it.opts.allErrors) out += ' } ';
    return out;
};

});

parcelRegister("9gPat", function(module, exports) {
'use strict';
module.exports = function generate_dependencies(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $schemaDeps = {}, $propertyDeps = {}, $ownProperties = it.opts.ownProperties;
    for($property in $schema){
        if ($property == '__proto__') continue;
        var $sch = $schema[$property];
        var $deps = Array.isArray($sch) ? $propertyDeps : $schemaDeps;
        $deps[$property] = $sch;
    }
    out += 'var ' + $errs + ' = errors;';
    var $currentErrorPath = it.errorPath;
    out += 'var missing' + $lvl + ';';
    for(var $property in $propertyDeps){
        $deps = $propertyDeps[$property];
        if ($deps.length) {
            out += ' if ( ' + $data + it.util.getProperty($property) + ' !== undefined ';
            if ($ownProperties) out += ' && Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($property) + '\') ';
            if ($breakOnError) {
                out += ' && ( ';
                var arr1 = $deps;
                if (arr1) {
                    var $propertyKey, $i = -1, l1 = arr1.length - 1;
                    while($i < l1){
                        $propertyKey = arr1[$i += 1];
                        if ($i) out += ' || ';
                        var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
                        out += ' ( ( ' + $useData + ' === undefined ';
                        if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                        out += ') && (missing' + $lvl + ' = ' + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ') ) ';
                    }
                }
                out += ')) {  ';
                var $propertyPath = 'missing' + $lvl, $missingProperty = '\' + ' + $propertyPath + ' + \'';
                if (it.opts._errorDataPathProperty) it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { property: \'' + it.util.escapeQuotes($property) + '\', missingProperty: \'' + $missingProperty + '\', depsCount: ' + $deps.length + ', deps: \'' + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'should have ';
                        if ($deps.length == 1) out += 'property ' + it.util.escapeQuotes($deps[0]);
                        else out += 'properties ' + it.util.escapeQuotes($deps.join(", "));
                        out += ' when property ' + it.util.escapeQuotes($property) + ' is present\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            } else {
                out += ' ) { ';
                var arr2 = $deps;
                if (arr2) {
                    var $propertyKey, i2 = -1, l2 = arr2.length - 1;
                    while(i2 < l2){
                        $propertyKey = arr2[i2 += 1];
                        var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
                        if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                        out += ' if ( ' + $useData + ' === undefined ';
                        if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                        out += ') {  var err =   '; /* istanbul ignore else */ 
                        if (it.createErrors !== false) {
                            out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { property: \'' + it.util.escapeQuotes($property) + '\', missingProperty: \'' + $missingProperty + '\', depsCount: ' + $deps.length + ', deps: \'' + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + '\' } ';
                            if (it.opts.messages !== false) {
                                out += ' , message: \'should have ';
                                if ($deps.length == 1) out += 'property ' + it.util.escapeQuotes($deps[0]);
                                else out += 'properties ' + it.util.escapeQuotes($deps.join(", "));
                                out += ' when property ' + it.util.escapeQuotes($property) + ' is present\' ';
                            }
                            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                            out += ' } ';
                        } else out += ' {} ';
                        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
                    }
                }
            }
            out += ' }   ';
            if ($breakOnError) {
                $closingBraces += '}';
                out += ' else { ';
            }
        }
    }
    it.errorPath = $currentErrorPath;
    var $currentBaseId = $it.baseId;
    for(var $property in $schemaDeps){
        var $sch = $schemaDeps[$property];
        if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
            out += ' ' + $nextValid + ' = true; if ( ' + $data + it.util.getProperty($property) + ' !== undefined ';
            if ($ownProperties) out += ' && Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($property) + '\') ';
            out += ') { ';
            $it.schema = $sch;
            $it.schemaPath = $schemaPath + it.util.getProperty($property);
            $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($property);
            out += '  ' + it.validate($it) + ' ';
            $it.baseId = $currentBaseId;
            out += ' }  ';
            if ($breakOnError) {
                out += ' if (' + $nextValid + ') { ';
                $closingBraces += '}';
            }
        }
    }
    if ($breakOnError) out += '   ' + $closingBraces + ' if (' + $errs + ' == errors) {';
    return out;
};

});

parcelRegister("iTdLK", function(module, exports) {
'use strict';
module.exports = function generate_enum(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $i = 'i' + $lvl, $vSchema = 'schema' + $lvl;
    if (!$isData) out += ' var ' + $vSchema + ' = validate.schema' + $schemaPath + ';';
    out += 'var ' + $valid + ';';
    if ($isData) out += ' if (schema' + $lvl + ' === undefined) ' + $valid + ' = true; else if (!Array.isArray(schema' + $lvl + ')) ' + $valid + ' = false; else {';
    out += '' + $valid + ' = false;for (var ' + $i + '=0; ' + $i + '<' + $vSchema + '.length; ' + $i + '++) if (equal(' + $data + ', ' + $vSchema + '[' + $i + '])) { ' + $valid + ' = true; break; }';
    if ($isData) out += '  }  ';
    out += ' if (!' + $valid + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'enum' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { allowedValues: schema' + $lvl + ' } ';
        if (it.opts.messages !== false) out += ' , message: \'should be equal to one of the allowed values\' ';
        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += ' }';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("lA6mt", function(module, exports) {
'use strict';
module.exports = function generate_format(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    if (it.opts.format === false) {
        if ($breakOnError) out += ' if (true) { ';
        return out;
    }
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $unknownFormats = it.opts.unknownFormats, $allowUnknown = Array.isArray($unknownFormats);
    if ($isData) {
        var $format = 'format' + $lvl, $isObject = 'isObject' + $lvl, $formatType = 'formatType' + $lvl;
        out += ' var ' + $format + ' = formats[' + $schemaValue + ']; var ' + $isObject + ' = typeof ' + $format + ' == \'object\' && !(' + $format + ' instanceof RegExp) && ' + $format + '.validate; var ' + $formatType + ' = ' + $isObject + ' && ' + $format + '.type || \'string\'; if (' + $isObject + ') { ';
        if (it.async) out += ' var async' + $lvl + ' = ' + $format + '.async; ';
        out += ' ' + $format + ' = ' + $format + '.validate; } if (  ';
        if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'string\') || ';
        out += ' (';
        if ($unknownFormats != 'ignore') {
            out += ' (' + $schemaValue + ' && !' + $format + ' ';
            if ($allowUnknown) out += ' && self._opts.unknownFormats.indexOf(' + $schemaValue + ') == -1 ';
            out += ') || ';
        }
        out += ' (' + $format + ' && ' + $formatType + ' == \'' + $ruleType + '\' && !(typeof ' + $format + ' == \'function\' ? ';
        if (it.async) out += ' (async' + $lvl + ' ? await ' + $format + '(' + $data + ') : ' + $format + '(' + $data + ')) ';
        else out += ' ' + $format + '(' + $data + ') ';
        out += ' : ' + $format + '.test(' + $data + '))))) {';
    } else {
        var $format = it.formats[$schema];
        if (!$format) {
            if ($unknownFormats == 'ignore') {
                it.logger.warn('unknown format "' + $schema + '" ignored in schema at path "' + it.errSchemaPath + '"');
                if ($breakOnError) out += ' if (true) { ';
                return out;
            } else if ($allowUnknown && $unknownFormats.indexOf($schema) >= 0) {
                if ($breakOnError) out += ' if (true) { ';
                return out;
            } else throw new Error('unknown format "' + $schema + '" is used in schema at path "' + it.errSchemaPath + '"');
        }
        var $isObject = typeof $format == 'object' && !($format instanceof RegExp) && $format.validate;
        var $formatType = $isObject && $format.type || 'string';
        if ($isObject) {
            var $async = $format.async === true;
            $format = $format.validate;
        }
        if ($formatType != $ruleType) {
            if ($breakOnError) out += ' if (true) { ';
            return out;
        }
        if ($async) {
            if (!it.async) throw new Error('async format in sync schema');
            var $formatRef = 'formats' + it.util.getProperty($schema) + '.validate';
            out += ' if (!(await ' + $formatRef + '(' + $data + '))) { ';
        } else {
            out += ' if (! ';
            var $formatRef = 'formats' + it.util.getProperty($schema);
            if ($isObject) $formatRef += '.validate';
            if (typeof $format == 'function') out += ' ' + $formatRef + '(' + $data + ') ';
            else out += ' ' + $formatRef + '.test(' + $data + ') ';
            out += ') { ';
        }
    }
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'format' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { format:  ';
        if ($isData) out += '' + $schemaValue;
        else out += '' + it.util.toQuotedString($schema);
        out += '  } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should match format "';
            if ($isData) out += '\' + ' + $schemaValue + ' + \'';
            else out += '' + it.util.escapeQuotes($schema);
            out += '"\' ';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + it.util.toQuotedString($schema);
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += ' } ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("jrYMY", function(module, exports) {
'use strict';
module.exports = function generate_if(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $thenSch = it.schema['then'], $elseSch = it.schema['else'], $thenPresent = $thenSch !== undefined && (it.opts.strictKeywords ? typeof $thenSch == 'object' && Object.keys($thenSch).length > 0 || $thenSch === false : it.util.schemaHasRules($thenSch, it.RULES.all)), $elsePresent = $elseSch !== undefined && (it.opts.strictKeywords ? typeof $elseSch == 'object' && Object.keys($elseSch).length > 0 || $elseSch === false : it.util.schemaHasRules($elseSch, it.RULES.all)), $currentBaseId = $it.baseId;
    if ($thenPresent || $elsePresent) {
        var $ifClause;
        $it.createErrors = false;
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += ' var ' + $errs + ' = errors; var ' + $valid + ' = true;  ';
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        out += '  ' + it.validate($it) + ' ';
        $it.baseId = $currentBaseId;
        $it.createErrors = true;
        out += '  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; }  ';
        it.compositeRule = $it.compositeRule = $wasComposite;
        if ($thenPresent) {
            out += ' if (' + $nextValid + ') {  ';
            $it.schema = it.schema['then'];
            $it.schemaPath = it.schemaPath + '.then';
            $it.errSchemaPath = it.errSchemaPath + '/then';
            out += '  ' + it.validate($it) + ' ';
            $it.baseId = $currentBaseId;
            out += ' ' + $valid + ' = ' + $nextValid + '; ';
            if ($thenPresent && $elsePresent) {
                $ifClause = 'ifClause' + $lvl;
                out += ' var ' + $ifClause + ' = \'then\'; ';
            } else $ifClause = '\'then\'';
            out += ' } ';
            if ($elsePresent) out += ' else { ';
        } else out += ' if (!' + $nextValid + ') { ';
        if ($elsePresent) {
            $it.schema = it.schema['else'];
            $it.schemaPath = it.schemaPath + '.else';
            $it.errSchemaPath = it.errSchemaPath + '/else';
            out += '  ' + it.validate($it) + ' ';
            $it.baseId = $currentBaseId;
            out += ' ' + $valid + ' = ' + $nextValid + '; ';
            if ($thenPresent && $elsePresent) {
                $ifClause = 'ifClause' + $lvl;
                out += ' var ' + $ifClause + ' = \'else\'; ';
            } else $ifClause = '\'else\'';
            out += ' } ';
        }
        out += ' if (!' + $valid + ') {   var err =   '; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'if' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { failingKeyword: ' + $ifClause + ' } ';
            if (it.opts.messages !== false) out += ' , message: \'should match "\' + ' + $ifClause + ' + \'" schema\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError(vErrors); ';
            else out += ' validate.errors = vErrors; return false; ';
        }
        out += ' }   ';
        if ($breakOnError) out += ' else { ';
    } else if ($breakOnError) out += ' if (true) { ';
    return out;
};

});

parcelRegister("fLhmh", function(module, exports) {
'use strict';
module.exports = function generate_items(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $idx = 'i' + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $currentBaseId = it.baseId;
    out += 'var ' + $errs + ' = errors;var ' + $valid + ';';
    if (Array.isArray($schema)) {
        var $additionalItems = it.schema.additionalItems;
        if ($additionalItems === false) {
            out += ' ' + $valid + ' = ' + $data + '.length <= ' + $schema.length + '; ';
            var $currErrSchemaPath = $errSchemaPath;
            $errSchemaPath = it.errSchemaPath + '/additionalItems';
            out += '  if (!' + $valid + ') {   ';
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = ''; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schema.length + ' } ';
                if (it.opts.messages !== false) out += ' , message: \'should NOT have more than ' + $schema.length + ' items\' ';
                if (it.opts.verbose) out += ' , schema: false , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                else out += ' validate.errors = [' + __err + ']; return false; ';
            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            out += ' } ';
            $errSchemaPath = $currErrSchemaPath;
            if ($breakOnError) {
                $closingBraces += '}';
                out += ' else { ';
            }
        }
        var arr1 = $schema;
        if (arr1) {
            var $sch, $i = -1, l1 = arr1.length - 1;
            while($i < l1){
                $sch = arr1[$i += 1];
                if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    out += ' ' + $nextValid + ' = true; if (' + $data + '.length > ' + $i + ') { ';
                    var $passData = $data + '[' + $i + ']';
                    $it.schema = $sch;
                    $it.schemaPath = $schemaPath + '[' + $i + ']';
                    $it.errSchemaPath = $errSchemaPath + '/' + $i;
                    $it.errorPath = it.util.getPathExpr(it.errorPath, $i, it.opts.jsonPointers, true);
                    $it.dataPathArr[$dataNxt] = $i;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                    else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                    out += ' }  ';
                    if ($breakOnError) {
                        out += ' if (' + $nextValid + ') { ';
                        $closingBraces += '}';
                    }
                }
            }
        }
        if (typeof $additionalItems == 'object' && (it.opts.strictKeywords ? typeof $additionalItems == 'object' && Object.keys($additionalItems).length > 0 || $additionalItems === false : it.util.schemaHasRules($additionalItems, it.RULES.all))) {
            $it.schema = $additionalItems;
            $it.schemaPath = it.schemaPath + '.additionalItems';
            $it.errSchemaPath = it.errSchemaPath + '/additionalItems';
            out += ' ' + $nextValid + ' = true; if (' + $data + '.length > ' + $schema.length + ') {  for (var ' + $idx + ' = ' + $schema.length + '; ' + $idx + ' < ' + $data + '.length; ' + $idx + '++) { ';
            $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
            var $passData = $data + '[' + $idx + ']';
            $it.dataPathArr[$dataNxt] = $idx;
            var $code = it.validate($it);
            $it.baseId = $currentBaseId;
            if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
            else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
            if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
            out += ' } }  ';
            if ($breakOnError) {
                out += ' if (' + $nextValid + ') { ';
                $closingBraces += '}';
            }
        }
    } else if (it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += '  for (var ' + $idx + ' = ' + 0 + '; ' + $idx + ' < ' + $data + '.length; ' + $idx + '++) { ';
        $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
        var $passData = $data + '[' + $idx + ']';
        $it.dataPathArr[$dataNxt] = $idx;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
        else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
        if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
        out += ' }';
    }
    if ($breakOnError) out += ' ' + $closingBraces + ' if (' + $errs + ' == errors) {';
    return out;
};

});

parcelRegister("gR5XB", function(module, exports) {
'use strict';
module.exports = function generate__limit(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $isMax = $keyword == 'maximum', $exclusiveKeyword = $isMax ? 'exclusiveMaximum' : 'exclusiveMinimum', $schemaExcl = it.schema[$exclusiveKeyword], $isDataExcl = it.opts.$data && $schemaExcl && $schemaExcl.$data, $op = $isMax ? '<' : '>', $notOp = $isMax ? '>' : '<', $errorKeyword = undefined;
    if (!($isData || typeof $schema == 'number' || $schema === undefined)) throw new Error($keyword + ' must be number');
    if (!($isDataExcl || $schemaExcl === undefined || typeof $schemaExcl == 'number' || typeof $schemaExcl == 'boolean')) throw new Error($exclusiveKeyword + ' must be number or boolean');
    if ($isDataExcl) {
        var $schemaValueExcl = it.util.getData($schemaExcl.$data, $dataLvl, it.dataPathArr), $exclusive = 'exclusive' + $lvl, $exclType = 'exclType' + $lvl, $exclIsNumber = 'exclIsNumber' + $lvl, $opExpr = 'op' + $lvl, $opStr = '\' + ' + $opExpr + ' + \'';
        out += ' var schemaExcl' + $lvl + ' = ' + $schemaValueExcl + '; ';
        $schemaValueExcl = 'schemaExcl' + $lvl;
        out += ' var ' + $exclusive + '; var ' + $exclType + ' = typeof ' + $schemaValueExcl + '; if (' + $exclType + ' != \'boolean\' && ' + $exclType + ' != \'undefined\' && ' + $exclType + ' != \'number\') { ';
        var $errorKeyword = $exclusiveKeyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += ' { keyword: \'' + ($errorKeyword || '_exclusiveLimit') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
            if (it.opts.messages !== false) out += ' , message: \'' + $exclusiveKeyword + ' should be boolean\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += ' } else if ( ';
        if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
        out += ' ' + $exclType + ' == \'number\' ? ( (' + $exclusive + ' = ' + $schemaValue + ' === undefined || ' + $schemaValueExcl + ' ' + $op + '= ' + $schemaValue + ') ? ' + $data + ' ' + $notOp + '= ' + $schemaValueExcl + ' : ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' ) : ( (' + $exclusive + ' = ' + $schemaValueExcl + ' === true) ? ' + $data + ' ' + $notOp + '= ' + $schemaValue + ' : ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' ) || ' + $data + ' !== ' + $data + ') { var op' + $lvl + ' = ' + $exclusive + ' ? \'' + $op + '\' : \'' + $op + '=\'; ';
        if ($schema === undefined) {
            $errorKeyword = $exclusiveKeyword;
            $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
            $schemaValue = $schemaValueExcl;
            $isData = $isDataExcl;
        }
    } else {
        var $exclIsNumber = typeof $schemaExcl == 'number', $opStr = $op;
        if ($exclIsNumber && $isData) {
            var $opExpr = '\'' + $opStr + '\'';
            out += ' if ( ';
            if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
            out += ' ( ' + $schemaValue + ' === undefined || ' + $schemaExcl + ' ' + $op + '= ' + $schemaValue + ' ? ' + $data + ' ' + $notOp + '= ' + $schemaExcl + ' : ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' ) || ' + $data + ' !== ' + $data + ') { ';
        } else {
            if ($exclIsNumber && $schema === undefined) {
                $exclusive = true;
                $errorKeyword = $exclusiveKeyword;
                $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
                $schemaValue = $schemaExcl;
                $notOp += '=';
            } else {
                if ($exclIsNumber) $schemaValue = Math[$isMax ? 'min' : 'max']($schemaExcl, $schema);
                if ($schemaExcl === ($exclIsNumber ? $schemaValue : true)) {
                    $exclusive = true;
                    $errorKeyword = $exclusiveKeyword;
                    $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
                    $notOp += '=';
                } else {
                    $exclusive = false;
                    $opStr += '=';
                }
            }
            var $opExpr = '\'' + $opStr + '\'';
            out += ' if ( ';
            if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
            out += ' ' + $data + ' ' + $notOp + ' ' + $schemaValue + ' || ' + $data + ' !== ' + $data + ') { ';
        }
    }
    $errorKeyword = $errorKeyword || $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || '_limit') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { comparison: ' + $opExpr + ', limit: ' + $schemaValue + ', exclusive: ' + $exclusive + ' } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should be ' + $opStr + ' ';
            if ($isData) out += '\' + ' + $schemaValue;
            else out += '' + $schemaValue + '\'';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + $schema;
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += ' } ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("btFuY", function(module, exports) {
'use strict';
module.exports = function generate__limitItems(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
    var $op = $keyword == 'maxItems' ? '>' : '<';
    out += 'if ( ';
    if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
    out += ' ' + $data + '.length ' + $op + ' ' + $schemaValue + ') { ';
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || '_limitItems') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schemaValue + ' } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should NOT have ';
            if ($keyword == 'maxItems') out += 'more';
            else out += 'fewer';
            out += ' than ';
            if ($isData) out += '\' + ' + $schemaValue + ' + \'';
            else out += '' + $schema;
            out += ' items\' ';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + $schema;
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += '} ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("7fIG7", function(module, exports) {
'use strict';
module.exports = function generate__limitLength(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
    var $op = $keyword == 'maxLength' ? '>' : '<';
    out += 'if ( ';
    if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
    if (it.opts.unicode === false) out += ' ' + $data + '.length ';
    else out += ' ucs2length(' + $data + ') ';
    out += ' ' + $op + ' ' + $schemaValue + ') { ';
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || '_limitLength') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schemaValue + ' } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should NOT be ';
            if ($keyword == 'maxLength') out += 'longer';
            else out += 'shorter';
            out += ' than ';
            if ($isData) out += '\' + ' + $schemaValue + ' + \'';
            else out += '' + $schema;
            out += ' characters\' ';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + $schema;
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += '} ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("bdygO", function(module, exports) {
'use strict';
module.exports = function generate__limitProperties(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
    var $op = $keyword == 'maxProperties' ? '>' : '<';
    out += 'if ( ';
    if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'number\') || ';
    out += ' Object.keys(' + $data + ').length ' + $op + ' ' + $schemaValue + ') { ';
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || '_limitProperties') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { limit: ' + $schemaValue + ' } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should NOT have ';
            if ($keyword == 'maxProperties') out += 'more';
            else out += 'fewer';
            out += ' than ';
            if ($isData) out += '\' + ' + $schemaValue + ' + \'';
            else out += '' + $schema;
            out += ' properties\' ';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + $schema;
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += '} ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("5CQOJ", function(module, exports) {
'use strict';
module.exports = function generate_multipleOf(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == 'number')) throw new Error($keyword + ' must be number');
    out += 'var division' + $lvl + ';if (';
    if ($isData) out += ' ' + $schemaValue + ' !== undefined && ( typeof ' + $schemaValue + ' != \'number\' || ';
    out += ' (division' + $lvl + ' = ' + $data + ' / ' + $schemaValue + ', ';
    if (it.opts.multipleOfPrecision) out += ' Math.abs(Math.round(division' + $lvl + ') - division' + $lvl + ') > 1e-' + it.opts.multipleOfPrecision + ' ';
    else out += ' division' + $lvl + ' !== parseInt(division' + $lvl + ') ';
    out += ' ) ';
    if ($isData) out += '  )  ';
    out += ' ) {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { multipleOf: ' + $schemaValue + ' } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should be multiple of ';
            if ($isData) out += '\' + ' + $schemaValue;
            else out += '' + $schemaValue + '\'';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + $schema;
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += '} ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("6Jkrv", function(module, exports) {
'use strict';
module.exports = function generate_not(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    if (it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += ' var ' + $errs + ' = errors;  ';
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        $it.createErrors = false;
        var $allErrorsOption;
        if ($it.opts.allErrors) {
            $allErrorsOption = $it.opts.allErrors;
            $it.opts.allErrors = false;
        }
        out += ' ' + it.validate($it) + ' ';
        $it.createErrors = true;
        if ($allErrorsOption) $it.opts.allErrors = $allErrorsOption;
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += ' if (' + $nextValid + ') {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
            if (it.opts.messages !== false) out += ' , message: \'should NOT be valid\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += ' } else {  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; } ';
        if (it.opts.allErrors) out += ' } ';
    } else {
        out += '  var err =   '; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: {} ';
            if (it.opts.messages !== false) out += ' , message: \'should NOT be valid\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        if ($breakOnError) out += ' if (false) { ';
    }
    return out;
};

});

parcelRegister("3uBa0", function(module, exports) {
'use strict';
module.exports = function generate_oneOf(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $currentBaseId = $it.baseId, $prevValid = 'prevValid' + $lvl, $passingSchemas = 'passingSchemas' + $lvl;
    out += 'var ' + $errs + ' = errors , ' + $prevValid + ' = false , ' + $valid + ' = false , ' + $passingSchemas + ' = null; ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var arr1 = $schema;
    if (arr1) {
        var $sch, $i = -1, l1 = arr1.length - 1;
        while($i < l1){
            $sch = arr1[$i += 1];
            if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + '[' + $i + ']';
                $it.errSchemaPath = $errSchemaPath + '/' + $i;
                out += '  ' + it.validate($it) + ' ';
                $it.baseId = $currentBaseId;
            } else out += ' var ' + $nextValid + ' = true; ';
            if ($i) {
                out += ' if (' + $nextValid + ' && ' + $prevValid + ') { ' + $valid + ' = false; ' + $passingSchemas + ' = [' + $passingSchemas + ', ' + $i + ']; } else { ';
                $closingBraces += '}';
            }
            out += ' if (' + $nextValid + ') { ' + $valid + ' = ' + $prevValid + ' = true; ' + $passingSchemas + ' = ' + $i + '; }';
        }
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += '' + $closingBraces + 'if (!' + $valid + ') {   var err =   '; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { passingSchemas: ' + $passingSchemas + ' } ';
        if (it.opts.messages !== false) out += ' , message: \'should match exactly one schema in oneOf\' ';
        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        out += ' } ';
    } else out += ' {} ';
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError(vErrors); ';
        else out += ' validate.errors = vErrors; return false; ';
    }
    out += '} else {  errors = ' + $errs + '; if (vErrors !== null) { if (' + $errs + ') vErrors.length = ' + $errs + '; else vErrors = null; }';
    if (it.opts.allErrors) out += ' } ';
    return out;
};

});

parcelRegister("iIIcn", function(module, exports) {
'use strict';
module.exports = function generate_pattern(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $regexp = $isData ? '(new RegExp(' + $schemaValue + '))' : it.usePattern($schema);
    out += 'if ( ';
    if ($isData) out += ' (' + $schemaValue + ' !== undefined && typeof ' + $schemaValue + ' != \'string\') || ';
    out += ' !' + $regexp + '.test(' + $data + ') ) {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { pattern:  ';
        if ($isData) out += '' + $schemaValue;
        else out += '' + it.util.toQuotedString($schema);
        out += '  } ';
        if (it.opts.messages !== false) {
            out += ' , message: \'should match pattern "';
            if ($isData) out += '\' + ' + $schemaValue + ' + \'';
            else out += '' + it.util.escapeQuotes($schema);
            out += '"\' ';
        }
        if (it.opts.verbose) {
            out += ' , schema:  ';
            if ($isData) out += 'validate.schema' + $schemaPath;
            else out += '' + it.util.toQuotedString($schema);
            out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
        }
        out += ' } ';
    } else out += ' {} ';
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
        else out += ' validate.errors = [' + __err + ']; return false; ';
    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    out += '} ';
    if ($breakOnError) out += ' else { ';
    return out;
};

});

parcelRegister("3GxNC", function(module, exports) {
'use strict';
module.exports = function generate_properties(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    var $key = 'key' + $lvl, $idx = 'idx' + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $dataProperties = 'dataProperties' + $lvl;
    var $schemaKeys = Object.keys($schema || {}).filter(notProto), $pProperties = it.schema.patternProperties || {}, $pPropertyKeys = Object.keys($pProperties).filter(notProto), $aProperties = it.schema.additionalProperties, $someProperties = $schemaKeys.length || $pPropertyKeys.length, $noAdditional = $aProperties === false, $additionalIsSchema = typeof $aProperties == 'object' && Object.keys($aProperties).length, $removeAdditional = it.opts.removeAdditional, $checkAdditional = $noAdditional || $additionalIsSchema || $removeAdditional, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
    var $required = it.schema.required;
    if ($required && !(it.opts.$data && $required.$data) && $required.length < it.opts.loopRequired) var $requiredHash = it.util.toHash($required);
    function notProto(p) {
        return p !== '__proto__';
    }
    out += 'var ' + $errs + ' = errors;var ' + $nextValid + ' = true;';
    if ($ownProperties) out += ' var ' + $dataProperties + ' = undefined;';
    if ($checkAdditional) {
        if ($ownProperties) out += ' ' + $dataProperties + ' = ' + $dataProperties + ' || Object.keys(' + $data + '); for (var ' + $idx + '=0; ' + $idx + '<' + $dataProperties + '.length; ' + $idx + '++) { var ' + $key + ' = ' + $dataProperties + '[' + $idx + ']; ';
        else out += ' for (var ' + $key + ' in ' + $data + ') { ';
        if ($someProperties) {
            out += ' var isAdditional' + $lvl + ' = !(false ';
            if ($schemaKeys.length) {
                if ($schemaKeys.length > 8) out += ' || validate.schema' + $schemaPath + '.hasOwnProperty(' + $key + ') ';
                else {
                    var arr1 = $schemaKeys;
                    if (arr1) {
                        var $propertyKey, i1 = -1, l1 = arr1.length - 1;
                        while(i1 < l1){
                            $propertyKey = arr1[i1 += 1];
                            out += ' || ' + $key + ' == ' + it.util.toQuotedString($propertyKey) + ' ';
                        }
                    }
                }
            }
            if ($pPropertyKeys.length) {
                var arr2 = $pPropertyKeys;
                if (arr2) {
                    var $pProperty, $i = -1, l2 = arr2.length - 1;
                    while($i < l2){
                        $pProperty = arr2[$i += 1];
                        out += ' || ' + it.usePattern($pProperty) + '.test(' + $key + ') ';
                    }
                }
            }
            out += ' ); if (isAdditional' + $lvl + ') { ';
        }
        if ($removeAdditional == 'all') out += ' delete ' + $data + '[' + $key + ']; ';
        else {
            var $currentErrorPath = it.errorPath;
            var $additionalProperty = '\' + ' + $key + ' + \'';
            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
            if ($noAdditional) {
                if ($removeAdditional) out += ' delete ' + $data + '[' + $key + ']; ';
                else {
                    out += ' ' + $nextValid + ' = false; ';
                    var $currErrSchemaPath = $errSchemaPath;
                    $errSchemaPath = it.errSchemaPath + '/additionalProperties';
                    var $$outStack = $$outStack || [];
                    $$outStack.push(out);
                    out = ''; /* istanbul ignore else */ 
                    if (it.createErrors !== false) {
                        out += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { additionalProperty: \'' + $additionalProperty + '\' } ';
                        if (it.opts.messages !== false) {
                            out += ' , message: \'';
                            if (it.opts._errorDataPathProperty) out += 'is an invalid additional property';
                            else out += 'should NOT have additional properties';
                            out += '\' ';
                        }
                        if (it.opts.verbose) out += ' , schema: false , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                        out += ' } ';
                    } else out += ' {} ';
                    var __err = out;
                    out = $$outStack.pop();
                    if (!it.compositeRule && $breakOnError) {
                        /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                        else out += ' validate.errors = [' + __err + ']; return false; ';
                    } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                    $errSchemaPath = $currErrSchemaPath;
                    if ($breakOnError) out += ' break; ';
                }
            } else if ($additionalIsSchema) {
                if ($removeAdditional == 'failing') {
                    out += ' var ' + $errs + ' = errors;  ';
                    var $wasComposite = it.compositeRule;
                    it.compositeRule = $it.compositeRule = true;
                    $it.schema = $aProperties;
                    $it.schemaPath = it.schemaPath + '.additionalProperties';
                    $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
                    $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + '[' + $key + ']';
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                    else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                    out += ' if (!' + $nextValid + ') { errors = ' + $errs + '; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete ' + $data + '[' + $key + ']; }  ';
                    it.compositeRule = $it.compositeRule = $wasComposite;
                } else {
                    $it.schema = $aProperties;
                    $it.schemaPath = it.schemaPath + '.additionalProperties';
                    $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
                    $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + '[' + $key + ']';
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                    else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                    if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
                }
            }
            it.errorPath = $currentErrorPath;
        }
        if ($someProperties) out += ' } ';
        out += ' }  ';
        if ($breakOnError) {
            out += ' if (' + $nextValid + ') { ';
            $closingBraces += '}';
        }
    }
    var $useDefaults = it.opts.useDefaults && !it.compositeRule;
    if ($schemaKeys.length) {
        var arr3 = $schemaKeys;
        if (arr3) {
            var $propertyKey, i3 = -1, l3 = arr3.length - 1;
            while(i3 < l3){
                $propertyKey = arr3[i3 += 1];
                var $sch = $schema[$propertyKey];
                if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    var $prop = it.util.getProperty($propertyKey), $passData = $data + $prop, $hasDefault = $useDefaults && $sch.default !== undefined;
                    $it.schema = $sch;
                    $it.schemaPath = $schemaPath + $prop;
                    $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($propertyKey);
                    $it.errorPath = it.util.getPath(it.errorPath, $propertyKey, it.opts.jsonPointers);
                    $it.dataPathArr[$dataNxt] = it.util.toQuotedString($propertyKey);
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) {
                        $code = it.util.varReplace($code, $nextData, $passData);
                        var $useData = $passData;
                    } else {
                        var $useData = $nextData;
                        out += ' var ' + $nextData + ' = ' + $passData + '; ';
                    }
                    if ($hasDefault) out += ' ' + $code + ' ';
                    else {
                        if ($requiredHash && $requiredHash[$propertyKey]) {
                            out += ' if ( ' + $useData + ' === undefined ';
                            if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                            out += ') { ' + $nextValid + ' = false; ';
                            var $currentErrorPath = it.errorPath, $currErrSchemaPath = $errSchemaPath, $missingProperty = it.util.escapeQuotes($propertyKey);
                            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                            $errSchemaPath = it.errSchemaPath + '/required';
                            var $$outStack = $$outStack || [];
                            $$outStack.push(out);
                            out = ''; /* istanbul ignore else */ 
                            if (it.createErrors !== false) {
                                out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                                if (it.opts.messages !== false) {
                                    out += ' , message: \'';
                                    if (it.opts._errorDataPathProperty) out += 'is a required property';
                                    else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                                    out += '\' ';
                                }
                                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                                out += ' } ';
                            } else out += ' {} ';
                            var __err = out;
                            out = $$outStack.pop();
                            if (!it.compositeRule && $breakOnError) {
                                /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                                else out += ' validate.errors = [' + __err + ']; return false; ';
                            } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                            $errSchemaPath = $currErrSchemaPath;
                            it.errorPath = $currentErrorPath;
                            out += ' } else { ';
                        } else if ($breakOnError) {
                            out += ' if ( ' + $useData + ' === undefined ';
                            if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                            out += ') { ' + $nextValid + ' = true; } else { ';
                        } else {
                            out += ' if (' + $useData + ' !== undefined ';
                            if ($ownProperties) out += ' &&   Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                            out += ' ) { ';
                        }
                        out += ' ' + $code + ' } ';
                    }
                }
                if ($breakOnError) {
                    out += ' if (' + $nextValid + ') { ';
                    $closingBraces += '}';
                }
            }
        }
    }
    if ($pPropertyKeys.length) {
        var arr4 = $pPropertyKeys;
        if (arr4) {
            var $pProperty, i4 = -1, l4 = arr4.length - 1;
            while(i4 < l4){
                $pProperty = arr4[i4 += 1];
                var $sch = $pProperties[$pProperty];
                if (it.opts.strictKeywords ? typeof $sch == 'object' && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    $it.schema = $sch;
                    $it.schemaPath = it.schemaPath + '.patternProperties' + it.util.getProperty($pProperty);
                    $it.errSchemaPath = it.errSchemaPath + '/patternProperties/' + it.util.escapeFragment($pProperty);
                    if ($ownProperties) out += ' ' + $dataProperties + ' = ' + $dataProperties + ' || Object.keys(' + $data + '); for (var ' + $idx + '=0; ' + $idx + '<' + $dataProperties + '.length; ' + $idx + '++) { var ' + $key + ' = ' + $dataProperties + '[' + $idx + ']; ';
                    else out += ' for (var ' + $key + ' in ' + $data + ') { ';
                    out += ' if (' + it.usePattern($pProperty) + '.test(' + $key + ')) { ';
                    $it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + '[' + $key + ']';
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
                    else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
                    if ($breakOnError) out += ' if (!' + $nextValid + ') break; ';
                    out += ' } ';
                    if ($breakOnError) out += ' else ' + $nextValid + ' = true; ';
                    out += ' }  ';
                    if ($breakOnError) {
                        out += ' if (' + $nextValid + ') { ';
                        $closingBraces += '}';
                    }
                }
            }
        }
    }
    if ($breakOnError) out += ' ' + $closingBraces + ' if (' + $errs + ' == errors) {';
    return out;
};

});

parcelRegister("5IFBq", function(module, exports) {
'use strict';
module.exports = function generate_propertyNames(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $errs = 'errs__' + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    out += 'var ' + $errs + ' = errors;';
    if (it.opts.strictKeywords ? typeof $schema == 'object' && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        var $key = 'key' + $lvl, $idx = 'idx' + $lvl, $i = 'i' + $lvl, $invalidName = '\' + ' + $key + ' + \'', $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = 'data' + $dataNxt, $dataProperties = 'dataProperties' + $lvl, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
        if ($ownProperties) out += ' var ' + $dataProperties + ' = undefined; ';
        if ($ownProperties) out += ' ' + $dataProperties + ' = ' + $dataProperties + ' || Object.keys(' + $data + '); for (var ' + $idx + '=0; ' + $idx + '<' + $dataProperties + '.length; ' + $idx + '++) { var ' + $key + ' = ' + $dataProperties + '[' + $idx + ']; ';
        else out += ' for (var ' + $key + ' in ' + $data + ') { ';
        out += ' var startErrs' + $lvl + ' = errors; ';
        var $passData = $key;
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += ' ' + it.util.varReplace($code, $nextData, $passData) + ' ';
        else out += ' var ' + $nextData + ' = ' + $passData + '; ' + $code + ' ';
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += ' if (!' + $nextValid + ') { for (var ' + $i + '=startErrs' + $lvl + '; ' + $i + '<errors; ' + $i + '++) { vErrors[' + $i + '].propertyName = ' + $key + '; }   var err =   '; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { propertyName: \'' + $invalidName + '\' } ';
            if (it.opts.messages !== false) out += ' , message: \'property name \\\'' + $invalidName + '\\\' is invalid\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError(vErrors); ';
            else out += ' validate.errors = vErrors; return false; ';
        }
        if ($breakOnError) out += ' break; ';
        out += ' } }';
    }
    if ($breakOnError) out += ' ' + $closingBraces + ' if (' + $errs + ' == errors) {';
    return out;
};

});

parcelRegister("8ucLm", function(module, exports) {
'use strict';
module.exports = function generate_required(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $vSchema = 'schema' + $lvl;
    if (!$isData) {
        if ($schema.length < it.opts.loopRequired && it.schema.properties && Object.keys(it.schema.properties).length) {
            var $required = [];
            var arr1 = $schema;
            if (arr1) {
                var $property, i1 = -1, l1 = arr1.length - 1;
                while(i1 < l1){
                    $property = arr1[i1 += 1];
                    var $propertySch = it.schema.properties[$property];
                    if (!($propertySch && (it.opts.strictKeywords ? typeof $propertySch == 'object' && Object.keys($propertySch).length > 0 || $propertySch === false : it.util.schemaHasRules($propertySch, it.RULES.all)))) $required[$required.length] = $property;
                }
            }
        } else var $required = $schema;
    }
    if ($isData || $required.length) {
        var $currentErrorPath = it.errorPath, $loopRequired = $isData || $required.length >= it.opts.loopRequired, $ownProperties = it.opts.ownProperties;
        if ($breakOnError) {
            out += ' var missing' + $lvl + '; ';
            if ($loopRequired) {
                if (!$isData) out += ' var ' + $vSchema + ' = validate.schema' + $schemaPath + '; ';
                var $i = 'i' + $lvl, $propertyPath = 'schema' + $lvl + '[' + $i + ']', $missingProperty = '\' + ' + $propertyPath + ' + \'';
                if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
                out += ' var ' + $valid + ' = true; ';
                if ($isData) out += ' if (schema' + $lvl + ' === undefined) ' + $valid + ' = true; else if (!Array.isArray(schema' + $lvl + ')) ' + $valid + ' = false; else {';
                out += ' for (var ' + $i + ' = 0; ' + $i + ' < ' + $vSchema + '.length; ' + $i + '++) { ' + $valid + ' = ' + $data + '[' + $vSchema + '[' + $i + ']] !== undefined ';
                if ($ownProperties) out += ' &&   Object.prototype.hasOwnProperty.call(' + $data + ', ' + $vSchema + '[' + $i + ']) ';
                out += '; if (!' + $valid + ') break; } ';
                if ($isData) out += '  }  ';
                out += '  if (!' + $valid + ') {   ';
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'';
                        if (it.opts._errorDataPathProperty) out += 'is a required property';
                        else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                        out += '\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                out += ' } else { ';
            } else {
                out += ' if ( ';
                var arr2 = $required;
                if (arr2) {
                    var $propertyKey, $i = -1, l2 = arr2.length - 1;
                    while($i < l2){
                        $propertyKey = arr2[$i += 1];
                        if ($i) out += ' || ';
                        var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
                        out += ' ( ( ' + $useData + ' === undefined ';
                        if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                        out += ') && (missing' + $lvl + ' = ' + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ') ) ';
                    }
                }
                out += ') {  ';
                var $propertyPath = 'missing' + $lvl, $missingProperty = '\' + ' + $propertyPath + ' + \'';
                if (it.opts._errorDataPathProperty) it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ''; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'';
                        if (it.opts._errorDataPathProperty) out += 'is a required property';
                        else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                        out += '\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
                    else out += ' validate.errors = [' + __err + ']; return false; ';
                } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
                out += ' } else { ';
            }
        } else if ($loopRequired) {
            if (!$isData) out += ' var ' + $vSchema + ' = validate.schema' + $schemaPath + '; ';
            var $i = 'i' + $lvl, $propertyPath = 'schema' + $lvl + '[' + $i + ']', $missingProperty = '\' + ' + $propertyPath + ' + \'';
            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
            if ($isData) {
                out += ' if (' + $vSchema + ' && !Array.isArray(' + $vSchema + ')) {  var err =   '; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                    if (it.opts.messages !== false) {
                        out += ' , message: \'';
                        if (it.opts._errorDataPathProperty) out += 'is a required property';
                        else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                        out += '\' ';
                    }
                    if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                    out += ' } ';
                } else out += ' {} ';
                out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (' + $vSchema + ' !== undefined) { ';
            }
            out += ' for (var ' + $i + ' = 0; ' + $i + ' < ' + $vSchema + '.length; ' + $i + '++) { if (' + $data + '[' + $vSchema + '[' + $i + ']] === undefined ';
            if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', ' + $vSchema + '[' + $i + ']) ';
            out += ') {  var err =   '; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                if (it.opts.messages !== false) {
                    out += ' , message: \'';
                    if (it.opts._errorDataPathProperty) out += 'is a required property';
                    else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                    out += '\' ';
                }
                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ';
            if ($isData) out += '  }  ';
        } else {
            var arr3 = $required;
            if (arr3) {
                var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                while(i3 < l3){
                    $propertyKey = arr3[i3 += 1];
                    var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
                    if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                    out += ' if ( ' + $useData + ' === undefined ';
                    if ($ownProperties) out += ' || ! Object.prototype.hasOwnProperty.call(' + $data + ', \'' + it.util.escapeQuotes($propertyKey) + '\') ';
                    out += ') {  var err =   '; /* istanbul ignore else */ 
                    if (it.createErrors !== false) {
                        out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { missingProperty: \'' + $missingProperty + '\' } ';
                        if (it.opts.messages !== false) {
                            out += ' , message: \'';
                            if (it.opts._errorDataPathProperty) out += 'is a required property';
                            else out += 'should have required property \\\'' + $missingProperty + '\\\'';
                            out += '\' ';
                        }
                        if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                        out += ' } ';
                    } else out += ' {} ';
                    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
                }
            }
        }
        it.errorPath = $currentErrorPath;
    } else if ($breakOnError) out += ' if (true) {';
    return out;
};

});

parcelRegister("dUhaW", function(module, exports) {
'use strict';
module.exports = function generate_uniqueItems(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    if (($schema || $isData) && it.opts.uniqueItems !== false) {
        if ($isData) out += ' var ' + $valid + '; if (' + $schemaValue + ' === false || ' + $schemaValue + ' === undefined) ' + $valid + ' = true; else if (typeof ' + $schemaValue + ' != \'boolean\') ' + $valid + ' = false; else { ';
        out += ' var i = ' + $data + '.length , ' + $valid + ' = true , j; if (i > 1) { ';
        var $itemType = it.schema.items && it.schema.items.type, $typeIsArray = Array.isArray($itemType);
        if (!$itemType || $itemType == 'object' || $itemType == 'array' || $typeIsArray && ($itemType.indexOf('object') >= 0 || $itemType.indexOf('array') >= 0)) out += ' outer: for (;i--;) { for (j = i; j--;) { if (equal(' + $data + '[i], ' + $data + '[j])) { ' + $valid + ' = false; break outer; } } } ';
        else {
            out += ' var itemIndices = {}, item; for (;i--;) { var item = ' + $data + '[i]; ';
            var $method = 'checkDataType' + ($typeIsArray ? 's' : '');
            out += ' if (' + it.util[$method]($itemType, 'item', it.opts.strictNumbers, true) + ') continue; ';
            if ($typeIsArray) out += ' if (typeof item == \'string\') item = \'"\' + item; ';
            out += ' if (typeof itemIndices[item] == \'number\') { ' + $valid + ' = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ';
        }
        out += ' } ';
        if ($isData) out += '  }  ';
        out += ' if (!' + $valid + ') {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { i: i, j: j } ';
            if (it.opts.messages !== false) out += ' , message: \'should NOT have duplicate items (items ## \' + j + \' and \' + i + \' are identical)\' ';
            if (it.opts.verbose) {
                out += ' , schema:  ';
                if ($isData) out += 'validate.schema' + $schemaPath;
                else out += '' + $schema;
                out += '         , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            }
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        out += ' } ';
        if ($breakOnError) out += ' else { ';
    } else if ($breakOnError) out += ' if (true) { ';
    return out;
};

});



parcelRegister("6iZXf", function(module, exports) {
'use strict';
var $49747b6b96377985$var$KEYWORDS = [
    'multipleOf',
    'maximum',
    'exclusiveMaximum',
    'minimum',
    'exclusiveMinimum',
    'maxLength',
    'minLength',
    'pattern',
    'additionalItems',
    'maxItems',
    'minItems',
    'uniqueItems',
    'maxProperties',
    'minProperties',
    'required',
    'additionalProperties',
    'enum',
    'format',
    'const'
];
module.exports = function(metaSchema, keywordsJsonPointers) {
    for(var i = 0; i < keywordsJsonPointers.length; i++){
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        var segments = keywordsJsonPointers[i].split('/');
        var keywords = metaSchema;
        var j;
        for(j = 1; j < segments.length; j++)keywords = keywords[segments[j]];
        for(j = 0; j < $49747b6b96377985$var$KEYWORDS.length; j++){
            var key = $49747b6b96377985$var$KEYWORDS[j];
            var schema = keywords[key];
            if (schema) keywords[key] = {
                anyOf: [
                    schema,
                    {
                        $ref: 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#'
                    }
                ]
            };
        }
    }
    return metaSchema;
};

});

parcelRegister("9M3ly", function(module, exports) {
'use strict';

var $fWa4K = parcelRequire("fWa4K");
var $71db31598cca1cde$require$MissingRefError = $fWa4K.MissingRef;
module.exports = $71db31598cca1cde$var$compileAsync;
/**
 * Creates validating function for passed schema with asynchronous loading of missing schemas.
 * `loadSchema` option should be a function that accepts schema uri and returns promise that resolves with the schema.
 * @this  Ajv
 * @param {Object}   schema schema object
 * @param {Boolean}  meta optional true to compile meta-schema; this parameter can be skipped
 * @param {Function} callback an optional node-style callback, it is called with 2 parameters: error (or null) and validating function.
 * @return {Promise} promise that resolves with a validating function.
 */ function $71db31598cca1cde$var$compileAsync(schema, meta, callback) {
    /* eslint no-shadow: 0 */ /* global Promise */ /* jshint validthis: true */ var self = this;
    if (typeof this._opts.loadSchema != 'function') throw new Error('options.loadSchema should be a function');
    if (typeof meta == 'function') {
        callback = meta;
        meta = undefined;
    }
    var p = loadMetaSchemaOf(schema).then(function() {
        var schemaObj = self._addSchema(schema, undefined, meta);
        return schemaObj.validate || _compileAsync(schemaObj);
    });
    if (callback) p.then(function(v) {
        callback(null, v);
    }, callback);
    return p;
    function loadMetaSchemaOf(sch) {
        var $schema = sch.$schema;
        return $schema && !self.getSchema($schema) ? $71db31598cca1cde$var$compileAsync.call(self, {
            $ref: $schema
        }, true) : Promise.resolve();
    }
    function _compileAsync(schemaObj) {
        try {
            return self._compile(schemaObj);
        } catch (e) {
            if (e instanceof $71db31598cca1cde$require$MissingRefError) return loadMissingSchema(e);
            throw e;
        }
        function loadMissingSchema(e) {
            var ref = e.missingSchema;
            if (added(ref)) throw new Error('Schema ' + ref + ' is loaded but ' + e.missingRef + ' cannot be resolved');
            var schemaPromise = self._loadingSchemas[ref];
            if (!schemaPromise) {
                schemaPromise = self._loadingSchemas[ref] = self._opts.loadSchema(ref);
                schemaPromise.then(removePromise, removePromise);
            }
            return schemaPromise.then(function(sch) {
                if (!added(ref)) return loadMetaSchemaOf(sch).then(function() {
                    if (!added(ref)) self.addSchema(sch, ref, undefined, meta);
                });
            }).then(function() {
                return _compileAsync(schemaObj);
            });
            function removePromise() {
                delete self._loadingSchemas[ref];
            }
            function added(ref) {
                return self._refs[ref] || self._schemas[ref];
            }
        }
    }
}

});

parcelRegister("8y08O", function(module, exports) {
'use strict';
var $63919bb5649ea76e$var$IDENTIFIER = /^[a-z_$][a-z0-9_$-]*$/i;

var $8Q2L5 = parcelRequire("8Q2L5");

var $eCKcA = parcelRequire("eCKcA");
module.exports = {
    add: $63919bb5649ea76e$var$addKeyword,
    get: $63919bb5649ea76e$var$getKeyword,
    remove: $63919bb5649ea76e$var$removeKeyword,
    validate: $63919bb5649ea76e$var$validateKeyword
};
/**
 * Define custom keyword
 * @this  Ajv
 * @param {String} keyword custom keyword, should be unique (including different from all standard, custom and macro keywords).
 * @param {Object} definition keyword definition object with properties `type` (type(s) which the keyword applies to), `validate` or `compile`.
 * @return {Ajv} this for method chaining
 */ function $63919bb5649ea76e$var$addKeyword(keyword, definition) {
    /* jshint validthis: true */ /* eslint no-shadow: 0 */ var RULES = this.RULES;
    if (RULES.keywords[keyword]) throw new Error('Keyword ' + keyword + ' is already defined');
    if (!$63919bb5649ea76e$var$IDENTIFIER.test(keyword)) throw new Error('Keyword ' + keyword + ' is not a valid identifier');
    if (definition) {
        this.validateKeyword(definition, true);
        var dataType = definition.type;
        if (Array.isArray(dataType)) for(var i = 0; i < dataType.length; i++)_addRule(keyword, dataType[i], definition);
        else _addRule(keyword, dataType, definition);
        var metaSchema = definition.metaSchema;
        if (metaSchema) {
            if (definition.$data && this._opts.$data) metaSchema = {
                anyOf: [
                    metaSchema,
                    {
                        '$ref': 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#'
                    }
                ]
            };
            definition.validateSchema = this.compile(metaSchema, true);
        }
    }
    RULES.keywords[keyword] = RULES.all[keyword] = true;
    function _addRule(keyword, dataType, definition) {
        var ruleGroup;
        for(var i = 0; i < RULES.length; i++){
            var rg = RULES[i];
            if (rg.type == dataType) {
                ruleGroup = rg;
                break;
            }
        }
        if (!ruleGroup) {
            ruleGroup = {
                type: dataType,
                rules: []
            };
            RULES.push(ruleGroup);
        }
        var rule = {
            keyword: keyword,
            definition: definition,
            custom: true,
            code: $8Q2L5,
            implements: definition.implements
        };
        ruleGroup.rules.push(rule);
        RULES.custom[keyword] = rule;
    }
    return this;
}
/**
 * Get keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Object|Boolean} custom keyword definition, `true` if it is a predefined keyword, `false` otherwise.
 */ function $63919bb5649ea76e$var$getKeyword(keyword) {
    /* jshint validthis: true */ var rule = this.RULES.custom[keyword];
    return rule ? rule.definition : this.RULES.keywords[keyword] || false;
}
/**
 * Remove keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Ajv} this for method chaining
 */ function $63919bb5649ea76e$var$removeKeyword(keyword) {
    /* jshint validthis: true */ var RULES = this.RULES;
    delete RULES.keywords[keyword];
    delete RULES.all[keyword];
    delete RULES.custom[keyword];
    for(var i = 0; i < RULES.length; i++){
        var rules = RULES[i].rules;
        for(var j = 0; j < rules.length; j++)if (rules[j].keyword == keyword) {
            rules.splice(j, 1);
            break;
        }
    }
    return this;
}
/**
 * Validate keyword definition
 * @this  Ajv
 * @param {Object} definition keyword definition object.
 * @param {Boolean} throwError true to throw exception if definition is invalid
 * @return {boolean} validation result
 */ function $63919bb5649ea76e$var$validateKeyword(definition, throwError) {
    $63919bb5649ea76e$var$validateKeyword.errors = null;
    var v = this._validateKeyword = this._validateKeyword || this.compile($eCKcA, true);
    if (v(definition)) return true;
    $63919bb5649ea76e$var$validateKeyword.errors = v.errors;
    if (throwError) throw new Error('custom keyword definition is invalid: ' + this.errorsText(v.errors));
    else return false;
}

});
parcelRegister("8Q2L5", function(module, exports) {
'use strict';
module.exports = function generate_custom(it, $keyword, $ruleType) {
    var out = ' ';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    var $errs = 'errs__' + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += ' var schema' + $lvl + ' = ' + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + '; ';
        $schemaValue = 'schema' + $lvl;
    } else $schemaValue = $schema;
    var $rule = this, $definition = 'definition' + $lvl, $rDef = $rule.definition, $closingBraces = '';
    var $compile, $inline, $macro, $ruleValidate, $validateCode;
    if ($isData && $rDef.$data) {
        $validateCode = 'keywordValidate' + $lvl;
        var $validateSchema = $rDef.validateSchema;
        out += ' var ' + $definition + ' = RULES.custom[\'' + $keyword + '\'].definition; var ' + $validateCode + ' = ' + $definition + '.validate;';
    } else {
        $ruleValidate = it.useCustomRule($rule, $schema, it.schema, it);
        if (!$ruleValidate) return;
        $schemaValue = 'validate.schema' + $schemaPath;
        $validateCode = $ruleValidate.code;
        $compile = $rDef.compile;
        $inline = $rDef.inline;
        $macro = $rDef.macro;
    }
    var $ruleErrs = $validateCode + '.errors', $i = 'i' + $lvl, $ruleErr = 'ruleErr' + $lvl, $asyncKeyword = $rDef.async;
    if ($asyncKeyword && !it.async) throw new Error('async keyword in sync schema');
    if (!($inline || $macro)) out += '' + $ruleErrs + ' = null;';
    out += 'var ' + $errs + ' = errors;var ' + $valid + ';';
    if ($isData && $rDef.$data) {
        $closingBraces += '}';
        out += ' if (' + $schemaValue + ' === undefined) { ' + $valid + ' = true; } else { ';
        if ($validateSchema) {
            $closingBraces += '}';
            out += ' ' + $valid + ' = ' + $definition + '.validateSchema(' + $schemaValue + '); if (' + $valid + ') { ';
        }
    }
    if ($inline) {
        if ($rDef.statements) out += ' ' + $ruleValidate.validate + ' ';
        else out += ' ' + $valid + ' = ' + $ruleValidate.validate + '; ';
    } else if ($macro) {
        var $it = it.util.copy(it);
        var $closingBraces = '';
        $it.level++;
        var $nextValid = 'valid' + $it.level;
        $it.schema = $ruleValidate.validate;
        $it.schemaPath = '';
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var $code = it.validate($it).replace(/validate\.schema/g, $validateCode);
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += ' ' + $code;
    } else {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        out += '  ' + $validateCode + '.call( ';
        if (it.opts.passContext) out += 'this';
        else out += 'self';
        if ($compile || $rDef.schema === false) out += ' , ' + $data + ' ';
        else out += ' , ' + $schemaValue + ' , ' + $data + ' , validate.schema' + it.schemaPath + ' ';
        out += ' , (dataPath || \'\')';
        if (it.errorPath != '""') out += ' + ' + it.errorPath;
        var $parentData = $dataLvl ? 'data' + ($dataLvl - 1 || '') : 'parentData', $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
        out += ' , ' + $parentData + ' , ' + $parentDataProperty + ' , rootData )  ';
        var def_callRuleValidate = out;
        out = $$outStack.pop();
        if ($rDef.errors === false) {
            out += ' ' + $valid + ' = ';
            if ($asyncKeyword) out += 'await ';
            out += '' + def_callRuleValidate + '; ';
        } else if ($asyncKeyword) {
            $ruleErrs = 'customErrors' + $lvl;
            out += ' var ' + $ruleErrs + ' = null; try { ' + $valid + ' = await ' + def_callRuleValidate + '; } catch (e) { ' + $valid + ' = false; if (e instanceof ValidationError) ' + $ruleErrs + ' = e.errors; else throw e; } ';
        } else out += ' ' + $ruleErrs + ' = null; ' + $valid + ' = ' + def_callRuleValidate + '; ';
    }
    if ($rDef.modifying) out += ' if (' + $parentData + ') ' + $data + ' = ' + $parentData + '[' + $parentDataProperty + '];';
    out += '' + $closingBraces;
    if ($rDef.valid) {
        if ($breakOnError) out += ' if (true) { ';
    } else {
        out += ' if ( ';
        if ($rDef.valid === undefined) {
            out += ' !';
            if ($macro) out += '' + $nextValid;
            else out += '' + $valid;
        } else out += ' ' + !$rDef.valid + ' ';
        out += ') { ';
        $errorKeyword = $rule.keyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = '';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { keyword: \'' + $rule.keyword + '\' } ';
            if (it.opts.messages !== false) out += ' , message: \'should pass "' + $rule.keyword + '" keyword validation\' ';
            if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
            out += ' } ';
        } else out += ' {} ';
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError([' + __err + ']); ';
            else out += ' validate.errors = [' + __err + ']; return false; ';
        } else out += ' var err = ' + __err + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        var def_customError = out;
        out = $$outStack.pop();
        if ($inline) {
            if ($rDef.errors) {
                if ($rDef.errors != 'full') {
                    out += '  for (var ' + $i + '=' + $errs + '; ' + $i + '<errors; ' + $i + '++) { var ' + $ruleErr + ' = vErrors[' + $i + ']; if (' + $ruleErr + '.dataPath === undefined) ' + $ruleErr + '.dataPath = (dataPath || \'\') + ' + it.errorPath + '; if (' + $ruleErr + '.schemaPath === undefined) { ' + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
                    if (it.opts.verbose) out += ' ' + $ruleErr + '.schema = ' + $schemaValue + '; ' + $ruleErr + '.data = ' + $data + '; ';
                    out += ' } ';
                }
            } else if ($rDef.errors === false) out += ' ' + def_customError + ' ';
            else {
                out += ' if (' + $errs + ' == errors) { ' + def_customError + ' } else {  for (var ' + $i + '=' + $errs + '; ' + $i + '<errors; ' + $i + '++) { var ' + $ruleErr + ' = vErrors[' + $i + ']; if (' + $ruleErr + '.dataPath === undefined) ' + $ruleErr + '.dataPath = (dataPath || \'\') + ' + it.errorPath + '; if (' + $ruleErr + '.schemaPath === undefined) { ' + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
                if (it.opts.verbose) out += ' ' + $ruleErr + '.schema = ' + $schemaValue + '; ' + $ruleErr + '.data = ' + $data + '; ';
                out += ' } } ';
            }
        } else if ($macro) {
            out += '   var err =   '; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + it.errorPath + ' , schemaPath: ' + it.util.toQuotedString($errSchemaPath) + ' , params: { keyword: \'' + $rule.keyword + '\' } ';
                if (it.opts.messages !== false) out += ' , message: \'should pass "' + $rule.keyword + '" keyword validation\' ';
                if (it.opts.verbose) out += ' , schema: validate.schema' + $schemaPath + ' , parentSchema: validate.schema' + it.schemaPath + ' , data: ' + $data + ' ';
                out += ' } ';
            } else out += ' {} ';
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += ' throw new ValidationError(vErrors); ';
                else out += ' validate.errors = vErrors; return false; ';
            }
        } else if ($rDef.errors === false) out += ' ' + def_customError + ' ';
        else {
            out += ' if (Array.isArray(' + $ruleErrs + ')) { if (vErrors === null) vErrors = ' + $ruleErrs + '; else vErrors = vErrors.concat(' + $ruleErrs + '); errors = vErrors.length;  for (var ' + $i + '=' + $errs + '; ' + $i + '<errors; ' + $i + '++) { var ' + $ruleErr + ' = vErrors[' + $i + ']; if (' + $ruleErr + '.dataPath === undefined) ' + $ruleErr + '.dataPath = (dataPath || \'\') + ' + it.errorPath + ';  ' + $ruleErr + '.schemaPath = "' + $errSchemaPath + '";  ';
            if (it.opts.verbose) out += ' ' + $ruleErr + '.schema = ' + $schemaValue + '; ' + $ruleErr + '.data = ' + $data + '; ';
            out += ' } } else { ' + def_customError + ' } ';
        }
        out += ' } ';
        if ($breakOnError) out += ' else { ';
    }
    return out;
};

});

parcelRegister("eCKcA", function(module, exports) {
'use strict';

var $6UkVC = parcelRequire("6UkVC");
module.exports = {
    $id: 'https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js',
    definitions: {
        simpleTypes: $6UkVC.definitions.simpleTypes
    },
    type: 'object',
    dependencies: {
        schema: [
            'validate'
        ],
        $data: [
            'validate'
        ],
        statements: [
            'inline'
        ],
        valid: {
            not: {
                required: [
                    'macro'
                ]
            }
        }
    },
    properties: {
        type: $6UkVC.properties.type,
        schema: {
            type: 'boolean'
        },
        statements: {
            type: 'boolean'
        },
        dependencies: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        metaSchema: {
            type: 'object'
        },
        modifying: {
            type: 'boolean'
        },
        valid: {
            type: 'boolean'
        },
        $data: {
            type: 'boolean'
        },
        async: {
            type: 'boolean'
        },
        errors: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    const: 'full'
                }
            ]
        }
    }
};

});
parcelRegister("6UkVC", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$comment\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":true},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true,\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentEncoding\":{\"type\":\"string\"},\"if\":{\"$ref\":\"#\"},\"then\":{\"$ref\":\"#\"},\"else\":{\"$ref\":\"#\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":true}");

});



parcelRegister("gQ2Dr", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#\",\"description\":\"Meta-schema for $data reference (JSON Schema extension proposal)\",\"type\":\"object\",\"required\":[\"$data\"],\"properties\":{\"$data\":{\"type\":\"string\",\"anyOf\":[{\"format\":\"relative-json-pointer\"},{\"format\":\"json-pointer\"}]}},\"additionalProperties\":false}");

});


parcelRegister("jngaF", function(module, exports) {

$parcel$export(module.exports, "ApiFieldDataResponseSchema", () => $e1acb58b182a1b74$export$d3e97414e885ab0b);
const $e1acb58b182a1b74$export$d3e97414e885ab0b = {
    $schema: 'http://json-schema.org/draft-04/schema#',
    description: 'Schema for the response of API fielddata.',
    $ref: '#/definitions/fielddata',
    definitions: {
        fielddata: {
            type: 'object',
            patternProperties: {
                '^[a-zA-Z0-9{}/]+$': {
                    $ref: '#/definitions/issuefielddata'
                }
            }
        },
        issuefielddata: {
            properties: {
                value: {
                    $ref: '#/definitions/issuefieldvalue'
                },
                readOnlyReason: {
                    type: 'string'
                },
                maxAllowedChoices: {
                    type: 'number'
                },
                multiple: {
                    type: 'boolean'
                },
                fieldConfigId: {
                    type: 'string'
                },
                populateDefaultValueOnEmptySearch: {
                    type: 'boolean'
                },
                dependsOn: {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                },
                schema: {
                    $ref: '#/definitions/schema'
                }
            },
            required: [
                'value'
            ],
            type: 'object'
        },
        schema: {
            properties: {
                type: {
                    type: 'string'
                },
                custom: {
                    type: 'string'
                },
                system: {
                    type: 'string'
                }
            },
            type: 'object'
        },
        issuefieldvalue: {
            properties: {
                choices: {
                    type: 'array',
                    items: {
                        $ref: '#/definitions/jirafieldchoice'
                    }
                },
                date: {
                    type: 'string'
                },
                text: {
                    type: 'string'
                },
                time: {
                    type: 'string'
                },
                users: {
                    items: {
                        $ref: '#/definitions/userpickeruser'
                    },
                    type: 'array'
                }
            },
            type: 'object'
        },
        jirafieldchoice: {
            defaultProperties: [],
            properties: {
                id: {
                    type: 'string'
                },
                label: {
                    type: 'string'
                }
            },
            required: [
                'id',
                'label'
            ],
            type: 'object'
        },
        userpickeruser: {
            defaultProperties: [],
            properties: {
                id: {
                    type: 'string'
                },
                name: {
                    type: 'string'
                }
            },
            required: [
                'id',
                'name'
            ],
            type: 'object'
        }
    }
};

});

parcelRegister("Z8Nv6", function(module, exports) {

$parcel$export(module.exports, "ApiFormChoicesResponseSchema", () => $0b7c85999398c70b$export$d8f14bc9d28df3b4);
const $0b7c85999398c70b$export$d8f14bc9d28df3b4 = {
    $schema: 'http://json-schema.org/draft-04/schema#',
    description: 'Schema for the response of API formchoices.',
    $ref: '#/definitions/formchoices',
    definitions: {
        formchoices: {
            defaultProperties: [],
            properties: {
                fields: {
                    type: 'object',
                    patternProperties: {
                        '^[a-zA-Z0-9{}/]+$': {
                            items: {
                                $ref: '#/definitions/jirafieldchoice'
                            },
                            type: 'array'
                        }
                    }
                },
                dataConnections: {
                    type: 'object',
                    patternProperties: {
                        '^[a-zA-Z0-9{}/]+$': {
                            items: {
                                $ref: '#/definitions/jirafieldchoice'
                            },
                            type: 'array'
                        }
                    }
                }
            },
            required: [
                'dataConnections',
                'fields'
            ],
            type: 'object'
        },
        jirafieldchoice: {
            properties: {
                id: {
                    type: 'string'
                },
                label: {
                    type: 'string'
                }
            },
            required: [
                'id',
                'label'
            ],
            type: 'object'
        }
    }
};

});

parcelRegister("9uYSm", function(module, exports) {
module.exports = JSON.parse("{\"id\":\"http://json-schema.org/draft-04/schema#\",\"$schema\":\"http://json-schema.org/draft-04/schema#\",\"description\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"positiveInteger\":{\"type\":\"integer\",\"minimum\":0},\"positiveIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/positiveInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"minItems\":1,\"uniqueItems\":true}},\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\"},\"$schema\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":{},\"multipleOf\":{\"type\":\"number\",\"minimum\":0,\"exclusiveMinimum\":true},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"boolean\",\"default\":false},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"boolean\",\"default\":false},\"maxLength\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minLength\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#\"}],\"default\":{}},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":{}},\"maxItems\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minItems\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"maxProperties\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#\"}],\"default\":{}},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"enum\":{\"type\":\"array\",\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"dependencies\":{\"exclusiveMaximum\":[\"maximum\"],\"exclusiveMinimum\":[\"minimum\"]},\"default\":{}}");

});



parcelRegister("ln9gy", function(module, exports) {

$parcel$export(module.exports, "loadFieldDataFn", () => $f8f2eeffb9900a7d$export$ed2a368872b32c4b);

var $alnGD = parcelRequire("alnGD");

var $4aJmI = parcelRequire("4aJmI");

var $iSRld = parcelRequire("iSRld");

var $5e1Fe = parcelRequire("5e1Fe");
const $f8f2eeffb9900a7d$var$shouldOverwriteAnswerWithFieldValueAnswer = (fieldValueAnswer)=>{
    // Assume that if there is a non-empty answer in the field data response, that we should prefer that
    // over whatever is currently in the form. At the time of writing, this only occurs for async choice fields
    // default answer values on portal create / issue forms.
    const isFieldValueAnswerEmpty = Object.keys(fieldValueAnswer).length === 0;
    return !isFieldValueAnswerEmpty;
};
const $f8f2eeffb9900a7d$var$getRichTextFormat = (formQuestionType)=>{
    if (formQuestionType === (0, $4aJmI.FormQuestionType).RichTextParagraph) return (0, $iSRld.RichTextFormat).Adf;
    else if (formQuestionType === (0, $4aJmI.FormQuestionType).TextParagraph) return (0, $iSRld.RichTextFormat).Wiki;
    return undefined;
};
const $f8f2eeffb9900a7d$export$ed2a368872b32c4b = (requestFieldData, errorUtils, isAlwaysOverwriteEmptyLinkedFields = true)=>{
    return (formStore)=>{
        return ()=>{
            // Build a map of all linked Jira fields used by this form:
            const fieldsInUse = formStore.questions.reduce((fieldsInUse, questionStore)=>{
                if (questionStore.formQuestion.jiraField) fieldsInUse.push({
                    fieldKey: questionStore.formQuestion.jiraField,
                    format: $f8f2eeffb9900a7d$var$getRichTextFormat(questionStore.formQuestion.type)
                });
                return fieldsInUse;
            }, []);
            if (fieldsInUse.length === 0) return Promise.resolve();
            return requestFieldData({
                fields: fieldsInUse
            }).then((fieldData)=>{
                const validationResult = (0, $5e1Fe.validate)('ApiFieldDataResponseSchema', fieldData);
                if (!validationResult.isValid) {
                    errorUtils.reportError(new Error('Response type mismatch'), {
                        id: 'ApiFieldDataResponseSchema',
                        attributes: {
                            errors: JSON.stringify(validationResult.errors)
                        }
                    });
                    return;
                }
                const fieldMap = new Map(Object.entries(fieldData));
                (0, $alnGD.runInAction)(()=>{
                    formStore.questions.forEach((questionStore)=>{
                        if (questionStore.formQuestion.jiraField && fieldMap.has(questionStore.formQuestion.jiraField)) {
                            // The API and UI code have slightly different representations of answers, so choices and users need to be converted:
                            const issueFieldData = fieldMap.get(questionStore.formQuestion.jiraField);
                            const issueFieldValue = issueFieldData.value;
                            const answer = {
                                ...issueFieldValue.text && {
                                    text: issueFieldValue.text
                                },
                                ...issueFieldValue.adf && {
                                    adf: issueFieldValue.adf
                                },
                                ...issueFieldValue.date && {
                                    date: issueFieldValue.date
                                },
                                ...issueFieldValue.time && {
                                    // jira time value includes seconds which ProForma doesn't use, so trim them
                                    time: !!issueFieldValue.time.match(/^\d+:\d+:\d+$/) ? issueFieldValue.time.replace(/:\d+$/, '') : issueFieldValue.time
                                },
                                ...issueFieldValue.choices && {
                                    choices: issueFieldValue.choices.map((choice)=>choice.id)
                                },
                                ...issueFieldValue.users && {
                                    users: issueFieldValue.users
                                }
                            };
                            questionStore.setIssueFieldData(issueFieldData);
                            if (formStore.status === (0, $4aJmI.FormStatus).Open) {
                                if (isAlwaysOverwriteEmptyLinkedFields || $f8f2eeffb9900a7d$var$shouldOverwriteAnswerWithFieldValueAnswer(answer)) {
                                    questionStore.setAnswerFromFieldValue(answer);
                                    questionStore.setAnswerChoicesAsObjects(issueFieldValue.choices || []);
                                }
                            }
                        }
                    });
                });
            });
        };
    };
};

});
parcelRegister("iSRld", function(module, exports) {

$parcel$export(module.exports, "RichTextFormat", () => $dbf6a5987f7a8f34$export$1a67d705855415ad);
let $dbf6a5987f7a8f34$export$1a67d705855415ad = /*#__PURE__*/ function(RichTextFormat) {
    RichTextFormat["Adf"] = "adf";
    RichTextFormat["Wiki"] = "wiki";
    return RichTextFormat;
}({});

});


parcelRegister("hlh9r", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a376b5b712f58f4a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a376b5b712f58f4a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    objectSearchErrorTitle: {
        "id": "proforma-panel-in-issue-view-ui.stores.object-search-error-title",
        "defaultMessage": "We couldn't fetch any objects for this field"
    },
    objectSearchErrorDescription: {
        "id": "proforma-panel-in-issue-view-ui.stores.object-search-error-description",
        "defaultMessage": "Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid."
    }
});

});


parcelRegister("i7kEj", function(module, exports) {

$parcel$export(module.exports, "IssueView", () => $1c02593db065b21d$export$5aebed4b5cba826a);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $c8cwY = parcelRequire("c8cwY");
var $N5QrD = parcelRequire("N5QrD");

var $4R6GH = parcelRequire("4R6GH");

var $6vE26 = parcelRequire("6vE26");

var $4P4jr = parcelRequire("4P4jr");

var $h6FXj = parcelRequire("h6FXj");
const $1c02593db065b21d$export$5aebed4b5cba826a = (0, $jJXgM.observer)(({ issueViewStore: issueViewStore, proformaUrl: proformaUrl, addFormButtonClickedCount: addFormButtonClickedCount, disableIssueViewFullPageDropzoneCallback: disableIssueViewFullPageDropzoneCallback, projectType: projectType })=>{
    const handleFormSelected = (0, $6vE26.useHandleFormSelected)(issueViewStore, disableIssueViewFullPageDropzoneCallback);
    const selectFormNoDiscardChangeNotice = (0, $4R6GH.fg)('granular_permissions_on_forms_ga') ? (0, $6vE26.useSelectFormNoDiscardChangeNotice)(issueViewStore.loadFormStore, disableIssueViewFullPageDropzoneCallback) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    const { formIndex: formIndex, isInitialised: isFormIndexInitialised, selectedFormId: selectedFormId } = (0, $N5QrD.useFormIndexState)();
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('granular_permissions_on_forms_ga')) {
            if (isFormIndexInitialised) {
                const formIdToSelect = selectedFormId || (0, $c8cwY.getDefaultFormId)(formIndex, issueViewStore.projectId);
                if (formIdToSelect !== undefined) {
                    const formToSelect = formIndex.find((form)=>form.id === formIdToSelect);
                    selectFormNoDiscardChangeNotice(formToSelect?.id, undefined, formToSelect?.hasAccess);
                }
            }
            return;
        }
        if (isFormIndexInitialised) {
            if (selectedFormId) handleFormSelected(selectedFormId);
            else {
                const defaultFormId = (0, $c8cwY.getDefaultFormId)(formIndex, issueViewStore.projectId);
                if (defaultFormId) handleFormSelected(defaultFormId);
            }
        }
    // Only depend on isFormIndexInitialised so this effect only runs once after the index is initialised
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFormIndexInitialised
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h6FXj.JiraFormCardIndex), {
        issueViewStore: issueViewStore,
        disableIssueViewFullPageDropzoneCallback: disableIssueViewFullPageDropzoneCallback,
        proformaUrl: proformaUrl,
        projectType: projectType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4P4jr.JiraAddForm), {
        addFormButtonClickedCount: addFormButtonClickedCount,
        issueViewStore: issueViewStore,
        disableIssueViewFullPageDropzoneCallback: disableIssueViewFullPageDropzoneCallback,
        issueId: issueViewStore.issueId
    }));
});

});
parcelRegister("f2sTC", function(module, exports) {

$parcel$export(module.exports, "observer", () => (parcelRequire("jJXgM")).observer);
parcelRequire("7qxfo");
parcelRequire("jcjpM");
var $7nsd3 = parcelRequire("7nsd3");

var $dkbyT = parcelRequire("dkbyT");

var $aZ24W = parcelRequire("aZ24W");

var $jJXgM = parcelRequire("jJXgM");

var $diuRl = parcelRequire("diuRl");

var $9rP9c = parcelRequire("9rP9c");

var $fB7Vm = parcelRequire("fB7Vm");

var $ic428 = parcelRequire("ic428");

var $g4qUw = parcelRequire("g4qUw");

var $a3gxK = parcelRequire("a3gxK");
(0, $dkbyT.observerBatching)((0, $7nsd3.unstable_batchedUpdates));

});
parcelRegister("7qxfo", function(module, exports) {

var $alnGD = parcelRequire("alnGD");

var $5uXOq = parcelRequire("5uXOq");
if (!(0, $5uXOq.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $alnGD.spy)) throw new Error("mobx-react-lite requires mobx at least version 4 to be available");

});

parcelRegister("jcjpM", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("7nsd3")).unstable_batchedUpdates);

var $7nsd3 = parcelRequire("7nsd3");

});

parcelRegister("dkbyT", function(module, exports) {

$parcel$export(module.exports, "observerBatching", () => $9b361c8d596d377c$export$294943bbc3c74f4f);

var $alnGD = parcelRequire("alnGD");

var $fB7Vm = parcelRequire("fB7Vm");
var $9b361c8d596d377c$var$observerBatchingConfiguredSymbol = (0, $fB7Vm.getSymbol)("observerBatching");
function $9b361c8d596d377c$export$fb2daceae6f5097a(callback) {
    callback();
}
function $9b361c8d596d377c$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $9b361c8d596d377c$export$fb2daceae6f5097a;
    (0, $alnGD.configure)({
        reactionScheduler: reactionScheduler
    });
    (0, $fB7Vm.getGlobal)()[$9b361c8d596d377c$var$observerBatchingConfiguredSymbol] = true;
}
var $9b361c8d596d377c$export$13ce1459b9a04b51 = function() {
    return !!(0, $fB7Vm.getGlobal)()[$9b361c8d596d377c$var$observerBatchingConfiguredSymbol];
};

});
parcelRegister("fB7Vm", function(module, exports) {

$parcel$export(module.exports, "useForceUpdate", () => $b5b0754b512ef7f7$export$91db9bc4f8ac944a);
$parcel$export(module.exports, "isPlainObject", () => $b5b0754b512ef7f7$export$53b83ca8eaab0383);
$parcel$export(module.exports, "getSymbol", () => $b5b0754b512ef7f7$export$57af67db727bc7c7);
$parcel$export(module.exports, "getGlobal", () => $b5b0754b512ef7f7$export$a4e55266d2135a7f);

var $5uXOq = parcelRequire("5uXOq");
var $b5b0754b512ef7f7$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b5b0754b512ef7f7$var$EMPTY_ARRAY = [];
function $b5b0754b512ef7f7$export$89e33b3d84d8c331(fn) {
    (0, $5uXOq.useEffect)(function() {
        return fn;
    }, $b5b0754b512ef7f7$var$EMPTY_ARRAY);
}
function $b5b0754b512ef7f7$export$91db9bc4f8ac944a() {
    var _a = $b5b0754b512ef7f7$var$__read((0, $5uXOq.useState)(0), 2), setTick = _a[1];
    var update = (0, $5uXOq.useCallback)(function() {
        setTick(function(tick) {
            return tick + 1;
        });
    }, []);
    return update;
}
function $b5b0754b512ef7f7$export$53b83ca8eaab0383(value) {
    if (!value || typeof value !== "object") return false;
    var proto = Object.getPrototypeOf(value);
    return !proto || proto === Object.prototype;
}
function $b5b0754b512ef7f7$export$57af67db727bc7c7(name) {
    if (typeof Symbol === "function") return Symbol.for(name);
    return "__$mobx-react " + name + "__";
}
var $b5b0754b512ef7f7$var$mockGlobal = {};
function $b5b0754b512ef7f7$export$a4e55266d2135a7f() {
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return $b5b0754b512ef7f7$var$mockGlobal;
}

});


parcelRegister("aZ24W", function(module, exports) {

$parcel$export(module.exports, "isUsingStaticRendering", () => $7ff136aa028e6424$export$55979271896d643e);
var $7ff136aa028e6424$var$globalIsUsingStaticRendering = false;
function $7ff136aa028e6424$export$7613124ee4202834(enable) {
    $7ff136aa028e6424$var$globalIsUsingStaticRendering = enable;
}
function $7ff136aa028e6424$export$55979271896d643e() {
    return $7ff136aa028e6424$var$globalIsUsingStaticRendering;
}

});

parcelRegister("jJXgM", function(module, exports) {

$parcel$export(module.exports, "observer", () => $e5f0320777ce83cc$export$b6ae1bc530f4c149);

var $5uXOq = parcelRequire("5uXOq");

var $aZ24W = parcelRequire("aZ24W");

var $diuRl = parcelRequire("diuRl");
var $e5f0320777ce83cc$var$__assign = undefined && undefined.__assign || function() {
    $e5f0320777ce83cc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e5f0320777ce83cc$var$__assign.apply(this, arguments);
};
function $e5f0320777ce83cc$export$b6ae1bc530f4c149(baseComponent, options) {
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $aZ24W.isUsingStaticRendering)()) return baseComponent;
    var realOptions = $e5f0320777ce83cc$var$__assign({
        forwardRef: false
    }, options);
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    var wrappedComponent = function(props, ref) {
        return (0, $diuRl.useObserver)(function() {
            return baseComponent(props, ref);
        }, baseComponentName);
    };
    wrappedComponent.displayName = baseComponentName;
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    var memoComponent;
    if (realOptions.forwardRef) // we have to use forwardRef here because:
    // 1. it cannot go before memo, only after it
    // 2. forwardRef converts the function into an actual component, so we can't let the baseComponent do it
    //    since it wouldn't be a callable function anymore
    memoComponent = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(wrappedComponent));
    else memoComponent = (0, $5uXOq.memo)(wrappedComponent);
    $e5f0320777ce83cc$var$copyStaticProperties(baseComponent, memoComponent);
    memoComponent.displayName = baseComponentName;
    return memoComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $e5f0320777ce83cc$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true
};
function $e5f0320777ce83cc$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$e5f0320777ce83cc$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}

});
parcelRegister("diuRl", function(module, exports) {

$parcel$export(module.exports, "useObserver", () => $9ae4e4d0873f62b3$export$b9c7ecd090a87b14);

var $alnGD = parcelRequire("alnGD");

var $5uXOq = parcelRequire("5uXOq");

var $kic6x = parcelRequire("kic6x");

var $gLdfn = parcelRequire("gLdfn");

var $aZ24W = parcelRequire("aZ24W");

var $fB7Vm = parcelRequire("fB7Vm");

var $a3gxK = parcelRequire("a3gxK");
var $9ae4e4d0873f62b3$var$EMPTY_OBJECT = {};
function $9ae4e4d0873f62b3$var$observerComponentNameFor(baseComponentName) {
    return "observer" + baseComponentName;
}
function $9ae4e4d0873f62b3$export$b9c7ecd090a87b14(fn, baseComponentName, options) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if (options === void 0) options = $9ae4e4d0873f62b3$var$EMPTY_OBJECT;
    if ((0, $aZ24W.isUsingStaticRendering)()) return fn();
    var wantedForceUpdateHook = options.useForceUpdate || (0, $fB7Vm.useForceUpdate);
    var forceUpdate = wantedForceUpdateHook();
    var queuedForceUpdate = (0, $a3gxK.useQueuedForceUpdate)(forceUpdate);
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var reactionTrackingRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    if (!reactionTrackingRef.current) {
        // First render for this component (or first time since a previous
        // reaction from an abandoned render was disposed).
        var newReaction_1 = new (0, $alnGD.Reaction)($9ae4e4d0873f62b3$var$observerComponentNameFor(baseComponentName), function() {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (trackingData_1.mounted) // We have reached useEffect(), so we're mounted, and can trigger an update
            queuedForceUpdate();
            else {
                // We haven't yet reached useEffect(), so we'll need to trigger a re-render
                // when (and if) useEffect() arrives.  The easiest way to do that is just to
                // drop our current reaction and allow useEffect() to recreate it.
                newReaction_1.dispose();
                reactionTrackingRef.current = null;
            }
        });
        var trackingData_1 = (0, $gLdfn.createTrackingData)(newReaction_1);
        reactionTrackingRef.current = trackingData_1;
        (0, $gLdfn.scheduleCleanupOfReactionIfLeaked)(reactionTrackingRef);
    }
    var reaction = reactionTrackingRef.current.reaction;
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useDebugValue(reaction, (0, $kic6x.printDebugValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(function() {
        // Called on first mount only
        (0, $gLdfn.recordReactionAsCommitted)(reactionTrackingRef);
        if (reactionTrackingRef.current) // Great. We've already got our reaction from our render;
        // all we need to do is to record that it's now mounted,
        // to allow future observable changes to trigger re-renders
        reactionTrackingRef.current.mounted = true;
        else {
            // The reaction we set up in our render has been disposed.
            // This is either due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up, or we got a observable change
            // between render and useEffect
            // Re-create the reaction
            reactionTrackingRef.current = {
                reaction: new (0, $alnGD.Reaction)($9ae4e4d0873f62b3$var$observerComponentNameFor(baseComponentName), function() {
                    // We've definitely already been mounted at this point
                    queuedForceUpdate();
                }),
                cleanAt: Infinity
            };
            queuedForceUpdate();
        }
        return function() {
            reactionTrackingRef.current.reaction.dispose();
            reactionTrackingRef.current = null;
        };
    }, []);
    // delay all force-update calls after rendering of this component
    return (0, $a3gxK.useQueuedForceUpdateBlock)(function() {
        // render the original component, but have the
        // reaction track the observables, so that rendering
        // can be invalidated (see above) once a dependency changes
        var rendering;
        var exception;
        reaction.track(function() {
            try {
                rendering = fn();
            } catch (e) {
                exception = e;
            }
        });
        if (exception) throw exception; // re-throw any exceptions caught during rendering
        return rendering;
    });
}

});
parcelRegister("kic6x", function(module, exports) {

$parcel$export(module.exports, "printDebugValue", () => $ec5ee0ca53ebf31f$export$ef795f1f307682c7);

var $alnGD = parcelRequire("alnGD");
function $ec5ee0ca53ebf31f$export$ef795f1f307682c7(v) {
    return (0, $alnGD.getDependencyTree)(v);
}

});

parcelRegister("gLdfn", function(module, exports) {

$parcel$export(module.exports, "createTrackingData", () => $c33b4fb78bda2447$export$bbb1082a9abc1839);
$parcel$export(module.exports, "scheduleCleanupOfReactionIfLeaked", () => $c33b4fb78bda2447$export$674b151f0ca8d79f);
$parcel$export(module.exports, "recordReactionAsCommitted", () => $c33b4fb78bda2447$export$ab63aa5c46b8d26f);
function $c33b4fb78bda2447$export$bbb1082a9abc1839(reaction) {
    var trackingData = {
        cleanAt: Date.now() + $c33b4fb78bda2447$export$6c9b1ff66852295c,
        reaction: reaction
    };
    return trackingData;
}
var $c33b4fb78bda2447$export$6c9b1ff66852295c = 10000;
var $c33b4fb78bda2447$export$262a80afc9566214 = 10000;
/**
 * Reactions created by components that have yet to be fully mounted.
 */ var $c33b4fb78bda2447$var$uncommittedReactionRefs = new Set();
/**
 * Latest 'uncommitted reactions' cleanup timer handle.
 */ var $c33b4fb78bda2447$var$reactionCleanupHandle;
function $c33b4fb78bda2447$var$ensureCleanupTimerRunning() {
    if ($c33b4fb78bda2447$var$reactionCleanupHandle === undefined) $c33b4fb78bda2447$var$reactionCleanupHandle = setTimeout($c33b4fb78bda2447$var$cleanUncommittedReactions, $c33b4fb78bda2447$export$262a80afc9566214);
}
function $c33b4fb78bda2447$export$674b151f0ca8d79f(ref) {
    $c33b4fb78bda2447$var$uncommittedReactionRefs.add(ref);
    $c33b4fb78bda2447$var$ensureCleanupTimerRunning();
}
function $c33b4fb78bda2447$export$ab63aa5c46b8d26f(reactionRef) {
    $c33b4fb78bda2447$var$uncommittedReactionRefs.delete(reactionRef);
}
/**
 * Run by the cleanup timer to dispose any outstanding reactions
 */ function $c33b4fb78bda2447$var$cleanUncommittedReactions() {
    $c33b4fb78bda2447$var$reactionCleanupHandle = undefined;
    // Loop through all the candidate leaked reactions; those older
    // than CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS get tidied.
    var now = Date.now();
    $c33b4fb78bda2447$var$uncommittedReactionRefs.forEach(function(ref) {
        var tracking = ref.current;
        if (tracking) {
            if (now >= tracking.cleanAt) {
                // It's time to tidy up this leaked reaction.
                tracking.reaction.dispose();
                ref.current = null;
                $c33b4fb78bda2447$var$uncommittedReactionRefs.delete(ref);
            }
        }
    });
    if ($c33b4fb78bda2447$var$uncommittedReactionRefs.size > 0) // We've just finished a round of cleanups but there are still
    // some leak candidates outstanding.
    $c33b4fb78bda2447$var$ensureCleanupTimerRunning();
}
function $c33b4fb78bda2447$export$e4e43e0ec68bea7() {
    // This allows us to control the execution of the cleanup timer
    // to force it to run at awkward times in unit tests.
    if ($c33b4fb78bda2447$var$reactionCleanupHandle) {
        clearTimeout($c33b4fb78bda2447$var$reactionCleanupHandle);
        $c33b4fb78bda2447$var$cleanUncommittedReactions();
    }
}
function $c33b4fb78bda2447$export$8ccb7f898b3f89a3() {
    if ($c33b4fb78bda2447$var$reactionCleanupHandle) {
        clearTimeout($c33b4fb78bda2447$var$reactionCleanupHandle);
        $c33b4fb78bda2447$var$reactionCleanupHandle = undefined;
    }
    $c33b4fb78bda2447$var$uncommittedReactionRefs.clear();
}

});

parcelRegister("a3gxK", function(module, exports) {

$parcel$export(module.exports, "useQueuedForceUpdate", () => $7517045cc96643b0$export$68f31d22c29ca55);
$parcel$export(module.exports, "useQueuedForceUpdateBlock", () => $7517045cc96643b0$export$7cdb73c439d9f744);

var $5uXOq = parcelRequire("5uXOq");
var $7517045cc96643b0$var$insideRender = false;
var $7517045cc96643b0$var$forceUpdateQueue = [];
function $7517045cc96643b0$export$68f31d22c29ca55(forceUpdate) {
    return function() {
        if ($7517045cc96643b0$var$insideRender) $7517045cc96643b0$var$forceUpdateQueue.push(forceUpdate);
        else forceUpdate();
    };
}
function $7517045cc96643b0$export$7cdb73c439d9f744(callback) {
    // start intercepting force-update calls
    $7517045cc96643b0$var$insideRender = true;
    $7517045cc96643b0$var$forceUpdateQueue = [];
    try {
        var result = callback();
        // stop intercepting force-update
        $7517045cc96643b0$var$insideRender = false;
        // store queue or nothing if it was empty to execute useLayoutEffect only when necessary
        var queue_1 = $7517045cc96643b0$var$forceUpdateQueue.length > 0 ? $7517045cc96643b0$var$forceUpdateQueue : undefined;
        // run force-update queue in useLayoutEffect
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useLayoutEffect(function() {
            if (queue_1) queue_1.forEach(function(x) {
                return x();
            });
        }, [
            queue_1
        ]);
        return result;
    } finally{
        $7517045cc96643b0$var$insideRender = false;
    }
}

});



parcelRegister("9rP9c", function(module, exports) {

var $diuRl = parcelRequire("diuRl");
function $6e0e4f738816fdc3$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $diuRl.useObserver)(component);
}
$6e0e4f738816fdc3$export$c1cbdee04e18ea8b.propTypes = {
    children: $6e0e4f738816fdc3$var$ObserverPropsCheck,
    render: $6e0e4f738816fdc3$var$ObserverPropsCheck
};
$6e0e4f738816fdc3$export$c1cbdee04e18ea8b.displayName = "Observer";
function $6e0e4f738816fdc3$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}

});

parcelRegister("ic428", function(module, exports) {

$parcel$export(module.exports, "useAsObservableSourceInternal", () => $d3ec79ea917503e0$export$3ad4ae20ecfadabf);

var $alnGD = parcelRequire("alnGD");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("fB7Vm");
var $d3ec79ea917503e0$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $d3ec79ea917503e0$export$3ad4ae20ecfadabf(current, usedByLocalStore) {
    var culprit = usedByLocalStore ? "useLocalStore" : "useAsObservableSource";
    var _a, initialSource;
    if (usedByLocalStore && current === undefined) return undefined;
    var _b = $d3ec79ea917503e0$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(function() {
        return (0, $alnGD.observable)(current, {}, {
            deep: false
        });
    }), 1), res = _b[0];
    (0, $alnGD.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}
function $d3ec79ea917503e0$export$e0ded3646391939c(current) {
    return $d3ec79ea917503e0$export$3ad4ae20ecfadabf(current, false);
}

});

parcelRegister("g4qUw", function(module, exports) {

var $alnGD = parcelRequire("alnGD");

var $5uXOq = parcelRequire("5uXOq");

var $ic428 = parcelRequire("ic428");

var $fB7Vm = parcelRequire("fB7Vm");
function $bb31e4eee5e1ad6a$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = (0, $ic428.useAsObservableSourceInternal)(current, true);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(function() {
        var local = (0, $alnGD.observable)(initializer(source));
        if ((0, $fB7Vm.isPlainObject)(local)) (0, $alnGD.runInAction)(function() {
            Object.keys(local).forEach(function(key) {
                var value = local[key];
                if (typeof value === "function") // @ts-ignore No idea why ts2536 is popping out here
                local[key] = $bb31e4eee5e1ad6a$var$wrapInTransaction(value, local);
            });
        });
        return local;
    })[0];
}
// tslint:disable-next-line: ban-types
function $bb31e4eee5e1ad6a$var$wrapInTransaction(fn, context) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (0, $alnGD.transaction)(function() {
            return fn.apply(context, args);
        });
    };
}

});


parcelRegister("c8cwY", function(module, exports) {

$parcel$export(module.exports, "getDefaultFormId", () => $8d4ff3c10dca0cb8$export$fdbb2f786b67f236);

var $4aJmI = parcelRequire("4aJmI");

var $jAFGQ = parcelRequire("jAFGQ");
const $8d4ff3c10dca0cb8$export$fdbb2f786b67f236 = (formIndex, projectId)=>{
    var _formIndexItem;
    // if there is a cookie with a templateFormId, then expand the first form on the issue which has a matching
    // templateFormId. If there is no matching form, then don’t expand any form in the issue view
    let formIndexItem;
    const lastViewedTemplateForm = projectId && (0, $jAFGQ.getLastViewedForm)(projectId);
    // if there's a previous template form ID saved in a cookie
    if (lastViewedTemplateForm) // find the first matching form with that templateFormId
    formIndexItem = formIndex.find((issueIndexForm)=>issueIndexForm.projectFormId === lastViewedTemplateForm.templateFormId);
    else // If there is no cookie, show the first open form on the issue.
    formIndexItem = formIndex.find((item)=>item.status === (0, $4aJmI.FormStatus).Open);
    return (_formIndexItem = formIndexItem) === null || _formIndexItem === void 0 ? void 0 : _formIndexItem.id;
};

});
parcelRegister("jAFGQ", function(module, exports) {

$parcel$export(module.exports, "getLastViewedForm", () => $e431b7df5ab30da8$export$6435fa8c8b3ab8ef);

var $cyHbi = parcelRequire("cyHbi");
const $e431b7df5ab30da8$var$LAST_VIEWED_FORM_COOKIE_NAME_PREFIX = 'lastViewedForm-';
const $e431b7df5ab30da8$export$6435fa8c8b3ab8ef = (projectId)=>{
    try {
        const lastViewedForm = (0, $cyHbi.getCookie)(`${$e431b7df5ab30da8$var$LAST_VIEWED_FORM_COOKIE_NAME_PREFIX}${projectId}`);
        if (lastViewedForm) return JSON.parse(lastViewedForm);
        return undefined;
    } catch (err) {
        return undefined;
    }
};

});


parcelRegister("6vE26", function(module, exports) {

$parcel$export(module.exports, "useSelectFormNoDiscardChangeNotice", () => $d8dfc8fd7bd68056$export$7f9976dd484745d7);
$parcel$export(module.exports, "useHandleSelectForm", () => $d8dfc8fd7bd68056$export$4b3cbb4a04635b29);
$parcel$export(module.exports, "useHandleFormSelected", () => $d8dfc8fd7bd68056$export$6f383aa56a3d19f2);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $aNTEp = parcelRequire("aNTEp");

var $ousew = parcelRequire("ousew");

var $bEQ2i = parcelRequire("bEQ2i");

var $N5QrD = parcelRequire("N5QrD");
var $3LDyf = parcelRequire("3LDyf");

var $erWXD = parcelRequire("erWXD");

var $6U2FW = parcelRequire("6U2FW");

var $4R6GH = parcelRequire("4R6GH");

var $lgVkI = parcelRequire("lgVkI");
const $d8dfc8fd7bd68056$var$getAnalyticsAttributes = (formId)=>({
        formId: formId,
        action: formId ? 'select' : 'unselect'
    });
const $d8dfc8fd7bd68056$export$7f9976dd484745d7 = (loadFormStore, disableIssueViewFullPageDropzoneCallback)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { setSelectedFormId: setSelectedFormId, setSelectedFormStoreState: setSelectedFormStoreState, reportError: reportError } = (0, $N5QrD.useFormIndexActions)();
    const { clear: clearFormSaveErrors } = (0, $bEQ2i.useFormSaveErrorsActions)();
    return (0, $5uXOq.useCallback)(async (formId, preloadFormStore, hasAccess = true)=>{
        try {
            setSelectedFormId(formId);
            disableIssueViewFullPageDropzoneCallback(false);
            clearFormSaveErrors();
            if (!formId) {
                // 1. Unselect all form
                setSelectedFormStoreState({
                    loading: false,
                    data: undefined,
                    error: undefined
                });
                (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).SELECTED}`, $d8dfc8fd7bd68056$var$getAnalyticsAttributes(formId));
                return;
            }
            if (!hasAccess && (0, $4R6GH.fg)('granular_permissions_on_forms_ga')) {
                // 2. When user has no form access, clear selected form store, UI would show warning message
                setSelectedFormStoreState({
                    loading: false,
                    data: undefined,
                    error: undefined
                });
                (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).SELECTED}`, $d8dfc8fd7bd68056$var$getAnalyticsAttributes(formId));
                return;
            }
            if (!preloadFormStore) {
                // 3. Select and load form
                setSelectedFormStoreState({
                    loading: true,
                    data: undefined,
                    error: undefined
                });
                const formStore = await loadFormStore(formId);
                setSelectedFormStoreState({
                    loading: false,
                    data: formStore,
                    error: undefined
                });
            } else // 4. Select and use preloaded formStore form
            setSelectedFormStoreState({
                loading: false,
                data: preloadFormStore,
                error: undefined
            });
            (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).SELECTED}`, $d8dfc8fd7bd68056$var$getAnalyticsAttributes(formId));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            reportError(error, {
                id: 'selectForm',
                attributes: $d8dfc8fd7bd68056$var$getAnalyticsAttributes(formId)
            });
            setSelectedFormStoreState({
                loading: false,
                data: undefined,
                error: error
            });
        }
    }, [
        setSelectedFormId,
        disableIssueViewFullPageDropzoneCallback,
        clearFormSaveErrors,
        createAnalyticsEvent,
        setSelectedFormStoreState,
        loadFormStore,
        reportError
    ]);
};
const $d8dfc8fd7bd68056$export$4b3cbb4a04635b29 = (loadFormStore, disableIssueViewFullPageDropzoneCallback)=>{
    const selectFormNoDiscardChangeNotice = $d8dfc8fd7bd68056$export$7f9976dd484745d7(loadFormStore, disableIssueViewFullPageDropzoneCallback);
    const withDiscardChangeNotice = (0, $3LDyf.useWithDiscardChangeNotice)();
    const handleSelectOld = (0, $5uXOq.useCallback)((formId)=>withDiscardChangeNotice(()=>selectFormNoDiscardChangeNotice(formId)), [
        selectFormNoDiscardChangeNotice,
        withDiscardChangeNotice
    ]);
    const handleSelect = (0, $5uXOq.useCallback)((formToSelect)=>withDiscardChangeNotice(()=>selectFormNoDiscardChangeNotice(formToSelect?.formId, undefined, formToSelect?.hasAccess)), [
        selectFormNoDiscardChangeNotice,
        withDiscardChangeNotice
    ]);
    return {
        handleSelect: handleSelect,
        handleSelectOld: handleSelectOld
    };
};
const $d8dfc8fd7bd68056$export$6f383aa56a3d19f2 = (issueViewStore, disableIssueViewFullPageDropzoneCallback)=>{
    const { setSelectedFormId: setSelectedFormId, setSelectedFormStoreState: setSelectedFormStoreState } = (0, $N5QrD.useFormIndexActions)();
    const { selectedFormStore: selectedFormStore } = (0, $N5QrD.useSelectedFormStoreState)();
    const { clear: clearFormSaveErrors } = (0, $bEQ2i.useFormSaveErrorsActions)();
    const { showNotice: showNotice } = (0, $6U2FW.useShowNotice)();
    const handleFormSelected = (0, $5uXOq.useCallback)(async (formId, loadForm = true)=>{
        try {
            setSelectedFormId(formId);
            disableIssueViewFullPageDropzoneCallback(false);
            if (!formId) {
                setSelectedFormStoreState({
                    loading: false,
                    data: undefined,
                    error: undefined
                });
                return;
            }
            if (loadForm) {
                setSelectedFormStoreState({
                    loading: true,
                    data: undefined,
                    error: undefined
                });
                const formStore = await issueViewStore.loadFormStore(formId);
                setSelectedFormStoreState({
                    loading: false,
                    data: formStore,
                    error: undefined
                });
                clearFormSaveErrors();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setSelectedFormStoreState({
                loading: false,
                data: undefined,
                error: error
            });
        }
    }, [
        setSelectedFormId,
        issueViewStore,
        disableIssueViewFullPageDropzoneCallback,
        setSelectedFormStoreState,
        clearFormSaveErrors
    ]);
    return (0, $5uXOq.useCallback)((formId, loadForm = true)=>{
        if (selectedFormStore?.answersModified) showNotice({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $lgVkI.messages).confirmDiscardChangesNoticeTitle),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $lgVkI.messages).confirmDiscardChangesNoticeBody,
                values: {
                    formName: selectedFormStore?.formName || 'Unknown form'
                }
            }),
            closeText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $lgVkI.messages).noticeCloseLabel),
            confirmText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $lgVkI.messages).noticeConfirmLabel),
            onConfirmHandler: ()=>{
                handleFormSelected(formId, loadForm);
            }
        });
        else handleFormSelected(formId, loadForm);
    }, [
        handleFormSelected,
        selectedFormStore?.answersModified,
        selectedFormStore?.formName,
        showNotice
    ]);
};

});
parcelRegister("3LDyf", function(module, exports) {

$parcel$export(module.exports, "useWithDiscardChangeNotice", () => $2be470fc3f1777a1$export$16db98c47e4c1f02);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $6U2FW = parcelRequire("6U2FW");

var $N5QrD = parcelRequire("N5QrD");

var $7OMVY = parcelRequire("7OMVY");

var $9BXdR = parcelRequire("9BXdR");
const $2be470fc3f1777a1$export$16db98c47e4c1f02 = ()=>{
    const { selectedFormStore: selectedFormStore } = (0, $N5QrD.useSelectedFormStoreState)();
    const { showNotice: showNotice } = (0, $6U2FW.useShowNotice)();
    return (0, $5uXOq.useCallback)((defaultHandler, confirmDiscardHandler, closeDiscardHandler)=>{
        (0, $9BXdR.clearAllFocus)();
        if (selectedFormStore !== null && selectedFormStore !== void 0 && selectedFormStore.answersModified) showNotice({
            appearance: 'warning',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7OMVY.messages).confirmCancelEditNoticeTitle),
            body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7OMVY.messages).confirmCancelEditNoticeBody),
            closeText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7OMVY.messages).confirmCancelEditNoticeCloseButton),
            confirmText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7OMVY.messages).confirmCancelEditNoticeConfirmButton),
            onConfirmHandler: confirmDiscardHandler || defaultHandler,
            onCloseHandler: closeDiscardHandler
        });
        else defaultHandler();
    }, [
        selectedFormStore,
        showNotice
    ]);
};

});
parcelRegister("7OMVY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5b13293254c23305$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5b13293254c23305$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    confirmCancelEditNoticeTitle: {
        id: 'proforma-form-system.controllers.form-index.confirm-cancel-edit-notice-title',
        defaultMessage: "Changes haven\u2019t been saved",
        description: 'Title for the notice dialog to confirm whether the user wants to discard their form changes'
    },
    confirmCancelEditNoticeBody: {
        id: 'proforma-form-system.controllers.form-index.confirm-cancel-edit-notice-body',
        defaultMessage: "Any changes made won\u2019t be saved if you move away from this form.",
        description: 'Body for the notice dialog to confirm whether the user wants to discard their form changes'
    },
    confirmCancelEditNoticeCloseButton: {
        id: 'proforma-form-system.controllers.form-index.confirm-cancel-edit-notice-close-button',
        defaultMessage: 'Cancel',
        description: 'Close button text for the notice dialog to confirm whether the user wants to discard their form changes'
    },
    confirmCancelEditNoticeConfirmButton: {
        id: 'proforma-form-system.controllers.form-index.confirm-cancel-edit-notice-confirm-button',
        defaultMessage: 'Discard changes',
        description: 'Confirm button text for the notice dialog to confirm whether the user wants to discard their form changes'
    }
});

});

parcelRegister("9BXdR", function(module, exports) {

$parcel$export(module.exports, "clearAllFocus", () => $6ff5822561d5ba1d$export$f44a717c401a878a);
const $6ff5822561d5ba1d$export$f44a717c401a878a = ()=>{
    if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
};

});


parcelRegister("lgVkI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fca4cfa6d5dc57e1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $fca4cfa6d5dc57e1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    confirmDiscardChangesNoticeBody: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-form-selected.confirm-discard-changes-notice-body",
        "defaultMessage": "There are changes to answers on the \u201C{formName}\u201D form that will be lost if you choose \"Confirm\". Are you sure you want to continue?"
    },
    confirmDiscardChangesNoticeTitle: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-form-selected.confirm-discard-changes-notice-title",
        "defaultMessage": "Confirm Discarding Changes"
    },
    noticeCloseLabel: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-form-selected.notice-close-label",
        "defaultMessage": "Close"
    },
    noticeConfirmLabel: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-form-selected.notice-confirm-label",
        "defaultMessage": "Confirm"
    }
});

});


parcelRegister("4P4jr", function(module, exports) {

$parcel$export(module.exports, "JiraAddForm", () => $29c57b3fd85de8e2$export$e8ae1176446aec9a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ex6Rw = parcelRequire("ex6Rw");

var $av6gl = parcelRequire("av6gl");
var $2sdeO = parcelRequire("2sdeO");

var $atZPK = parcelRequire("atZPK");

var $6vE26 = parcelRequire("6vE26");

var $cjBra = parcelRequire("cjBra");
const $29c57b3fd85de8e2$export$e8ae1176446aec9a = ({ addFormButtonClickedCount: addFormButtonClickedCount, issueViewStore: issueViewStore, disableIssueViewFullPageDropzoneCallback: disableIssueViewFullPageDropzoneCallback, issueId: issueId })=>{
    const addFormCallback = (0, $atZPK.useAddForm)(issueViewStore, disableIssueViewFullPageDropzoneCallback);
    const handleFormSelected = (0, $6vE26.useHandleFormSelected)(issueViewStore, disableIssueViewFullPageDropzoneCallback);
    const { fetchAvailableForms: fetchAvailableForms } = (0, $cjBra.useGetAvailableFormsService)(issueId);
    const errorUtils = (0, $ex6Rw.usePfErrorUtils)();
    const [showAddFormPanel, setShowAddFormPanel] = (0, $5uXOq.useState)(false);
    const buttonClickCountRef = (0, $5uXOq.useRef)(0);
    (0, $5uXOq.useEffect)(()=>{
        // handleFormSelected can get refreshed when the selectedFormStore state changes, so we want to exclude this
        // from triggering itself. Only call handleFormSelected when addFormButtonClickedCount updates
        if (addFormButtonClickedCount > buttonClickCountRef.current) {
            buttonClickCountRef.current = addFormButtonClickedCount;
            handleFormSelected();
            setShowAddFormPanel(true);
        }
    }, [
        addFormButtonClickedCount,
        handleFormSelected,
        setShowAddFormPanel
    ]);
    const handleAddForm = (0, $5uXOq.useCallback)((formToAdd)=>{
        setShowAddFormPanel(false);
        addFormCallback(formToAdd);
    }, [
        addFormCallback,
        setShowAddFormPanel
    ]);
    const handleCancelAddForm = (0, $5uXOq.useCallback)(()=>{
        setShowAddFormPanel(false);
    }, [
        setShowAddFormPanel
    ]);
    const addFormApi = (0, $5uXOq.useMemo)(()=>({
            loadForms: fetchAvailableForms
        }), [
        fetchAvailableForms
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showAddFormPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29c57b3fd85de8e2$var$AddFormContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2sdeO.AddFormStoreContainer), {
        api: addFormApi,
        errorUtils: errorUtils
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $av6gl.AddForm), {
        onAdd: handleAddForm,
        onCancel: handleCancelAddForm
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/use-primitives -- To migrate as part of go/ui-styling-standard
const $29c57b3fd85de8e2$var$AddFormContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("av6gl", function(module, exports) {

$parcel$export(module.exports, "AddForm", () => $7a51a842404d7d1a$export$11223b1abaada9c7);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");


var $jHTSg = parcelRequire("jHTSg");
var $cNW3X = parcelRequire("cNW3X");


var $lau8t = parcelRequire("lau8t");

var $bv2Tr = parcelRequire("bv2Tr");

var $i9OHB = parcelRequire("i9OHB");

var $hTsMS = parcelRequire("hTsMS");

var $hnuQa = parcelRequire("hnuQa");

var $2sdeO = parcelRequire("2sdeO");

var $hAFzt = parcelRequire("hAFzt");

var $7J3wD = parcelRequire("7J3wD");

var $gATks = parcelRequire("gATks");
const $7a51a842404d7d1a$var$IconOption = ({ option: option, restrictionStatus: restrictionStatus })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gATks.IconSelect), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnuQa.FormCardIcon), {
        restrictionStatus: restrictionStatus,
        isSelecting: true
    }), option);
const $7a51a842404d7d1a$var$AddFormBase = ({ onAdd: onAdd, onCancel: onCancel })=>{
    const intl = (0, $koVbs.default)();
    const { forms: forms, isLoading: isLoading, error: error } = (0, $2sdeO.useAddFormState)();
    const [selectedForm, setSelectedForm] = (0, $5uXOq.useState)(undefined);
    const handleOnAdd = ()=>{
        if (selectedForm) onAdd(selectedForm);
    };
    const buildSelectOptions = (availableForms)=>{
        if (availableForms.recommended.length > 0 && availableForms.available.length > 0) return [
            {
                label: intl.formatMessage((0, $7J3wD.messages).addFormSelectGroupRecommended),
                options: availableForms.recommended
            },
            {
                label: intl.formatMessage((0, $7J3wD.messages).addFormSelectGroupOther),
                options: availableForms.available
            }
        ];
        // flatten object values to 1D-Array
        return Object.values(availableForms).flat();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hAFzt.ErrorState), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gATks.IssueFormSelectorStyles), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), {
        id: "AddFormSelector",
        instanceId: "proforma-form-system.add-form.ui.issue-form-selector.add-form-select",
        tabSelectsValue: true,
        isLoading: isLoading,
        options: forms ? buildSelectOptions(forms) : [],
        defaultMenuIsOpen: true,
        label: intl.formatMessage((0, $7J3wD.messages).addFormSelectInputPlaceholder),
        placeholder: intl.formatMessage((0, $7J3wD.messages).addFormSelectInputPlaceholder),
        autoFocus: true,
        onChange: (_selectedForm)=>{
            if (_selectedForm && 'value' in _selectedForm) setSelectedForm(_selectedForm);
        },
        formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a51a842404d7d1a$var$IconOption, {
                option: option.label || intl.formatMessage((0, $7J3wD.messages).emptyFormName),
                restrictionStatus: option.restrictionStatus
            }),
        labelId: "react-select-proforma-form-system.add-form.ui.issue-form-selector.add-form-select-placeholder"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gATks.ButtonRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHTSg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "primary",
        onClick: handleOnAdd,
        isDisabled: selectedForm === undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7J3wD.messages).addFormButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        onClick: ()=>{
            setSelectedForm(undefined);
            onCancel();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7J3wD.messages).cancelButton))))));
};
const $7a51a842404d7d1a$export$11223b1abaada9c7 = (props)=>{
    const { locale: locale } = (0, $koVbs.default)();
    const errorUtils = (0, $2sdeO.useAddFormErrorUtils)();
    if (!errorUtils) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9OHB.ProformaIntlProvider), {
        messages: (0, $hTsMS.default),
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bv2Tr.ErrorBoundary), {
        errorUtils: errorUtils,
        renderError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hAFzt.ErrorState), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a51a842404d7d1a$var$AddFormBase, props)));
};

});
parcelRegister("hTsMS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d06de74d149dd62e$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index in @atlassian/proforma-utils.
 */ 
























const $d06de74d149dd62e$var$lazyMessages = {
    cs: ()=>(parcelRequire("a0euB")),
    da: ()=>(parcelRequire("bvC3V")),
    de: ()=>(parcelRequire("fMnWv")),
    en: ()=>(parcelRequire("fiK4i")),
    en_GB: ()=>(parcelRequire("cScDM")),
    en_ZZ: ()=>(parcelRequire("7M3Pi")),
    es: ()=>(parcelRequire("g2uyY")),
    fi: ()=>(parcelRequire("cxakX")),
    fr: ()=>(parcelRequire("fLSq6")),
    hu: ()=>(parcelRequire("6kBGL")),
    it: ()=>(parcelRequire("lDcKQ")),
    ja: ()=>(parcelRequire("fqw2Z")),
    ko: ()=>(parcelRequire("jPARt")),
    nb: ()=>(parcelRequire("1MJVM")),
    nl: ()=>(parcelRequire("6ET94")),
    pl: ()=>(parcelRequire("8gvoL")),
    pt_BR: ()=>(parcelRequire("jasi2")),
    ru: ()=>(parcelRequire("gOrWq")),
    sv: ()=>(parcelRequire("cRWHc")),
    th: ()=>(parcelRequire("0lGVp")),
    tr: ()=>(parcelRequire("dt2DP")),
    uk: ()=>(parcelRequire("jL11Y")),
    vi: ()=>(parcelRequire("6tG1e")),
    zh: ()=>(parcelRequire("aoQaJ")),
    zh_TW: ()=>(parcelRequire("fDiqB"))
};
var $d06de74d149dd62e$export$2e2bcd8739ae039 = $d06de74d149dd62e$var$lazyMessages;

});
parcelRegister("a0euB", function(module, exports) {

let $748525653077b5a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $748525653077b5a7$var$load("8HX2i").then(()=>parcelRequire('2axnI'));

});

parcelRegister("bvC3V", function(module, exports) {

let $86101d5530bd19c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $86101d5530bd19c0$var$load("b0nLq").then(()=>parcelRequire('e4hHg'));

});

parcelRegister("fMnWv", function(module, exports) {

let $b7cde93af6898da6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7cde93af6898da6$var$load("aXE5n").then(()=>parcelRequire('g2HH7'));

});

parcelRegister("fiK4i", function(module, exports) {

let $b23c45a5599a84ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b23c45a5599a84ad$var$load("lTxlH").then(()=>parcelRequire('fglIY'));

});

parcelRegister("cScDM", function(module, exports) {

let $95f4555ab185a506$var$load = (parcelRequire("28QjX"))(4);
module.exports = $95f4555ab185a506$var$load("kON2y").then(()=>parcelRequire('7aNOL'));

});

parcelRegister("7M3Pi", function(module, exports) {

let $5a8ffbf36772102d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a8ffbf36772102d$var$load("eYvdg").then(()=>parcelRequire('i2TKh'));

});

parcelRegister("g2uyY", function(module, exports) {

let $bad48a69d1fd3172$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bad48a69d1fd3172$var$load("1gXu0").then(()=>parcelRequire('bZAbe'));

});

parcelRegister("cxakX", function(module, exports) {

let $920095d05bb95f4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $920095d05bb95f4e$var$load("dLNBF").then(()=>parcelRequire('igpDq'));

});

parcelRegister("fLSq6", function(module, exports) {

let $b7b575752aef6734$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7b575752aef6734$var$load("8oIvg").then(()=>parcelRequire('7bVRR'));

});

parcelRegister("6kBGL", function(module, exports) {

let $49c1d88791eb94ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49c1d88791eb94ce$var$load("kRxHs").then(()=>parcelRequire('fWdTq'));

});

parcelRegister("lDcKQ", function(module, exports) {

let $fbf7224b4437f0cf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fbf7224b4437f0cf$var$load("crpYp").then(()=>parcelRequire('frg6f'));

});

parcelRegister("fqw2Z", function(module, exports) {

let $b3b2249d210e907e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b3b2249d210e907e$var$load("bLKJd").then(()=>parcelRequire('JNri8'));

});

parcelRegister("jPARt", function(module, exports) {

let $e6ff5fac5f5ab983$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e6ff5fac5f5ab983$var$load("d47JO").then(()=>parcelRequire('6IPMP'));

});

parcelRegister("1MJVM", function(module, exports) {

let $14cde70c3f0cc42b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $14cde70c3f0cc42b$var$load("ftcUi").then(()=>parcelRequire('3HkCf'));

});

parcelRegister("6ET94", function(module, exports) {

let $4d914138aa6a8967$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d914138aa6a8967$var$load("5rLps").then(()=>parcelRequire('aWYNk'));

});

parcelRegister("8gvoL", function(module, exports) {

let $60482c6bb8f70cbd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60482c6bb8f70cbd$var$load("irfYs").then(()=>parcelRequire('3j2V3'));

});

parcelRegister("jasi2", function(module, exports) {

let $df44e549829e67a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $df44e549829e67a5$var$load("8hynA").then(()=>parcelRequire('8g2ln'));

});

parcelRegister("gOrWq", function(module, exports) {

let $c3d6fd6845f7f318$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3d6fd6845f7f318$var$load("56mbx").then(()=>parcelRequire('f9i5O'));

});

parcelRegister("cRWHc", function(module, exports) {

let $95e7f709589f9ad2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $95e7f709589f9ad2$var$load("1XRxm").then(()=>parcelRequire('ap02o'));

});

parcelRegister("0lGVp", function(module, exports) {

let $0010d3a66c8eb629$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0010d3a66c8eb629$var$load("YYSnT").then(()=>parcelRequire('lGvmY'));

});

parcelRegister("dt2DP", function(module, exports) {

let $9ce008550303bc4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ce008550303bc4c$var$load("ltbZw").then(()=>parcelRequire('3Rtcm'));

});

parcelRegister("jL11Y", function(module, exports) {

let $e62334d4e7e45d7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e62334d4e7e45d7a$var$load("kW8g5").then(()=>parcelRequire('heWlD'));

});

parcelRegister("6tG1e", function(module, exports) {

let $4b760b8ec39a39ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b760b8ec39a39ef$var$load("4cz5e").then(()=>parcelRequire('30zIL'));

});

parcelRegister("aoQaJ", function(module, exports) {

let $79249d8d2ac0502b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $79249d8d2ac0502b$var$load("7ehvN").then(()=>parcelRequire('iz96j'));

});

parcelRegister("fDiqB", function(module, exports) {

let $b618caf1c43aa11f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b618caf1c43aa11f$var$load("iEjIe").then(()=>parcelRequire('g1O7M'));

});


parcelRegister("hnuQa", function(module, exports) {

$parcel$export(module.exports, "FormCardIcon", () => $ca6c81ee2b600ce5$export$ee70f67f15460e27);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");


var $ddl7e = parcelRequire("ddl7e");

var $dU448 = parcelRequire("dU448");

var $7fWGY = parcelRequire("7fWGY");

var $fHpHg = parcelRequire("fHpHg");


var $5KCCi = parcelRequire("5KCCi");

var $aNTEp = parcelRequire("aNTEp");

var $5wvQR = parcelRequire("5wvQR");

var $erWXD = parcelRequire("erWXD");

var $k3kYV = parcelRequire("k3kYV");
const $ca6c81ee2b600ce5$export$ee70f67f15460e27 = ({ restrictionStatus: restrictionStatus, isSelecting: isSelecting })=>{
    const getFormLockedIcon = ()=>{
        const lockedIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dU448))), {
            color: isSelecting ? `var(--ds-icon-accent-red, ${0, $a7f8c6b391092279$export$2010d0fb4295b346})` : `var(--ds-icon, ${0, $a7f8c6b391092279$export$7d61b15e0da132af})`,
            spacing: "none",
            label: ""
        });
        return !isSelecting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $k3kYV.messages).restrictedFormIconTooltip),
            onShow: (analyticsEvent)=>{
                (0, $aNTEp.fireUIAnalytics)(analyticsEvent, (0, $erWXD.ActionSubject).FORM_PERMISSIONS);
            }
        }, lockedIcon) : lockedIcon;
    };
    return restrictionStatus === (0, $5wvQR.FormRestrictionStatus).RESTRICTED && (0, $fHpHg.fg)('granular_permissions_on_forms_m1') ? getFormLockedIcon() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ddl7e))), {
        LEGACY_fallbackIcon: (0, $7fWGY.default),
        color: "currentColor",
        label: ""
    });
};

});
parcelRegister("7fWGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d257f3eabce71ec$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $4d257f3eabce71ec$var$FormCardIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "18",
        viewBox: "0 0 14 18",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "currentColor",
                d: "M1.994 2v14h10V2h-10ZM0 1.791C0 .8028.897 0 2.006 0h9.988C13.102 0 14 .8082 14 1.791v14.418c0 .9891-.897 1.791-2.006 1.791H2.006c-.5295.0007-1.03778-.1873-1.41369-.5229C.21639 17.1415.00344 16.6855 0 16.209V1.791Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "currentColor",
                d: "M6.9013 11.1153h2.8718c.5287 0 .9572-.3997.9572-.8929 0-.4931-.4285-.8928-.9572-.8928H6.9013c-.5287 0-.9573.3997-.9573.8928 0 .4932.4286.8929.9573.8929ZM6.9013 8.2231h2.8718c.5287 0 .9572-.3997.9572-.8928 0-.49314-.4285-.89288-.9572-.89288H6.9013c-.5287 0-.9573.39974-.9573.89288 0 .4931.4286.8928.9573.8928ZM6.9013 5.40103h2.8718c.5287 0 .9572-.39975.9572-.89286s-.4285-.89286-.9572-.89286L6.9013 3.6153c-.5287 0-.9573.39976-.9573.89287 0 .49311.4286.89286.9573.89286ZM3.1488 5.32959h1.83796c0-.82142-.00001-1.22117 0-1.71429H3.1488v1.71429ZM3.22598 8.1517H5.0639V6.43742H3.22598V8.1517ZM3.22598 11.0439H5.0639V9.3296H3.22598v1.7143ZM4.18324 14H9.812c.5286 0 .9572-.3997.9572-.8929 0-.4931-.4286-.8928-.9572-.8928H4.18324c-.52868 0-.95726.3997-.95726.8928 0 .4932.42858.8929.95726.8929Z"
            })
        ]
    });
/**
 * __FormCardIcon__
 */ const $4d257f3eabce71ec$var$FormCardIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $4d257f3eabce71ec$var$FormCardIconGlyph
    });
var $4d257f3eabce71ec$export$2e2bcd8739ae039 = $4d257f3eabce71ec$var$FormCardIcon;

});

parcelRegister("5wvQR", function(module, exports) {

$parcel$export(module.exports, "FormRestrictionStatus", () => $4058a5fc30fc445c$export$a22d71169ecf2be0);
$parcel$export(module.exports, "FormSupportedPrincipalType", () => $4058a5fc30fc445c$export$4bfccb8a14f3a257);
const $4058a5fc30fc445c$export$a22d71169ecf2be0 = {
    OPEN: 'open',
    RESTRICTED: 'restricted'
};
const $4058a5fc30fc445c$export$4bfccb8a14f3a257 = {
    USER: 'USER',
    USER_GROUP: 'USER_GROUP'
}; // TODO(amartinez): response API to be confirmed as a part of REQIN-1453.

});

parcelRegister("k3kYV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e9945cf8e4526c89$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e9945cf8e4526c89$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    restrictedFormIconTooltip: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header-new.form-card-icon.restricted-form-icon-tooltip',
        defaultMessage: 'Only specific people can view this form',
        description: 'Tooltip for the restricted form icon used in the form card header.'
    }
});

});


parcelRegister("2sdeO", function(module, exports) {

$parcel$export(module.exports, "useAddFormState", () => $1c9877100143736e$export$7fef181a170f4ae6);
$parcel$export(module.exports, "useAddFormErrorUtils", () => $1c9877100143736e$export$4b850b7ba9a639fb);
$parcel$export(module.exports, "AddFormStoreContainer", () => $1c9877100143736e$export$1e510900fbeff2e9);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $8pSia = parcelRequire("8pSia");

var $bNNwg = parcelRequire("bNNwg");
const $1c9877100143736e$var$AddFormStore = (0, $iXqE5.createStore)({
    initialState: {
        isLoading: false,
        forms: null,
        error: null
    },
    actions: $8pSia.actions,
    name: 'proforma-form-index-store'
});
const $1c9877100143736e$export$7fef181a170f4ae6 = (0, $3sQ5x.createStateHook)($1c9877100143736e$var$AddFormStore, {
    selector: (state)=>({
            isLoading: state.isLoading,
            forms: state.forms,
            error: state.error
        })
});
const $1c9877100143736e$export$880450b7fc383fe6 = (0, $3sQ5x.createActionsHook)($1c9877100143736e$var$AddFormStore);
const $1c9877100143736e$export$4b850b7ba9a639fb = (0, $3sQ5x.createStateHook)($1c9877100143736e$var$AddFormStore, {
    selector: (state)=>state.errorUtils
});
const $1c9877100143736e$export$1e510900fbeff2e9 = (0, $gg7kZ.createContainer)($1c9877100143736e$var$AddFormStore, {
    onInit: ()=>({ dispatch: dispatch, setState: setState }, { errorUtils: errorUtils })=>{
            setState({
                errorUtils: errorUtils
            });
            dispatch((0, $bNNwg.loadForms)());
        }
});

});
parcelRegister("8pSia", function(module, exports) {

$parcel$export(module.exports, "actions", () => $620ac5cc707c7823$export$e324594224ef24da);

var $bNNwg = parcelRequire("bNNwg");
const $620ac5cc707c7823$export$e324594224ef24da = {
    loadForms: $bNNwg.loadForms
};

});
parcelRegister("bNNwg", function(module, exports) {

$parcel$export(module.exports, "loadForms", () => $897aaed7a28a267e$export$ff4d94dd8c4ee66);
const $897aaed7a28a267e$export$ff4d94dd8c4ee66 = ()=>async ({ setState: setState }, { api: api, errorUtils: errorUtils })=>{
        setState({
            isLoading: true
        });
        try {
            const forms = await api.loadForms();
            setState({
                forms: forms,
                isLoading: false
            });
        } catch (error) {
            errorUtils.reportError(error, {
                id: 'loadForms'
            });
            setState({
                error: error,
                isLoading: false
            });
            throw error;
        }
    };

});



parcelRegister("hAFzt", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $cce60ba545dfe517$export$c1ed4f415b9e7023);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $9FSw2 = parcelRequire("9FSw2");

var $7yg3D = parcelRequire("7yg3D");
const $cce60ba545dfe517$export$c1ed4f415b9e7023 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7yg3D.messages).errorMessage));

});
parcelRegister("7yg3D", function(module, exports) {

$parcel$export(module.exports, "messages", () => $57f82a1cf3a7e657$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $57f82a1cf3a7e657$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorMessage: {
        id: 'proforma-form-system.add-form.ui.error-state.error-message',
        defaultMessage: "We\u2019re unable to load forms. Refresh this page and try again.",
        description: 'Text for the error state when there is an error in form preview.'
    }
});

});


parcelRegister("7J3wD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $59ff78766a3b0adc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $59ff78766a3b0adc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    emptyFormName: {
        id: 'proforma-form-system.add-form.ui.empty-form-name',
        defaultMessage: 'Untitled Form',
        description: 'A placeholder for a form with an empty name.'
    },
    addFormButton: {
        id: 'proforma-form-system.add-form.ui.add-form-button',
        defaultMessage: 'Add',
        description: 'Add form button text'
    },
    cancelButton: {
        id: 'proforma-form-system.add-form.ui.cancel-button',
        defaultMessage: 'Cancel',
        description: 'Form cancel button text'
    },
    addFormSelectInputPlaceholder: {
        id: 'proforma-form-system.add-form.ui.add-form-select-input-placeholder',
        defaultMessage: 'Select a form',
        description: 'Placeholder text for add form dropdown'
    },
    addFormSelectGroupRecommended: {
        id: 'proforma-form-system.add-form.ui.add-form-select-group-recommended',
        defaultMessage: 'Recommended',
        description: 'Option group text for recommended forms'
    },
    addFormSelectGroupOther: {
        id: 'proforma-form-system.add-form.ui.add-form-select-group-other',
        defaultMessage: 'Other Forms',
        description: 'Option group text for avaiable or other forms'
    }
});

});

parcelRegister("gATks", function(module, exports) {

$parcel$export(module.exports, "IssueFormSelectorStyles", () => $c14aed5547718d40$export$fbd06a3f6aaad3cd);
$parcel$export(module.exports, "ButtonRow", () => $c14aed5547718d40$export$564cbe3426fc093a);
$parcel$export(module.exports, "IconSelect", () => $c14aed5547718d40$export$249df474ea45aebc);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dAHxw = parcelRequire("dAHxw");
const $c14aed5547718d40$export$fbd06a3f6aaad3cd = (0, $dAHxw.default).div({
    marginBottom: "var(--ds-space-100, 8px)"
});
const $c14aed5547718d40$export$564cbe3426fc093a = (0, $dAHxw.default).div({
    textAlign: 'right',
    margin: `${"var(--ds-space-100, 8px)"} 1px`
});
const $c14aed5547718d40$export$249df474ea45aebc = (0, $dAHxw.default).div({
    display: 'flex',
    gap: "var(--ds-space-075, 6px)",
    alignItems: 'center'
});

});


parcelRegister("atZPK", function(module, exports) {

$parcel$export(module.exports, "useAddForm", () => $6cd22d1388e9dca4$export$31daa09fb4ebb6fd);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $aNTEp = parcelRequire("aNTEp");

var $hprFm = parcelRequire("hprFm");
var $N5QrD = parcelRequire("N5QrD");

var $erWXD = parcelRequire("erWXD");

var $6vE26 = parcelRequire("6vE26");
const $6cd22d1388e9dca4$export$31daa09fb4ebb6fd = (issueViewStore, disableIssueViewFullPageDropzoneCallback)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { setIsIndexLoading: setIsIndexLoading, loadIndex: loadIndex, setFormViewMode: setFormViewMode, reportError: reportError } = (0, $N5QrD.useFormIndexActions)();
    const selectFormNoDiscardChangeNotice = (0, $6vE26.useSelectFormNoDiscardChangeNotice)(issueViewStore.loadFormStore, disableIssueViewFullPageDropzoneCallback);
    return (0, $5uXOq.useCallback)(async (formToAdd)=>{
        const templateFormId = formToAdd.value;
        setIsIndexLoading(true);
        try {
            const form = await issueViewStore.callAddForm(templateFormId);
            await loadIndex();
            setIsIndexLoading(true);
            await selectFormNoDiscardChangeNotice(form.id, issueViewStore.createFormStore(form));
            setFormViewMode((0, $hprFm.FormViewMode).Edit);
            (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).CREATED}`, {
                formId: form.id,
                templateFormId: templateFormId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            reportError(error, {
                id: 'addForm',
                attributes: {
                    templateFormId: templateFormId
                }
            });
            return Promise.reject(error);
        } finally{
            setIsIndexLoading(false);
        }
    }, [
        setIsIndexLoading,
        issueViewStore,
        loadIndex,
        createAnalyticsEvent,
        selectFormNoDiscardChangeNotice,
        setFormViewMode,
        reportError
    ]);
};

});

parcelRegister("cjBra", function(module, exports) {

$parcel$export(module.exports, "useGetAvailableFormsService", () => $9e1796b3cfe89c9f$export$d26a095c1d4c5e0e);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $4Ihci = parcelRequire("4Ihci");
const $9e1796b3cfe89c9f$export$d26a095c1d4c5e0e = (issueId)=>{
    const [state, setState] = (0, $5uXOq.useState)({
        data: undefined,
        loading: false,
        error: undefined
    });
    const issueViewFormApi = (0, $4Ihci.useIssueViewFormApi)();
    const oldRequest = (0, $5uXOq.useCallback)(()=>// issueViewFormApi.get will be replaced with a 'fetch' utility hook in the future which replaces ApiUtil
        issueViewFormApi.get(`/api/1/issues/${issueId}/availableforms`), [
        issueId,
        issueViewFormApi
    ]);
    const request = (0, $5uXOq.useCallback)(()=>// issueViewFormApi.get will be replaced with a 'fetch' utility hook in the future which replaces ApiUtil
        issueViewFormApi.get(`/api/frontend/jira/issue/${issueId}/availableforms`).then((forms)=>({
                recommended: forms.recommended.map($9e1796b3cfe89c9f$var$toLegacyAvailableForm),
                available: forms.available.map($9e1796b3cfe89c9f$var$toLegacyAvailableForm)
            })), [
        issueId,
        issueViewFormApi
    ]);
    const fetchAvailableForms = (0, $5uXOq.useCallback)(async ()=>{
        try {
            setState({
                data: undefined,
                loading: true,
                error: undefined
            });
            const data = await ((0, $4R6GH.fg)('granular_permissions_on_forms_m1') ? request() : oldRequest());
            setState({
                data: data,
                loading: false,
                error: undefined
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                data: undefined,
                loading: false,
                error: error
            });
            return Promise.reject(error);
        }
    }, [
        request,
        oldRequest
    ]);
    return {
        ...state,
        fetchAvailableForms: fetchAvailableForms
    };
};
const $9e1796b3cfe89c9f$var$toLegacyAvailableForm = (form)=>{
    return {
        label: form.name,
        value: form.id,
        restrictionStatus: form.restrictionStatus
    };
};

});


parcelRegister("h6FXj", function(module, exports) {

$parcel$export(module.exports, "JiraFormCardIndex", () => $2502e9c38d135ef3$export$9ef2b3b4a139fc18);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $X8LwV = parcelRequire("X8LwV");
var $hprFm = parcelRequire("hprFm");
var $N5QrD = parcelRequire("N5QrD");

var $jEJ7g = parcelRequire("jEJ7g");

var $koeKL = parcelRequire("koeKL");

var $eiXdg = parcelRequire("eiXdg");
var $bedpg = parcelRequire("bedpg");

var $4R6GH = parcelRequire("4R6GH");

var $2d5Q3 = parcelRequire("2d5Q3");

var $1NVs4 = parcelRequire("1NVs4");

var $bPD3w = parcelRequire("bPD3w");

var $eM2bk = parcelRequire("eM2bk");

var $4xIAx = parcelRequire("4xIAx");

var $6vE26 = parcelRequire("6vE26");

var $gZVQw = parcelRequire("gZVQw");

var $aWqtm = parcelRequire("aWqtm");

var $1A1EL = parcelRequire("1A1EL");

var $PHy0I = parcelRequire("PHy0I");
const $2502e9c38d135ef3$export$9ef2b3b4a139fc18 = (0, $jJXgM.observer)(({ issueViewStore: issueViewStore, disableIssueViewFullPageDropzoneCallback: disableIssueViewFullPageDropzoneCallback, proformaUrl: proformaUrl, projectType: projectType })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formViewMode: formViewMode, permissions: permissions } = (0, $N5QrD.useFormIndexState)();
    const handleDeleteForm = (0, $eM2bk.useHandleDeleteForm)(issueViewStore.loadFormStore, disableIssueViewFullPageDropzoneCallback);
    const handleDownloadPdf = (0, $2d5Q3.useDownloadForm)(proformaUrl, issueViewStore.issueId, issueViewStore.issueKey, 'pdf');
    const handleDownloadXlsx = (0, $2d5Q3.useDownloadForm)(proformaUrl, issueViewStore.issueId, issueViewStore.issueKey, 'xlsx');
    const handleCancelEdit = (0, $1NVs4.useHandleCancelEditForm)();
    const handleReopenFormWithIndexItem = (0, $aWqtm.useHandleReopenFormWithIndexItem)(projectType);
    const handleCloseForm = (0, $bPD3w.useHandleCloseForm)(issueViewStore.loadFormStore, disableIssueViewFullPageDropzoneCallback, projectType);
    const handleEditForm = (0, $4xIAx.useHandleEditForm)(issueViewStore.loadFormStore, disableIssueViewFullPageDropzoneCallback);
    const { handleSelectOld: handleSelectOld, handleSelect: handleSelect } = (0, $6vE26.useHandleSelectForm)(issueViewStore.loadFormStore, disableIssueViewFullPageDropzoneCallback);
    const handleUpdateFormVisibility = (0, $gZVQw.useHandleUpdateFormVisibility)();
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(projectType);
    // This is a workaround that forces JiraFormCardIndex to re-render whenever isUploadingMedia is updated.
    // It relies on the observer MobX wrapper picking up isUploadingMedia changes.
    // We need this workaround until we re-write FormStore, QuestionStore and how the attachment uploading state is managed.
    const { selectedFormStore: selectedFormStore } = (0, $N5QrD.useSelectedFormStoreState)();
    selectedFormStore?.isUploadingMedia;
    (0, $5uXOq.useEffect)(()=>{
        disableIssueViewFullPageDropzoneCallback(formViewMode === (0, $hprFm.FormViewMode).Edit);
    }, [
        disableIssueViewFullPageDropzoneCallback,
        formViewMode
    ]);
    const renderMenuIssueView = (0, $5uXOq.useCallback)((form, formStore)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $PHy0I.JiraFormCardMenu), {
            form: form,
            formStore: formStore,
            permissions: permissions,
            onDeleteForm: handleDeleteForm,
            onDownloadFormPdf: handleDownloadPdf,
            onDownloadFormXlsx: handleDownloadXlsx,
            onUpdateFormVisibility: handleUpdateFormVisibility,
            onReopenForm: handleReopenFormWithIndexItem,
            onCloseForm: handleCloseForm,
            onEditForm: handleEditForm,
            projectType: projectType
        }), [
        permissions,
        handleDeleteForm,
        handleDownloadPdf,
        handleDownloadXlsx,
        handleUpdateFormVisibility,
        handleReopenFormWithIndexItem,
        handleCloseForm,
        handleEditForm,
        projectType
    ]);
    const formSecurityApi = new (0, $bedpg.LiveFormSecurityApi)(cloudId, issueViewStore.projectId);
    return (0, $4R6GH.fg)('granular_permissions_on_forms_ff_ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eiXdg.FormSecurityApiProvider), {
        formSecurityApi: formSecurityApi
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $X8LwV.FormCardIndex), {
        renderFormUfoExperience: (0, $1A1EL.issueViewAttachedFormExperience),
        onFormSelected: handleSelect,
        onFormSelectedOld: handleSelectOld,
        linkedFieldNames: selectedFormStore?.questions.reduce((fieldIdToName, question)=>{
            if (question.issueFieldData && question.formQuestion.jiraField) fieldIdToName.set(question.formQuestion.jiraField, question.issueFieldData.name);
            return fieldIdToName;
        }, new Map()),
        renderMenu: !isJCS ? renderMenuIssueView : undefined,
        onCancelEdit: handleCancelEdit,
        projectType: projectType
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $X8LwV.FormCardIndex), {
        renderFormUfoExperience: (0, $1A1EL.issueViewAttachedFormExperience),
        onFormSelected: handleSelect,
        onFormSelectedOld: handleSelectOld,
        linkedFieldNames: selectedFormStore?.questions.reduce((fieldIdToName, question)=>{
            if (question.issueFieldData && question.formQuestion.jiraField) fieldIdToName.set(question.formQuestion.jiraField, question.issueFieldData.name);
            return fieldIdToName;
        }, new Map()),
        renderMenu: !isJCS ? renderMenuIssueView : undefined,
        onCancelEdit: handleCancelEdit,
        projectType: projectType
    });
});

});
parcelRegister("X8LwV", function(module, exports) {

$parcel$export(module.exports, "FormCardIndex", () => $0b1c4f78873a802c$export$afc1892fadd2a96b);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");


var $7ndW8 = parcelRequire("7ndW8");

var $clxo5 = parcelRequire("clxo5");

var $8b5Ks = parcelRequire("8b5Ks");

var $erWXD = parcelRequire("erWXD");

var $i9OHB = parcelRequire("i9OHB");

var $6U2FW = parcelRequire("6U2FW");

var $N5QrD = parcelRequire("N5QrD");

var $hTsMS = parcelRequire("hTsMS");

var $5bt60 = parcelRequire("5bt60");

var $9EhjM = parcelRequire("9EhjM");
const $0b1c4f78873a802c$export$f66430f7a49f8145 = ({ renderFormUfoExperience: renderFormUfoExperience, onFormSelected: onFormSelected, onFormSelectedOld: onFormSelectedOld, linkedFieldNames: linkedFieldNames, renderMenu: renderMenu, onCancelEdit: onCancelEdit, projectType: projectType, hideLockedLozenge: hideLockedLozenge })=>{
    const { formIndex: forms, isIndexLoading: isIndexLoading, selectedFormId: selectedFormId } = (0, $N5QrD.useFormIndexState)();
    const { selectedFormStore: selectedFormStore } = (0, $N5QrD.useSelectedFormStoreState)();
    if (forms.length === 0 && isIndexLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9EhjM.FormCardsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9EhjM.EmptyFormsLoadingPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9EhjM.SpinnerBackdrop), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "large"
    })));
    if (forms.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9EhjM.FormCardsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9EhjM.FormCards), {
        isIndexLoading: isIndexLoading
    }, forms.map((form, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5bt60.FormCard), {
            key: form.id,
            form: form,
            formStore: form.id === selectedFormId ? selectedFormStore : undefined,
            ufoExperience: renderFormUfoExperience,
            onFormSelected: onFormSelected,
            onFormSelectedOld: onFormSelectedOld,
            linkedFieldNames: linkedFieldNames,
            renderMenu: renderMenu,
            onCancelEdit: onCancelEdit,
            projectType: projectType,
            hideLockedLozenge: hideLockedLozenge,
            isFirstForm: index === 0
        })), !isIndexLoading && renderFormUfoExperience.markFMP() || null, !isIndexLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8b5Ks.FireUIAnalytics), {
        actionSubject: (0, $erWXD.ActionSubject).LIST,
        action: (0, $erWXD.Action).VIEWED,
        actionSubjectId: "formsList",
        attributes: {
            formsCount: forms.length
        }
    })), isIndexLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9EhjM.SpinnerBackdrop), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "large"
    })));
};
const $0b1c4f78873a802c$export$afc1892fadd2a96b = (props)=>{
    const { locale: locale } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9OHB.ProformaIntlProvider), {
        messages: (0, $hTsMS.default),
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ndW8.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U2FW.NoticeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b1c4f78873a802c$export$f66430f7a49f8145, props))));
};

});
parcelRegister("5bt60", function(module, exports) {

$parcel$export(module.exports, "FormCard", () => $3c648ca8e7cbdabb$export$11154b700737b45e);

var $5uXOq = parcelRequire("5uXOq");


var $fHpHg = parcelRequire("fHpHg");

var $N5QrD = parcelRequire("N5QrD");

var $gHAEJ = parcelRequire("gHAEJ");

var $fwz4r = parcelRequire("fwz4r");

var $l6kTe = parcelRequire("l6kTe");
const $3c648ca8e7cbdabb$export$11154b700737b45e = ({ form: form, formStore: formStore, ufoExperience: ufoExperience, onFormSelected: onFormSelected, onFormSelectedOld: onFormSelectedOld, linkedFieldNames: linkedFieldNames, renderMenu: renderMenu, onCancelEdit: onCancelEdit, projectType: projectType, hideLockedLozenge: hideLockedLozenge, isFirstForm: isFirstForm })=>{
    const { selectedFormId: selectedFormId } = (0, $N5QrD.useFormIndexState)();
    const formIsSelected = selectedFormId === form.id;
    // Card header callbacks
    const toggleExpanded = (0, $5uXOq.useCallback)(()=>{
        if ((0, $fHpHg.fg)('granular_permissions_on_forms_ga')) onFormSelected(formIsSelected ? undefined : {
            formId: form.id,
            hasAccess: form.hasAccess
        });
        else onFormSelectedOld(formIsSelected ? undefined : form.id);
    }, [
        onFormSelected,
        onFormSelectedOld,
        formIsSelected,
        form.id,
        form === null || form === void 0 ? void 0 : form.hasAccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l6kTe.FormCardContainer), {
        "data-testid": `proforma-form-index-form-card-container-${form.id}`,
        isFormYellow: form.internal && projectType === 'service_desk',
        formIsSelected: formIsSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fwz4r.FormCardHeader), {
        form: form,
        formStore: formStore,
        toggleExpanded: toggleExpanded,
        renderMenu: renderMenu,
        onCancelEdit: onCancelEdit,
        projectType: projectType,
        hideLockedLozenge: hideLockedLozenge,
        isFirstForm: isFirstForm
    }), formIsSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l6kTe.FormBodyWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gHAEJ.FormCardBody), {
        form: form,
        ufoExperience: ufoExperience,
        linkedFieldNames: linkedFieldNames,
        onCancelEdit: onCancelEdit,
        projectType: projectType
    })));
};

});
parcelRegister("gHAEJ", function(module, exports) {

$parcel$export(module.exports, "FormCardBody", () => $c28d189dd753e117$export$af3f360def2a4864);

var $5uXOq = parcelRequire("5uXOq");


var $fHpHg = parcelRequire("fHpHg");

var $clxo5 = parcelRequire("clxo5");

var $aNTEp = parcelRequire("aNTEp");

var $8iale = parcelRequire("8iale");
var $4aJmI = parcelRequire("4aJmI");

var $hprFm = parcelRequire("hprFm");
var $N5QrD = parcelRequire("N5QrD");

var $3bQqD = parcelRequire("3bQqD");

var $5atqw = parcelRequire("5atqw");

var $3LDyf = parcelRequire("3LDyf");

var $eG2p4 = parcelRequire("eG2p4");

var $4corl = parcelRequire("4corl");

var $kcsGs = parcelRequire("kcsGs");

var $bcxlj = parcelRequire("bcxlj");

var $iuD4T = parcelRequire("iuD4T");
const $c28d189dd753e117$export$af3f360def2a4864 = ({ form: form, ufoExperience: ufoExperience, linkedFieldNames: linkedFieldNames, onCancelEdit: onCancelEdit, projectType: projectType })=>{
    // Hooks for retrieving state relevant to the selected form
    const { formViewMode: formViewMode } = (0, $N5QrD.useFormIndexState)();
    const { selectedFormStore: formStore, loading: loading, error: error } = (0, $N5QrD.useSelectedFormStoreState)();
    // Hooks providing functions for transitioning the form between states
    const { isSaving: isSaving, handleSaveForm: handleSaveForm } = (0, $3bQqD.useHandleSaveForm)();
    const { isSubmitting: isSubmitting, handleSubmitForm: handleSubmitForm } = (0, $5atqw.useHandleSubmitForm)(projectType);
    const withDiscardChangeNotice = (0, $3LDyf.useWithDiscardChangeNotice)();
    // Fire a submitForm UI analytics event, then submit the form.
    const handleClickSubmit = async (_e, analyticsEvent)=>{
        (0, $aNTEp.fireUIAnalytics)(analyticsEvent, 'submitForm', {
            ...(0, $eG2p4.getSimpleFormAnalytics)(formStore === null || formStore === void 0 ? void 0 : formStore.formId, formStore === null || formStore === void 0 ? void 0 : formStore.templateFormId, formStore === null || formStore === void 0 ? void 0 : formStore.status, formStore === null || formStore === void 0 ? void 0 : formStore.internal),
            formFields: {
                cc: formStore === null || formStore === void 0 ? void 0 : formStore.questions.some((question)=>question.formQuestion.type === (0, $4aJmI.FormQuestionType).ChoiceCascading)
            },
            hasCascadingFields: formStore === null || formStore === void 0 ? void 0 : formStore.questions.some((question)=>question.formQuestion.type === (0, $4aJmI.FormQuestionType).ChoiceCascading),
            translated: (formStore === null || formStore === void 0 ? void 0 : formStore.translatedLocale) && (formStore === null || formStore === void 0 ? void 0 : formStore.primaryLocale) !== (formStore === null || formStore === void 0 ? void 0 : formStore.translatedLocale)
        });
        await handleSubmitForm(projectType);
    };
    // Fire a saveForm UI analytics event, then save the form.
    const handleClickSave = async (_e, analyticsEvent)=>{
        (0, $aNTEp.fireUIAnalytics)(analyticsEvent, 'saveForm', (0, $eG2p4.getSimpleFormAnalytics)(formStore === null || formStore === void 0 ? void 0 : formStore.formId, formStore === null || formStore === void 0 ? void 0 : formStore.templateFormId, formStore === null || formStore === void 0 ? void 0 : formStore.status, formStore === null || formStore === void 0 ? void 0 : formStore.internal));
        await handleSaveForm();
    };
    // Fire a cancelForm UI analytics event, then save the form.
    const handleClickCancel = async (_e, analyticsEvent)=>{
        (0, $aNTEp.fireUIAnalytics)(analyticsEvent, 'cancelEdit', (0, $eG2p4.getSimpleFormAnalytics)(formStore === null || formStore === void 0 ? void 0 : formStore.formId, formStore === null || formStore === void 0 ? void 0 : formStore.templateFormId, formStore === null || formStore === void 0 ? void 0 : formStore.status, formStore === null || formStore === void 0 ? void 0 : formStore.internal));
        withDiscardChangeNotice(onCancelEdit);
    };
    // If the form data is still loading, show a spinner
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), null);
    if (!(form !== null && form !== void 0 && form.hasAccess) && (0, $fHpHg.fg)('granular_permissions_on_forms_ga')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcxlj.PermissionErrorMessage), null);
    // If there was an error loading the form, or the formStore has no form loaded, display an error message
    if (error || !formStore || formStore.formId !== form.id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcsGs.ErrorMessage), null);
    const isEditingForm = formViewMode === (0, $hprFm.FormViewMode).Edit;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iale.RenderForm), {
        formStore: formStore,
        displayMode: isEditingForm ? (0, $8iale.DisplayMode).Edit : (0, $8iale.DisplayMode).View,
        key: form.id,
        ufoExperience: ufoExperience,
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        linkedFieldNames: linkedFieldNames
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuD4T.RightAlign), null, isEditingForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4corl.EditButtons), {
        isSubmitting: isSubmitting,
        isSaving: isSaving,
        onSubmit: handleClickSubmit,
        onSave: handleClickSave,
        onCancel: handleClickCancel
    })));
};

});
parcelRegister("8iale", function(module, exports) {

$parcel$export(module.exports, "DisplayMode", () => $609806bf29c81d8d$export$4b7264771109adb6);
$parcel$export(module.exports, "RenderForm", () => $609806bf29c81d8d$export$9c83347a04dcbf4e);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $ajpes = parcelRequire("ajpes");

var $alnGD = parcelRequire("alnGD");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $eSRMC = parcelRequire("eSRMC");
var $f108J = parcelRequire("f108J");

var $fcIoh = parcelRequire("fcIoh");

var $8b5Ks = parcelRequire("8b5Ks");

var $erWXD = parcelRequire("erWXD");

var $luvXZ = parcelRequire("luvXZ");

var $dlLGv = parcelRequire("dlLGv");

var $iu3cq = parcelRequire("iu3cq");

var $c75hs = parcelRequire("c75hs");

var $dwM46 = parcelRequire("dwM46");

var $31xp0 = parcelRequire("31xp0");

var $a9AOh = parcelRequire("a9AOh");

var $8iiJB = parcelRequire("8iiJB");
let $609806bf29c81d8d$export$4b7264771109adb6 = /*#__PURE__*/ function(DisplayMode) {
    /**
   * View: Display the form as a plain document, display all answers are plain text
   */ DisplayMode["View"] = "view";
    /**
   * Edit: Display the form in edit mode with all input fields
   */ DisplayMode["Edit"] = "edit";
    /**
   * Preview: Display the form with all input fields disabled
   */ DisplayMode["Preview"] = "preview";
    /**
   * Translate: Display the form for translating with all input fields disabled
   */ DisplayMode["Translate"] = "translate";
    return DisplayMode;
}({});
const $609806bf29c81d8d$var$environment = window.location.hostname === 'localhost' ? 'staging' : undefined; // Make smart links connect to staging when developing locally.
const $609806bf29c81d8d$var$smartCardClient = new (0, $eSRMC.default)($609806bf29c81d8d$var$environment);
const $609806bf29c81d8d$var$formExtensionFn = (intl, formStoreRef, displayModeRef, blockFormSubmission, linkedFieldNames, QuestionRenderer, questionTypeRendererMap)=>{
    return (ext)=>{
        const formStore = formStoreRef.current;
        if (ext.extensionKey === 'question') {
            var _ext$parameters, _ref, _ref2, _formStore$translated;
            const questionId = (_ext$parameters = ext.parameters) === null || _ext$parameters === void 0 ? void 0 : _ext$parameters.id;
            const questionStore = questionId !== undefined && formStore.questions.find((question)=>question.id === questionId);
            if (!questionStore) {
                // eslint-disable-next-line no-console
                console.error(`Could not find the question store with ID ${questionId}:`, ext);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
            }
            const displayLocale = (_ref = (_ref2 = (_formStore$translated = formStore.translatedLocale) !== null && _formStore$translated !== void 0 ? _formStore$translated : formStore.primaryLocale) !== null && _ref2 !== void 0 ? _ref2 : formStore.language) !== null && _ref !== void 0 ? _ref : intl.locale;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlLGv.PackageIntlProvider), {
                locale: displayLocale
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9AOh.RenderQuestion), {
                questionStore: questionStore,
                displayMode: displayModeRef.current,
                formStore: formStore,
                blockFormSubmission: blockFormSubmission,
                linkedFieldNames: linkedFieldNames,
                QuestionRenderer: QuestionRenderer,
                questionTypeRendererMap: questionTypeRendererMap
            }));
        }
        if (ext.extensionKey === 'html') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dwM46.HtmlExtension), {
            extensionId: ext.parameters.id,
            htmlContent: ext.parameters.htmlContent || ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    };
};
const $609806bf29c81d8d$export$fc6800ebf988f90 = (linkedSummaryQuestionId, formLayout)=>{
    var _formLayout$some;
    return (_formLayout$some = formLayout === null || formLayout === void 0 ? void 0 : formLayout.some((layout)=>layout.content.some((content)=>{
            var _content$attrs, _content$attrs$parame;
            return content.type === 'extension' && ((_content$attrs = content.attrs) === null || _content$attrs === void 0 ? void 0 : (_content$attrs$parame = _content$attrs.parameters) === null || _content$attrs$parame === void 0 ? void 0 : _content$attrs$parame.id) === linkedSummaryQuestionId;
        }))) !== null && _formLayout$some !== void 0 ? _formLayout$some : false;
};
const $609806bf29c81d8d$export$9c83347a04dcbf4e = (0, $dlLGv.withPackageIntlProvider)((0, $jJXgM.observer)(({ formStore: formStore, showHiddenSections: showHiddenSections, displayMode: displayMode, backgroundColor: backgroundColor, ufoExperience: ufoExperience, blockFormSubmission: blockFormSubmission, linkedFieldNames: linkedFieldNames, QuestionRenderer: QuestionRenderer, questionTypeRendererMap: questionTypeRendererMap, nodeComponents: nodeComponents })=>{
    var _formStore$layout, _ref3, _ref4, _formStore$translated2, _formStore$language;
    const intl = (0, $koVbs.default)();
    const formStoreRef = (0, $5uXOq.useRef)(formStore);
    if (formStoreRef.current !== formStore) formStoreRef.current = formStore;
    const displayModeRef = (0, $5uXOq.useRef)(displayMode);
    if (displayModeRef.current !== displayMode) displayModeRef.current = displayMode;
    const { mediaReadTokenRefresh: mediaReadTokenRefresh } = (0, $iu3cq.useMediaContext)();
    const [attachmentIdsCache, setAttachmentIdsCache] = (0, $5uXOq.useState)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        let mediaTokenRefreshTimeoutId;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(attachmentIdsCache, formStore.attachmentIds)) {
            setAttachmentIdsCache(new Set([
                ...formStore.attachmentIds
            ]));
            if (formStore.attachmentIds.size > 0 && mediaReadTokenRefresh) mediaTokenRefreshTimeoutId = setTimeout(()=>mediaReadTokenRefresh(), 1000);
        }
        return ()=>{
            if (mediaTokenRefreshTimeoutId) clearInterval(mediaTokenRefreshTimeoutId);
        };
    // removing attachmentIdsCache from dependency array as we set it in the useEffect
    // this will immediately trigger the useEffect again which calls the returned cleanup function
    // this will clear the timeout which means the token won't be refreshed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formStore.attachmentIds,
        mediaReadTokenRefresh
    ]);
    (0, $c75hs.useEmitAttachmentMetrics)(formStore, displayMode !== $609806bf29c81d8d$export$4b7264771109adb6.Edit);
    (0, $5uXOq.useEffect)(()=>{
        blockFormSubmission && blockFormSubmission(formStore.isUploadingMedia);
    }, [
        blockFormSubmission,
        formStore.isUploadingMedia
    ]);
    const formSections = (_formStore$layout = formStore.layout) === null || _formStore$layout === void 0 ? void 0 : _formStore$layout.map((sectionLayout, index)=>{
        const sectionId = index.toString();
        if (showHiddenSections === undefined && !formStore.visibleSections.includes(sectionId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
        const formSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fcIoh.default), {
            key: sectionId,
            document: (0, $alnGD.toJS)(sectionLayout),
            extensionHandlers: {
                'com.thinktilt.proforma': $609806bf29c81d8d$var$formExtensionFn(intl, formStoreRef, displayModeRef, blockFormSubmission, linkedFieldNames, QuestionRenderer, questionTypeRendererMap)
            },
            eventHandlers: (0, $31xp0.rendererEventHandlers),
            nodeComponents: nodeComponents,
            adfStage: "stage0"
        });
        if (showHiddenSections && !formStore.visibleSections.includes(sectionId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($609806bf29c81d8d$var$SectionWrapperStyles, {
            key: sectionId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formSection), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($609806bf29c81d8d$var$SectionOverlayStyles, {
            hiddenSectionTheme: showHiddenSections
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($609806bf29c81d8d$var$SectionMessageStyles, {
            hiddenSectionTheme: showHiddenSections
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $8iiJB.IntlViewFormMessages)[(0, $8iiJB.ViewFormMessage).HiddenSection]))));
        return formSection;
    });
    const linkedSummaryQuestionId = formStore === null || formStore === void 0 ? void 0 : formStore.questions.find((question)=>question.formQuestion.jiraField === 'summary');
    const displayLocale = (_ref3 = (_ref4 = (_formStore$translated2 = formStore.translatedLocale) !== null && _formStore$translated2 !== void 0 ? _formStore$translated2 : formStore.primaryLocale) !== null && _ref4 !== void 0 ? _ref4 : formStore.language) !== null && _ref3 !== void 0 ? _ref3 : intl.locale;
    const form = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($609806bf29c81d8d$var$FormContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($609806bf29c81d8d$var$FormStyles, {
        backgroundColor: backgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f108J.SmartCardProvider), {
        client: $609806bf29c81d8d$var$smartCardClient
    }, formSections)), !!ufoExperience && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luvXZ.ExperienceSuccess), {
        experience: ufoExperience
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8b5Ks.FireUIAnalytics), {
        actionSubject: (0, $erWXD.ActionSubject).FORM,
        action: (0, $erWXD.Action).VIEWED,
        actionSubjectId: "proformaRenderForm",
        attributes: {
            ...formStore.analyticsAttributes,
            hasLinkedSummary: !!linkedSummaryQuestionId,
            summaryOnTopLevel: linkedSummaryQuestionId ? $609806bf29c81d8d$export$fc6800ebf988f90(linkedSummaryQuestionId.id, formStore === null || formStore === void 0 ? void 0 : formStore.layout) : false,
            translationDetails: {
                legacyLanguage: (_formStore$language = formStore.language) === null || _formStore$language === void 0 ? void 0 : _formStore$language.replace('_', '-'),
                localeMatched: displayLocale === intl.locale,
                primaryLocale: formStore.primaryLocale,
                translated: formStore.translatedLocale !== formStore.primaryLocale,
                translatedLocale: formStore.translatedLocale,
                translationsApplied: formStore.translatedLocale !== undefined,
                userLocale: intl.locale
            }
        }
    }));
    if (displayLocale !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dlLGv.PackageIntlProvider), {
        locale: displayLocale
    }, form);
    return form;
}));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $609806bf29c81d8d$var$FormContainer = (0, $dAHxw.default).div({
    height: 'auto',
    overflow: 'visible'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $609806bf29c81d8d$var$FormStyles = (0, $dAHxw.default).div(({ backgroundColor: backgroundColor })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "var(--ds-surface, white)",
        padding: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& .ak-renderer-extension-overflow-container': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            overflow: 'unset !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& .pm-table-container': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            zIndex: 'auto !important'
        }
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $609806bf29c81d8d$var$SectionWrapperStyles = (0, $dAHxw.default).div({
    position: 'relative',
    padding: "var(--ds-space-050, 4px)"
});
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ const $609806bf29c81d8d$var$SectionOverlayStyles = (0, $dAHxw.default).div(({ hiddenSectionTheme: hiddenSectionTheme })=>({
        height: '100%',
        width: '100%',
        backgroundColor: hiddenSectionTheme === 'dark' ? "var(--ds-background-disabled, rgba(108, 121, 143, 0.1))" : undefined,
        top: 0,
        left: 0,
        position: 'absolute',
        borderRadius: "var(--ds-border-radius, 3px)",
        textAlign: 'center',
        pointerEvents: 'none'
    }));
const $609806bf29c81d8d$var$SectionMessageStyles = (0, $dAHxw.default).h4(({ hiddenSectionTheme: hiddenSectionTheme })=>({
        padding: "var(--ds-space-100, 8px)",
        color: hiddenSectionTheme === 'light' ? "var(--ds-text, #091E42)" : "var(--ds-text, #172b4d)",
        backgroundColor: hiddenSectionTheme === 'light' ? "var(--ds-background-accent-gray-subtler, #DFE1E6)" : "var(--ds-surface, white)",
        display: 'inline-block',
        position: 'relative',
        top: "var(--ds-space-100, 8px)",
        borderRadius: "var(--ds-border-radius-200, 8px)"
    })); /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */  /* eslint-enable @atlaskit/ui-styling-standard/no-dynamic-styles */  /* eslint-enable @atlaskit/ui-styling-standard/no-styled */ 

});
parcelRegister("c75hs", function(module, exports) {

$parcel$export(module.exports, "useEmitAttachmentMetrics", () => $8d1a3c12749d62b3$export$3266ff6df305d226);

var $5uXOq = parcelRequire("5uXOq");

var $2hW3Y = parcelRequire("2hW3Y");

var $bngFq = parcelRequire("bngFq");

var $aNTEp = parcelRequire("aNTEp");

var $6Pi9E = parcelRequire("6Pi9E");

var $erWXD = parcelRequire("erWXD");

var $iu3cq = parcelRequire("iu3cq");
const $8d1a3c12749d62b3$export$3266ff6df305d226 = (formStore, view)=>{
    const { mediaApiReadToken: mediaApiReadToken, mediaUploadAndViewContexts: mediaUploadAndViewContexts, projectId: projectId, portalId: portalId, issueKey: issueKey } = (0, $iu3cq.useMediaContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (view && formStore.numberOfAttachment > 0) try {
            var _mediaUploadAndViewCo;
            const viewContextToken = mediaUploadAndViewContexts ? (_mediaUploadAndViewCo = mediaUploadAndViewContexts.viewContext) === null || _mediaUploadAndViewCo === void 0 ? void 0 : _mediaUploadAndViewCo.token : mediaApiReadToken ? (0, $6Pi9E.transformReadAttachmentsToken)(mediaApiReadToken).token : null;
            let viewableIds = new Set();
            if (viewContextToken) {
                // when there are no attachments, the token will be undefined and so do not decode
                const { access: access } = (0, (/*@__PURE__*/$parcel$interopDefault($2hW3Y)))(viewContextToken);
                const viewableFiles = Object.entries(access).filter(([_, value])=>value.includes('read'));
                viewableIds = new Set(viewableFiles.flatMap(([key, _])=>key.split(':')[3]));
            }
            const brokenFiles = formStore.questions.filter((questionStore)=>questionStore.formQuestion.type === 'at').flatMap((questionStore)=>{
                const attachments = questionStore.currentAnswer;
                return attachments.filter((attachment)=>!viewableIds.has(attachment.id));
            });
            const attachmentIdCreationDtStr = (attachments)=>{
                return attachments.map((attachment)=>`${attachment.id}: ${attachment.creationDate}`).join(', ');
            };
            if (brokenFiles.length > 0) (0, $aNTEp.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $erWXD.ActionSubject).ATTACHMENT_VIEWER_CARD,
                action: (0, $erWXD.Action).FAILED
            }), `${(0, $erWXD.ActionSubject).ATTACHMENT_VIEWER_CARD} ${(0, $erWXD.Action).FAILED}`, projectId ? {
                projectId: projectId,
                issueKey: issueKey,
                attachmentCreationDate: attachmentIdCreationDtStr(brokenFiles)
            } : {
                portalId: portalId,
                issueKey: issueKey,
                attachmentCreationDate: attachmentIdCreationDtStr(brokenFiles)
            });
        } catch (error) {
            (0, $aNTEp.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $erWXD.ActionSubject).ATTACHMENT_VIEWER_CARD,
                action: (0, $erWXD.Action).FAILED
            }), `${(0, $erWXD.ActionSubject).ATTACHMENT_VIEWER_CARD} ${(0, $erWXD.Action).FAILED}`, projectId ? {
                projectId: projectId,
                issueKey: issueKey,
                error: JSON.stringify(error)
            } : {
                portalId: portalId,
                issueKey: issueKey,
                error: JSON.stringify(error)
            });
        }
    // disabling exhaustive-deps as the metric is to track failed to load attachments which only occurs on first render
    // and we do not want duplicate events on re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        issueKey,
        portalId,
        projectId
    ]);
};

});
parcelRegister("6Pi9E", function(module, exports) {

$parcel$export(module.exports, "transformReadAttachmentsToken", () => $4f8596a17a4dbe84$export$12a604fa4698eff2);
$parcel$export(module.exports, "formatFilesWithEditActions", () => $4f8596a17a4dbe84$export$3d6c93fa1d202edb);
$parcel$export(module.exports, "formatFilesWithViewActions", () => $4f8596a17a4dbe84$export$42b47cfb0cc8860f);
$parcel$export(module.exports, "sortFilesYoungestFirstOnLeft", () => $4f8596a17a4dbe84$export$9b74b6d805ca078c);

var $5uXOq = parcelRequire("5uXOq");

var $4qnvw = parcelRequire("4qnvw");
const $4f8596a17a4dbe84$export$4d271852dd07ca26 = (token)=>{
    let decodedToken;
    try {
        decodedToken = JSON.parse(atob(token.split('.')[1]));
    } catch (error) {
        // why would this be the case
        return {
            tokenDecodeError: typeof error.message === 'string' ? error.message : undefined,
            localTimeDelta: undefined,
            tokenExpiryTime: undefined
        };
    }
    // In my testing, sometimes issued at was missing
    const startTimestamp = decodedToken.iat || decodedToken.nbf;
    const getLocalTimeDeltaMilliseconds = (startTimestamp)=>startTimestamp ? startTimestamp - Date.now() : undefined;
    return {
        tokenDecodeError: undefined,
        localTimeDelta: getLocalTimeDeltaMilliseconds(startTimestamp * 1000),
        // @ts-ignore
        tokenExpiryTime: decodedToken.exp * 1000
    };
};
const $4f8596a17a4dbe84$export$12a604fa4698eff2 = (readAttachmentsToken)=>{
    const getFirstTokenIfAvailable = (tokensWithFiles)=>tokensWithFiles.length > 0 ? tokensWithFiles[0].token : null;
    const token = getFirstTokenIfAvailable(readAttachmentsToken.tokensWithFiles);
    const tokenProps = typeof token === 'string' ? $4f8596a17a4dbe84$export$4d271852dd07ca26(token) : {};
    return {
        clientId: readAttachmentsToken.clientId,
        serviceHost: readAttachmentsToken.endpointUrl,
        token: token,
        areTokenPermissionsUpToDate: true,
        tokenLifespanInMs: readAttachmentsToken.tokenLifespanInSeconds * 1000,
        tokenIssueTimestamp: Date.now() - 10000,
        // added 10s buffer to cover network calls
        collection: null,
        tokenDecodeError: tokenProps.tokenDecodeError,
        localTimeDelta: tokenProps.localTimeDelta,
        tokenExpiryTime: tokenProps.tokenExpiryTime
    };
};
const $4f8596a17a4dbe84$export$e094e7a8aa55f6c7 = (uploadToken)=>{
    return {
        clientId: uploadToken.clientId,
        serviceHost: uploadToken.endpointUrl,
        token: uploadToken.token,
        tokenLifespanInMs: uploadToken.tokenDurationInMins * 60000,
        collection: uploadToken.targetCollection,
        tokenIssueTimestamp: Date.now() - 10000 // added 10s buffer to cover network calls
    };
};
const $4f8596a17a4dbe84$export$3ceb62baab058c6b = ({ readToken: readToken, uploadToken: uploadToken })=>{
    return {
        viewContext: readToken ? $4f8596a17a4dbe84$export$12a604fa4698eff2(readToken) : null,
        uploadContext: uploadToken ? $4f8596a17a4dbe84$export$e094e7a8aa55f6c7(uploadToken) : null
    };
};
const $4f8596a17a4dbe84$export$3d6c93fa1d202edb = (files, mediaClientConfig, collection, removeFile)=>{
    const toBeUploadedFiles = [];
    files.forEach((file)=>{
        toBeUploadedFiles.push({
            identifier: {
                id: file.id,
                mediaItemType: 'file',
                collectionName: collection
            },
            info: {
                ...file
            },
            mediaClientConfig: mediaClientConfig,
            actions: [
                {
                    handler: removeFile,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4qnvw))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: "Delete"
                    }),
                    label: 'Delete'
                }
            ]
        });
    });
    return toBeUploadedFiles;
};
const $4f8596a17a4dbe84$export$42b47cfb0cc8860f = (files, mediaClientConfig, collection)=>{
    const toBeUploadedFiles = [];
    files.forEach((file)=>{
        toBeUploadedFiles.push({
            identifier: {
                id: file.id,
                mediaItemType: 'file',
                collectionName: collection
            },
            info: {
                ...file
            },
            mediaClientConfig: mediaClientConfig,
            actions: []
        });
    });
    return toBeUploadedFiles;
};
const $4f8596a17a4dbe84$export$9b74b6d805ca078c = (a, b)=>{
    return b.info.creationDate && a.info.creationDate ? b.info.creationDate - a.info.creationDate : 0;
};

});


parcelRegister("dwM46", function(module, exports) {

$parcel$export(module.exports, "HtmlExtension", () => $9d938c3fc1de63f6$export$d8b28a189603eb0a);

var $5uXOq = parcelRequire("5uXOq");

var $kOFhM = parcelRequire("kOFhM");

var $lidZJ = parcelRequire("lidZJ");

var $hIzKv = parcelRequire("hIzKv");

var $fcIoh = parcelRequire("fcIoh");
const $9d938c3fc1de63f6$export$d8b28a189603eb0a = ({ extensionId: extensionId, htmlContent: htmlContent })=>{
    try {
        const jiraTransformer = new (0, $lidZJ.JIRATransformer)((0, $kOFhM.defaultSchema));
        const adfTransformer = new (0, $hIzKv.JSONTransformer)();
        const pmNode = jiraTransformer.parse(htmlContent);
        const adf = adfTransformer.encode(pmNode);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fcIoh.default), {
            key: extensionId,
            document: adf
        });
    } catch (err) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    }
};

});
parcelRegister("lidZJ", function(module, exports) {

$parcel$export(module.exports, "JIRATransformer", () => $b9afb8ede39d29d4$export$f47bcfd72ef563cc);

var $kCV8T = parcelRequire("kCV8T");

var $6bzqG = parcelRequire("6bzqG");

var $lxdRJ = parcelRequire("lxdRJ");

var $iaI69 = parcelRequire("iaI69");

var $5Sc2i = parcelRequire("5Sc2i");
class $b9afb8ede39d29d4$export$f47bcfd72ef563cc {
    constructor(schema, customEncoders, mediaContextInfo){
        this.schema = schema;
        this.customEncoders = customEncoders || {};
        this.mediaContextInfo = mediaContextInfo;
    }
    encode(node) {
        this.doc = this.makeDocument();
        this.doc.body.appendChild(this.encodeFragment(node.content));
        const html = this.doc.body.innerHTML;
        // JIRA encodes empty documents as an empty string
        if (html === '<p></p>') return '';
        // Normalise to XHTML style self closing tags.
        return html// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<br><\/br>/g, '<br />')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<br>/g, '<br />')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<hr><\/hr>/g, '<hr />')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<hr>/g, '<hr />')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/&amp;/g, '&');
    }
    parse(html) {
        const convertedNodes = new WeakMap();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const dom = (0, $lxdRJ.default)((0, $6bzqG.default)(html)).querySelector('body');
        const nodes = (0, $iaI69.bfsOrder)(dom);
        // JIRA encodes empty content as a single nbsp
        if (nodes.length === 1 && nodes[0].textContent === '\xa0') {
            const schemaNodes = this.schema.nodes;
            return schemaNodes.doc.createChecked({}, schemaNodes.paragraph.createChecked());
        }
        // Process through nodes in reverse (so deepest child elements are first).
        for(let i = nodes.length - 1; i >= 0; i--){
            const node = nodes[i];
            // for tables we take tbody content, because tbody is not in schema so the whole bfs thing wouldn't work
            const targetNode = // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node.tagName && node.tagName.toUpperCase() === 'TABLE' ? node.firstChild : node;
            const content = this.getContent(targetNode, convertedNodes);
            const candidate = (0, $iaI69.convert)(content, node, this.schema);
            if (typeof candidate !== 'undefined') convertedNodes.set(node, candidate);
        }
        const content = this.getContent(dom, convertedNodes);
        // Dangling inline nodes can't be directly inserted into a document, so
        // we attempt to wrap in a paragraph.
        const compatibleContent = this.schema.nodes.doc.validContent(content) ? content : (0, $iaI69.ensureBlocks)(content, this.schema);
        return this.schema.nodes.doc.createChecked({}, compatibleContent);
    }
    /*
	 * Contructs a struct string of replacement blocks and marks for a given node
	 */ getContent(node, convertedNodes) {
        let fragment = (0, $kCV8T.Fragment).fromArray([]);
        let childIndex;
        for(childIndex = 0; childIndex < node.childNodes.length; childIndex++){
            const child = node.childNodes[childIndex];
            const thing = convertedNodes.get(child);
            if (thing instanceof (0, $kCV8T.Fragment) || thing instanceof (0, $kCV8T.Node)) fragment = fragment.append((0, $kCV8T.Fragment).from(thing));
        }
        return fragment;
    }
    encodeNode(node) {
        const { blockquote: blockquote, bulletList: bulletList, codeBlock: codeBlock, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, emoji: emoji, orderedList: orderedList, paragraph: paragraph, rule: rule, mediaInline: mediaInline, mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media, table: table } = this.schema.nodes;
        // We compare node type names in this method rather than
        // node types directly as the node comparision fails.
        // This suggests the schema which is coming from
        // the doc has been recreated after being passed
        // to this transformer on setup which is somewhat
        // unexpected.
        // This package is internally (within editor) considered
        // "obsolete", and we are aiming to either hand over
        // or deprecate.
        // This "fix" is being done to unblock an existing
        // consumer so they can apply an unrelated security
        // upgrade.
        if (node.isText) return this.encodeText(node);
        else if (node.type.name === heading.name) return this.encodeHeading(node);
        else if (node.type.name === rule.name) return this.encodeHorizontalRule();
        else if (node.type.name === paragraph.name) return this.encodeParagraph(node);
        else if (node.type.name === hardBreak.name) return this.encodeHardBreak();
        if ((0, $5Sc2i.isSchemaWithLists)(this.schema)) {
            if (node.type.name === bulletList.name) return this.encodeBulletList(node);
            else if (node.type.name === orderedList.name) return this.encodeOrderedList(node);
            else if (node.type.name === listItem.name) return this.encodeListItem(node);
        }
        if ((0, $5Sc2i.isSchemaWithMentions)(this.schema) && node.type.name === mention.name) return this.encodeMention(node, this.customEncoders.mention);
        if ((0, $5Sc2i.isSchemaWithEmojis)(this.schema) && node.type.name === emoji.name) return this.encodeEmoji(node);
        if ((0, $5Sc2i.isSchemaWithCodeBlock)(this.schema) && node.type.name === codeBlock.name) return this.encodeCodeBlock(node);
        if ((0, $5Sc2i.isSchemaWithBlockQuotes)(this.schema) && node.type.name === blockquote.name) return this.encodeBlockQuote(node);
        if ((0, $5Sc2i.isSchemaWithMedia)(this.schema)) {
            if (node.type.name === mediaGroup.name) return this.encodeMediaGroup(node);
            else if (node.type.name === mediaSingle.name) return this.encodeMediaSingle(node);
            else if (node.type.name === media.name || node.type.name === mediaInline.name) return this.encodeMedia(node);
        }
        if ((0, $5Sc2i.isSchemaWithTables)(this.schema) && node.type.name === table.name) return this.encodeTable(node);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        throw new Error(`Unexpected node '${node.type.name}' for HTML encoding`);
    }
    makeDocument() {
        const doc = document.implementation.createHTMLDocument('');
        doc.body = doc.createElement('body');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        doc.documentElement.appendChild(doc.body);
        return doc;
    }
    encodeFragment(fragment) {
        const documentFragment = this.doc.createDocumentFragment();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        fragment.forEach((node)=>documentFragment.appendChild(this.encodeNode(node)));
        return documentFragment;
    }
    encodeHeading(node) {
        function anchorNameEncode(name) {
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            const noSpaces = name.replace(/ /g, '');
            const uriEncoded = encodeURIComponent(noSpaces);
            const specialsEncoded = uriEncoded.replace(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            /[!'()*]/g, (c)=>'%' + c.charCodeAt(0).toString(16));
            return specialsEncoded;
        }
        const { level: level } = node.attrs;
        // @see ED-4708
        const elem = this.doc.createElement(`h${level === 6 ? 5 : level}`);
        const anchor = this.doc.createElement('a');
        anchor.setAttribute('name', anchorNameEncode(node.textContent));
        elem.appendChild(anchor);
        elem.appendChild(this.encodeFragment(node.content));
        return elem;
    }
    encodeParagraph(node) {
        const elem = this.doc.createElement('p');
        elem.appendChild(this.encodeFragment(node.content));
        return elem;
    }
    encodeText(node) {
        if (node.text) {
            const root = this.doc.createDocumentFragment();
            let elem = root;
            const { code: code, em: em, link: link, typeAheadQuery: typeAheadQuery, strike: strike, strong: strong, subsup: subsup, underline: underline, textColor: textColor } = this.schema.marks;
            for (const mark of node.marks)switch(mark.type){
                case strong:
                    elem = elem.appendChild(this.doc.createElement('b'));
                    break;
                case em:
                    elem = elem.appendChild(this.doc.createElement('em'));
                    break;
                case code:
                    elem = elem.appendChild(this.doc.createElement('tt'));
                    break;
                case strike:
                    elem = elem.appendChild(this.doc.createElement('del'));
                    break;
                case underline:
                    elem = elem.appendChild(this.doc.createElement('ins'));
                    break;
                case subsup:
                    elem = elem.appendChild(this.doc.createElement(mark.attrs['type']));
                    break;
                case link:
                    const linkElem = this.doc.createElement('a');
                    const href = mark.attrs['href'];
                    /** JIRA always expects external-link attribute set on links created via editor unless its #fragment */ // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (!href.match(/^#/)) {
                        linkElem.setAttribute('class', 'external-link');
                        linkElem.setAttribute('rel', 'nofollow');
                    }
                    linkElem.setAttribute('href', href);
                    if (mark.attrs['title']) linkElem.setAttribute('title', mark.attrs['title']);
                    elem = elem.appendChild(linkElem);
                    break;
                case textColor:
                    const fontElem = this.doc.createElement('font');
                    fontElem.setAttribute('color', mark.attrs['color']);
                    elem = elem.appendChild(fontElem);
                    break;
                case typeAheadQuery:
                    break;
                default:
                    throw new Error(`Unable to encode mark '${mark.type.name}'`);
            }
            elem.textContent = node.text;
            return root;
        } else return this.doc.createTextNode('');
    }
    encodeHardBreak() {
        return this.doc.createElement('br');
    }
    encodeHorizontalRule() {
        return this.doc.createElement('hr');
    }
    encodeBulletList(node) {
        const elem = this.doc.createElement('ul');
        elem.setAttribute('class', 'alternate');
        elem.setAttribute('type', 'disc');
        elem.appendChild(this.encodeFragment(node.content));
        for(let index = 0; index < elem.childElementCount; index++)elem.children[index].setAttribute('data-parent', 'ul');
        return elem;
    }
    encodeOrderedList(node) {
        const elem = this.doc.createElement('ol');
        elem.appendChild(this.encodeFragment(node.content));
        for(let index = 0; index < elem.childElementCount; index++)elem.children[index].setAttribute('data-parent', 'ol');
        return elem;
    }
    encodeListItem(node) {
        const elem = this.doc.createElement('li');
        if (node.content.childCount) {
            let hasBlocks = false;
            node.content.forEach((childNode)=>{
                if (childNode.type === this.schema.nodes.bulletList || childNode.type === this.schema.nodes.orderedList) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const list = this.encodeNode(childNode);
                    /**
					 * Changing type for nested list:
					 *
					 * Second level -> circle
					 * Third and deeper -> square
					 */ if (list instanceof HTMLElement && list.tagName === 'UL') {
                        list.setAttribute('type', 'circle');
                        [].forEach.call(list.querySelectorAll('ul'), (ul)=>{
                            ul.setAttribute('type', 'square');
                        });
                    }
                    elem.appendChild(list);
                } else if (childNode.type.name === 'paragraph' && !hasBlocks) // Strip the paragraph node from the list item.
                elem.appendChild(this.encodeFragment(childNode.content));
                else {
                    if (childNode.isBlock) hasBlocks = true;
                    elem.appendChild(this.encodeNode(childNode));
                }
            });
        }
        return elem;
    }
    encodeMention(node, encoder) {
        const elem = this.doc.createElement('a');
        elem.setAttribute('class', 'user-hover');
        elem.setAttribute('href', encoder ? encoder(node.attrs.id) : node.attrs.id);
        elem.setAttribute('rel', node.attrs.id);
        elem.appendChild(this.doc.createTextNode(node.attrs.text));
        return elem;
    }
    encodeEmoji(node) {
        return this.doc.createTextNode(node.attrs && node.attrs.text);
    }
    encodeCodeBlock(node) {
        const elem = this.doc.createElement('div');
        elem.setAttribute('class', 'code panel');
        const content = this.doc.createElement('div');
        content.setAttribute('class', 'codeContent panelContent');
        const pre = this.doc.createElement('pre');
        // java is default language for JIRA
        pre.setAttribute('class', `code-${(node.attrs.language || 'plain').toLocaleLowerCase()}`);
        pre.appendChild(this.encodeFragment(node.content));
        content.appendChild(pre);
        elem.appendChild(content);
        return elem;
    }
    encodeBlockQuote(node) {
        const elem = this.doc.createElement('blockquote');
        elem.appendChild(this.encodeFragment(node.content));
        return elem;
    }
    encodeMediaGroup(node) {
        const elem = this.doc.createElement('p');
        elem.setAttribute('class', 'mediaGroup');
        elem.appendChild(this.encodeFragment(node.content));
        return elem;
    }
    encodeMediaSingle(node) {
        const elem = this.doc.createElement('p');
        elem.setAttribute('class', 'mediaSingle');
        elem.appendChild(this.encodeFragment(node.content));
        return elem;
    }
    addDataToNode(domNode, mediaNode, defaultDisplayType = 'thumbnail') {
        const { id: id, type: type, collection: collection, __fileName: __fileName, __displayType: __displayType, width: width, height: height } = mediaNode.attrs;
        // Order of dataset matters in IE Edge, please keep the current order
        domNode.setAttribute('data-attachment-type', __displayType || defaultDisplayType);
        if (__fileName) domNode.setAttribute('data-attachment-name', __fileName);
        if (width) domNode.setAttribute('data-width', width);
        if (height) domNode.setAttribute('data-height', height);
        domNode.setAttribute('data-media-services-type', type);
        domNode.setAttribute('data-media-services-id', id);
        if (collection) domNode.setAttribute('data-media-services-collection', collection);
    }
    buildURLWithContextInfo(fileId, contextInfo) {
        const { clientId: clientId, baseUrl: baseUrl, token: token, collection: collection } = contextInfo;
        return `${baseUrl}/file/${fileId}/image?token=${token}&client=${clientId}&collection=${collection}&width=200&height=200&mode=fit`;
    }
    isImageMimeType(mimeType) {
        return mimeType && mimeType.indexOf('image/') > -1;
    }
    encodeMedia(node) {
        // span.image-wrap > a > jira-attachment-thumbnail > img[data-media-*] > content
        // span.no-br > a[data-media] > content
        const elem = this.doc.createElement('span');
        const a = this.doc.createElement('a');
        if (node.attrs.__displayType === 'file' || !(node.attrs.__displayType || this.isImageMimeType(node.attrs.__fileMimeType))) {
            elem.setAttribute('class', 'nobr');
            this.addDataToNode(a, node, 'file');
            a.textContent = node.attrs.__fileName || '';
        } else {
            elem.setAttribute('class', 'image-wrap');
            const img = this.doc.createElement('img');
            img.setAttribute('alt', node.attrs.__fileName);
            // Newly uploaded items have collection
            if (node.attrs.collection && this.mediaContextInfo && this.mediaContextInfo.uploadContext) img.setAttribute('src', this.buildURLWithContextInfo(node.attrs.id, this.mediaContextInfo.uploadContext));
            else if (this.mediaContextInfo && this.mediaContextInfo.viewContext) img.setAttribute('src', this.buildURLWithContextInfo(node.attrs.id, this.mediaContextInfo.viewContext));
            this.addDataToNode(img, node);
            const jiraThumb = this.doc.createElement('jira-attachment-thumbnail');
            jiraThumb.appendChild(img);
            a.appendChild(jiraThumb);
        }
        elem.appendChild(a);
        return elem;
    }
    encodeTable(node) {
        const elem = this.doc.createElement('table');
        const tbody = this.doc.createElement('tbody');
        node.descendants((rowNode)=>{
            const rowElement = this.doc.createElement('tr');
            rowNode.descendants((colNode)=>{
                const cellType = colNode.type === this.schema.nodes.tableCell ? 'd' : 'h';
                const cellElement = this.doc.createElement(`t${cellType}`);
                cellElement.setAttribute('class', `confluenceT${cellType}`);
                cellElement.appendChild(this.encodeFragment(colNode.content));
                rowElement.appendChild(cellElement);
                return false;
            });
            tbody.appendChild(rowElement);
            return false;
        });
        elem.appendChild(tbody);
        elem.setAttribute('class', 'confluenceTable');
        return elem;
    }
}

});
parcelRegister("6bzqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $426efd6457873dbf$export$2e2bcd8739ae039);

var $k6j8t = parcelRequire("k6j8t");
function $426efd6457873dbf$export$2e2bcd8739ae039(fragment) {
    const html = `<!doctype html><html><body>${fragment}</body></html>`;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parser = new window.DOMParser();
    const tree = parser.parseFromString(html, 'text/html');
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $k6j8t.default)(tree.documentElement, $426efd6457873dbf$var$isBlock);
    return tree;
}
function $426efd6457873dbf$var$isBlock(node) {
    // these blocks are mainly used to collapse whitespace between the blocks
    // (preventing spurious text nodes of ' ')
    switch(node.nodeName.toUpperCase()){
        case 'ADDRESS':
        case 'ARTICLE':
        case 'ASIDE':
        case 'AUDIO':
        case 'BLOCKQUOTE':
        case 'BODY':
        case 'CANVAS':
        case 'CENTER':
        case 'DD':
        case 'DIR':
        case 'DIV':
        case 'DL':
        case 'DT':
        case 'FIELDSET':
        case 'FIGCAPTION':
        case 'FIGURE':
        case 'FOOTER':
        case 'FORM':
        case 'FRAMESET':
        case 'H1':
        case 'H2':
        case 'H3':
        case 'H4':
        case 'H5':
        case 'H6':
        case 'HEADER':
        case 'HGROUP':
        case 'HR':
        case 'HTML':
        case 'ISINDEX':
        case 'LI':
        case 'MAIN':
        case 'MENU':
        case 'NAV':
        case 'NOFRAMES':
        case 'NOSCRIPT':
        case 'OL':
        case 'OUTPUT':
        case 'P':
        case 'PRE':
        case 'SECTION':
        case 'TABLE':
        case 'TBODY':
        case 'TD':
        case 'TFOOT':
        case 'TH':
        case 'THEAD':
        case 'TR':
        case 'UL':
            return true;
    }
    return false;
}

});
parcelRegister("k6j8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9bfa79d5d9dbdf3$export$2e2bcd8739ae039);

var $djRVT = parcelRequire("djRVT");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f9bfa79d5d9dbdf3$var$collapseWhitespace = (0, (/*@__PURE__*/$parcel$interopDefault($djRVT)));
var $f9bfa79d5d9dbdf3$export$2e2bcd8739ae039 = $f9bfa79d5d9dbdf3$var$collapseWhitespace;

});
parcelRegister("djRVT", function(module, exports) {
'use strict';

var $gZtrJ = parcelRequire("gZtrJ");
Object.keys($gZtrJ).forEach(function(name) {
    $gZtrJ[name.toUpperCase()] = 1;
});
var $9b26e2a3640f01c2$var$blockElements = {};

(parcelRequire("b6Htb")).forEach(function(name) {
    $9b26e2a3640f01c2$var$blockElements[name.toUpperCase()] = 1;
});
/**
 * isBlockElem(node) determines if the given node is a block element.
 *
 * @param {Node} node
 * @return {Boolean}
 */ function $9b26e2a3640f01c2$var$isBlockElem(node) {
    return !!(node && $9b26e2a3640f01c2$var$blockElements[node.nodeName]);
}
/**
 * isPreElem(node) determines if the given node is a PRE element.
 * 
 * Whitespace for PRE elements are not collapsed.
 * 
 * @param {Node} node
 * @return {Boolean}
 */ function $9b26e2a3640f01c2$var$isPreElem(node) {
    return node.nodeName === 'PRE';
}
/**
 * isVoid(node) determines if the given node is a void element.
 *
 * @param {Node} node
 * @return {Boolean}
 */ function $9b26e2a3640f01c2$var$isVoid(node) {
    return !!(node && $gZtrJ[node.nodeName]);
}
/**
 * whitespace(elem [, isBlock]) removes extraneous whitespace from an
 * the given element. The function isBlock may optionally be passed in
 * to determine whether or not an element is a block element; if none
 * is provided, defaults to using the list of block elements provided
 * by the `block-elements` module.
 *
 * @param {Node} elem
 * @param {Function} blockTest
 */ function $9b26e2a3640f01c2$var$collapseWhitespace(elem, isBlock, isPre) {
    if (!elem.firstChild || elem.nodeName === 'PRE') return;
    if (typeof isBlock !== 'function') isBlock = $9b26e2a3640f01c2$var$isBlockElem;
    if (typeof isPre !== 'function') isPre = $9b26e2a3640f01c2$var$isPreElem;
    var prevText = null;
    var prevVoid = false;
    var prev = null;
    var node = $9b26e2a3640f01c2$var$next(prev, elem, isPre);
    while(node !== elem){
        if (node.nodeType === 3 || node.nodeType === 4) {
            // Node.TEXT_NODE or Node.CDATA_SECTION_NODE
            var text = node.data.replace(/[ \r\n\t]+/g, ' ');
            if ((!prevText || / $/.test(prevText.data)) && !prevVoid && text[0] === ' ') text = text.substr(1);
            // `text` might be empty at this point.
            if (!text) {
                node = $9b26e2a3640f01c2$var$remove(node);
                continue;
            }
            node.data = text;
            prevText = node;
        } else if (node.nodeType === 1) {
            // Node.ELEMENT_NODE
            if (isBlock(node) || node.nodeName === 'BR') {
                if (prevText) prevText.data = prevText.data.replace(/ $/, '');
                prevText = null;
                prevVoid = false;
            } else if ($9b26e2a3640f01c2$var$isVoid(node)) {
                // Avoid trimming space around non-block, non-BR void elements.
                prevText = null;
                prevVoid = true;
            }
        } else {
            node = $9b26e2a3640f01c2$var$remove(node);
            continue;
        }
        var nextNode = $9b26e2a3640f01c2$var$next(prev, node, isPre);
        prev = node;
        node = nextNode;
    }
    if (prevText) {
        prevText.data = prevText.data.replace(/ $/, '');
        if (!prevText.data) $9b26e2a3640f01c2$var$remove(prevText);
    }
}
/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */ function $9b26e2a3640f01c2$var$remove(node) {
    var next = node.nextSibling || node.parentNode;
    node.parentNode.removeChild(node);
    return next;
}
/**
 * next(prev, current, isPre) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @param {Function} isPre
 * @return {Node}
 */ function $9b26e2a3640f01c2$var$next(prev, current, isPre) {
    if (prev && prev.parentNode === current || isPre(current)) return current.nextSibling || current.parentNode;
    return current.firstChild || current.nextSibling || current.parentNode;
}
module.exports = $9b26e2a3640f01c2$var$collapseWhitespace;

});
parcelRegister("gZtrJ", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "keygen": true,
    "link": true,
    "menuitem": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});

parcelRegister("b6Htb", function(module, exports) {
/**
 * This file automatically generated from `build.js`.
 * Do not manually edit.
 */ module.exports = [
    "address",
    "article",
    "aside",
    "blockquote",
    "canvas",
    "dd",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "li",
    "main",
    "nav",
    "noscript",
    "ol",
    "output",
    "p",
    "pre",
    "section",
    "table",
    "tfoot",
    "ul",
    "video"
];

});




parcelRegister("lxdRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5725dd8d11f9a80d$export$2e2bcd8739ae039);
function $5725dd8d11f9a80d$var$getNodeName(node) {
    return node && node.nodeName.toUpperCase();
}
function $5725dd8d11f9a80d$var$isMedia(node) {
    if (!node) return false;
    if ($5725dd8d11f9a80d$var$getNodeName(node) === 'SPAN' && node instanceof HTMLElement) return !!node.querySelector('a > jira-attachment-thumbnail > img[data-attachment-type="thumbnail"], a[data-attachment-type="file"]');
    return false;
}
function $5725dd8d11f9a80d$var$repairParagraph(p) {
    const paragraphs = [];
    let buffer = [];
    let mediaGroupFound = false;
    let skipBuffer = false;
    const processMedia = ()=>{
        if (buffer.length) {
            const head = buffer[0];
            if ($5725dd8d11f9a80d$var$getNodeName(head) === 'BR') buffer.shift();
            paragraphs.push(buffer);
            buffer = [];
        }
    };
    for(let i = 0, length = p.childNodes.length; i < length; i++){
        const node = p.childNodes[i];
        skipBuffer = false;
        // [..., M, BR, ...]
        if ($5725dd8d11f9a80d$var$getNodeName(node) === 'BR') {
            // [mmm, M, BR, ...]
            if (mediaGroupFound) {
                processMedia();
                mediaGroupFound = false;
                skipBuffer = true;
            }
            // [..., BR, M, ...]
            if ($5725dd8d11f9a80d$var$isMedia(node.nextSibling)) {
                mediaGroupFound = true;
                if (buffer.length) {
                    paragraphs.push(buffer);
                    buffer = [];
                }
            }
        } else if ($5725dd8d11f9a80d$var$isMedia(node)) // [M, ...]
        {
            if (node.previousSibling === null) mediaGroupFound = true;
        } else if (mediaGroupFound) {
            // Skip white space characters inside media
            if ($5725dd8d11f9a80d$var$getNodeName(node) === '#TEXT' && (node.textContent || '').trim() === '') continue;
            buffer = (paragraphs.pop() || []).concat(buffer);
            mediaGroupFound = false;
        }
        if (!skipBuffer) buffer.push(node);
    }
    if (mediaGroupFound) processMedia();
    else paragraphs.push(buffer);
    if (paragraphs.length > 1) {
        const fragment = document.createDocumentFragment();
        paragraphs.forEach((childP)=>{
            const innerP = document.createElement('p');
            childP.forEach((child)=>innerP.appendChild(child));
            fragment.appendChild(innerP);
        });
        // Replace old P
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const parent = p.parentNode;
        parent.insertBefore(fragment, p.nextSibling);
        // IE11 doesn't support remove
        parent.removeChild(p);
    }
}
function $5725dd8d11f9a80d$export$2e2bcd8739ae039(doc) {
    const paragraphs = doc.querySelectorAll('p');
    for(let i = 0, length = paragraphs.length; i < length; i++)$5725dd8d11f9a80d$var$repairParagraph(paragraphs[i]);
    return doc;
}

});

parcelRegister("iaI69", function(module, exports) {

$parcel$export(module.exports, "ensureBlocks", () => $5dc2ec50ecaeaa0f$export$c389196451c598e2);
$parcel$export(module.exports, "convert", () => $5dc2ec50ecaeaa0f$export$9c68d69a4c5bbcf9);
$parcel$export(module.exports, "bfsOrder", () => $5dc2ec50ecaeaa0f$export$6f3da03763fd5ca0);

var $51H8P = parcelRequire("51H8P");

var $5Sc2i = parcelRequire("5Sc2i");

var $kCV8T = parcelRequire("kCV8T");

var $jAjrm = parcelRequire("jAjrm");
function $5dc2ec50ecaeaa0f$export$c389196451c598e2(fragment, schema, nodeType) {
    // If all the nodes are inline, we want to wrap in a single paragraph.
    if (schema.nodes.paragraph.validContent(fragment)) return (0, $kCV8T.Fragment).fromArray([
        schema.nodes.paragraph.createChecked({}, fragment)
    ]);
    // Either all the nodes are blocks, or a mix of inline and blocks.
    // We convert each (if any) inline nodes to blocks.
    const blockNodes = [];
    // Following if condition has been added as fix for #ED-3431.
    // First child of list-item should be paragraph,
    // if that is not the case paragraph requires to be added.
    if (nodeType && nodeType === schema.nodes.listItem && fragment.firstChild && (fragment.firstChild.type === schema.nodes.bulletList || fragment.firstChild.type === schema.nodes.orderedList)) blockNodes.push(schema.nodes.paragraph.createAndFill());
    fragment.forEach((child)=>{
        if (child.isBlock) blockNodes.push(child);
        else blockNodes.push(schema.nodes.paragraph.createChecked({}, child));
    });
    return (0, $kCV8T.Fragment).fromArray(blockNodes);
}
const $5dc2ec50ecaeaa0f$export$5cb2cb6b3b363caa = (schema, content, supportedMarks)=>{
    const result = [];
    content.forEach((node)=>{
        if (node.isInline) {
            const filteredMarks = node.marks.filter((mark)=>mark.isInSet(supportedMarks));
            result.push(node.mark(filteredMarks));
            return;
        }
        // We replace an non-inline node with UnsupportedInline node
        result.push(schema.text(node.textContent));
    });
    return (0, $kCV8T.Fragment).fromArray(result);
};
function $5dc2ec50ecaeaa0f$export$9c68d69a4c5bbcf9(content, node, schema) {
    // text
    if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        return text ? schema.text(text) : null;
    }
    // marks and nodes
    if (node instanceof HTMLElement) {
        const tag = node.tagName.toUpperCase();
        switch(tag){
            // Marks
            case 'DEL':
                if (!(0, $5Sc2i.isSchemaWithAdvancedTextFormattingMarks)(schema)) return null;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return $5dc2ec50ecaeaa0f$var$addMarks(content, [
                    schema.marks.strike.create()
                ]);
            case 'B':
                return $5dc2ec50ecaeaa0f$var$addMarks(content, [
                    schema.marks.strong.create()
                ]);
            case 'EM':
                return $5dc2ec50ecaeaa0f$var$addMarks(content, [
                    schema.marks.em.create()
                ]);
            case 'TT':
                if (!(0, $5Sc2i.isSchemaWithAdvancedTextFormattingMarks)(schema)) return null;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return $5dc2ec50ecaeaa0f$var$addMarks(content, [
                    schema.marks.code.create()
                ]);
            case 'SUB':
            case 'SUP':
                if (!(0, $5Sc2i.isSchemaWithSubSupMark)(schema)) return null;
                const type = tag === 'SUB' ? 'sub' : 'sup';
                return $5dc2ec50ecaeaa0f$var$addMarks(content, [
                    schema.marks.subsup.create({
                        type: type
                    })
                ]);
            case 'INS':
                return $5dc2ec50ecaeaa0f$var$addMarks(content, [
                    schema.marks.underline.create()
                ]);
            case 'FONT':
                if (!(0, $5Sc2i.isSchemaWithTextColor)(schema)) return null;
                const color = (0, $51H8P.normalizeHexColor)(node.getAttribute('color'), '#333333');
                return color ? $5dc2ec50ecaeaa0f$var$addMarks(content, [
                    schema.marks.textColor.create({
                        color: color
                    })
                ]) : content;
            // Nodes
            case 'A':
                if (node.className === 'user-hover' && (0, $5Sc2i.isSchemaWithMentions)(schema)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return schema.nodes.mention.createChecked({
                    id: node.getAttribute('rel'),
                    text: node.textContent
                });
                if (node.className.match('jira-issue-macro-key') || !content || !(0, $5Sc2i.isSchemaWithLinks)(schema)) return null;
                const href = node.getAttribute('href');
                const title = node.getAttribute('title');
                return href ? $5dc2ec50ecaeaa0f$var$addMarks(content, [
                    schema.marks.link.create({
                        href: href,
                        title: title
                    })
                ]) : content;
            case 'SPAN':
                /**
				 * JIRA ISSUE MACROS
				 * `````````````````
				 * <span class="jira-issue-macro" data-jira-key="ED-1">
				 *     <a href="https://product-fabric.atlassian.net/browse/ED-1" class="jira-issue-macro-key issue-link">
				 *         <img class="icon" src="./epic.svg" />
				 *         ED-1
				 *     </a>
				 *     <span class="aui-lozenge aui-lozenge-subtle aui-lozenge-current jira-macro-single-issue-export-pdf">
				 *         In Progress
				 *     </span>
				 * </span>
				 */ if (node.className.split(' ').indexOf('jira-issue-macro') > -1) {
                    const jiraKey = node.getAttribute('data-jira-key');
                    const link = node.getElementsByTagName('a')[0];
                    if (jiraKey && link) return $5dc2ec50ecaeaa0f$var$addMarks((0, $kCV8T.Fragment).from(schema.text(jiraKey)), [
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        schema.marks.link.create({
                            href: link.getAttribute('href'),
                            title: link.getAttribute('title')
                        })
                    ]);
                    return null;
                } else if (node.className.match('jira-macro-single-issue-export-pdf')) return null;
                else if (node.className.match('code-')) // Removing spans with syntax highlighting from JIRA
                return null;
                else if ($5dc2ec50ecaeaa0f$var$isMedia(node) && (0, $5Sc2i.isSchemaWithMedia)(schema)) {
                    const dataNode = node.querySelector('[data-media-services-id]');
                    if (dataNode && dataNode instanceof HTMLElement) {
                        const id = dataNode.getAttribute('data-media-services-id');
                        const type = dataNode.getAttribute('data-media-services-type');
                        const collection = dataNode.getAttribute('data-media-services-collection') || '';
                        const attachmentName = dataNode.getAttribute('data-attachment-name');
                        const attachmentType = dataNode.getAttribute('data-attachment-type');
                        const fileName = dataNode.getAttribute('data-file-name');
                        const displayType = dataNode.getAttribute('data-display-type');
                        const width = parseInt(dataNode.getAttribute('data-width') || '', 10);
                        const height = parseInt(dataNode.getAttribute('data-height') || '', 10);
                        return schema.nodes.media.createChecked({
                            id: id,
                            type: type,
                            collection: collection,
                            width: width || null,
                            height: height || null,
                            __fileName: attachmentName || fileName,
                            __displayType: attachmentType || displayType || 'thumbnail'
                        });
                    }
                }
                break;
            case 'IMG':
                if (node.parentElement && node.parentElement.className.match('jira-issue-macro-key')) return null;
                else if (node.className === 'emoticon') {
                    const emojiResult = (0, $jAjrm.mapImageToEmoji)(node);
                    if (emojiResult) return schema.text(emojiResult);
                }
                break;
            case 'H1':
            case 'H2':
            case 'H3':
            case 'H4':
            case 'H5':
            case 'H6':
                const level = Number(tag.charAt(1));
                const supportedMarks = [
                    schema.marks.link
                ].filter((mark)=>!!mark);
                return schema.nodes.heading.createChecked(// @see ED-4708
                {
                    level: level === 6 ? 5 : level
                }, schema.nodes.heading.validContent(content) ? content : // eslint-disable-next-line @typescript-eslint/no-explicit-any
                $5dc2ec50ecaeaa0f$export$5cb2cb6b3b363caa(schema, content, supportedMarks));
            case 'BR':
                return schema.nodes.hardBreak.createChecked();
            case 'HR':
                return schema.nodes.rule.createChecked();
            case 'P':
                if (node.firstElementChild && $5dc2ec50ecaeaa0f$var$isMedia(node.firstElementChild)) {
                    // Filter out whitespace text nodes
                    const { mediaSingle: mediaSingle, mediaGroup: mediaGroup, paragraph: paragraph } = schema.nodes;
                    const mediaArray = [];
                    const contentArray = [];
                    const fragmentArray = [];
                    let hasNonMediaChildren = false;
                    content.forEach((child)=>{
                        if (child.type === schema.nodes.media) {
                            mediaArray.push(child);
                            return;
                        // Ignored via go/ees005
                        // eslint-disable-next-line require-unicode-regexp
                        } else if (!(child.isText && /^\s*$/.test(child.text || ''))) hasNonMediaChildren = true;
                        contentArray.push(child);
                    });
                    if (hasNonMediaChildren && contentArray.length) fragmentArray.push(paragraph.createChecked({}, contentArray));
                    if ((0, $5Sc2i.isSchemaWithMedia)(schema) && mediaArray.length) {
                        const mediaNodeType = $5dc2ec50ecaeaa0f$var$isMediaSingle(node.firstElementChild) ? mediaSingle : mediaGroup;
                        fragmentArray.push(mediaNodeType.createChecked({}, mediaArray));
                    }
                    if (fragmentArray.length) return (0, $kCV8T.Fragment).fromArray(fragmentArray);
                    return null;
                }
                return schema.nodes.paragraph.createChecked({}, content);
        }
        // lists
        if ((0, $5Sc2i.isSchemaWithLists)(schema)) switch(tag){
            case 'UL':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return schema.nodes.bulletList.createChecked({}, content);
            case 'OL':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return schema.nodes.orderedList.createChecked({}, content);
            case 'LI':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const compatibleContent = schema.nodes.listItem.validContent(content) ? content : $5dc2ec50ecaeaa0f$export$c389196451c598e2(content, schema, schema.nodes.listItem);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return schema.nodes.listItem.createChecked({}, compatibleContent);
        }
        // code block
        if ((0, $5Sc2i.isSchemaWithCodeBlock)(schema)) switch(tag){
            case 'DIV':
                if (node.className === 'codeContent panelContent' || node.className.match('preformattedContent')) return null;
                else if (node.className === 'code panel' || node.className === 'preformatted panel') {
                    const pre = node.querySelector('pre');
                    if (!pre) return null;
                    const language = node.className === 'preformatted panel' ? 'plain' : pre.className.split('-')[1];
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    const textContent = (pre.textContent || '').replace(/\r\n/g, '\n');
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return schema.nodes.codeBlock.createChecked({
                        language: language
                    }, textContent ? schema.text(textContent) : undefined);
                }
                break;
            case 'PRE':
                return null;
        }
        if ((0, $5Sc2i.isSchemaWithBlockQuotes)(schema) && tag === 'BLOCKQUOTE') {
            const blockquoteContent = // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            content && content.content.length ? content : schema.nodes.paragraph.createChecked();
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return schema.nodes.blockquote.createChecked({}, blockquoteContent);
        }
        // table
        if ((0, $5Sc2i.isSchemaWithTables)(schema)) switch(tag){
            case 'TABLE':
                return schema.nodes.table.createChecked({}, content);
            case 'TR':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return schema.nodes.tableRow.createChecked({}, content);
            case 'TD':
                const tdContent = schema.nodes.tableCell.validContent(content) ? content : $5dc2ec50ecaeaa0f$export$c389196451c598e2(content, schema);
                return schema.nodes.tableCell.createChecked({}, tdContent);
            case 'TH':
                const thContent = schema.nodes.tableHeader.validContent(content) ? content : $5dc2ec50ecaeaa0f$export$c389196451c598e2(content, schema);
                return schema.nodes.tableHeader.createChecked({}, thContent);
        }
    }
    return;
}
function $5dc2ec50ecaeaa0f$export$6f3da03763fd5ca0(root) {
    const inqueue = [
        root
    ];
    const outqueue = [];
    let elem;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(elem = inqueue.shift()){
        outqueue.push(elem);
        let childIndex;
        for(childIndex = 0; childIndex < elem.childNodes.length; childIndex++){
            const child = elem.childNodes[childIndex];
            switch(child.nodeType){
                case Node.ELEMENT_NODE:
                case Node.TEXT_NODE:
                    inqueue.push(child);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.error(`Not pushing: ${child.nodeType} ${child.nodeName}`);
            }
        }
    }
    outqueue.shift();
    return outqueue;
}
/**
 * Create a fragment by adding a set of marks to each node.
 */ function $5dc2ec50ecaeaa0f$var$addMarks(fragment, marks) {
    let result = fragment;
    for(let i = 0; i < fragment.childCount; i++){
        const child = result.child(i);
        let newChild = child;
        for (const mark of marks)newChild = newChild.mark(mark.addToSet(newChild.marks));
        result = result.replaceChild(i, newChild);
    }
    return result;
}
function $5dc2ec50ecaeaa0f$var$getNodeName(node) {
    return node.nodeName.toUpperCase();
}
function $5dc2ec50ecaeaa0f$var$isMedia(node) {
    if (node && node instanceof HTMLElement) {
        if (node.parentNode && $5dc2ec50ecaeaa0f$var$getNodeName(node.parentNode) === 'P') {
            if ($5dc2ec50ecaeaa0f$var$getNodeName(node) === 'SPAN') return !!node.querySelector('a > jira-attachment-thumbnail > img[data-attachment-type="thumbnail"], a[data-attachment-type="file"]');
        }
    }
    return false;
}
function $5dc2ec50ecaeaa0f$var$isMediaSingle(node) {
    if ($5dc2ec50ecaeaa0f$var$isMedia(node)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dataNode = node.querySelector('[data-media-services-id]');
        if (dataNode instanceof HTMLElement) {
            const width = parseInt(dataNode.getAttribute('data-width') || '', 10);
            const height = parseInt(dataNode.getAttribute('data-height') || '', 10);
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (node.parentNode.classList.contains('mediaSingle') && width && height) return true;
        }
    }
    return false;
}

});
parcelRegister("5Sc2i", function(module, exports) {

$parcel$export(module.exports, "isSchemaWithLists", () => $446b550712d928f4$export$c7b73e631457b93a);
$parcel$export(module.exports, "isSchemaWithMentions", () => $446b550712d928f4$export$9581c5c4f18e364);
$parcel$export(module.exports, "isSchemaWithEmojis", () => $446b550712d928f4$export$85a55ee1ae0815e3);
$parcel$export(module.exports, "isSchemaWithLinks", () => $446b550712d928f4$export$be604d30ea08e34c);
$parcel$export(module.exports, "isSchemaWithAdvancedTextFormattingMarks", () => $446b550712d928f4$export$6b152f895f3f2d6a);
$parcel$export(module.exports, "isSchemaWithSubSupMark", () => $446b550712d928f4$export$b7fbc21a18ab46d0);
$parcel$export(module.exports, "isSchemaWithCodeBlock", () => $446b550712d928f4$export$24f23e2680c2f593);
$parcel$export(module.exports, "isSchemaWithBlockQuotes", () => $446b550712d928f4$export$2761b627be3a2c10);
$parcel$export(module.exports, "isSchemaWithMedia", () => $446b550712d928f4$export$fce37e3087e971dd);
$parcel$export(module.exports, "isSchemaWithTextColor", () => $446b550712d928f4$export$6bc3d8bd3aad229);
$parcel$export(module.exports, "isSchemaWithTables", () => $446b550712d928f4$export$fff0e9b2ccefb752);

var $kBho7 = parcelRequire("kBho7");
function $446b550712d928f4$export$2e2bcd8739ae039(config) {
    const nodes = [
        'doc',
        'paragraph',
        'text',
        'hardBreak',
        'heading',
        'rule'
    ];
    const marks = [
        'strong',
        'em',
        'underline',
        'typeAheadQuery',
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ];
    if (config.allowLinks) marks.push('link');
    if (config.allowLists) nodes.push('orderedList', 'bulletList', 'listItem');
    if (config.allowMentions) {
        nodes.push('mention');
        marks.push('mentionQuery');
    }
    if (config.allowEmojis) nodes.push('emoji');
    if (config.allowAdvancedTextFormatting) marks.push('strike', 'code');
    if (config.allowSubSup) marks.push('subsup');
    if (config.allowCodeBlock) nodes.push('codeBlock');
    if (config.allowBlockQuote) nodes.push('blockquote');
    if (config.allowMedia) nodes.push('mediaGroup', 'mediaSingle', 'media', 'caption', 'mediaInline');
    if (config.allowTextColor) marks.push('textColor');
    if (config.allowTables) nodes.push('table', 'tableCell', 'tableHeader', 'tableRow');
    return (0, $kBho7.createSchema)({
        nodes: nodes,
        marks: marks
    });
}
function $446b550712d928f4$export$c7b73e631457b93a(schema) {
    return !!schema.nodes.bulletList;
}
function $446b550712d928f4$export$9581c5c4f18e364(schema) {
    return !!schema.nodes.mention;
}
function $446b550712d928f4$export$85a55ee1ae0815e3(schema) {
    return !!schema.nodes.emoji;
}
function $446b550712d928f4$export$be604d30ea08e34c(schema) {
    return !!schema.marks.link;
}
function $446b550712d928f4$export$6b152f895f3f2d6a(schema) {
    return !!schema.marks.code && !!schema.marks.strike;
}
function $446b550712d928f4$export$b7fbc21a18ab46d0(schema) {
    return !!schema.marks.subsup;
}
function $446b550712d928f4$export$24f23e2680c2f593(schema) {
    return !!schema.nodes.codeBlock;
}
function $446b550712d928f4$export$2761b627be3a2c10(schema) {
    return !!schema.nodes.blockquote;
}
function $446b550712d928f4$export$fce37e3087e971dd(schema) {
    return !!schema.nodes.mediaGroup && !!schema.nodes.media && !!schema.nodes.mediaInline;
}
function $446b550712d928f4$export$6bc3d8bd3aad229(schema) {
    return !!schema.marks.textColor;
}
function $446b550712d928f4$export$fff0e9b2ccefb752(schema) {
    return !!schema.nodes.table && !!schema.nodes.tableCell && !!schema.nodes.tableHeader && !!schema.nodes.tableRow;
}

});

parcelRegister("jAjrm", function(module, exports) {

$parcel$export(module.exports, "mapImageToEmoji", () => $e621ab5b696aebe6$export$f0d20a903b124435);
const $e621ab5b696aebe6$var$emojiMap = {
    'smile.png': "\uD83D\uDE42",
    'sad.png': "\u2639\uFE0F",
    'tongue.png': "\uD83D\uDE1B",
    'biggrin.png': "\uD83D\uDE01",
    'wink.png': "\uD83D\uDE09",
    'thumbs_up.png': "\uD83D\uDC4D",
    'thumbs_down.png': "\uD83D\uDC4E",
    'information.png': "\u2139\uFE0F",
    'check.png': "\u2705",
    'error.png': "\u274C",
    'warning.png': "\u26A0\uFE0F",
    'add.png': "\u2795",
    'forbidden.png': "\u2796",
    'help_16.png': "\u2753",
    'lightbulb_on.png': "\uD83D\uDCA1",
    'lightbulb.png': "\u26D4\uFE0F",
    'star_yellow.png': "\uD83D\uDC9B",
    'star_red.png': "\u2764\uFE0F",
    'star_green.png': "\uD83D\uDC9A",
    'star_blue.png': "\uD83D\uDC99",
    'flag.png': "\uD83D\uDEA9",
    'flag_gray.png': "\uD83C\uDFF3"
};
function $e621ab5b696aebe6$export$f0d20a903b124435(imageElement) {
    let src = imageElement.src;
    const slashIndex = src.lastIndexOf('/');
    src = src.substr(slashIndex + 1);
    return $e621ab5b696aebe6$var$emojiMap[src] || null;
}

});




parcelRegister("31xp0", function(module, exports) {

$parcel$export(module.exports, "rendererEventHandlers", () => $233b601bde61bd9c$export$7099af1d0eb30f39);
const $233b601bde61bd9c$export$7099af1d0eb30f39 = {
    link: {
        onClick: (event, url)=>{
            // Intercept link event and open in another window stripping any opener or referrer info
            event.preventDefault();
            window.open(url, '_blank', 'noopener noreferrer');
        }
    }
};

});

parcelRegister("a9AOh", function(module, exports) {

$parcel$export(module.exports, "RenderQuestion", () => $76474c573330a931$export$d8f386356b080eb1);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $cGltd = parcelRequire("cGltd");
var $cUUCJ = parcelRequire("cUUCJ");

var $aUcIH = parcelRequire("aUcIH");

var $d9Coz = parcelRequire("d9Coz");

var $bEQ2i = parcelRequire("bEQ2i");

var $6lxfx = parcelRequire("6lxfx");

var $9JaSd = parcelRequire("9JaSd");

var $cU8Qs = parcelRequire("cU8Qs");

var $gs4em = parcelRequire("gs4em");

var $4OnBQ = parcelRequire("4OnBQ");

var $d6RcY = parcelRequire("d6RcY");

var $hBksn = parcelRequire("hBksn");

var $bQ3UU = parcelRequire("bQ3UU");

var $8iale = parcelRequire("8iale");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76474c573330a931$var$LinkedFieldIconWrapper = (0, $dAHxw.default).span({
    marginLeft: "var(--ds-space-050, 4px)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76474c573330a931$var$QuestionLabelWrapper = (0, $dAHxw.default).span({
    display: 'flex'
});
const $76474c573330a931$export$d8f386356b080eb1 = (0, $jJXgM.observer)(({ QuestionRenderer: QuestionRenderer, questionTypeRendererMap: questionTypeRendererMap, questionStore: questionStore, displayMode: displayMode, formStore: formStore, blockFormSubmission: blockFormSubmission, linkedFieldNames: linkedFieldNames })=>{
    var _questionTypeRenderer;
    const intl = (0, $koVbs.default)();
    const { formQuestion: formQuestion, id: questionId, issueFieldData: issueFieldData, revisionToken: revisionToken, validationErrors: validationErrors } = questionStore;
    const fieldId = `pf-${formStore.formId}-${formQuestion.type}-${questionId}`;
    const formSaveQuestionError = (0, $bEQ2i.useFormSaveQuestionError)(questionId);
    const questionProps = {
        questionStore: questionStore,
        formStore: formStore,
        displayMode: displayMode,
        id: fieldId,
        revisionToken: revisionToken,
        blockFormSubmission: blockFormSubmission
    };
    const QuestionTypeRenderer = (_questionTypeRenderer = questionTypeRendererMap === null || questionTypeRendererMap === void 0 ? void 0 : questionTypeRendererMap[formQuestion.type]) !== null && _questionTypeRenderer !== void 0 ? _questionTypeRenderer : (0, $gs4em.defaultQuestionTypeRendererMap)[formQuestion.type];
    const questionComponent = QuestionTypeRenderer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(QuestionTypeRenderer, questionProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bQ3UU.UnknownQuestionType), {
        questionType: formQuestion.type
    });
    let allQuestionErrors = [];
    if (displayMode === (0, $8iale.DisplayMode).Edit) allQuestionErrors = [
        ...validationErrors ? validationErrors : [],
        ...formSaveQuestionError ? [
            {
                key: (0, $6lxfx.ValidationErrorMsg).FormSave,
                message: formSaveQuestionError
            }
        ] : []
    ];
    let warningMessage;
    switch(issueFieldData === null || issueFieldData === void 0 ? void 0 : issueFieldData.readOnlyReason){
        case (0, $d9Coz.ReadOnlyReason).Anonymous:
            warningMessage = (0, $cU8Qs.messages).readOnlyReasonAnonymousMessage;
            break;
        case (0, $d9Coz.ReadOnlyReason).Unlicensed:
            warningMessage = (0, $cU8Qs.messages).readOnlyReasonUnlicensedMessage;
            break;
        default:
    }
    return QuestionRenderer !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(QuestionRenderer, {
        questionId: questionId.toString(),
        fieldId: fieldId,
        formQuestion: formQuestion,
        questionComponent: questionComponent
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.LabelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cGltd.Label), {
        htmlFor: fieldId,
        id: `label-${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76474c573330a931$var$QuestionLabelWrapper, null, formQuestion.label, formQuestion.validation.rq && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUUCJ.default), null), formQuestion.jiraField && linkedFieldNames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76474c573330a931$var$LinkedFieldIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JaSd.LinkedFieldIcon), {
        fieldName: linkedFieldNames === null || linkedFieldNames === void 0 ? void 0 : linkedFieldNames.get(formQuestion.jiraField)
    })))), warningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUcIH.default), {
        appearance: "connectivity",
        iconLabel: intl.formatMessage(warningMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), warningMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6RcY.QuestionHelperMsg), {
        description: formQuestion.description
    }), questionComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4OnBQ.QuestionErrorMsg), {
        validationErrors: allQuestionErrors.length === 0 ? undefined : allQuestionErrors
    }));
});

});
parcelRegister("d9Coz", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyReason", () => $9939e625595b280c$export$3981c7d6e6518dac);
let $9939e625595b280c$export$3981c7d6e6518dac = /*#__PURE__*/ function(ReadOnlyReason) {
    ReadOnlyReason["Anonymous"] = "anonymous";
    ReadOnlyReason["Unlicensed"] = "unlicensed";
    return ReadOnlyReason;
}({});

});

parcelRegister("9JaSd", function(module, exports) {

$parcel$export(module.exports, "LinkedFieldIcon", () => $7150c044d49bfc58$export$e3615186b8ead0ae);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");


var $9hW6e = parcelRequire("9hW6e");

var $4l9BM = parcelRequire("4l9BM");

var $fHpHg = parcelRequire("fHpHg");

var $5KCCi = parcelRequire("5KCCi");

var $ljThx = parcelRequire("ljThx");
const $7150c044d49bfc58$export$e3615186b8ead0ae = ({ fieldName: fieldName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = fieldName ? formatMessage((0, $ljThx.messages).tooltip, {
        fieldName: fieldName
    }) : formatMessage((0, $ljThx.messages).unknownField);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        position: "top",
        content: message
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, (0, $fHpHg.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9hW6e.default), {
            size: "16",
            label: '',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4l9BM))),
            appearance: "grayBold",
            shape: "circle"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4l9BM))), {
            color: "currentColor",
            LEGACY_size: "small",
            label: "Linked field"
        })));
};

});
parcelRegister("ljThx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f856412023fabe65$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f856412023fabe65$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tooltip: {
        id: 'proforma-form-builder.src.components.questiontypes.linked-field-icon.tooltip',
        defaultMessage: "Linked to \u2018{fieldName}\u2018 Jira field",
        description: 'Text for a tooltip indicating the form field is linked to a Jira field.'
    },
    unknownField: {
        id: 'proforma-form-builder.src.components.questiontypes.linked-field-icon.unknown-field',
        defaultMessage: 'Linked to Jira field',
        description: 'Text for a tooltip indicating the form field is linked to an unknown Jira field.'
    }
});

});


parcelRegister("cU8Qs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9651937404364adf$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9651937404364adf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    readOnlyReasonAnonymousMessage: {
        id: 'form-system.renderQuestion.read-only-reason-anonymous-message',
        defaultMessage: 'Log in with a valid account to access this field.',
        description: 'The question is read only because the user is anonymous message to display when mousing over an icon.'
    },
    readOnlyReasonUnlicensedMessage: {
        id: 'form-system.renderQuestion.read-only-reason-unlicensed-message',
        defaultMessage: 'This field is only available to users with Jira access.',
        description: 'The question is read only because the user does not have a Jira license message to display when mousing over an icon.'
    },
    emptyFormName: {
        id: 'form-system.headerBar.emptyFormName',
        defaultMessage: 'Untitled Form',
        description: 'A placeholder for a form with an empty name.'
    }
});

});

parcelRegister("gs4em", function(module, exports) {

$parcel$export(module.exports, "defaultQuestionTypeRendererMap", () => $bfa28af6ffba73d5$export$75e3472ea9146861);

var $4aJmI = parcelRequire("4aJmI");

var $50MJJ = parcelRequire("50MJJ");

var $ey2nO = parcelRequire("ey2nO");

var $aBenK = parcelRequire("aBenK");

var $cGJ7q = parcelRequire("cGJ7q");

var $bchDp = parcelRequire("bchDp");

var $dCF6m = parcelRequire("dCF6m");

var $jLknN = parcelRequire("jLknN");

var $6r1D6 = parcelRequire("6r1D6");

var $bVxQm = parcelRequire("bVxQm");

var $gqc26 = parcelRequire("gqc26");

var $isuZ1 = parcelRequire("isuZ1");

var $aZCPa = parcelRequire("aZCPa");

var $erYCV = parcelRequire("erYCV");

var $f1Hmw = parcelRequire("f1Hmw");

var $bfOs9 = parcelRequire("bfOs9");

var $fGwwO = parcelRequire("fGwwO");

var $gyvX2 = parcelRequire("gyvX2");
const $bfa28af6ffba73d5$export$75e3472ea9146861 = {
    [(0, $4aJmI.FormQuestionType).TextShort]: (0, $erYCV.ShortText),
    [(0, $4aJmI.FormQuestionType).TextLong]: (0, $6r1D6.LongText),
    [(0, $4aJmI.FormQuestionType).TextEmail]: (0, $6r1D6.LongText),
    [(0, $4aJmI.FormQuestionType).TextUrl]: (0, $fGwwO.UrlText),
    [(0, $4aJmI.FormQuestionType).TextParagraph]: (0, $isuZ1.Paragraph),
    [(0, $4aJmI.FormQuestionType).RichTextParagraph]: (0, $aZCPa.RichTextParagraph),
    [(0, $4aJmI.FormQuestionType).Number]: (0, $gqc26.Number),
    [(0, $4aJmI.FormQuestionType).DateTime]: (0, $bchDp.DateTime),
    [(0, $4aJmI.FormQuestionType).Date]: (0, $cGJ7q.Date),
    [(0, $4aJmI.FormQuestionType).Time]: (0, $bfOs9.Time),
    [(0, $4aJmI.FormQuestionType).ChoiceCascading]: (0, $ey2nO.CascadingDropdown),
    [(0, $4aJmI.FormQuestionType).ChoiceSingle]: (0, $f1Hmw.SingleChoice),
    [(0, $4aJmI.FormQuestionType).ChoiceMultiple]: (0, $bVxQm.MultiChoice),
    [(0, $4aJmI.FormQuestionType).ChoiceDropdown]: (0, $dCF6m.Dropdown),
    [(0, $4aJmI.FormQuestionType).ChoiceDropdownMultiple]: (0, $jLknN.DropdownMultiselect),
    [(0, $4aJmI.FormQuestionType).UserSingle]: (0, $gyvX2.UserPicker),
    [(0, $4aJmI.FormQuestionType).UserMultiple]: (0, $gyvX2.UserPicker),
    [(0, $4aJmI.FormQuestionType).Attachment]: (0, $50MJJ.AttachmentAsync),
    [(0, $4aJmI.FormQuestionType).CmdbObject]: (0, $aBenK.CmdbDropdown)
};

});
parcelRegister("50MJJ", function(module, exports) {

$parcel$export(module.exports, "AttachmentAsync", () => $3a62c1f01fa2540a$export$43936e8d08b9b853);

var $5uXOq = parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $clxo5 = parcelRequire("clxo5");

const $3a62c1f01fa2540a$export$43936e8d08b9b853 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("c3uWY")).then((mod)=>mod.Attachment),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), null)
});

});
parcelRegister("c3uWY", function(module, exports) {

let $8c6dc5ee98c5caa6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8c6dc5ee98c5caa6$var$load("7mb2K").then(()=>parcelRequire('5UDXB'));

});


parcelRegister("ey2nO", function(module, exports) {

$parcel$export(module.exports, "CascadingDropdown", () => $a97616e10eb11575$export$24252a0c62dc3678);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $9BlW6 = parcelRequire("9BlW6");

var $6lRsX = parcelRequire("6lRsX");
const $a97616e10eb11575$export$24252a0c62dc3678 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
    var _questionStore$issueF;
    const currentAnswer = (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
    const availableParentOptions = questionStore.availableOptions();
    const currentParentOption = availableParentOptions.find((option)=>{
        var _currentAnswer$choice, _currentAnswer$choice2;
        return option.value === (currentAnswer === null || currentAnswer === void 0 ? void 0 : (_currentAnswer$choice = currentAnswer.choices) === null || _currentAnswer$choice === void 0 ? void 0 : (_currentAnswer$choice2 = _currentAnswer$choice[0]) === null || _currentAnswer$choice2 === void 0 ? void 0 : _currentAnswer$choice2.split(':')[0]);
    });
    const availableChildOptions = currentParentOption === null || currentParentOption === void 0 ? void 0 : currentParentOption.children;
    const currentChildOption = availableChildOptions === null || availableChildOptions === void 0 ? void 0 : availableChildOptions.find((option)=>{
        var _currentAnswer$choice3;
        return option.value === (currentAnswer === null || currentAnswer === void 0 ? void 0 : (_currentAnswer$choice3 = currentAnswer.choices) === null || _currentAnswer$choice3 === void 0 ? void 0 : _currentAnswer$choice3[0].split(':')[1]);
    });
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
        const onChange = (value)=>{
            const selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
            const newChoiceIds = selectedChoiceId ? [
                selectedChoiceId
            ] : [];
            questionStore.setAnswer({
                choices: newChoiceIds
            });
        };
        const onChangeChild = (value)=>{
            const selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
            const newChoiceIds = selectedChoiceId ? [
                `${currentParentOption === null || currentParentOption === void 0 ? void 0 : currentParentOption.value}:${selectedChoiceId}`
            ] : [];
            questionStore.setAnswer({
                choices: newChoiceIds
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9BlW6.EditCascadingDropdown), {
            id: id,
            key: `${id}-${questionStore.dependentFieldChangedCount}`,
            options: availableParentOptions,
            value: currentParentOption,
            childOptions: availableChildOptions,
            childValue: currentChildOption,
            loading: questionStore.loading,
            onChange: onChange,
            onChangeChild: onChangeChild,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lRsX.ViewCascadingDropdown), {
        id: id,
        value: currentParentOption,
        childValue: currentChildOption,
        displayMode: displayMode
    });
});

});
parcelRegister("9BlW6", function(module, exports) {

$parcel$export(module.exports, "EditCascadingDropdown", () => $6fd895cdf831d555$export$c12cc085d12a21d6);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $lau8t = parcelRequire("lau8t");

var $4dI0P = parcelRequire("4dI0P");

var $lsVZ9 = parcelRequire("lsVZ9");
const $6fd895cdf831d555$var$containerStyles = (0, $2s57o.xcss)({
    display: 'flex',
    flexDirection: 'row'
});
const $6fd895cdf831d555$var$parentStyles = (0, $2s57o.xcss)({
    width: '50%',
    marginRight: 'space.100'
});
const $6fd895cdf831d555$var$childStyles = (0, $2s57o.xcss)({
    width: '50%'
});
const $6fd895cdf831d555$export$c12cc085d12a21d6 = ({ id: id, options: options, value: value, childOptions: childOptions, childValue: childValue, loading: loading, onChange: onChange, onChangeChild: onChangeChild, isRequired: isRequired, label: label })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $6fd895cdf831d555$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $6fd895cdf831d555$var$parentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6fd895cdf831d555$var$EditDropdown, {
        id: id,
        options: options,
        value: value !== null && value !== void 0 ? value : null,
        loading: loading,
        onChange: onChange,
        clearable: true,
        isRequired: isRequired,
        label: label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $6fd895cdf831d555$var$childStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6fd895cdf831d555$var$EditDropdown, {
        id: `${id}-child`,
        options: childOptions,
        value: childValue !== null && childValue !== void 0 ? childValue : null,
        loading: loading,
        onChange: onChangeChild,
        isRequired: isRequired,
        label: label
    })));
};
const $6fd895cdf831d555$var$EditDropdown = ({ id: id, options: options, value: value, loading: loading, onChange: onChange, clearable: clearable = false, label: label })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), (0, $bS32t.default)({
        id: id,
        key: id,
        options: options,
        value: value !== null && value !== void 0 ? value : null,
        isLoading: loading,
        onChange: onChange,
        isSearchable: true,
        isClearable: clearable,
        noOptionsMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $lsVZ9.messages).choiceDropdownNoOptions),
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $lsVZ9.messages).choiceDropdownSelect)
    }, (0, $4dI0P.getDropDownMenuPosition)(), {
        label: label
    }));
};

});
parcelRegister("4dI0P", function(module, exports) {

$parcel$export(module.exports, "getDropDownMenuPosition", () => $312a84430896a8a0$export$cc1c1d9e6b32e7b2);

var $dpaDt = parcelRequire("dpaDt");
const $312a84430896a8a0$export$cc1c1d9e6b32e7b2 = ()=>(0, $dpaDt.isIPhone)() || (0, $dpaDt.isIPad)() ? // This is to prevent menu floating away due to virtual keyboard in iPad and iPhone
    {
        menuPosition: 'absolute'
    } : // This is to prevent long menus getting cut off in portal
    {
        menuPosition: 'fixed'
    };

});
parcelRegister("dpaDt", function(module, exports) {

$parcel$export(module.exports, "isMobile", () => $9c25dc32dcb71a15$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "isIPhone", () => $9c25dc32dcb71a15$export$186c6964ca17d99);
$parcel$export(module.exports, "isIPad", () => $9c25dc32dcb71a15$export$7bef049ce92e4224);

var $cyHbi = parcelRequire("cyHbi");
// User agent checking code was copied from JFE
const $9c25dc32dcb71a15$var$DESKTOP_SWITCH_COOKIE_KEY = 'jira.mobile.desktop.switch';
const $9c25dc32dcb71a15$var$ANDROID_CHROME_USER_AGENT = /Chrome\/[.\d]* Mobile/;
const $9c25dc32dcb71a15$var$OLD_ANDROID_USER_AGENT = /Linux;(?: U;)? Android (?:[23]\.\d|4\.0\.[12])/;
const $9c25dc32dcb71a15$var$MOBILE_USER_AGENT = /(iPhone;|iPhone Simulator;|iPad;|iPod;|iPod touch;|Linux;(?: U;)? Android)/;
const $9c25dc32dcb71a15$var$IPHONE_USER_AGENT = /(iPhone;|iPhone Simulator;|iPod;|iPod touch;)/;
const $9c25dc32dcb71a15$var$IPAD_USER_AGENT = /iPad;/;
const $9c25dc32dcb71a15$var$isSupportedUserAgent = ()=>{
    var _navigator, _navigator$userAgent;
    if (!((_navigator = navigator) !== null && _navigator !== void 0 && (_navigator$userAgent = _navigator.userAgent) !== null && _navigator$userAgent !== void 0 && _navigator$userAgent.length)) return false;
    return $9c25dc32dcb71a15$var$ANDROID_CHROME_USER_AGENT.test(navigator.userAgent) || $9c25dc32dcb71a15$var$MOBILE_USER_AGENT.test(navigator.userAgent) && !$9c25dc32dcb71a15$var$OLD_ANDROID_USER_AGENT.test(navigator.userAgent);
};
const $9c25dc32dcb71a15$var$isDesktopSwitchEnabled = ()=>(0, $cyHbi.getCookie)($9c25dc32dcb71a15$var$DESKTOP_SWITCH_COOKIE_KEY) === 'true';
function $9c25dc32dcb71a15$export$d0a8044dce8ff2fc() {
    return $9c25dc32dcb71a15$var$isSupportedUserAgent() && !$9c25dc32dcb71a15$var$isDesktopSwitchEnabled();
}
function $9c25dc32dcb71a15$export$186c6964ca17d99() {
    var _navigator2, _navigator2$userAgent;
    if (!((_navigator2 = navigator) !== null && _navigator2 !== void 0 && (_navigator2$userAgent = _navigator2.userAgent) !== null && _navigator2$userAgent !== void 0 && _navigator2$userAgent.length)) return false;
    return $9c25dc32dcb71a15$var$IPHONE_USER_AGENT.test(navigator.userAgent);
}
function $9c25dc32dcb71a15$export$7bef049ce92e4224() {
    var _navigator3, _navigator3$userAgent, _navigator4, _navigator4$platform;
    if (!navigator || !((_navigator3 = navigator) !== null && _navigator3 !== void 0 && (_navigator3$userAgent = _navigator3.userAgent) !== null && _navigator3$userAgent !== void 0 && _navigator3$userAgent.length) || !((_navigator4 = navigator) !== null && _navigator4 !== void 0 && (_navigator4$platform = _navigator4.platform) !== null && _navigator4$platform !== void 0 && _navigator4$platform.length)) return false;
    const { userAgent: userAgent, platform: platform, maxTouchPoints: maxTouchPoints } = navigator;
    // Check for iPad using user agent
    const isIPadUserGgent = $9c25dc32dcb71a15$var$IPAD_USER_AGENT.test(userAgent);
    // Check for iPad in desktop mode (iOS 13+)
    const isIPadDesktop = platform === 'MacIntel' && maxTouchPoints > 1;
    return isIPadUserGgent || isIPadDesktop;
}

});


parcelRegister("lsVZ9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fa09312fcc50755c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $fa09312fcc50755c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    choiceDropdownSelect: {
        id: 'proforma-common-core.form-system.components.questions.cascading-dropdown.edit.choice-dropdown-select',
        defaultMessage: 'Select...',
        description: 'Placeholder text in dropdown waiting for the user to select something.'
    },
    choiceDropdownNoOptions: {
        id: 'proforma-common-core.form-system.components.questions.cascading-dropdown.edit.choice-dropdown-no-options',
        defaultMessage: 'No options',
        description: 'Placeholder text in dropdown when there are no options.'
    }
});

});


parcelRegister("6lRsX", function(module, exports) {

$parcel$export(module.exports, "ViewCascadingDropdown", () => $49fe2d7f303ab78a$export$3527cac9cc6cb5cd);

var $5uXOq = parcelRequire("5uXOq");

var $51H8P = parcelRequire("51H8P");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $lau8t = parcelRequire("lau8t");

var $8iale = parcelRequire("8iale");

var $hBksn = parcelRequire("hBksn");
const $49fe2d7f303ab78a$var$styles = {
    control: (base)=>({
            ...base,
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${0, $51H8P.N20})`,
            borderColor: "var(--ds-border-disabled, #DFE1E6)",
            color: "var(--ds-text, #172B4D !important)"
        }),
    menu: (base)=>({
            ...base,
            color: "var(--ds-text, #172B4D)"
        })
};
const $49fe2d7f303ab78a$var$containerStyles = (0, $2s57o.xcss)({
    display: 'flex',
    flexDirection: 'row'
});
const $49fe2d7f303ab78a$var$parentStyles = (0, $2s57o.xcss)({
    width: '50%',
    marginRight: 'space.100'
});
const $49fe2d7f303ab78a$var$childStyles = (0, $2s57o.xcss)({
    width: '50%'
});
const $49fe2d7f303ab78a$export$3527cac9cc6cb5cd = ({ id: id, value: value, childValue: childValue, displayMode: displayMode })=>{
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) // The Select displays as disabled in these modes
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $49fe2d7f303ab78a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $49fe2d7f303ab78a$var$parentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), {
        id: id,
        value: value,
        placeholder: "",
        isDisabled: true,
        styles: $49fe2d7f303ab78a$var$styles
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $49fe2d7f303ab78a$var$childStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), {
        id: id,
        value: childValue,
        placeholder: "",
        isDisabled: true,
        styles: $49fe2d7f303ab78a$var$styles
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, value ? `${value.label}` + (childValue ? ` - ${childValue.label}` : '') : '');
};

});
parcelRegister("hBksn", function(module, exports) {

$parcel$export(module.exports, "invalidFieldContainerStyles", () => $cd05c2a10b87a591$export$4775851963af2f92);
$parcel$export(module.exports, "FieldDisabledWrapper", () => $cd05c2a10b87a591$export$d4e6edaaff357b7c);
$parcel$export(module.exports, "ChoiceFieldWrapper", () => $cd05c2a10b87a591$export$40ba0da6d283da29);
$parcel$export(module.exports, "TextfieldDisabledWrapper", () => $cd05c2a10b87a591$export$500b62c17cc006cd);
$parcel$export(module.exports, "ShortTextFieldWrapper", () => $cd05c2a10b87a591$export$9eab2966dbf9c8a);
$parcel$export(module.exports, "ChoicePlaceholder", () => $cd05c2a10b87a591$export$235f6b91c45162a2);
$parcel$export(module.exports, "LabelWrapper", () => $cd05c2a10b87a591$export$147422f7450ccfac);
$parcel$export(module.exports, "ErrorWrapper", () => $cd05c2a10b87a591$export$bb27b7e39840238f);
$parcel$export(module.exports, "SelectErrorContainer", () => $cd05c2a10b87a591$export$29ae8e181f8cf4c6);
$parcel$export(module.exports, "ShortFieldWrapper", () => $cd05c2a10b87a591$export$be1670a66b7ea819);
$parcel$export(module.exports, "ViewWrapper", () => $cd05c2a10b87a591$export$895814aa5a1cf38c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dAHxw = parcelRequire("dAHxw");

const $cd05c2a10b87a591$var$textFieldDisabledStyles = `
  min-height: 36px;
  border-style: solid;
  border-color: ${"var(--ds-border-disabled, #DFE1E6)"};
  border-radius: 3px;
  border-width: 2px;
  background-color: ${`var(--ds-background-accent-gray-subtlest, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`};
  cursor: default;
  color: ${`var(--ds-text-disabled, ${(0, $a7f8c6b391092279$export$5f71e19f3a7ad9de)})`};

  > div {
    padding: 8px 6px;
    line-height: normal
  }
`;
const $cd05c2a10b87a591$var$choiceDisabledStyles = `
  > div {
    border-style: none;
    border-color: ${"var(--ds-border-disabled, #DFE1E6)"};
    border-radius: 3px;
    border-width: 2px;
    background-color: none;
    cursor: default;
    pointer-events: none;
  }
`;
const $cd05c2a10b87a591$var$choiceInvalidStyles = `
  > div {
    border-style: none;
    border-color: ${"var(--ds-border-danger, #FF5630;)"}
    border-radius: 3px;
    border-width: 2px;
    cursor: default;
  }
`;
const $cd05c2a10b87a591$var$choiceViewStyles = `
  span {
    color: ${`var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`};
  }
`;
const $cd05c2a10b87a591$export$4775851963af2f92 = `
  border-style: solid;
  border-color: ${`var(--ds-border-danger, ${(0, $a7f8c6b391092279$export$2010d0fb4295b346)})`};
  border-radius: 3px;
  border-width: 2px;
  cursor: default;
`;
const $cd05c2a10b87a591$export$d4e6edaaff357b7c = (0, $dAHxw.default).div({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> div': {
        borderStyle: 'solid',
        borderColor: "var(--ds-border-disabled, #DFE1E6)",
        borderRadius: 3,
        borderWidth: 2,
        backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`,
        cursor: 'default',
        pointerEvents: 'none',
        color: `var(--ds-text-disabled, ${(0, $a7f8c6b391092279$export$5f71e19f3a7ad9de)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '*': {
        color: "var(--ds-text, #172B4D !important)",
        cursor: 'default'
    }
});
const $cd05c2a10b87a591$export$40ba0da6d283da29 = (0, $dAHxw.default)('div')(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled && $cd05c2a10b87a591$var$choiceDisabledStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isInvalid && $cd05c2a10b87a591$var$choiceInvalidStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isView && $cd05c2a10b87a591$var$choiceViewStyles);
const $cd05c2a10b87a591$export$500b62c17cc006cd = (0, $dAHxw.default).div($cd05c2a10b87a591$var$textFieldDisabledStyles);
const $cd05c2a10b87a591$export$9eab2966dbf9c8a = (0, $dAHxw.default)('div')({
    maxWidth: '240px'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled && $cd05c2a10b87a591$var$textFieldDisabledStyles);
const $cd05c2a10b87a591$export$235f6b91c45162a2 = (0, $dAHxw.default).div({
    margin: "var(--ds-space-500, 40px)"
});
const $cd05c2a10b87a591$export$147422f7450ccfac = (0, $dAHxw.default).div({
    display: 'flex'
});
const $cd05c2a10b87a591$export$bb27b7e39840238f = (0, $dAHxw.default).div({
    height: '16px',
    marginTop: "var(--ds-space-050, 4px)"
});
const $cd05c2a10b87a591$export$29ae8e181f8cf4c6 = (0, $dAHxw.default).div(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isInvalid && $cd05c2a10b87a591$export$4775851963af2f92);
const $cd05c2a10b87a591$export$be1670a66b7ea819 = (0, $dAHxw.default).div({
    maxWidth: '160px'
});
const $cd05c2a10b87a591$export$895814aa5a1cf38c = (0, $dAHxw.default).div({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`
});

});



parcelRegister("aBenK", function(module, exports) {

$parcel$export(module.exports, "CmdbDropdown", () => $7b788407fa8d1282$export$e96bc7c6676f4fad);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $4QmvR = parcelRequire("4QmvR");

var $dCF6m = parcelRequire("dCF6m");

var $jLknN = parcelRequire("jLknN");

var $8WT1f = parcelRequire("8WT1f");
const $7b788407fa8d1282$export$e96bc7c6676f4fad = (questionProps)=>{
    var _questionStore$issueF;
    const { questionStore: questionStore } = questionProps;
    const shouldRenderMultiple = ((_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 ? void 0 : _questionStore$issueF.multiple) !== false;
    const hasMultipleAnswers = (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.answer).choices.length > 1;
    if (shouldRenderMultiple || hasMultipleAnswers) {
        const customComponentsMultiselect = {
            Option: (props)=>{
                var _questionStore$issueF2, _questionStore$issueF3;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WT1f.EditDropdownOption), (0, $bS32t.default)({}, props, {
                    filterAttributes: (_questionStore$issueF2 = (_questionStore$issueF3 = questionStore.issueFieldData) === null || _questionStore$issueF3 === void 0 ? void 0 : _questionStore$issueF3.attributes) !== null && _questionStore$issueF2 !== void 0 ? _questionStore$issueF2 : []
                }));
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jLknN.DropdownMultiselect), (0, $bS32t.default)({}, questionProps, {
            customComponents: (0, $fHpHg.fg)('proforma_asset_fields_show_selected_attributes') ? customComponentsMultiselect : undefined
        }));
    } else {
        const customComponents = {
            Option: (props)=>{
                var _questionStore$issueF4, _questionStore$issueF5;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WT1f.EditDropdownOption), (0, $bS32t.default)({}, props, {
                    filterAttributes: (_questionStore$issueF4 = (_questionStore$issueF5 = questionStore.issueFieldData) === null || _questionStore$issueF5 === void 0 ? void 0 : _questionStore$issueF5.attributes) !== null && _questionStore$issueF4 !== void 0 ? _questionStore$issueF4 : []
                }));
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dCF6m.Dropdown), (0, $bS32t.default)({}, questionProps, {
            customComponents: (0, $fHpHg.fg)('proforma_asset_fields_show_selected_attributes') ? customComponents : undefined
        }));
    }
};

});
parcelRegister("dCF6m", function(module, exports) {

$parcel$export(module.exports, "Dropdown", () => $9eaeb4df1c5c07fb$export$931cbfb6bfb85fc);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $cnwtr = parcelRequire("cnwtr");

var $kH8LN = parcelRequire("kH8LN");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $fORQz = parcelRequire("fORQz");

var $diuGR = parcelRequire("diuGR");
const $9eaeb4df1c5c07fb$export$931cbfb6bfb85fc = (0, $jJXgM.observer)((props)=>{
    var _questionStore$issueF;
    const { id: id, questionStore: questionStore, formStore: formStore, displayMode: displayMode, customComponents: customComponents } = props;
    const availableOptions = questionStore.availableOptions();
    const currentAnswer = (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
    const currentOption = questionStore.getAnswerChoicesAsObjects()[0];
    const currentChoiceId = currentOption === null || currentOption === void 0 ? void 0 : currentOption.value;
    const hasOtherChoice = !!questionStore.otherChoiceId;
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
        const onChange = (value)=>{
            const selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
            const newChoiceIds = selectedChoiceId ? [
                selectedChoiceId
            ] : [];
            questionStore.setAnswer({
                text: hasOtherChoice && selectedChoiceId === questionStore.otherChoiceId ? (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).text : '',
                choices: newChoiceIds,
                choiceObjects: value ? [
                    (0, $4QmvR.QuestionStore).optionToChoice(value)
                ] : []
            });
        };
        const otherChoiceSelected = hasOtherChoice && currentChoiceId === questionStore.otherChoiceId;
        const loadChoicesAsync = questionStore.isAsyncChoicesField ? (0, $cnwtr.debounce)((inputValue, callback)=>{
            formStore.loadChoicesAsync(questionStore.id, inputValue).then((_)=>callback(questionStore.choices.map((0, $kH8LN.toSelectOption))));
        }, 500) : undefined;
        const onOtherChoiceTextChange = (event)=>{
            questionStore.setAnswer({
                text: event.target.value,
                choices: (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).choices
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fORQz.EditDropdown), {
            id: id,
            key: `${id}-${questionStore.dependentFieldChangedCount}`,
            options: availableOptions,
            value: currentOption,
            loading: questionStore.loading,
            loadOptions: loadChoicesAsync,
            onChange: onChange,
            hasOtherOption: hasOtherChoice,
            otherOptionSelected: otherChoiceSelected,
            otherOptionText: currentAnswer.text,
            onOtherOptionTextChange: onOtherChoiceTextChange,
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            customComponents: customComponents,
            label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $diuGR.ViewDropdown), {
        id: id,
        options: availableOptions,
        value: currentOption,
        hasOtherOption: hasOtherChoice,
        otherOptionText: currentAnswer.text,
        displayMode: displayMode
    });
});

});
parcelRegister("kH8LN", function(module, exports) {

$parcel$export(module.exports, "toSelectOption", () => $f10ea050384b6a90$export$b1200bb97cce0ea8);

var $fHpHg = parcelRequire("fHpHg");
const $f10ea050384b6a90$export$b1200bb97cce0ea8 = (choice)=>{
    var _choice$children;
    return {
        value: choice.id,
        label: choice.label,
        children: (_choice$children = choice.children) === null || _choice$children === void 0 ? void 0 : _choice$children.map($f10ea050384b6a90$export$b1200bb97cce0ea8),
        ...(0, $fHpHg.fg)('proforma_asset_fields_show_selected_attributes') ? {
            cmdbObject: choice.cmdbObject
        } : {}
    };
};

});

parcelRegister("fORQz", function(module, exports) {

$parcel$export(module.exports, "EditDropdown", () => $b8454b6872b7e585$export$16b249c780871ab1);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $ia3X2 = parcelRequire("ia3X2");
var $lau8t = parcelRequire("lau8t");

var $4dI0P = parcelRequire("4dI0P");

var $hBksn = parcelRequire("hBksn");

var $3uIOs = parcelRequire("3uIOs");

var $6YPn9 = parcelRequire("6YPn9");
const $b8454b6872b7e585$export$16b249c780871ab1 = ({ id: id, options: options, value: value, loading: loading, loadOptions: loadOptions, onChange: onChange, hasOtherOption: hasOtherOption, otherOptionSelected: otherOptionSelected, otherOptionText: otherOptionText, onOtherOptionTextChange: onOtherOptionTextChange, isInvalid: isInvalid, isRequired: isRequired, customComponents: customComponents, label: label })=>{
    const [hasBeenFocused, setHasBeenFocused] = (0, $5uXOq.useState)(false);
    if (loadOptions === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.SelectErrorContainer), {
        isInvalid: isInvalid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), (0, $bS32t.default)({
        id: id,
        options: options,
        value: value !== null && value !== void 0 ? value : null,
        isLoading: loading,
        onChange: onChange,
        isSearchable: true,
        noOptionsMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownNoOptions),
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownSelect),
        isRequired: isRequired
    }, (0, $4dI0P.getDropDownMenuPosition)(), {
        label: label
    })), hasOtherOption && otherOptionSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uIOs.EditOtherOption), {
        dropdown: true,
        value: otherOptionText,
        isDisabled: !otherOptionSelected,
        onChange: onOtherOptionTextChange,
        id: id
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.SelectErrorContainer), {
        isInvalid: isInvalid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ia3X2.default), (0, $bS32t.default)({
        autoFocus: hasBeenFocused,
        defaultMenuIsOpen: hasBeenFocused,
        defaultOptions: hasBeenFocused,
        id: id,
        isSearchable: true,
        key: id + hasBeenFocused,
        isLoading: loading,
        noOptionsMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownNoOptions),
        loadOptions: loadOptions,
        loadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownLoading)
    }, (0, $4dI0P.getDropDownMenuPosition)(), {
        onChange: onChange,
        onFocus: ()=>setHasBeenFocused(true),
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownSelect),
        value: value !== null && value !== void 0 ? value : null,
        components: customComponents,
        label: label
    })));
};

});
parcelRegister("3uIOs", function(module, exports) {

$parcel$export(module.exports, "EditOtherOption", () => $28b6ef57e6d15d46$export$589a3e241a77ada7);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $fHpHg = parcelRequire("fHpHg");

var $bjTxt = parcelRequire("bjTxt");

var $6YPn9 = parcelRequire("6YPn9");
const $28b6ef57e6d15d46$export$589a3e241a77ada7 = ({ dropdown: dropdown, isDisabled: isDisabled, value: value, onChange: onChange, id: id })=>{
    const intl = (0, $koVbs.default)();
    // Local state required to show textarea changes as onChange callback is debounced.
    // Without it, user will only see their last inputted character added within the debounce period.
    const [textAreaValue, setTextAreaValue] = (0, $5uXOq.useState)(value);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $fHpHg.fg)('debounce_proforma_text_field_edits')) setTextAreaValue(value);
    }, [
        value
    ]);
    const debouncedOnChange = (0, $5uXOq.useMemo)(()=>(0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? onChange ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onChange, 500) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), [
        onChange
    ]);
    const handleTextAreaChange = (0, $5uXOq.useCallback)((e)=>{
        e.persist();
        setTextAreaValue(e.target.value);
        debouncedOnChange(e);
    }, [
        debouncedOnChange
    ]);
    const TextWrapper = dropdown ? $28b6ef57e6d15d46$var$OptionalTextWrapperDropdown : $28b6ef57e6d15d46$var$OptionalTextWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bjTxt.default), {
        appearance: "standard",
        isCompact: false,
        placeholder: intl.formatMessage((0, $6YPn9.messages).choiceDropdownNewOption),
        isDisabled: isDisabled,
        isReadOnly: false,
        minimumRows: 2,
        maxHeight: "none",
        isMonospaced: false,
        value: (0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? textAreaValue : value,
        resize: "smart",
        spellCheck: false,
        onBlur: undefined,
        onChange: (0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? handleTextAreaChange : (event)=>{
            onChange ? onChange(event) : undefined;
        },
        onFocus: undefined,
        id: id + '-other-option'
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $28b6ef57e6d15d46$var$OptionalTextWrapper = (0, $dAHxw.default).div({
    marginLeft: "var(--ds-space-300, 24px)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $28b6ef57e6d15d46$var$OptionalTextWrapperDropdown = (0, $dAHxw.default).div({
    marginTop: "var(--ds-space-050, 4px)"
});

});
parcelRegister("6YPn9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $515032243273a247$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $515032243273a247$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    choiceDropdownSelect: {
        id: 'form-system.choice-dropdown.select',
        defaultMessage: 'Select...',
        description: 'Placeholder text in dropdown waiting for the user to select something.'
    },
    choiceDropdownLoading: {
        id: 'form-system.choice-dropdown.loading',
        defaultMessage: 'Loading...',
        description: 'Placeholder text in dropdown while loading.'
    },
    choiceDropdownNoOptions: {
        id: 'form-system.choice-dropdown.no-options',
        defaultMessage: 'No options',
        description: 'Placeholder text in dropdown when there are no options.'
    },
    choiceDropdownNewOption: {
        id: 'form-system.choice-dropdown.new-option',
        defaultMessage: 'New option...',
        description: 'Placeholder text in dropdown when a new option can be created.'
    },
    dateLabel: {
        id: 'form-system.date-time.date.label',
        defaultMessage: 'Date : {label}',
        description: 'Label for date input.'
    },
    timeLabel: {
        id: 'form-system.date-time.time.label',
        defaultMessage: 'Time : {label}',
        description: 'Label for time input.'
    }
});

});



parcelRegister("diuGR", function(module, exports) {

$parcel$export(module.exports, "ViewDropdown", () => $9ae4c3417473dd28$export$1a3e8c431e82eb82);

var $5uXOq = parcelRequire("5uXOq");

var $51H8P = parcelRequire("51H8P");

var $lau8t = parcelRequire("lau8t");

var $8iale = parcelRequire("8iale");

var $hBksn = parcelRequire("hBksn");

var $5aEbC = parcelRequire("5aEbC");
const $9ae4c3417473dd28$var$styles = {
    control: (base)=>({
            ...base,
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${0, $51H8P.N20})`,
            borderColor: "var(--ds-border-disabled, #DFE1E6)",
            color: "var(--ds-text, #172B4D !important)"
        }),
    menu: (base)=>({
            ...base,
            color: "var(--ds-text, #172B4D)"
        })
};
const $9ae4c3417473dd28$export$1a3e8c431e82eb82 = ({ id: id, value: value, options: options, hasOtherOption: hasOtherOption, otherOptionText: otherOptionText, displayMode: displayMode })=>{
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) // This is a Disabled Select
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), {
        key: id,
        id: id,
        options: options,
        value: value,
        placeholder: "",
        isDisabled: true,
        styles: $9ae4c3417473dd28$var$styles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5aEbC.ViewOtherOption), {
        dropdown: true,
        display: hasOtherOption,
        value: otherOptionText
    }));
    // if the user has selected 'Other...' and provided a value we display that value. Otherwise we display 'Other...'
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, hasOtherOption && otherOptionText || value && value.label);
};

});
parcelRegister("5aEbC", function(module, exports) {

$parcel$export(module.exports, "ViewOtherOption", () => $3c3d0f1fcc645f3c$export$4444a1a54c5eeec2);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");
const $3c3d0f1fcc645f3c$export$4444a1a54c5eeec2 = ({ dropdown: dropdown, display: display, value: value })=>{
    if (!display) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    const TextWrapper = dropdown ? $3c3d0f1fcc645f3c$var$OptionalTextDisabledWrapperDropdown : $3c3d0f1fcc645f3c$var$OptionalTextDisabledWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TextWrapper, null, value);
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c3d0f1fcc645f3c$var$OptionalTextDisabledWrapper = (0, $dAHxw.default).div`
	padding: ${"var(--ds-space-100, 8px)"};
	margin-left: ${"var(--ds-space-300, 24px)"};
	margin-bottom: ${"var(--ds-space-100, 8px)"};
	margin-right: ${"var(--ds-space-100, 8px)"};
	background-color: ${"var(--ds-background-disabled, white)"};
	color: ${"var(--ds-text-disabled, #172b4d !important)"};
`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c3d0f1fcc645f3c$var$OptionalTextDisabledWrapperDropdown = (0, $dAHxw.default).div`
	padding: ${"var(--ds-space-100, 8px)"};
	margin-top: ${"var(--ds-space-050, 4px)"};
	background-color: ${"var(--ds-background-disabled, white)"};
	color: ${"var(--ds-text-disabled, #172b4d !important)"};
`;

});



parcelRegister("jLknN", function(module, exports) {

$parcel$export(module.exports, "DropdownMultiselect", () => $e63237b770d73786$export$61a2787f31ddc186);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $cnwtr = parcelRequire("cnwtr");

var $kH8LN = parcelRequire("kH8LN");

var $4QmvR = parcelRequire("4QmvR");

var $ctPpG = parcelRequire("ctPpG");

var $8iale = parcelRequire("8iale");

var $cbTKF = parcelRequire("cbTKF");

var $7IStc = parcelRequire("7IStc");
const $e63237b770d73786$export$61a2787f31ddc186 = (0, $jJXgM.observer)((props)=>{
    var _questionStore$issueF;
    const { id: id, questionStore: questionStore, formStore: formStore, displayMode: displayMode, customComponents: customComponents } = props;
    const availableOptions = questionStore.availableOptions();
    const currentAnswer = (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
    const currentOptions = questionStore.getAnswerChoicesAsObjects();
    const hasOtherChoice = !!questionStore.otherChoiceId;
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
        const otherChoiceSelected = hasOtherChoice && currentOptions.some((option)=>option.value === questionStore.otherChoiceId);
        const onChange = (values)=>{
            const newChoiceIds = values.map((option)=>option.value);
            questionStore.setAnswer({
                text: otherChoiceSelected ? (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).text : '',
                choices: newChoiceIds,
                // ideally - make `choices` objects, not ids, and remove `choiceObjects` prop. But ... (what's the problem? - ask Jason Thai or Banu)
                choiceObjects: values.map((0, $4QmvR.QuestionStore).optionToChoice)
            });
        };
        const loadChoicesAsync = questionStore.isAsyncChoicesField ? (0, $cnwtr.debounce)((inputValue, callback)=>{
            formStore.loadChoicesAsync(questionStore.id, inputValue).then((_)=>callback(questionStore.choices.map((0, $kH8LN.toSelectOption))));
        }, 500) : undefined;
        const onOtherChoiceTextChange = (event)=>{
            questionStore.setAnswer({
                text: event.target.value,
                choices: (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).choices
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbTKF.EditDropdownMultiselect), {
            id: id,
            key: `${id}-${questionStore.dependentFieldChangedCount}`,
            options: availableOptions,
            value: currentOptions,
            loading: questionStore.loading,
            loadOptions: loadChoicesAsync,
            isCreatable: (0, $ctPpG.isAsyncCreatable)(questionStore),
            onChange: onChange,
            hasOtherOption: hasOtherChoice,
            otherOptionSelected: otherChoiceSelected,
            otherOptionText: currentAnswer.text,
            onOtherOptionTextChange: onOtherChoiceTextChange,
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            customComponents: customComponents,
            label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7IStc.ViewDropdownMultiselect), {
        id: id,
        options: availableOptions,
        value: currentOptions,
        hasOtherOption: hasOtherChoice,
        otherOptionText: currentAnswer.text,
        displayMode: displayMode
    });
});

});
parcelRegister("cbTKF", function(module, exports) {

$parcel$export(module.exports, "EditDropdownMultiselect", () => $8e01c2400a4a27c3$export$263bc266433bf0b6);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $hWb15 = parcelRequire("hWb15");
var $ia3X2 = parcelRequire("ia3X2");
var $lau8t = parcelRequire("lau8t");

var $4dI0P = parcelRequire("4dI0P");

var $hBksn = parcelRequire("hBksn");

var $3uIOs = parcelRequire("3uIOs");

var $6YPn9 = parcelRequire("6YPn9");
const $8e01c2400a4a27c3$export$263bc266433bf0b6 = ({ id: id, options: options, value: value, loading: loading, loadOptions: loadOptions, isCreatable: isCreatable, onChange: onChange, hasOtherOption: hasOtherOption, otherOptionSelected: otherOptionSelected, otherOptionText: otherOptionText, onOtherOptionTextChange: onOtherOptionTextChange, isInvalid: isInvalid, isRequired: isRequired, customComponents: customComponents, label: label })=>{
    const [hasBeenFocused, setHasBeenFocused] = (0, $5uXOq.useState)(false);
    if (loadOptions === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.SelectErrorContainer), {
        isInvalid: isInvalid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), (0, $bS32t.default)({
        id: id,
        options: options,
        value: value,
        isLoading: loading,
        onChange: onChange,
        isMulti: true
    }, (0, $4dI0P.getDropDownMenuPosition)(), {
        isSearchable: true,
        noOptionsMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownNoOptions),
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownSelect),
        isRequired: isRequired,
        label: label
    })), hasOtherOption && otherOptionSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uIOs.EditOtherOption), {
        dropdown: true,
        value: otherOptionText,
        isDisabled: !otherOptionSelected,
        onChange: onOtherOptionTextChange,
        id: id
    }));
    const MaybeCreatableAsyncSelect = isCreatable ? (0, $hWb15.default) : (0, $ia3X2.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.SelectErrorContainer), {
        isInvalid: isInvalid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MaybeCreatableAsyncSelect, (0, $bS32t.default)({
        autoFocus: hasBeenFocused,
        defaultMenuIsOpen: hasBeenFocused,
        defaultOptions: hasBeenFocused,
        id: id,
        isMulti: true,
        isSearchable: true,
        isValidNewOption: isCreatable ? (inputValue)=>inputValue.length > 0 && !inputValue.includes(' ') : undefined,
        key: id + hasBeenFocused,
        isLoading: loading,
        noOptionsMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownNoOptions),
        loadOptions: loadOptions,
        loadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownLoading),
        onChange: onChange,
        onFocus: ()=>setHasBeenFocused(true),
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownSelect),
        value: value
    }, (0, $4dI0P.getDropDownMenuPosition)(), {
        components: customComponents,
        label: label
    })));
};

});

parcelRegister("7IStc", function(module, exports) {

$parcel$export(module.exports, "ViewDropdownMultiselect", () => $59f6e50dc3f38ee3$export$70cbf19b62c07ef9);

var $5uXOq = parcelRequire("5uXOq");

var $51H8P = parcelRequire("51H8P");

var $lau8t = parcelRequire("lau8t");

var $8iale = parcelRequire("8iale");

var $hBksn = parcelRequire("hBksn");

var $5aEbC = parcelRequire("5aEbC");
const $59f6e50dc3f38ee3$var$styles = {
    control: (base)=>({
            ...base,
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${0, $51H8P.N20})`,
            borderColor: "var(--ds-border-disabled, #DFE1E6)",
            color: "var(--ds-text, #172B4D !important)"
        }),
    menu: (base)=>({
            ...base,
            color: "var(--ds-text, #172B4D)"
        })
};
const $59f6e50dc3f38ee3$export$70cbf19b62c07ef9 = ({ id: id, value: value, options: options, hasOtherOption: hasOtherOption, otherOptionText: otherOptionText, displayMode: displayMode })=>{
    // if the user has selected 'Other...' and provided a value we display that value. Otherwise we display 'Other...'
    const labels = value && value.map((item)=>item.label);
    if (labels && hasOtherOption && otherOptionText) {
        labels.push(otherOptionText);
        // the actual 'Other...' option will always be the last one in the array, we do not display this in view mode
        // it is the last one in case the user added their own option that is also called 'Other...'
        const lastIndex = labels.lastIndexOf('Other...');
        if (lastIndex !== -1) labels.splice(lastIndex, 1);
    }
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) // This is a Disabled Select
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), {
        id: id,
        options: options,
        value: value,
        isMulti: true,
        placeholder: "",
        isDisabled: true,
        styles: $59f6e50dc3f38ee3$var$styles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5aEbC.ViewOtherOption), {
        dropdown: true,
        display: hasOtherOption,
        value: otherOptionText
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, labels && labels.join(', '));
};

});


parcelRegister("8WT1f", function(module, exports) {

$parcel$export(module.exports, "EditDropdownOption", () => $683e6b2464a30a1c$export$b451235916dc4ebd);

var $5uXOq = parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");

var $fHpHg = parcelRequire("fHpHg");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $b1kcy = parcelRequire("b1kcy");

var $6U5Ei = parcelRequire("6U5Ei");

var $8VVnQ = parcelRequire("8VVnQ");
const $683e6b2464a30a1c$export$b451235916dc4ebd = (props)=>{
    const { data: data, selectProps: selectProps, filterAttributes: filterAttributes } = props;
    const Option = (0, $b1kcy.components).Option;
    // return regular select formatting if there is no cmdbObject
    if (!data.cmdbObject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Option, props);
    const { inputValue: inputValue } = selectProps;
    const object = data.cmdbObject;
    const visibleAttributes = (0, $8VVnQ.getVisibleAttributes)(object.attributes, filterAttributes);
    const [, ...secondaryAttributes] = visibleAttributes;
    const labelAttribute = (0, $8VVnQ.createLabelString)(visibleAttributes, object.label);
    const secondaryAttributesDescription = (0, $8VVnQ.createAttributeString)(secondaryAttributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        paddingInline: "space.200",
        paddingBlock: "space.100",
        xcss: $683e6b2464a30a1c$var$boxHover
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $683e6b2464a30a1c$var$iconBoxStyle
    }, (0, $fHpHg.fg)('fix_unlicensed_proforma_cmdb_icon_jsdcloud-16258') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U5Ei.CmdbIcon), object.avatar.mediaClientConfig) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
        src: object.avatar.url48,
        size: "small",
        name: labelAttribute,
        appearance: "square"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $683e6b2464a30a1c$var$contentBoxStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        size: "medium",
        weight: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8VVnQ.BoldMatchingText), {
        match: inputValue !== null && inputValue !== void 0 ? inputValue : ''
    }, labelAttribute)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8VVnQ.BoldMatchingText), {
        match: inputValue !== null && inputValue !== void 0 ? inputValue : '',
        isSmall: true
    }, secondaryAttributesDescription)))))));
};
const $683e6b2464a30a1c$var$boxHover = (0, $2s57o.xcss)({
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    }
});
const $683e6b2464a30a1c$var$iconBoxStyle = (0, $2s57o.xcss)({
    marginRight: 'space.150',
    flexShrink: 0
});
const $683e6b2464a30a1c$var$contentBoxStyle = (0, $2s57o.xcss)({
    color: 'color.text'
});

});
parcelRegister("6U5Ei", function(module, exports) {

$parcel$export(module.exports, "CmdbIcon", () => $506c5acb71e4e3bf$export$dd40f6e54a495f23);

var $5uXOq = parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");
var $1RiSN = parcelRequire("1RiSN");

var $afuOi = parcelRequire("afuOi");

var $cmbAE = parcelRequire("cmbAE");
const $506c5acb71e4e3bf$var$IMAGE_SIZE = {
    width: 24,
    height: 24
};
// We want to reuse mediaClientConfigs across all CmdbIcons to avoid extra http requests
// MediaImage internally checks for object equality to prevent image refetch.
// That's why we need to check for the individual parameters equality at this level
// and prevent the property mediaClientConfig to change
const $506c5acb71e4e3bf$var$mediaClientConfigs = new Map();
const $506c5acb71e4e3bf$var$getMediaClientConfig = ({ mediaJwtToken: mediaJwtToken, clientId: clientId, mediaBaseUrl: mediaBaseUrl })=>{
    const key = `${mediaJwtToken}:${clientId}:${mediaBaseUrl}`;
    const existingMediaClientConfig = $506c5acb71e4e3bf$var$mediaClientConfigs.get(key);
    if (existingMediaClientConfig) return existingMediaClientConfig;
    const mediaClientConfig = {
        authProvider: ()=>Promise.resolve({
                clientId: clientId,
                token: mediaJwtToken,
                baseUrl: mediaBaseUrl
            }),
        useSha256ForUploads: true
    };
    $506c5acb71e4e3bf$var$mediaClientConfigs.set(key, mediaClientConfig);
    return mediaClientConfig;
};
const $506c5acb71e4e3bf$var$hasAuth = ({ mediaBaseUrl: mediaBaseUrl, mediaJwtToken: mediaJwtToken, fileId: fileId, clientId: clientId })=>Boolean(mediaBaseUrl) && Boolean(mediaJwtToken) && Boolean(clientId) && Boolean(fileId);
const $506c5acb71e4e3bf$var$DefaultIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
        appearance: "square",
        size: "small"
    });
const $506c5acb71e4e3bf$var$CmdbIconInternal = (props)=>{
    if (!$506c5acb71e4e3bf$var$hasAuth(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($506c5acb71e4e3bf$var$DefaultIcon, null);
    const fileIdentifier = {
        id: props.fileId,
        mediaItemType: 'file'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $afuOi.MediaClientProvider), {
        clientConfig: $506c5acb71e4e3bf$var$getMediaClientConfig(props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmbAE.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: $506c5acb71e4e3bf$var$getMediaClientConfig(props),
        apiConfig: $506c5acb71e4e3bf$var$IMAGE_SIZE
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RiSN.default), {
            appearance: "square",
            size: "small"
        });
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($506c5acb71e4e3bf$var$DefaultIcon, null);
        if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($506c5acb71e4e3bf$var$DefaultIcon, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
            src: data.src,
            appearance: "square",
            size: "small"
        });
    })));
};
const $506c5acb71e4e3bf$export$dd40f6e54a495f23 = /*#__PURE__*/ (0, $5uXOq.memo)($506c5acb71e4e3bf$var$CmdbIconInternal);

});

parcelRegister("8VVnQ", function(module, exports) {

$parcel$export(module.exports, "BoldMatchingText", () => $681028cdb3c10ed6$export$fee117cd50d6234b);
$parcel$export(module.exports, "getVisibleAttributes", () => $681028cdb3c10ed6$export$3c4337b649d4ffca);
$parcel$export(module.exports, "createAttributeString", () => $681028cdb3c10ed6$export$cd0f2f750043f4bc);
$parcel$export(module.exports, "createLabelString", () => $681028cdb3c10ed6$export$9ce1cf00f76f3d0b);

var $5uXOq = parcelRequire("5uXOq");

var $k9nuy = parcelRequire("k9nuy");
const $681028cdb3c10ed6$export$fee117cd50d6234b = ({ match: match, children: children, isSmall: isSmall = false })=>{
    if (match === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    // we need to escape special characters to avoid getting them interpreted in the RegExp group
    const escapedSpecialCharsInMatchQuery = match.replace(/[\\.,*+?^${}()|[\]]/g, '\\$&');
    const parts = children.split(new RegExp(`(${escapedSpecialCharsInMatchQuery})`, 'gi'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
        if (part.toLowerCase() === match.toLowerCase()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
            testId: "cmdb-edit-dropdown-option.bold-text",
            as: "strong",
            size: isSmall ? 'small' : undefined,
            key: i
        }, part);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: i
        }, part);
    }));
};
const $681028cdb3c10ed6$export$3c4337b649d4ffca = (attributes, attributesToDisplay)=>{
    const notUndefined = (attr)=>{
        return Boolean(attr);
    };
    return attributesToDisplay.map((attrName)=>attrName === 'Label' ? attributes.find((attr)=>attr.objectTypeAttribute.label) : attributes.find((attr)=>attr.objectTypeAttribute.name === attrName)).filter(notUndefined).filter((attribute)=>attribute.objectAttributeValues.length > 0 && attribute.objectAttributeValues.every((value)=>value && value.displayValue));
};
const $681028cdb3c10ed6$export$cd0f2f750043f4bc = (attributes)=>{
    return attributes.map((attribute)=>attribute.objectAttributeValues.map((value)=>value.displayValue).join(', ')).join(' | ');
};
const $681028cdb3c10ed6$export$9ce1cf00f76f3d0b = (attributes, defaultLabel)=>{
    var _attributes$;
    return ((_attributes$ = attributes[0]) === null || _attributes$ === void 0 ? void 0 : _attributes$.objectAttributeValues.map((v)=>v.displayValue).join(', ')) || defaultLabel;
};

});



parcelRegister("cGJ7q", function(module, exports) {

$parcel$export(module.exports, "Date", () => $93cc67ea76b37d18$export$6341f9a885713487);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $fKL5L = parcelRequire("fKL5L");

var $dv29C = parcelRequire("dv29C");
const $93cc67ea76b37d18$export$6341f9a885713487 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit;
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fKL5L.EditDate), {
            id: id,
            value: (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer),
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            onChange: (value)=>questionStore.setAnswer(value),
            label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dv29C.ViewDate), {
        id: id,
        value: (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer),
        displayMode: displayMode
    });
});

});
parcelRegister("fKL5L", function(module, exports) {

$parcel$export(module.exports, "EditDate", () => $b77fae5d063f7451$export$9b310bf64ea058a0);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $koVbs = parcelRequire("koVbs");

var $i2731 = parcelRequire("i2731");

var $fHpHg = parcelRequire("fHpHg");

var $fiX4W = parcelRequire("fiX4W");

var $dpaDt = parcelRequire("dpaDt");

var $9c6Sr = parcelRequire("9c6Sr");

var $hBksn = parcelRequire("hBksn");

var $fD4eY = parcelRequire("fD4eY");

var $dnKOm = parcelRequire("dnKOm");
const $b77fae5d063f7451$export$9b310bf64ea058a0 = ({ id: id, value: value, isInvalid: isInvalid, isRequired: isRequired, onChange: onChange, label: label })=>{
    const intl = (0, $koVbs.default)();
    const startOfWeekDay = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $9c6Sr.getLocale)(intl.locale), 'options.weekStartsOn', (0, $9c6Sr.DEFAULT_WEEK_START_DAY));
    return (0, $dpaDt.isMobile)() && !(0, $fHpHg.fg)('proforma_use_atlaskit_date_time_picker_for_mobile') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fD4eY.DatePickerMobile), {
        dateValue: value,
        onChange: onChange
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ShortFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2731.default), {
        id: id,
        value: value,
        isInvalid: isInvalid,
        isRequired: isRequired,
        onChange: onChange,
        locale: intl.locale || (0, $fiX4W.DEFAULT_LOCALE),
        placeholder: intl.formatMessage((0, $dnKOm.IntlEditDateMessages)[(0, $dnKOm.EditDateMessages).DatePlaceholder], {
            date: intl.formatDate(new Date(), {})
        }),
        weekStartDay: startOfWeekDay,
        label: label,
        shouldShowCalendarButton: (0, $fHpHg.fg)('dst-init-calendar-button-proforma-editdate') ? true : undefined
    }));
};

});
parcelRegister("9c6Sr", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_WEEK_START_DAY", () => $6b1a91b76b2dd4ba$export$845e1054649a85c2);
$parcel$export(module.exports, "getLocale", () => $6b1a91b76b2dd4ba$export$180605366c04f0cd);

var $h5fUo = parcelRequire("h5fUo");
var $ffv2q = parcelRequire("ffv2q");
var $dm4b1 = parcelRequire("dm4b1");
var $aFgGS = parcelRequire("aFgGS");
var $llpfr = parcelRequire("llpfr");
var $9iTW1 = parcelRequire("9iTW1");
var $jhzA6 = parcelRequire("jhzA6");
var $kxtvT = parcelRequire("kxtvT");
var $hEliE = parcelRequire("hEliE");
var $hIVAh = parcelRequire("hIVAh");
var $5hliK = parcelRequire("5hliK");
var $jxRuk = parcelRequire("jxRuk");
var $L1VDF = parcelRequire("L1VDF");
var $jZP2w = parcelRequire("jZP2w");
var $l4n7P = parcelRequire("l4n7P");
var $eeqpy = parcelRequire("eeqpy");
var $gsxJS = parcelRequire("gsxJS");
var $30BQk = parcelRequire("30BQk");
var $9XBqA = parcelRequire("9XBqA");
var $41VsA = parcelRequire("41VsA");
var $dy8Kh = parcelRequire("dy8Kh");
var $bVTfl = parcelRequire("bVTfl");
var $hTCZG = parcelRequire("hTCZG");
var $84SrD = parcelRequire("84SrD");
var $cuiuC = parcelRequire("cuiuC");
var $7XYbY = parcelRequire("7XYbY");
var $5xGxo = parcelRequire("5xGxo");
var $bYR3G = parcelRequire("bYR3G");

var $fiX4W = parcelRequire("fiX4W");
const $6b1a91b76b2dd4ba$export$df1c34db1371eeed = {
    arDZ: $h5fUo.default,
    ar: (0, $h5fUo.default),
    ar_DZ: (0, $h5fUo.default),
    cs: $ffv2q.default,
    cs_CZ: (0, $ffv2q.default),
    'cs-CZ': (0, $ffv2q.default),
    da: $dm4b1.default,
    da_DK: (0, $dm4b1.default),
    'da-DK': (0, $dm4b1.default),
    de: $aFgGS.default,
    de_DE: (0, $aFgGS.default),
    'de-DE': (0, $aFgGS.default),
    enUS: $jhzA6.default,
    en_US: (0, $jhzA6.default),
    'en-US': (0, $jhzA6.default),
    enGB: $9iTW1.default,
    en_UK: (0, $9iTW1.default),
    'en-UK': (0, $9iTW1.default),
    'en-GB': (0, $9iTW1.default),
    en_GB: (0, $9iTW1.default),
    enAU: $llpfr.default,
    en_AU: (0, $llpfr.default),
    'en-AU': (0, $llpfr.default),
    es: $kxtvT.default,
    es_ES: (0, $kxtvT.default),
    'es-ES': (0, $kxtvT.default),
    et: $hEliE.default,
    et_EE: (0, $hEliE.default),
    'et-EE': (0, $hEliE.default),
    fi: $hIVAh.default,
    fi_FI: (0, $hIVAh.default),
    'fi-FI': (0, $hIVAh.default),
    fr: $5hliK.default,
    fr_FR: (0, $5hliK.default),
    'fr-FR': (0, $5hliK.default),
    hu: $jxRuk.default,
    hu_HU: (0, $jxRuk.default),
    'hu-HU': (0, $jxRuk.default),
    is: $L1VDF.default,
    is_IS: (0, $L1VDF.default),
    'is-IS': (0, $L1VDF.default),
    it: $jZP2w.default,
    it_IT: (0, $jZP2w.default),
    'it-IT': (0, $jZP2w.default),
    ja: $l4n7P.default,
    ja_JP: (0, $l4n7P.default),
    'ja-JP': (0, $l4n7P.default),
    ko: $eeqpy.default,
    ko_KR: (0, $eeqpy.default),
    'ko-KR': (0, $eeqpy.default),
    nb: $gsxJS.default,
    nb_NO: (0, $gsxJS.default),
    'nb-NO': (0, $gsxJS.default),
    nl: $30BQk.default,
    nl_NL: (0, $30BQk.default),
    'nl-NL': (0, $30BQk.default),
    pl: $9XBqA.default,
    pl_PL: (0, $9XBqA.default),
    'pl-PL': (0, $9XBqA.default),
    pt: $41VsA.default,
    'pt-PT': (0, $41VsA.default),
    pt_PT: (0, $41VsA.default),
    ptBR: $dy8Kh.default,
    'pt-BR': (0, $dy8Kh.default),
    pt_BR: (0, $dy8Kh.default),
    ro: $bVTfl.default,
    ro_RO: (0, $bVTfl.default),
    'ro-RO': (0, $bVTfl.default),
    ru: $hTCZG.default,
    ru_RU: (0, $hTCZG.default),
    'ru-RU': (0, $hTCZG.default),
    sk: $84SrD.default,
    sk_SK: (0, $84SrD.default),
    'sk-SK': (0, $84SrD.default),
    sv: $cuiuC.default,
    sv_SE: (0, $cuiuC.default),
    'sv-SE': (0, $cuiuC.default),
    tr: $7XYbY.default,
    'tr-TR': (0, $7XYbY.default),
    tr_TR: (0, $7XYbY.default),
    zhCN: $5xGxo.default,
    'zh-CN': (0, $5xGxo.default),
    zh_CN: (0, $5xGxo.default),
    zhTW: $bYR3G.default,
    'zh-TW': (0, $bYR3G.default),
    zh_TW: (0, $bYR3G.default)
};
const $6b1a91b76b2dd4ba$export$845e1054649a85c2 = 0; // Sunday
const $6b1a91b76b2dd4ba$export$180605366c04f0cd = (localeString)=>{
    const key = localeString;
    return $6b1a91b76b2dd4ba$export$df1c34db1371eeed[key] || $6b1a91b76b2dd4ba$export$df1c34db1371eeed[0, $fiX4W.DEFAULT_LOCALE];
};

});

parcelRegister("fD4eY", function(module, exports) {

$parcel$export(module.exports, "DatePickerMobile", () => $b60dc999602e0454$export$d4f2531de00bdbd4);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $koVbs = parcelRequire("koVbs");

var $dnKOm = parcelRequire("dnKOm");
const $b60dc999602e0454$export$d4f2531de00bdbd4 = ({ id: id, dateValue: dateValue, onChange: onChange, isRequired: isRequired, label: label })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b60dc999602e0454$var$DatePickerMobileStyles, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        id: id,
        type: "date",
        value: dateValue,
        onChange: onChange ? (event)=>onChange(event.target.value) : undefined,
        placeholder: intl.formatMessage((0, $dnKOm.IntlEditDateMessages)[(0, $dnKOm.EditDateMessages).DatePlaceholder], {
            date: intl.formatDate(new Date(), {})
        }),
        required: isRequired,
        "aria-label": label
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b60dc999602e0454$var$DatePickerMobileStyles = (0, $dAHxw.default).div({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > input': {
        whiteSpace: 'initial',
        display: 'flex',
        backgroundColor: "var(--ds-background-input, #f4f5f7)",
        borderColor: "var(--ds-border-inverse, #f4f5f7)",
        borderRadius: "var(--ds-border-radius, 3px)",
        marginBottom: "var(--ds-space-100, 8px)",
        boxShadow: 'none',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 2px)",
        paddingTop: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-075, 6px)",
        boxSizing: 'border-box',
        width: '100%',
        '&:hover': {
            backgroundColor: "var(--ds-background-input-hovered, #ebecf0)"
        }
    }
});

});
parcelRegister("dnKOm", function(module, exports) {

$parcel$export(module.exports, "EditDateMessages", () => $9be1bc18bc18050f$export$f52547d1f3be6201);
$parcel$export(module.exports, "IntlEditDateMessages", () => $9be1bc18bc18050f$export$4c6d5d4699fcb1bd);

var $7VHMR = parcelRequire("7VHMR");
let $9be1bc18bc18050f$export$f52547d1f3be6201 = /*#__PURE__*/ function(EditDateMessages) {
    EditDateMessages["DatePlaceholder"] = "DatePlaceholder";
    return EditDateMessages;
}({});
const $9be1bc18bc18050f$export$4c6d5d4699fcb1bd = (0, $7VHMR.defineMessages)({
    [$9be1bc18bc18050f$export$f52547d1f3be6201.DatePlaceholder]: {
        id: 'form-system.DateQuestion.DatePlaceholder',
        defaultMessage: 'e.g. {date}'
    }
});

});



parcelRegister("dv29C", function(module, exports) {

$parcel$export(module.exports, "ViewDate", () => $9d3fd76483ccf621$export$2c30cd42d7b40e0f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $i2731 = parcelRequire("i2731");

var $fiX4W = parcelRequire("fiX4W");

var $8iale = parcelRequire("8iale");

var $6YylQ = parcelRequire("6YylQ");

var $hBksn = parcelRequire("hBksn");
const $9d3fd76483ccf621$var$formatValueForView = (currentAnswer, locale)=>{
    if (!currentAnswer || currentAnswer.length === 0) return '';
    return new Intl.DateTimeFormat(locale, {
        ...(0, $6YylQ.longDateOnlyFormat),
        timeZone: 'UTC'
    }).format(Date.parse(currentAnswer));
};
const $9d3fd76483ccf621$export$2c30cd42d7b40e0f = ({ id: id, value: value, displayMode: displayMode })=>{
    const intl = (0, $koVbs.default)();
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ShortFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.FieldDisabledWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2731.default), {
        id: id,
        value: value,
        locale: intl.locale || (0, $fiX4W.DEFAULT_LOCALE),
        placeholder: " ",
        isDisabled: true,
        appearance: "subtle",
        shouldShowCalendarButton: true
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, $9d3fd76483ccf621$var$formatValueForView(value, intl.locale));
};

});
parcelRegister("6YylQ", function(module, exports) {

$parcel$export(module.exports, "longDateOnlyFormat", () => $5142fe259e6a615c$export$51f819d50bcd4ae1);
$parcel$export(module.exports, "longTimeOnlyFormat", () => $5142fe259e6a615c$export$a3aff10871f7171c);
/**
 * At the moment straight copy from jira/src/packages/issue/format-date/src/common/constants.tsx
 *
 * If you remove this file, please remove the comment from the above constants file.
 */ /**
 * Long format of a date time, eg "Jun 16, 1971, 2:34 AM" with 12h/24h formatting resolved from locale
 */ const $5142fe259e6a615c$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $5142fe259e6a615c$export$51f819d50bcd4ae1 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
};
const $5142fe259e6a615c$export$a3aff10871f7171c = {
    hour: 'numeric',
    minute: 'numeric'
};

});



parcelRegister("bchDp", function(module, exports) {

$parcel$export(module.exports, "DateTime", () => $826e7e9134f8351b$export$82f9ebd9adeba146);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $hYgPO = parcelRequire("hYgPO");

var $37690 = parcelRequire("37690");
const $826e7e9134f8351b$export$82f9ebd9adeba146 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
    const currentAnswer = (0, $4QmvR.toDateTimeQuestionAnswerOrEmpty)(questionStore.currentAnswer);
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit;
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYgPO.EditDateTime), {
            id: id,
            dateValue: currentAnswer.date,
            timeValue: currentAnswer.time,
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            onDateChange: (value)=>{
                questionStore.setAnswer({
                    date: value,
                    time: (0, $4QmvR.toDateTimeQuestionAnswerOrEmpty)(questionStore.currentAnswer).time
                });
            },
            onTimeChange: (value)=>{
                questionStore.setAnswer({
                    date: (0, $4QmvR.toDateTimeQuestionAnswerOrEmpty)(questionStore.currentAnswer).date,
                    time: value
                });
            },
            label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $37690.ViewDateTime), {
        id: id,
        dateValue: currentAnswer.date,
        timeValue: currentAnswer.time,
        displayMode: displayMode
    });
});

});
parcelRegister("hYgPO", function(module, exports) {

$parcel$export(module.exports, "EditDateTime", () => $d1551943753e3384$export$eee3c3913c1d4b94);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $koVbs = parcelRequire("koVbs");

var $hBksn = parcelRequire("hBksn");

var $fKL5L = parcelRequire("fKL5L");

var $6MwDx = parcelRequire("6MwDx");

var $6YPn9 = parcelRequire("6YPn9");
const $d1551943753e3384$export$eee3c3913c1d4b94 = ({ id: id, dateValue: dateValue, timeValue: timeValue, isInvalid: isInvalid, isRequired: isRequired, onDateChange: onDateChange, onTimeChange: onTimeChange, label: label })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d1551943753e3384$var$DateTimePickerContainer, {
        isInvalid: isInvalid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fKL5L.EditDate), {
        id: id,
        value: dateValue,
        isInvalid: false,
        isRequired: isRequired,
        onChange: onDateChange,
        label: intl.formatMessage((0, $6YPn9.messages).dateLabel, {
            label: label
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6MwDx.EditTime), {
        id: id + '-time',
        value: timeValue,
        isInvalid: false,
        isRequired: isRequired,
        label: intl.formatMessage((0, $6YPn9.messages).timeLabel, {
            label: label
        }),
        onChange: onTimeChange
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1551943753e3384$var$DateTimePickerContainer = (0, $dAHxw.default).div({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> div': {
        width: '50%'
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
(props)=>props.isInvalid && (0, $hBksn.invalidFieldContainerStyles));

});
parcelRegister("6MwDx", function(module, exports) {

$parcel$export(module.exports, "EditTime", () => $4f008ac450d5ca31$export$289bb9c0e3074c18);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $1h7Rm = parcelRequire("1h7Rm");

var $fHpHg = parcelRequire("fHpHg");

var $fiX4W = parcelRequire("fiX4W");

var $dpaDt = parcelRequire("dpaDt");

var $giaor = parcelRequire("giaor");

var $hBksn = parcelRequire("hBksn");

var $ak9K8 = parcelRequire("ak9K8");

var $6LBmA = parcelRequire("6LBmA");
const $4f008ac450d5ca31$export$289bb9c0e3074c18 = ({ id: id, value: value, isInvalid: isInvalid, isRequired: isRequired, onChange: onChange, label: label })=>{
    const intl = (0, $koVbs.default)();
    return (0, $dpaDt.isMobile)() && !(0, $fHpHg.fg)('proforma_use_atlaskit_date_time_picker_for_mobile') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ak9K8.TimePickerMobile), {
        timeValue: value,
        onChange: onChange
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ShortFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1h7Rm.default), {
        id: id,
        times: (0, $giaor.times),
        value: value,
        isInvalid: isInvalid,
        isRequired: isRequired,
        onChange: onChange,
        locale: intl.locale || (0, $fiX4W.DEFAULT_LOCALE),
        timeIsEditable: true,
        placeholder: intl.formatMessage((0, $6LBmA.IntlEditTimeMessages)[(0, $6LBmA.EditTimeMessages).TimePlaceholder], {
            time: intl.formatTime(new Date(), {})
        }),
        label: label
    }));
};

});
parcelRegister("giaor", function(module, exports) {

$parcel$export(module.exports, "times", () => $bdc663adda57dc5c$export$b5bc26e198ce73d0);
const $bdc663adda57dc5c$export$b5bc26e198ce73d0 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});

parcelRegister("ak9K8", function(module, exports) {

$parcel$export(module.exports, "TimePickerMobile", () => $7843546acdea69f8$export$3378012995be7fff);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $koVbs = parcelRequire("koVbs");

var $6LBmA = parcelRequire("6LBmA");
const $7843546acdea69f8$export$3378012995be7fff = ({ id: id, timeValue: timeValue, onChange: onChange, isRequired: isRequired, label: label })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7843546acdea69f8$var$TimePickerMobileStyles, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        id: id,
        type: "time",
        step: 1800,
        value: timeValue,
        onChange: onChange ? (event)=>onChange(event.target.value) : undefined,
        placeholder: intl.formatMessage((0, $6LBmA.IntlEditTimeMessages)[(0, $6LBmA.EditTimeMessages).TimePlaceholder], {
            date: intl.formatDate(new Date(), {})
        }),
        required: isRequired,
        "aria-label": label
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7843546acdea69f8$var$TimePickerMobileStyles = (0, $dAHxw.default).div({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > input': {
        whiteSpace: 'initial',
        display: 'flex',
        backgroundColor: "var(--ds-background-input, #f4f5f7)",
        borderColor: "var(--ds-border-inverse, #f4f5f7)",
        borderRadius: "var(--ds-border-radius, 3px)",
        marginBottom: "var(--ds-space-100, 8px)",
        boxShadow: 'none',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 2px)",
        paddingTop: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-075, 6px)",
        boxSizing: 'border-box',
        width: '100%',
        '&:hover': {
            backgroundColor: "var(--ds-background-input-hovered, #ebecf0)"
        }
    }
});

});
parcelRegister("6LBmA", function(module, exports) {

$parcel$export(module.exports, "EditTimeMessages", () => $4ed41d6b41268a11$export$294574788aa92dac);
$parcel$export(module.exports, "IntlEditTimeMessages", () => $4ed41d6b41268a11$export$9e56ea5118404c6c);

var $7VHMR = parcelRequire("7VHMR");
let $4ed41d6b41268a11$export$294574788aa92dac = /*#__PURE__*/ function(EditTimeMessages) {
    EditTimeMessages["TimePlaceholder"] = "TimePlaceholder";
    return EditTimeMessages;
}({});
const $4ed41d6b41268a11$export$9e56ea5118404c6c = (0, $7VHMR.defineMessages)({
    [$4ed41d6b41268a11$export$294574788aa92dac.TimePlaceholder]: {
        id: 'form-system.TimeQuestion.TimePlaceholder',
        defaultMessage: 'e.g. {time}'
    }
});

});




parcelRegister("37690", function(module, exports) {

$parcel$export(module.exports, "ViewDateTime", () => $2446caa628a316e5$export$2c68b874ce2247d1);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $koVbs = parcelRequire("koVbs");


var $8iale = parcelRequire("8iale");

var $6YylQ = parcelRequire("6YylQ");

var $hBksn = parcelRequire("hBksn");
function $2446caa628a316e5$var$parseDatetimeValueForView(dateAnswer, timeAnswer, intl) {
    const formattedDateValue = dateAnswer.length < 1 ? '' : new Intl.DateTimeFormat(intl.locale, {
        ...(0, $6YylQ.longDateOnlyFormat),
        timeZone: 'UTC'
    }).format(new Date(dateAnswer));
    let formattedTimeValue = '';
    if (timeAnswer.length) {
        const timeSplit = timeAnswer.split(':');
        const hours = parseInt(timeSplit[0], 10);
        const minutes = parseInt(timeSplit[1], 10);
        formattedTimeValue = new Intl.DateTimeFormat(intl.locale, {
            ...(0, $6YylQ.longTimeOnlyFormat),
            timeZone: 'UTC'
        }).format(Date.UTC(0, 0, 1, hours, minutes));
    }
    return {
        formattedDateValue: formattedDateValue,
        formattedTimeValue: formattedTimeValue
    };
}
const $2446caa628a316e5$export$2c68b874ce2247d1 = ({ dateValue: dateValue, timeValue: timeValue, displayMode: displayMode })=>{
    const intl = (0, $koVbs.default)();
    const { formattedDateValue: formattedDateValue, formattedTimeValue: formattedTimeValue } = $2446caa628a316e5$var$parseDatetimeValueForView(dateValue || '', timeValue || '', intl);
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2446caa628a316e5$var$LongDisabledQuestionPlaceholder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2446caa628a316e5$var$DateTimeQuestionSubPlaceholder, null, formattedDateValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2446caa628a316e5$var$DateTimeQuestionSubPlaceholder, null, formattedTimeValue));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, formattedDateValue && !formattedTimeValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formattedDateValue), !formattedDateValue && formattedTimeValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formattedTimeValue), formattedDateValue && formattedTimeValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, `${formattedDateValue}, ${formattedTimeValue}`));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2446caa628a316e5$var$DateTimeQuestionSubPlaceholder = (0, $dAHxw.default).div({
    width: '50%',
    padding: "var(--ds-space-100, 8px)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2446caa628a316e5$var$LongDisabledQuestionPlaceholder = (0, $dAHxw.default).div({
    borderStyle: 'solid',
    borderColor: "var(--ds-border-disabled, #DFE1E6)",
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 2px)",
    backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`,
    cursor: 'default',
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    color: `var(--ds-text-disabled, ${(0, $a7f8c6b391092279$export$5f71e19f3a7ad9de)})`,
    width: '320px'
});

});


parcelRegister("6r1D6", function(module, exports) {

$parcel$export(module.exports, "LongText", () => $4af6874d47ad7dec$export$7e7c4cb6f8068ef2);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $5SeaB = parcelRequire("5SeaB");

var $iBr5x = parcelRequire("iBr5x");

var $1ZO5m = parcelRequire("1ZO5m");
const $4af6874d47ad7dec$export$7e7c4cb6f8068ef2 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit;
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iBr5x.EditLongText), {
            id: id,
            value: (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer),
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            onChange: (event)=>questionStore.setAnswer(event.target.value),
            label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5SeaB.KbSuggestionFieldWrapper), {
            questionStore: questionStore
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ZO5m.ViewLongText), {
        id: id,
        value: (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer),
        displayMode: displayMode
    });
});

});
parcelRegister("5SeaB", function(module, exports) {

$parcel$export(module.exports, "KbSuggestionFieldWrapper", () => $446cfcc8f4b78ed4$export$452cd7af2ce503e3);

var $5uXOq = parcelRequire("5uXOq");

var $e96BB = parcelRequire("e96BB");
const $446cfcc8f4b78ed4$export$452cd7af2ce503e3 = ({ questionStore: questionStore })=>{
    const { KbSuggestionField: KbSuggestionField } = (0, $e96BB.usePortalCreateContext)();
    return questionStore.formQuestion.jiraField === 'summary' && KbSuggestionField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KbSuggestionField, null) : null;
};

});
parcelRegister("e96BB", function(module, exports) {

$parcel$export(module.exports, "usePortalCreateContext", () => $a4c707a6de8d86a1$export$32ac7395fd280394);

var $5uXOq = parcelRequire("5uXOq");
const $a4c707a6de8d86a1$var$PortalCreateContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $a4c707a6de8d86a1$export$2d5163f5d25155ab = ({ KbSuggestionField: KbSuggestionField, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4c707a6de8d86a1$var$PortalCreateContext.Provider, {
        value: {
            KbSuggestionField: KbSuggestionField
        }
    }, children);
};
function $a4c707a6de8d86a1$export$32ac7395fd280394() {
    var _portalCreateContextD;
    const portalCreateContextData = (0, $5uXOq.useContext)($a4c707a6de8d86a1$var$PortalCreateContext);
    return {
        KbSuggestionField: (_portalCreateContextD = portalCreateContextData === null || portalCreateContextData === void 0 ? void 0 : portalCreateContextData.KbSuggestionField) !== null && _portalCreateContextD !== void 0 ? _portalCreateContextD : undefined
    };
}

});


parcelRegister("iBr5x", function(module, exports) {

$parcel$export(module.exports, "EditLongText", () => $d8b0b1e5cea9ff67$export$dbe61e9bf5805eb5);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $fHpHg = parcelRequire("fHpHg");

var $9r7BT = parcelRequire("9r7BT");
const $d8b0b1e5cea9ff67$export$dbe61e9bf5805eb5 = ({ id: id, value: value, isInvalid: isInvalid, isRequired: isRequired, onChange: onChange, label: label })=>{
    // Local state required to show textfield changes as onChange callback is debounced.
    // Without it, user will only see their last inputted character added within the debounce period.
    const [textFieldValue, setTextFieldValue] = (0, $5uXOq.useState)(value);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $fHpHg.fg)('debounce_proforma_text_field_edits')) setTextFieldValue(value);
    }, [
        value
    ]);
    const debouncedOnChange = (0, $5uXOq.useMemo)(()=>(0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? onChange ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onChange, 500) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), [
        onChange
    ]);
    const handleTextFieldChange = (0, $5uXOq.useCallback)((e)=>{
        e.persist();
        setTextFieldValue(e.target.value);
        debouncedOnChange(e);
    }, [
        debouncedOnChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
        id: id,
        value: (0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? textFieldValue : value,
        isInvalid: isInvalid,
        isRequired: isRequired,
        onChange: (0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? handleTextFieldChange : onChange,
        label: label,
        "aria-label": label,
        title: label,
        placeholder: ""
    }));
};

});

parcelRegister("1ZO5m", function(module, exports) {

$parcel$export(module.exports, "ViewLongText", () => $174256dcd4e2615e$export$39f50b0a4ef9ef2b);

var $5uXOq = parcelRequire("5uXOq");

var $8iale = parcelRequire("8iale");

var $hBksn = parcelRequire("hBksn");
const $174256dcd4e2615e$export$39f50b0a4ef9ef2b = ({ value: value, displayMode: displayMode })=>{
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.TextfieldDisabledWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, value));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, value);
};

});


parcelRegister("bVxQm", function(module, exports) {

$parcel$export(module.exports, "MultiChoice", () => $8aef4533a6df0de3$export$70859b46811b52c1);

var $5uXOq = parcelRequire("5uXOq");

var $alnGD = parcelRequire("alnGD");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $fwzSF = parcelRequire("fwzSF");

var $gIvFI = parcelRequire("gIvFI");
const $8aef4533a6df0de3$export$70859b46811b52c1 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
    const availableOptions = questionStore.availableOptions();
    const currentAnswer = (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
    const currentOptions = availableOptions.filter((option)=>currentAnswer.choices.includes(option.value));
    const hasOtherChoice = !!questionStore.otherChoiceId;
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit;
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2;
        const onChange = (event)=>{
            const newChoiceId = event.target.value;
            const currentAnswer = (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
            let newChoiceIds = [
                ...(0, $alnGD.toJS)(currentAnswer.choices)
            ];
            if (newChoiceIds.includes(newChoiceId)) newChoiceIds = newChoiceIds.filter((choiceId)=>choiceId !== newChoiceId);
            else newChoiceIds.push(newChoiceId);
            questionStore.setAnswer({
                text: hasOtherChoice && newChoiceIds.some((choiceId)=>choiceId === questionStore.otherChoiceId) ? currentAnswer.text : '',
                choices: newChoiceIds
            });
        };
        const otherChoiceSelected = hasOtherChoice && currentOptions.some((option)=>option.value === questionStore.otherChoiceId);
        const onOtherChoiceTextChange = (event)=>{
            questionStore.setAnswer({
                text: event.target.value,
                choices: (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).choices
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fwzSF.EditMultiChoice), {
            id: id,
            options: availableOptions,
            value: currentOptions,
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            onChange: onChange,
            hasOtherOption: hasOtherChoice,
            otherOptionSelected: otherChoiceSelected,
            otherOptionText: currentAnswer.text,
            onOtherOptionTextChange: onOtherChoiceTextChange
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gIvFI.ViewMultiChoice), {
        id: id,
        options: availableOptions,
        value: currentOptions,
        hasOtherOption: hasOtherChoice,
        otherOptionText: currentAnswer.text,
        displayMode: displayMode
    });
});

});
parcelRegister("fwzSF", function(module, exports) {

$parcel$export(module.exports, "EditMultiChoice", () => $b4d5ad53df3ef11d$export$15915f0c4ed40c0a);

var $5uXOq = parcelRequire("5uXOq");

var $aveRr = parcelRequire("aveRr");

var $9FSw2 = parcelRequire("9FSw2");

var $i1R0l = parcelRequire("i1R0l");

var $hBksn = parcelRequire("hBksn");

var $3uIOs = parcelRequire("3uIOs");
const $b4d5ad53df3ef11d$export$15915f0c4ed40c0a = ({ id: id, options: options, value: value, isInvalid: isInvalid, isRequired: isRequired, onChange: onChange, hasOtherOption: hasOtherOption, otherOptionSelected: otherOptionSelected, otherOptionText: otherOptionText, onOtherOptionTextChange: onOtherOptionTextChange, warningMessage: warningMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ChoiceFieldWrapper), {
        isDisabled: false,
        isInvalid: isInvalid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, options !== null && options !== void 0 && options.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i1R0l.ChoiceQuestionStyles), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: id
    }, options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aveRr.default), {
            name: id,
            key: option.value,
            value: option.value,
            label: option.label,
            isChecked: value === null || value === void 0 ? void 0 : value.includes(option),
            onChange: onChange,
            "aria-required": isRequired
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ChoicePlaceholder), null), hasOtherOption && otherOptionSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uIOs.EditOtherOption), {
        dropdown: false,
        value: otherOptionText,
        isDisabled: !otherOptionSelected,
        onChange: onOtherOptionTextChange,
        id: id
    }))), warningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
        appearance: "warning"
    }, warningMessage));
};

});
parcelRegister("i1R0l", function(module, exports) {

$parcel$export(module.exports, "ChoiceQuestionStyles", () => $d2016f9c4b338c04$export$c19d7d5bbf8b0a0a);
$parcel$export(module.exports, "darkSelectStyles", () => $d2016f9c4b338c04$export$a4905290da34703d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dAHxw = parcelRequire("dAHxw");

const $d2016f9c4b338c04$export$c19d7d5bbf8b0a0a = (0, $dAHxw.default).div({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'initial'
});
const $d2016f9c4b338c04$export$a4905290da34703d = {
    control: (provided)=>({
            ...provided,
            backgroundColor: `var(--ds-background-input, ${0, $a7f8c6b391092279$export$3e51e8f1440314ba})`,
            borderWidth: '2px',
            borderColor: `var(--ds-border, ${0, $a7f8c6b391092279$export$3e51e8f1440314ba})`,
            borderRadius: '3px'
        })
};

});


parcelRegister("gIvFI", function(module, exports) {

$parcel$export(module.exports, "ViewMultiChoice", () => $c2b952caaf3b0bfb$export$44f53fea20230d97);

var $5uXOq = parcelRequire("5uXOq");

var $aveRr = parcelRequire("aveRr");

var $8iale = parcelRequire("8iale");

var $i1R0l = parcelRequire("i1R0l");

var $hBksn = parcelRequire("hBksn");

var $5aEbC = parcelRequire("5aEbC");
const $c2b952caaf3b0bfb$export$44f53fea20230d97 = ({ id: id, value: value, options: options, hasOtherOption: hasOtherOption, otherOptionText: otherOptionText, displayMode: displayMode })=>{
    // if the user has selected 'Other...' and provided a value we display that value. Otherwise we display 'Other...'
    const labels = value && value.map((item)=>item.label);
    if (labels && hasOtherOption && otherOptionText) {
        labels.push(otherOptionText);
        // the actual 'Other...' option will always be the last one in the array, we do not display this in view mode
        // it is the last one in case the user added their own option that is also called 'Other...'
        const lastIndex = labels.lastIndexOf('Other...');
        if (lastIndex !== -1) labels.splice(lastIndex, 1);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ChoiceFieldWrapper), {
        isDisabled: true,
        isView: displayMode === (0, $8iale.DisplayMode).View
    }, options !== null && options !== void 0 && options.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i1R0l.ChoiceQuestionStyles), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: id
    }, options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aveRr.default), {
            name: id,
            key: option.value,
            value: option.value,
            label: option.label,
            isChecked: value === null || value === void 0 ? void 0 : value.includes(option),
            isDisabled: true
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ChoicePlaceholder), null), otherOptionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5aEbC.ViewOtherOption), {
        dropdown: false,
        display: hasOtherOption,
        value: otherOptionText
    }));
};

});


parcelRegister("gqc26", function(module, exports) {

$parcel$export(module.exports, "Number", () => $bf48688a24befee2$export$fffa67e515d04022);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $dfSSA = parcelRequire("dfSSA");

var $lSbYB = parcelRequire("lSbYB");
const $bf48688a24befee2$export$fffa67e515d04022 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit;
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dfSSA.EditNumber), {
            id: id,
            value: (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer),
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            onChange: (event)=>{
                const value = event.target.value.trim().replace(/[^\d.\-,]/g, '');
                questionStore.setAnswer(value);
            },
            label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lSbYB.ViewNumber), {
        id: id,
        value: (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer),
        displayMode: displayMode
    });
});

});
parcelRegister("dfSSA", function(module, exports) {

$parcel$export(module.exports, "EditNumber", () => $9a673f024c5e3de4$export$63f6e55a0e1fdd5);

var $5uXOq = parcelRequire("5uXOq");

var $9r7BT = parcelRequire("9r7BT");
const $9a673f024c5e3de4$export$63f6e55a0e1fdd5 = ({ id: id, value: value, isInvalid: isInvalid, isRequired: isRequired, onChange: onChange, label: label })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
        id: id,
        value: value,
        isInvalid: isInvalid,
        isRequired: isRequired,
        onChange: onChange,
        width: "small",
        label: label,
        "aria-label": label,
        title: label,
        placeholder: ""
    });
};

});

parcelRegister("lSbYB", function(module, exports) {

$parcel$export(module.exports, "ViewNumber", () => $fec7ee67db18a81b$export$ba244afa8d066f60);

var $5uXOq = parcelRequire("5uXOq");

var $9r7BT = parcelRequire("9r7BT");

var $8iale = parcelRequire("8iale");

var $hBksn = parcelRequire("hBksn");
const $fec7ee67db18a81b$export$ba244afa8d066f60 = ({ id: id, value: value, displayMode: displayMode })=>{
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.FieldDisabledWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
        id: id,
        value: value,
        isReadOnly: true,
        width: "small",
        label: "number",
        "aria-label": "number field",
        title: "number",
        placeholder: "",
        role: "presentation"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, value);
};

});


parcelRegister("isuZ1", function(module, exports) {

$parcel$export(module.exports, "Paragraph", () => $d702e0296fa8e174$export$358a232cca1ab2ac);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $jF2nc = parcelRequire("jF2nc");

var $2FULG = parcelRequire("2FULG");
const $d702e0296fa8e174$export$358a232cca1ab2ac = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit;
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jF2nc.EditParagraph), {
            id: id,
            value: (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer),
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            onChange: (event)=>questionStore.setAnswer(event.target.value),
            label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FULG.ViewParagraph), {
        id: id,
        value: (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer),
        displayMode: displayMode
    });
});

});
parcelRegister("jF2nc", function(module, exports) {

$parcel$export(module.exports, "EditParagraph", () => $03b19b9caa1c2997$export$cffad3bd4cd5e3a2);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $fHpHg = parcelRequire("fHpHg");

var $bjTxt = parcelRequire("bjTxt");
const $03b19b9caa1c2997$export$cffad3bd4cd5e3a2 = ({ id: id, value: value, isInvalid: isInvalid, isRequired: isRequired, onChange: onChange, label: label })=>{
    // Local state required to show textarea changes as onChange callback is debounced.
    // Without it, user will only see their last inputted character added within the debounce period.
    const [textAreaValue, setTextAreaValue] = (0, $5uXOq.useState)(value);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $fHpHg.fg)('debounce_proforma_text_field_edits')) setTextAreaValue(value);
    }, [
        value
    ]);
    const debouncedOnChange = (0, $5uXOq.useMemo)(()=>(0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? onChange ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onChange, 500) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), [
        onChange
    ]);
    const handleTextAreaChange = (0, $5uXOq.useCallback)((e)=>{
        e.persist();
        setTextAreaValue(e.target.value);
        debouncedOnChange(e);
    }, [
        debouncedOnChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bjTxt.default), {
        appearance: "standard",
        isCompact: false,
        isDisabled: false,
        isReadOnly: false,
        isInvalid: isInvalid,
        isRequired: isRequired,
        minimumRows: 5,
        maxHeight: "none",
        isMonospaced: false,
        value: (0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? textAreaValue : value,
        defaultValue: undefined,
        resize: "smart",
        spellCheck: false,
        onBlur: undefined,
        onChange: (0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? handleTextAreaChange : onChange,
        onFocus: undefined,
        id: id,
        "aria-label": label
    });
};

});

parcelRegister("2FULG", function(module, exports) {

$parcel$export(module.exports, "ViewParagraph", () => $1f2b72149b30f41c$export$c181b145ef549ce6);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");


var $8iale = parcelRequire("8iale");

var $hBksn = parcelRequire("hBksn");
const $1f2b72149b30f41c$export$c181b145ef549ce6 = ({ value: value, displayMode: displayMode })=>{
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f2b72149b30f41c$var$DisabledParagraphPlaceholder, null, value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, value);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f2b72149b30f41c$var$DisabledParagraphPlaceholder = (0, $dAHxw.default).div({
    borderStyle: 'solid',
    borderColor: `var(--ds-border-disabled, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)})`,
    borderRadius: '3px',
    borderWidth: '2px',
    backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`,
    cursor: 'default',
    padding: "var(--ds-space-075, 6px)",
    minHeight: '100px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1.42857,
    color: `var(--ds-text-disabled, ${(0, $a7f8c6b391092279$export$5f71e19f3a7ad9de)})`
});

});


parcelRegister("aZCPa", function(module, exports) {

$parcel$export(module.exports, "RichTextParagraph", () => $800db79ae66c9018$export$ef0485d3887498d6);

var $5uXOq = parcelRequire("5uXOq");

var $LpImS = parcelRequire("LpImS");

var $ajpes = parcelRequire("ajpes");

var $alnGD = parcelRequire("alnGD");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $2UP8x = parcelRequire("2UP8x");

var $6g7dR = parcelRequire("6g7dR");
const $800db79ae66c9018$export$ef0485d3887498d6 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
    const richTextValue = (0, $alnGD.toJS)((0, $4QmvR.toRichTextQuestionAnswer)(questionStore.currentAnswer));
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit;
    //We pass a cloned 'richTextValue' to avoid the mutation by AsyncEditRichTextParagraph component
    const richTextValueCloned = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(richTextValue), [
        richTextValue
    ]);
    if (showEditComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2UP8x.AsyncEditRichTextParagraph), {
        id: id,
        value: richTextValueCloned,
        isInvalid: !!questionStore.validationErrors,
        onChange: (answer)=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(richTextValue, answer)) questionStore.setAnswer(answer);
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6g7dR.ViewRichTextParagraph), {
        id: id,
        value: richTextValue,
        displayMode: displayMode
    });
});

});
parcelRegister("2UP8x", function(module, exports) {

$parcel$export(module.exports, "AsyncEditRichTextParagraph", () => $21f87a701b042d2d$export$295cea8a1bb83d62);

var $5uXOq = parcelRequire("5uXOq");

var $kc9vJ = parcelRequire("kc9vJ");

const $21f87a701b042d2d$var$LazyEditRichTextParagraph = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("hvbv4")).then(({ EditRichTextParagraph: EditRichTextParagraph })=>EditRichTextParagraph), {
    ssr: false
});
const $21f87a701b042d2d$export$295cea8a1bb83d62 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kc9vJ.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21f87a701b042d2d$var$LazyEditRichTextParagraph, props));
};

});
parcelRegister("hvbv4", function(module, exports) {

let $cbde409e1e4c7b88$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cbde409e1e4c7b88$var$load("dsiAd"),
    $cbde409e1e4c7b88$var$load("h2MrD"),
    $cbde409e1e4c7b88$var$load("bYT2S"),
    $cbde409e1e4c7b88$var$load("cM9em"),
    $cbde409e1e4c7b88$var$load("fr9NE"),
    $cbde409e1e4c7b88$var$load("azJuy")
]).then(()=>parcelRequire('8tcuo'));

});


parcelRegister("6g7dR", function(module, exports) {

$parcel$export(module.exports, "ViewRichTextParagraph", () => $48e9d6f51b32d840$export$9f8ac553fae1fe6);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $fcIoh = parcelRequire("fcIoh");


var $8iale = parcelRequire("8iale");

var $hBksn = parcelRequire("hBksn");
const $48e9d6f51b32d840$export$9f8ac553fae1fe6 = ({ value: value, displayMode: displayMode })=>{
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48e9d6f51b32d840$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fcIoh.default), {
        document: value
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fcIoh.default), {
        document: value
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48e9d6f51b32d840$var$Wrapper = (0, $dAHxw.default).div({
    borderStyle: 'solid',
    borderColor: `var(--ds-border-disabled, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)})`,
    borderRadius: '3px',
    borderWidth: '2px',
    backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`,
    padding: "var(--ds-space-075, 6px)",
    minHeight: '100px',
    color: `var(--ds-text-disabled, ${(0, $a7f8c6b391092279$export$5f71e19f3a7ad9de)})`
});

});


parcelRegister("erYCV", function(module, exports) {

$parcel$export(module.exports, "ShortText", () => $a8529d85c0ff25d6$export$5f45173d0e4e8a25);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $5SeaB = parcelRequire("5SeaB");

var $kjJHk = parcelRequire("kjJHk");

var $5rWjI = parcelRequire("5rWjI");
const $a8529d85c0ff25d6$export$5f45173d0e4e8a25 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
    const value = (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer);
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit;
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjJHk.EditShortText), {
            id: id,
            value: value,
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            onChange: (event)=>questionStore.setAnswer(event.target.value),
            label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5SeaB.KbSuggestionFieldWrapper), {
            questionStore: questionStore
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rWjI.ViewShortText), {
        id: id,
        value: value,
        displayMode: displayMode
    });
});

});
parcelRegister("kjJHk", function(module, exports) {

$parcel$export(module.exports, "EditShortText", () => $eca907a382ad1335$export$64676e3eaae6b70f);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $fHpHg = parcelRequire("fHpHg");

var $9r7BT = parcelRequire("9r7BT");

var $hBksn = parcelRequire("hBksn");
const $eca907a382ad1335$export$64676e3eaae6b70f = ({ id: id, value: value, isInvalid: isInvalid, isRequired: isRequired, onChange: onChange, label: label })=>{
    // Local state required to show textfield changes as onChange callback is debounced.
    // Without it, user will only see their last inputted character added within the debounce period.
    const [textFieldValue, setTextFieldValue] = (0, $5uXOq.useState)(value);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $fHpHg.fg)('debounce_proforma_text_field_edits')) setTextFieldValue(value);
    }, [
        value
    ]);
    const debouncedOnChange = (0, $5uXOq.useMemo)(()=>(0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? onChange ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onChange, 500) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), [
        onChange
    ]);
    const handleTextFieldChange = (0, $5uXOq.useCallback)((e)=>{
        e.persist();
        setTextFieldValue(e.target.value);
        debouncedOnChange(e);
    }, [
        debouncedOnChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ShortTextFieldWrapper), {
        isDisabled: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
        id: id,
        value: (0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? textFieldValue : value,
        isInvalid: isInvalid,
        onChange: (0, $fHpHg.fg)('debounce_proforma_text_field_edits') ? handleTextFieldChange : onChange,
        width: "medium",
        label: label,
        "aria-label": label,
        title: label,
        placeholder: "",
        isRequired: isRequired
    }));
};

});

parcelRegister("5rWjI", function(module, exports) {

$parcel$export(module.exports, "ViewShortText", () => $3f7cb5e56b5e559f$export$871f3649be20241);

var $5uXOq = parcelRequire("5uXOq");

var $8iale = parcelRequire("8iale");

var $hBksn = parcelRequire("hBksn");
const $3f7cb5e56b5e559f$export$871f3649be20241 = ({ value: value, displayMode: displayMode })=>{
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ShortTextFieldWrapper), {
        isDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, value));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, value);
};

});


parcelRegister("f1Hmw", function(module, exports) {

$parcel$export(module.exports, "SingleChoice", () => $af0895dbcf5ab3c8$export$518ee1f8a60ca514);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $kDNl4 = parcelRequire("kDNl4");

var $3jE9l = parcelRequire("3jE9l");
const $af0895dbcf5ab3c8$export$518ee1f8a60ca514 = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
    var _currentAnswer$choice;
    const availableOptions = questionStore.availableOptions();
    const currentAnswer = (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer);
    const currentChoiceId = (_currentAnswer$choice = currentAnswer.choices) !== null && _currentAnswer$choice !== void 0 && _currentAnswer$choice.length ? currentAnswer.choices[0] : undefined;
    const currentOption = availableOptions.find((option)=>option.value === currentChoiceId);
    const hasOtherChoice = !!questionStore.otherChoiceId;
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit;
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2;
        const onChange = (event)=>{
            const selectedChoiceId = event.target.value;
            const newChoiceId = selectedChoiceId ? [
                selectedChoiceId
            ] : [];
            questionStore.setAnswer({
                text: hasOtherChoice && selectedChoiceId === questionStore.otherChoiceId ? (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).text : '',
                choices: newChoiceId
            });
        };
        const otherChoiceSelected = hasOtherChoice && currentChoiceId === questionStore.otherChoiceId;
        const onOtherChoiceTextChange = (event)=>{
            questionStore.setAnswer({
                text: event.target.value,
                choices: (0, $4QmvR.toChoiceQuestionAnswerOrEmpty)(questionStore.currentAnswer).choices
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kDNl4.EditSingleChoice), {
            id: id,
            options: availableOptions,
            value: currentOption,
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            onChange: onChange,
            hasOtherOption: hasOtherChoice,
            otherOptionSelected: otherChoiceSelected,
            otherOptionText: currentAnswer.text,
            onOtherOptionTextChange: onOtherChoiceTextChange
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jE9l.ViewSingleChoice), {
        id: id,
        options: availableOptions,
        value: currentOption,
        hasOtherOption: hasOtherChoice,
        otherOptionText: currentAnswer.text,
        displayMode: displayMode
    });
});

});
parcelRegister("kDNl4", function(module, exports) {

$parcel$export(module.exports, "EditSingleChoice", () => $f06db8cee684911e$export$acb5351231003cc);

var $5uXOq = parcelRequire("5uXOq");

var $9NQxf = parcelRequire("9NQxf");

var $9FSw2 = parcelRequire("9FSw2");

var $i1R0l = parcelRequire("i1R0l");

var $hBksn = parcelRequire("hBksn");

var $3uIOs = parcelRequire("3uIOs");
const $f06db8cee684911e$export$acb5351231003cc = ({ id: id, options: options, value: value, isInvalid: isInvalid, isRequired: isRequired, onChange: onChange, hasOtherOption: hasOtherOption, otherOptionSelected: otherOptionSelected, otherOptionText: otherOptionText, onOtherOptionTextChange: onOtherOptionTextChange, warningMessage: warningMessage })=>{
    var _value$value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ChoiceFieldWrapper), {
        isDisabled: false,
        isInvalid: isInvalid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, options !== null && options !== void 0 && options.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i1R0l.ChoiceQuestionStyles), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NQxf.default), {
        name: id,
        options: options.map((option)=>({
                label: option.label,
                value: option.value
            })),
        value: (_value$value = value === null || value === void 0 ? void 0 : value.value) !== null && _value$value !== void 0 ? _value$value : null // When `undefined` this is an uncontrolled component and uses internal state.
        ,
        onChange: onChange,
        "aria-labelledby": `label-${id}` // This id is linked to the id  of the label element from RennderQuestion.tsx
        ,
        isRequired: isRequired
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ChoicePlaceholder), null), hasOtherOption && otherOptionSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uIOs.EditOtherOption), {
        dropdown: false,
        value: otherOptionText,
        isDisabled: !otherOptionSelected,
        onChange: onOtherOptionTextChange,
        id: id
    }))), warningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
        appearance: "warning"
    }, warningMessage));
};

});
parcelRegister("9NQxf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a7e2eff578181947$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");

var $jJsBW = parcelRequire("jJsBW");

var $fOUic = parcelRequire("fOUic");
const $a7e2eff578181947$var$noOptions = [];
function $a7e2eff578181947$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $a7e2eff578181947$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $bKnKN.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $jJsBW.useId)();
    const [selectedValue, setSelectedValue] = (0, $5uXOq.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $fOUic.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});
parcelRegister("fOUic", function(module, exports) {

$parcel$export(module.exports, "default", () => $46ba0700e31f3518$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $fHpHg = parcelRequire("fHpHg");
const $46ba0700e31f3518$var$packageName = "platform-pkg";
const $46ba0700e31f3518$var$packageVersion = "0.0.0-use.local";
const $46ba0700e31f3518$var$noop = (0, $bKnKN.default);
const $46ba0700e31f3518$var$labelPaddingStyles = null;
const $46ba0700e31f3518$var$labelStyles = null;
const $46ba0700e31f3518$var$radioStyles = null;
const $46ba0700e31f3518$var$newRadioStyles = null;
const $46ba0700e31f3518$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $46ba0700e31f3518$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $46ba0700e31f3518$var$packageName,
        packageVersion: $46ba0700e31f3518$var$packageVersion
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $bwpsq.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $fHpHg.fg)('platform-visual-refresh-icons') && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    (0, $fHpHg.fg)('platform-icon-control-migration') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $46ba0700e31f3518$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($46ba0700e31f3518$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $46ba0700e31f3518$export$2e2bcd8739ae039 = $46ba0700e31f3518$var$Radio;

});



parcelRegister("3jE9l", function(module, exports) {

$parcel$export(module.exports, "ViewSingleChoice", () => $26a24a599612ab04$export$edf119980eaa894f);

var $5uXOq = parcelRequire("5uXOq");

var $9NQxf = parcelRequire("9NQxf");

var $8iale = parcelRequire("8iale");

var $i1R0l = parcelRequire("i1R0l");

var $hBksn = parcelRequire("hBksn");

var $5aEbC = parcelRequire("5aEbC");
const $26a24a599612ab04$export$edf119980eaa894f = ({ id: id, value: value, options: options, hasOtherOption: hasOtherOption, otherOptionText: otherOptionText, displayMode: displayMode })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ChoiceFieldWrapper), {
        isDisabled: true,
        isView: displayMode === (0, $8iale.DisplayMode).View
    }, options !== null && options !== void 0 && options.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i1R0l.ChoiceQuestionStyles), null, options.map((option, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NQxf.default), {
            key: index,
            name: id,
            value: value === null || value === void 0 ? void 0 : value.value,
            options: [
                option
            ],
            isDisabled: true
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ChoicePlaceholder), null), otherOptionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5aEbC.ViewOtherOption), {
        dropdown: false,
        display: hasOtherOption,
        value: otherOptionText
    }));
};

});


parcelRegister("bfOs9", function(module, exports) {

$parcel$export(module.exports, "Time", () => $83183b5c5738b0f1$export$680ea196effce5f);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $6MwDx = parcelRequire("6MwDx");

var $70VLf = parcelRequire("70VLf");
const $83183b5c5738b0f1$export$680ea196effce5f = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, displayMode: displayMode })=>{
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit;
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6MwDx.EditTime), {
            id: id,
            value: (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer),
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            onChange: (value)=>{
                let returnValue = value;
                if (value.includes('am') || value.includes('pm')) returnValue = value.slice(0, -2);
                questionStore.setAnswer(returnValue);
            },
            label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70VLf.ViewTime), {
        id: id,
        value: (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer),
        displayMode: displayMode
    });
});

});
parcelRegister("70VLf", function(module, exports) {

$parcel$export(module.exports, "ViewTime", () => $51b5569efddb9e93$export$90499bba0174747e);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $1h7Rm = parcelRequire("1h7Rm");

var $fiX4W = parcelRequire("fiX4W");

var $8iale = parcelRequire("8iale");

var $giaor = parcelRequire("giaor");

var $6YylQ = parcelRequire("6YylQ");

var $hBksn = parcelRequire("hBksn");
const $51b5569efddb9e93$var$formatValueForView = (value, locale)=>{
    if (!value || value.length === 0) return '';
    const timeSplit = value.split(':');
    const hours = parseInt(timeSplit[0], 10);
    const minutes = parseInt(timeSplit[1], 10);
    return new Intl.DateTimeFormat(locale, {
        ...(0, $6YylQ.longTimeOnlyFormat),
        timeZone: 'UTC'
    }).format(Date.UTC(0, 0, 1, hours, minutes));
};
const $51b5569efddb9e93$export$90499bba0174747e = ({ id: id, value: value, displayMode: displayMode })=>{
    const intl = (0, $koVbs.default)();
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ShortFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.FieldDisabledWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1h7Rm.default), {
        id: id,
        value: value,
        locale: intl.locale || (0, $fiX4W.DEFAULT_LOCALE),
        timeIsEditable: true,
        placeholder: " ",
        isDisabled: true,
        appearance: "subtle",
        times: (0, $giaor.times)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, $51b5569efddb9e93$var$formatValueForView(value, intl.locale));
};

});


parcelRegister("fGwwO", function(module, exports) {

$parcel$export(module.exports, "UrlText", () => $02f26323d352870a$export$9540a67a0f90e032);

var $5uXOq = parcelRequire("5uXOq");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $6r1D6 = parcelRequire("6r1D6");

var $l4CPE = parcelRequire("l4CPE");
const $02f26323d352870a$export$9540a67a0f90e032 = (questionProps)=>{
    const { questionStore: questionStore, displayMode: displayMode, id: fieldId } = questionProps;
    return displayMode === (0, $8iale.DisplayMode).Edit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6r1D6.LongText), questionProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l4CPE.ViewUrlText), {
        id: fieldId,
        value: (0, $4QmvR.toTextQuestionAnswer)(questionStore.currentAnswer),
        displayMode: displayMode
    });
};

});
parcelRegister("l4CPE", function(module, exports) {

$parcel$export(module.exports, "ViewUrlText", () => $f57817edfd8aebbf$export$3eaa24e64e359c45);

var $5uXOq = parcelRequire("5uXOq");

var $iZOJ9 = parcelRequire("iZOJ9");

var $8iale = parcelRequire("8iale");

var $hBksn = parcelRequire("hBksn");
const $f57817edfd8aebbf$export$3eaa24e64e359c45 = ({ value: value, displayMode: displayMode })=>{
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.TextfieldDisabledWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, value !== undefined && (0, $iZOJ9.isSafeUrl)(value) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: value,
        target: "_blank",
        rel: "noopener noreferrer"
    }, value) : value));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, value !== undefined && (0, $iZOJ9.isSafeUrl)(value) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: value,
        target: "_blank",
        rel: "noopener noreferrer"
    }, value) : value);
};

});


parcelRegister("gyvX2", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $c0d89b26febf513c$export$83e0c73b09b3a9cd);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("f2sTC");
var $jJXgM = parcelRequire("jJXgM");

var $cnwtr = parcelRequire("cnwtr");

var $4aJmI = parcelRequire("4aJmI");

var $4QmvR = parcelRequire("4QmvR");

var $8iale = parcelRequire("8iale");

var $lz5Pa = parcelRequire("lz5Pa");

var $1JRg6 = parcelRequire("1JRg6");
const $c0d89b26febf513c$export$83e0c73b09b3a9cd = (0, $jJXgM.observer)(({ id: id, questionStore: questionStore, formStore: formStore, displayMode: displayMode })=>{
    const isMulti = questionStore.formQuestion.type === (0, $4aJmI.FormQuestionType).UserMultiple;
    const value = questionStore.currentAnswer ? (0, $4QmvR.toUserPickerQuestionAnswerOrEmpty)(questionStore.currentAnswer).map((item)=>({
            value: item.id,
            label: item.name
        })) : null;
    const showEditComponent = displayMode === (0, $8iale.DisplayMode).Edit;
    if (showEditComponent) {
        var _questionStore$formQu, _questionStore$formQu2, _questionStore$formQu3;
        const loadOptions = (0, $cnwtr.debounce)((inputValue, callback)=>{
            const input = inputValue.trim();
            if (input) {
                var _questionStore$issueF;
                formStore.searchUsersWithFieldConfig(questionStore.formQuestion.jiraField, (_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 ? void 0 : _questionStore$issueF.fieldConfigId, input).then((results)=>{
                    callback(results);
                }).catch((error)=>{
                    callback([]);
                });
            } else callback([]);
        }, 500);
        const onChange = (newValue)=>{
            let values;
            if (!newValue) values = [];
            else if (isMulti) values = newValue.map((item)=>{
                return {
                    id: item.value,
                    name: item.label
                };
            });
            else values = [
                {
                    id: newValue.value,
                    name: newValue.label
                }
            ];
            questionStore.setAnswer(values);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lz5Pa.EditUserPicker), {
            id: id,
            isMulti: isMulti,
            value: value,
            loadOptions: loadOptions,
            onChange: onChange,
            isInvalid: !!questionStore.validationErrors,
            isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 ? void 0 : (_questionStore$formQu2 = _questionStore$formQu.validation) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.rq,
            label: (_questionStore$formQu3 = questionStore.formQuestion) === null || _questionStore$formQu3 === void 0 ? void 0 : _questionStore$formQu3.label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JRg6.ViewUserPicker), {
        id: id,
        isMulti: isMulti,
        value: value,
        displayMode: displayMode
    });
});

});
parcelRegister("lz5Pa", function(module, exports) {

$parcel$export(module.exports, "EditUserPicker", () => $fb3162767ca80cc2$export$77369e24c8177d52);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $ia3X2 = parcelRequire("ia3X2");

var $4dI0P = parcelRequire("4dI0P");

var $hBksn = parcelRequire("hBksn");

var $i3bxp = parcelRequire("i3bxp");

var $6YPn9 = parcelRequire("6YPn9");
const $fb3162767ca80cc2$export$77369e24c8177d52 = ({ id: id, isMulti: isMulti, value: value, loadOptions: loadOptions, onChange: onChange, isInvalid: isInvalid, isRequired: isRequired, label: label })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.SelectErrorContainer), {
        isInvalid: isInvalid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ia3X2.default), (0, $bS32t.default)({
        id: id,
        value: value,
        loadOptions: loadOptions,
        noOptionsMessage: (input)=>{
            if (input !== null && input !== void 0 && input.inputValue) // The user entered something and we couldn't find a match.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownNoOptions);
            // The user hasn't started typing yet, or deleted what they had typed.
            return intl.formatMessage((0, $i3bxp.IntlEditUserPickerMessages)[(0, $i3bxp.EditUserPickerMessage).UserPickerStartTyping]);
        },
        cacheOptions: true,
        isMulti: isMulti,
        isClearable: true,
        loadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownLoading),
        defaultOptions: true,
        onChange: onChange,
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6YPn9.messages).choiceDropdownSelect),
        isRequired: isRequired,
        label: label
    }, (0, $4dI0P.getDropDownMenuPosition)())));
};

});
parcelRegister("i3bxp", function(module, exports) {

$parcel$export(module.exports, "EditUserPickerMessage", () => $0364270c64e8bfa2$export$16234d9772cc0f0b);
$parcel$export(module.exports, "IntlEditUserPickerMessages", () => $0364270c64e8bfa2$export$37c452ac81af37c9);

var $7VHMR = parcelRequire("7VHMR");
let $0364270c64e8bfa2$export$16234d9772cc0f0b = /*#__PURE__*/ function(EditUserPickerMessage) {
    EditUserPickerMessage["UserPickerStartTyping"] = "UserPickerStartTyping";
    return EditUserPickerMessage;
}({});
const $0364270c64e8bfa2$export$37c452ac81af37c9 = (0, $7VHMR.defineMessages)({
    [$0364270c64e8bfa2$export$16234d9772cc0f0b.UserPickerStartTyping]: {
        id: 'form-system.UserPicker.UserPickerStartTyping',
        defaultMessage: 'Start typing to search for users'
    }
});

});


parcelRegister("1JRg6", function(module, exports) {

$parcel$export(module.exports, "ViewUserPicker", () => $14434e824cb0001e$export$df59b12b504e64b4);

var $5uXOq = parcelRequire("5uXOq");

var $lau8t = parcelRequire("lau8t");


var $8iale = parcelRequire("8iale");

var $hBksn = parcelRequire("hBksn");
const $14434e824cb0001e$export$df59b12b504e64b4 = ({ id: id, isMulti: isMulti, value: value, displayMode: displayMode })=>{
    if (displayMode === (0, $8iale.DisplayMode).Edit || displayMode === (0, $8iale.DisplayMode).Preview || displayMode === (0, $8iale.DisplayMode).Translate) // This is a Disabled Select
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lau8t.default), {
        id: id,
        value: value,
        isMulti: isMulti,
        isDisabled: true,
        styles: {
            control: (base)=>({
                    ...base,
                    backgroundColor: `var(--ds-background-accent-gray-subtlest, ${0, $a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                    borderColor: "var(--ds-border-disabled, #DFE1E6)",
                    color: "var(--ds-text, #172B4D !important)"
                }),
            menu: (base)=>({
                    ...base,
                    color: "var(--ds-text-subtle, #172B4D)"
                })
        },
        isClearable: true,
        defaultOptions: true,
        placeholder: ""
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ViewWrapper), null, value && value.map((item)=>item.label).join(', '));
};

});



parcelRegister("4OnBQ", function(module, exports) {

$parcel$export(module.exports, "QuestionErrorMsg", () => $380e253ff8ebade2$export$4cac87f7e054d053);

var $5uXOq = parcelRequire("5uXOq");

var $k5Wbc = parcelRequire("k5Wbc");

var $fHpHg = parcelRequire("fHpHg");

var $hBksn = parcelRequire("hBksn");
const $380e253ff8ebade2$export$4cac87f7e054d053 = ({ validationErrors: validationErrors })=>{
    return (0, $fHpHg.fg)('a11y_error_messages') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ErrorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.MessageWrapper), null, validationErrors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), null, validationErrors.map((validationError)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            key: validationError.key
        }, validationError.message, "\xA0");
    }), "\xA0"))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBksn.ErrorWrapper), null, validationErrors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.ErrorMessage), null, validationErrors.map((validationError)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            key: validationError.key
        }, validationError.message, "\xA0");
    }), "\xA0"));
};

});

parcelRegister("d6RcY", function(module, exports) {

$parcel$export(module.exports, "QuestionHelperMsg", () => $98b51bee2b5403ca$export$1872e1e6dda4cf63);

var $5uXOq = parcelRequire("5uXOq");

var $dAHxw = parcelRequire("dAHxw");

var $k5Wbc = parcelRequire("k5Wbc");

var $k9nuy = parcelRequire("k9nuy");

const $98b51bee2b5403ca$export$1872e1e6dda4cf63 = ({ description: description })=>{
    return !!description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98b51bee2b5403ca$var$HelperMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k5Wbc.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
        testId: "description"
    }, description))) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98b51bee2b5403ca$var$HelperMessageWrapper = (0, $dAHxw.default).div({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    span: {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        marginBottom: "var(--ds-space-050, 4px)",
        color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`
    }
});

});

parcelRegister("bQ3UU", function(module, exports) {

$parcel$export(module.exports, "UnknownQuestionType", () => $89e796d82e5a277c$export$83ab0504c2d7cd30);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $k9nuy = parcelRequire("k9nuy");

var $2Ce34 = parcelRequire("2Ce34");

var $dXYuS = parcelRequire("dXYuS");

var $7gmPx = parcelRequire("7gmPx");

var $eaUiW = parcelRequire("eaUiW");
function $89e796d82e5a277c$export$83ab0504c2d7cd30({ questionType: questionType }) {
    const intl = (0, $koVbs.default)();
    const questionTypeMessage = (0, $2Ce34.IntlQuestionTypeMessages)[(0, $dXYuS.questionTypeToQuestionTypeMessage)(questionType)];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaUiW.UnknownQuestionTypeText), {
        "data-testid": "proforma-unknown-question"
    }, intl.formatMessage((0, $7gmPx.messages).unknownQuestionType, {
        questionType: questionTypeMessage ? intl.formatMessage(questionTypeMessage) : '',
        // Cannot rely on ProformaIntlProvider for this since this could be rendered inside the editor (which prevents accesses from providers outside)
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
                as: "strong"
            }, chunks)
    }));
}

});
parcelRegister("2Ce34", function(module, exports) {

$parcel$export(module.exports, "QuestionTypeMessage", () => $1e7a071bc1fc5bb0$export$8f21f8f314b6a220);
$parcel$export(module.exports, "IntlQuestionTypeMessages", () => $1e7a071bc1fc5bb0$export$1fcc5e9b2fea45ca);

var $7VHMR = parcelRequire("7VHMR");
let $1e7a071bc1fc5bb0$export$8f21f8f314b6a220 = /*#__PURE__*/ function(QuestionTypeMessage) {
    QuestionTypeMessage["TextQuestionsGroupLabel"] = "TextQuestionsGroupLabel";
    QuestionTypeMessage["TextShortLabel"] = "TextShortLabel";
    QuestionTypeMessage["TextAttachmentLabel"] = "TextAttachmentLabel";
    QuestionTypeMessage["TextLongLabel"] = "TextLongLabel";
    QuestionTypeMessage["TextParagraphLabel"] = "TextParagraphLabel";
    QuestionTypeMessage["PlainTextParagraphLabel"] = "PlainTextParagraphLabel";
    QuestionTypeMessage["RichTextParagraphLabel"] = "RichTextParagraphLabel";
    QuestionTypeMessage["TextEmailLabel"] = "TextEmailLabel";
    QuestionTypeMessage["TextUrlLabel"] = "TextUrlLabel";
    QuestionTypeMessage["ChoiceCascadingLabel"] = "ChoiceCascadingLabel";
    QuestionTypeMessage["ChoiceQuestionsGroupLabel"] = "ChoiceQuestionsGroupLabel";
    QuestionTypeMessage["ChoiceSingleLabel"] = "ChoiceSingleLabel";
    QuestionTypeMessage["ChoiceMultipleLabel"] = "ChoiceMultipleLabel";
    QuestionTypeMessage["ChoiceDropdownLabel"] = "ChoiceDropdownLabel";
    QuestionTypeMessage["ChoiceDropdownMultipleLabel"] = "ChoiceDropdownMultipleLabel";
    QuestionTypeMessage["CmdbObjectLabel"] = "CmdbObjectLabel";
    QuestionTypeMessage["DateQuestionsGroupLabel"] = "DateQuestionsGroupLabel";
    QuestionTypeMessage["DateLabel"] = "DateLabel";
    QuestionTypeMessage["DateTimeLabel"] = "DateTimeLabel";
    QuestionTypeMessage["TimeLabel"] = "TimeLabel";
    QuestionTypeMessage["NumericQuestionsGroupLabel"] = "NumericQuestionsGroupLabel";
    QuestionTypeMessage["NumberLabel"] = "NumberLabel";
    QuestionTypeMessage["UserQuestionsGroupLabel"] = "UserQuestionsGroupLabel";
    QuestionTypeMessage["UserSingleLabel"] = "UserSingleLabel";
    QuestionTypeMessage["UserMultipleLabel"] = "UserMultipleLabel";
    QuestionTypeMessage["UnsupportedLabel"] = "UnsupportedLabel";
    return QuestionTypeMessage;
}({});
const $1e7a071bc1fc5bb0$export$1fcc5e9b2fea45ca = (0, $7VHMR.defineMessages)({
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextQuestionsGroupLabel]: {
        id: 'form-builder.QuestionType.TextQuestionsGroupLabel',
        defaultMessage: 'Text fields'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextAttachmentLabel]: {
        id: 'form-builder.QuestionType.TextAttachmentLabel',
        defaultMessage: 'Attachment'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextShortLabel]: {
        id: 'form-builder.QuestionType.TextShortLabel',
        defaultMessage: 'Short text'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextLongLabel]: {
        id: 'form-builder.QuestionType.TextLongLabel',
        defaultMessage: 'Long text'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextParagraphLabel]: {
        id: 'form-builder.QuestionType.TextParagraphLabel',
        defaultMessage: 'Paragraph'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.PlainTextParagraphLabel]: {
        id: 'form-builder.QuestionType.PlainTextParagraphLabel',
        defaultMessage: 'Paragraph (Plain text)'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.RichTextParagraphLabel]: {
        id: 'form-builder.QuestionType.RichTextParagraphLabel',
        defaultMessage: 'Paragraph'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextEmailLabel]: {
        id: 'form-builder.QuestionType.TextEmailLabel',
        defaultMessage: 'Email'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TextUrlLabel]: {
        id: 'form-builder.QuestionType.TextUrlLabel',
        defaultMessage: 'URL'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceQuestionsGroupLabel]: {
        id: 'form-builder.QuestionType.ChoiceQuestionsGroupLabel',
        defaultMessage: 'Choice fields'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceCascadingLabel]: {
        id: 'form-builder.QuestionType.ChoiceCascadingLabel',
        defaultMessage: 'Cascading dropdown'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceSingleLabel]: {
        id: 'form-builder.QuestionType.ChoiceSingleLabel',
        defaultMessage: 'Radio buttons'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceMultipleLabel]: {
        id: 'form-builder.QuestionType.ChoiceMultipleLabel',
        defaultMessage: 'Checkboxes'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceDropdownLabel]: {
        id: 'form-builder.QuestionType.ChoiceDropdownLabel',
        defaultMessage: 'Dropdown'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.ChoiceDropdownMultipleLabel]: {
        id: 'form-builder.QuestionType.ChoiceDropdownMultipleLabel',
        defaultMessage: 'Multiselect dropdown'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.CmdbObjectLabel]: {
        id: 'form-builder.QuestionType.CmdbObjectLabel',
        defaultMessage: 'Assets object/s'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.DateQuestionsGroupLabel]: {
        id: 'form-builder.QuestionType.DateQuestionsGroupLabel',
        defaultMessage: 'Date fields'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.DateLabel]: {
        id: 'form-builder.QuestionType.DateLabel',
        defaultMessage: 'Date'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.DateTimeLabel]: {
        id: 'form-builder.QuestionType.DateTimeLabel',
        defaultMessage: 'Date & Time'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.TimeLabel]: {
        id: 'form-builder.QuestionType.TimeLabel',
        defaultMessage: 'Time'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.NumericQuestionsGroupLabel]: {
        id: 'form-builder.QuestionType.NumericQuestionsGroupLabel',
        defaultMessage: 'Numeric fields'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.NumberLabel]: {
        id: 'form-builder.QuestionType.NumberLabel',
        defaultMessage: 'Number'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.UserQuestionsGroupLabel]: {
        id: 'form-builder.QuestionType.UserQuestionsGroupLabel',
        defaultMessage: 'User fields'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.UserSingleLabel]: {
        id: 'form-builder.QuestionType.UserSingleLabel',
        defaultMessage: 'Single user'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.UserMultipleLabel]: {
        id: 'form-builder.QuestionType.UserMultipleLabel',
        defaultMessage: 'Multiple users'
    },
    [$1e7a071bc1fc5bb0$export$8f21f8f314b6a220.UnsupportedLabel]: {
        id: 'form-builder.QuestionType.UnsupportedLabel',
        defaultMessage: 'Unsupported'
    }
});

});

parcelRegister("dXYuS", function(module, exports) {

$parcel$export(module.exports, "questionTypeToQuestionTypeMessage", () => $a2afb6844be32e55$export$a64008dcb04384c9);

var $4aJmI = parcelRequire("4aJmI");

var $2Ce34 = parcelRequire("2Ce34");
function $a2afb6844be32e55$export$a64008dcb04384c9(questionType) {
    switch(questionType){
        case (0, $4aJmI.FormQuestionType).TextShort:
            return (0, $2Ce34.QuestionTypeMessage).TextShortLabel;
        case (0, $4aJmI.FormQuestionType).TextLong:
            return (0, $2Ce34.QuestionTypeMessage).TextLongLabel;
        case (0, $4aJmI.FormQuestionType).TextParagraph:
            return (0, $2Ce34.QuestionTypeMessage).PlainTextParagraphLabel;
        case (0, $4aJmI.FormQuestionType).RichTextParagraph:
            return (0, $2Ce34.QuestionTypeMessage).RichTextParagraphLabel;
        case (0, $4aJmI.FormQuestionType).TextEmail:
            return (0, $2Ce34.QuestionTypeMessage).TextEmailLabel;
        case (0, $4aJmI.FormQuestionType).TextUrl:
            return (0, $2Ce34.QuestionTypeMessage).TextUrlLabel;
        case (0, $4aJmI.FormQuestionType).ChoiceCascading:
            return (0, $2Ce34.QuestionTypeMessage).ChoiceCascadingLabel;
        case (0, $4aJmI.FormQuestionType).ChoiceDropdown:
            return (0, $2Ce34.QuestionTypeMessage).ChoiceDropdownLabel;
        case (0, $4aJmI.FormQuestionType).ChoiceSingle:
            return (0, $2Ce34.QuestionTypeMessage).ChoiceSingleLabel;
        case (0, $4aJmI.FormQuestionType).ChoiceMultiple:
            return (0, $2Ce34.QuestionTypeMessage).ChoiceMultipleLabel;
        case (0, $4aJmI.FormQuestionType).ChoiceDropdownMultiple:
            return (0, $2Ce34.QuestionTypeMessage).ChoiceDropdownMultipleLabel;
        case (0, $4aJmI.FormQuestionType).CmdbObject:
            return (0, $2Ce34.QuestionTypeMessage).CmdbObjectLabel;
        case (0, $4aJmI.FormQuestionType).Date:
            return (0, $2Ce34.QuestionTypeMessage).DateLabel;
        case (0, $4aJmI.FormQuestionType).DateTime:
            return (0, $2Ce34.QuestionTypeMessage).DateTimeLabel;
        case (0, $4aJmI.FormQuestionType).Time:
            return (0, $2Ce34.QuestionTypeMessage).TimeLabel;
        case (0, $4aJmI.FormQuestionType).Number:
            return (0, $2Ce34.QuestionTypeMessage).NumberLabel;
        case (0, $4aJmI.FormQuestionType).UserSingle:
            return (0, $2Ce34.QuestionTypeMessage).UserSingleLabel;
        case (0, $4aJmI.FormQuestionType).UserMultiple:
            return (0, $2Ce34.QuestionTypeMessage).UserMultipleLabel;
        default:
            return (0, $2Ce34.QuestionTypeMessage).UnsupportedLabel;
    }
}

});

parcelRegister("7gmPx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $549bbca0c169f13e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $549bbca0c169f13e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unknownQuestionType: {
        defaultMessage: "We couldn't load the <strong>{questionType}</strong> field type at this time.",
        description: 'Shown when a form field is unable to be shown',
        id: 'form-system.unknown-question-type'
    }
});

});

parcelRegister("eaUiW", function(module, exports) {

$parcel$export(module.exports, "UnknownQuestionTypeText", () => $a51dacc64d3da6db$export$284247789c6eec03);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dAHxw = parcelRequire("dAHxw");

const $a51dacc64d3da6db$export$284247789c6eec03 = (0, $dAHxw.default).p({
    color: `var(--ds-text-danger, ${(0, $a7f8c6b391092279$export$2010d0fb4295b346)})`
});

});



parcelRegister("8iiJB", function(module, exports) {

$parcel$export(module.exports, "ViewFormMessage", () => $609e8970ac2d98e4$export$e6feff1a2af45d34);
$parcel$export(module.exports, "IntlViewFormMessages", () => $609e8970ac2d98e4$export$8d484546a77c3c19);

var $7VHMR = parcelRequire("7VHMR");
let $609e8970ac2d98e4$export$e6feff1a2af45d34 = /*#__PURE__*/ function(ViewFormMessage) {
    ViewFormMessage["HiddenSection"] = "HiddenSection";
    return ViewFormMessage;
}({});
const $609e8970ac2d98e4$export$8d484546a77c3c19 = (0, $7VHMR.defineMessages)({
    [$609e8970ac2d98e4$export$e6feff1a2af45d34.HiddenSection]: {
        id: 'form-system.viewForm.HiddenSection',
        defaultMessage: 'Hidden section - Conditions apply'
    }
});

});


parcelRegister("3bQqD", function(module, exports) {

$parcel$export(module.exports, "useHandleSaveForm", () => $252b1162d7555f27$export$321514d9cf6c733f);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bngFq = parcelRequire("bngFq");

var $7ndW8 = parcelRequire("7ndW8");

var $5E93O = parcelRequire("5E93O");


var $aNTEp = parcelRequire("aNTEp");

var $bEQ2i = parcelRequire("bEQ2i");

var $8LS7b = parcelRequire("8LS7b");

var $caW8j = parcelRequire("caW8j");

var $erWXD = parcelRequire("erWXD");

var $eG2p4 = parcelRequire("eG2p4");

var $N5QrD = parcelRequire("N5QrD");

var $4prRh = parcelRequire("4prRh");
const $252b1162d7555f27$export$321514d9cf6c733f = ()=>{
    const [isSaving, setIsSaving] = (0, $5uXOq.useState)(false);
    const { selectedFormStore: formStore } = (0, $N5QrD.useSelectedFormStoreState)();
    const { saveAnswers: saveAnswers, reportError: reportError } = (0, $N5QrD.useFormIndexActions)();
    const { clear: clearFormSaveErrors, set: setFormSaveErrors } = (0, $bEQ2i.useFormSaveErrorsActions)();
    const { showFlag: showFlag } = (0, $7ndW8.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return {
        isSaving: isSaving,
        handleSaveForm: (0, $5uXOq.useCallback)(async ()=>{
            setIsSaving(true);
            try {
                if (formStore && formStore.formId) {
                    const answers = (0, $8LS7b.convertAnswers)(formStore.visibleQuestions);
                    const savedForm = await saveAnswers(formStore.formId, answers);
                    clearFormSaveErrors();
                    await formStore.update(savedForm);
                    (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).UPDATED}`, {
                        formUpdateType: (0, $erWXD.FormUpdateType).SAVE,
                        ...(0, $eG2p4.getSimpleFormAnalytics)(formStore.formId, formStore.templateFormId, formStore.status, formStore.internal)
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                const formSaveErrors = (0, $caW8j.getFormSaveErrors)(error);
                if (formSaveErrors) {
                    setFormSaveErrors(formSaveErrors.errorsByQuestionId);
                    const showGeneralErrorMsg = Object.keys(formSaveErrors.errorsByQuestionId).length === 0 && formSaveErrors.generalErrors.length > 0;
                    const customDescription = showGeneralErrorMsg ? formSaveErrors === null || formSaveErrors === void 0 ? void 0 : formSaveErrors.generalErrors[0] : undefined;
                    showFlag({
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                            spacing: "spacious",
                            label: "",
                            color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$2010d0fb4295b346)})`
                        }),
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4prRh.messages).errorSaveFormTitle),
                        description: customDescription || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4prRh.messages).errorSaveFormInvalidAnswersDescription),
                        isAutoDismiss: true
                    });
                    throw error;
                }
                let description;
                if ((0, $caW8j.isUnknownApiError)(error) && error.status === 409) description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4prRh.messages).errorSaveFormFailedOnConflictDescription);
                else {
                    reportError(error, {
                        id: 'saveForm',
                        attributes: {
                            formId: formStore === null || formStore === void 0 ? void 0 : formStore.formId
                        }
                    });
                    description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4prRh.messages).errorSaveFormServerErrorDescription);
                }
                showFlag({
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                        spacing: "spacious",
                        label: "",
                        color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$2010d0fb4295b346)})`
                    }),
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4prRh.messages).errorSaveFormTitle),
                    description: description,
                    isAutoDismiss: true
                });
                throw error;
            } finally{
                setIsSaving(false);
            }
        }, [
            formStore,
            saveAnswers,
            clearFormSaveErrors,
            reportError,
            showFlag,
            setFormSaveErrors,
            createAnalyticsEvent
        ])
    };
};

});
parcelRegister("8LS7b", function(module, exports) {

$parcel$export(module.exports, "convertAnswers", () => $662cb095ff9aa35e$export$ebf64a9da647b95d);

var $4aJmI = parcelRequire("4aJmI");

var $4QmvR = parcelRequire("4QmvR");
const $662cb095ff9aa35e$export$ebf64a9da647b95d = (questions)=>{
    const answersMap = {};
    questions.forEach((question)=>{
        answersMap[question.id.toString()] = $662cb095ff9aa35e$var$getFormAnswer(question);
    });
    return answersMap;
};
const $662cb095ff9aa35e$export$1f200de465f7a566 = (answer)=>{
    return answer === undefined ? null : answer;
};
function $662cb095ff9aa35e$var$getFormAnswer(question) {
    var _toDateTimeQuestionAn, _toDateTimeQuestionAn2, _toChoiceQuestionAnsw, _toChoiceQuestionAnsw2;
    switch(question.formQuestion.type){
        case (0, $4aJmI.FormQuestionType).TextShort:
        case (0, $4aJmI.FormQuestionType).TextLong:
        case (0, $4aJmI.FormQuestionType).TextParagraph:
        case (0, $4aJmI.FormQuestionType).TextEmail:
        case (0, $4aJmI.FormQuestionType).TextUrl:
        case (0, $4aJmI.FormQuestionType).Number:
            return {
                text: $662cb095ff9aa35e$export$1f200de465f7a566((0, $4QmvR.toTextQuestionAnswer)(question.currentAnswer))
            };
        case (0, $4aJmI.FormQuestionType).RichTextParagraph:
            return {
                adf: (0, $4QmvR.toRichTextQuestionAnswer)(question.currentAnswer) || null
            };
        case (0, $4aJmI.FormQuestionType).DateTime:
            return {
                date: ((_toDateTimeQuestionAn = (0, $4QmvR.toDateTimeQuestionAnswer)(question.currentAnswer)) === null || _toDateTimeQuestionAn === void 0 ? void 0 : _toDateTimeQuestionAn.date) || null,
                time: ((_toDateTimeQuestionAn2 = (0, $4QmvR.toDateTimeQuestionAnswer)(question.currentAnswer)) === null || _toDateTimeQuestionAn2 === void 0 ? void 0 : _toDateTimeQuestionAn2.time) || null
            };
        case (0, $4aJmI.FormQuestionType).Date:
            return {
                date: (0, $4QmvR.toTextQuestionAnswer)(question.currentAnswer) || null
            };
        case (0, $4aJmI.FormQuestionType).Time:
            return {
                time: (0, $4QmvR.toTextQuestionAnswer)(question.currentAnswer) || null
            };
        case (0, $4aJmI.FormQuestionType).ChoiceCascading:
        case (0, $4aJmI.FormQuestionType).ChoiceSingle:
        case (0, $4aJmI.FormQuestionType).ChoiceMultiple:
        case (0, $4aJmI.FormQuestionType).ChoiceDropdown:
        case (0, $4aJmI.FormQuestionType).ChoiceDropdownMultiple:
        case (0, $4aJmI.FormQuestionType).CmdbObject:
            return {
                text: (_toChoiceQuestionAnsw = (0, $4QmvR.toChoiceQuestionAnswer)(question.currentAnswer)) === null || _toChoiceQuestionAnsw === void 0 ? void 0 : _toChoiceQuestionAnsw.text,
                choices: (_toChoiceQuestionAnsw2 = (0, $4QmvR.toChoiceQuestionAnswer)(question.currentAnswer)) === null || _toChoiceQuestionAnsw2 === void 0 ? void 0 : _toChoiceQuestionAnsw2.choices
            };
        case (0, $4aJmI.FormQuestionType).UserSingle:
        case (0, $4aJmI.FormQuestionType).UserMultiple:
            return {
                users: (0, $4QmvR.toUserPickerQuestionAnswer)(question.currentAnswer)
            };
        case (0, $4aJmI.FormQuestionType).Attachment:
            return {
                files: (0, $4QmvR.toAttachmentQuestionAnswer)(question.currentAnswer)
            };
        default:
            return {
                text: (0, $4QmvR.toTextQuestionAnswer)(question.currentAnswer)
            };
    }
}

});

parcelRegister("eG2p4", function(module, exports) {

$parcel$export(module.exports, "getSimpleFormAnalytics", () => $aaf6da2fe5c6793e$export$120bacc3decf73ac);

var $4aJmI = parcelRequire("4aJmI");
const $aaf6da2fe5c6793e$var$formStatusMapping = {
    [(0, $4aJmI.FormStatus).Locked]: 'locked',
    [(0, $4aJmI.FormStatus).Submitted]: 'submitted',
    [(0, $4aJmI.FormStatus).Open]: 'open'
};
const $aaf6da2fe5c6793e$export$120bacc3decf73ac = (formId, projectFormId, status, internal)=>({
        formId: formId,
        templateFormId: projectFormId,
        formStatus: status && $aaf6da2fe5c6793e$var$formStatusMapping[status],
        visibility: internal === undefined ? 'unknown' : internal ? 'internal' : 'external'
    });

});

parcelRegister("4prRh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $335f1b4ea26c9049$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $335f1b4ea26c9049$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorSaveFormTitle: {
        id: 'proforma-form-system.controllers.form-index.save-form-invalid-answers-flag-title',
        defaultMessage: "We couldn\u2019t save your changes",
        description: 'The title on the error flag informing customers that their form failed to save.'
    },
    errorSaveFormInvalidAnswersDescription: {
        id: 'proforma-form-system.controllers.form-index.save-form-invalid-answers-flag-description',
        defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
        description: 'The error message on the error flag informing customers that their form failed to save due to invalid answers.'
    },
    errorSaveFormFailedOnConflictDescription: {
        id: 'proforma-form-system.controllers.form-index.save-form-failed-on-conflict-flag-description',
        defaultMessage: 'The settings for this form have been changed. If you believe this was an error, leave a comment on the request.',
        description: 'The error message on error flag informing customers about what happened and what to do when saving form answers request was rejected because the form state does not allow the customer to do so.'
    },
    errorSaveFormServerErrorDescription: {
        id: 'proforma-form-system.controllers.form-index.save-form-failed-server-error-flag-description',
        defaultMessage: 'A server error occurred while trying to save the form.'
    }
});

});


parcelRegister("5atqw", function(module, exports) {

$parcel$export(module.exports, "useHandleSubmitForm", () => $3c34b67d5e704181$export$47a4c6559612c141);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bngFq = parcelRequire("bngFq");

var $7ndW8 = parcelRequire("7ndW8");

var $5E93O = parcelRequire("5E93O");

var $bMdrA = parcelRequire("bMdrA");


var $aNTEp = parcelRequire("aNTEp");

var $4aJmI = parcelRequire("4aJmI");

var $erWXD = parcelRequire("erWXD");

var $eG2p4 = parcelRequire("eG2p4");

var $N5QrD = parcelRequire("N5QrD");

var $kYn4T = parcelRequire("kYn4T");

var $3QBpJ = parcelRequire("3QBpJ");

var $dVDm8 = parcelRequire("dVDm8");

var $jOtwh = parcelRequire("jOtwh");

var $lASqC = parcelRequire("lASqC");
const $3c34b67d5e704181$export$47a4c6559612c141 = (projectType)=>{
    const [isSubmitting, setIsSubmitting] = (0, $5uXOq.useState)(false);
    const { selectedFormStore: selectedFormStore } = (0, $N5QrD.useSelectedFormStoreState)();
    const { saveModifiedFormWithErrorFlag: saveModifiedFormWithErrorFlag } = (0, $dVDm8.useSaveModifiedFormWithErrorFlag)();
    const { submitFormWithConfirmation: submitFormWithConfirmation, submitForm: submitForm } = (0, $jOtwh.useSubmitForm)(projectType);
    const reportError = (0, $N5QrD.useReportError)();
    const { showFlag: showFlag } = (0, $7ndW8.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleError = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        if (!(e instanceof (0, $3QBpJ.SubmitError))) {
            reportError(e, {
                id: 'submitForm',
                attributes: {
                    errorType: 'unknown'
                }
            });
            return (0, $3QBpJ.SubmitResult).UnknownError;
        }
        switch(e.type){
            case (0, $3QBpJ.ErrorType).Save:
                // Do not showFlag() or reportError() for save, because saveModifiedFormWithErrorFlag already did it
                return (0, $3QBpJ.SubmitResult).SaveError;
            case (0, $3QBpJ.ErrorType).Validation:
                //  Do not report error for validation error
                showFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kYn4T.messages).validationFailedFlagTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kYn4T.messages).validationFailedFlagDescription),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                        spacing: "spacious",
                        label: "Error",
                        color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$4a7404f376229999)})`
                    })
                });
                return (0, $3QBpJ.SubmitResult).ValidationError;
            case (0, $3QBpJ.ErrorType).Submit:
                reportError(e.error, {
                    id: 'submitForm',
                    attributes: {
                        errorType: e.type
                    }
                });
                showFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kYn4T.messages).submitFailedFlagTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kYn4T.messages).submitFailedFlagDescription),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                        spacing: "spacious",
                        label: "Error",
                        color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$4a7404f376229999)})`
                    })
                });
                return (0, $3QBpJ.SubmitResult).SubmitError;
            default:
                return (0, $3QBpJ.SubmitResult).UnknownError;
        }
    }, [
        reportError,
        showFlag
    ]);
    return {
        isSubmitting: isSubmitting,
        handleSubmitForm: (0, $5uXOq.useCallback)(async ()=>{
            if (!selectedFormStore) return;
            try {
                setIsSubmitting(true);
                let submitResult;
                await (0, $lASqC.validateForm)(selectedFormStore);
                await saveModifiedFormWithErrorFlag(selectedFormStore);
                if (selectedFormStore.status === (0, $4aJmI.FormStatus).Open) submitResult = selectedFormStore.internal || projectType !== 'service_desk' ? await submitForm(selectedFormStore) : await submitFormWithConfirmation(selectedFormStore);
                else submitResult = await submitForm(selectedFormStore);
                if (submitResult === (0, $3QBpJ.SubmitResult).Success) {
                    showFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kYn4T.messages).submitSuccessFlagTitle),
                        isAutoDismiss: true,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
                            spacing: "spacious",
                            label: "Success",
                            color: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$export$940e1f69e873f202)})`
                        })
                    });
                    (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).UPDATED}`, {
                        formUpdateType: (0, $erWXD.FormUpdateType).SUBMIT,
                        ...(0, $eG2p4.getSimpleFormAnalytics)(selectedFormStore.formId, selectedFormStore.templateFormId, selectedFormStore.status, selectedFormStore.internal)
                    });
                }
                return submitResult;
            } catch (e) {
                return handleError(e);
            } finally{
                setIsSubmitting(false);
            }
        }, [
            selectedFormStore,
            saveModifiedFormWithErrorFlag,
            projectType,
            submitForm,
            submitFormWithConfirmation,
            showFlag,
            createAnalyticsEvent,
            handleError
        ])
    };
};

});
parcelRegister("kYn4T", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f44b50086300a081$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f44b50086300a081$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    confirmSubmitFormNoticeTitle: {
        id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.confirm-submit-form-notice-title',
        defaultMessage: "Submit \u2018{formName}\u2019 form",
        description: 'The title of the confirmation modal checking that the user wants to submit the form.'
    },
    confirmSubmitFormNoticeBody: {
        id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.confirm-submit-notice-body',
        defaultMessage: 'Customer edits will close once this form is submitted.',
        description: 'The content of the confirmation modal checking that the user wants to submit the form.'
    },
    confirmSubmitFormNoticeBodyNonJsm: {
        id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.confirm-submit-notice-body-non-jsm',
        defaultMessage: 'Edits will close once this form is submitted.',
        description: 'The content of the confirmation modal checking that the user wants to submit the form (non JSM project).'
    },
    noticeCancelSubmitLabel: {
        id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.notice-cancel-submit-label',
        defaultMessage: 'Cancel',
        description: 'The label for the cancel button on the submit form notice.'
    },
    noticeConfirmSubmitLabel: {
        id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.notice-confirm-submit-label',
        defaultMessage: 'Submit form',
        description: 'The label for the confirm button on the submit form notice.'
    },
    submitSuccessFlagTitle: {
        id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.submit-success-flag-title',
        defaultMessage: 'Form submitted',
        description: 'The title of the flag indicating that the form submission success.'
    },
    submitFailedFlagTitle: {
        id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.submit-failed-flag-title',
        defaultMessage: 'Error: Submitting form failed',
        description: 'The title of the flag indicating that the form submission failed.'
    },
    submitFailedFlagDescription: {
        id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.submit-failed-flag-description',
        defaultMessage: 'A server error occurred while trying to submit the form.',
        description: 'The description of the flag indicating that the form submission failed.'
    },
    validationFailedFlagTitle: {
        id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.validation-failed-flag-title',
        defaultMessage: "We couldn\u2019t submit this form",
        description: 'The title of the flag indicating that the form contains validation errors and can not be submitted.'
    },
    validationFailedFlagDescription: {
        id: 'proforma-form-system.src.controllers.form-index.use-handle-submit-form.validation-failed-flag-description',
        defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
        description: 'The description of the flag indicating that the form contains validation errors and can not be submitted.'
    }
});

});

parcelRegister("3QBpJ", function(module, exports) {

$parcel$export(module.exports, "SubmitResult", () => $2cd3400f33e8dea4$export$515aefb0a70bbed7);
$parcel$export(module.exports, "ErrorType", () => $2cd3400f33e8dea4$export$dba1278861bf0dc1);
$parcel$export(module.exports, "SubmitError", () => $2cd3400f33e8dea4$export$6c3894e4a5d79ea5);
let $2cd3400f33e8dea4$export$515aefb0a70bbed7 = /*#__PURE__*/ function(SubmitResult) {
    SubmitResult[SubmitResult["Success"] = 0] = "Success";
    SubmitResult[SubmitResult["Cancelled"] = 1] = "Cancelled";
    SubmitResult[SubmitResult["ValidationError"] = 2] = "ValidationError";
    SubmitResult[SubmitResult["SaveError"] = 3] = "SaveError";
    SubmitResult[SubmitResult["SubmitError"] = 4] = "SubmitError";
    SubmitResult[SubmitResult["UnknownError"] = 5] = "UnknownError";
    return SubmitResult;
}({});
let $2cd3400f33e8dea4$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType[ErrorType["Validation"] = 0] = "Validation";
    ErrorType[ErrorType["Save"] = 1] = "Save";
    ErrorType[ErrorType["Submit"] = 2] = "Submit";
    return ErrorType;
}({});
class $2cd3400f33e8dea4$export$6c3894e4a5d79ea5 extends Error {
    constructor(type, error){
        super(`submitError-${type}`);
        this.type = type;
        this.error = error;
    }
}

});

parcelRegister("dVDm8", function(module, exports) {

$parcel$export(module.exports, "useSaveModifiedFormWithErrorFlag", () => $a23f2088e1bcb604$export$39b162835a94e2ca);

var $5uXOq = parcelRequire("5uXOq");

var $3bQqD = parcelRequire("3bQqD");

var $7Bkz9 = parcelRequire("7Bkz9");
const $a23f2088e1bcb604$export$39b162835a94e2ca = ()=>{
    const { handleSaveForm: handleSaveFormWithErrorFlag } = (0, $3bQqD.useHandleSaveForm)();
    return {
        saveModifiedFormWithErrorFlag: (0, $5uXOq.useCallback)(async (formStore)=>{
            if (formStore.answersModified) try {
                await handleSaveFormWithErrorFlag();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                throw (0, $7Bkz9.createSaveFormError)(error);
            }
        }, [
            handleSaveFormWithErrorFlag
        ])
    };
};

});
parcelRegister("7Bkz9", function(module, exports) {

$parcel$export(module.exports, "createSaveFormError", () => $588bf11710d22f41$export$d56932515996644c);
$parcel$export(module.exports, "createSubmitFormError", () => $588bf11710d22f41$export$29f9bc5f337d89d2);
$parcel$export(module.exports, "createValidateFormError", () => $588bf11710d22f41$export$976da9026f2240e5);

var $3QBpJ = parcelRequire("3QBpJ");
const $588bf11710d22f41$export$d56932515996644c = (e)=>new (0, $3QBpJ.SubmitError)((0, $3QBpJ.ErrorType).Save, e);
const $588bf11710d22f41$export$29f9bc5f337d89d2 = (e)=>new (0, $3QBpJ.SubmitError)((0, $3QBpJ.ErrorType).Submit, e);
const $588bf11710d22f41$export$976da9026f2240e5 = ()=>new (0, $3QBpJ.SubmitError)((0, $3QBpJ.ErrorType).Validation, new Error('Validation failure'));

});


parcelRegister("jOtwh", function(module, exports) {

$parcel$export(module.exports, "useSubmitForm", () => $e6c995d80b51eedc$export$f892117c4d06c1ea);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $6U2FW = parcelRequire("6U2FW");

var $N5QrD = parcelRequire("N5QrD");

var $hprFm = parcelRequire("hprFm");

var $kYn4T = parcelRequire("kYn4T");

var $3QBpJ = parcelRequire("3QBpJ");

var $7Bkz9 = parcelRequire("7Bkz9");
const $e6c995d80b51eedc$export$f892117c4d06c1ea = (projectType)=>{
    const { submitForm: submitForm, updateFormStatus: updateFormStatus, setFormViewMode: setFormViewMode } = (0, $N5QrD.useFormIndexActions)();
    const { showNotice: showNotice } = (0, $6U2FW.useShowNotice)();
    const confirmSubmitForm = (0, $5uXOq.useCallback)(async (formStore)=>{
        if (formStore.formId) {
            const updatedForm = await submitForm(formStore.formId, formStore.submitLock);
            await formStore.update(updatedForm);
            formStore.hideValidations();
            setFormViewMode((0, $hprFm.FormViewMode).View);
            updateFormStatus(updatedForm.id, updatedForm.state.status);
        }
    }, [
        setFormViewMode,
        submitForm,
        updateFormStatus
    ]);
    return {
        submitFormWithConfirmation: (0, $5uXOq.useCallback)((formStore)=>new Promise((resolve, reject)=>{
                showNotice({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bS32t.default)({}, (0, $kYn4T.messages).confirmSubmitFormNoticeTitle, {
                        values: {
                            formName: formStore.formName || 'Untitled form'
                        }
                    })),
                    body: projectType === 'service_desk' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kYn4T.messages).confirmSubmitFormNoticeBody) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kYn4T.messages).confirmSubmitFormNoticeBodyNonJsm),
                    closeText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kYn4T.messages).noticeCancelSubmitLabel),
                    confirmText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kYn4T.messages).noticeConfirmSubmitLabel),
                    onConfirmHandler: ()=>confirmSubmitForm(formStore).then(()=>resolve((0, $3QBpJ.SubmitResult).Success)).catch((e)=>reject((0, $7Bkz9.createSubmitFormError)(e))),
                    onCloseHandler: ()=>{
                        resolve((0, $3QBpJ.SubmitResult).Cancelled);
                    }
                });
            }), [
            confirmSubmitForm,
            projectType,
            showNotice
        ]),
        submitForm: (formStore)=>confirmSubmitForm(formStore).then(()=>(0, $3QBpJ.SubmitResult).Success).catch((e)=>{
                throw (0, $7Bkz9.createSubmitFormError)(e);
            })
    };
};

});

parcelRegister("lASqC", function(module, exports) {

$parcel$export(module.exports, "validateForm", () => $fb872e1b7d2b6a29$export$ed692cabb252e59b);

var $7Bkz9 = parcelRequire("7Bkz9");
const $fb872e1b7d2b6a29$export$ed692cabb252e59b = async (formStore)=>{
    formStore.validate();
    if (formStore.invalid) throw (0, $7Bkz9.createValidateFormError)();
};

});


parcelRegister("4corl", function(module, exports) {

$parcel$export(module.exports, "EditButtons", () => $30eb3db0a97039a4$export$80015745862423ab);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");


var $jHTSg = parcelRequire("jHTSg");
var $cNW3X = parcelRequire("cNW3X");
var $i95f5 = parcelRequire("i95f5");

var $4aJmI = parcelRequire("4aJmI");

var $N5QrD = parcelRequire("N5QrD");

var $ek3Ze = parcelRequire("ek3Ze");

const $30eb3db0a97039a4$export$80015745862423ab = ({ isSubmitting: isSubmitting, isSaving: isSaving, onSubmit: onSubmit, onSave: onSave, onCancel: onCancel })=>{
    const { permissions: permissions } = (0, $N5QrD.useFormIndexState)();
    const { selectedFormStore: formStore } = (0, $N5QrD.useSelectedFormStoreState)();
    // formStore is typed nullable - but we never render this component in the parent if it's null, so we can just render
    // nothing to make TypeScript happy.
    if (!formStore) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHTSg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "subtle",
        isDisabled: isSaving || isSubmitting,
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ek3Ze.messages).cancel)), permissions.save && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i95f5.default), {
        isLoading: isSaving,
        isDisabled: !formStore.answersModified || isSaving || formStore.isUploadingMedia || formStore.status !== (0, $4aJmI.FormStatus).Open,
        onClick: onSave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ek3Ze.messages).save)), permissions.submit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i95f5.default), {
        isLoading: isSubmitting,
        appearance: "primary",
        isDisabled: isSubmitting || formStore.isUploadingMedia || formStore.status !== (0, $4aJmI.FormStatus).Open && !formStore.answersModified,
        onClick: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ek3Ze.messages).submit)));
};

});
parcelRegister("ek3Ze", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a6d6069f8244f067$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a6d6069f8244f067$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    submitsave: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.submitsave',
        description: 'Text for the button used to submit and save changes to a form.',
        defaultMessage: 'Save and submit'
    },
    submit: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.submit',
        description: 'Text for the button used to submit a form.',
        defaultMessage: 'Submit'
    },
    save: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.save',
        description: 'Text for the button used to save a form when changes have been made.',
        defaultMessage: 'Save'
    },
    saved: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.saved',
        description: 'Text for the button used to save a form when there are no changes made.',
        defaultMessage: 'Saved'
    },
    cancel: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.cancel',
        description: 'Text for the button used to exit edit mode and discard changes made to a form.',
        defaultMessage: 'Cancel'
    },
    close: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-body.edit-buttons.close',
        description: 'Text for the button used to exit edit mode when the form has not been changed.',
        defaultMessage: 'Close'
    }
});

});


parcelRegister("kcsGs", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", () => $eb4b2da4f4ad2f60$export$915e9e7bd4f0f96d);

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $k9nuy = parcelRequire("k9nuy");

var $9FSw2 = parcelRequire("9FSw2");
const $eb4b2da4f4ad2f60$export$915e9e7bd4f0f96d = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
        as: "p"
    }, formatMessage($eb4b2da4f4ad2f60$var$messages.description)));
};
const $eb4b2da4f4ad2f60$var$messages = (0, $7VHMR.defineMessages)({
    description: {
        id: 'proforma-form-system.src.ui.form-card-index.form-card.form-card-body.error.title',
        defaultMessage: "We\u2019re unable to load this form. Refresh this page and try again.",
        description: 'Error message shown when a form fails to load.'
    }
});

});

parcelRegister("bcxlj", function(module, exports) {

$parcel$export(module.exports, "PermissionErrorMessage", () => $827aadd925b8aa92$export$1333555f234be40);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $hT0MN = parcelRequire("hT0MN");
const $827aadd925b8aa92$var$permissionErrorWrapperStyles = (0, $2s57o.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $827aadd925b8aa92$export$1333555f234be40 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $827aadd925b8aa92$var$permissionErrorWrapperStyles,
        testId: "proforma-form-system-permission-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        color: "color.text.subtle",
        as: "p"
    }, formatMessage((0, $hT0MN.messages).description)));
};

});
parcelRegister("hT0MN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d0582ed3032f9414$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d0582ed3032f9414$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    description: {
        id: 'proforma-form-system.src.ui.form-card-index.form-card.form-card-body.permission-error.title',
        defaultMessage: 'Only specific people can view this form.',
        description: 'Error message shown when a user does not have permissions to view the form.'
    }
});

});


parcelRegister("iuD4T", function(module, exports) {

$parcel$export(module.exports, "RightAlign", () => $d769576801b470fb$export$e35716ba6a388a5c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dAHxw = parcelRequire("dAHxw");
const $d769576801b470fb$export$e35716ba6a388a5c = (0, $dAHxw.default).div({
    display: 'flex',
    justifyContent: 'end'
});

});


parcelRegister("fwz4r", function(module, exports) {

$parcel$export(module.exports, "FormCardHeader", () => $b4d50c7b7c5e9aa3$export$87f3dd3035ba418f);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");


var $cNW3X = parcelRequire("cNW3X");

var $1Seuh = parcelRequire("1Seuh");

var $j7m8K = parcelRequire("j7m8K");

var $elaEw = parcelRequire("elaEw");

var $8eqvE = parcelRequire("8eqvE");

var $tkOiB = parcelRequire("tkOiB");

var $eOat1 = parcelRequire("eOat1");

var $inni2 = parcelRequire("inni2");
var $cOGPo = parcelRequire("cOGPo");
var $Pxnvj = parcelRequire("Pxnvj");

var $fHpHg = parcelRequire("fHpHg");

var $5KCCi = parcelRequire("5KCCi");

var $4aJmI = parcelRequire("4aJmI");

var $N5QrD = parcelRequire("N5QrD");

var $N5QrD = parcelRequire("N5QrD");

var $hnuQa = parcelRequire("hnuQa");

var $3lSkX = parcelRequire("3lSkX");

var $5aNT3 = parcelRequire("5aNT3");

var $7nn5p = parcelRequire("7nn5p");

var $jGoQM = parcelRequire("jGoQM");
const $b4d50c7b7c5e9aa3$var$PROFORMA_ISSUE_VIEW_FORM_MEATBALL_SEEN_STATUS_USER_PROPERTY_KEY = 'proforma-issue-view-form-meatball-seen-status';
const $b4d50c7b7c5e9aa3$export$87f3dd3035ba418f = ({ form: form, formStore: formStore, toggleExpanded: toggleExpanded, renderMenu: renderMenu, onCancelEdit: onCancelEdit, projectType: projectType, hideLockedLozenge: hideLockedLozenge, isFirstForm: isFirstForm })=>{
    const { hasSeenOnboarding: hasSeenOnboarding, markAsSeenOnboarding: markAsSeenOnboarding } = (0, $N5QrD.useFormIndexActions)();
    const { selectedFormId: selectedFormId } = (0, $N5QrD.useFormIndexState)();
    const { isOpen: isOpen, handleDropdownOpenChange: handleDropdownOpenChange } = (0, $jGoQM.useHandleDropdownOpenChange)(onCancelEdit);
    const intl = (0, $koVbs.default)();
    const hasFormAccess = (0, $fHpHg.fg)('granular_permissions_on_forms_ga') ? form.hasAccess : true;
    let status;
    switch(form.status){
        case (0, $4aJmI.FormStatus).Open:
            status = 'inprogress';
            break;
        case (0, $4aJmI.FormStatus).Submitted:
            status = 'success';
            break;
        case (0, $4aJmI.FormStatus).Locked:
            if (hideLockedLozenge) status = 'success';
            else status = 'removed';
            break;
        default:
            status = 'default';
    }
    // has the user seen the spotlight yet (from user properties)
    const [hasSeenSpotlight, setHasSeenSpotlight] = (0, $5uXOq.useState)(true);
    const [shouldShowPulse, setShouldShowPulse] = (0, $5uXOq.useState)(false);
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $5uXOq.useState)(false);
    // has the spotlight displayed on this current render
    const [hasSpotlightDisplayed, setHasSpotlightDisplayed] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (isFirstForm && projectType === 'service_desk') hasSeenOnboarding($b4d50c7b7c5e9aa3$var$PROFORMA_ISSUE_VIEW_FORM_MEATBALL_SEEN_STATUS_USER_PROPERTY_KEY).then((result)=>{
            if (!result) setHasSeenSpotlight(false);
        });
    }, [
        hasSeenOnboarding,
        isFirstForm,
        projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasSeenSpotlight && !hasSpotlightDisplayed) setShouldShowPulse(!hasSeenSpotlight);
    }, [
        hasSeenSpotlight,
        hasSpotlightDisplayed,
        projectType
    ]);
    const onDisplaySpotlight = (attrs)=>{
        var _attrs$event;
        (_attrs$event = attrs.event) === null || _attrs$event === void 0 || _attrs$event.stopPropagation();
        if (shouldShowPulse) {
            setShouldShowPulse(false);
            setShouldShowSpotlight(true);
        }
    };
    const onAcknowledgeSpotlight = ()=>{
        setHasSeenSpotlight(true);
        setHasSpotlightDisplayed(true);
        setShouldShowSpotlight(false);
        markAsSeenOnboarding($b4d50c7b7c5e9aa3$var$PROFORMA_ISSUE_VIEW_FORM_MEATBALL_SEEN_STATUS_USER_PROPERTY_KEY);
    };
    const formChevronButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, selectedFormId === form.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($tkOiB))),
        "aria-expanded": "true",
        label: intl.formatMessage((0, $5aNT3.messages).collapseChevronLabel, {
            formName: form.name
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8eqvE))),
        "aria-expanded": "false",
        label: intl.formatMessage((0, $5aNT3.messages).expandChevronLabel, {
            formName: form.name
        })
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nn5p.HeaderContainer), {
        "data-test-id": "proforma-form-index-form-card-header",
        onClick: toggleExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnuQa.FormCardIcon), {
        restrictionStatus: form.restrictionStatus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nn5p.FormName), {
        "data-test-id": "proforma-form-index-form-card-name"
    }, form.name), form.internal && projectType === 'service_desk' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5aNT3.messages).statusInternal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, form.status === (0, $4aJmI.FormStatus).Locked && !hideLockedLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5aNT3.messages).statusLockedTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5aNT3.messages).statusLockedForEdits))), form.status === (0, $4aJmI.FormStatus).Open && (!form.internal || !(projectType === 'service_desk')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5aNT3.messages).statusOpenForEdits)), (form.status === (0, $4aJmI.FormStatus).Submitted || form.status === (0, $4aJmI.FormStatus).Locked && hideLockedLozenge) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5aNT3.messages).statusSubmitted))), hasFormAccess ? isFirstForm ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inni2.default), null, (renderMenu || !(0, $fHpHg.fg)('platform_jsm_issue_view_forms_meatballs_optional')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: (0, $8db68d4213610b78$export$3c389bd4d38f57a0),
        key: "form-card-meatball"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOGPo.Pulse), {
        radius: 3,
        pulse: shouldShowPulse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
        placement: "bottom-end",
        shouldRenderToParent: true,
        testId: "proforma-form-index-form-card-menu-meatball",
        isOpen: isOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), (0, $bS32t.default)({}, props, {
                appearance: "subtle",
                ref: triggerRef,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elaEw))), {
                    color: "currentColor",
                    label: "Actions"
                })
            })),
        onOpenChange: hasSeenSpotlight ? handleDropdownOpenChange : onDisplaySpotlight
    }, renderMenu && renderMenu(form, formStore)))), shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3lSkX.MeatballSpotlight), {
        onAcknowledge: onAcknowledgeSpotlight
    }), formChevronButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (renderMenu || !(0, $fHpHg.fg)('platform_jsm_issue_view_forms_meatballs_optional')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
        placement: "bottom-end",
        shouldRenderToParent: true,
        testId: "proforma-form-index-form-card-menu-meatball",
        isOpen: isOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), (0, $bS32t.default)({}, props, {
                appearance: "subtle",
                ref: triggerRef,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elaEw))), {
                    color: "currentColor",
                    label: "Actions"
                })
            })),
        onOpenChange: handleDropdownOpenChange
    }, renderMenu && renderMenu(form, formStore)), formChevronButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formChevronButton));
};

});
parcelRegister("3lSkX", function(module, exports) {

$parcel$export(module.exports, "MeatballSpotlight", () => $270d7b7559fa1ac4$export$f8c860a354c8950f);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $bkS4F = parcelRequire("bkS4F");
var $98UVV = parcelRequire("98UVV");

var $fHpHg = parcelRequire("fHpHg");

var $k9nuy = parcelRequire("k9nuy");



var $fqfia = parcelRequire("fqfia");
const $270d7b7559fa1ac4$export$f8c860a354c8950f = ({ onAcknowledge: onAcknowledge })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98UVV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bkS4F.default), {
        target: (0, $8db68d4213610b78$export$3c389bd4d38f57a0),
        heading: intl.formatMessage((0, $fqfia.messages).title),
        actions: [
            {
                text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $fqfia.messages).ok),
                onClick: onAcknowledge
            }
        ],
        dialogPlacement: "left middle",
        dialogWidth: 336,
        key: (0, $8db68d4213610b78$export$1222b4ae9a94b9ec),
        targetBgColor: `var(--ds-surface-raised, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9nuy.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $fHpHg.fg)('itsm-issue-renaming') ? (0, $fqfia.messages).messageIssueTermRefresh : (0, $fqfia.messages).message))));
};

});
const $8db68d4213610b78$export$1222b4ae9a94b9ec = 'proforma-meatball-changeboarding-spotlight';
const $8db68d4213610b78$export$3c389bd4d38f57a0 = 'proforma-meatball-changeboarding-spotlight-target';

parcelRegister("fqfia", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b3a52561336761c2$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b3a52561336761c2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    message: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.meatball-spotlight.message',
        defaultMessage: 'You can now edit a form on an issue without it also opening edits in the portal. Select <b>Open customer edits</b> to request customer changes, or select <b>Edit form</b> to update it yourself.',
        description: 'ProForma meatball changeboarding spotlight message explaining the capacity to edit a submitted form within issue view and the dropdown options'
    },
    messageIssueTermRefresh: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.meatball-spotlight.message-issue-term-refresh',
        defaultMessage: 'You can now edit a form on a work item without it also opening edits in the portal. Select <b>Open customer edits</b> to request customer changes, or select <b>Edit form</b> to update it yourself.',
        description: 'ProForma meatball changeboarding spotlight message explaining the capacity to edit a submitted form within issue view and the dropdown options'
    },
    ok: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.meatball-spotlight.ok',
        defaultMessage: 'OK',
        description: 'ProForma meatball changeboarding spotlight button text.'
    },
    title: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.meatball-spotlight.title',
        defaultMessage: 'Control when customers can edit forms in the portal',
        description: 'Proforma meatball changeboarding spotlight title'
    }
});

});


parcelRegister("5aNT3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3c449571f2de61ab$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3c449571f2de61ab$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    collapseChevronLabel: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.collapseChevronLabel',
        description: 'Label for the chevron icon that collapses the form card, with the form name as a variable.',
        defaultMessage: 'Collapse form {formName}'
    },
    expandChevronLabel: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.expandChevronLabel',
        description: 'Label for the chevron icon that expands the form card, with the form name as a variable.',
        defaultMessage: 'Expand form {formName}'
    },
    statusOpenForEdits: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.statusOpenForEdits',
        description: 'Text to display in the status lozenge when the form is open for edits.',
        defaultMessage: 'Open for edits'
    },
    statusSubmitted: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.statusSubmitted',
        description: 'Text to display in the status lozenge when the form has been submitted.',
        defaultMessage: 'Submitted'
    },
    statusLockedForEdits: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.statusLockedForEdits',
        description: 'Text to display in the status lozenge when the form is locked.',
        defaultMessage: 'Locked for edits'
    },
    statusLockedTooltip: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.statusLockedTooltip',
        description: 'Tooltip to display in the status lozenge when the form is locked.',
        defaultMessage: 'Only admins are able to update this form.'
    },
    statusInternal: {
        id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.statusInternal',
        description: 'Text to display in the status lozenge when the form is internal.',
        defaultMessage: 'Internal'
    }
});

});

parcelRegister("7nn5p", function(module, exports) {

$parcel$export(module.exports, "HeaderContainer", () => $55ec96d8da88836a$export$1e86fd0e1db89578);
$parcel$export(module.exports, "FormName", () => $55ec96d8da88836a$export$d3497138d726cd58);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dAHxw = parcelRequire("dAHxw");
const $55ec96d8da88836a$export$1e86fd0e1db89578 = (0, $dAHxw.default).div({
    display: 'flex',
    alignItems: 'center',
    gap: "var(--ds-space-100, 8px)",
    margin: `0 ${"var(--ds-space-075, 6px)"}`,
    height: '40px',
    '&:hover': {
        cursor: 'pointer'
    }
});
const $55ec96d8da88836a$export$d3497138d726cd58 = (0, $dAHxw.default).span({
    flexGrow: 1,
    flexShrink: 2,
    flexBasis: 0,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
});

});

parcelRegister("jGoQM", function(module, exports) {

$parcel$export(module.exports, "useHandleDropdownOpenChange", () => $e5453752d1ce6b26$export$cdfb6f3da561902f);

var $5uXOq = parcelRequire("5uXOq");

var $3LDyf = parcelRequire("3LDyf");
const $e5453752d1ce6b26$export$cdfb6f3da561902f = (onCancelEdit)=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const withDiscardChangeNotice = (0, $3LDyf.useWithDiscardChangeNotice)();
    const handleDropdownOpenChange = (attrs)=>{
        var _attrs$event;
        (_attrs$event = attrs.event) === null || _attrs$event === void 0 || _attrs$event.stopPropagation();
        if (attrs.isOpen) // To open
        withDiscardChangeNotice(()=>setIsOpen(attrs.isOpen), ()=>{
            onCancelEdit();
            setIsOpen(attrs.isOpen);
        });
        else // To close
        setIsOpen(attrs.isOpen);
    };
    return {
        isOpen: isOpen,
        handleDropdownOpenChange: handleDropdownOpenChange
    };
};

});


parcelRegister("l6kTe", function(module, exports) {

$parcel$export(module.exports, "FormCardContainer", () => $f5ca5cc941484def$export$4b5aae10459db887);
$parcel$export(module.exports, "FormBodyWrapper", () => $f5ca5cc941484def$export$3af8423aa7ae93fe);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dAHxw = parcelRequire("dAHxw");

const $f5ca5cc941484def$var$lightYellow = `var(--ds-background-accent-yellow-subtlest, ${(0, $a7f8c6b391092279$export$8d9596b529bbb9cf)})`;
const $f5ca5cc941484def$var$darkYellow = `var(--ds-background-accent-yellow-subtler, ${(0, $a7f8c6b391092279$export$41060a744ab0b7ae)})`;
const $f5ca5cc941484def$var$hoverWhite = `var(--ds-surface-raised-hovered, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`;
const $f5ca5cc941484def$var$white = `var(--ds-surface-raised, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`;
const $f5ca5cc941484def$export$4b5aae10459db887 = (0, $dAHxw.default).div`
	border-bottom: 1px solid ${`var(--ds-border, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)})`};
	padding: ${"var(--ds-space-025, 2px)"} 0;
	border-radius: 4px;

	background-color: ${(props)=>props.isFormYellow ? $f5ca5cc941484def$var$lightYellow : $f5ca5cc941484def$var$white};

	&:hover {
		background-color: ${(props)=>{
    if (props.formIsSelected) return '';
    return props.isFormYellow ? $f5ca5cc941484def$var$darkYellow : $f5ca5cc941484def$var$hoverWhite;
}};
	}

	&:first-child {
		border-radius: ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0 0;
	}

	&:last-child {
		border-radius: 0 0 ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"};
		border-bottom: 0;
	}
`;
const $f5ca5cc941484def$export$3af8423aa7ae93fe = (0, $dAHxw.default).div({
    padding: "var(--ds-space-150, 12px)"
});

});


parcelRegister("9EhjM", function(module, exports) {

$parcel$export(module.exports, "FormCardsContainer", () => $7065487e11cc2fea$export$d2c1c2780a14f1af);
$parcel$export(module.exports, "FormCards", () => $7065487e11cc2fea$export$1000c088c603ca25);
$parcel$export(module.exports, "SpinnerBackdrop", () => $7065487e11cc2fea$export$aa207050321b0c53);
$parcel$export(module.exports, "EmptyFormsLoadingPlaceholder", () => $7065487e11cc2fea$export$e1403abfc2d0ae7e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dAHxw = parcelRequire("dAHxw");

const $7065487e11cc2fea$export$d2c1c2780a14f1af = (0, $dAHxw.default).div({
    position: 'relative'
});
const $7065487e11cc2fea$export$1000c088c603ca25 = (0, $dAHxw.default).div`
	border: 1px solid ${`var(--ds-border, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)})`};
	border-radius: ${"var(--ds-space-050, 4px)"};
	${({ isIndexLoading: isIndexLoading })=>isIndexLoading ? `opacity: ${"var(--ds-opacity-loading, 0.2)"}` : ''};
`;
const $7065487e11cc2fea$export$aa207050321b0c53 = (0, $dAHxw.default).div({
    display: 'flex',
    position: 'absolute',
    inset: '15px 0',
    alignItems: 'center',
    justifyContent: 'center'
});
const $7065487e11cc2fea$export$e1403abfc2d0ae7e = (0, $dAHxw.default).div({
    height: '60px'
});

});


parcelRegister("eiXdg", function(module, exports) {

$parcel$export(module.exports, "FormSecurityApiProvider", () => $a6a0ad94832bfc83$export$9300063f2eaac750);
$parcel$export(module.exports, "useFormSecurityApi", () => $a6a0ad94832bfc83$export$d7ae0dc939d81f9e);

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");
const $a6a0ad94832bfc83$var$FormSecurityApiContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $a6a0ad94832bfc83$export$9300063f2eaac750 = ({ formSecurityApi: formSecurityApi, children: children })=>(0, $fHpHg.fg)('granular_permissions_on_forms_m1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a6a0ad94832bfc83$var$FormSecurityApiContext.Provider, {
        value: formSecurityApi
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
const $a6a0ad94832bfc83$export$d7ae0dc939d81f9e = ()=>{
    if ((0, $fHpHg.fg)('granular_permissions_on_forms_m1')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const context = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($a6a0ad94832bfc83$var$FormSecurityApiContext);
        if (context === undefined) throw new Error('useFormSecurityApi must be used within a FormSecurityApiProvider');
        return context;
    }
    return undefined;
};

});

parcelRegister("bedpg", function(module, exports) {

$parcel$export(module.exports, "LiveFormSecurityApi", () => $82cb66bde4bb12a9$export$c507202beced3af9);

var $kxjzW = parcelRequire("kxjzW");
class $82cb66bde4bb12a9$export$c507202beced3af9 {
    constructor(cloudId, projectId){
        this.cloudId = cloudId;
        this.projectId = projectId;
        this.cloudId = cloudId;
        this.projectId = projectId;
    }
    load(projectFormId) {
        return (0, $kxjzW.loadRestrictedPrincipalsForTemplateForm)(this.cloudId, this.projectId, projectFormId);
    }
    save(projectFormId, principals) {
        return (0, $kxjzW.saveRestrictedPrincipalsForTemplateForm)(this.cloudId, this.projectId, projectFormId, principals);
    }
}

});
parcelRegister("kxjzW", function(module, exports) {

$parcel$export(module.exports, "saveRestrictedPrincipalsForTemplateForm", () => $ef3613a539de0fa9$export$29bab78c7af6515d);
$parcel$export(module.exports, "loadRestrictedPrincipalsForTemplateForm", () => $ef3613a539de0fa9$export$94a42509057aab46);

var $1Jl81 = parcelRequire("1Jl81");
var $guy0h = parcelRequire("guy0h");
var $k9L5z = parcelRequire("k9L5z");

var $5wvQR = parcelRequire("5wvQR");

var $66UG2 = parcelRequire("66UG2");
const $ef3613a539de0fa9$export$29bab78c7af6515d = (cloudId, projectId, templateFormLegacyId, principals)=>$ef3613a539de0fa9$var$doFetch($ef3613a539de0fa9$var$proformaFormRestrictionsURLPath(cloudId, projectId, templateFormLegacyId), 'POST', (0, $66UG2.AcceptedResponseType).None, principals.map((principal)=>principal.ari.toString())).then(()=>principals.length > 0 ? (0, $5wvQR.FormRestrictionStatus).RESTRICTED : (0, $5wvQR.FormRestrictionStatus).OPEN);
const $ef3613a539de0fa9$export$94a42509057aab46 = (cloudId, projectId, templateFormLegacyId)=>$ef3613a539de0fa9$var$doFetch($ef3613a539de0fa9$var$proformaFormRestrictionsURLPath(cloudId, projectId, templateFormLegacyId), 'GET', (0, $66UG2.AcceptedResponseType).Json).then((principals)=>({
            principals: principals.map($ef3613a539de0fa9$var$toFormSupportedPrincipal)
        }));
const $ef3613a539de0fa9$var$toFormSupportedPrincipal = (p)=>{
    const identityResourceType = (0, $1Jl81.AnyAri).parse(p.principalId).resourceType;
    switch(identityResourceType){
        case 'user':
            return {
                ari: (0, $k9L5z.IdentityUserAri).parse(p.principalId),
                type: (0, $5wvQR.FormSupportedPrincipalType).USER,
                name: p.name,
                avatar: p.avatarUrl
            };
        case 'group':
            return {
                ari: (0, $guy0h.IdentityGroupAri).parse(p.principalId),
                type: (0, $5wvQR.FormSupportedPrincipalType).USER_GROUP,
                name: p.name,
                avatar: p.avatarUrl
            };
        default:
            throw new Error(`unsupported principal type ${identityResourceType}`);
    }
};
/** Formats a url path for the form restrictions endpoint on Proforma */ const $ef3613a539de0fa9$var$proformaFormRestrictionsURLPath = (cloudId, projectId, templateFormLegacyId)=>`/gateway/api/proforma/cloudid/${cloudId}/api/frontend/jira/project/${projectId}/form/${templateFormLegacyId}/restrictions`;
/** Wrapper around fetch with a minimal API specific for form restriction requests */ const $ef3613a539de0fa9$var$doFetch = (url, method, acceptedResponseType, body)=>fetch(url, {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        method: method,
        ...body && {
            body: JSON.stringify(body)
        }
    }).then((response)=>{
        if (!response.ok) throw new Error(`Unexpected response from ${response.url} ${response.status} ${response.statusText}`);
        switch(acceptedResponseType){
            case (0, $66UG2.AcceptedResponseType).Json:
                return response.json();
            case (0, $66UG2.AcceptedResponseType).None:
                return undefined;
            default:
                throw new Error(`Unexpected accepted response type ${acceptedResponseType}`);
        }
    });

});
parcelRegister("guy0h", function(module, exports) {

$parcel$export(module.exports, "IdentityGroupAri", () => $c019d318335b1dcb$export$a0ec2d0676c0549c);

var $iyUs3 = parcelRequire("iyUs3");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/identity/group/manifest.ts
var $c019d318335b1dcb$var$identityGroupAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $iyUs3.IdentityGroupAriResourceOwner),
    resourceType: (0, $iyUs3.IdentityGroupAriResourceType),
    resourceIdSlug: "{groupId}",
    resourceIdSegmentFormats: {
        groupId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/identity/group/index.ts
var $c019d318335b1dcb$export$a0ec2d0676c0549c = class _IdentityGroupAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._groupId = opts.resourceIdSegmentValues.groupId;
    }
    get groupId() {
        return this._groupId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c019d318335b1dcb$var$identityGroupAriStaticOpts.qualifier,
            platformQualifier: $c019d318335b1dcb$var$identityGroupAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $c019d318335b1dcb$var$identityGroupAriStaticOpts.resourceOwner,
            resourceType: $c019d318335b1dcb$var$identityGroupAriStaticOpts.resourceType,
            resourceId: `${opts.groupId}`,
            resourceIdSegmentValues: {
                groupId: opts.groupId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $c019d318335b1dcb$var$identityGroupAriStaticOpts);
        return new _IdentityGroupAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $c019d318335b1dcb$var$identityGroupAriStaticOpts);
        return new _IdentityGroupAri(opts);
    }
    getVariables() {
        return {
            groupId: this.groupId
        };
    }
};

});
parcelRegister("iyUs3", function(module, exports) {

$parcel$export(module.exports, "IdentityGroupAriResourceOwner", () => $d8373112590c3b25$export$37767420f897daca);
$parcel$export(module.exports, "IdentityGroupAriResourceType", () => $d8373112590c3b25$export$34f7ba4c01550cbf);
// src/identity/group/types.ts
var $d8373112590c3b25$export$37767420f897daca = "identity", $d8373112590c3b25$export$34f7ba4c01550cbf = "group";

});


parcelRegister("66UG2", function(module, exports) {

$parcel$export(module.exports, "AcceptedResponseType", () => $472f447cba27e932$export$9126c50ecfe2a46d);
const $472f447cba27e932$export$9126c50ecfe2a46d = {
    Json: 'json',
    None: 'none'
};

});



parcelRegister("2d5Q3", function(module, exports) {

$parcel$export(module.exports, "useDownloadForm", () => $1a85cbaa8c66f153$export$3aec255d07f4f02d);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $aNTEp = parcelRequire("aNTEp");

var $fOfPQ = parcelRequire("fOfPQ");
var $N5QrD = parcelRequire("N5QrD");

var $erWXD = parcelRequire("erWXD");
const $1a85cbaa8c66f153$var$getXlsxDownloadUrl = (issueId, formId)=>`/api/1/issues/${issueId}/forms/${formId}/spreadsheet`;
const $1a85cbaa8c66f153$var$getPdfDownloadUrl = (issueId, formId)=>`/api/1/issues/${issueId}/forms/${formId}/pdf`;
const $1a85cbaa8c66f153$export$3aec255d07f4f02d = (proformaUrl, issueId, defaultFilenameKey, formType)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { reportError: reportError } = (0, $N5QrD.useFormIndexActions)();
    const handleDownloadForm = (0, $5uXOq.useCallback)(async (formId, formName)=>{
        let fileUrl = '';
        switch(formType){
            case 'pdf':
                fileUrl = $1a85cbaa8c66f153$var$getPdfDownloadUrl(issueId, formId);
                break;
            case 'xlsx':
                fileUrl = $1a85cbaa8c66f153$var$getXlsxDownloadUrl(issueId, formId);
                break;
            default:
                break;
        }
        try {
            await (0, $fOfPQ.downloadFile)(proformaUrl + fileUrl, `${formName || 'Proforma'}-${defaultFilenameKey}.${formType}`, formType);
            (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).DOWNLOADED}`, {
                formId: formId,
                formType: formType
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            reportError(error, {
                id: 'downloadForm',
                attributes: {
                    formId: formId,
                    formType: formType
                }
            });
            return Promise.reject(error);
        }
    }, [
        formType,
        proformaUrl,
        defaultFilenameKey,
        issueId,
        createAnalyticsEvent,
        reportError
    ]);
    return handleDownloadForm;
};

});
parcelRegister("fOfPQ", function(module, exports) {

$parcel$export(module.exports, "downloadFile", () => $b827cf1517c5ce84$export$bb3b75778e3e272);

var $s7PgC = parcelRequire("s7PgC");
const $b827cf1517c5ce84$export$bb3b75778e3e272 = (urlPath, nameToSaveAs, fileType)=>{
    const contentType = (0, $s7PgC.downloadOptionToContentType)[fileType];
    const preFlight = {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': contentType
        }
    };
    return fetch(urlPath, preFlight).then((response)=>{
        if (response.ok) return response.blob();
        throw response;
    }).then((blob)=>{
        const fileUrl = window.URL.createObjectURL(blob);
        // @ts-expect-error: Navigator type not defined?
        if (window.navigator.msSaveBlob) {
            // @ts-expect-error: Navigator type not defined?
            window.navigator.msSaveBlob(blob, nameToSaveAs);
            return;
        }
        const downloadLink = window.document.createElement('a');
        downloadLink.href = fileUrl;
        downloadLink.setAttribute('download', nameToSaveAs);
        window.document.body.appendChild(downloadLink);
        downloadLink.click();
        window.document.body.removeChild(downloadLink);
    });
};

});
parcelRegister("s7PgC", function(module, exports) {

$parcel$export(module.exports, "downloadOptionToContentType", () => $0548afb2bd97387f$export$3df7b8388948283b);

var $NfjoT = parcelRequire("NfjoT");
const $0548afb2bd97387f$export$3df7b8388948283b = {
    pdf: (0, $NfjoT.ContentType).PDF,
    xlsx: (0, $NfjoT.ContentType).XLSX
};

});
parcelRegister("NfjoT", function(module, exports) {

$parcel$export(module.exports, "ContentType", () => $094074584a3bac2d$export$e2e108cbe2e4f865);
let $094074584a3bac2d$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PDF"] = "application/pdf";
    ContentType["XLSX"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    return ContentType;
}({});

});




parcelRegister("1NVs4", function(module, exports) {

$parcel$export(module.exports, "useHandleCancelEditForm", () => $a53dd8cf3aa0fbc3$export$637855f98bcd2af);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $aNTEp = parcelRequire("aNTEp");

var $hprFm = parcelRequire("hprFm");
var $N5QrD = parcelRequire("N5QrD");

var $erWXD = parcelRequire("erWXD");
const $a53dd8cf3aa0fbc3$export$637855f98bcd2af = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { setFormViewMode: setFormViewMode, reportError: reportError } = (0, $N5QrD.useFormIndexActions)();
    const { selectedFormStore: selectedFormStore } = (0, $N5QrD.useSelectedFormStoreState)();
    return (0, $5uXOq.useCallback)(()=>{
        try {
            if (!selectedFormStore) return;
            selectedFormStore.discardModifiedAnswers();
            selectedFormStore.hideValidations();
            setFormViewMode((0, $hprFm.FormViewMode).View);
            (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM_EDIT} ${(0, $erWXD.Action).STOPPED}`, {
                formId: selectedFormStore.formId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            reportError(error, {
                id: 'cancelEditForm',
                attributes: {
                    formId: selectedFormStore?.formId
                }
            });
            throw error;
        }
    }, [
        createAnalyticsEvent,
        reportError,
        selectedFormStore,
        setFormViewMode
    ]);
};

});

parcelRegister("bPD3w", function(module, exports) {

$parcel$export(module.exports, "useHandleCloseForm", () => $c8d819ec6919658b$export$112e6df3bff73122);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $aNTEp = parcelRequire("aNTEp");

var $ousew = parcelRequire("ousew");

var $hprFm = parcelRequire("hprFm");
var $N5QrD = parcelRequire("N5QrD");

var $erWXD = parcelRequire("erWXD");

var $6U2FW = parcelRequire("6U2FW");

var $6vE26 = parcelRequire("6vE26");

var $kX9X3 = parcelRequire("kX9X3");

var $eSxOS = parcelRequire("eSxOS");
const $c8d819ec6919658b$export$112e6df3bff73122 = (loadFormStore, disableIssueViewFullPageDropzoneCallback, projectType)=>{
    const { showNotice: showNotice } = (0, $6U2FW.useShowNotice)();
    const { selectedFormStore: selectedFormStore } = (0, $N5QrD.useSelectedFormStoreState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const selectFormNoDiscardChangeNotice = (0, $6vE26.useSelectFormNoDiscardChangeNotice)(loadFormStore, disableIssueViewFullPageDropzoneCallback);
    const { updateFormStatus: updateFormStatus, setFormViewMode: setFormViewMode, submitForm: submitForm, reportError: reportError } = (0, $N5QrD.useFormIndexActions)();
    return async (formId, formStore)=>{
        if (selectedFormStore?.answersModified) throw new Error('"Close form edits" not allowed while editing form');
        const loadedFormStore = formStore || await loadFormStore(formId);
        loadedFormStore.validate();
        if (loadedFormStore.invalid) {
            await selectFormNoDiscardChangeNotice(formId, loadedFormStore);
            setFormViewMode((0, $hprFm.FormViewMode).Edit);
            return (0, $eSxOS.CloseFormResult).ValidationFailed;
        }
        return new Promise((resolve)=>{
            showNotice({
                title: projectType === 'service_desk' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                    ...(0, $kX9X3.messages).closeModalTitle,
                    values: {
                        formName: loadedFormStore.formName
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                    ...(0, $kX9X3.messages).closeFormModalTitle,
                    values: {
                        formName: loadedFormStore.formName
                    }
                }),
                body: projectType === 'service_desk' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kX9X3.messages).closeModalBody) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kX9X3.messages).closeFormModalBody),
                closeText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kX9X3.messages).closeModalCancel),
                confirmText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kX9X3.messages).closeModalConfirm),
                onCloseHandler: ()=>resolve((0, $eSxOS.CloseFormResult).Cancelled),
                onConfirmHandler: async ()=>{
                    try {
                        if (loadedFormStore.formId) {
                            const isCurrentFormSelected = !!formStore;
                            const updatedForm = await submitForm(loadedFormStore.formId, loadedFormStore.submitLock);
                            if (isCurrentFormSelected) {
                                await loadedFormStore.update(updatedForm);
                                loadedFormStore.hideValidations();
                                setFormViewMode((0, $hprFm.FormViewMode).View);
                            }
                            updateFormStatus(loadedFormStore.formId, updatedForm.state.status);
                            (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).UPDATED}`, {
                                formId: loadedFormStore.formId,
                                templateFormId: loadedFormStore.templateFormId,
                                formUpdateType: (0, $erWXD.FormUpdateType).CLOSE,
                                visibility: loadedFormStore.internal ? 'internal' : 'external'
                            });
                        }
                        resolve((0, $eSxOS.CloseFormResult).Success);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        reportError(e, {
                            id: 'closeForm',
                            attributes: {
                                formId: formId
                            }
                        });
                        resolve((0, $eSxOS.CloseFormResult).UnknownError);
                    }
                }
            });
        });
    };
};

});
parcelRegister("kX9X3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7928b9984a28643a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7928b9984a28643a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    closeModalTitle: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-modal-title",
        "defaultMessage": "Close customer edits on this form"
    },
    closeModalBody: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-modal-body",
        "defaultMessage": "Customers will no longer be able to edit this form and it will be submitted in its current state."
    },
    closeFormModalTitle: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-form-modal-title",
        "defaultMessage": "Close edits on this form"
    },
    closeFormModalBody: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-form-modal-body",
        "defaultMessage": "Closing edits will submit this form in its current state. "
    },
    closeModalConfirm: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-modal-confirm",
        "defaultMessage": "Close edits"
    },
    closeModalCancel: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-close-form.close-modal-cancel",
        "defaultMessage": "Cancel"
    }
});

});

parcelRegister("eSxOS", function(module, exports) {

$parcel$export(module.exports, "CloseFormResult", () => $1376c6261789e996$export$e307500b4f641011);
var $1376c6261789e996$export$e307500b4f641011 = /*#__PURE__*/ function(CloseFormResult) {
    CloseFormResult[CloseFormResult["Success"] = 0] = "Success";
    CloseFormResult[CloseFormResult["Cancelled"] = 1] = "Cancelled";
    CloseFormResult[CloseFormResult["ValidationFailed"] = 2] = "ValidationFailed";
    CloseFormResult[CloseFormResult["UnknownError"] = 3] = "UnknownError";
    return CloseFormResult;
}({});

});


parcelRegister("eM2bk", function(module, exports) {

$parcel$export(module.exports, "useHandleDeleteForm", () => $aa94d08b8bb21cf2$export$8d6a21cca1db99e0);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $aNTEp = parcelRequire("aNTEp");

var $ousew = parcelRequire("ousew");

var $N5QrD = parcelRequire("N5QrD");

var $erWXD = parcelRequire("erWXD");

var $6U2FW = parcelRequire("6U2FW");

var $6vE26 = parcelRequire("6vE26");

var $lwnmD = parcelRequire("lwnmD");

var $l9tYV = parcelRequire("l9tYV");
const $aa94d08b8bb21cf2$export$8d6a21cca1db99e0 = (loadFormStore, disableIssueViewFullPageDropzoneCallback)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { deleteForm: deleteForm, reportError: reportError } = (0, $N5QrD.useFormIndexActions)();
    const selectFormNoDiscardChangeNotice = (0, $6vE26.useSelectFormNoDiscardChangeNotice)(loadFormStore, disableIssueViewFullPageDropzoneCallback);
    const { selectedFormStore: selectedFormStore } = (0, $N5QrD.useSelectedFormStoreState)();
    const { showNotice: showNotice } = (0, $6U2FW.useShowNotice)();
    const handleDeleteForm = (0, $5uXOq.useCallback)((formId, formName)=>new Promise((resolve)=>{
            showNotice({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                    ...(0, $lwnmD.messages).deleteModalTitle,
                    values: {
                        formName: formName
                    }
                }),
                appearance: 'warning',
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $lwnmD.messages).deleteModalBody),
                closeText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $lwnmD.messages).deleteModalCancel),
                confirmText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $lwnmD.messages).deleteModalConfirm),
                onConfirmHandler: async ()=>{
                    try {
                        const deletedProjectFormId = await deleteForm(formId);
                        if (formId === selectedFormStore?.formId) selectFormNoDiscardChangeNotice();
                        (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).DELETED}`, {
                            formId: formId,
                            templateFormId: deletedProjectFormId
                        });
                        resolve((0, $l9tYV.DeleteFormResult).Success);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        reportError(error, {
                            id: 'deleteForm',
                            attributes: {
                                formId: formId
                            }
                        });
                        resolve((0, $l9tYV.DeleteFormResult).Failure);
                    }
                },
                onCloseHandler: ()=>resolve((0, $l9tYV.DeleteFormResult).Cancelled)
            });
        }), [
        createAnalyticsEvent,
        deleteForm,
        reportError,
        selectFormNoDiscardChangeNotice,
        selectedFormStore?.formId,
        showNotice
    ]);
    return handleDeleteForm;
};

});
parcelRegister("lwnmD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7e4972a11427b57a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7e4972a11427b57a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    deleteModalTitle: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-delete-form.delete-modal-title",
        "defaultMessage": "Delete \u2018{formName}\u2019 form "
    },
    deleteModalBody: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-delete-form.delete-modal-body",
        "defaultMessage": "Deleting this form will be permanent and cannot be undone."
    },
    deleteModalConfirm: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-delete-form.delete-modal-confirm",
        "defaultMessage": "Delete form"
    },
    deleteModalCancel: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-delete-form.delete-modal-cancel",
        "defaultMessage": "Cancel"
    }
});

});

parcelRegister("l9tYV", function(module, exports) {

$parcel$export(module.exports, "DeleteFormResult", () => $684f593128c7caee$export$346afc90f08c6147);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $684f593128c7caee$export$346afc90f08c6147 = /*#__PURE__*/ function(DeleteFormResult) {
    DeleteFormResult[DeleteFormResult["Success"] = 0] = "Success";
    DeleteFormResult[DeleteFormResult["Cancelled"] = 1] = "Cancelled";
    DeleteFormResult[DeleteFormResult["Failure"] = 2] = "Failure";
    return DeleteFormResult;
}({});

});


parcelRegister("4xIAx", function(module, exports) {

$parcel$export(module.exports, "useHandleEditForm", () => $eeb592c867d5afa5$export$fec36c588ae656c);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $aNTEp = parcelRequire("aNTEp");

var $hprFm = parcelRequire("hprFm");
var $N5QrD = parcelRequire("N5QrD");

var $erWXD = parcelRequire("erWXD");

var $6vE26 = parcelRequire("6vE26");
const $eeb592c867d5afa5$export$fec36c588ae656c = (loadFormStore, disableIssueViewFullPageDropzoneCallback)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { selectedFormStore: selectedFormStore } = (0, $N5QrD.useSelectedFormStoreState)();
    const { setFormViewMode: setFormViewMode, reportError: reportError } = (0, $N5QrD.useFormIndexActions)();
    const selectFormNoDiscardChangeNotice = (0, $6vE26.useSelectFormNoDiscardChangeNotice)(loadFormStore, disableIssueViewFullPageDropzoneCallback);
    return (0, $5uXOq.useCallback)(async (formId, formStore)=>{
        try {
            if (selectedFormStore?.answersModified) throw new Error('"Edit form" not allowed while editing form');
            const isCurrentFormSelected = !!formStore;
            if (!isCurrentFormSelected) await selectFormNoDiscardChangeNotice(formId);
            setFormViewMode((0, $hprFm.FormViewMode).Edit);
            (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM_EDIT} ${(0, $erWXD.Action).STARTED}`, {
                formId: formId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            reportError(error, {
                id: 'editForm',
                attributes: {
                    formId: formId
                }
            });
            return Promise.reject(error);
        }
    }, [
        createAnalyticsEvent,
        reportError,
        selectFormNoDiscardChangeNotice,
        selectedFormStore?.answersModified,
        setFormViewMode
    ]);
};

});

parcelRegister("gZVQw", function(module, exports) {

$parcel$export(module.exports, "useHandleUpdateFormVisibility", () => $e9a2aed471af89e5$export$8b674baa544f95c7);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $bEIgH = parcelRequire("bEIgH");

var $9FSw2 = parcelRequire("9FSw2");

var $aNTEp = parcelRequire("aNTEp");

var $ousew = parcelRequire("ousew");

var $N5QrD = parcelRequire("N5QrD");

var $erWXD = parcelRequire("erWXD");

var $6U2FW = parcelRequire("6U2FW");

var $5wvQR = parcelRequire("5wvQR");

var $4R6GH = parcelRequire("4R6GH");

var $41j30 = parcelRequire("41j30");

var $3PJX6 = parcelRequire("3PJX6");

var $amKTV = parcelRequire("amKTV");

var $c75GN = parcelRequire("c75GN");
const $e9a2aed471af89e5$export$8b674baa544f95c7 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { updateFormVisibility: updateFormVisibility, reportError: reportError } = (0, $N5QrD.useFormIndexActions)();
    const { showNotice: showNotice } = (0, $6U2FW.useShowNotice)();
    const handleUpdateFormVisibility = (0, $5uXOq.useCallback)(async (formId, toInternal, formRestrictionStatus)=>new Promise((resolve)=>{
            toInternal ? showNotice({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $amKTV.messages).changeFormToInternalModalTitle),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $amKTV.messages).changeFormToInternalModalBody),
                closeText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $amKTV.messages).changeFormToInternalModalClose),
                confirmText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $amKTV.messages).changeFormToInternalModalConfirm),
                onConfirmHandler: async ()=>{
                    try {
                        await updateFormVisibility(formId, true);
                        (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).UPDATED}`, {
                            formId: formId,
                            formUpdateType: (0, $erWXD.FormUpdateType).SET_INTERNAL
                        });
                        resolve((0, $c75GN.UpdateFormVisibilityResult).SUCCESS);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        reportError(error, {
                            id: 'updateFormVisibility',
                            attributes: {
                                formId: formId
                            }
                        });
                        resolve((0, $c75GN.UpdateFormVisibilityResult).FAILURE);
                    }
                },
                onCloseHandler: ()=>resolve((0, $c75GN.UpdateFormVisibilityResult).CANCELLED)
            }) : showNotice({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $amKTV.messages).changeFormToExternalModalTitle),
                body: formRestrictionStatus && formRestrictionStatus === (0, $5wvQR.FormRestrictionStatus).RESTRICTED && (0, $4R6GH.fg)('granular_permissions_on_forms_m1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
                    space: "space.300"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
                    appearance: "warning"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                    ...(0, $amKTV.messages).changeRestrictedFormToExternalWarning,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
                                href: (0, $3PJX6.FORM_RESTRICTION_URL),
                                target: "_blank"
                            }, chunks)
                    }
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $amKTV.messages).changeFormToExternalModalBody)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $amKTV.messages).changeFormToExternalModalBody),
                closeText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $amKTV.messages).changeFormToExternalModalClose),
                confirmText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $amKTV.messages).changeFormToExternalModalConfirm),
                onConfirmHandler: async ()=>{
                    try {
                        await updateFormVisibility(formId, false);
                        (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).UPDATED}`, {
                            formId: formId,
                            formUpdateType: (0, $erWXD.FormUpdateType).SET_EXTERNAL
                        });
                        resolve((0, $c75GN.UpdateFormVisibilityResult).SUCCESS);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        reportError(error, {
                            id: 'updateFormVisibility',
                            attributes: {
                                formId: formId
                            }
                        });
                        resolve((0, $c75GN.UpdateFormVisibilityResult).FAILURE);
                    }
                },
                onCloseHandler: ()=>resolve((0, $c75GN.UpdateFormVisibilityResult).CANCELLED)
            });
        }), [
        createAnalyticsEvent,
        reportError,
        showNotice,
        updateFormVisibility
    ]);
    return handleUpdateFormVisibility;
};

});
parcelRegister("amKTV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $718551fc72bfd0c5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $718551fc72bfd0c5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    changeFormToInternalModalTitle: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-internal-modal-title",
        "defaultMessage": "Make form internal only and hide from customer"
    },
    changeFormToInternalModalBody: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-internal-modal-body",
        "defaultMessage": "Any forms made internal will only be seen by agents and hidden in the portal from customers."
    },
    changeFormToInternalModalConfirm: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-internal-modal-confirm",
        "defaultMessage": "Make internal"
    },
    changeFormToInternalModalClose: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-internal-modal-close",
        "defaultMessage": "Cancel"
    },
    changeFormToExternalModalTitle: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-external-modal-title",
        "defaultMessage": "Make form external and show to customer"
    },
    changeFormToExternalModalBody: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-external-modal-body",
        "defaultMessage": "Customers will be able to view this form in the portal and it will no longer be internal only."
    },
    changeFormToExternalModalConfirm: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-external-modal-confirm",
        "defaultMessage": "Make external"
    },
    changeFormToExternalModalClose: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-external-modal-close",
        "defaultMessage": "Cancel"
    },
    changeRestrictedFormToExternalWarning: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-restricted-form-to-external-warning",
        "defaultMessage": "Customers may not have access to view this form as it is restricted to certain people. <link>Read more about restricting forms</link>"
    }
});

});

parcelRegister("c75GN", function(module, exports) {

$parcel$export(module.exports, "UpdateFormVisibilityResult", () => $2b07719b6eb900f8$export$562c0ed9eed943dc);
const $2b07719b6eb900f8$export$562c0ed9eed943dc = {
    SUCCESS: 'Success',
    CANCELLED: 'Cancelled',
    FAILURE: 'Failure'
};

});


parcelRegister("aWqtm", function(module, exports) {

$parcel$export(module.exports, "useHandleReopenFormWithIndexItem", () => $7c364df9ad5cf3c2$export$bc67c63ab2b4f056);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $aNTEp = parcelRequire("aNTEp");

var $ousew = parcelRequire("ousew");

var $4aJmI = parcelRequire("4aJmI");

var $N5QrD = parcelRequire("N5QrD");

var $erWXD = parcelRequire("erWXD");

var $6U2FW = parcelRequire("6U2FW");

var $hzeUK = parcelRequire("hzeUK");

var $lGv7m = parcelRequire("lGv7m");
const $7c364df9ad5cf3c2$export$bc67c63ab2b4f056 = (projectType)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { updateFormStatus: updateFormStatus, reopenForm: reopenForm, reportError: reportError } = (0, $N5QrD.useFormIndexActions)();
    const { permissions: permissions } = (0, $N5QrD.useFormIndexState)();
    const { showNotice: showNotice } = (0, $6U2FW.useShowNotice)();
    const confirmReopenForm = (0, $5uXOq.useCallback)((formIndexItem, formStore)=>reopenForm(formIndexItem.id, formIndexItem.status).then((updatedForm)=>{
            if (formStore) return formStore.update(updatedForm, true).then((_)=>{
                updateFormStatus(updatedForm.id, updatedForm.state.status);
            });
            updateFormStatus(updatedForm.id, updatedForm.state.status);
            return Promise.resolve();
        }), [
        reopenForm,
        updateFormStatus
    ]);
    return (0, $5uXOq.useCallback)(async (formIndexItem, formStore)=>{
        if (!permissions.reopen || formIndexItem.status === (0, $4aJmI.FormStatus).Locked && !permissions.unlock) return Promise.resolve((0, $lGv7m.OpenFormResult).Failure);
        if (!formIndexItem.id) return Promise.resolve((0, $lGv7m.OpenFormResult).Failure);
        return new Promise((resolve)=>{
            showNotice({
                title: projectType === 'service_desk' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hzeUK.messages).confirmReopenJsmFormNoticeTitle) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hzeUK.messages).confirmReopenFormNoticeTitle),
                body: projectType === 'service_desk' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hzeUK.messages).confirmReopenJsmFormNoticeBody) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hzeUK.messages).confirmReopenNonJsmFormNoticeBody),
                closeText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hzeUK.messages).noticeCloseLabel),
                onCloseHandler: ()=>resolve((0, $lGv7m.OpenFormResult).Cancelled),
                confirmText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $hzeUK.messages).noticeConfirmLabel),
                onConfirmHandler: ()=>confirmReopenForm(formIndexItem, formStore).then(()=>{
                        (0, $aNTEp.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $erWXD.ActionSubject).FORM} ${(0, $erWXD.Action).UPDATED}`, {
                            formId: formIndexItem.id,
                            templateFormId: formIndexItem.projectFormId,
                            formUpdateType: (0, $erWXD.FormUpdateType).REOPEN,
                            visibility: formIndexItem.internal ? 'internal' : 'external'
                        });
                        return resolve((0, $lGv7m.OpenFormResult).Success);
                    }).catch((error)=>{
                        reportError(error, {
                            id: 'reopenForm',
                            attributes: {
                                formId: formIndexItem.id
                            }
                        });
                        return resolve((0, $lGv7m.OpenFormResult).Failure);
                    })
            });
        });
    }, [
        permissions.reopen,
        permissions.unlock,
        showNotice,
        projectType,
        confirmReopenForm,
        createAnalyticsEvent,
        reportError
    ]);
};

});
parcelRegister("hzeUK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $379d5e63d6fb8744$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $379d5e63d6fb8744$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    confirmReopenJsmFormNoticeTitle: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.confirm-reopen-jsm-form-notice-title",
        "defaultMessage": "Open customer edits on this form"
    },
    confirmReopenJsmFormNoticeBody: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.confirm-reopen-jsm-form-notice-body",
        "defaultMessage": "Customers will be able to edit and resubmit this form. Once submitted, customer edits will be closed."
    },
    confirmReopenFormNoticeTitle: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.confirm-reopen-form-notice-title",
        "defaultMessage": "Open edits on this form"
    },
    confirmReopenNonJsmFormNoticeBody: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.confirm-reopen-non-jsm-form-notice-body",
        "defaultMessage": "Opening edits will allow you to submit changes to this form."
    },
    noticeCloseLabel: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.notice-close-label",
        "defaultMessage": "Cancel"
    },
    noticeConfirmLabel: {
        "id": "proforma-panel-in-issue-view-ui.controllers.use-reopen-form-with-indexitem.notice-confirm-label",
        "defaultMessage": "Open edits"
    }
});

});

parcelRegister("lGv7m", function(module, exports) {

$parcel$export(module.exports, "OpenFormResult", () => $670ae98223053204$export$3b1fd8838e61cea7);
var $670ae98223053204$export$3b1fd8838e61cea7 = /*#__PURE__*/ function(OpenFormResult) {
    OpenFormResult[OpenFormResult["Success"] = 0] = "Success";
    OpenFormResult[OpenFormResult["Cancelled"] = 1] = "Cancelled";
    OpenFormResult[OpenFormResult["Failure"] = 2] = "Failure";
    return OpenFormResult;
}({});

});


parcelRegister("1A1EL", function(module, exports) {

$parcel$export(module.exports, "issueViewAttachedFormExperience", () => $3fdd2eca6b816427$export$2df3a4c8f8d59b5d);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");
const $3fdd2eca6b816427$export$2df3a4c8f8d59b5d = new (0, $kkzI0.UFOExperience)('issue-view.attached-form', {
    type: (0, $lrUJ4.ExperienceTypes).Load,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("PHy0I", function(module, exports) {

$parcel$export(module.exports, "JiraFormCardMenu", () => $76683cad1816ed0c$export$527a3378270d6970);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $aNTEp = parcelRequire("aNTEp");

var $pa9q9 = parcelRequire("pa9q9");

var $ousew = parcelRequire("ousew");

var $4aJmI = parcelRequire("4aJmI");

var $bJp27 = parcelRequire("bJp27");

var $erWXD = parcelRequire("erWXD");

var $eSxOS = parcelRequire("eSxOS");

var $l9tYV = parcelRequire("l9tYV");

var $c75GN = parcelRequire("c75GN");

var $lGv7m = parcelRequire("lGv7m");

var $13o2w = parcelRequire("13o2w");

var $7elen = parcelRequire("7elen");
const $76683cad1816ed0c$export$527a3378270d6970 = ({ form: form, formStore: formStore, permissions: permissions, onDeleteForm: onDeleteForm, onDownloadFormPdf: onDownloadFormPdf, onDownloadFormXlsx: onDownloadFormXlsx, onUpdateFormVisibility: onUpdateFormVisibility, onReopenForm: onReopenForm, onCloseForm: onCloseForm, onEditForm: onEditForm, projectType: projectType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const showErrorFlag = (title, description)=>showFlag({
            title: title,
            description: description || undefined,
            type: 'error',
            messageId: 'proforma-panel-in-issue-view-ui.ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.show-flag.error',
            messageType: 'transactional'
        });
    const showSuccessFlag = (title)=>showFlag({
            title: title,
            isAutoDismiss: true,
            type: 'success',
            messageId: 'proforma-panel-in-issue-view-ui.ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.show-flag.success',
            messageType: 'transactional'
        });
    const canSaveAndSubmit = permissions.save && permissions.submit;
    const canReopenAndUnlock = permissions.reopen && permissions.unlock;
    // "Edit form"
    const handleEditForm = async ()=>{
        (0, $aNTEp.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $erWXD.ActionSubject).DROPDOWN_ITEM,
            action: (0, $erWXD.Action).CLICKED
        }), 'editForm', (0, $7elen.getSimpleFormAnalytics)(form.id, form.projectFormId, form.status, form.internal));
        await onEditForm(form.id, formStore);
    };
    const disableEditForm = !canSaveAndSubmit || form.status === (0, $4aJmI.FormStatus).Submitted && !permissions.reopen || form.status === (0, $4aJmI.FormStatus).Locked && !canReopenAndUnlock;
    const editFormMenuItem = {
        onClick: handleEditForm,
        isDisabled: disableEditForm,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).editForm)
    };
    // "Open customer edits"
    const handleReopenForm = async ()=>{
        const result = await onReopenForm(form, formStore);
        if (result === (0, $lGv7m.OpenFormResult).Success) showSuccessFlag(projectType === 'service_desk' ? (0, $13o2w.messages).openSuccessTitle : (0, $13o2w.messages).openSuccessTitleNonJsm);
        else if (result === (0, $lGv7m.OpenFormResult).Failure) showErrorFlag(projectType === 'service_desk' ? (0, $13o2w.messages).openFailureTitle : (0, $13o2w.messages).openFailureTitleNonJsm);
    };
    const openCustomerEditMenuItem = {
        onClick: handleReopenForm,
        isDisabled: !permissions.reopen || form.status === (0, $4aJmI.FormStatus).Locked && !canReopenAndUnlock,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).openCustomerEdits)
    };
    // "Close customer edits"
    const handleCloseForm = async ()=>{
        const result = await onCloseForm(form.id, formStore);
        if (result === (0, $eSxOS.CloseFormResult).Success) showSuccessFlag((0, $13o2w.messages).closeSuccessTitle);
        else if (result === (0, $eSxOS.CloseFormResult).ValidationFailed) showErrorFlag((0, $13o2w.messages).closeValidationFailedTitle, (0, $13o2w.messages).closeValidationFailedDescription);
    };
    const closeCustomerEditMenuItem = {
        onClick: handleCloseForm,
        isDisabled: !canSaveAndSubmit,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).closeCustomerEdits)
    };
    let openCloseMenuItem;
    if (!form.internal && form.status === (0, $4aJmI.FormStatus).Open) openCloseMenuItem = closeCustomerEditMenuItem;
    else if (!form.internal && form.status !== (0, $4aJmI.FormStatus).Open) openCloseMenuItem = openCustomerEditMenuItem;
    // "Close for edits" (non JSM projects)
    const handleCloseFormNonJSM = async ()=>{
        const result = await onCloseForm(form.id, formStore);
        if (result === (0, $eSxOS.CloseFormResult).Success) showSuccessFlag((0, $13o2w.messages).closeFormSuccessTitle);
        else if (result === (0, $eSxOS.CloseFormResult).ValidationFailed) showErrorFlag((0, $13o2w.messages).closeFormValidationFailedTitle, (0, $13o2w.messages).closeValidationFailedDescription);
    };
    const openCustomerEditMenuItemNonJSM = {
        onClick: handleReopenForm,
        isDisabled: !permissions.reopen || form.status === (0, $4aJmI.FormStatus).Locked && !canReopenAndUnlock,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).openFormEdits)
    };
    const closeCustomerEditMenuItemNonJSM = {
        onClick: handleCloseFormNonJSM,
        isDisabled: !canSaveAndSubmit,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).closeFormEdits)
    };
    const openCloseMenuItemNonJSM = form.status === (0, $4aJmI.FormStatus).Open ? closeCustomerEditMenuItemNonJSM : openCustomerEditMenuItemNonJSM;
    // "Make Internal"/"Make External"
    const handleUpdateFormVisibility = async ()=>{
        const result = await onUpdateFormVisibility(form.id, !form.internal, form.restrictionStatus);
        if (result === (0, $c75GN.UpdateFormVisibilityResult).SUCCESS) showSuccessFlag(form.internal ? (0, $13o2w.messages).externalFormSuccess : (0, $13o2w.messages).internalFormSuccess);
        else if (result === (0, $c75GN.UpdateFormVisibilityResult).FAILURE) showErrorFlag(form.internal ? (0, $13o2w.messages).externalFormFailureTitle : (0, $13o2w.messages).internalFormFailureTitle);
    };
    const toggleVisibilityMenuItem = {
        isDisabled: !permissions.toggleAccess,
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), form.internal ? (0, $13o2w.messages).makeExternalTooltip : (0, $13o2w.messages).makeInternalTooltip),
        onClick: handleUpdateFormVisibility,
        children: form.internal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).makeExternal) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).makeInternal)
    };
    // "Download Pdf"
    const downloadPdfMenuItem = {
        onClick: ()=>onDownloadFormPdf(form.id, form.name),
        isDisabled: !permissions.download,
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).downloadPdfTooltip),
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).downloadPdf)
    };
    // "Download Xlsx"
    const downloadXlsxMenuItem = {
        onClick: ()=>onDownloadFormXlsx(form.id, form.name),
        isDisabled: !permissions.download,
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).downloadXlsxTooltip),
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).downloadXlsx)
    };
    // "Delete Form"
    const handleDeleteForm = async ()=>{
        (0, $aNTEp.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: (0, $erWXD.ActionSubject).DROPDOWN_ITEM,
            action: (0, $erWXD.Action).CLICKED
        }), 'deleteForm', (0, $7elen.getSimpleFormAnalytics)(form.id, form.projectFormId, form.status, form.internal));
        const result = await onDeleteForm(form.id, form.name);
        if (result === (0, $l9tYV.DeleteFormResult).Success) showSuccessFlag((0, $13o2w.messages).deleteSuccessTitle);
        else if (result === (0, $l9tYV.DeleteFormResult).Failure) showErrorFlag((0, $13o2w.messages).deleteFailureTitle);
    };
    const deleteMenuItem = {
        isDisabled: !canSaveAndSubmit || form.status !== (0, $4aJmI.FormStatus).Open,
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).deleteTooltip),
        onClick: handleDeleteForm,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $13o2w.messages).delete)
    };
    const menuItems = [
        projectType === 'service_desk' || form.status === (0, $4aJmI.FormStatus).Open ? editFormMenuItem : undefined,
        projectType === 'service_desk' ? openCloseMenuItem : openCloseMenuItemNonJSM,
        projectType === 'service_desk' ? toggleVisibilityMenuItem : undefined,
        downloadPdfMenuItem,
        downloadXlsxMenuItem,
        deleteMenuItem
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJp27.DefaultMeatballMenu), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        items: menuItems.filter((i)=>i !== undefined)
    });
};

});
parcelRegister("bJp27", function(module, exports) {

$parcel$export(module.exports, "DefaultMeatballMenu", () => $88a750c44865a0fc$export$8fdf4c5226c492c8);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $3jAdT = parcelRequire("3jAdT");

var $lDSHa = parcelRequire("lDSHa");
const $88a750c44865a0fc$export$8fdf4c5226c492c8 = ({ items: items })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), null, items.map(({ children: children, ...itemProps }, i)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lDSHa.MeatballMenuItem), (0, $bS32t.default)({
            key: i
        }, itemProps), children)));

});
parcelRegister("lDSHa", function(module, exports) {

$parcel$export(module.exports, "MeatballMenuItem", () => $fc17aad7b72a475d$export$72bdbc92f154b68);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $1eETS = parcelRequire("1eETS");

var $5KCCi = parcelRequire("5KCCi");
const $fc17aad7b72a475d$export$72bdbc92f154b68 = ({ isDisabled: isDisabled, tooltip: tooltip, onClick: onClick, children: children })=>{
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        isDisabled: true
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), (0, $bS32t.default)({}, tooltipProps, {
            onClick: onClick
        }), children));
};

});


parcelRegister("13o2w", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4f9dbe2ce58d3a64$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4f9dbe2ce58d3a64$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editForm: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.edit-form",
        "defaultMessage": "Edit form"
    },
    openCustomerEdits: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-customer-edits",
        "defaultMessage": "Open customer edits"
    },
    openSuccessTitle: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-success-title",
        "defaultMessage": "Customer edits open on form"
    },
    openSuccessTitleNonJsm: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-success-title-non-jsm",
        "defaultMessage": "Edits open on form"
    },
    openFailureTitle: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-failure-title",
        "defaultMessage": "We couldn\u2019t open customer edits."
    },
    openFailureTitleNonJsm: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-failure-title-non-jsm",
        "defaultMessage": "We couldn\u2019t open the form for edits."
    },
    closeCustomerEdits: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-customer-edits",
        "defaultMessage": "Close customer edits"
    },
    closeSuccessTitle: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-success-title",
        "defaultMessage": "Customer edits closed on form"
    },
    closeValidationFailedTitle: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-validation-failed-title",
        "defaultMessage": "We couldn\u2019t close customer edits"
    },
    closeValidationFailedDescription: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-validation-failed-description",
        "defaultMessage": "Resolve any invalid answers and check all required fields are complete."
    },
    deleteSuccessTitle: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.delete-success-title",
        "defaultMessage": "Form deleted"
    },
    deleteFailureTitle: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.delete-failure-title",
        "defaultMessage": "We couldn\u2019t delete this form."
    },
    makeInternal: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.make-internal",
        "defaultMessage": "Make form internal"
    },
    makeInternalTooltip: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.make-internal-tooltip",
        "defaultMessage": "Form will be hidden from customers in the portal, and visible to agents only."
    },
    internalFormSuccess: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.internal-form-success",
        "defaultMessage": "Form made internal only"
    },
    internalFormFailureTitle: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.internal-form-failure-title",
        "defaultMessage": "We couldn\u2019t make form internal."
    },
    makeExternal: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.make-external",
        "defaultMessage": "Make form external"
    },
    makeExternalTooltip: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.make-external-tooltip",
        "defaultMessage": "Form will be shown on the portal and visible to customers."
    },
    externalFormSuccess: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.external-form-success",
        "defaultMessage": "Form made external for customers"
    },
    externalFormFailureTitle: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.external-form-failure-title",
        "defaultMessage": "We couldn\u2019t make form external."
    },
    downloadPdf: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.download-pdf",
        "defaultMessage": "Download PDF"
    },
    downloadPdfTooltip: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.download-pdf-tooltip",
        "defaultMessage": "Download the form as a PDF file."
    },
    downloadXlsx: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.download-xlsx",
        "defaultMessage": "Download XLSX"
    },
    downloadXlsxTooltip: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.download-xlsx-tooltip",
        "defaultMessage": "Download the form as a XLSX file."
    },
    delete: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.delete",
        "defaultMessage": "Delete form"
    },
    deleteTooltip: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.delete-tooltip",
        "defaultMessage": "Permanently delete the form."
    },
    openFormEdits: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.open-form-edits",
        "defaultMessage": "Open for edits"
    },
    closeFormEdits: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-form-edits",
        "defaultMessage": "Close for edits"
    },
    closeFormSuccessTitle: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-form-success-title",
        "defaultMessage": "Edits closed on form"
    },
    closeFormValidationFailedTitle: {
        "id": "proforma-panel-in-issue-view-ui.issue-view-forms.jira-form-card-index.jira-form-card-menu.close-form-validation-failed-title",
        "defaultMessage": "We couldn\u2019t close edits on the form"
    }
});

});

parcelRegister("7elen", function(module, exports) {

$parcel$export(module.exports, "getSimpleFormAnalytics", () => $345ee278cc8c8f0a$export$120bacc3decf73ac);

var $4aJmI = parcelRequire("4aJmI");
const $345ee278cc8c8f0a$var$formStatusMapping = {
    [(0, $4aJmI.FormStatus).Locked]: 'locked',
    [(0, $4aJmI.FormStatus).Submitted]: 'submitted',
    [(0, $4aJmI.FormStatus).Open]: 'open'
};
const $345ee278cc8c8f0a$export$120bacc3decf73ac = (formId, projectFormId, status, internal)=>({
        formId: formId,
        templateFormId: projectFormId,
        formStatus: status && $345ee278cc8c8f0a$var$formStatusMapping[status],
        visibility: internal ? 'internal' : 'external'
    });

});




parcelRegister("88gr9", function(module, exports) {

$parcel$export(module.exports, "convertToFormIndexItems", () => $49026036f8106dee$export$404a7d99f8e56a0d);

var $4R6GH = parcelRequire("4R6GH");

var $4aJmI = parcelRequire("4aJmI");

var $5wvQR = parcelRequire("5wvQR");
const $49026036f8106dee$export$404a7d99f8e56a0d = (formIndexList)=>formIndexList.map((formIndex)=>{
        let status = (0, $4aJmI.FormStatus).Open;
        if (formIndex.lock) status = (0, $4aJmI.FormStatus).Locked;
        else if (formIndex.submitted) status = (0, $4aJmI.FormStatus).Submitted;
        return {
            id: formIndex.id,
            internal: formIndex.internal,
            status: status,
            name: formIndex.name,
            projectFormId: formIndex.projectFormId,
            ...(0, $4R6GH.fg)('granular_permissions_on_forms_m1') && {
                restrictionStatus: formIndex.restrictionStatus ?? (0, $5wvQR.FormRestrictionStatus).OPEN
            },
            hasAccess: formIndex.hasAccess
        };
    });

});


parcelRegister("hu5EZ", function(module, exports) {

$parcel$export(module.exports, "useFetchProjectToken", () => $33f8c2fc3462cef8$export$deb3400d2cc42494);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $eCaXc = parcelRequire("eCaXc");
const $33f8c2fc3462cef8$export$46f82b8a3ce2a183 = async (projectId, setData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
setError)=>{
    try {
        const response = await (0, $eusud.performGetRequest)(`/rest/api/2/attachment/upload/project/${projectId}/credentials`);
        setData(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        setError(e);
    }
};
const $33f8c2fc3462cef8$export$deb3400d2cc42494 = (projectId, mediaContext)=>{
    const [data, setData] = (0, $5uXOq.useState)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        mediaContext && projectId && $33f8c2fc3462cef8$export$46f82b8a3ce2a183(projectId, setData, setError);
    }, [
        projectId,
        mediaContext
    ]);
    return {
        data: data ? (0, $eCaXc.default)(data) : null,
        error: error
    };
};

});
parcelRegister("eCaXc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d44128525059e75d$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d44128525059e75d$export$2e2bcd8739ae039 = (uploadResponse)=>({
        clientId: uploadResponse.clientId,
        serviceHost: uploadResponse.endpointUrl,
        token: uploadResponse.token,
        tokenLifespanInMs: uploadResponse.tokenDurationInMins * 60000,
        collection: uploadResponse.targetCollection,
        tokenIssueTimestamp: Date.now() - 10000
    });

});





//# sourceMappingURL=async-jira-proforma-panel-in-issue-view.05b8a78a.js.map
